(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dgs9t", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $bsOiL = parcelRequire("bsOiL");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $bsOiL.getWindow)();
    const document = (0, $bsOiL.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $bsOiL.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $bsOiL.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $bsOiL.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $bsOiL.getWindow)();
        const document = (0, $bsOiL.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $bsOiL.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $bsOiL.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $bsOiL.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $bsOiL.getWindow)();
    const document = (0, $bsOiL.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $bsOiL.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $bsOiL.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $bsOiL.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $bsOiL.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $9a829b59c758b65e$export$2e2bcd8739ae039 = $;

});
parcelRegister("bsOiL", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $8589541a787ca437$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $8589541a787ca437$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $8589541a787ca437$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $8589541a787ca437$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($8589541a787ca437$var$isObject(src[key]) && $8589541a787ca437$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $8589541a787ca437$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $8589541a787ca437$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $8589541a787ca437$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $8589541a787ca437$export$8b58be045bf06082(doc, $8589541a787ca437$export$3fdcb9b4d81368d8);
    return doc;
}
const $8589541a787ca437$export$8582633f185c62bb = {
    document: $8589541a787ca437$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $8589541a787ca437$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $8589541a787ca437$export$8b58be045bf06082(win, $8589541a787ca437$export$8582633f185c62bb);
    return win;
}

});


parcelRegister("22Ih0", function(module, exports) {
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */ 'use strict';

var $8jGas = parcelRequire("8jGas");

var $8AktI = parcelRequire("8AktI");
// Reasonable defaults
var $17ce1c674b08a47c$var$PIXEL_STEP = 10;
var $17ce1c674b08a47c$var$LINE_HEIGHT = 40;
var $17ce1c674b08a47c$var$PAGE_HEIGHT = 800;
/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */ function $17ce1c674b08a47c$var$normalizeWheel(/*object*/ event) /*object*/ {
    var sX = 0, sY = 0, pX = 0, pY = 0; // pixelX, pixelY
    // Legacy
    if ('detail' in event) sY = event.detail;
    if ('wheelDelta' in event) sY = -event.wheelDelta / 120;
    if ('wheelDeltaY' in event) sY = -event.wheelDeltaY / 120;
    if ('wheelDeltaX' in event) sX = -event.wheelDeltaX / 120;
    // side scrolling on FF with DOMMouseScroll
    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
    }
    pX = sX * $17ce1c674b08a47c$var$PIXEL_STEP;
    pY = sY * $17ce1c674b08a47c$var$PIXEL_STEP;
    if ('deltaY' in event) pY = event.deltaY;
    if ('deltaX' in event) pX = event.deltaX;
    if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode == 1) {
            pX *= $17ce1c674b08a47c$var$LINE_HEIGHT;
            pY *= $17ce1c674b08a47c$var$LINE_HEIGHT;
        } else {
            pX *= $17ce1c674b08a47c$var$PAGE_HEIGHT;
            pY *= $17ce1c674b08a47c$var$PAGE_HEIGHT;
        }
    }
    // Fall-back if spin cannot be determined
    if (pX && !sX) sX = pX < 1 ? -1 : 1;
    if (pY && !sY) sY = pY < 1 ? -1 : 1;
    return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
    };
}
/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */ $17ce1c674b08a47c$var$normalizeWheel.getEventType = function() /*string*/ {
    return $8jGas.firefox() ? 'DOMMouseScroll' : $8AktI('wheel') ? 'wheel' : 'mousewheel';
};
module.exports = $17ce1c674b08a47c$var$normalizeWheel;

});
parcelRegister("8jGas", function(module, exports) {
/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */ /**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */ var $60e0ceb63061088a$var$_populated = false;
// Browsers
var $60e0ceb63061088a$var$_ie, $60e0ceb63061088a$var$_firefox, $60e0ceb63061088a$var$_opera, $60e0ceb63061088a$var$_webkit, $60e0ceb63061088a$var$_chrome;
// Actual IE browser for compatibility mode
var $60e0ceb63061088a$var$_ie_real_version;
// Platforms
var $60e0ceb63061088a$var$_osx, $60e0ceb63061088a$var$_windows, $60e0ceb63061088a$var$_linux, $60e0ceb63061088a$var$_android;
// Architectures
var $60e0ceb63061088a$var$_win64;
// Devices
var $60e0ceb63061088a$var$_iphone, $60e0ceb63061088a$var$_ipad, $60e0ceb63061088a$var$_native;
var $60e0ceb63061088a$var$_mobile;
function $60e0ceb63061088a$var$_populate() {
    if ($60e0ceb63061088a$var$_populated) return;
    $60e0ceb63061088a$var$_populated = true;
    // To work around buggy JS libraries that can't handle multi-digit
    // version numbers, Opera 10's user agent string claims it's Opera
    // 9, then later includes a Version/X.Y field:
    //
    // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
    var uas = navigator.userAgent;
    var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
    var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
    $60e0ceb63061088a$var$_iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
    $60e0ceb63061088a$var$_ipad = /\b(iP[ao]d)/.exec(uas);
    $60e0ceb63061088a$var$_android = /Android/i.exec(uas);
    $60e0ceb63061088a$var$_native = /FBAN\/\w+;/i.exec(uas);
    $60e0ceb63061088a$var$_mobile = /Mobile/i.exec(uas);
    // Note that the IE team blog would have you believe you should be checking
    // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
    // from either x64 or ia64;  so ultimately, you should just check for Win64
    // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
    // Windows will send 'WOW64' instead.
    $60e0ceb63061088a$var$_win64 = !!/Win64/.exec(uas);
    if (agent) {
        $60e0ceb63061088a$var$_ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN;
        // IE compatibility mode
        if ($60e0ceb63061088a$var$_ie && document && document.documentMode) $60e0ceb63061088a$var$_ie = document.documentMode;
        // grab the "true" ie version from the trident token if available
        var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
        $60e0ceb63061088a$var$_ie_real_version = trident ? parseFloat(trident[1]) + 4 : $60e0ceb63061088a$var$_ie;
        $60e0ceb63061088a$var$_firefox = agent[2] ? parseFloat(agent[2]) : NaN;
        $60e0ceb63061088a$var$_opera = agent[3] ? parseFloat(agent[3]) : NaN;
        $60e0ceb63061088a$var$_webkit = agent[4] ? parseFloat(agent[4]) : NaN;
        if ($60e0ceb63061088a$var$_webkit) {
            // We do not add the regexp to the above test, because it will always
            // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
            // the userAgent string.
            agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
            $60e0ceb63061088a$var$_chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
        } else $60e0ceb63061088a$var$_chrome = NaN;
    } else $60e0ceb63061088a$var$_ie = $60e0ceb63061088a$var$_firefox = $60e0ceb63061088a$var$_opera = $60e0ceb63061088a$var$_chrome = $60e0ceb63061088a$var$_webkit = NaN;
    if (os) {
        if (os[1]) {
            // Detect OS X version.  If no version number matches, set _osx to true.
            // Version examples:  10, 10_6_1, 10.7
            // Parses version number as a float, taking only first two sets of
            // digits.  If only one set of digits is found, returns just the major
            // version number.
            var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
            $60e0ceb63061088a$var$_osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
        } else $60e0ceb63061088a$var$_osx = false;
        $60e0ceb63061088a$var$_windows = !!os[2];
        $60e0ceb63061088a$var$_linux = !!os[3];
    } else $60e0ceb63061088a$var$_osx = $60e0ceb63061088a$var$_windows = $60e0ceb63061088a$var$_linux = false;
}
var $60e0ceb63061088a$var$UserAgent_DEPRECATED = {
    /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ ie: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_ie;
    },
    /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */ ieCompatibilityMode: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_ie_real_version > $60e0ceb63061088a$var$_ie;
    },
    /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */ ie64: function() {
        return $60e0ceb63061088a$var$UserAgent_DEPRECATED.ie() && $60e0ceb63061088a$var$_win64;
    },
    /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ firefox: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_firefox;
    },
    /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ opera: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_opera;
    },
    /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ webkit: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_webkit;
    },
    /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */ safari: function() {
        return $60e0ceb63061088a$var$UserAgent_DEPRECATED.webkit();
    },
    /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ chrome: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_chrome;
    },
    /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */ windows: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_windows;
    },
    /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */ osx: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_osx;
    },
    /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */ linux: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_linux;
    },
    /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */ iphone: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_iphone;
    },
    mobile: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_iphone || $60e0ceb63061088a$var$_ipad || $60e0ceb63061088a$var$_android || $60e0ceb63061088a$var$_mobile;
    },
    nativeApp: function() {
        // webviews inside of the native apps
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_native;
    },
    android: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_android;
    },
    ipad: function() {
        return $60e0ceb63061088a$var$_populate() || $60e0ceb63061088a$var$_ipad;
    }
};
module.exports = $60e0ceb63061088a$var$UserAgent_DEPRECATED;

});

parcelRegister("8AktI", function(module, exports) {
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */ 'use strict';

var $iPecS = parcelRequire("iPecS");
var $64019211f5ded4bd$var$useHasFeature;
if ($iPecS.canUseDOM) $64019211f5ded4bd$var$useHasFeature = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
// @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
document.implementation.hasFeature('', '') !== true;
/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function $64019211f5ded4bd$var$isEventSupported(eventNameSuffix, capture) {
    if (!$iPecS.canUseDOM || capture && !('addEventListener' in document)) return false;
    var eventName = 'on' + eventNameSuffix;
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
    }
    if (!isSupported && $64019211f5ded4bd$var$useHasFeature && eventNameSuffix === 'wheel') // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
    return isSupported;
}
module.exports = $64019211f5ded4bd$var$isEventSupported;

});
parcelRegister("iPecS", function(module, exports) {
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */ /*jslint evil: true */ 'use strict';
var $db48028ede4afdfa$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */ var $db48028ede4afdfa$var$ExecutionEnvironment = {
    canUseDOM: $db48028ede4afdfa$var$canUseDOM,
    canUseWorkers: typeof Worker !== 'undefined',
    canUseEventListeners: $db48028ede4afdfa$var$canUseDOM && !!(window.addEventListener || window.attachEvent),
    canUseViewport: $db48028ede4afdfa$var$canUseDOM && !!window.screen,
    isInWorker: !$db48028ede4afdfa$var$canUseDOM // For now, this is true - might change in the future.
};
module.exports = $db48028ede4afdfa$var$ExecutionEnvironment;

});



// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $1f237190b3823da6$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${$1f237190b3823da6$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener('resize', ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});


var $a5bce33b7b920d36$exports = {};
/** @type {import('tailwindcss').Config} */ $a5bce33b7b920d36$exports = {
    important: true,
    content: [
        './app/modules/**/*.php',
        '!./app/modules/**/system/**',
        './app/layout/**/*.php',
        './app/layout/**/**/*.php',
        './app/public/js/*.js',
        './src/js/**/*.js',
        './src/js/*.js',
        './src-panel/js/**/*.js',
        './src-panel/js/*.js',
        './src-shop/js/**/*.js',
        './src-shop/js/*.js'
    ],
    theme: {
        screens: {
            xs: '360px',
            // => @media (min-width: 360px) { ... }
            sm: '640px',
            // => @media (min-width: 640px) { ... }
            md: '768px',
            // => @media (min-width: 768px) { ... }
            lg: '1024px',
            // => @media (min-width: 1024px) { ... }
            menuMedia: '1200px',
            xl: '1280px',
            // => @media (min-width: 1280px) { ... }
            '2xl': '1536px',
            // => @media (min-width: 1536px) { ... }
            '3xl': '1800px'
        },
        extend: {
            colors: {
                transparent: 'transparent',
                current: 'currentColor'
            }
        }
    },
    plugins: [],
    safelist: [
        'w-full',
        'hidden',
        'sr-only',
        {
            pattern: /^grid-cols-/
        },
        {
            pattern: /^col-span-/
        },
        {
            pattern: /^flex-/
        },
        {
            pattern: /^grid-/
        },
        {
            pattern: /^justify-/
        },
        {
            pattern: /^items-/
        },
        {
            pattern: /^ml-/
        },
        {
            pattern: /^mr-/
        },
        {
            pattern: /^mb-/
        }
    ]
}; /*Classes:
w-full - width: 100%;
hidden - display: none;
sr-only - hides visually, screen reader accessible;

flex - display: flex;
flex-wrap - flex-wrap: wrap;
justify-start - justify-content: flex-start;
justify-center - justify-content: center;
justify-end - justify-content: flex-end;
justify-between - justify-content: flex-between;
items-start - alight-items: flex-start;
items-center - alight-items: center;
items-end - alight-items: flex-end;
items-between - alight-items: flex-between;

grid - display: grid;
grid-cols-8 (1–8) – sets the parent to 8 grid columns.
col-span-8 (1–8) – makes the child span 8 columns.
col-span-full - makes the child span all columns.
* */ 


function $d913fe852cb14a3a$export$74b8f1741b4483c3(options = {}) {
    const defaultOptions = {
        animateOnce: true,
        speed: 600,
        threshold: 0.5,
        delay: 0,
        easing: 'ease',
        disableMutationObserver: false,
        breakpoints: {}
    };
    // Export breakpoints from tailwind
    if (Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($a5bce33b7b920d36$exports))).theme.screens).length) defaultOptions.breakpoints = (0, (/*@__PURE__*/$parcel$interopDefault($a5bce33b7b920d36$exports))).theme.screens;
    /* --- Merge all options --- */ const { breakpoints: breakpoints } = defaultOptions;
    const mergedBreakpoints = Object.assign(breakpoints, options.breakpoints);
    const mainOptions = Object.assign(defaultOptions, options);
    mainOptions.breakpoints = mergedBreakpoints;
    /* --- Set global properties --- */ function setGlobalProperty(name, value, isTimeUnit) {
        if (isTimeUnit) value += 'ms';
        document.documentElement.style.setProperty(`--view-${name}`, `${value}`);
    }
    const { speed: speed, easing: easing } = mainOptions;
    setGlobalProperty('speed', speed, true);
    setGlobalProperty('easing', easing);
    // Setup of Intersection Observer
    const intesectionObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) entry.target.classList.add('animated');
            else if (!entry.isIntersecting && !mainOptions.animateOnce) entry.target.classList.remove('animated');
        });
    }, {
        threshold: 0,
        rootMargin: window.innerWidth >= 640 ? '0% 0% -10% 0%' : '0% 0% -5% 0%'
    });
    // Change animation of element on breakpoints
    function changeEffectOnResize(element, breakpoint, effect) {
        const initialEffect = element.dataset.view;
        let fixedBreakpoint = typeof breakpoint === 'string' ? breakpoint.replace(/\D/g, '') : breakpoint;
        if (window.innerWidth >= fixedBreakpoint) element.dataset.view = effect;
        else element.dataset.view = initialEffect;
    }
    // Main function to observe element
    function intersectElement(element, isMutation = false) {
        element.classList.add('in-view');
        const dataset = element.dataset;
        // Set speed to current element
        if (dataset.viewSpeed) element.style.transitionDuration = `${dataset.viewSpeed}ms`;
        // Set easing to current element
        if (dataset.viewEasing) element.style.transitionTimingFunction = dataset.viewEasing;
        Object.keys(dataset).forEach((key)=>{
            // Match only `data-view-*` attributes
            if (key.startsWith('view')) {
                const property = key.toLowerCase();
                const dataViewValue = property.replace(/^view/, '').replace(/^-/, '');
                // Check if dataset value corresponds to a breakpoint
                if (dataViewValue && dataViewValue in breakpoints) changeEffectOnResize(element, breakpoints[dataViewValue], dataset[key]);
            }
        });
        if (!isMutation) window.addEventListener('load', ()=>{
            if (dataset.viewDelay) setTimeout(()=>intesectionObserver.observe(element), dataset.viewDelay);
            else intesectionObserver.observe(element);
        });
        else intesectionObserver.observe(element);
    }
    /* --- Intersect elements on init --- */ const targetElements = document.querySelectorAll('[data-view]');
    if (targetElements.length) targetElements.forEach((target)=>intersectElement(target));
    /* --- Intersect dynamically added elements in DOM --- */ if (!mainOptions.disableMutationObserver) {
        const handleMutations = function(mutationsList) {
            for (const mutation of mutationsList)if (mutation.addedNodes.length) {
                const addedNodes = mutation.addedNodes;
                addedNodes.forEach((target)=>{
                    if (target.dataset && target.dataset.view) intersectElement(target, true);
                });
            }
        };
        const mutationObserver = new MutationObserver(handleMutations);
        const mutationObserverOptions = {
            childList: true,
            subtree: true,
            characterData: false
        };
        mutationObserver.observe(document.body, mutationObserverOptions);
    }
}
// Test call
$d913fe852cb14a3a$export$74b8f1741b4483c3();
const $d913fe852cb14a3a$var$startViewAnimationArr = document.querySelectorAll('.start-view-animation');
if ($d913fe852cb14a3a$var$startViewAnimationArr.length) for(let i = 0; i < $d913fe852cb14a3a$var$startViewAnimationArr.length; i++)setTimeout(function() {
    $d913fe852cb14a3a$var$startViewAnimationArr[i].classList.add('animated');
}, 50);


function $54c6583ff500d57c$var$setParallax(element, effectSpeed) {
    element.style.opacity = 1;
    function handleScroll() {
        const defaultSpeed = 0.1;
        const originalSpeed = parseFloat(element.getAttribute('data-parallax-view-speed')) || defaultSpeed;
        const speed = originalSpeed / 10;
        const scroll = window.scrollY + window.innerHeight;
        const elPos = element.getBoundingClientRect().top + window.scrollY;
        let newPos = 0;
        let start = true;
        if (element.hasAttribute('data-parallax-view-not-mobile') === true && window.innerWidth <= 640) start = false;
        if (start && elPos + element.clientHeight >= window.scrollY) {
            if (window.innerHeight >= elPos) {
                newPos = window.scrollY * speed;
                if (element.hasAttribute('data-parallax-view-horizontal') === true) element.style.transform = `translateX(${-newPos}px)`;
                else {
                    element.style.transform = `translateY(${-newPos}px)`;
                    if (element.hasAttribute('data-parallax-view-custom-transformX') === true) {
                        const customTransform = parseFloat(element.getAttribute('data-parallax-view-custom-transformX')) || '-50%';
                        element.style.transform = `translateY(${-newPos}px) translateX(${customTransform})`;
                    }
                }
            } else if (scroll >= elPos) {
                newPos = (elPos - (window.scrollY + window.innerHeight)) * speed;
                if (element.hasAttribute('data-parallax-view-horizontal') === true) element.style.transform = `translateX(${newPos}px)`;
                else {
                    element.style.transform = `translateY(${newPos}px)`;
                    if (element.hasAttribute('data-parallax-view-custom-transformX') === true) {
                        const customTransform = parseFloat(element.getAttribute('data-parallax-view-custom-transformX')) || '-50%';
                        element.style.transform = `translateY(${-newPos}px) translateX(${customTransform})`;
                    }
                }
            }
        }
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
}
const $54c6583ff500d57c$var$parallaxElements = document.querySelectorAll('[data-parallax-view]');
$54c6583ff500d57c$var$parallaxElements.forEach((element)=>{
    $54c6583ff500d57c$var$setParallax(element);
});


window.createVisibilityObserver = function createVisibilityObserver(targetClass, callback, threshold = 0.1) {
    if (typeof callback !== 'function') return;
    if (typeof threshold !== 'number' || threshold < 0 || threshold > 1) threshold = 0.1;
    function onElementVisible(entry) {
        if (entry.isIntersecting) callback(entry.target);
    }
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: threshold
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach(onElementVisible);
    }, observerOptions);
    if (document.querySelector(`.${targetClass}`)) document.querySelectorAll(`.${targetClass}`).forEach((el)=>{
        observer.observe(el);
    });
};
/* createVisibilityObserver('my-class', funcName, 0.05); */ window.lineTitlesFunc = function lineTitlesFunc(titlesArr) {
    let maxHeight = 0;
    titlesArr.forEach((title)=>{
        const height = title.offsetHeight;
        if (height > maxHeight) maxHeight = height;
    });
    titlesArr.forEach((title)=>{
        title.style.minHeight = maxHeight + 'px';
    });
};


/*
// import { gsap } from 'gsap';

window.boldLoaderNewInit = function boldLoaderNewInit() {
  if (document.querySelector('.bold-loader-new')) {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    setTimeout(function () {
      scrollLock.disablePageScroll();
    }, 100);

    const headerEl = document.querySelector('.header');
    const boldLoaderEl = document.querySelector('.bold-loader-new');
    const loaderProgress = boldLoaderEl.querySelector(
      '.bold-loader-new__progress-wr'
    );
    const loaderProgressBg = loaderProgress.querySelector(
      '.bold-loader-new__progress-bg'
    );
    const loaderProgressTextsArr = loaderProgress.querySelectorAll(
      '.bold-loader-new__progress-text'
    );
    const loaderContentEl = boldLoaderEl.querySelector(
      '.bold-loader-new__content'
    );
    const loaderWordsArr = loaderContentEl.querySelectorAll(
      '.bold-loader-new__word'
    );
    const cube = document.querySelector('.page-container');
    const cubeWr = document.querySelector('.page-container-wr');

    const homeFirsSecTitle = document.querySelector(
      '.home-first-sec .first-sec__title'
    );
    const homeFirsSecButtons = document.querySelector(
      '.home-first-sec .first-sec__buttons'
    );

    loaderProgress.style.opacity = '1';

    const duration = 1400;
    const steps = 100;
    const stepDuration = duration / steps;
    let progress = 0;

    if (headerEl) {
      headerEl.classList.add('bold-loader-new-animation');
    }

    function wordsStartAnimation() {
      const wordsCount = loaderWordsArr.length;
      if (wordsCount === 0) return;

      loaderWordsArr.forEach((word) => word.classList.remove('is-animated'));

      loaderWordsArr.forEach((word, index) => {
        const delay = (duration / wordsCount) * index;
        setTimeout(() => {
          loaderWordsArr.forEach((w) => w.classList.remove('is-animated'));
          word.classList.add('is-animated');
        }, delay);
      });
    }

    const updateProgress = () => {
      progress++;

      loaderProgressBg.style.setProperty('--progress-h', `${progress}%`);
      loaderProgressBg.style.setProperty(
        '--progress-h-reverse',
        `${100 - progress}%`
      );
      for (let i = 0; i < loaderProgressTextsArr.length; i++) {
        loaderProgressTextsArr[i].textContent = `${progress}%`;
      }

      if (progress < 100) {
        setTimeout(updateProgress, stepDuration);
      } else {
        boldLoaderEl.classList.add('is-end-animated');

        if (window.innerWidth > 1024) {
          gsap.to(cube, {
            rotationY: 0,
            duration: 1,
            ease: 'power2.inOut',
            onStart: () => {
              setTimeout(() => {
                cubeWr.classList.add('is-start-loader-animation');
              }, 380);
              /!*setTimeout(() => {
                boldLoaderEl.classList.add(
                  'is-end-first-main-before-animation'
                );
              }, 900);*!/
            },
            onComplete: () => {
              normalPageInit();
              scrollLock.enablePageScroll();
            },
          });
        } else {
          cubeWr.classList.add('is-start-mob-animation');

          setTimeout(function () {
            normalPageInit();
            scrollLock.enablePageScroll();
          }, 1000);
        }
      }
    };

    function normalPageInit() {
      const headerEl = document.querySelector('.header');
      const headerCloseWr = document.querySelector('.header-close-wrapper');
      const mainEL = document.querySelector('.main');
      const siteEL = document.querySelector('#site');
      const bodyBg = document.querySelector('.body-bg');
      const firstBgEL = document.querySelector('.first-sec-bg');

      /!*siteEL.prepend(mainEL);*!/
      if (headerEl) {
        siteEL.prepend(headerCloseWr);
        siteEL.prepend(headerEl);
      }

      if (firstBgEL && bodyBg) {
        bodyBg.prepend(firstBgEL);
      }

      cubeWr.classList.add('is-finish-loader-animation');
      cube.classList.remove('is-worked-loader');

      homeFirsSecTitle?.classList.add('is-title-animated');
      homeFirsSecButtons?.classList.add('is-title-animated');
      setTimeout(function () {
        homeFirsSecButtons?.classList.add('is-title-animated-stop');
      }, 2500);

      initCursor();
      evolveSliderInit();
      beBoldSliderInit();
      initScrollBlurAnimation();
      bgFirstFixedAnimation();
      bgFixedAnimation();
      if (typeof initCaseStudiesHead === 'function') {
        initCaseStudiesHead();
      }
      if (typeof initCaseStudies === 'function') {
        initCaseStudies();
      }
      bgChangeAnimation();
      cardScaleAnimation();
      parallaxVerticalAnimation();

      AOS.refresh();
      setTimeout(() => {
        pauseLatestWorksGradientAnimation();
        pauseProjectGradientAnimation();
      }, 50);
      pauseFooterGradientAnimation();
      btnToTopFunc();
      btnCallFunc();
      checkHeaderOverlapInit();
      textStickyAnimation();
      textParallaxAnimation();
    }

    updateProgress();
    wordsStartAnimation();
    boldLoaderEl.classList.add('is-start-animated');

    setTimeout(() => {
      const firstSecTitle = document.querySelector(
        '.home-first-sec .first-sec__title'
      );
      firstSecTitle.classList.remove('opacity-0');
      firstSecTitle.classList.add('aos-animate');
    }, 2500);
  }
};

boldLoaderNewInit();
*/ 

/*!
 * Cuberto Mouse Follower
 * https://cuberto.com/
 *
 * @version 1.1.2
 * @author Cuberto, Artem Dordzhiev (Draft)
 */ var $4959b9bff3093b7c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @typedef {Object} MouseFollowerOptions
   * @property {string|HTMLElement|null} [el] Existed cursor element.
   * @property {string|HTMLElement|null} [container] Cursor container.
   * @property {string} [className] Cursor root element class name.
   * @property {string} [innerClassName] Inner element class name.
   * @property {string} [textClassName] Text element class name.
   * @property {string} [mediaClassName] Media element class name.
   * @property {string} [mediaBoxClassName] Media inner element class name.
   * @property {string} [iconSvgClassName] SVG sprite class name.
   * @property {string} [iconSvgNamePrefix] SVG sprite icon class name prefix.
   * @property {string} [iconSvgSrc] SVG sprite source.
   * @property {string|null} [dataAttr] Name of data attribute for changing cursor state directly in HTML.
   * @property {string} [hiddenState] Hidden state name.
   * @property {string} [textState] Text state name.
   * @property {string} [iconState] Icon state name.
   * @property {string|null} [activeState] Active (mousedown) state name. Set false to disable.
   * @property {string} [mediaState] Media (image/video) state name.
   * @property {Object} [stateDetection] State detection rules.
   * @property {boolean} [visible] Is cursor visible by default.
   * @property {boolean} [visibleOnState] Automatically show/hide cursor when state added.
   * @property {number} [speed] Cursor movement speed.
   * @property {string} [ease] Timing function of cursor movement.
   * @property {boolean} [overwrite] Overwrite or remain cursor position when `mousemove` event happens.
   * @property {number} [skewing] Default skewing factor.
   * @property {number} [skewingText] Skewing effect factor in a text state.
   * @property {number} [skewingIcon] Skewing effect factor in a icon state.
   * @property {number} [skewingMedia] Skewing effect factor in a media (image/video) state.
   * @property {number} [skewingDelta] Skewing effect base delta.
   * @property {number} [skewingDeltaMax] Skew effect max delta.
   * @property {number} [stickDelta] Stick effect delta.
   * @property {number} [showTimeout] Delay before show.
   * @property {boolean} [hideOnLeave] Hide the cursor when mouse leave container.
   * @property {number} [hideTimeout] Delay before hiding. It should be equal to the CSS hide animation time.
   * @property {number[]} [initialPos] Array (x, y) of initial cursor position.
   */ /**
   * Register GSAP animation library.
   *
   * @param {gsap} gsap GSAP library.
   */ MouseFollower.registerGSAP = function registerGSAP(gsap) {
        MouseFollower.gsap = gsap;
    } /**
   * Create cursor instance.
   *
   * @param {MouseFollowerOptions} [options] Cursor options.
   */ ;
    function MouseFollower(options) {
        if (options === void 0) options = {};
        /** @type {MouseFollowerOptions} **/ this.options = Object.assign({}, {
            el: null,
            container: document.body,
            className: 'mf-cursor',
            innerClassName: 'mf-cursor-inner',
            textClassName: 'mf-cursor-text',
            mediaClassName: 'mf-cursor-media',
            mediaBoxClassName: 'mf-cursor-media-box',
            iconSvgClassName: 'mf-svgsprite',
            iconSvgNamePrefix: '-',
            iconSvgSrc: '',
            dataAttr: 'cursor',
            hiddenState: '-hidden',
            textState: '-text',
            iconState: '-icon',
            activeState: '-active',
            mediaState: '-media',
            stateDetection: {
                '-pointer': 'a,button'
            },
            visible: true,
            visibleOnState: false,
            speed: 0.55,
            ease: 'expo.out',
            overwrite: true,
            skewing: 0,
            skewingText: 2,
            skewingIcon: 2,
            skewingMedia: 2,
            skewingDelta: 0.001,
            skewingDeltaMax: 0.15,
            stickDelta: 0.15,
            showTimeout: 0,
            hideOnLeave: true,
            hideTimeout: 300,
            hideMediaTimeout: 300,
            initialPos: [
                -window.innerWidth,
                -window.innerHeight
            ]
        }, options);
        if (this.options.visible && options.stateDetection == null) this.options.stateDetection['-hidden'] = 'iframe';
        this.gsap = MouseFollower.gsap || window.gsap;
        this.el = typeof this.options.el === 'string' ? document.querySelector(this.options.el) : this.options.el;
        this.container = typeof this.options.container === 'string' ? document.querySelector(this.options.container) : this.options.container;
        this.skewing = this.options.skewing;
        this.pos = {
            x: this.options.initialPos[0],
            y: this.options.initialPos[1]
        };
        this.vel = {
            x: 0,
            y: 0
        };
        this.event = {};
        this.events = [];
        this.init();
    }
    /**
   * Init cursor.
   */ var _proto = MouseFollower.prototype;
    _proto.init = function init() {
        if (!this.el) this.create();
        this.createSetter();
        this.bind();
        this.render(true);
        this.ticker = this.render.bind(this, false);
        this.gsap.ticker.add(this.ticker);
    } /**
   * Create cursor DOM element and append to container.
   */ ;
    _proto.create = function create() {
        this.el = document.createElement('div');
        this.el.className = this.options.className;
        this.el.classList.add(this.options.hiddenState);
        this.inner = document.createElement('div');
        this.inner.className = this.options.innerClassName;
        this.text = document.createElement('div');
        this.text.className = this.options.textClassName;
        this.media = document.createElement('div');
        this.media.className = this.options.mediaClassName;
        this.mediaBox = document.createElement('div');
        this.mediaBox.className = this.options.mediaBoxClassName;
        this.media.appendChild(this.mediaBox);
        this.inner.appendChild(this.media);
        this.inner.appendChild(this.text);
        this.el.appendChild(this.inner);
        this.container.appendChild(this.el);
    } /**
   * Create GSAP setters.
   */ ;
    _proto.createSetter = function createSetter() {
        this.setter = {
            x: this.gsap.quickSetter(this.el, 'x', 'px'),
            y: this.gsap.quickSetter(this.el, 'y', 'px'),
            rotation: this.gsap.quickSetter(this.el, 'rotation', 'deg'),
            scaleX: this.gsap.quickSetter(this.el, 'scaleX'),
            scaleY: this.gsap.quickSetter(this.el, 'scaleY'),
            wc: this.gsap.quickSetter(this.el, 'willChange'),
            inner: {
                rotation: this.gsap.quickSetter(this.inner, 'rotation', 'deg')
            }
        };
    } /**
   * Create and attach events.
   */ ;
    _proto.bind = function bind() {
        var _this = this;
        this.event.mouseleave = function() {
            return _this.hide();
        };
        this.event.mouseenter = function() {
            return _this.show();
        };
        this.event.mousedown = function() {
            return _this.addState(_this.options.activeState);
        };
        this.event.mouseup = function() {
            return _this.removeState(_this.options.activeState);
        };
        this.event.mousemoveOnce = function() {
            return _this.show();
        };
        this.event.mousemove = function(e) {
            _this.gsap.to(_this.pos, {
                x: _this.stick ? _this.stick.x - (_this.stick.x - e.clientX) * _this.options.stickDelta : e.clientX,
                y: _this.stick ? _this.stick.y - (_this.stick.y - e.clientY) * _this.options.stickDelta : e.clientY,
                overwrite: _this.options.overwrite,
                ease: _this.options.ease,
                duration: _this.visible ? _this.options.speed : 0,
                onUpdate: function onUpdate() {
                    return _this.vel = {
                        x: e.clientX - _this.pos.x,
                        y: e.clientY - _this.pos.y
                    };
                }
            });
        };
        this.event.mouseover = function(e) {
            for(var target = e.target; target && target !== _this.container; target = target.parentNode){
                if (e.relatedTarget && target.contains(e.relatedTarget)) break;
                for(var state in _this.options.stateDetection)if (target.matches(_this.options.stateDetection[state])) _this.addState(state);
                if (_this.options.dataAttr) {
                    var params = _this.getFromDataset(target);
                    if (params.state) _this.addState(params.state);
                    if (params.text) _this.setText(params.text);
                    if (params.icon) _this.setIcon(params.icon);
                    if (params.img) _this.setImg(params.img);
                    if (params.video) _this.setVideo(params.video);
                    if (typeof params.show !== 'undefined') _this.show();
                    if (typeof params.stick !== 'undefined') _this.setStick(params.stick || target);
                }
            }
        };
        this.event.mouseout = function(e) {
            for(var target = e.target; target && target !== _this.container; target = target.parentNode){
                if (e.relatedTarget && target.contains(e.relatedTarget)) break;
                for(var state in _this.options.stateDetection)if (target.matches(_this.options.stateDetection[state])) _this.removeState(state);
                if (_this.options.dataAttr) {
                    var params = _this.getFromDataset(target);
                    if (params.state) _this.removeState(params.state);
                    if (params.text) _this.removeText();
                    if (params.icon) _this.removeIcon();
                    if (params.img) _this.removeImg();
                    if (params.video) _this.removeVideo();
                    if (typeof params.show !== 'undefined') _this.hide();
                    if (typeof params.stick !== 'undefined') _this.removeStick();
                }
            }
        };
        if (this.options.hideOnLeave) this.container.addEventListener('mouseleave', this.event.mouseleave, {
            passive: true
        });
        if (this.options.visible) this.container.addEventListener('mouseenter', this.event.mouseenter, {
            passive: true
        });
        if (this.options.activeState) {
            this.container.addEventListener('mousedown', this.event.mousedown, {
                passive: true
            });
            this.container.addEventListener('mouseup', this.event.mouseup, {
                passive: true
            });
        }
        this.container.addEventListener('mousemove', this.event.mousemove, {
            passive: true
        });
        if (this.options.visible) this.container.addEventListener('mousemove', this.event.mousemoveOnce, {
            passive: true,
            once: true
        });
        if (this.options.stateDetection || this.options.dataAttr) {
            this.container.addEventListener('mouseover', this.event.mouseover, {
                passive: true
            });
            this.container.addEventListener('mouseout', this.event.mouseout, {
                passive: true
            });
        }
    } /**
   * Render the cursor in a new position.
   *
   * @param {boolean} [force=false] Force render.
   */ ;
    _proto.render = function render(force) {
        if (force !== true && (this.vel.y === 0 || this.vel.x === 0)) {
            this.setter.wc('auto');
            return;
        }
        this.trigger('render');
        this.setter.wc('transform');
        this.setter.x(this.pos.x);
        this.setter.y(this.pos.y);
        if (this.skewing) {
            var distance = Math.sqrt(Math.pow(this.vel.x, 2) + Math.pow(this.vel.y, 2));
            var scale = Math.min(distance * this.options.skewingDelta, this.options.skewingDeltaMax) * this.skewing;
            var angle = Math.atan2(this.vel.y, this.vel.x) * 180 / Math.PI;
            this.setter.rotation(angle);
            this.setter.scaleX(1 + scale);
            this.setter.scaleY(1 - scale);
            this.setter.inner.rotation(-angle);
        }
    } /**
   * Show cursor.
   */ ;
    _proto.show = function show() {
        var _this2 = this;
        this.trigger('show');
        clearInterval(this.visibleInt);
        this.visibleInt = setTimeout(function() {
            _this2.el.classList.remove(_this2.options.hiddenState);
            _this2.visible = true;
            _this2.render(true);
        }, this.options.showTimeout);
    } /**
   * Hide cursor.
   */ ;
    _proto.hide = function hide() {
        var _this3 = this;
        this.trigger('hide');
        clearInterval(this.visibleInt);
        this.el.classList.add(this.options.hiddenState);
        this.visibleInt = setTimeout(function() {
            return _this3.visible = false;
        }, this.options.hideTimeout);
    } /**
   * Toggle cursor.
   *
   * @param {boolean} [force] Force state.
   */ ;
    _proto.toggle = function toggle(force) {
        if (force === true || force !== false && !this.visible) this.show();
        else this.hide();
    } /**
   * Add state/states to the cursor.
   *
   * @param {string} state State name.
   */ ;
    _proto.addState = function addState(state) {
        var _this$el$classList;
        this.trigger('addState', state);
        if (state === this.options.hiddenState) return this.hide();
        (_this$el$classList = this.el.classList).add.apply(_this$el$classList, state.split(' '));
        if (this.options.visibleOnState) this.show();
    } /**
   * Remove state/states from cursor.
   *
   * @param {string} state State name.
   */ ;
    _proto.removeState = function removeState(state) {
        var _this$el$classList2;
        this.trigger('removeState', state);
        if (state === this.options.hiddenState) return this.show();
        (_this$el$classList2 = this.el.classList).remove.apply(_this$el$classList2, state.split(' '));
        if (this.options.visibleOnState && this.el.className === this.options.className) this.hide();
    } /**
   * Toggle cursor state.
   *
   * @param {string} state State name.
   * @param {boolean} [force] Force state.
   */ ;
    _proto.toggleState = function toggleState(state, force) {
        if (force === true || force !== false && !this.el.classList.contains(state)) this.addState(state);
        else this.removeState(state);
    } /**
   * Set factor of skewing effect.
   *
   * @param {number} value Skewing factor.
   */ ;
    _proto.setSkewing = function setSkewing(value) {
        this.gsap.to(this, {
            skewing: value
        });
    } /**
   * Reverts skewing factor to default.
   */ ;
    _proto.removeSkewing = function removeSkewing() {
        this.gsap.to(this, {
            skewing: this.options.skewing
        });
    } /**
   * Stick cursor to the element.
   *
   * @param {string|HTMLElement} element Element or selector.
   */ ;
    _proto.setStick = function setStick(element) {
        var el = typeof element === 'string' ? document.querySelector(element) : element;
        var rect = el.getBoundingClientRect();
        this.stick = {
            y: rect.top + rect.height / 2,
            x: rect.left + rect.width / 2
        };
    } /**
   * Unstick cursor from the element.
   */ ;
    _proto.removeStick = function removeStick() {
        this.stick = false;
    } /**
   * Transform cursor to text mode with a given string.
   *
   * @param {string} text Text.
   */ ;
    _proto.setText = function setText(text) {
        this.text.innerHTML = text;
        this.addState(this.options.textState);
        this.setSkewing(this.options.skewingText);
    } /**
   * Reverts cursor from text mode.
   */ ;
    _proto.removeText = function removeText() {
        this.removeState(this.options.textState);
        this.removeSkewing();
    } /**
   * Transform cursor to svg icon mode.
   *
   * @param {string} name Icon identifier.
   * @param {string} [style=""] Additional SVG styles.
   */ ;
    _proto.setIcon = function setIcon(name, style) {
        if (style === void 0) style = '';
        this.text.innerHTML = "<svg class='" + this.options.iconSvgClassName + " " + this.options.iconSvgNamePrefix + name + "'" + (" style='" + style + "'><use xlink:href='" + this.options.iconSvgSrc + "#" + name + "'></use></svg>");
        this.addState(this.options.iconState);
        this.setSkewing(this.options.skewingIcon);
    } /**
   * Reverts cursor from icon mode.
   */ ;
    _proto.removeIcon = function removeIcon() {
        this.removeState(this.options.iconState);
        this.removeSkewing();
    } /**
   * Transform cursor to media mode with a given element.
   *
   * @param {HTMLElement} element Element.
   */ ;
    _proto.setMedia = function setMedia(element) {
        var _this4 = this;
        clearTimeout(this.mediaInt);
        if (element) {
            this.mediaBox.innerHTML = '';
            this.mediaBox.appendChild(element);
        }
        this.mediaInt = setTimeout(function() {
            return _this4.addState(_this4.options.mediaState);
        }, 20);
        this.setSkewing(this.options.skewingMedia);
    } /**
   * Revert cursor from media mode.
   */ ;
    _proto.removeMedia = function removeMedia() {
        var _this5 = this;
        clearTimeout(this.mediaInt);
        this.removeState(this.options.mediaState);
        this.mediaInt = setTimeout(function() {
            return _this5.mediaBox.innerHTML = '';
        }, this.options.hideMediaTimeout);
        this.removeSkewing();
    } /**
   * Transform cursor to image mode.
   *
   * @param {string} url Image url.
   */ ;
    _proto.setImg = function setImg(url) {
        if (!this.mediaImg) this.mediaImg = new Image();
        if (this.mediaImg.src !== url) this.mediaImg.src = url;
        this.setMedia(this.mediaImg);
    } /**
   * Reverts cursor from image mode.
   */ ;
    _proto.removeImg = function removeImg() {
        this.removeMedia();
    } /**
   * Transform cursor to video mode.
   *
   * @param {string} url Video url.
   */ ;
    _proto.setVideo = function setVideo(url) {
        if (!this.mediaVideo) {
            this.mediaVideo = document.createElement('video');
            this.mediaVideo.muted = true;
            this.mediaVideo.loop = true;
            this.mediaVideo.autoplay = true;
        }
        if (this.mediaVideo.src !== url) {
            this.mediaVideo.src = url;
            this.mediaVideo.load();
        }
        this.mediaVideo.play();
        this.setMedia(this.mediaVideo);
    } /**
   * Reverts cursor from video mode.
   */ ;
    _proto.removeVideo = function removeVideo() {
        if (this.mediaVideo && this.mediaVideo.readyState > 2) this.mediaVideo.pause();
        this.removeMedia();
    } /**
   * Attach an event handler function.
   *
   * @param {string} event Event name.
   * @param {function} callback Callback.
   */ ;
    _proto.on = function on(event, callback) {
        if (!(this.events[event] instanceof Array)) this.off(event);
        this.events[event].push(callback);
    } /**
   * Remove an event handler.
   *
   * @param {string} event Event name.
   * @param {function} [callback] Callback.
   */ ;
    _proto.off = function off(event, callback) {
        if (callback) this.events[event] = this.events[event].filter(function(f) {
            return f !== callback;
        });
        else this.events[event] = [];
    } /**
   * Execute all handlers for the given event type.
   *
   * @param {string} event Event name.
   * @param params Extra parameters.
   */ ;
    _proto.trigger = function trigger(event) {
        var _arguments = arguments, _this6 = this;
        if (!this.events[event]) return;
        this.events[event].forEach(function(f) {
            return f.call.apply(f, [
                _this6,
                _this6
            ].concat([].slice.call(_arguments, 1)));
        });
    } /**
   * Get cursor options from data attribute of a given element.
   *
   * @param {HTMLElement} element Element.
   * @return {Object} Options.
   */ ;
    _proto.getFromDataset = function getFromDataset(element) {
        var dataset = element.dataset;
        return {
            state: dataset[this.options.dataAttr],
            show: dataset[this.options.dataAttr + 'Show'],
            text: dataset[this.options.dataAttr + 'Text'],
            icon: dataset[this.options.dataAttr + 'Icon'],
            img: dataset[this.options.dataAttr + 'Img'],
            video: dataset[this.options.dataAttr + 'Video'],
            stick: dataset[this.options.dataAttr + 'Stick']
        };
    } /**
   * Destroy cursor instance.
   */ ;
    _proto.destroy = function destroy() {
        this.trigger('destroy');
        this.gsap.ticker.remove(this.ticker);
        this.container.removeEventListener('mouseleave', this.event.mouseleave);
        this.container.removeEventListener('mouseenter', this.event.mouseenter);
        this.container.removeEventListener('mousedown', this.event.mousedown);
        this.container.removeEventListener('mouseup', this.event.mouseup);
        this.container.removeEventListener('mousemove', this.event.mousemove);
        this.container.removeEventListener('mousemove', this.event.mousemoveOnce);
        this.container.removeEventListener('mouseover', this.event.mouseover);
        this.container.removeEventListener('mouseout', this.event.mouseout);
        if (this.el) {
            this.container.removeChild(this.el);
            this.el = null;
            this.mediaImg = null;
            this.mediaVideo = null;
        }
    };
    return MouseFollower;
}();


const $0819eadcecfe3c54$export$622cea445a1c5b7d = (el)=>{
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
    };
};


/**
 * Function to getPosition of element in DOM
 * **/ function $0d3ea76a08c19ef7$export$1690e12b840569b9(element) {
    var xPosition = 0;
    var yPosition = 0;
    while(element){
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }
    return {
        x: xPosition,
        y: yPosition
    };
}
function $0d3ea76a08c19ef7$export$eebd1d6b9908ac73(element, classname) {
    if (element.className.split(' ').indexOf(classname) >= 0) return true;
    return element.parentNode && $0d3ea76a08c19ef7$export$eebd1d6b9908ac73(element.parentNode, classname);
}
function $0d3ea76a08c19ef7$export$ff7f7c97cdce86e(arr, needle) {
    return arr.reduce((a, b)=>{
        return Math.abs(b - needle) < Math.abs(a - needle) ? b : a;
    });
}
const $0d3ea76a08c19ef7$export$ef7b59bbfcfa5534 = (defaultValue, callback, callAfterInit = false)=>{
    const proxyHandler = {
        set (obj, prop, value) {
            if (prop === 'value') {
                obj[prop] = value;
                callback(value);
                return true;
            }
            return true;
        }
    };
    if (callAfterInit) callback(defaultValue);
    return new Proxy({
        value: defaultValue
    }, proxyHandler);
};
function $0d3ea76a08c19ef7$export$a1d0d20ee9546562() {
    return window.matchMedia('(pointer: coarse)').matches;
}


/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $bsOiL = parcelRequire("bsOiL");

var $dgs9t = parcelRequire("dgs9t");
const $09a2488a0b838f2a$var$Methods = {
    addClass: $dgs9t.addClass,
    removeClass: $dgs9t.removeClass,
    hasClass: $dgs9t.hasClass,
    toggleClass: $dgs9t.toggleClass,
    attr: $dgs9t.attr,
    removeAttr: $dgs9t.removeAttr,
    transform: $dgs9t.transform,
    transition: $dgs9t.transition,
    on: $dgs9t.on,
    off: $dgs9t.off,
    trigger: $dgs9t.trigger,
    transitionEnd: $dgs9t.transitionEnd,
    outerWidth: $dgs9t.outerWidth,
    outerHeight: $dgs9t.outerHeight,
    styles: $dgs9t.styles,
    offset: $dgs9t.offset,
    css: $dgs9t.css,
    each: $dgs9t.each,
    html: $dgs9t.html,
    text: $dgs9t.text,
    is: $dgs9t.is,
    index: $dgs9t.index,
    eq: $dgs9t.eq,
    append: $dgs9t.append,
    prepend: $dgs9t.prepend,
    next: $dgs9t.next,
    nextAll: $dgs9t.nextAll,
    prev: $dgs9t.prev,
    prevAll: $dgs9t.prevAll,
    parent: $dgs9t.parent,
    parents: $dgs9t.parents,
    closest: $dgs9t.closest,
    find: $dgs9t.find,
    children: $dgs9t.children,
    filter: $dgs9t.filter,
    remove: $dgs9t.remove
};
Object.keys($09a2488a0b838f2a$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $dgs9t.$).fn, methodName, {
        value: $09a2488a0b838f2a$var$Methods[methodName],
        writable: true
    });
});
var $09a2488a0b838f2a$export$2e2bcd8739ae039 = (0, $dgs9t.$);



var $bsOiL = parcelRequire("bsOiL");
function $66763f78a062fe47$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $66763f78a062fe47$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $66763f78a062fe47$export$461939dd4422153() {
    return Date.now();
}
function $66763f78a062fe47$export$3735103072e4a80(el) {
    const window1 = (0, $bsOiL.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $66763f78a062fe47$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $bsOiL.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $66763f78a062fe47$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $66763f78a062fe47$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $66763f78a062fe47$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $66763f78a062fe47$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$66763f78a062fe47$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($66763f78a062fe47$export$a6cdc56e425d0d0a(to[nextKey]) && $66763f78a062fe47$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $66763f78a062fe47$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$66763f78a062fe47$export$a6cdc56e425d0d0a(to[nextKey]) && $66763f78a062fe47$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $66763f78a062fe47$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $66763f78a062fe47$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $66763f78a062fe47$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $bsOiL.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $bsOiL = parcelRequire("bsOiL");
let $d37d3ba6ecfe5a72$var$support;
function $d37d3ba6ecfe5a72$var$calcSupport() {
    const window = (0, $bsOiL.getWindow)();
    const document = (0, $bsOiL.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $d37d3ba6ecfe5a72$export$d61c7b85ff180578() {
    if (!$d37d3ba6ecfe5a72$var$support) $d37d3ba6ecfe5a72$var$support = $d37d3ba6ecfe5a72$var$calcSupport();
    return $d37d3ba6ecfe5a72$var$support;
}



var $bsOiL = parcelRequire("bsOiL");

let $ae582f4d24f7c2fb$var$deviceCached;
function $ae582f4d24f7c2fb$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $d37d3ba6ecfe5a72$export$d61c7b85ff180578)();
    const window = (0, $bsOiL.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $ae582f4d24f7c2fb$export$30c823bc834d6ab4(overrides = {}) {
    if (!$ae582f4d24f7c2fb$var$deviceCached) $ae582f4d24f7c2fb$var$deviceCached = $ae582f4d24f7c2fb$var$calcDevice(overrides);
    return $ae582f4d24f7c2fb$var$deviceCached;
}



var $bsOiL = parcelRequire("bsOiL");
let $a30ceb5533f64505$var$browser;
function $a30ceb5533f64505$var$calcBrowser() {
    const window = (0, $bsOiL.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $a30ceb5533f64505$export$89e15fc796a4a429() {
    if (!$a30ceb5533f64505$var$browser) $a30ceb5533f64505$var$browser = $a30ceb5533f64505$var$calcBrowser();
    return $a30ceb5533f64505$var$browser;
}



var $bsOiL = parcelRequire("bsOiL");
function $cd460839c9cbbc59$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $bsOiL.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}



var $bsOiL = parcelRequire("bsOiL");
function $ef57bcfb5c097272$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $bsOiL.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}


/* eslint-disable no-underscore-dangle */ var $6a8281605c772701$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $210f60d32123e8e7$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $68eb0cf121c59169$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $426fa933ee75f219$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}


function $2af765414d9eaf96$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $b85aeb1d32e07acf$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $25eb2b21e967947d$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $98a889da9c221704$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $133b671b7a081d15$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $b7207ab419786c61$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $75ff85ec5879b45b$export$2e2bcd8739ae039 = {
    updateSize: $210f60d32123e8e7$export$2e2bcd8739ae039,
    updateSlides: $68eb0cf121c59169$export$2e2bcd8739ae039,
    updateAutoHeight: $426fa933ee75f219$export$2e2bcd8739ae039,
    updateSlidesOffset: $2af765414d9eaf96$export$2e2bcd8739ae039,
    updateSlidesProgress: $b85aeb1d32e07acf$export$2e2bcd8739ae039,
    updateProgress: $25eb2b21e967947d$export$2e2bcd8739ae039,
    updateSlidesClasses: $98a889da9c221704$export$2e2bcd8739ae039,
    updateActiveIndex: $133b671b7a081d15$export$2e2bcd8739ae039,
    updateClickedSlide: $b7207ab419786c61$export$2e2bcd8739ae039
};



function $0546a0b151930c41$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $66763f78a062fe47$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $7ac2389e38f913c5$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $5b58634c8d191622$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $7aa1f25adfe5bdab$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $5798041355eced0a$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $66763f78a062fe47$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $962db72774df1284$export$2e2bcd8739ae039 = {
    getTranslate: $0546a0b151930c41$export$2e2bcd8739ae039,
    setTranslate: $7ac2389e38f913c5$export$2e2bcd8739ae039,
    minTranslate: $5b58634c8d191622$export$2e2bcd8739ae039,
    maxTranslate: $7aa1f25adfe5bdab$export$2e2bcd8739ae039,
    translateTo: $5798041355eced0a$export$2e2bcd8739ae039
};


function $3190c9998aec4ae7$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $24e62f98c4361c80$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $f4d802a159993cd3$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $24e62f98c4361c80$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}



function $2b50bb871008a11b$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $24e62f98c4361c80$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}


var $89616bdae253e41c$export$2e2bcd8739ae039 = {
    setTransition: $3190c9998aec4ae7$export$2e2bcd8739ae039,
    transitionStart: $f4d802a159993cd3$export$2e2bcd8739ae039,
    transitionEnd: $2b50bb871008a11b$export$2e2bcd8739ae039
};



function $6ea64ad839f2c279$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $66763f78a062fe47$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $a4e955b960cd8fc8$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $4fb48a23c4503556$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $19c996edfff8eb5b$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $0e118ee037a33a24$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $a7269f78c96724cc$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $e8252889e03a0b18$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $a6edf884942961cd$export$2e2bcd8739ae039 = {
    slideTo: $6ea64ad839f2c279$export$2e2bcd8739ae039,
    slideToLoop: $a4e955b960cd8fc8$export$2e2bcd8739ae039,
    slideNext: $4fb48a23c4503556$export$2e2bcd8739ae039,
    slidePrev: $19c996edfff8eb5b$export$2e2bcd8739ae039,
    slideReset: $0e118ee037a33a24$export$2e2bcd8739ae039,
    slideToClosest: $a7269f78c96724cc$export$2e2bcd8739ae039,
    slideToClickedSlide: $e8252889e03a0b18$export$2e2bcd8739ae039
};



var $bsOiL = parcelRequire("bsOiL");

function $14baa2eb2e7097b0$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $bsOiL.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $a4c52dcbb96873be$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $2d57ee0418aa66b4$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $f15e4c9cc0e03817$export$2e2bcd8739ae039 = {
    loopCreate: $14baa2eb2e7097b0$export$2e2bcd8739ae039,
    loopFix: $a4c52dcbb96873be$export$2e2bcd8739ae039,
    loopDestroy: $2d57ee0418aa66b4$export$2e2bcd8739ae039
};


function $da7fb8973a20037f$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $0b67149cd017787a$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


var $5be8069dbb5c8df7$export$2e2bcd8739ae039 = {
    setGrabCursor: $da7fb8973a20037f$export$2e2bcd8739ae039,
    unsetGrabCursor: $0b67149cd017787a$export$2e2bcd8739ae039
};



var $bsOiL = parcelRequire("bsOiL");

var $bsOiL = parcelRequire("bsOiL");


function $354123c9cafb5485$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $bsOiL.getDocument)() || el === (0, $bsOiL.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $354123c9cafb5485$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $bsOiL.getDocument)();
    const window = (0, $bsOiL.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $354123c9cafb5485$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}



var $bsOiL = parcelRequire("bsOiL");


function $99259322ff43828e$export$2e2bcd8739ae039(event) {
    const document = (0, $bsOiL.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $66763f78a062fe47$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $bbede752bca22337$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $1572e748929275a7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $c4b0db16c657f9a5$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $b228fe3831925206$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


let $7e78f1d37a3135f1$var$dummyEventAttached = false;
function $7e78f1d37a3135f1$var$dummyEventListener() {}
const $7e78f1d37a3135f1$var$events = (swiper, method)=>{
    const document = (0, $bsOiL.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $1572e748929275a7$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]('observerUpdate', (0, $1572e748929275a7$export$2e2bcd8739ae039), true);
};
function $7e78f1d37a3135f1$var$attachEvents() {
    const swiper = this;
    const document = (0, $bsOiL.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $354123c9cafb5485$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $99259322ff43828e$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $bbede752bca22337$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $b228fe3831925206$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $c4b0db16c657f9a5$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$7e78f1d37a3135f1$var$dummyEventAttached) {
        document.addEventListener('touchstart', $7e78f1d37a3135f1$var$dummyEventListener);
        $7e78f1d37a3135f1$var$dummyEventAttached = true;
    }
    $7e78f1d37a3135f1$var$events(swiper, 'on');
}
function $7e78f1d37a3135f1$var$detachEvents() {
    const swiper = this;
    $7e78f1d37a3135f1$var$events(swiper, 'off');
}
var $7e78f1d37a3135f1$export$2e2bcd8739ae039 = {
    attachEvents: $7e78f1d37a3135f1$var$attachEvents,
    detachEvents: $7e78f1d37a3135f1$var$detachEvents
};



const $e4e317f56ed14b72$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $e4e317f56ed14b72$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $e4e317f56ed14b72$var$isGridEnabled(swiper, params);
    const isMultiRow = $e4e317f56ed14b72$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $66763f78a062fe47$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $bsOiL = parcelRequire("bsOiL");
function $6c086ee93f033c59$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $bsOiL.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $1dbac7449a9a70b4$export$2e2bcd8739ae039 = {
    setBreakpoint: $e4e317f56ed14b72$export$2e2bcd8739ae039,
    getBreakpoint: $6c086ee93f033c59$export$2e2bcd8739ae039
};


function $242fed346075ae93$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $242fed346075ae93$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $242fed346075ae93$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}


function $7b231c1bcc1cd8d1$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $e34e3657ee98588a$export$2e2bcd8739ae039 = {
    addClasses: $242fed346075ae93$export$2e2bcd8739ae039,
    removeClasses: $7b231c1bcc1cd8d1$export$2e2bcd8739ae039
};



var $bsOiL = parcelRequire("bsOiL");

function $e8d5422f90e359ec$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $bsOiL.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $353418d5bf56f01e$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $6c5c43237fe6188b$export$2e2bcd8739ae039 = {
    loadImage: $e8d5422f90e359ec$export$2e2bcd8739ae039,
    preloadImages: $353418d5bf56f01e$export$2e2bcd8739ae039
};


function $489d4307d1a2a0a4$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $489d4307d1a2a0a4$export$2e2bcd8739ae039 = {
    checkOverflow: $489d4307d1a2a0a4$var$checkOverflow
};


var $39dec5f93d59aafb$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $a630f0dbc46875f1$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $66763f78a062fe47$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $66763f78a062fe47$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $66763f78a062fe47$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $41c4fba6d5b8bc4d$var$prototypes = {
    eventsEmitter: $6a8281605c772701$export$2e2bcd8739ae039,
    update: $75ff85ec5879b45b$export$2e2bcd8739ae039,
    translate: $962db72774df1284$export$2e2bcd8739ae039,
    transition: $89616bdae253e41c$export$2e2bcd8739ae039,
    slide: $a6edf884942961cd$export$2e2bcd8739ae039,
    loop: $f15e4c9cc0e03817$export$2e2bcd8739ae039,
    grabCursor: $5be8069dbb5c8df7$export$2e2bcd8739ae039,
    events: $7e78f1d37a3135f1$export$2e2bcd8739ae039,
    breakpoints: $1dbac7449a9a70b4$export$2e2bcd8739ae039,
    checkOverflow: $489d4307d1a2a0a4$export$2e2bcd8739ae039,
    classes: $e34e3657ee98588a$export$2e2bcd8739ae039,
    images: $6c5c43237fe6188b$export$2e2bcd8739ae039
};
const $41c4fba6d5b8bc4d$var$extendedDefaults = {};
class $41c4fba6d5b8bc4d$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $41c4fba6d5b8bc4d$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $d37d3ba6ecfe5a72$export$d61c7b85ff180578)();
        swiper.device = (0, $ae582f4d24f7c2fb$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $a30ceb5533f64505$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $a630f0dbc46875f1$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, (0, $39dec5f93d59aafb$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, swiperParams, $41c4fba6d5b8bc4d$var$extendedDefaults, params);
        swiper.originalParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $66763f78a062fe47$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $66763f78a062fe47$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $bsOiL.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $66763f78a062fe47$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $66763f78a062fe47$export$8b58be045bf06082)($41c4fba6d5b8bc4d$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $41c4fba6d5b8bc4d$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $39dec5f93d59aafb$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$41c4fba6d5b8bc4d$var$Swiper.prototype.__modules__) $41c4fba6d5b8bc4d$var$Swiper.prototype.__modules__ = [];
        const modules = $41c4fba6d5b8bc4d$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$41c4fba6d5b8bc4d$var$Swiper.installModule(m));
            return $41c4fba6d5b8bc4d$var$Swiper;
        }
        $41c4fba6d5b8bc4d$var$Swiper.installModule(module);
        return $41c4fba6d5b8bc4d$var$Swiper;
    }
}
Object.keys($41c4fba6d5b8bc4d$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($41c4fba6d5b8bc4d$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $41c4fba6d5b8bc4d$var$Swiper.prototype[protoMethod] = $41c4fba6d5b8bc4d$var$prototypes[prototypeGroup][protoMethod];
    });
});
$41c4fba6d5b8bc4d$var$Swiper.use([
    (0, $cd460839c9cbbc59$export$2e2bcd8739ae039),
    (0, $ef57bcfb5c097272$export$2e2bcd8739ae039)
]);
var $41c4fba6d5b8bc4d$export$2e2bcd8739ae039 = $41c4fba6d5b8bc4d$var$Swiper;




function $4884439917ba81a8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $66763f78a062fe47$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $bsOiL = parcelRequire("bsOiL");

function $65a8e7a53f8571a2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $bsOiL.getDocument)();
    const window = (0, $bsOiL.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $bsOiL = parcelRequire("bsOiL");


function $000996de4791f079$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $bsOiL.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $66763f78a062fe47$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $66763f78a062fe47$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $66763f78a062fe47$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $66763f78a062fe47$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $66763f78a062fe47$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $bsOiL = parcelRequire("bsOiL");
function $b2b5753ec39ba701$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $bsOiL.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $7b5d41c9939efc77$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $b2b5753ec39ba701$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $15f28c549e2c12fa$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}



function $00cadfbf20e66242$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $b2b5753ec39ba701$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $bsOiL = parcelRequire("bsOiL");



function $c5a497678a245696$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $bsOiL.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $b2b5753ec39ba701$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $ff992fdd4fc4c244$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $bsOiL = parcelRequire("bsOiL");


function $f5e3ad991037b6c6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $bsOiL.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $66763f78a062fe47$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $66763f78a062fe47$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $bsOiL = parcelRequire("bsOiL");

function $69a62319825aa708$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $bsOiL.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $9be603625c7cf795$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $c240c595c0d3fbdd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $15f28c549e2c12fa$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $bsOiL = parcelRequire("bsOiL");
function $c1978cb544450144$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $bsOiL.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $bsOiL.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $bsOiL.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $bsOiL.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $bsOiL = parcelRequire("bsOiL");

function $30ec01fbe608190c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $bsOiL.getDocument)();
    const window = (0, $bsOiL.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $bsOiL = parcelRequire("bsOiL");

function $d6a8de0ae0918423$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $66763f78a062fe47$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $bsOiL.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $bsOiL.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $bsOiL.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $72f9f0012f40ddc2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $66763f78a062fe47$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $b9ef5a7823f4e4ba$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $66763f78a062fe47$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $66763f78a062fe47$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $66763f78a062fe47$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $df520085d71b3a51$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $e4c2b7e31c11463d$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $3b130e40a5a9e723$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $504ed09ee395bc9d$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $56782469e370a8b6$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $139e0f202f1b0a63$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $d5271872f2f6357f$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $e4c2b7e31c11463d$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $3b130e40a5a9e723$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $504ed09ee395bc9d$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $56782469e370a8b6$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $139e0f202f1b0a63$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $8aa5bc9213868547$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $892958664a91861e$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}


function $06c97c96b512608b$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $8873c9004bc371bc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $3d213107b8942e00$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $4a6c085448bb9aa0$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $77cffb5b66fd0604$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $09a2488a0b838f2a$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $975c4d79e411ce84$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $acaeb69da8b99d8b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $89703391ee609a8f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $4a6c085448bb9aa0$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $892958664a91861e$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $06c97c96b512608b$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $8aa5bc9213868547$export$2e2bcd8739ae039)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




const $cc7dd15504793d86$var$isHomeScrollHintEnabled = ()=>window.BOLD_HOME_SCROLL_HINT_ENABLED === true;
window.initCursor = function initCursor1() {
    const isMouseDevice = window.matchMedia('(pointer: fine)').matches;
    if (!isMouseDevice) return;
    (0, $4959b9bff3093b7c$export$2e2bcd8739ae039).registerGSAP(gsap);
    const bodyBgEl = document.querySelector('.body-bg');
    const homeScrollHintElements = document.querySelectorAll('[data-home-scroll-hint]');
    homeScrollHintElements.forEach((element)=>{
        if ($cc7dd15504793d86$var$isHomeScrollHintEnabled()) {
            element.dataset.cursorText = 'Scroll';
            return;
        }
        element.removeAttribute('data-cursor-text');
    });
    const cursorTextsArr = document.querySelectorAll('[data-cursor-text]');
    if (cursorTextsArr.length) cursorTextsArr.forEach((el)=>{
        el.classList.add('.cursor-text');
    });
    const stateDetection = {
        '-pointer': 'a:not(.menu-link),button:not(.menu-link)',
        '-hidden': '.btn-link,.embedsocial-hashtag,.drag-item,.chat-modal',
        '-icon-only': '.btn-icon-only',
        '-full-video': '.full-video-bg',
        '-btn': '.btn-wr,.btn-to-top,.btn-call,.menu-link-btn,.dir-control-btn,.dir-control,.cc-nb-okagree,.cc-nb-reject,.cc-nb-changep,.cc-cp-foot-save,.following-chat-btn,.burger',
        '-cursor-text-hidden': '[data-cursor-text-hidden]',
        '-cursor-title-img': '.first-sec__title-image'
    };
    if ($cc7dd15504793d86$var$isHomeScrollHintEnabled()) stateDetection['-first-scroll'] = '.home-first-sec';
    window.cursor = !(0, $0d3ea76a08c19ef7$export$a1d0d20ee9546562)() ? new (0, $4959b9bff3093b7c$export$2e2bcd8739ae039)({
        speed: 1.1,
        stickDelta: 0,
        iconSvgSrc: 'app/assets/static/icons/play.svg',
        iconSvgClassName: 'play',
        iconSvgNamePrefix: '-',
        stateDetection: stateDetection
    }) : null;
    if (cursor) {
        let cursorRaf = null;
        window.addEventListener('mousemove', (e)=>{
            if (cursorRaf !== null) return;
            const clientX = e.clientX;
            const clientY = e.clientY;
            cursorRaf = requestAnimationFrame(()=>{
                cursor.position = {
                    x: clientX,
                    y: clientY
                };
                cursorRaf = null;
            });
        }, {
            passive: true
        });
    }
    /*if (document.querySelector('.bold-loader')) {
    const boldLoader = document.querySelector('.bold-loader');
    boldLoader.addEventListener('mousemove', () => {
      cursor.hide();
    });

    boldLoader.addEventListener('mouseleave', () => {
      cursor.show();
    });
  }

  if (document.querySelector('.bold-loader-new')) {
    const boldLoader = document.querySelector('.bold-loader-new');
    boldLoader.addEventListener('mousemove', () => {
      cursor.hide();
    });

    boldLoader.addEventListener('mouseleave', () => {
      cursor.show();
    });
  }*/ if (cursor) setTimeout(()=>{
        const cursorInner = document.querySelector('.mf-cursor-inner');
        cursorInner;
    }, 100);
    if (cursor && $cc7dd15504793d86$var$isHomeScrollHintEnabled()) {
        const SCROLL_IDLE_DELAY = 4000;
        const MIN_SHOW_TIME = 2000;
        let scrollIdleTimeout;
        let firstScrollActive = false;
        let mouseMoveListenerAdded = false;
        let scrollActivatedTimestamp = 0;
        let isUserScrolling = false;
        let currentMouseX = 0;
        let currentMouseY = 0;
        const allStates = [
            '-pointer',
            '-hidden',
            '-icon-only',
            '-icon',
            '-burger',
            '-btn',
            '-cursor-text-hidden'
        ];
        const cursorEl = document.querySelector('.mf-cursor');
        const hasAnyActiveState = ()=>allStates.some((stateClass)=>cursorEl.classList.contains(stateClass));
        let lastMouseX = null;
        let lastMouseY = null;
        const onMouseMove = (e)=>{
            currentMouseX = e.clientX;
            currentMouseY = e.clientY;
            if (lastMouseX === null || lastMouseY === null) {
                lastMouseX = e.clientX;
                lastMouseY = e.clientY;
                return;
            }
            const deltaX = Math.abs(e.clientX - lastMouseX);
            const deltaY = Math.abs(e.clientY - lastMouseY);
            if (deltaX > 20 || deltaY > 20) {
                lastMouseX = e.clientX;
                lastMouseY = e.clientY;
                if (firstScrollActive && (hasAnyActiveState() || isUserScrolling)) {
                    deactivateScrollReminder();
                    return;
                }
                const timeSinceActivate = Date.now() - scrollActivatedTimestamp;
                if (firstScrollActive && timeSinceActivate < MIN_SHOW_TIME) return;
            }
        };
        const updateMousePosition = (e)=>{
            currentMouseX = e.clientX;
            currentMouseY = e.clientY;
        };
        window.addEventListener('mousemove', updateMousePosition);
        const addMouseMoveListener = ()=>{
            if (!mouseMoveListenerAdded) {
                window.addEventListener('mousemove', onMouseMove);
                mouseMoveListenerAdded = true;
            }
        };
        const removeMouseMoveListener = ()=>{
            if (mouseMoveListenerAdded) {
                window.removeEventListener('mousemove', onMouseMove);
                mouseMoveListenerAdded = false;
                lastMouseX = null;
                lastMouseY = null;
            }
        };
        const activateScrollReminder = ()=>{
            if (hasAnyActiveState() || firstScrollActive) return;
            if (document.querySelector('.bold-popup')) return;
            const elUnderCursor = document.elementFromPoint(currentMouseX, currentMouseY);
            if (elUnderCursor?.closest('.full-video-bg')) return;
            cursor.addState('-first-scroll');
            cursor.addState('-text');
            cursor.setText('Scroll');
            firstScrollActive = true;
            scrollActivatedTimestamp = Date.now();
            addMouseMoveListener();
        };
        const deactivateScrollReminder = ()=>{
            if (!firstScrollActive) return;
            cursor.removeState('-first-scroll');
            cursor.removeState('-text');
            cursor.removeText();
            firstScrollActive = false;
            removeMouseMoveListener();
        };
        const resetScrollIdleTimer = ()=>{
            clearTimeout(scrollIdleTimeout);
            deactivateScrollReminder();
            isUserScrolling = true;
            scrollIdleTimeout = setTimeout(()=>{
                isUserScrolling = false;
                activateScrollReminder();
            }, SCROLL_IDLE_DELAY);
        };
        let scrollEndTimeout;
        const handleScrollEnd = ()=>{
            clearTimeout(scrollEndTimeout);
            scrollEndTimeout = setTimeout(()=>{
                isUserScrolling = false;
            }, 150);
        };
        if (document.querySelector('.bold-loader-new')) {
            window.addEventListener('scroll', ()=>{
                resetScrollIdleTimer();
                handleScrollEnd();
            }, {
                passive: true
            });
            resetScrollIdleTimer();
        }
    }
    const stickyWrapList = document.querySelectorAll('[data-sticky-wrap]');
    if (!(0, $0d3ea76a08c19ef7$export$a1d0d20ee9546562)()) stickyWrapList.forEach((stickyWrap)=>{
        const stickyTarget = stickyWrap.querySelector('[data-sticky-target]');
        stickyWrap.addEventListener('mousemove', (e)=>{
            const { top: offsetTop, left: offsetLeft } = (0, $0819eadcecfe3c54$export$622cea445a1c5b7d)(stickyWrap);
            const x = e.pageX - offsetLeft - stickyWrap.clientWidth / 2;
            const y = e.pageY - offsetTop - stickyWrap.clientHeight / 2;
            const xPosition = (x - stickyWrap.clientWidth / 2) / stickyWrap.clientWidth * 10;
            const yPosition = (y - stickyWrap.clientHeight / 2) / stickyWrap.clientHeight * 10;
            gsap.to(stickyWrap, {
                scale: 2,
                ease: 'power2.out'
            });
            gsap.to(stickyTarget, {
                x: xPosition,
                y: yPosition,
                scale: 0.5,
                ease: 'power2.out'
            });
            cursor?.el.style.setProperty('--x-offset', `${xPosition}px`);
            cursor?.el.style.setProperty('--y-offset', `${yPosition}px`);
        });
        stickyWrap.addEventListener('mouseleave', ()=>{
            gsap.to(stickyWrap, {
                scale: 1,
                ease: 'power2.out'
            });
            gsap.to(stickyTarget, {
                x: 0,
                y: 0,
                scale: 1,
                ease: 'power2.out'
            });
            cursor?.el.style.setProperty('--x-offset', `0px`);
            cursor?.el.style.setProperty('--y-offset', `0px`);
        });
    });
    const iconBtnList = document.querySelectorAll('.btn-icon');
    iconBtnList.forEach((btn)=>{
        btn.addEventListener('mouseenter', ()=>{
            const target = btn.querySelector('.btn-icon__icon-wrap');
            cursor?.setStick(target);
        });
        btn.addEventListener('mouseleave', ()=>{
            cursor?.removeStick();
        });
    });
    const videoSecEl = document.querySelector('.video-full-sec');
    if (videoSecEl) {
        videoSecEl.addEventListener('mouseenter', ()=>{
            const cursorEl = document.querySelector('.mf-cursor');
            cursorEl.classList.add('is-video');
            cursor.setIcon('play');
        });
        videoSecEl.addEventListener('mouseleave', ()=>{
            const cursorEl = document.querySelector('.mf-cursor');
            cursorEl.classList.remove('is-video');
            cursor.removeIcon();
        });
    }
    const iconOnlyBtnList = document.querySelectorAll('.btn');
    iconOnlyBtnList.forEach((btn)=>{
    /*btn.addEventListener('mouseenter', () => {
      /!*cursor.setStick(btn);*!/

      if (bodyBgEl.classList.contains('is-dark-bg')) {
      }

      if (bodyBgEl.classList.contains('is-dark-bg')) {
      }
    });

    btn.addEventListener('mouseleave', () => {
      cursor.removeStick();
    });*/ });
    cursorTextsArr.forEach((element, idx)=>{
        const value = element.dataset.cursorText;
        let text = value !== '' ? value : 'Test';
        if (element.classList.contains('home-first-sec')) {
            element.addEventListener('mouseover', ()=>{
                cursor.setText(`${text}`);
            });
            const mouseEnterEvent = new Event('mouseenter');
            if (element.matches(':hover')) element.dispatchEvent(mouseEnterEvent);
        }
        element.addEventListener('mouseenter', ()=>{
            cursor.setText(`${text}`);
        });
        element.addEventListener('mouseleave', ()=>{
            cursor.removeText();
        });
    });
    /*const linkList = document.querySelectorAll('.menu-link');

  linkList.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      cursor.addState('-hidden');
    });

    link.addEventListener('mouseleave', () => {
      cursor.removeState('-hidden');
    });
  });*/ // function moveElement(e, target) {
    //   Tween.to(target, 0.3, {
    //     css: {
    //       left: e.x - target.offsetWidth / 2,
    //       top: e.y - target.offsetHeight / 2,
    //     },
    //   });
    // }
    /*
  const serviceList = document.querySelector('.services-list');

  if (serviceList) {
    const serviceItems = serviceList.querySelectorAll('.services-list__item');

    const slider = serviceList.querySelector('.services-list__slider');

    if (slider) {
      const swiper = new Swiper(slider, {
        direction: 'vertical',
        speed: 500,
      });

      serviceList.addEventListener('mousemove', (e) => {
        moveElement(e, slider);
      });
      serviceList.addEventListener('mouseenter', () => {
        slider.classList.add('is-show');
      });
      serviceList.addEventListener('mouseleave', () => {
        slider.classList.remove('is-show');
      });

      serviceItems.forEach((item, idx) => {
        item.addEventListener('mouseenter', () => {
          swiper.slideTo(idx);
        });
      });
    }
  }
  */ const bodyBg = document.querySelector('.body-bg');
    if (bodyBg && cursor) {
        const updateCursorBgClass = ()=>{
            const cursor1 = document.querySelector('.mf-cursor');
            cursor1.classList.remove('is-cursor-bg-light', 'is-cursor-bg-dark');
            if (bodyBg.classList.contains('is-bg-dark') || bodyBg.classList.contains('is-worked-first-fixed-bg') || bodyBg.classList.contains('is-worked-fixed-bg')) cursor1.classList.add('is-cursor-bg-dark');
            else if (bodyBg.classList.contains('is-bg-light')) cursor1.classList.add('is-cursor-bg-light');
        };
        updateCursorBgClass();
        const observer = new MutationObserver(updateCursorBgClass);
        observer.observe(bodyBg, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
    }
/*const lightSections = document.querySelectorAll('[data-cursor-bg-light]');
  const darkSections = document.querySelectorAll('[data-cursor-bg-dark]');

  if (lightSections.length) {
    lightSections.forEach((lightSection) => {
      lightSection.addEventListener('mouseenter', () => {
        const cursor = document.querySelector('.mf-cursor');

        if (cursor) {
          cursor.classList.add('is-cursor-bg-light');
        }
      });

      lightSection.addEventListener('mouseleave', () => {
        const cursor = document.querySelector('.mf-cursor');

        if (cursor) {
          cursor.classList.remove('is-cursor-bg-light');
        }
      });
    });
  }

  if (darkSections.length) {
    darkSections.forEach((darkSection) => {
      darkSection.addEventListener('mouseenter', () => {
        if (!darkSection.classList.contains('is-hidden-gradient')) {
          const cursor = document.querySelector('.mf-cursor');

          if (cursor) {
            cursor.classList.add('is-cursor-bg-dark');
          }
        }
      });

      darkSection.addEventListener('mouseleave', () => {
        const cursor = document.querySelector('.mf-cursor');

        if (cursor) {
          cursor.classList.remove('is-cursor-bg-dark');
        }
      });
    });
  }*/ };
if (!document.querySelector('.bold-loader-new')) initCursor();
window.refreshCursorElements = function refreshCursorElements() {
    if (!window.cursor) return;
    const cursorTextsArr = document.querySelectorAll('[data-cursor-text]');
    cursorTextsArr.forEach((element)=>{
        if (element.dataset.cursorBound) return;
        const value = element.dataset.cursorText;
        const text = value !== '' ? value : 'Test';
        element.addEventListener('mouseenter', ()=>{
            window.cursor.setText(`${text}`);
        });
        element.addEventListener('mouseleave', ()=>{
            window.cursor.removeText();
        });
        element.dataset.cursorBound = 'true';
    });
    const iconBtnList = document.querySelectorAll('.btn-icon');
    iconBtnList.forEach((btn)=>{
        if (btn.dataset.cursorBound) return;
        const target = btn.querySelector('.btn-icon__icon-wrap');
        btn.addEventListener('mouseenter', ()=>{
            window.cursor?.setStick(target);
        });
        btn.addEventListener('mouseleave', ()=>{
            window.cursor?.removeStick();
        });
        btn.dataset.cursorBound = 'true';
    });
};
window.restartCursor = function restartCursor(forceDestroy = false) {
    if (window.cursor && typeof window.cursor.destroy === 'function') {
        window.cursor.destroy();
        window.cursor = null;
    }
    const oldCursorEl = document.querySelector('.mf-cursor');
    if (oldCursorEl && oldCursorEl.parentNode) oldCursorEl.parentNode.removeChild(oldCursorEl);
    initCursor();
};
window.scrollTitleCursor = function scrollTitleCursor1() {
    if (document.querySelector('.bold-loader-new') && !$cc7dd15504793d86$var$isHomeScrollHintEnabled()) return;
    const titlesArr = document.querySelectorAll('.cursor-scroll-title');
    const bodyEl = document.body;
    if (!titlesArr.length) return;
    titlesArr.forEach((element)=>{
        element.addEventListener('mouseenter', ()=>{
            bodyEl.classList.add('is-cursor-scroll-title');
        });
        element.addEventListener('mousemove', ()=>{
            bodyEl.classList.add('is-cursor-scroll-title');
        });
        element.addEventListener('mouseleave', ()=>{
            bodyEl.classList.remove('is-cursor-scroll-title');
        });
    });
    const titlesImagesArr = document.querySelectorAll('.first-sec__title-image-wr');
    titlesImagesArr.forEach((element)=>{
        element.addEventListener('mouseenter', ()=>{
            bodyEl.classList.add('is-cursor-scroll-title-image');
        });
        element.addEventListener('mouseleave', ()=>{
            bodyEl.classList.remove('is-cursor-scroll-title-image');
        });
    });
};
if (!document.querySelector('.bold-loader-new')) scrollTitleCursor();


window.footerScrollHiddenAnimation = function footerScrollHiddenAnimation() {
    const headerBottomComponent = document.querySelector('.header-bottom');
    const footerEl = document.querySelector('footer');
    const btnToTop = document.querySelector('.btn-to-top');
    const btnCall = document.querySelector('.btn-call');
    if (!headerBottomComponent || !footerEl) return;
    setTimeout(()=>{
        headerBottomComponent.querySelector('.header-bottom__wrap').style.transitionDelay = '0s';
    }, 500);
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const isIntersecting = entry.isIntersecting;
            if (isIntersecting) {
                headerBottomComponent.classList.remove('is-visible');
                btnToTop?.classList.add('is-hidden');
                btnCall?.classList.add('is-hidden');
            } else {
                headerBottomComponent.classList.add('is-visible');
                btnToTop?.classList.remove('is-hidden');
                btnCall?.classList.remove('is-hidden');
            }
        });
    }, {
        root: null,
        threshold: 0
    });
    observer.observe(footerEl);
};
const $9054bdb407069633$var$footerTitleMemory = {
    savedContent: null
};
function $9054bdb407069633$var$saveFooterTitleContent() {
    const footerTitleWr = document.querySelector('.footer__title-wr');
    if (!footerTitleWr) return;
    $9054bdb407069633$var$footerTitleMemory.savedContent = footerTitleWr.innerHTML;
}
function $9054bdb407069633$var$restoreFooterTitleContent() {
    const footerTitleWr = document.querySelector('.footer__title-wr');
    if (!footerTitleWr) return;
    if ($9054bdb407069633$var$footerTitleMemory.savedContent === null) return;
    footerTitleWr.innerHTML = $9054bdb407069633$var$footerTitleMemory.savedContent;
}
$9054bdb407069633$var$saveFooterTitleContent();
window.globalFooterTitleFunc = function globalFooterTitleFunc() {
    const footerTitleWr = document.querySelector('.footer__title-wr');
    if (footerTitleWr) {
        if (typeof destroyScrollBlurAnimation === 'function') destroyScrollBlurAnimation(footerTitleWr);
        $9054bdb407069633$var$restoreFooterTitleContent();
        initScrollBlurAnimation(footerTitleWr);
    }
};


const $6e0072d6babad5b9$var$headerComponent = document.getElementsByClassName('header')[0];
const $6e0072d6babad5b9$var$headerBottomComponent = document.querySelector('.header-bottom');
window.headerBottomScrollFunc = function headerBottomScrollFunc1() {
    const headerBottom = document.querySelector('.header-bottom');
    if (!headerBottom) return;
    let closeFlag = false;
    const getLocalStorageState = localStorage.getItem('headerBottomSavedState');
    const headerBottomContent = headerBottom.querySelector('.header-bottom__content');
    const headerBottomToggleBtn = headerBottom.querySelector('.header-bottom__toggle-btn');
    const scrollCloseHeaderBottom = ()=>{
        const scrollY = window.scrollY || window.pageYOffset;
        const triggerPoint = window.innerHeight * 0.2;
        if (scrollY >= triggerPoint) {
            if (closeFlag !== true) {
                closeFlag = true;
                headerBottomContent.classList.remove('is-open-bottom-menu');
                headerBottomToggleBtn.classList.remove('is-open-bottom-menu');
                localStorage.setItem('headerBottomSavedState', 'close');
            }
        }
    };
    scrollCloseHeaderBottom();
    window.addEventListener('scroll', scrollCloseHeaderBottom);
};
window.headerBottomVisibleAnimation = function headerBottomVisibleAnimation1() {
    if ($6e0072d6babad5b9$var$headerBottomComponent) {
        $6e0072d6babad5b9$var$headerBottomComponent.classList.add('is-visible');
        headerBottomScrollFunc();
    // footerScrollHiddenAnimation();
    }
};
if ($6e0072d6babad5b9$var$headerComponent) {
    const additionalButtons = $6e0072d6babad5b9$var$headerComponent.querySelector('.menu-additional-content__buttons');
    const headerBottom = document.querySelector('.header-bottom');
    const getLocalStorageState = localStorage.getItem('headerBottomSavedState');
    if (headerBottom) {
        const headerBottomContent = headerBottom.querySelector('.header-bottom__content');
        const headerBottomOpenBtn = headerBottom.querySelector('.header-bottom__open-menu');
        const headerBottomToggleBtn = headerBottom.querySelector('.header-bottom__toggle-btn');
        function headerBottomOpenMenu() {
            /*headerBottomContent.classList.remove('is-end-open-bottom-menu');*/ headerBottomContent.classList.add('is-open-bottom-menu');
            headerBottomToggleBtn.classList.add('is-open-bottom-menu');
            localStorage.setItem('headerBottomSavedState', 'open');
        }
        function headerBottomCloseMenu() {
            headerBottomContent.classList.remove('is-open-bottom-menu');
            headerBottomToggleBtn.classList.remove('is-open-bottom-menu');
            localStorage.setItem('headerBottomSavedState', 'close');
        /*setTimeout(() => {
        headerBottomContent.classList.add('is-end-open-bottom-menu');
      }, 500);*/ /*setTimeout(() => {
        headerBottomToggleBtn.classList.remove('is-open-bottom-menu');
      }, 700);*/ }
        headerBottomToggleBtn.addEventListener('click', function() {
            if (headerBottomToggleBtn.classList.contains('is-open-bottom-menu')) headerBottomCloseMenu();
            else headerBottomOpenMenu();
        });
        headerBottomOpenBtn.addEventListener('click', function() {
            headerBottomOpenMenu();
        });
    }
    // Header scroll
    const scrollContainer = ()=>document.documentElement || document.body;
    document.addEventListener('scroll', ()=>{
        if (scrollContainer().scrollTop > 50) {
            $6e0072d6babad5b9$var$headerComponent.classList.add('scrolled');
            $6e0072d6babad5b9$var$headerBottomComponent?.classList.add('scrolled');
        } else if (scrollContainer().scrollTop == 0) {
            $6e0072d6babad5b9$var$headerComponent.classList.remove('scrolled');
            $6e0072d6babad5b9$var$headerBottomComponent?.classList.remove('scrolled');
        }
    });
    // menu handlers
    // check mobile menu show/hide condition
    const mobileMenuStartPoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mobile-menu-start-point'));
    let isMobileMenuEnable = window.outerWidth <= mobileMenuStartPoint || document.querySelector('.header-mobile');
    // toggle menu handler
    function menuToggleFunc() {
        const menuToggle = document.querySelector('.menu-toggle');
        const navbarNav = document.querySelector('.navbar-nav');
        const headerCloseWrapper = document.querySelector('.header-close-wrapper');
        menuToggle.classList.toggle('active');
        navbarNav.classList.toggle('active');
        $6e0072d6babad5b9$var$headerComponent.classList.toggle('open-menu');
        headerCloseWrapper.classList.toggle('active');
        // LockScroll when burger open and enable when closed and enable scroll on menu
        if (scrollLock.getScrollState()) {
            scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
            scrollLock.addScrollableSelector('.simplebar-content-wrapper');
            scrollLock.addScrollableSelector('.scroll-content');
        } else scrollLock.enablePageScroll();
        if (!menuToggle.classList.contains('active')) scrollLock.enablePageScroll();
    }
    // menu update function
    function updateMenu() {
        isMobileMenuEnable = window.outerWidth <= mobileMenuStartPoint || document.querySelector('.mobile-header');
        if (!isMobileMenuEnable) {
            const dropdownMenus = document.querySelectorAll('.dropdown-menu');
            dropdownMenus.forEach((menu)=>{
                menu.style.display = '';
            });
            const headerCloseWrapper = document.querySelector('.header-close-wrapper');
            headerCloseWrapper.classList.remove('active');
            const activeMenuItems = document.querySelectorAll('.menu-item.active');
            activeMenuItems.forEach((item)=>{
                item.classList.remove('active');
            });
            const navbarNav = document.querySelector('.navbar-nav');
            navbarNav.classList.remove('active');
            $6e0072d6babad5b9$var$headerComponent.classList.remove('open-menu');
            const menuToggle = document.querySelector('.menu-toggle');
            menuToggle.classList.remove('active');
            // LockScroll when burger open and enable when closed
            scrollLock.enablePageScroll();
        }
        if (additionalButtons) {
            if (window.innerWidth <= mobileMenuStartPoint) {
                const buttons = additionalButtons.querySelectorAll('.btn');
                buttons.forEach((button)=>{
                    button.classList.remove('outline');
                });
            } else {
                const buttons = additionalButtons.querySelectorAll('.btn');
                buttons.forEach((button)=>{
                    button.classList.add('outline');
                });
            }
        }
    }
    if (window.innerWidth <= mobileMenuStartPoint) {
        const buttons = additionalButtons.querySelectorAll('.btn');
        buttons.forEach((button)=>{
            button.classList.remove('outline');
        });
    } else {
        const buttons = additionalButtons.querySelectorAll('.btn');
        buttons.forEach((button)=>{
            button.classList.add('outline');
        });
    }
    window.addEventListener('resize', updateMenu);
    window.addEventListener('orientationchange', updateMenu);
    // end of toggle menu handler
    const menuToggle = document.querySelector('.menu-toggle');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    menuToggle.addEventListener('click', menuToggleFunc);
    headerCloseWrapper.addEventListener('click', menuToggleFunc);
    // Hide and show Header when scroll up
    function headerSticky() {
        let prevScrollPos = window.pageYOffset;
        window.onscroll = ()=>{
            const currentScrollPos = window.pageYOffset;
            const headerHeight = $6e0072d6babad5b9$var$headerComponent.scrollHeight;
            if (window.scrollY > 0) {
                if (prevScrollPos > currentScrollPos) {
                    /*headerComponent.style.top = 0;*/ $6e0072d6babad5b9$var$headerComponent.classList.add('scrolled');
                    $6e0072d6babad5b9$var$headerBottomComponent?.classList.add('scrolled');
                    $6e0072d6babad5b9$var$headerComponent.classList.remove('scrolled-content');
                } else /*headerComponent.style.top = `-${headerHeight + 3}px`;*/ $6e0072d6babad5b9$var$headerComponent.classList.add('scrolled-content');
            }
            if (window.scrollY === 0) {
                $6e0072d6babad5b9$var$headerComponent.classList.remove('scrolled');
                $6e0072d6babad5b9$var$headerBottomComponent?.classList.remove('scrolled');
            }
            prevScrollPos = currentScrollPos;
        };
        if (window.scrollY !== 0) {
            $6e0072d6babad5b9$var$headerComponent.classList.add('scrolled');
            $6e0072d6babad5b9$var$headerBottomComponent?.classList.add('scrolled');
        }
    }
    setTimeout(()=>{
        headerSticky();
        initCountUp();
    }, 300);
    if (document.querySelector('.menu-dropdown')) {
        const menuDropdownArr = document.querySelectorAll('.menu-dropdown');
        menuDropdownArr.forEach((menuDropdown)=>{
            const toggle = menuDropdown.querySelector('.menu-dropdown-toggle');
            const btn = toggle.querySelector('.menu-dropdown-btn');
            const content = menuDropdown.querySelector('.menu-dropdown-content');
            toggle.addEventListener('click', (e)=>{
                e.preventDefault();
                if (!menuDropdown.classList.contains('active')) {
                    menuDropdown.classList.add('active');
                    $6e0072d6babad5b9$var$headerComponent.querySelector('.navbar-nav').classList.add('open-dropdown');
                } else {
                    menuDropdown.classList.remove('active');
                    $6e0072d6babad5b9$var$headerComponent.querySelector('.navbar-nav').classList.remove('open-dropdown');
                }
            });
        });
    }
    function opacityHeader() {
        $6e0072d6babad5b9$var$headerComponent.classList.add('is-init');
        setTimeout(function() {
            $6e0072d6babad5b9$var$headerComponent.style.opacity = 1;
        }, 300);
    }
    // document.fonts.ready.then(opacityHeader);
    window.addEventListener('load', opacityHeader);
}
window.closeMobMenu = function closeMobMenu() {
    if ($6e0072d6babad5b9$var$headerComponent) {
        const menuToggle = document.querySelector('.menu-toggle');
        const navbarNav = document.querySelector('.navbar-nav');
        const headerCloseWrapper = document.querySelector('.header-close-wrapper');
        menuToggle.classList.remove('active');
        navbarNav.classList.remove('active');
        $6e0072d6babad5b9$var$headerComponent.classList.remove('open-menu');
        headerCloseWrapper.classList.remove('active');
    }
};
window.menuCloseFunc = function menuCloseFunc() {
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    menuToggle.classList.remove('active');
    navbarNav.classList.remove('active');
    $6e0072d6babad5b9$var$headerComponent.classList.remove('open-menu');
    headerCloseWrapper.classList.remove('active');
    scrollLock.enablePageScroll();
};
if (!document.querySelector('.bold-loader-new')) headerBottomVisibleAnimation();


window.uploadFile = function uploadFile1() {
    if (document.querySelector('[data-upload-file-animation]')) {
        const uploadFileBlocksArr = document.querySelectorAll('[data-upload-file-animation]');
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener('dragover', function() {
                this.classList.add('drag');
                this.classList.remove('drop', 'done');
            });
            fileUpload.addEventListener('dragleave', function() {
                this.classList.remove('drag');
            });
            fileUpload.addEventListener('drop', start, false);
            fileUpload.addEventListener('change', start, false);
            function start() {
                this.classList.remove('drag');
                this.classList.add('drop');
                setTimeout(()=>this.classList.add('done'), 500);
            }
        });
    }
};
uploadFile();


window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector('textarea[data-autosize]')) {
        const autosizeTextareaElements = document.querySelectorAll('textarea[data-autosize]');
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener('input', autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();
function $cf68deaccb5072b2$var$formatInput(inputEl, maxValue) {
    let sanitizedValue = inputEl.value.replace(/[^\d]/g, '');
    if (sanitizedValue === '') {
        inputEl.value = '';
        return;
    }
    const numericValue = Number.isNaN(parseInt(sanitizedValue)) ? 0 : parseInt(sanitizedValue);
    sanitizedValue = Math.min(numericValue, maxValue).toString();
    const formattedValue = sanitizedValue.replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ');
    inputEl.value = "\xa3" + formattedValue;
}
if (document.querySelector('.salary-input')) {
    const salaryInputsArr = document.querySelectorAll('.salary-input');
    salaryInputsArr.forEach((input)=>{
        $cf68deaccb5072b2$var$formatInput(input, 999999);
        input.addEventListener('input', ()=>{
            $cf68deaccb5072b2$var$formatInput(input, 999999);
        });
    });
}
window.clearSalaryInput = function clearSalaryInput(id) {
    const salaryInputEl = document.querySelector(`#${id}`);
    salaryInputEl.value = '';
    $cf68deaccb5072b2$var$formatInput(salaryInputEl, 999999);
};
function $cf68deaccb5072b2$var$customSelectsLogic() {
    const defaultCustomSelect = document.getElementsByClassName('default-custom-select')[0];
    if (defaultCustomSelect) {
        const defaultCustomSelectArr = document.querySelectorAll('.default-custom-select');
        defaultCustomSelectArr.forEach((customSelect, i)=>{
            const zIndexValue = defaultCustomSelectArr.length - i;
            customSelect.style.zIndex = zIndexValue + 10;
            const customSelectPlaceholder = customSelect.querySelector('.default-custom-select__placeholder');
            const customSelectList = customSelect.querySelector('.default-custom-select__list');
            const customSelectPlaceholderTextContent = customSelect.querySelector('.default-custom-select__placeholder').textContent;
            customSelectPlaceholder.setAttribute('data-original-placeholder', customSelectPlaceholderTextContent);
            customSelect.addEventListener('click', (e)=>{
                if (!customSelect.classList.contains('active')) customSelect.classList.add('active');
                else if (!e.target.classList.contains('default-custom-select__list')) customSelect.classList.remove('active');
            });
            document.addEventListener('click', (event)=>{
                if (!customSelectList.contains(event.target) && !customSelect.contains(event.target)) customSelect.classList.remove('active');
            });
            const checkboxesSelect = customSelect.querySelectorAll('input[type="checkbox"]');
            function placeholderCheck() {
                const checkedCount = customSelect.querySelectorAll('input[type="checkbox"]:checked').length;
                if (checkedCount === 1) {
                    const checkedItem = customSelect.querySelector('input[type="checkbox"]:checked');
                    customSelectPlaceholder.textContent = checkedItem.nextElementSibling.nextElementSibling.textContent;
                } else customSelectPlaceholder.textContent = checkedCount > 0 ? `${checkedCount} items selected` : customSelectPlaceholderTextContent;
            }
            checkboxesSelect.forEach((checkbox)=>{
                checkbox.addEventListener('change', ()=>{
                    placeholderCheck();
                });
            });
            const checkboxes = document.querySelectorAll('input[type="checkbox"]');
            for(let j = 0; j < checkboxes.length; j++)checkboxes[j].addEventListener('change', ()=>{
                placeholderCheck();
            });
            placeholderCheck();
        });
    }
}
$cf68deaccb5072b2$var$customSelectsLogic();
window.checkAllCheckboxes = function checkAllCheckboxes() {
    const customSelects = document.querySelectorAll('.default-custom-select');
    customSelects.forEach((customSelect)=>{
        const customSelectPlaceholder = customSelect.querySelector('.default-custom-select__placeholder');
        function placeholderCheck() {
            const checkedCount = customSelect.querySelectorAll('input[type="checkbox"]:checked').length;
            if (checkedCount === 1) {
                const checkedItem = customSelect.querySelector('input[type="checkbox"]:checked');
                customSelectPlaceholder.textContent = checkedItem.nextElementSibling.nextElementSibling.textContent;
            } else customSelectPlaceholder.textContent = checkedCount > 0 ? `${checkedCount} items selected` : customSelectPlaceholder.getAttribute('data-original-placeholder');
        }
        placeholderCheck();
    });
};
const $cf68deaccb5072b2$var$changeMobilePlaceholderInput = document.querySelector('.change-mobile-placeholder');
if ($cf68deaccb5072b2$var$changeMobilePlaceholderInput) {
    const deskPlaceholder = $cf68deaccb5072b2$var$changeMobilePlaceholderInput.placeholder;
    const mobPlaceholder = 'Search by keyword';
    function updatePlaceholder() {
        if (window.innerWidth <= 890) $cf68deaccb5072b2$var$changeMobilePlaceholderInput.placeholder = mobPlaceholder;
        else $cf68deaccb5072b2$var$changeMobilePlaceholderInput.placeholder = deskPlaceholder;
    }
    updatePlaceholder();
    window.addEventListener('resize', updatePlaceholder);
}


/**
 * Updates the SimpleBar instance for a given list element.
 *
 * @param {HTMLElement} list - The list element to update.
 */ function $f9d9117d056bb82c$var$updateSimpleBar(list) {
    if (list.SimpleBar) list.SimpleBar.unMount();
    list.SimpleBar = new SimpleBar(list);
    const simplebarYInstancesArr = list.querySelectorAll('.simplebar-track.simplebar-vertical');
    const simplebarXInstancesArr = list.querySelectorAll('.simplebar-track.simplebar-horizontal');
    if (simplebarYInstancesArr.length) simplebarYInstancesArr.forEach((element, idx)=>{
        if (idx > 0) element.remove();
    });
    if (simplebarXInstancesArr.length) simplebarXInstancesArr.forEach((element, idx)=>{
        if (idx > 0) element.remove();
    });
}
/**
 * Initializes  meta select elements and sets up the list dropdown functionality.
 *
 * @param {string} elementsArr - The CSS selector to find the select elements.
 */ window.initMetaSelect = function initMetaSelect1(elementsArr) {
    const metaSelectArr = document.querySelectorAll(elementsArr);
    metaSelectArr.forEach((selectElement, idx)=>{
        const parentContainer = selectElement.closest('.meta-select');
        parentContainer.style.zIndex = metaSelectArr.length - idx;
        if (!parentContainer) return;
        if (!selectElement.classList.contains('is-init')) {
            selectElement.classList.add('is-init');
            const label = parentContainer.querySelector('label');
            const wrapper = document.createElement('div');
            wrapper.className = 'meta-select-inner';
            const placeholder = document.createElement('div');
            placeholder.className = 'meta-select-placeholder';
            const list = document.createElement('div');
            list.className = 'meta-select-list';
            const notInlinePosition = selectElement.hasAttribute('data-meta-select-not-inline');
            let firstCall = true;
            /**
       * Positions the dropdown list relative to the select element.
       */ function positionList() {
                if (!notInlinePosition) return;
                document.body.appendChild(list);
                list.style.position = 'absolute';
                list.style.minWidth = `${wrapper.clientWidth}px`;
                list.style.maxWidth = `${wrapper.clientWidth}px`;
                const selectRect = wrapper.getBoundingClientRect();
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                let top = selectRect.top + scrollTop + wrapper.clientHeight + 3;
                let left = selectRect.left;
                list.style.top = `${top}px`;
                list.style.left = `${left}px`;
            }
            /**
       * Updates the dropdown list with the current options from the select element.
       */ function updateList() {
                list.innerHTML = '';
                placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';
                Array.from(selectElement.options).forEach((option)=>{
                    const item = document.createElement('div');
                    item.className = 'meta-select-list__item';
                    item.textContent = option.text;
                    item.dataset.value = option.value;
                    if (option.selected) item.classList.add('is-selected');
                    if (option.disabled) item.classList.add('is-disabled');
                    if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
                    item.addEventListener('click', ()=>{
                        if (!item.classList.contains('is-disabled')) {
                            setMetaSelectValue(selectElement.id, option.value);
                            closeList();
                        }
                    });
                    list.appendChild(item);
                });
                setTimeout(function() {
                    positionList();
                }, 50);
                $f9d9117d056bb82c$var$updateSimpleBar(list);
            }
            /**
       * Opens the dropdown list and positions it correctly.
       */ function openList() {
                list.classList.add('is-open');
                wrapper.classList.add('is-open');
                positionList();
                // window.addEventListener('resize', positionList);
                $f9d9117d056bb82c$var$updateSimpleBar(list);
                setTimeout(function() {
                    positionList();
                }, 0);
            }
            /**
       * Closes the dropdown list and removes event listeners.
       */ function closeList() {
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
                // window.removeEventListener('resize', positionList);
                if (notInlinePosition) wrapper.appendChild(list);
            }
            /*if (notInlinePosition) {
        const scrollContainer = selectElement.closest(
          '.container-scroll'
        );
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', closeList);
          scrollContainer.addEventListener('touchmove', closeList);
        }
      }*/ /**
       * Toggles the visibility of the dropdown list.
       */ const toggleList = ()=>{
                if (list.classList.contains('is-open')) closeList();
                else openList();
            };
            wrapper.addEventListener('click', (ev)=>{
                if (ev.target !== list && ev.target !== label) toggleList();
            });
            label?.addEventListener('click', (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                toggleList();
            });
            document.addEventListener('click', (e)=>{
                if (!wrapper.contains(e.target) && !list.contains(e.target) && (!label || !label.contains(e.target))) closeList();
            });
            selectElement.addEventListener('change', updateList);
            wrapper.appendChild(placeholder);
            wrapper.appendChild(list);
            parentContainer.appendChild(wrapper);
            selectElement.style.display = 'none';
            updateList();
        }
    });
};
/**
 * Sets the value of a select element and triggers a change event.
 *
 * @param {string} selectId - The ID of the select element.
 * @param {string} value - The value to set for the select element.
 */ window.setMetaSelectValue = function setMetaSelectValue1(selectId, value) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;
    const optionExists = Array.from(selectElement.options).some((option)=>option.value === value);
    if (!optionExists) return;
    selectElement.value = value;
    selectElement.dispatchEvent(new Event('change', {
        bubbles: true
    }));
};
/**
 * Updates the dropdown list of a specific select element.
 *
 * @param {string} selectId - The ID of the select element to update.
 */ window.updateMetaSelect = function updateMetaSelect(selectId) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;
    const parentContainer = selectElement.closest('.meta-select');
    if (!parentContainer) return;
    const wrapper = parentContainer.querySelector('.meta-select-inner');
    const placeholder = wrapper.querySelector('.meta-select-placeholder');
    const list = wrapper.querySelector('.meta-select-list');
    if (!list) return;
    list.innerHTML = '';
    Array.from(selectElement.options).forEach((option)=>{
        const item = document.createElement('div');
        item.className = 'meta-select-list__item';
        item.textContent = option.text;
        item.dataset.value = option.value;
        if (option.selected) item.classList.add('is-selected');
        if (option.disabled) item.classList.add('is-disabled');
        if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
        item.addEventListener('click', ()=>{
            if (!item.classList.contains('is-disabled')) {
                setMetaSelectValue(selectId, option.value);
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
            }
        });
        list.appendChild(item);
    });
    placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';
    $f9d9117d056bb82c$var$updateSimpleBar(list);
};
/**
 * Updates the dropdown list of all select elements on the page.
 */ window.updateAllMetaSelects = function updateAllMetaSelects() {
    document.querySelectorAll('[data-meta-select]').forEach((selectElement)=>{
        const parentContainer = selectElement.closest('.meta-select');
        if (!parentContainer) return;
        const wrapper = parentContainer.querySelector('.meta-select-inner');
        const placeholder = wrapper.querySelector('.meta-select-placeholder');
        const list = wrapper.querySelector('.meta-select-list');
        if (!list) return;
        list.innerHTML = '';
        Array.from(selectElement.options).forEach((option)=>{
            const item = document.createElement('div');
            item.className = 'meta-select-list__item';
            item.textContent = option.text;
            item.dataset.value = option.value;
            if (option.selected) item.classList.add('is-selected');
            item.addEventListener('click', ()=>{
                setMetaSelectValue(selectElement.id, option.value);
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
            });
            list.appendChild(item);
        });
        placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';
        $f9d9117d056bb82c$var$updateSimpleBar(list);
    });
};
initMetaSelect('[data-meta-select]');


/*Splitting();*/ var $b5be3fbf97127d69$exports = {};
(function(f) {
    var g;
    $b5be3fbf97127d69$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
                        test1[5] = 'de';
                        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join('') !== '0123456789') return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    // Generated by CoffeeScript 1.12.2
                    (function() {
                        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                            return performance.now();
                        };
                        else if (typeof process !== "undefined" && process !== null && process.hrtime) {
                            module1.exports = function() {
                                return (getNanoSeconds() - nodeLoadTime) / 1e6;
                            };
                            hrtime = process.hrtime;
                            getNanoSeconds = function() {
                                var hr;
                                hr = hrtime();
                                return hr[0] * 1e9 + hr[1];
                            };
                            moduleLoadTime = getNanoSeconds();
                            upTime = process.uptime() * 1e9;
                            nodeLoadTime = moduleLoadTime - upTime;
                        } else if (Date.now) {
                            module1.exports = function() {
                                return Date.now() - loadTime;
                            };
                            loadTime = Date.now();
                        } else {
                            module1.exports = function() {
                                return new Date().getTime() - loadTime;
                            };
                            loadTime = new Date().getTime();
                        }
                    }).call(this);
                }).call(this, require1('_process'));
            },
            {
                "_process": 3
            }
        ],
        3: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error('setTimeout has not been defined');
                }
                function defaultClearTimeout() {
                    throw new Error('clearTimeout has not been defined');
                }
                (function() {
                    try {
                        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = 'browser';
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ''; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error('process.binding is not supported');
                };
                process.cwd = function() {
                    return '/';
                };
                process.chdir = function(dir) {
                    throw new Error('process.chdir is not supported');
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                (function(global1) {
                    var now = require1('performance-now'), root = typeof window === 'undefined' ? global1 : window, vendors = [
                        'moz',
                        'webkit'
                    ], suffix = 'AnimationFrame', raf = root['request' + suffix], caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
                    for(var i = 0; !raf && i < vendors.length; i++){
                        raf = root[vendors[i] + 'Request' + suffix];
                        caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
                    }
                    // Some versions of FF have rAF but not cAF
                    if (!raf || !caf) {
                        var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                        raf = function(callback) {
                            if (queue.length === 0) {
                                var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                                last = next + _now;
                                setTimeout(function() {
                                    var cp = queue.slice(0);
                                    // Clear queue here to prevent
                                    // callbacks from appending listeners
                                    // to the current frame's queue
                                    queue.length = 0;
                                    for(var i = 0; i < cp.length; i++){
                                        if (!cp[i].cancelled) try {
                                            cp[i].callback(last);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw e;
                                            }, 0);
                                        }
                                    }
                                }, Math.round(next));
                            }
                            queue.push({
                                handle: ++id,
                                callback: callback,
                                cancelled: false
                            });
                            return id;
                        };
                        caf = function(handle) {
                            for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                        };
                    }
                    module1.exports = function(fn) {
                        // Wrap in a new function to prevent
                        // `cancel` potentially being assigned
                        // to the native rAF function
                        return raf.call(root, fn);
                    };
                    module1.exports.cancel = function() {
                        caf.apply(root, arguments);
                    };
                    module1.exports.polyfill = function() {
                        root.requestAnimationFrame = raf;
                        root.cancelAnimationFrame = caf;
                    };
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "performance-now": 2
            }
        ],
        5: [
            function(require1, module1, exports) {
                'use strict';
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
* Parallax.js
* @author Matthew Wagerfield - @wagerfield, René Roth - mail@reneroth.org
* @description Creates a parallax effect between an array of layers,
*              driving the motion from the gyroscope output of a smartdevice.
*              If no gyroscope is available, the cursor position is used.
*/ var rqAnFr = require1('raf');
                var objectAssign = require1('object-assign');
                var helpers = {
                    propertyCache: {},
                    vendors: [
                        null,
                        [
                            '-webkit-',
                            'webkit'
                        ],
                        [
                            '-moz-',
                            'Moz'
                        ],
                        [
                            '-o-',
                            'O'
                        ],
                        [
                            '-ms-',
                            'ms'
                        ]
                    ],
                    clamp: function clamp(value, min, max) {
                        return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
                    },
                    data: function data(element, name) {
                        return helpers.deserialize(element.getAttribute('data-' + name));
                    },
                    deserialize: function deserialize(value) {
                        if (value === 'true') return true;
                        else if (value === 'false') return false;
                        else if (value === 'null') return null;
                        else if (!isNaN(parseFloat(value)) && isFinite(value)) return parseFloat(value);
                        else return value;
                    },
                    camelCase: function camelCase(value) {
                        return value.replace(/-+(.)?/g, function(match, character) {
                            return character ? character.toUpperCase() : '';
                        });
                    },
                    accelerate: function accelerate(element) {
                        helpers.css(element, 'transform', 'translate3d(0,0,0) rotate(0.0001deg)');
                        helpers.css(element, 'transform-style', 'preserve-3d');
                        helpers.css(element, 'backface-visibility', 'hidden');
                    },
                    transformSupport: function transformSupport(value) {
                        var element = document.createElement('div'), propertySupport = false, propertyValue = null, featureSupport = false, cssProperty = null, jsProperty = null;
                        for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) {
                                cssProperty = helpers.vendors[i][0] + 'transform';
                                jsProperty = helpers.vendors[i][1] + 'Transform';
                            } else {
                                cssProperty = 'transform';
                                jsProperty = 'transform';
                            }
                            if (element.style[jsProperty] !== undefined) {
                                propertySupport = true;
                                break;
                            }
                        }
                        switch(value){
                            case '2D':
                                featureSupport = propertySupport;
                                break;
                            case '3D':
                                if (propertySupport) {
                                    var body = document.body || document.createElement('body'), documentElement = document.documentElement, documentOverflow = documentElement.style.overflow, isCreatedBody = false;
                                    if (!document.body) {
                                        isCreatedBody = true;
                                        documentElement.style.overflow = 'hidden';
                                        documentElement.appendChild(body);
                                        body.style.overflow = 'hidden';
                                        body.style.background = '';
                                    }
                                    body.appendChild(element);
                                    element.style[jsProperty] = 'translate3d(1px,1px,1px)';
                                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
                                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== 'none';
                                    documentElement.style.overflow = documentOverflow;
                                    body.removeChild(element);
                                    if (isCreatedBody) {
                                        body.removeAttribute('style');
                                        body.parentNode.removeChild(body);
                                    }
                                }
                                break;
                        }
                        return featureSupport;
                    },
                    css: function css(element, property, value) {
                        var jsProperty = helpers.propertyCache[property];
                        if (!jsProperty) for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) jsProperty = helpers.camelCase(helpers.vendors[i][1] + '-' + property);
                            else jsProperty = property;
                            if (element.style[jsProperty] !== undefined) {
                                helpers.propertyCache[property] = jsProperty;
                                break;
                            }
                        }
                        element.style[jsProperty] = value;
                    }
                };
                var MAGIC_NUMBER = 30, DEFAULTS = {
                    relativeInput: false,
                    clipRelativeInput: false,
                    inputElement: null,
                    hoverOnly: false,
                    calibrationThreshold: 100,
                    calibrationDelay: 500,
                    supportDelay: 500,
                    calibrateX: false,
                    calibrateY: true,
                    invertX: true,
                    invertY: true,
                    limitX: false,
                    limitY: false,
                    scalarX: 10.0,
                    scalarY: 10.0,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5,
                    pointerEvents: false,
                    precision: 1,
                    onReady: null,
                    selector: null
                };
                var Parallax = function() {
                    function Parallax(element, options) {
                        _classCallCheck(this, Parallax);
                        this.element = element;
                        var data = {
                            calibrateX: helpers.data(this.element, 'calibrate-x'),
                            calibrateY: helpers.data(this.element, 'calibrate-y'),
                            invertX: helpers.data(this.element, 'invert-x'),
                            invertY: helpers.data(this.element, 'invert-y'),
                            limitX: helpers.data(this.element, 'limit-x'),
                            limitY: helpers.data(this.element, 'limit-y'),
                            scalarX: helpers.data(this.element, 'scalar-x'),
                            scalarY: helpers.data(this.element, 'scalar-y'),
                            frictionX: helpers.data(this.element, 'friction-x'),
                            frictionY: helpers.data(this.element, 'friction-y'),
                            originX: helpers.data(this.element, 'origin-x'),
                            originY: helpers.data(this.element, 'origin-y'),
                            pointerEvents: helpers.data(this.element, 'pointer-events'),
                            precision: helpers.data(this.element, 'precision'),
                            relativeInput: helpers.data(this.element, 'relative-input'),
                            clipRelativeInput: helpers.data(this.element, 'clip-relative-input'),
                            hoverOnly: helpers.data(this.element, 'hover-only'),
                            inputElement: document.querySelector(helpers.data(this.element, 'input-element')),
                            selector: helpers.data(this.element, 'selector')
                        };
                        for(var key in data)if (data[key] === null) delete data[key];
                        objectAssign(this, DEFAULTS, data, options);
                        if (!this.inputElement) this.inputElement = this.element;
                        this.calibrationTimer = null;
                        this.calibrationFlag = true;
                        this.enabled = false;
                        this.depthsX = [];
                        this.depthsY = [];
                        this.raf = null;
                        this.bounds = null;
                        this.elementPositionX = 0;
                        this.elementPositionY = 0;
                        this.elementWidth = 0;
                        this.elementHeight = 0;
                        this.elementCenterX = 0;
                        this.elementCenterY = 0;
                        this.elementRangeX = 0;
                        this.elementRangeY = 0;
                        this.calibrationX = 0;
                        this.calibrationY = 0;
                        this.inputX = 0;
                        this.inputY = 0;
                        this.motionX = 0;
                        this.motionY = 0;
                        this.velocityX = 0;
                        this.velocityY = 0;
                        this.onMouseMove = this.onMouseMove.bind(this);
                        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
                        this.onDeviceMotion = this.onDeviceMotion.bind(this);
                        this.onOrientationTimer = this.onOrientationTimer.bind(this);
                        this.onMotionTimer = this.onMotionTimer.bind(this);
                        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
                        this.onAnimationFrame = this.onAnimationFrame.bind(this);
                        this.onWindowResize = this.onWindowResize.bind(this);
                        this.windowWidth = null;
                        this.windowHeight = null;
                        this.windowCenterX = null;
                        this.windowCenterY = null;
                        this.windowRadiusX = null;
                        this.windowRadiusY = null;
                        this.portrait = false;
                        this.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
                        this.motionSupport = !!window.DeviceMotionEvent && !this.desktop;
                        this.orientationSupport = !!window.DeviceOrientationEvent && !this.desktop;
                        this.orientationStatus = 0;
                        this.motionStatus = 0;
                        this.initialise();
                    }
                    _createClass(Parallax, [
                        {
                            key: 'initialise',
                            value: function initialise() {
                                if (this.transform2DSupport === undefined) {
                                    this.transform2DSupport = helpers.transformSupport('2D');
                                    this.transform3DSupport = helpers.transformSupport('3D');
                                }
                                // Configure Context Styles
                                if (this.transform3DSupport) helpers.accelerate(this.element);
                                var style = window.getComputedStyle(this.element);
                                if (style.getPropertyValue('position') === 'static') this.element.style.position = 'relative';
                                // Pointer events
                                if (!this.pointerEvents) this.element.style.pointerEvents = 'none';
                                // Setup
                                this.updateLayers();
                                this.updateDimensions();
                                this.enable();
                                this.queueCalibration(this.calibrationDelay);
                            }
                        },
                        {
                            key: 'doReadyCallback',
                            value: function doReadyCallback() {
                                if (this.onReady) this.onReady();
                            }
                        },
                        {
                            key: 'updateLayers',
                            value: function updateLayers() {
                                if (this.selector) this.layers = this.element.querySelectorAll(this.selector);
                                else this.layers = this.element.children;
                                if (!this.layers.length) console.warn('ParallaxJS: Your scene does not have any layers.');
                                this.depthsX = [];
                                this.depthsY = [];
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index];
                                    if (this.transform3DSupport) helpers.accelerate(layer);
                                    layer.style.position = index ? 'absolute' : 'relative';
                                    layer.style.display = 'block';
                                    layer.style.left = 0;
                                    layer.style.top = 0;
                                    var depth = helpers.data(layer, 'depth') || 0;
                                    this.depthsX.push(helpers.data(layer, 'depth-x') || depth);
                                    this.depthsY.push(helpers.data(layer, 'depth-y') || depth);
                                }
                            }
                        },
                        {
                            key: 'updateDimensions',
                            value: function updateDimensions() {
                                this.windowWidth = window.innerWidth;
                                this.windowHeight = window.innerHeight;
                                this.windowCenterX = this.windowWidth * this.originX;
                                this.windowCenterY = this.windowHeight * this.originY;
                                this.windowRadiusX = Math.max(this.windowCenterX, this.windowWidth - this.windowCenterX);
                                this.windowRadiusY = Math.max(this.windowCenterY, this.windowHeight - this.windowCenterY);
                            }
                        },
                        {
                            key: 'updateBounds',
                            value: function updateBounds() {
                                this.bounds = this.inputElement.getBoundingClientRect();
                                this.elementPositionX = this.bounds.left;
                                this.elementPositionY = this.bounds.top;
                                this.elementWidth = this.bounds.width;
                                this.elementHeight = this.bounds.height;
                                this.elementCenterX = this.elementWidth * this.originX;
                                this.elementCenterY = this.elementHeight * this.originY;
                                this.elementRangeX = Math.max(this.elementCenterX, this.elementWidth - this.elementCenterX);
                                this.elementRangeY = Math.max(this.elementCenterY, this.elementHeight - this.elementCenterY);
                            }
                        },
                        {
                            key: 'queueCalibration',
                            value: function queueCalibration(delay) {
                                clearTimeout(this.calibrationTimer);
                                this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
                            }
                        },
                        {
                            key: 'enable',
                            value: function enable() {
                                if (this.enabled) return;
                                this.enabled = true;
                                if (this.orientationSupport) {
                                    this.portrait = false;
                                    window.addEventListener('deviceorientation', this.onDeviceOrientation);
                                    this.detectionTimer = setTimeout(this.onOrientationTimer, this.supportDelay);
                                } else if (this.motionSupport) {
                                    this.portrait = false;
                                    window.addEventListener('devicemotion', this.onDeviceMotion);
                                    this.detectionTimer = setTimeout(this.onMotionTimer, this.supportDelay);
                                } else {
                                    this.calibrationX = 0;
                                    this.calibrationY = 0;
                                    this.portrait = false;
                                    window.addEventListener('mousemove', this.onMouseMove);
                                    this.doReadyCallback();
                                }
                                window.addEventListener('resize', this.onWindowResize);
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: 'disable',
                            value: function disable() {
                                if (!this.enabled) return;
                                this.enabled = false;
                                if (this.orientationSupport) window.removeEventListener('deviceorientation', this.onDeviceOrientation);
                                else if (this.motionSupport) window.removeEventListener('devicemotion', this.onDeviceMotion);
                                else window.removeEventListener('mousemove', this.onMouseMove);
                                window.removeEventListener('resize', this.onWindowResize);
                                rqAnFr.cancel(this.raf);
                            }
                        },
                        {
                            key: 'calibrate',
                            value: function calibrate(x, y) {
                                this.calibrateX = x === undefined ? this.calibrateX : x;
                                this.calibrateY = y === undefined ? this.calibrateY : y;
                            }
                        },
                        {
                            key: 'invert',
                            value: function invert(x, y) {
                                this.invertX = x === undefined ? this.invertX : x;
                                this.invertY = y === undefined ? this.invertY : y;
                            }
                        },
                        {
                            key: 'friction',
                            value: function friction(x, y) {
                                this.frictionX = x === undefined ? this.frictionX : x;
                                this.frictionY = y === undefined ? this.frictionY : y;
                            }
                        },
                        {
                            key: 'scalar',
                            value: function scalar(x, y) {
                                this.scalarX = x === undefined ? this.scalarX : x;
                                this.scalarY = y === undefined ? this.scalarY : y;
                            }
                        },
                        {
                            key: 'limit',
                            value: function limit(x, y) {
                                this.limitX = x === undefined ? this.limitX : x;
                                this.limitY = y === undefined ? this.limitY : y;
                            }
                        },
                        {
                            key: 'origin',
                            value: function origin(x, y) {
                                this.originX = x === undefined ? this.originX : x;
                                this.originY = y === undefined ? this.originY : y;
                            }
                        },
                        {
                            key: 'setInputElement',
                            value: function setInputElement(element) {
                                this.inputElement = element;
                                this.updateDimensions();
                            }
                        },
                        {
                            key: 'setPosition',
                            value: function setPosition(element, x, y) {
                                x = x.toFixed(this.precision) + 'px';
                                y = y.toFixed(this.precision) + 'px';
                                if (this.transform3DSupport) helpers.css(element, 'transform', 'translate3d(' + x + ',' + y + ',0)');
                                else if (this.transform2DSupport) helpers.css(element, 'transform', 'translate(' + x + ',' + y + ')');
                                else {
                                    element.style.left = x;
                                    element.style.top = y;
                                }
                            }
                        },
                        {
                            key: 'onOrientationTimer',
                            value: function onOrientationTimer() {
                                if (this.orientationSupport && this.orientationStatus === 0) {
                                    this.disable();
                                    this.orientationSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: 'onMotionTimer',
                            value: function onMotionTimer() {
                                if (this.motionSupport && this.motionStatus === 0) {
                                    this.disable();
                                    this.motionSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: 'onCalibrationTimer',
                            value: function onCalibrationTimer() {
                                this.calibrationFlag = true;
                            }
                        },
                        {
                            key: 'onWindowResize',
                            value: function onWindowResize() {
                                this.updateDimensions();
                            }
                        },
                        {
                            key: 'onAnimationFrame',
                            value: function onAnimationFrame() {
                                this.updateBounds();
                                var calibratedInputX = this.inputX - this.calibrationX, calibratedInputY = this.inputY - this.calibrationY;
                                if (Math.abs(calibratedInputX) > this.calibrationThreshold || Math.abs(calibratedInputY) > this.calibrationThreshold) this.queueCalibration(0);
                                if (this.portrait) {
                                    this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
                                    this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
                                } else {
                                    this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
                                    this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
                                }
                                this.motionX *= this.elementWidth * (this.scalarX / 100);
                                this.motionY *= this.elementHeight * (this.scalarY / 100);
                                if (!isNaN(parseFloat(this.limitX))) this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
                                if (!isNaN(parseFloat(this.limitY))) this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
                                this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
                                this.velocityY += (this.motionY - this.velocityY) * this.frictionY;
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index], depthX = this.depthsX[index], depthY = this.depthsY[index], xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)), yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1));
                                    this.setPosition(layer, xOffset, yOffset);
                                }
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: 'rotate',
                            value: function rotate(beta, gamma) {
                                // Extract Rotation
                                var x = (beta || 0) / MAGIC_NUMBER, //  -90 :: 90
                                y = (gamma || 0) / MAGIC_NUMBER; // -180 :: 180
                                // Detect Orientation Change
                                var portrait = this.windowHeight > this.windowWidth;
                                if (this.portrait !== portrait) {
                                    this.portrait = portrait;
                                    this.calibrationFlag = true;
                                }
                                if (this.calibrationFlag) {
                                    this.calibrationFlag = false;
                                    this.calibrationX = x;
                                    this.calibrationY = y;
                                }
                                this.inputX = x;
                                this.inputY = y;
                            }
                        },
                        {
                            key: 'onDeviceOrientation',
                            value: function onDeviceOrientation(event) {
                                var beta = event.beta;
                                var gamma = event.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.orientationStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: 'onDeviceMotion',
                            value: function onDeviceMotion(event) {
                                var beta = event.rotationRate.beta;
                                var gamma = event.rotationRate.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.motionStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: 'onMouseMove',
                            value: function onMouseMove(event) {
                                var clientX = event.clientX, clientY = event.clientY;
                                // reset input to center if hoverOnly is set and we're not hovering the element
                                if (this.hoverOnly && (clientX < this.elementPositionX || clientX > this.elementPositionX + this.elementWidth || clientY < this.elementPositionY || clientY > this.elementPositionY + this.elementHeight)) {
                                    this.inputX = 0;
                                    this.inputY = 0;
                                    return;
                                }
                                if (this.relativeInput) {
                                    // Clip mouse coordinates inside element bounds.
                                    if (this.clipRelativeInput) {
                                        clientX = Math.max(clientX, this.elementPositionX);
                                        clientX = Math.min(clientX, this.elementPositionX + this.elementWidth);
                                        clientY = Math.max(clientY, this.elementPositionY);
                                        clientY = Math.min(clientY, this.elementPositionY + this.elementHeight);
                                    }
                                    // Calculate input relative to the element.
                                    if (this.elementRangeX && this.elementRangeY) {
                                        this.inputX = (clientX - this.elementPositionX - this.elementCenterX) / this.elementRangeX;
                                        this.inputY = (clientY - this.elementPositionY - this.elementCenterY) / this.elementRangeY;
                                    }
                                } else // Calculate input relative to the window.
                                if (this.windowRadiusX && this.windowRadiusY) {
                                    this.inputX = (clientX - this.windowCenterX) / this.windowRadiusX;
                                    this.inputY = (clientY - this.windowCenterY) / this.windowRadiusY;
                                }
                            }
                        },
                        {
                            key: 'destroy',
                            value: function destroy() {
                                this.disable();
                                clearTimeout(this.calibrationTimer);
                                clearTimeout(this.detectionTimer);
                                this.element.removeAttribute('style');
                                for(var index = 0; index < this.layers.length; index++)this.layers[index].removeAttribute('style');
                                delete this.element;
                                delete this.layers;
                            }
                        },
                        {
                            key: 'version',
                            value: function version() {
                                return '3.1.0';
                            }
                        }
                    ]);
                    return Parallax;
                }();
                module1.exports = Parallax;
            },
            {
                "object-assign": 1,
                "raf": 4
            }
        ]
    }, {}, [
        5
    ])(5);
});


window.logoCubeFunc = function logoCubeFunc1() {
    const logoCubeArr = document.querySelectorAll('.logo .cube');
    logoCubeArr.forEach((logoCube)=>{
        if (logoCube && !logoCube.classList.contains('is-init-logo-cube')) {
            const parentLogoEl = logoCube.closest('.logo');
            const parentLogoLinkEl = logoCube.closest('.logo-link');
            const parentPopupLoaderEl = logoCube.closest('.popup-form__logo-loader');
            logoCube.classList.add('is-init-logo-cube');
            const steps = [
                {
                    x: 0,
                    y: -90,
                    z: 0,
                    class: 'rotate-b'
                },
                {
                    x: 90,
                    y: -90,
                    z: 0,
                    class: 'rotate-o'
                },
                {
                    x: 90,
                    y: -180,
                    z: -90,
                    class: 'rotate-l'
                },
                {
                    x: 90,
                    y: -180,
                    z: -180,
                    class: 'rotate-d'
                }
            ];
            let currentStep = 0;
            let interval;
            let timeout;
            let timerAnim = 500;
            let intervalAnim = 1000;
            function logoStartAnimFunc(timerAnim, intervalAnim) {
                clearInterval(interval);
                clearTimeout(timeout);
                currentStep = 0;
                parentLogoEl.classList.remove('rotate-b', 'rotate-o', 'rotate-l', 'rotate-d');
                logoCube.style.transform = `rotateX(0deg) rotateY(0deg) rotateZ(0deg)`;
                timeout = setTimeout(()=>{
                    const step = steps[currentStep];
                    logoCube.style.transform = `rotateX(${step.x}deg) rotateY(${step.y}deg) rotateZ(${step.z}deg)`;
                    parentLogoEl.classList.add(step.class);
                    currentStep++;
                    interval = setInterval(()=>{
                        if (currentStep >= steps.length) {
                            clearInterval(interval);
                            return;
                        }
                        const step = steps[currentStep];
                        logoCube.style.transform = `rotateX(${step.x}deg) rotateY(${step.y}deg) rotateZ(${step.z}deg)`;
                        parentLogoEl.classList.remove('rotate-b', 'rotate-o', 'rotate-l', 'rotate-d');
                        parentLogoEl.classList.add(step.class);
                        currentStep++;
                    }, intervalAnim);
                }, timerAnim);
            }
            function logoEndAnimFunc() {
                clearInterval(interval);
                clearTimeout(timeout);
                currentStep = 0;
                logoCube.style.transform = `rotateX(0deg) rotateY(0deg) rotateZ(0deg)`;
                parentLogoEl.classList.remove('rotate-b', 'rotate-o', 'rotate-l', 'rotate-d');
            }
            if (parentLogoLinkEl) {
                parentLogoLinkEl.addEventListener('mouseenter', ()=>{
                    logoStartAnimFunc(timerAnim, intervalAnim);
                });
                parentLogoLinkEl.addEventListener('mouseleave', ()=>{
                    logoEndAnimFunc();
                });
            }
            if (parentPopupLoaderEl) {
                timerAnim = 1000;
                intervalAnim = 700;
                logoStartAnimFunc(timerAnim, intervalAnim);
            }
        }
    });
};
logoCubeFunc();
AOS.init({
    offset: 50,
    delay: 10,
    duration: 600,
    easing: 'ease-in-out',
    once: true,
    startEvent: 'DOMContentLoaded'
});
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
window.addEventListener('load', ()=>{
    AOS.refresh();
});
window.initParallaxJSAnimation = function initParallaxJSAnimation1() {
    if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
        const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
        parallaxContainer.forEach((elem)=>{
            let parallaxInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($b5be3fbf97127d69$exports)))(elem);
            parallaxInstance.enable();
        });
    }
};
if (!document.querySelector('.bold-loader-new')) initParallaxJSAnimation();
if (document.querySelector('[data-duplicate]')) {
    const originalArr = document.querySelectorAll('[data-original]');
    const duplicateArr = document.querySelectorAll('[data-duplicate]');
    originalArr.forEach((originalElement)=>{
        const originalValue = originalElement.dataset.original;
        duplicateArr.forEach((duplicateElement)=>{
            const duplicateValue = duplicateElement.dataset.duplicate;
            if (originalValue === duplicateValue) duplicateElement.textContent = originalElement.textContent;
        });
    });
}
if (document.querySelector('[data-splitting]')) {
    const splittingArr = document.querySelectorAll('[data-splitting]');
    splittingArr.forEach((item, i)=>{
        if (item.hasAttribute('data-splitting-char') === true) {
            const splitting = Splitting({
                target: item
            });
        } else {
            const splitting = Splitting({
                target: item,
                by: 'words'
            });
        }
    });
}
if (document.querySelector('[data-splitting-image]')) {
    const splittingImageArr = document.querySelectorAll('[data-splitting-image]');
    splittingImageArr.forEach((item, i)=>{
        item.classList.add(`splitting-img-${i + 1}`);
        const splitting = Splitting({
            target: item,
            by: 'cells',
            image: true
        });
        function addAnimatedClassFunc() {
            setTimeout(function() {
                item.classList.add('animated');
            }, 100);
        }
        createVisibilityObserver(`splitting-img-${i + 1}`, addAnimatedClassFunc, 0.05);
    });
}
window.initTilt = function initTilt1() {
    if (typeof VanillaTilt !== 'undefined' && document.querySelector('[data-tilt-init]') && window.innerWidth > 1024) {
        const tiltInitItemsArr = document.querySelectorAll('[data-tilt-init]');
        tiltInitItemsArr.forEach((item)=>{
            if (item.vanillaTilt) return;
            const tiltMax = Number(item.dataset.tiltMax);
            const options = {
                speed: 500
            };
            if (Number.isFinite(tiltMax)) options.max = tiltMax;
            VanillaTilt.init(item, options);
        });
    }
};
if (!document.querySelector('.bold-loader-new')) initTilt();
if (document.querySelector('.anime-motion-animation')) {
    const animeMotionAnimElArr = document.querySelectorAll('.anime-motion-animation');
    animeMotionAnimElArr.forEach((animeMotionAnimEl)=>{
        const defaultSpeed = 3000;
        const originalSpeed = Number(parseFloat(animeMotionAnimEl.getAttribute('data-anime-speed'))) || defaultSpeed;
        const petaAnimation = anime({
            targets: animeMotionAnimEl.querySelector('svg path'),
            strokeDashoffset: [
                anime.setDashoffset,
                0
            ],
            easing: 'easeInOutSine',
            duration: originalSpeed,
            delay: function(el, i) {
                return i * 1;
            },
            direction: 'normal',
            loop: false
        });
        petaAnimation.pause();
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    setTimeout(()=>{
                        petaAnimation.play();
                        animeMotionAnimEl.classList.add('animated');
                    }, 600);
                    observer.unobserve(animeMotionAnimEl);
                }
            });
        }, {
            threshold: 0,
            rootMargin: '0% 0% -10% 0%'
        });
        observer.observe(animeMotionAnimEl);
    });
}
/*import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const gsapViewArr = document.querySelectorAll('[data-gsap-view]');
if (gsapViewArr.length > 0) {
  gsapViewArr.forEach((el, i) => {
    gsapViewAnimation(el, el, 25, 0, 0, 0);
  });

  function gsapViewAnimation(triggerEl, animEl, minY, minX, maxY, maxX) {
    if (ScrollTrigger.isTouch !== 1) {
      gsap.fromTo(
        animEl,
        {
          translateY: `${minY}%`,
          translateX: `${minX}%`,
          /!*opacity: 0,*!/
        },
        {
          translateY: `${maxY}%`,
          translateX: `${maxX}%`,
          /!*opacity: 1,*!/
          scrollTrigger: {
            trigger: triggerEl,
            end: 'top',
            scrub: true,
          },
        }
      );
    } else {
      /!*animEl.removeAttribute('data-scroll-bg');*!/
      /!*animEl.setAttribute('data-view', 'fade-t');*!/
    }
  }
}*/ if (document.getElementsByClassName('aura-card') && window.innerWidth > 551) {
    const page = document.querySelector('#site');
    const header = document.querySelector('header');
    const headerBurger = document.querySelector('.header .burger');
    const auraContainers = document.querySelectorAll('.aura-container');
    if (window.innerWidth > 1025) {
        auraContainers.forEach((container)=>{
            const auraCursor = container.querySelector('.cursor-aura');
            const auraCursorWidth = auraCursor.offsetWidth;
            const auraCursorHeight = auraCursor.offsetHeight;
            const initLeft = parseFloat(getComputedStyle(auraCursor).left);
            const initTop = parseFloat(getComputedStyle(auraCursor).top);
            function cursorAuraLogic(e) {
                auraCursor.classList.add('active');
                const rect = container.getBoundingClientRect();
                let x = e.clientX - rect.left - auraCursorWidth / 1.85;
                let y = e.clientY - rect.top - auraCursorHeight / 1.95;
                const currentLeft = parseFloat(getComputedStyle(auraCursor).left);
                const currentTop = parseFloat(getComputedStyle(auraCursor).top);
                x -= currentLeft;
                y -= currentTop;
                requestAnimationFrame(()=>{
                    auraCursor.style.left = 0;
                    auraCursor.style.top = 0;
                    auraCursor.style.transform = `translate(${x}px, ${y}px)`;
                });
            }
            function cursorAuraLeaveLogic() {
                auraCursor.classList.remove('active');
                auraCursor.style.left = `${initLeft}px`;
                auraCursor.style.top = `${initTop}px`;
                auraCursor.style.transform = `translate(0, 0)`;
            }
            container.addEventListener('mousemove', (e)=>{
                auraCursor.classList.add('is-init');
                cursorAuraLogic(e);
            });
            container.addEventListener('mouseleave', (event)=>{
                const nextElement = document.elementFromPoint(event.clientX, event.clientY);
                if (header.contains(nextElement)) return;
                cursorAuraLeaveLogic();
            });
            if (header) {
                header.addEventListener('mousemove', (e)=>{
                    if (!header.classList.contains('open-menu')) {
                        auraCursor.classList.add('is-init');
                        cursorAuraLogic(e);
                    }
                });
                header.addEventListener('mouseleave', (event)=>{
                    const nextElement = document.elementFromPoint(event.clientX, event.clientY);
                    if (container.contains(nextElement)) return;
                    cursorAuraLeaveLogic();
                });
                headerBurger.addEventListener('click', ()=>{
                    cursorAuraLeaveLogic();
                });
            }
            window.addEventListener('DOMContentLoaded', (event)=>{
                const isCursorOverElement = isCursorOverElementOnLoad(container);
                cursorAuraLogic(event);
            });
        });
        function isCursorOverElementOnLoad(element) {
            const rect = element.getBoundingClientRect();
            const mouseX = window.pageXOffset + rect.left;
            const mouseY = window.pageYOffset + rect.top;
            return mouseX >= 0 && mouseX <= window.innerWidth && mouseY >= 0 && mouseY <= window.innerHeight;
        }
    }
}
const $936dbd06c8961682$var$scrollingText = document.querySelectorAll('.scrolling-text');
let $936dbd06c8961682$var$scrollingTextSpeed = 25;
if (window.innerWidth > 1366) $936dbd06c8961682$var$scrollingTextSpeed = 20;
let $936dbd06c8961682$var$scrollingTextTimeline = gsap.timeline();
if ($936dbd06c8961682$var$scrollingText.length >= 1) $936dbd06c8961682$var$scrollingText.forEach((text, i)=>{
    if (window.innerWidth >= 640) {
        const val = i % 2 === 0 ? $936dbd06c8961682$var$scrollingTextSpeed : -$936dbd06c8961682$var$scrollingTextSpeed;
        $936dbd06c8961682$var$scrollingTextTimeline.to(text, {
            xPercent: val,
            scrollTrigger: {
                trigger: $936dbd06c8961682$var$scrollingText[$936dbd06c8961682$var$scrollingText.length - 2],
                start: 'center center',
                end: '+=1000',
                scrub: 0
            }
        });
    }
});
window.titlesSvgAnimation = function titlesSvgAnimation() {
    const titlesSvgAnimationsElArr = document.querySelectorAll('.title-svg-hero-fade-animation');
    if (titlesSvgAnimationsElArr.length) titlesSvgAnimationsElArr.forEach((el)=>{
        el.classList.add('is-title-svg-animate');
    });
};


window.buttons3DInit = function buttons3DInit1() {
    document.querySelectorAll('.btn').forEach((original)=>{
        if (!original.classList.contains('is-init')) {
            const tagName = original.tagName.toLowerCase();
            const isLink = tagName === 'a';
            const isButton = tagName === 'button';
            const wrapper = document.createElement(isLink ? 'a' : 'button');
            wrapper.classList.add('btn-wr');
            const attrsToTransfer = [
                'href',
                'target',
                'type',
                'onclick'
            ];
            attrsToTransfer.forEach((attr)=>{
                if (original.hasAttribute(attr)) wrapper.setAttribute(attr, original.getAttribute(attr));
            });
            const visualBtn = document.createElement('div');
            visualBtn.className = original.className;
            visualBtn.classList.add('is-init');
            const originalContent = original.innerHTML;
            visualBtn.innerHTML = originalContent;
            const btnBack = document.createElement('div');
            const btnFront = document.createElement('div');
            btnBack.classList.add('btn__back');
            btnFront.classList.add('btn__front');
            btnBack.innerHTML = originalContent;
            btnFront.innerHTML = originalContent;
            visualBtn.appendChild(btnBack);
            visualBtn.appendChild(btnFront);
            original.parentNode.insertBefore(wrapper, original);
            wrapper.appendChild(visualBtn);
            original.remove();
        }
    });
};
buttons3DInit();
// import { gsap } from 'gsap';
const $75e3c21f2ef91dfc$var$followOnHover = (hovered, following)=>{
    const onMouseMove = (event)=>{
        const rect = hovered.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const circleWidth = following.offsetWidth;
        const circleHeight = following.offsetHeight;
        const offsetX = x - circleWidth / 2;
        const offsetY = y - circleHeight / 2;
        gsap.to(following, {
            duration: 0.05,
            x: offsetX,
            y: offsetY,
            ease: 'power2.out',
            opacity: 1,
            backgroundColor: 'var(--cl-blush)',
            borderColor: 'var(--cl-blush)'
        });
    };
    const removeMouseMove = ()=>{
        gsap.to(following, {
            duration: 0.1,
            opacity: 0
        });
    };
    hovered.addEventListener('mousemove', onMouseMove);
    hovered.addEventListener('mouseleave', removeMouseMove);
    if (window.innerWidth < 1025) {
        hovered.removeEventListener('mousemove', onMouseMove);
        hovered.removeEventListener('mouseleave', removeMouseMove);
    }
};
window.hoverButton = $75e3c21f2ef91dfc$var$followOnHover;
document.querySelectorAll('.btn-link').forEach((btn)=>{
    const circle = btn.querySelector('.circle');
    $75e3c21f2ef91dfc$var$followOnHover(btn, circle);
});
window.btnToTopFunc = function btnToTopFunc1() {
    // селекторы (как у тебя)
    const btnToTop = document.querySelector('.btn-to-top');
    const btnToTopWr = document.querySelector('.btn-to-top-wr');
    const btnFollowingChatWr = document.querySelector('.btn-following-chat-wr');
    const btnOurWorkWr = document.querySelector('.btn-our-work-wr');
    const btnOurWorkMobWr = document.querySelector('.home-first-sec .first-sec__buttons');
    function ourWorkDistanceToWindowBottom() {
        let distanceToWindowBottom = 0;
        if (btnOurWorkMobWr) {
            const rect = btnOurWorkMobWr.getBoundingClientRect();
            distanceToWindowBottom = window.innerHeight - rect.bottom;
        }
        return distanceToWindowBottom;
    }
    // вспомогательная функция — получить left от .cont внутри обёртки
    function getContLeft(wrapper) {
        if (!wrapper) return 0;
        const cont = wrapper.querySelector('.cont');
        if (!cont) return 0;
        if (window.innerWidth >= 1100) return cont.getBoundingClientRect().left;
        else {
            const style = window.getComputedStyle(cont);
            return parseFloat(style.paddingLeft) || 0;
        }
    }
    // основная функция обновления позиций
    function updatePositions() {
        // -------------------------
        // 1) Старая логика для btnToTopWr (и для .btn-to-top по сути)
        //    — если есть только btnToTopWr, ей ставим bottom = leftOffset
        //    (тут мы не меняем логику, только переиспользуем getContLeft)
        // -------------------------
        if (btnFollowingChatWr) {
            const leftOffset = getContLeft(btnFollowingChatWr);
            btnFollowingChatWr.style.bottom = leftOffset + 'px';
        }
        // -------------------------
        // 2) Логика для btnOurWorkWr — НЕ ТРОГАЮ (оставил как было)
        // -------------------------
        if (btnOurWorkWr) {
            const cont = btnOurWorkWr.querySelector('.cont');
            if (cont) {
                const leftOffset = cont.getBoundingClientRect().left;
            /*btnOurWorkWr.style.paddingBottom = leftOffset + 'px';*/ }
        }
        // -------------------------
        // 3) Новая логика для пары btnToTopWr и btnFollowingChatWr
        //    — меняем только bottom (не paddingBottom)
        //    — если есть 1 элемент: обычный bottom = leftOffset
        //    — если есть 2 элемента: считаем DOM-порядок
        //        second (тот, что позже в DOM) = нижний → даём обычный bottom
        //        first (тот, что раньше в DOM) = верхний → bottom = bottom_нижнего + высота_нижнего + 10
        // -------------------------
        const bottomCandidates = [
            btnToTopWr,
            btnFollowingChatWr
        ].filter(Boolean);
        if (bottomCandidates.length === 1) {
            const el = bottomCandidates[0];
            const leftOffset = getContLeft(el);
            el.style.bottom = leftOffset + 'px';
        } else if (bottomCandidates.length === 2) {
            // определить порядок в DOM: first — тот, кто раньше в DOM, second — позже (нижний)
            let first = bottomCandidates[0];
            let second = bottomCandidates[1];
            // если first не предшествует second — поменяем
            if (!(first.compareDocumentPosition(second) & Node.DOCUMENT_POSITION_FOLLOWING)) {
                first = bottomCandidates[1];
                second = bottomCandidates[0];
            }
            // нижнему — его обычный bottom
            const secondLeft = getContLeft(second);
            second.style.bottom = secondLeft + 'px';
            second.style.setProperty('--bottom', secondLeft + 'px');
            // вычисляем высоту нижнего (для сдвига верхнего)
            const secondRect = second.getBoundingClientRect();
            let shiftedBottom = secondLeft + secondRect.height + 10; // +10px как просил
            // верхнему — bottom от нижнего + высота нижнего + 10px
            if (first.classList.contains('btn-to-top-wr')) {
                if (btnFollowingChatWr && window.innerWidth > 1100) shiftedBottom = shiftedBottom - 20;
                else shiftedBottom = secondLeft + secondRect.height + 10;
            }
            first.style.bottom = shiftedBottom + 'px';
            first.style.setProperty('--bottom', shiftedBottom + 'px');
        }
    /*if (btnFollowingChatWr && window.innerWidth <= 1100) {
      btnFollowingChatWr.style.bottom = '10px';
      btnToTopWr.style.bottom = `${
        btnFollowingChatWr.clientHeight + 10 + 10
      }px`;
    } else {
      btnFollowingChatWr.style.bottom = '20px';
      btnToTopWr.style.bottom = `${
        btnFollowingChatWr.clientHeight + 10 + 20
      }px`;
    }*/ }
    updatePositions();
    let resizeTicking = false;
    window.addEventListener('resize', ()=>{
        if (!resizeTicking) {
            window.requestAnimationFrame(()=>{
                updatePositions();
                resizeTicking = false;
            });
            resizeTicking = true;
        }
    }, {
        passive: true
    });
    if (!btnToTop) return;
    const toggleBtnClass = ()=>{
        const scrollY = window.scrollY || window.pageYOffset;
        const triggerPoint = window.innerWidth > 640 ? window.innerHeight * 0.45 : window.innerHeight * 0.1;
        if (scrollY >= triggerPoint) {
            btnToTop?.classList.add('is-active');
            btnFollowingChatWr?.classList.remove('is-inactive-btn-to-top');
            btnOurWorkMobWr?.classList.add('is-active-btn-to-top');
            if (btnToTopWr && btnFollowingChatWr) {
                const leftOffset = getContLeft(btnToTopWr);
                btnToTopWr.style.bottom = 52 + leftOffset + 10 + 'px';
                if (window.innerWidth <= 1100 && window.innerWidth > 640) {
                    btnFollowingChatWr.style.bottom = `20px`;
                    btnToTopWr.style.bottom = `${btnFollowingChatWr.clientHeight + 20 + 10}px`;
                } else if (window.innerWidth <= 640) {
                    btnFollowingChatWr.style.bottom = `16px`;
                    btnToTopWr.style.bottom = `${btnFollowingChatWr.clientHeight + 10 + 20}px`;
                    if (btnOurWorkMobWr) {
                        btnFollowingChatWr?.style.setProperty('--bottom-window', ourWorkDistanceToWindowBottom() + 'px');
                        btnFollowingChatWr?.classList.remove('is-bottom-window-distance');
                    }
                }
            }
        } else {
            btnToTop?.classList.remove('is-active');
            btnFollowingChatWr?.classList.add('is-inactive-btn-to-top');
            btnOurWorkMobWr?.classList.remove('is-active-btn-to-top');
            if (btnOurWorkMobWr) {
                btnFollowingChatWr?.style.setProperty('--bottom-window', ourWorkDistanceToWindowBottom() + 'px');
                btnFollowingChatWr?.classList.add('is-bottom-window-distance');
            }
        }
    };
    $(btnToTop).on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 600);
    });
    let toTopTicking = false;
    const onToTopScroll = ()=>{
        if (!toTopTicking) {
            window.requestAnimationFrame(()=>{
                toggleBtnClass();
                toTopTicking = false;
            });
            toTopTicking = true;
        }
    };
    toggleBtnClass();
    window.addEventListener('scroll', onToTopScroll, {
        passive: true
    });
};
if (!document.querySelector('.bold-loader-new')) btnToTopFunc();
window.btnCallFunc = function btnCallFunc1() {
    const btnCall = document.querySelector('.btn-call');
    if (!btnCall) return;
    const toggleBtnClass = ()=>{
        const scrollY = window.scrollY || window.pageYOffset;
        const triggerPoint = window.innerHeight * 0.6;
        if (scrollY >= triggerPoint) btnCall.classList.add('is-active');
        else btnCall.classList.remove('is-active');
    };
    let callTicking = false;
    const onCallScroll = ()=>{
        if (!callTicking) {
            window.requestAnimationFrame(()=>{
                toggleBtnClass();
                callTicking = false;
            });
            callTicking = true;
        }
    };
    toggleBtnClass();
    window.addEventListener('scroll', onCallScroll, {
        passive: true
    });
};
if (!document.querySelector('.bold-loader-new')) btnCallFunc();
window.dirControlBtnInit = function dirControlBtnInit1() {
    document.querySelectorAll('.dir-control').forEach((el)=>{
        if (el.dataset.dirInit) return;
        el.dataset.dirInit = '1';
        const text = el.innerHTML.trim();
        el.innerHTML = '';
        for(let i = 0; i < 4; i++){
            const mask = document.createElement('span');
            mask.className = 'dir-control__mask';
            mask.dataset.index = String(i + 1);
            el.appendChild(mask);
        }
        for(let i = 0; i < 4; i++){
            const b = document.createElement('b');
            b.setAttribute('aria-hidden', 'true');
            b.innerHTML = text;
            el.appendChild(b);
        }
        const label = document.createElement('span');
        label.className = 'dir-control__label';
        label.innerHTML = text;
        el.appendChild(label);
        let activeIndex = null;
        function clearActive() {
            activeIndex = null;
            el.querySelectorAll('.dir-control__mask.active').forEach((n)=>n.classList.remove('active'));
            el.querySelectorAll('b.active').forEach((n)=>n.classList.remove('active'));
        }
        function sectorIndexFromEvent(ev) {
            const rect = el.getBoundingClientRect();
            const x = ev.clientX - rect.left;
            const y = ev.clientY - rect.top;
            const w = rect.width;
            const h = rect.height;
            const cx = w / 2;
            const cy = h / 2;
            const dx = x - cx;
            const dy = y - cy;
            if (Math.abs(dx) > Math.abs(dy)) return dx > 0 ? 2 : 4;
            else return dy > 0 ? 3 : 1;
        }
        function setActive(idx) {
            if (activeIndex === idx) return;
            clearActive();
            const mask = el.querySelector(`.dir-control__mask[data-index="${idx}"]`);
            const b = el.querySelector(`b:nth-of-type(${idx})`);
            if (mask) mask.classList.add('active');
            if (b) b.classList.add('active');
            activeIndex = idx;
        }
        el.addEventListener('mouseenter', (e)=>{
            const idx = sectorIndexFromEvent(e);
            setActive(idx);
        });
        /*el.addEventListener('mousemove', (e) => {
    });*/ el.addEventListener('mouseleave', ()=>{
            clearActive();
        });
        el.addEventListener('click', ()=>{
            try {
                el.animate([
                    {
                        transform: getComputedStyle(el).transform
                    },
                    {
                        transform: 'translateY(0) scale(1)'
                    },
                    {
                        transform: getComputedStyle(el).transform
                    }
                ], {
                    duration: 140,
                    easing: 'linear'
                });
            } catch  {}
        });
    });
};
dirControlBtnInit();
window.btnChatAnimationsFunc = function btnChatAnimationsFunc1() {
    const btnChatWr = document.querySelector('.btn-following-chat-wr');
    const firstOurWorkBtn = document.querySelector('.first-sec__buttons .dir-control-btn');
    const ourWorkBtn = document.querySelector('.btn-our-work-wr .dir-control-btn');
    if (!btnChatWr) return;
    if (!document.querySelector('.bold-loader-new')) setTimeout(function() {
        btnChatWr.classList.add('is-internal-page');
    }, 300);
    const btnChat = btnChatWr.querySelector('.following-chat-btn');
    // стартовое состояние
    /*btnChat.classList.add('is-chat-start-size');*/ ourWorkBtn?.classList.add('is-chat-btn-start-animation');
    firstOurWorkBtn?.classList.add('is-chat-btn-start-animation');
    btnChatWr.classList.add('is-chat-btn-start-animation');
    btnChatWr.classList.add('is-init-chat-btn');
    let ticking = false;
    window.addEventListener('scroll', ()=>{
        if (!ticking) {
            window.requestAnimationFrame(()=>{
                if (window.scrollY >= 130) {
                    ourWorkBtn?.classList.remove('is-chat-btn-start-animation');
                    firstOurWorkBtn?.classList.remove('is-chat-btn-start-animation');
                    btnChatWr.classList.remove('is-chat-btn-start-animation');
                    btnChat.classList.add('is-small-size');
                } else {
                    ourWorkBtn?.classList.add('is-chat-btn-start-animation');
                    firstOurWorkBtn?.classList.add('is-chat-btn-start-animation');
                    btnChatWr.classList.add('is-chat-btn-start-animation');
                    btnChat.classList.remove('is-small-size');
                }
                ticking = false;
            });
            ticking = true;
        }
    });
};
if (!document.querySelector('.bold-loader-new')) btnChatAnimationsFunc();


const $ef543fddeaeed7f9$var$videoPlayer = document.getElementsByClassName('video-player')[0];
if ($ef543fddeaeed7f9$var$videoPlayer) {
    const videoPlayersArr = document.querySelectorAll('.video-player');
    for(let i = 0; i < videoPlayersArr.length; i++){
        const parentEl = videoPlayersArr[i].parentElement;
        let ratio = null;
        if (parentEl.classList.contains('first-text-section__video')) {
            if (window.innerWidth <= 640) ratio = '335:200';
            else if (window.innerWidth <= 951) ratio = '1280:480';
            else ratio = '1280:357';
        }
        const player = new Plyr(videoPlayersArr[i], {
            controls: [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'captions',
                'settings',
                'fullscreen',
                'pip',
                'airplay'
            ],
            ratio: ratio,
            tooltips: {
                controls: !0
            },
            fullscreen: {
                iosNative: true
            }
        });
        player.on('enterfullscreen', function() {});
        player.on('exitfullscreen', function() {});
        player.on('play', function() {
            parentEl.classList.add('is-played');
        });
        player.on('pause', function() {
            parentEl.classList.remove('is-played');
        });
        // Expose player so it can be used from the console
        window.player = player;
        if (window.innerWidth >= 1024) setTimeout(function() {
            const plyrArr = document.querySelectorAll('.plyr');
            for(let j = 0; j < plyrArr.length; j++)plyrArr[i].classList.add('plyr-hide-controls');
            plyrArr[i].addEventListener('mouseenter', ()=>{
                plyrArr[i].classList.remove('plyr-hide-controls');
            });
            plyrArr[i].addEventListener('mouseleave', ()=>{
                plyrArr[i].classList.add('plyr-hide-controls');
            });
        }, 300);
    }
}


// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */ const $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a = (swiperInstance)=>{
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) swiperInstance.autoplay.start();
            else swiperInstance.autoplay.stop();
        });
    }, observerOptions);
    observer.observe(swiperInstance.el);
};


var $5a994ebaf2ce4239$exports = {};

$5a994ebaf2ce4239$exports = (parcelRequire("22Ih0"));


window.evolveSliderInit = function evolveSliderInit() {
    if (window.innerWidth > 1024) {
        const evolveSec = document.querySelector('.evolve-sec');
        const evolveGallery = document.querySelector('.evolve-sec__gallery');
        const evolveSecContainer = document.querySelector('.evolve-sec-container');
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (isChrome && window.innerWidth >= 1025 && evolveSecContainer) evolveSecContainer.classList.add('is-chrome');
        if (evolveSec && evolveGallery) {
            const evolveSlides = document.querySelector('.evolve-sec__slides');
            const evolveSlidesArr = document.querySelectorAll('.evolve-sec__slide');
            const evolveGallerySlidesArr = evolveGallery.querySelectorAll('.evolve-sec__gallery-slide');
            const slides = gsap.utils.toArray('.evolve-sec__slide');
            let currentIndex = 0;
            let lastSnapTarget = 0;
            let slideWidth = evolveSec.getBoundingClientRect().width;
            evolveSlides.style.width = `${slides.length * slideWidth}px`;
            slides.forEach((slide, index)=>{
                slide.style.width = `${slideWidth}px`;
                slide.style.position = 'absolute';
                slide.style.left = `${index * slideWidth}px`;
                slide.style.top = '0';
                slide.style.height = '100vh';
            });
            evolveGallerySlidesArr.forEach((slide, index)=>{
                slide.style.transition = 'transform 0.4s ease';
                slide.style.transform = index === 0 ? 'translateX(0%)' : 'translateX(100%)';
            });
            function applyGalleryState(targetIndex) {
                const prev = targetIndex - 1;
                evolveGallerySlidesArr.forEach((slide, index)=>{
                    if (index === targetIndex || index === prev) slide.style.transform = 'translateX(0%)';
                    else slide.style.transform = 'translateX(100%)';
                    slide.classList.toggle('is-prev', index === prev && index !== slides.length - 1);
                });
                evolveSlidesArr.forEach((slide, index)=>{
                    slide.classList.toggle('is-active', index === targetIndex);
                });
                currentIndex = targetIndex;
                lastSnapTarget = targetIndex;
            }
            applyGalleryState(0);
            let lastScrollY = 0;
            let scrollDirection = 'down';
            const updateScrollDirection = $5289fc5ae5c685da$var$throttle(()=>{
                const currentScrollY = window.scrollY;
                scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
                lastScrollY = currentScrollY;
            }, 100);
            window.addEventListener('scroll', updateScrollDirection, {
                passive: true
            });
            // Добавляем переменные для контроля скорости скролла
            let scrollVelocity = 0;
            let lastScrollTime = Date.now();
            const updateScrollVelocity = ()=>{
                const currentTime = Date.now();
                const currentScrollY = window.scrollY;
                const timeDiff = currentTime - lastScrollTime;
                const scrollDiff = Math.abs(currentScrollY - lastScrollY);
                scrollVelocity = timeDiff > 0 ? scrollDiff / timeDiff : 0;
                lastScrollTime = currentTime;
            };
            window.addEventListener('scroll', updateScrollVelocity, {
                passive: true
            });
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: evolveSec,
                    pin: true,
                    start: 'top top',
                    scrub: 0.33,
                    normalizeScroll: true,
                    pinSpacing: true,
                    preventOverlaps: true,
                    refreshPriority: 1,
                    invalidateOnRefresh: true,
                    snap: {
                        snapTo: (progress)=>{
                            const slideProgress = progress * (slides.length - 1);
                            return Math.round(slideProgress) / (slides.length - 1);
                        },
                        duration: {
                            min: 0.05,
                            max: 0.1
                        },
                        delay: 0.1
                    },
                    end: ()=>'+=' + (evolveSlides.offsetWidth - window.innerWidth)
                }
            });
            tl.to(slides, {
                x: -slideWidth * (slides.length - 1),
                ease: 'none'
            });
            let callback = function(entries) {
                entries.forEach((entry)=>{
                    const slide = entry.target;
                    const slideIndex = slides.indexOf(slide);
                    if (entry.isIntersecting && slideIndex !== -1) {
                        if (slideIndex !== currentIndex) applyGalleryState(slideIndex);
                    }
                });
            };
            let resizeTimeout;
            const resizeObserver = new ResizeObserver((entries)=>{
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(()=>{
                    slideWidth = evolveSec.getBoundingClientRect().width;
                    evolveSlides.style.width = `${slides.length * slideWidth}px`;
                    slides.forEach((slide, index)=>{
                        slide.style.width = `${slideWidth}px`;
                        slide.style.left = `${index * slideWidth}px`;
                    });
                    tl.invalidate();
                }, 200);
            });
            resizeObserver.observe(document.querySelector('body'));
            let observer = new IntersectionObserver(callback, {
                root: evolveSec,
                threshold: 0.7
            });
            slides.forEach((slide)=>observer.observe(slide));
        }
    }
};
function $5289fc5ae5c685da$var$throttle(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
let $5289fc5ae5c685da$var$evolveSwiperWr = document.querySelectorAll('.evolve-swiper-wr');
$5289fc5ae5c685da$var$evolveSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.swiper-button-next');
        let prevEl = el.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        const evolveSliderTitlesArr = el.querySelectorAll('.evolve-sec__slider-title');
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            /*autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },*/ autoplay: false
        });
        lineTitlesFunc(evolveSliderTitlesArr);
    }
});
const $5289fc5ae5c685da$var$evolveSecSlidesEl = document.querySelector('.evolve-sec__slides');
const $5289fc5ae5c685da$var$evolveSecGalleryEl = document.querySelector('.evolve-sec__gallery');
const $5289fc5ae5c685da$var$evolveSecSliderEl = document.querySelector('.evolve-sec__slider');
if ($5289fc5ae5c685da$var$evolveSecSlidesEl) {
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                $5289fc5ae5c685da$var$evolveSecSlidesEl.classList.add('is-add-animation-fade');
                $5289fc5ae5c685da$var$evolveSecGalleryEl.classList.add('is-add-animation-fade');
                $5289fc5ae5c685da$var$evolveSecSliderEl.classList.add('is-add-animation-fade');
            } else {
                $5289fc5ae5c685da$var$evolveSecSlidesEl.classList.remove('is-add-animation-fade');
                $5289fc5ae5c685da$var$evolveSecGalleryEl.classList.remove('is-add-animation-fade');
                $5289fc5ae5c685da$var$evolveSecSliderEl.classList.remove('is-add-animation-fade');
            }
        });
    }, {
        root: null,
        rootMargin: '0px 0px -55% 0px',
        threshold: 0
    });
    setTimeout(()=>{
        observer.observe($5289fc5ae5c685da$var$evolveSecSlidesEl);
    }, 300);
}


// import gsap from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);
let $a24e03a37ce4f370$var$progressEndFlag = false;
window.beBoldSliderInit = function beBoldSliderInit() {
    if (window.innerWidth > 1024) {
        /*let progressEndFlag = false;*/ const beBoldSec = document.querySelector('.be-bold-sec');
        if (beBoldSec) {
            const beBoldSlides = document.querySelector('.be-bold-sec__slides');
            const slides = gsap.utils.toArray('.be-bold-sec__slide');
            const container = document.querySelector('.cont');
            let totalWidth = 0;
            const positions = [];
            slides.forEach((slide)=>{
                positions.push(totalWidth);
                totalWidth += slide.offsetWidth;
            });
            beBoldSlides.style.width = `${totalWidth}px`;
            const containerPaddingLeft = container ? parseFloat(getComputedStyle(container).paddingLeft) || container.getBoundingClientRect().left : 0;
            const visibleWidth = beBoldSec.offsetWidth - containerPaddingLeft;
            const speedFactor = 1.5;
            const scrollDistance = (totalWidth - visibleWidth) / speedFactor;
            const finalX = -(totalWidth - visibleWidth);
            slides.forEach((slide, index)=>{
                const slidePosition = positions[index] - containerPaddingLeft;
                let scale, opacity, x;
                if (slidePosition <= 0) {
                    scale = 1;
                    opacity = 1;
                    x = 0;
                } else {
                    const maxDistance = visibleWidth;
                    const normalizedDistance = Math.min(slidePosition / maxDistance, 1);
                    scale = 1 - normalizedDistance * 0.35;
                    opacity = 1 - normalizedDistance * 0.8;
                    x = normalizedDistance * 100;
                }
                gsap.set(slide, {
                    scale: scale,
                    opacity: opacity,
                    x: x
                });
            });
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: beBoldSec,
                    pin: true,
                    scrub: 1,
                    start: 'top top',
                    end: ()=>`+=${scrollDistance}`,
                    onUpdate: (self)=>{
                        const progress = self.progress;
                        if (progress >= 0.05) $a24e03a37ce4f370$var$progressEndFlag = true;
                        if (progress >= 0.972) {
                            for(let i = 0; i < slides.length; i++)if (!slides[i].classList.contains('is-last')) slides[i].classList.add('is-last-opacity');
                        } else {
                            for(let i = 0; i < slides.length; i++)if (!slides[i].classList.contains('is-last')) slides[i].classList.remove('is-last-opacity');
                        }
                        const currentX = finalX * progress;
                        slides.forEach((slide, index)=>{
                            const slidePosition = positions[index] + currentX - containerPaddingLeft;
                            let scale, opacity, x;
                            if (slidePosition <= 0) {
                                scale = 1;
                                opacity = 1;
                                x = 0;
                            } else {
                                const maxDistance = visibleWidth;
                                const normalizedDistance = Math.min(slidePosition / maxDistance, 1);
                                scale = 1 - normalizedDistance * 0.35;
                                opacity = 1 - normalizedDistance * 0.8;
                                x = normalizedDistance * 100;
                            }
                            gsap.set(slide, {
                                scale: scale,
                                opacity: opacity,
                                x: x
                            });
                        });
                    }
                }
            });
            tl.to(beBoldSlides, {
                x: finalX,
                ease: 'none'
            });
        }
    }
    const beBoldTitle = document.querySelector('.text-sec.be-bold-type .text-sec__title');
    const beBoldText = document.querySelector('.text-sec.be-bold-type .text-sec__text-fixed');
    const beBoldTextNotAnimation = document.querySelector('.text-sec.be-bold-type .text-sec__text:not(.text-sec__text-fixed)');
    const beBoldTextSec = document.querySelector('.text-sec.be-bold-type');
    const beBoldWe = document.querySelector('.be-bold-sec-wr');
    let sharedMinOffset = 265;
    if (window.innerHeight >= 1100) sharedMinOffset = 290;
    else if (window.innerHeight <= 850) sharedMinOffset = 235;
    else if (window.innerHeight <= 800) sharedMinOffset = 205;
    else if (window.innerHeight <= 740) sharedMinOffset = 190;
    // общая переменная для трека
    let sharedTrackHeight = null;
    // --- TITLE ---
    if (beBoldTitle && window.innerWidth > 1024) setTimeout(()=>{
        const maxOffset = 450;
        const minOffset = sharedMinOffset;
        const diff = maxOffset - minOffset;
        if (!beBoldTitle.parentElement.classList.contains('be-bold-title-wrapper')) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('be-bold-title-wrapper');
            beBoldTitle.parentElement.insertBefore(wrapper, beBoldTitle);
            wrapper.appendChild(beBoldTitle);
        }
        const wrapper = document.querySelector('.be-bold-title-wrapper');
        beBoldTitle.style.transform = `translateY(${diff}px)`;
        beBoldTextNotAnimation.style.marginTop = `${diff * 2}px`;
        if (beBoldWe) sharedTrackHeight = beBoldWe.clientHeight + beBoldTextSec.clientHeight - parseFloat(getComputedStyle(beBoldWe).paddingTop) - window.innerHeight - beBoldTitle.clientHeight;
        else sharedTrackHeight = beBoldTextSec.clientHeight + beBoldTitle.clientHeight / 2 - parseFloat(getComputedStyle(beBoldTextNotAnimation).marginTop);
        ScrollTrigger.create({
            trigger: wrapper,
            start: `top top+=${minOffset}`,
            end: `+=${sharedTrackHeight}`,
            pin: true,
            pinSpacing: false,
            scrub: true,
            onUpdate: (self)=>{
                const progress = self.progress;
                if (progress <= 0.3) {
                    const eased = 1 - progress / 0.3;
                    const y = diff * eased;
                    beBoldTitle.style.transform = `translateY(${y}px)`;
                } else beBoldTitle.style.transform = `translateY(0px)`;
            }
        });
        const pinSpacer = wrapper.closest('.pin-spacer');
        if (pinSpacer) pinSpacer.classList.add('text-sec__be-bold-title');
    }, 1200);
    // --- TEXT ---
    if (beBoldText && window.innerWidth > 1024) setTimeout(function() {
        const minOffset = sharedMinOffset;
        if (!beBoldText.parentElement.classList.contains('be-bold-text-wrapper')) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('be-bold-text-wrapper');
            beBoldText.parentElement.insertBefore(wrapper, beBoldText);
            wrapper.appendChild(beBoldText);
        }
        const wrapper = document.querySelector('.be-bold-text-wrapper');
        beBoldText.style.transform = `translateY(0px)`;
        beBoldText.style.paddingTop = `8px`;
        // считаем разницу стартовых позиций текста и заголовка
        const offsetDiff = beBoldText.getBoundingClientRect().top + window.scrollY - (beBoldTitle.getBoundingClientRect().top + window.scrollY);
        // общий trackHeight минус эта разница
        const textTrackHeight = sharedTrackHeight - offsetDiff - 16 - beBoldTitle.scrollHeight - beBoldText.scrollHeight / 2;
        ScrollTrigger.create({
            trigger: wrapper,
            start: `top top+=${minOffset}`,
            end: `+=${textTrackHeight}`,
            pin: true,
            pinSpacing: false,
            scrub: true,
            onUpdate: ()=>{
                beBoldText.style.transform = `translateY(0px)`;
            }
        });
    }, 1200);
};
let $a24e03a37ce4f370$var$beBoldSwiperWr = document.querySelectorAll('.be-bold-swiper-wr');
$a24e03a37ce4f370$var$beBoldSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.swiper-button-next');
        let prevEl = el.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 30,
            slidesPerView: 'auto',
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            breakpoints: {
                768: {
                    spaceBetween: 24,
                    slidesPerView: 2
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
});


if (document.querySelector('.faq-sec__container')) {
    const faqsContainersArr = document.querySelectorAll('.faq-sec__container');
    faqsContainersArr.forEach((faqsContainer)=>{
        if (!faqsContainer.classList.contains('is-init-faq')) {
            faqsContainer.classList.add('is-init-faq');
            const togglesArr = faqsContainer.querySelectorAll('.faq-sec__toggle');
            const itemsArr = faqsContainer.querySelectorAll('.faq-sec__item');
            togglesArr.forEach((toggle, idx)=>{
                toggle.addEventListener('click', ()=>{
                    if (toggle.classList.contains('is-active')) closeTabFunc(toggle, idx);
                    else openTabFunc(toggle, idx);
                });
            });
            function openTabFunc(toggle, idx) {
                for(let i = 0; i < togglesArr.length; i++){
                    togglesArr[i].classList.remove('is-active');
                    itemsArr[i].classList.remove('is-active');
                }
                toggle.classList.add('is-active');
                itemsArr[idx].classList.add('is-active');
            }
            function closeTabFunc(toggle, idx) {
                toggle.classList.remove('is-active');
                itemsArr[idx].classList.remove('is-active');
            }
        }
    });
}


// import gsap from 'gsap';
if (document.querySelector('.first-sec__row')) document.querySelectorAll('.first-sec__row').forEach((row)=>{
    const track = row.querySelector('.first-sec__row-track');
    const contents = track.querySelectorAll('.first-sec__row-content');
    const maxChildren = Math.max(...Array.from(contents).map((content)=>content.children.length));
    contents.forEach((content)=>{
        const currentLen = content.children.length;
        const diff = maxChildren - currentLen;
        if (diff > 0) {
            const childrenArray = Array.from(content.children);
            for(let i = 0; i < diff; i++){
                const randIndex = Math.floor(Math.random() * childrenArray.length);
                const clone = childrenArray[randIndex].cloneNode(true);
                content.appendChild(clone);
            }
        }
    });
    const originalContent = track.querySelector('.first-sec__row-content');
    for(let i = 0; i < 4; i++){
        const clone = originalContent.cloneNode(true);
        track.appendChild(clone);
    }
    const totalWidth = originalContent.offsetWidth;
    gsap.set(track, {
        x: -window.innerWidth
    });
    gsap.to(track, {
        x: `${-1 * totalWidth}px`,
        duration: 80,
        ease: 'none',
        repeat: -1,
        modifiers: {
            x: gsap.utils.unitize((x)=>parseFloat(x) % totalWidth)
        }
    });
});


// import { gsap } from 'gsap';
if (document.querySelector('.text-sec__row-marquee')) {
    let currentScroll = window.pageYOffset;
    let isScrollingDown = true;
    let scrollTimeout;
    document.querySelectorAll('.text-sec__row-marquee').forEach((row)=>{
        const track = row.querySelector('.text-sec__row-track');
        const content = track.querySelector('.text-sec__row-content');
        for(let i = 0; i < 10; i++){
            const clone = content.cloneNode(true);
            track.appendChild(clone);
        }
        const contentWidth = content.offsetWidth;
        gsap.set(track, {
            x: -contentWidth
        });
        const tween = gsap.to(track, {
            x: `-=${contentWidth}`,
            duration: 80,
            ease: 'none',
            repeat: -1,
            modifiers: {
                x: gsap.utils.unitize((x)=>parseFloat(x) % contentWidth)
            }
        });
        tween.totalProgress(0.5);
    /*window.addEventListener('scroll', () => {
      const newScroll = window.pageYOffset;
      isScrollingDown = newScroll > currentScroll;
      currentScroll = newScroll;

      gsap.to(tween, {
        timeScale: isScrollingDown ? 2 : -2,
        overwrite: true,
        duration: 0.2,
      });

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        gsap.to(tween, {
          timeScale: isScrollingDown ? 1 : -1,
          duration: 0.5,
          ease: 'power2.out',
        });
      }, 300);
    });*/ });
}


// import { gsap } from 'gsap';
if (document.querySelector('.text-sec__tech-row')) document.querySelectorAll('.text-sec__tech-row').forEach((row)=>{
    const track = row.querySelector('.text-sec__tech-row-track');
    const content = track.querySelector('.text-sec__tech-row-content');
    for(let i = 0; i < 4; i++){
        const clone = content.cloneNode(true);
        track.appendChild(clone);
    }
    requestAnimationFrame(()=>{
        const totalWidth = content.offsetWidth;
        gsap.set(track, {
            x: -window.innerWidth
        });
        gsap.to(track, {
            x: `${-1 * totalWidth}px`,
            duration: window.innerWidth > 640 ? 45 : 80,
            ease: 'none',
            repeat: -1,
            modifiers: {
                x: gsap.utils.unitize(gsap.utils.wrap(-totalWidth, 0))
            }
        });
    });
});


const $62af12d4c3e06418$var$projectSecImages2ColumnsEl = document.querySelector('.project-sec__images.with-2-columns');
if ($62af12d4c3e06418$var$projectSecImages2ColumnsEl) {
    const imagesArr = $62af12d4c3e06418$var$projectSecImages2ColumnsEl.querySelectorAll('.project-sec__image:not(.col-span-full)');
    if (imagesArr.length < 2) imagesArr.forEach((image)=>{
        image.classList.add('col-span-full');
    });
}


window.testimonialCardsFunc = function testimonialCardsFunc1() {
    const testimonialCardsArr = document.querySelectorAll('.testimonial-card');
    let testimonialContainersArr = [];
    testimonialCardsArr.forEach((testimonialCard)=>{
        if (!testimonialCard.classList.contains('is-init-testimonial-card')) {
            testimonialCard.classList.add('is-init-testimonial-card');
            const testimonialContainerEl = testimonialCard.querySelector('.testimonial-card__container');
            const testimonialCardTextEl = testimonialCard.querySelector('.testimonial-card__text');
            if (testimonialCardTextEl) testimonialCardTextEl.querySelectorAll('p').forEach((p)=>{
                if (!p.textContent.trim()) p.remove();
            });
            if (testimonialContainerEl) testimonialContainersArr.push(testimonialContainerEl);
        }
    });
    function containersHeightFunc(containersArr) {
        let maxHeight = 0;
        containersArr.forEach((container)=>{
            const height = container.offsetHeight;
            if (height > maxHeight) maxHeight = height;
        });
        containersArr.forEach((container)=>{
            container.style.minHeight = maxHeight + 'px';
        });
    }
    if (window.innerWidth > 640) containersHeightFunc(testimonialContainersArr);
};
testimonialCardsFunc();
gsap.registerPlugin(ScrollTrigger);
const $d2f1b2f18ff1e62b$var$testimonialsGrid = document.querySelector('.our-testimonials-sec__container');
const $d2f1b2f18ff1e62b$var$title = document.querySelector('.testimonials-first-sec .first-sec__title');
if ($d2f1b2f18ff1e62b$var$testimonialsGrid && $d2f1b2f18ff1e62b$var$title) {
    const isTablet = window.matchMedia('(max-width: 1024px)').matches;
    $d2f1b2f18ff1e62b$var$testimonialsGrid.classList.add('animated');
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    if (!isTablet) {
        const moveY = 150;
        const columns = $d2f1b2f18ff1e62b$var$testimonialsGrid.querySelectorAll('[data-speed]');
        let maxShift = 0;
        columns.forEach((col)=>{
            const speed = parseFloat(col.dataset.speed);
            const maxScroll = $d2f1b2f18ff1e62b$var$testimonialsGrid.scrollHeight - window.innerHeight;
            const shift = Math.abs(maxScroll * (speed - 1) * 0.45);
            if (shift > maxShift) maxShift = shift;
        });
        if (window.innerWidth > 551) $d2f1b2f18ff1e62b$var$testimonialsGrid.style.maxHeight = `${$d2f1b2f18ff1e62b$var$testimonialsGrid.scrollHeight - +maxShift.toFixed(2) / 0.75}px`;
        gsap.to($d2f1b2f18ff1e62b$var$testimonialsGrid, {
            y: -moveY,
            ease: 'none',
            scrollTrigger: {
                trigger: $d2f1b2f18ff1e62b$var$title,
                start: 'top 20%',
                end: ()=>'+=' + ($d2f1b2f18ff1e62b$var$title.offsetHeight + 200),
                scrub: true
            }
        });
        columns.forEach((column)=>{
            const speed = parseFloat(column.dataset.speed);
            const maxScroll = $d2f1b2f18ff1e62b$var$testimonialsGrid.scrollHeight - window.innerHeight;
            gsap.to(column, {
                y: ()=>-maxScroll * (speed - 1) * 0.8,
                ease: 'none',
                scrollTrigger: {
                    trigger: $d2f1b2f18ff1e62b$var$testimonialsGrid,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });
    }
}


const $74fdecdb72380e2d$var$workCardsArr = document.querySelectorAll('.second-work-card.if-not-search-page');
if ($74fdecdb72380e2d$var$workCardsArr.length > 0) $74fdecdb72380e2d$var$workCardsArr.forEach((card)=>{
    const image = card.querySelector('.second-work-card__image img');
    const galleryWrapper = card.querySelector('.second-work-card__gallery');
    if (galleryWrapper) {
        const galleryImages = card.querySelectorAll('.second-work-card__gallery-img');
        if (!galleryImages.length) return;
        const sources = [];
        const imgs = [];
        imgs.push(image);
        galleryImages.forEach((picture)=>{
            const source = picture.querySelector('source');
            const img = picture.querySelector('img');
            if (source?.dataset.srcset) {
                source.srcset = source.dataset.srcset;
                delete source.dataset.srcset;
            }
            if (img?.dataset.src) {
                img.src = img.dataset.src;
                delete img.dataset.src;
            }
            sources.push(source);
            imgs.push(img);
        });
        let hoverTimeout;
        let cycleInterval;
        card.addEventListener('mouseenter', ()=>{
            if (imgs.length <= 1) return;
            clearTimeout(hoverTimeout);
            clearInterval(cycleInterval);
            const delay = card.dataset.hasHoveredBefore ? 300 : 500;
            hoverTimeout = setTimeout(()=>{
                let currentIndex = 0;
                const showImage = (index)=>{
                    imgs.forEach((img, i)=>{
                        img.style.opacity = i === index ? '1' : '0';
                    });
                };
                showImage(currentIndex);
                cycleInterval = setInterval(()=>{
                    currentIndex = (currentIndex + 1) % imgs.length;
                    showImage(currentIndex);
                }, 2000);
                card.dataset.hasHoveredBefore = 'true';
            }, delay);
        });
        card.addEventListener('mouseleave', ()=>{
            clearTimeout(hoverTimeout);
            clearInterval(cycleInterval);
            imgs.forEach((img, i)=>{
                img.style.opacity = i === 0 ? '1' : '0';
            });
        });
    }
});


window.initProjectButtonsDropdowns = function initProjectButtonsDropdowns1() {
    const projectButtonsDropdownsWrArr = document.querySelectorAll('.project-dropdown-btn-wr');
    if (projectButtonsDropdownsWrArr.length) projectButtonsDropdownsWrArr.forEach((projectButtonsDropdownWr)=>{
        if (!projectButtonsDropdownWr.classList.contains('is-init')) {
            projectButtonsDropdownWr.classList.add('is-init');
            const btn = projectButtonsDropdownWr.querySelector('.project-dropdown-open-btn');
            const content = projectButtonsDropdownWr.querySelector('.project-dropdown-btn-content');
            const contentItemsArr = content.querySelectorAll('.project-dropdown-btn-content__link');
            const placeholder = projectButtonsDropdownWr.querySelector('.project-dropdown-placeholder');
            if (placeholder) checkedSelectedItems();
            function checkedSelectedItems() {
                contentItemsArr.forEach((item)=>{
                    if (item.classList.contains('is-selected')) {
                        const flag = item.querySelector('.project-dropdown-btn-content__link-flag');
                        placeholder.textContent = item.textContent;
                        if (item.querySelector('.amd-value-to-label')) placeholder.textContent = item.querySelector('.amd-value-to-label').textContent;
                        if (placeholder.classList.contains('if-language')) {
                            const flagClone = flag.cloneNode(true);
                            placeholder.innerHTML = '';
                            placeholder.appendChild(flagClone);
                        }
                    }
                });
            }
            document.body.appendChild(content);
            content.style.position = 'absolute';
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                if (!content.classList.contains('is-open')) {
                    function contentPositionFunc() {
                        content.style.minWidth = btn.clientWidth + 'px';
                        const btnRect = btn.getBoundingClientRect();
                        const contentRect = content.getBoundingClientRect();
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;
                        const scrollTop = window.scrollY || document.documentElement.scrollTop;
                        let top = btnRect.bottom + scrollTop;
                        let left = btnRect.right - contentRect.width;
                        if (left < 0) left = btnRect.left;
                        /*if (top + contentRect.height > viewportHeight + scrollTop) {
                top = btnRect.top - contentRect.height + scrollTop;
              }*/ if (content.classList.contains('if-bottom-position')) {
                            top = btnRect.top + scrollTop;
                            content.style.top = `${top + btn.clientHeight + 4}px`;
                        } else content.style.top = `${top - btn.clientHeight - 4}px`;
                        if (content.classList.contains('if-left-position')) left = btnRect.left;
                        content.style.left = `${left}px`;
                    }
                    contentPositionFunc();
                    content.classList.add('is-open');
                    projectButtonsDropdownWr.classList.add('is-open');
                    setTimeout(()=>{
                        contentPositionFunc();
                    }, 0);
                } else {
                    content.classList.remove('is-open');
                    projectButtonsDropdownWr.classList.remove('is-open');
                }
            });
            document.addEventListener('click', (e)=>{
                if (!content.contains(e.target) && !btn.contains(e.target)) {
                    content.classList.remove('is-open');
                    projectButtonsDropdownWr.classList.remove('is-open');
                }
            });
            function hideDropdown() {
                content.classList.remove('is-open');
                projectButtonsDropdownWr.classList.remove('is-open');
            }
            /*if (content.classList.contains('if-hidden-on-scroll')) {
          document.addEventListener('scroll', () => {
            hideDropdown();
          });

          document.addEventListener('touchmove', () => {
            hideDropdown();
          });
        }

        const scrollContainer = projectButtonsDropdownWr.closest(
          '.project-container-scroll'
        );
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', hideDropdown);
          scrollContainer.addEventListener('touchmove', hideDropdown);
        }*/ if (content.querySelector('.is-selected')) contentItemsArr.forEach((item)=>{
                item.addEventListener('click', (e)=>{
                    if (item.tagName === 'A' || item.tagName === 'BUTTON') e.preventDefault();
                    for(let i = 0; i < contentItemsArr.length; i++)contentItemsArr[i].classList.remove('is-selected');
                    item.classList.add('is-selected');
                    if (placeholder) checkedSelectedItems();
                    if (item.classList.contains('if-open-amd-inline')) {
                        if (!item.classList.contains('is-open-amd-inline')) item.classList.add('is-open-amd-inline');
                    }
                });
                if (item.classList.contains('if-open-amd-inline')) {
                    const adpClose = item.querySelector('.project-dropdown-btn-content__link-calendar-close');
                    setInterval(function() {
                        if (item.classList.contains('is-open-amd-inline')) checkedSelectedItems();
                    }, 300);
                    adpClose.addEventListener('click', (e)=>{
                        setTimeout(function() {
                            item.classList.remove('is-open-amd-inline');
                        }, 50);
                    });
                }
            });
        }
    });
};
initProjectButtonsDropdowns();


const $bae63c91f7a80e65$var$chatToggleBtn = document.getElementsByClassName('following-chat-btn')[0];
const $bae63c91f7a80e65$var$chatToggleBtnWr = document.getElementsByClassName('btn-following-chat-wr')[0];
const $bae63c91f7a80e65$var$chatMenuBtn = document.getElementsByClassName('menu-chat-btn')[0];
const $bae63c91f7a80e65$var$chatModal = document.getElementsByClassName('chat-modal')[0];
let $bae63c91f7a80e65$var$hasChatOpened = false;
let $bae63c91f7a80e65$var$hasUserInteracted = false;
if ($bae63c91f7a80e65$var$chatToggleBtn && $bae63c91f7a80e65$var$chatModal) {
    /*const vh = window.innerHeight * 0.01;*/ const chatModalClose = $bae63c91f7a80e65$var$chatModal.querySelector('.chat-modal__head-close');
    const chatModalScrollEl = $bae63c91f7a80e65$var$chatModal.querySelector('.chat-modal__scroll');
    const chatInput = $bae63c91f7a80e65$var$chatModal.querySelector('.chat-modal__input-container input');
    const chatTextarea = $bae63c91f7a80e65$var$chatModal.querySelector('.chat-modal__input-container textarea');
    const chatInputBtn = $bae63c91f7a80e65$var$chatModal.querySelector('.chat-modal__input-btn');
    function sendChat() {
        chatInputBtn.click();
    }
    if (chatInput) chatInput.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            sendChat();
        }
    });
    if (chatTextarea) chatTextarea.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendChat();
        }
    });
    /*const chatModalHeadEl = chatModal.querySelector('.chat-modal__head');
  const chatModalBottomlEl = chatModal.querySelector('.chat-modal__bottom');
  const headerEl = chatModal.querySelector('header');*/ window.updateModalBottom = function updateModalBottom1() {
        if ($bae63c91f7a80e65$var$chatToggleBtnWr) {
            const cont = $bae63c91f7a80e65$var$chatToggleBtnWr.querySelector('.cont');
            if (cont) {
                const leftOffset = cont.getBoundingClientRect().left;
                const bottomOffset = window.getComputedStyle($bae63c91f7a80e65$var$chatToggleBtnWr).bottom;
                $bae63c91f7a80e65$var$chatModal.style.right = leftOffset + 'px';
                $bae63c91f7a80e65$var$chatModal.style.bottom = bottomOffset;
            }
        }
    };
    updateModalBottom();
    window.addEventListener('resize', updateModalBottom);
    $bae63c91f7a80e65$var$chatToggleBtn.addEventListener('click', (event)=>{
        event.stopPropagation();
        $bae63c91f7a80e65$var$hasChatOpened = true;
        $bae63c91f7a80e65$var$hasUserInteracted = true;
        menuCloseFunc();
        $bae63c91f7a80e65$var$chatModal.classList.remove('is-closed');
        $bae63c91f7a80e65$var$chatModal.classList.toggle('is-active');
        $bae63c91f7a80e65$var$chatToggleBtn.classList.toggle('is-open-chat');
        if ($bae63c91f7a80e65$var$chatToggleBtnWr) updateModalBottom();
    });
    chatModalClose.addEventListener('click', ()=>{
        $bae63c91f7a80e65$var$hasUserInteracted = true;
        $bae63c91f7a80e65$var$chatModal.classList.add('is-closed');
        setTimeout(function() {
            $bae63c91f7a80e65$var$chatModal.classList.remove('is-active');
            $bae63c91f7a80e65$var$chatToggleBtn.classList.remove('is-open-chat');
        }, 400);
        setTimeout(function() {
            $bae63c91f7a80e65$var$chatModal.classList.remove('is-closed');
        }, 900);
    });
    document.addEventListener('click', (event)=>{
        const targetElement = event.target;
        const isChatOpen = $bae63c91f7a80e65$var$chatModal.classList.contains('is-active');
        const isClickInsideProjectDropdown = targetElement.closest('.project-dropdown-btn-content');
        if (isChatOpen && !$bae63c91f7a80e65$var$chatModal.contains(targetElement) && targetElement !== $bae63c91f7a80e65$var$chatToggleBtn && targetElement !== $bae63c91f7a80e65$var$chatMenuBtn && !isClickInsideProjectDropdown) {
            $bae63c91f7a80e65$var$hasUserInteracted = true;
            $bae63c91f7a80e65$var$chatModal.classList.remove('is-active');
            $bae63c91f7a80e65$var$chatToggleBtn.classList.remove('is-open-chat');
        }
    });
    $bae63c91f7a80e65$var$chatMenuBtn.addEventListener('click', (event)=>{
        $bae63c91f7a80e65$var$hasChatOpened = true;
        $bae63c91f7a80e65$var$hasUserInteracted = true;
        menuCloseFunc();
        setTimeout(()=>{
            $bae63c91f7a80e65$var$chatModal.classList.remove('is-closed');
            $bae63c91f7a80e65$var$chatModal.classList.add('is-active');
            $bae63c91f7a80e65$var$chatToggleBtn.classList.add('is-open-chat');
            if ($bae63c91f7a80e65$var$chatToggleBtnWr) updateModalBottom();
        }, 300);
    });
    const chatModalScroll = new SimpleBar(chatModalScrollEl);
    window.scrollToBottom = function scrollToBottom1() {
        const scrollContainer = chatModalScroll.getScrollElement();
        if (scrollContainer) {
            const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
            if (isSmoothScrollSupported) scrollContainer.scrollTo({
                top: scrollContainer.scrollHeight,
                behavior: 'smooth'
            });
            else scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
    };
    if (chatInput) chatInput.addEventListener('change', ()=>{
        scrollToBottom();
    });
    if (chatTextarea) chatTextarea.addEventListener('change', ()=>{
        scrollToBottom();
    });
    chatInputBtn.addEventListener('click', ()=>{
        scrollToBottom();
    });
    const initChatScrollTrigger = ()=>{
        const textDigitalSec = document.querySelector('.text-digital-sec');
        if (!textDigitalSec || !$bae63c91f7a80e65$var$chatModal) return;
        const portfolioSec = document.querySelector('.portfolio-sec');
        const triggerElement = portfolioSec || textDigitalSec;
        const openChat = ()=>{
            if ($bae63c91f7a80e65$var$hasChatOpened || $bae63c91f7a80e65$var$hasUserInteracted) return;
            window.chatTimerOpenFunc();
        };
        const scrollTrigger = globalThis.ScrollTrigger;
        if (scrollTrigger && typeof scrollTrigger.create === 'function') {
            scrollTrigger.create({
                trigger: triggerElement,
                start: portfolioSec ? 'top 80%' : 'bottom top',
                once: true,
                onEnter: ()=>{
                    openChat();
                }
            });
            return;
        }
        let ticking = false;
        const checkScroll = ()=>{
            if ($bae63c91f7a80e65$var$hasChatOpened || $bae63c91f7a80e65$var$hasUserInteracted) {
                window.removeEventListener('scroll', onScroll);
                return;
            }
            const rect = triggerElement.getBoundingClientRect();
            const isPast = portfolioSec ? rect.top <= window.innerHeight * 0.8 : rect.bottom <= 0;
            if (isPast) {
                window.removeEventListener('scroll', onScroll);
                openChat();
            }
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(()=>{
                    checkScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener('scroll', onScroll, {
            passive: true
        });
        checkScroll();
    };
    initChatScrollTrigger();
    window.initChatScrollTrigger = initChatScrollTrigger;
}
window.initChatProductToggle = function initChatProductToggle1() {
    const productCard = document.getElementsByClassName('chat-bot-message__product')[0];
    if (productCard) {
        const productCardsArr = document.querySelectorAll('.chat-bot-message__product');
        for(let i = 0; i < productCardsArr.length; i++){
            const input = productCardsArr[i].querySelector('input');
            const counterBlock = productCardsArr[i].querySelector('.counter-parent-toggle');
            const btn = productCardsArr[i].querySelector('.chat-bot-btn');
            if (btn) btn.addEventListener('click', ()=>{
                if (counterBlock) counterBlock.classList.add('active');
                if (input && input.value < 1) input.stepUp();
            });
        }
    }
};
initChatProductToggle();
window.chatTimerOpenFunc = function chatTimerOpenFunc() {
    const modal = $bae63c91f7a80e65$var$chatModal || document.getElementsByClassName('chat-modal')[0];
    const toggleBtnWr = $bae63c91f7a80e65$var$chatToggleBtnWr || document.getElementsByClassName('btn-following-chat-wr')[0];
    if (!modal || $bae63c91f7a80e65$var$hasChatOpened || $bae63c91f7a80e65$var$hasUserInteracted) return;
    $bae63c91f7a80e65$var$hasChatOpened = true;
    modal.classList.remove('is-closed');
    modal.classList.add('is-active');
    if (toggleBtnWr && typeof updateModalBottom === 'function') updateModalBottom();
};




let $84470f90f07c1899$var$worksSwiperWr = document.querySelectorAll('.works-swiper-wr');
$84470f90f07c1899$var$worksSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.swiper-button-next');
        let prevEl = el.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039),
                (0, $b9ef5a7823f4e4ba$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                640: {
                    slidesPerView: 2
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') : wrapper.classList.add('justify-center');
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') : wrapper.classList.add('justify-center');
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
}); /*
let lastX = 0;
let lastY = 0;
let requestID = null;*/  /*function updateCursorPosition(x, y) {
  if (cursor && cursor.el) {
    if (Math.abs(x - lastX) > 2 || Math.abs(y - lastY) > 2) {
      lastX = x;
      lastY = y;

      if (requestID !== null) {
        cancelAnimationFrame(requestID);
      }

      requestID = requestAnimationFrame(() => {
        cursor.el.style.transform = `translate3d(${lastX}px, ${lastY}px, 0)`;
      });
    }
  }
}*/ 





const $9cb5cf8bde55ff38$export$f16e6af5a274aa5b = (breakpoint, swiperClass, swiperSettings, startOnView)=>{
    let swiper = null;
    breakpoint = window.matchMedia(breakpoint);
    const enableSwiper = function(className, settings) {
        swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(className, settings);
        if (startOnView) (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    };
    const checker = function() {
        if (breakpoint.matches) {
            if (!swiper) enableSwiper(swiperClass, swiperSettings);
        } else if (swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    };
    breakpoint.addEventListener("change", checker);
    checker();
    return {
        swiper: swiper
    };
};


const $52d2e35a6348193f$var$initializedWrappers = new WeakSet();
const $52d2e35a6348193f$var$initIntegrationsContentSwiper = (scope = document)=>{
    const wrappers = scope.matches?.('.integrations-content-swiper-wr') ? [
        scope
    ] : Array.from(scope.querySelectorAll('.integrations-content-swiper-wr'));
    wrappers.forEach((wrapper)=>{
        if ($52d2e35a6348193f$var$initializedWrappers.has(wrapper)) return;
        const swiperEl = wrapper.querySelector('.swiper');
        if (!swiperEl) return;
        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');
        $52d2e35a6348193f$var$initializedWrappers.add(wrapper);
        const swiperOptions = {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 20,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            }
        };
        if (prevEl && nextEl) swiperOptions.navigation = {
            prevEl: prevEl,
            nextEl: nextEl
        };
        (0, $9cb5cf8bde55ff38$export$f16e6af5a274aa5b)('(max-width: 1023px)', swiperEl, swiperOptions);
    });
};
$52d2e35a6348193f$var$initIntegrationsContentSwiper();
window.initIntegrationsContentSwiper = $52d2e35a6348193f$var$initIntegrationsContentSwiper;




let $c9f50e14fc6e389d$var$latestWorksSwiperWr = document.querySelectorAll('.latest-works-swiper-wr');
$c9f50e14fc6e389d$var$latestWorksSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.swiper-button-next');
        let prevEl = el.querySelector('.swiper-button-prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                (0, $7b5d41c9939efc77$export$2e2bcd8739ae039),
                (0, $b9ef5a7823f4e4ba$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') : wrapper.classList.add('justify-center');
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') : wrapper.classList.add('justify-center');
                }
            }
        });
        (0, $20f6f0e1e0f4fe4b$export$1ef7ff889bcb5d7a)(swiper);
    }
}); /*
let lastX = 0;
let lastY = 0;
let requestID = null;*/  /*function updateCursorPosition(x, y) {
  if (cursor && cursor.el) {
    if (Math.abs(x - lastX) > 2 || Math.abs(y - lastY) > 2) {
      lastX = x;
      lastY = y;

      if (requestID !== null) {
        cancelAnimationFrame(requestID);
      }

      requestID = requestAnimationFrame(() => {
        cursor.el.style.transform = `translate3d(${lastX}px, ${lastY}px, 0)`;
      });
    }
  }
}*/ 


document.querySelectorAll('.drag-slider').forEach((el)=>{
    if (!el.classList.contains('is-init')) {
        el.classList.add('is-init');
        const slider = el.querySelector('.drag-slider-wrapper');
        const buttonsContainer = el.parentElement.querySelector('.drag-slider-buttons');
        const prevButton = buttonsContainer?.querySelector('.drag-slider-button.prev');
        const nextButton = buttonsContainer?.querySelector('.drag-slider-button.next');
        let velocity = 0;
        let animationFrame;
        let isDown = false;
        let startX;
        let startY;
        let scrollLeft;
        const tolerance = 10;
        let isMoving = false;
        const dragSlidesArr = slider.querySelectorAll('.drag-slide');
        const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
        const isSafari = navigator.userAgent.toLowerCase().includes('safari') && !navigator.userAgent.toLowerCase().includes('chrome');
        let preventClick = false;
        // Функция для получения ширины одного слайда
        const getSlideWidth = ()=>{
            const firstSlide = dragSlidesArr[0];
            if (!firstSlide) return 0;
            const computedStyle = window.getComputedStyle(firstSlide);
            const width = firstSlide.offsetWidth;
            const marginLeft = parseFloat(computedStyle.marginLeft) || 0;
            const marginRight = parseFloat(computedStyle.marginRight) || 0;
            return width + marginLeft + marginRight;
        };
        // Функция для плавного скролла
        const smoothScrollTo = (targetPosition, duration = 500)=>{
            const startPosition = slider.scrollLeft;
            const distance = targetPosition - startPosition;
            const startTime = performance.now();
            // Отключаем scroll-snap на время анимации
            slider.style.scrollSnapType = 'none';
            const animateScroll = (currentTime)=>{
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                // Easing функция для плавности
                const easeInOutCubic = progress < 0.5 ? 4 * progress * progress * progress : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1;
                slider.scrollLeft = startPosition + distance * easeInOutCubic;
                if (progress < 1) requestAnimationFrame(animateScroll);
                else // Возвращаем scroll-snap после анимации
                slider.style.scrollSnapType = '';
            };
            requestAnimationFrame(animateScroll);
        };
        // Функция для обновления состояния кнопок
        const updateButtonsState = ()=>{
            if (!buttonsContainer) return;
            const isAtStart = slider.scrollLeft <= 10;
            const isAtEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 10;
            prevButton?.classList.toggle('disabled', isAtStart);
            nextButton?.classList.toggle('disabled', isAtEnd);
        };
        // Обработчики кнопок
        if (prevButton) prevButton.addEventListener('click', (e)=>{
            e.preventDefault();
            if (prevButton.classList.contains('disabled')) return;
            const slideWidth = getSlideWidth();
            const currentScroll = slider.scrollLeft;
            const targetScroll = Math.max(0, currentScroll - slideWidth);
            smoothScrollTo(targetScroll);
        });
        if (nextButton) nextButton.addEventListener('click', (e)=>{
            e.preventDefault();
            if (nextButton.classList.contains('disabled')) return;
            const slideWidth = getSlideWidth();
            const currentScroll = slider.scrollLeft;
            const maxScroll = slider.scrollWidth - slider.clientWidth;
            const targetScroll = Math.min(maxScroll, currentScroll + slideWidth);
            smoothScrollTo(targetScroll);
        });
        // Отслеживание скролла для обновления кнопок
        let scrollTimeout;
        slider.addEventListener('scroll', ()=>{
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(()=>{
                updateButtonsState();
            }, 10);
        });
        // Инициализация состояния кнопок
        setTimeout(()=>{
            updateButtonsState();
        }, 100);
        // Оригинальная логика драга остается без изменений
        const start = (x, y)=>{
            isDown = true;
            isMoving = false;
            preventClick = false;
            slider.classList.add('active');
            startX = x - slider.getBoundingClientRect().left;
            startY = y;
            scrollLeft = slider.scrollLeft;
            slider.style.scrollSnapType = 'none';
        };
        const move = (x, y)=>{
            if (!isDown) return;
            const deltaX = Math.abs(x - startX);
            const deltaY = Math.abs(y - startY);
            if (deltaX > tolerance || deltaY > tolerance) {
                isMoving = true;
                preventClick = true;
            }
            const dist = x - startX;
            const newScrollLeft = scrollLeft - dist;
            velocity = newScrollLeft - slider.scrollLeft;
            slider.scrollLeft = newScrollLeft;
            // Обновляем кнопки во время драга
            updateButtonsState();
        };
        const end = (e)=>{
            if (!isDown) return;
            isDown = false;
            isMoving = false;
            slider.classList.remove('active');
            slider.style.scrollSnapType = '';
            if (!preventClick) {
                let target;
                if (e.clientX !== undefined && e.clientY !== undefined) target = document.elementFromPoint(e.clientX, e.clientY)?.closest('a');
                else if (e.changedTouches && e.changedTouches[0]) target = document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY)?.closest('a');
                if (target) window.location.href = target.getAttribute('href');
            }
            cancelAnimationFrame(animationFrame);
            const friction = 0.95;
            const minVelocity = 0.5;
            const inertia = ()=>{
                if (Math.abs(velocity) > minVelocity) {
                    slider.scrollLeft += velocity;
                    velocity *= friction;
                    animationFrame = requestAnimationFrame(inertia);
                    updateButtonsState();
                }
            };
            inertia();
            preventClick = false;
        };
        const handleGlobalMouseUp = ()=>{
            if (isDown) {
                isDown = false;
                isMoving = false;
                slider.classList.remove('active');
                slider.style.scrollSnapType = '';
                preventClick = true;
            }
        };
        if (!isFirefox) {
            slider.addEventListener('pointerdown', (e)=>{
                start(e.pageX, e.pageY);
                slider.setPointerCapture(e.pointerId);
            });
            slider.addEventListener('pointermove', (e)=>{
                if (!isDown) return;
                e.preventDefault();
                move(e.pageX, e.pageY);
            });
            slider.addEventListener('pointerup', (e)=>{
                end(e);
                slider.releasePointerCapture(e.pointerId);
            });
            slider.addEventListener('pointercancel', end);
        }
        if (isFirefox) {
            let isDragging = false;
            const handleMouseMoveFirefox = (e)=>{
                if (isDown) {
                    const deltaX = Math.abs(e.pageX - startX);
                    const deltaY = Math.abs(e.pageY - startY);
                    if (deltaX > tolerance || deltaY > tolerance) {
                        isDragging = true;
                        slider.querySelectorAll('a').forEach((link)=>{
                            link.style.pointerEvents = 'none';
                        });
                    }
                    const dist = e.pageX - startX;
                    slider.scrollLeft = scrollLeft - dist;
                    updateButtonsState();
                }
            };
            const handleMouseUpFirefox = (e)=>{
                end(e);
                window.removeEventListener('mouseup', handleMouseUpFirefox);
                window.removeEventListener('mousemove', handleMouseMoveFirefox);
                setTimeout(()=>{
                    slider.querySelectorAll('a').forEach((link)=>{
                        link.style.pointerEvents = '';
                    });
                    isDragging = false;
                }, 100);
            };
            slider.addEventListener('mousedown', (e)=>{
                if (e.button === 0) {
                    start(e.pageX, e.pageY);
                    isDragging = false;
                    window.addEventListener('mouseup', handleMouseUpFirefox);
                    window.addEventListener('mousemove', handleMouseMoveFirefox);
                }
            });
            slider.addEventListener('touchstart', (e)=>{
                if (e.touches.length > 0) start(e.touches[0].pageX, e.touches[0].pageY);
            });
            slider.addEventListener('touchmove', (e)=>{
                if (e.touches.length > 0) move(e.touches[0].pageX, e.touches[0].pageY);
            });
            slider.addEventListener('touchend', (e)=>{
                end(e);
            });
            slider.addEventListener('dragstart', (e)=>{
                e.preventDefault();
            });
        }
        if (isSafari) {
            let isDragging = false;
            const handleMouseMoveSafari = (e)=>{
                if (isDown) {
                    const deltaX = Math.abs(e.pageX - startX);
                    const deltaY = Math.abs(e.pageY - startY);
                    if (deltaX > tolerance || deltaY > tolerance) {
                        isDragging = true;
                        slider.querySelectorAll('a').forEach((link)=>{
                            link.style.pointerEvents = 'none';
                        });
                    }
                    const dist = e.pageX - startX;
                    slider.scrollLeft = scrollLeft - dist;
                    updateButtonsState();
                }
            };
            const handleMouseUpSafari = (e)=>{
                end(e);
                window.removeEventListener('mouseup', handleMouseUpSafari);
                window.removeEventListener('mousemove', handleMouseMoveSafari);
                setTimeout(()=>{
                    slider.querySelectorAll('a').forEach((link)=>{
                        link.style.pointerEvents = '';
                    });
                    isDragging = false;
                }, 100);
            };
            slider.addEventListener('mousedown', (e)=>{
                if (e.button === 0) {
                    start(e.pageX, e.pageY);
                    isDragging = false;
                    window.addEventListener('mouseup', handleMouseUpSafari);
                    window.addEventListener('mousemove', handleMouseMoveSafari);
                }
            });
        }
        slider.querySelectorAll('a').forEach((link)=>{
            link.addEventListener('dragstart', (e)=>{
                e.preventDefault();
            });
        });
        // Оригинальная логика высоты слайдов
        let maxHeight = 0;
        dragSlidesArr.forEach((slide)=>{
            const height = slide.offsetHeight;
            if (height > maxHeight) maxHeight = height;
        });
        dragSlidesArr.forEach((slide)=>{
            slide.style.minHeight = maxHeight + 'px';
        });
        // Обновление кнопок при изменении размера окна
        window.addEventListener('resize', ()=>{
            setTimeout(()=>{
                updateButtonsState();
            }, 100);
        });
    }
});


function $7082d30e5438ab38$var$t(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, n = Array(e); i < e; i++)n[i] = t[i];
    return n;
}
function $7082d30e5438ab38$var$e() {
    return $7082d30e5438ab38$var$e = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $7082d30e5438ab38$var$e.apply(null, arguments);
}
window.__allCometMarqueeInstances || (window.__allCometMarqueeInstances = []);
var $7082d30e5438ab38$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function t(t, e) {
        if (void 0 === e && (e = {}), "string" == typeof t) this.containers = Array.from(document.querySelectorAll(t));
        else if (t instanceof HTMLElement) this.containers = [
            t
        ];
        else {
            if (!(t instanceof NodeList || Array.isArray(t))) throw new Error("CometMarquee: invalid selector");
            this.containers = Array.from(t);
        }
        this.instances = this.containers.map(function(t, i) {
            return new $7082d30e5438ab38$var$n(t, e, i);
        });
    }
    var e = t.prototype;
    return e.start = function() {
        this.instances.forEach(function(t) {
            return t.startAnimation();
        });
    }, e.stop = function() {
        this.instances.forEach(function(t) {
            return t.stop();
        });
    }, e.pause = function() {
        this.instances.forEach(function(t) {
            return t.pause();
        });
    }, e.resume = function() {
        this.instances.forEach(function(t) {
            return t.resume();
        });
    }, e.refresh = function() {
        this.instances.forEach(function(t) {
            return t.refresh();
        });
    }, e.addItem = function(t) {
        this.instances.forEach(function(e) {
            return e.addItem(t);
        });
    }, e.removeItem = function() {
        this.instances.forEach(function(t) {
            return t.removeItem();
        });
    }, e.destroy = function() {
        this.instances.forEach(function(t) {
            return t.destroy();
        });
    }, t;
}(), $7082d30e5438ab38$var$n = /*#__PURE__*/ function() {
    function i(t, e, i) {
        var n, s, o, a, r, h, c, l = this;
        if (void 0 === e && (e = {}), void 0 === i && (i = 0), this.animate = function(t) {
            if (l.isAnimating) {
                t || (t = performance.now());
                var e = (t - l.lastTime) / 1e3;
                if (l.lastTime = t, !l.isPaused) {
                    var i = l.loopWidth || l.contentWidth + l.options.gap;
                    l.options.reverse ? (l.currentTranslate += l.options.speed * e, l.currentTranslate >= -(l.prependWidth || 0) && (l.currentTranslate -= i, l.dispatchEvent("animation-cycle", {
                        direction: "reverse"
                    }))) : (l.currentTranslate -= l.options.speed * e, l.currentTranslate <= -i && (l.currentTranslate += i, l.dispatchEvent("animation-cycle", {
                        direction: "forward"
                    }))), l.content.style.transform = l.isVertical ? "translate3d(0," + l.currentTranslate + "px,0)" : "translate3d(" + l.currentTranslate + "px,0,0)";
                }
                l.animationId = requestAnimationFrame(l.animate);
            }
        }, this.container = t, this.content = t.querySelector(".comet-marquee-content"), this.items = Array.from(this.content.children).filter(function(t) {
            return !t.classList.contains("comet-marquee-clone");
        }), this.container.classList.contains("is-init-comet-marquee")) e.develop && console.warn("[CometMarquee #" + i + "] Already initialized. Skipping.");
        else {
            var d = getComputedStyle(this.content), u = parseFloat(d.gap || d.columnGap || "0");
            this.options = {
                speed: null != (n = e.speed) ? n : 50,
                gap: null != (s = e.gap) ? s : Number.isFinite(u) ? u : 0,
                pauseOnHover: !!e.pauseOnHover,
                pauseOnClick: !!e.pauseOnClick,
                adaptivePause: !!e.adaptivePause,
                reverse: !!e.reverse,
                initialShift: null != (o = e.initialShift) && o,
                pauseOnInvisible: !!e.pauseOnInvisible,
                syncPause: !!e.syncPause,
                repeatCount: null != (a = e.repeatCount) ? a : 3,
                develop: !!e.develop,
                forceAnimation: !!e.forceAnimation,
                forceAnimationWidth: null != (r = e.forceAnimationWidth) ? r : 2,
                fadeEdges: null != (h = e.fadeEdges) && h,
                fullWidth: !!e.fullWidth,
                vertical: !!e.vertical,
                height: null != (c = e.height) ? c : null
            }, this.isVertical = this.options.vertical, this.axis = this.isVertical ? "y" : "x", this.sizeProperty = this.isVertical ? "height" : "width", window.__allCometMarqueeInstances.push(this), this.isAnimating = !1, this.isPaused = !1, this.animationId = null, this.currentTranslate = 0, this.contentWidth = 0, this.containerWidth = 0, this.lastTime = 0, this.idx = i, this.io = null, this.ro = null, this._hoverPause = null, this._hoverResume = null, this._clickToggle = null, this._documentClick = null, this._resizeHandler = null, this._fadeEdgesResizeHandler = null, this._visibilityHandler = null, this._motionChangeHandler = null, this.forceAnimationEnabled = !1, this.lastContainerRectWidth = 0, this.lastWindowWidth = window.innerWidth, this.refreshTimeout = null, this.isRefreshing = !1, this.isInitializing = !1, this.resizeObserverCallCount = 0, this.lastResizeTimestamp = 0, this.contentSetup = !1, this._fullWidthResizeHandler = null, this._fullWidthDebounceTimeout = null, this._originalContainerStyles = null, this._initFallbackTimeout = null, this._refreshingGuardTimeout = null, this._orientationTimeout = null, this.init(), this.bindEvents();
        }
    }
    var n = i.prototype;
    return n.dispatchEvent = function(t, i) {
        void 0 === i && (i = {});
        var n = new CustomEvent("comet-marquee:" + t, {
            detail: $7082d30e5438ab38$var$e({
                instance: this,
                container: this.container
            }, i),
            bubbles: !0,
            cancelable: !0
        });
        this.container.dispatchEvent(n), this.options.develop && console.log("[CometMarquee #" + this.idx + "] " + t, i);
    }, n.getTotalSize = function() {
        var t = this, e = this.items.map(function(e) {
            var i = e.getBoundingClientRect();
            return t.isVertical ? i.height : i.width;
        });
        return e.length ? e.reduce(function(t, e) {
            return t + e;
        }, 0) + this.options.gap * (this.items.length - 1) : 0;
    }, n.calculateDimensions = function() {
        var t = this.container.getBoundingClientRect();
        this.containerWidth = t.width, this.containerHeight = t.height, this.containerSize = this.isVertical ? t.height : t.width, this.contentWidth = this.getTotalSize(), this.contentSize = this.contentWidth, this.contentSize <= 0 ? (this.shouldAnimate = !1, this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Content " + (this.isVertical ? "height" : "width") + " is 0. Animation disabled.")) : this.shouldAnimate = this.contentSize > this.containerSize + 1, this.options.forceAnimation && !this.shouldAnimate && this.contentSize > 0 ? (this.shouldAnimate = !0, this.forceAnimationEnabled = !0, this.dispatchEvent("force-animation-enabled", {
            originalContentSize: this.contentSize,
            containerSize: this.containerSize
        })) : this.forceAnimationEnabled = !1, this.dispatchEvent("dimensions-calculated", {
            containerWidth: this.containerWidth,
            containerHeight: this.containerHeight,
            containerSize: this.containerSize,
            contentSize: this.contentSize,
            shouldAnimate: this.shouldAnimate,
            forceAnimationEnabled: this.forceAnimationEnabled,
            isVertical: this.isVertical
        });
    }, n.calculateForceAnimationClones = function() {
        if (!this.forceAnimationEnabled || !this.items.length) return 0;
        var t = (this.isVertical ? window.innerHeight : window.innerWidth) * this.options.forceAnimationWidth, e = this.contentWidth, i = Math.min(Math.ceil(t / e), 20), n = Math.max(0, (i - 1) * this.items.length), s = Math.min(n, 100);
        return s < n && this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Clone count capped at 100 (would be " + n + ")"), this.dispatchEvent("force-animation-calculated", {
            targetSize: t,
            singleSetSize: e,
            setsNeeded: i,
            clonesNeeded: s,
            cappedFromOriginal: n
        }), s;
    }, n.applyFadeEdges = function() {
        var t = this.options.fadeEdges;
        if (!1 === t) return this.container.classList.remove("is-fade-edges"), void this.dispatchEvent("fade-edges-removed");
        if (!0 === t) return this.container.classList.add("is-fade-edges"), void this.dispatchEvent("fade-edges-applied", {
            condition: "always"
        });
        if ("number" == typeof t) {
            var e = window.innerWidth;
            e >= t ? (this.container.classList.add("is-fade-edges"), this.dispatchEvent("fade-edges-applied", {
                condition: "breakpoint",
                breakpoint: t,
                currentWidth: e
            })) : (this.container.classList.remove("is-fade-edges"), this.dispatchEvent("fade-edges-removed", {
                condition: "breakpoint",
                breakpoint: t,
                currentWidth: e
            }));
        }
    }, n.setupContent = function() {
        var t, e = this;
        if (this.content.style.willChange = "transform", this.content.querySelectorAll(".comet-marquee-clone").forEach(function(t) {
            return t.remove();
        }), !this.shouldAnimate) return this.content.style.transform = "translate3d(0,0,0)", this.isVertical ? this.content.style.height = "auto" : this.content.style.width = "auto", this.currentTranslate = 0, this.contentSetup = !1, void this.dispatchEvent("animation-not-needed");
        this.contentSetup = !0, this.dispatchEvent("clones-creating");
        var i = [];
        if (this.forceAnimationEnabled) {
            var n = this.calculateForceAnimationClones();
            t = Math.ceil(n / this.items.length);
            for(var s = document.createDocumentFragment(), o = 0; o < n; o++){
                var a = this.items[o % this.items.length].cloneNode(!0);
                a.classList.add("comet-marquee-clone"), s.appendChild(a), i.push(a);
            }
            this.content.appendChild(s);
        } else {
            var r = Math.max(this.containerWidth, window.innerWidth);
            t = Math.max(this.options.repeatCount, Math.ceil(r * this.options.repeatCount / this.contentWidth));
            for(var h = document.createDocumentFragment(), c = 0; c < t; c++)this.items.forEach(function(t) {
                var e = t.cloneNode(!0);
                e.classList.add("comet-marquee-clone"), h.appendChild(e), i.push(e);
            });
            this.content.appendChild(h);
        }
        var l = [];
        if (this.options.reverse) {
            for(var d = Math.max(this.containerWidth, window.innerWidth), u = Math.max(2, Math.ceil(d / this.contentWidth) + 1), m = document.createDocumentFragment(), p = 0; p < u; p++)this.items.forEach(function(t) {
                var e = t.cloneNode(!0);
                e.classList.add("comet-marquee-clone"), e.classList.add("comet-marquee-prepend"), m.appendChild(e), l.push(e);
            });
            this.content.insertBefore(m, this.content.firstChild);
        }
        this.dispatchEvent("clones-created", {
            cloneCount: i.length,
            prependedCount: l.length,
            repeatCount: t,
            forceAnimationEnabled: this.forceAnimationEnabled
        });
        var v = Array.from(this.content.children), f = v.length, g = v.reduce(function(t, i) {
            var n = i.getBoundingClientRect();
            return t + (e.isVertical ? n.height : n.width);
        }, 0) + this.options.gap * (f - 1);
        this.isVertical ? this.content.style.height = g + "px" : this.content.style.width = g + "px";
        var E = l.length > 0 ? l.reduce(function(t, i) {
            var n = i.getBoundingClientRect();
            return t + (e.isVertical ? n.height : n.width);
        }, 0) + this.options.gap * l.length : 0, w = 0;
        !0 === this.options.initialShift ? w = this.containerSize : "number" == typeof this.options.initialShift && (w = this.options.initialShift);
        var y = this.contentWidth + this.options.gap;
        this.loopWidth = y, this.prependWidth = E, this.currentTranslate = this.options.reverse ? -E - y + w : -w, this.content.style.transform = this.isVertical ? "translate3d(0," + this.currentTranslate + "px,0)" : "translate3d(" + this.currentTranslate + "px,0,0)", this.dispatchEvent("content-setup", {
            totalSize: g,
            initialTranslate: this.currentTranslate,
            forceAnimationEnabled: this.forceAnimationEnabled,
            isVertical: this.isVertical
        });
    }, n.init = function() {
        var t = this;
        this.isInitializing = !0, this.dispatchEvent("init-start"), this.container.classList.add("is-init-comet-marquee"), this.isVertical && (this.container.setAttribute("data-vertical", ""), null !== this.options.height ? this.container.style.setProperty("--comet-marquee-height", "number" == typeof this.options.height ? this.options.height + "px" : this.options.height) : this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Vertical mode without explicit height. Using CSS default (--comet-marquee-height: 300px).")), this.options.fullWidth && this.applyFullSize(), this.calculateDimensions(), this.setupContent(), this.applyFadeEdges(), this.startAnimation(), this.dispatchEvent("init-complete"), this.isInitializing = !1, this._initFallbackTimeout && clearTimeout(this._initFallbackTimeout), this._initFallbackTimeout = setTimeout(function() {
            t.isInitializing = !1, t._initFallbackTimeout = null;
        }, 300);
    }, n.applyFullSize = function() {
        var t = this;
        if (this.options.fullWidth) {
            this._originalContainerStyles || (this._originalContainerStyles = {
                width: this.container.style.width,
                height: this.container.style.height,
                maxWidth: this.container.style.maxWidth,
                maxHeight: this.container.style.maxHeight,
                marginLeft: this.container.style.marginLeft,
                marginTop: this.container.style.marginTop,
                position: this.container.style.position
            });
            var e = this.container.getBoundingClientRect();
            if (this.isVertical) {
                var i = e.top;
                this.container.style.height = "100vh", this.container.style.maxHeight = "100vh", this.container.style.marginTop = "-" + i + "px", this.dispatchEvent("fullsize-applied", {
                    offsetTop: i,
                    axis: "vertical"
                });
            } else {
                var n = e.left;
                this.container.style.width = "100vw", this.container.style.maxWidth = "100vw", this.container.style.marginLeft = "-" + n + "px", this.dispatchEvent("fullsize-applied", {
                    offsetLeft: n,
                    axis: "horizontal"
                });
            }
            "static" === getComputedStyle(this.container).position && (this.container.style.position = "relative"), this._fullWidthResizeHandler || (this._fullWidthResizeHandler = function() {
                t._fullWidthDebounceTimeout && clearTimeout(t._fullWidthDebounceTimeout), t._fullWidthDebounceTimeout = setTimeout(function() {
                    t.updateFullSize();
                }, 150);
            }, window.addEventListener("resize", this._fullWidthResizeHandler));
        }
    }, n.updateFullSize = function() {
        if (this.options.fullWidth) {
            var t, e, i, n;
            this.isVertical ? (this.container.style.height = (null == (t = this._originalContainerStyles) ? void 0 : t.height) || "", this.container.style.marginTop = (null == (e = this._originalContainerStyles) ? void 0 : e.marginTop) || "") : (this.container.style.width = (null == (i = this._originalContainerStyles) ? void 0 : i.width) || "", this.container.style.marginLeft = (null == (n = this._originalContainerStyles) ? void 0 : n.marginLeft) || "");
            var s = this.container.getBoundingClientRect();
            if (this.isVertical) {
                var o = s.top;
                this.container.style.height = "100vh", this.container.style.maxHeight = "100vh", this.container.style.marginTop = "-" + o + "px", this.dispatchEvent("fullsize-updated", {
                    offsetTop: o
                });
            } else {
                var a = s.left;
                this.container.style.width = "100vw", this.container.style.maxWidth = "100vw", this.container.style.marginLeft = "-" + a + "px", this.dispatchEvent("fullsize-updated", {
                    offsetLeft: a
                });
            }
        }
    }, n.startAnimation = function() {
        this.shouldAnimate ? (this.isAnimating = !0, this.isPaused = !1, this.lastTime = performance.now(), cancelAnimationFrame(this.animationId), this.dispatchEvent("animation-started"), this.animate()) : this.dispatchEvent("animation-skipped");
    }, n.pause = function(t) {
        var e = this;
        void 0 === t && (t = !0);
        var i = this.isPaused;
        this.isPaused = !0, i || this.dispatchEvent("animation-paused"), t && this.options.syncPause && window.__allCometMarqueeInstances && window.__allCometMarqueeInstances.forEach(function(t) {
            t !== e && (t.isPaused = !0);
        });
    }, n.resume = function(t) {
        var e = this;
        if (void 0 === t && (t = !0), this.isPaused || !this.contentSetup || !this.isAnimating) {
            if (this.calculateDimensions(), this.shouldAnimate && !this.contentSetup && (this.options.develop && console.log("[CometMarquee #" + this.idx + "] Resume: forcing content setup (width: " + this.contentWidth + ")"), this.setupContent()), this.shouldAnimate) {
                var i = this.isPaused;
                this.isPaused && (this.isPaused = !1, this.lastTime = performance.now(), this.isAnimating ? i && this.dispatchEvent("animation-resumed") : (this.isAnimating = !0, this.startAnimation())), t && this.options.syncPause && window.__allCometMarqueeInstances && window.__allCometMarqueeInstances.forEach(function(t) {
                    t !== e && t.isPaused && (t.calculateDimensions(), t.shouldAnimate && (t.isPaused = !1, t.lastTime = performance.now(), t.isAnimating || (t.isAnimating = !0, t.startAnimation())));
                });
            } else this.stop();
        }
    }, n.stop = function() {
        var t = this.isAnimating;
        this.isAnimating = !1, this.animationId && cancelAnimationFrame(this.animationId), this.animationId = null, t && this.dispatchEvent("animation-stopped");
    }, n.refresh = function() {
        var t = this;
        this.isRefreshing || this.isInitializing ? this.options.develop && console.warn("[CometMarquee #" + this.idx + "] Refresh blocked - already in progress") : (this.isRefreshing = !0, this.dispatchEvent("refresh-start"), this.stop(), this.items = Array.from(this.content.children).filter(function(t) {
            return !t.classList.contains("comet-marquee-clone");
        }), this.init(), this.dispatchEvent("refresh-complete"), this._refreshingGuardTimeout && clearTimeout(this._refreshingGuardTimeout), this._refreshingGuardTimeout = setTimeout(function() {
            t.isRefreshing = !1, t._refreshingGuardTimeout = null, t.options.develop && console.log("[CometMarquee #" + t.idx + "] Refresh guard cleared");
        }, 500));
    }, n.bindEvents = function() {
        var e = this;
        this.dispatchEvent("events-bound");
        var i = function() {
            var t = window.innerWidth >= 1024;
            e.container.removeEventListener("mouseenter", e._hoverPause), e.container.removeEventListener("mouseleave", e._hoverResume), e.container.removeEventListener("click", e._clickToggle), document.removeEventListener("click", e._documentClick), t ? (e._hoverPause = function() {
                e.dispatchEvent("hover-pause"), e.pause();
            }, e._hoverResume = function() {
                e.dispatchEvent("hover-resume"), e.resume();
            }, e.container.addEventListener("mouseenter", e._hoverPause), e.container.addEventListener("mouseleave", e._hoverResume)) : (e._clickToggle = function(t) {
                t.stopPropagation(), e.isPaused ? (e.dispatchEvent("click-resume"), e.resume()) : (e.dispatchEvent("click-pause"), e.pause());
            }, e._documentClick = function(t) {
                !e.container.contains(t.target) && e.isPaused && (e.dispatchEvent("outside-click-resume"), e.resume());
            }, e.container.addEventListener("click", e._clickToggle), document.addEventListener("click", e._documentClick));
        };
        this.options.adaptivePause ? (i(), this._resizeHandler = function() {
            e.dispatchEvent("adaptive-pause-resize"), i();
        }, window.addEventListener("resize", this._resizeHandler)) : (this.options.pauseOnHover && (this._hoverPause = function() {
            e.dispatchEvent("hover-pause"), e.pause();
        }, this._hoverResume = function() {
            e.dispatchEvent("hover-resume"), e.resume();
        }, this.container.addEventListener("mouseenter", this._hoverPause), this.container.addEventListener("mouseleave", this._hoverResume)), this.options.pauseOnClick && (this._clickToggle = function(t) {
            t.stopPropagation(), e.isPaused ? (e.dispatchEvent("click-resume"), e.resume()) : (e.dispatchEvent("click-pause"), e.pause());
        }, this._documentClick = function(t) {
            !e.container.contains(t.target) && e.isPaused && (e.dispatchEvent("outside-click-resume"), e.resume());
        }, this.container.addEventListener("click", this._clickToggle), document.addEventListener("click", this._documentClick))), this.options.pauseOnInvisible && (this.io = new IntersectionObserver(function(t) {
            t.forEach(function(t) {
                t.isIntersecting ? (e.dispatchEvent("visibility-resume"), e.resume(!1)) : (e.dispatchEvent("visibility-pause"), e.pause(!1));
            });
        }, {
            threshold: .1,
            rootMargin: "0px"
        }), this.io.observe(this.container)), this.ro = new ResizeObserver(function(i) {
            var n = performance.now();
            if (e.resizeObserverCallCount++, e.isRefreshing || e.isInitializing) e.options.develop && console.log("[CometMarquee #" + e.idx + "] RO blocked - refreshing/initializing");
            else {
                var s = n - e.lastResizeTimestamp;
                if (s < 50) e.options.develop && console.warn("[CometMarquee #" + e.idx + "] RO call too rapid (" + s.toFixed(1) + "ms) - ignoring");
                else {
                    if (e.lastResizeTimestamp = n, e.resizeObserverCallCount > 100) return console.error("[CometMarquee #" + e.idx + "] ResizeObserver loop detected! Disconnecting to prevent crash."), void e.ro.disconnect();
                    for(var o, a = e.isVertical ? window.innerHeight : window.innerWidth, r = a !== e.lastWindowWidth, h = !1, c = function(e) {
                        var i = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (i) return (i = i.call(e)).next.bind(i);
                        if (Array.isArray(e) || (i = function(e, i) {
                            if (e) {
                                if ("string" == typeof e) return $7082d30e5438ab38$var$t(e, i);
                                var n = ({}).toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $7082d30e5438ab38$var$t(e, i) : void 0;
                            }
                        }(e))) {
                            i && (e = i);
                            var n = 0;
                            return function() {
                                return n >= e.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e[n++]
                                };
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }(i); !(o = c()).done;){
                        var l = o.value, d = Math.round(e.isVertical ? l.contentRect.height : l.contentRect.width);
                        if (0 === e.lastContainerRectWidth) return e.lastContainerRectWidth = d, void (e.options.develop && console.log("[CometMarquee #" + e.idx + "] Initial " + (e.isVertical ? "height" : "width") + ": " + d + "px"));
                        var u = Math.abs(d - e.lastContainerRectWidth);
                        if (u < 5) return void (e.options.develop && console.log("[CometMarquee #" + e.idx + "] Size change too small (" + u + "px) - ignoring"));
                        if (!r && u < 10) return void (e.options.develop && console.log("[CometMarquee #" + e.idx + "] Internal size change without window resize - ignoring"));
                        e.options.develop && console.log("[CometMarquee #" + e.idx + "] " + (e.isVertical ? "Height" : "Width") + ": " + e.lastContainerRectWidth + "px \u2192 " + d + "px (window: " + r + ")"), e.lastContainerRectWidth = d, h = !0;
                    }
                    (h || r) && (e.lastWindowWidth = a, e.dispatchEvent("container-resized"), e.applyFadeEdges(), e._refreshTimeout && clearTimeout(e._refreshTimeout), e._refreshTimeout = setTimeout(function() {
                        e.resizeObserverCallCount = 0, e.refresh();
                    }, 300));
                }
            }
        }), this.ro.observe(this.container), this._orientationChangeHandler = function() {
            e.dispatchEvent("orientation-change"), e._orientationTimeout && clearTimeout(e._orientationTimeout), e._orientationTimeout = setTimeout(function() {
                e._orientationTimeout = null, e.applyFadeEdges(), e.refresh();
            }, 200);
        }, window.addEventListener("orientationchange", this._orientationChangeHandler), this._fadeEdgesResizeHandler = function() {
            e.applyFadeEdges();
        }, window.addEventListener("resize", this._fadeEdgesResizeHandler), this._visibilityHandler = function() {
            "visible" === document.visibilityState ? e.options.pauseOnInvisible && (e.dispatchEvent("document-visible"), e.resume(!1)) : e.options.pauseOnInvisible && (e.dispatchEvent("document-hidden"), e.pause(!1));
        }, document.addEventListener("visibilitychange", this._visibilityHandler);
        var n = window.matchMedia("(prefers-reduced-motion: reduce)");
        this._motionChangeHandler = function() {
            n.matches ? (e.dispatchEvent("reduced-motion-on"), e.pause(!1)) : (e.dispatchEvent("reduced-motion-off"), e.resume(!1));
        }, n.matches && this.pause(!1), n.addEventListener && n.addEventListener("change", this._motionChangeHandler);
    }, n.addItem = function(t) {
        this.dispatchEvent("item-adding", {
            itemHtml: t
        });
        var e = document.createElement("div");
        e.innerHTML = t;
        var i = e.firstElementChild, n = this.content.querySelector(".comet-marquee-clone");
        n ? this.content.insertBefore(i, n) : this.content.appendChild(i), this.refresh(), this.dispatchEvent("item-added", {
            newItem: i
        });
    }, n.removeItem = function() {
        var t = Array.from(this.content.children).filter(function(t) {
            return !t.classList.contains("comet-marquee-clone");
        });
        if (t.length > 0) {
            var e = t[t.length - 1];
            this.dispatchEvent("item-removing", {
                removedItem: e
            }), e.remove(), this.refresh(), this.dispatchEvent("item-removed");
        }
    }, n.destroy = function() {
        if (this.dispatchEvent("destroy-start"), this.stop(), this._refreshTimeout && clearTimeout(this._refreshTimeout), this._initFallbackTimeout && clearTimeout(this._initFallbackTimeout), this._refreshingGuardTimeout && clearTimeout(this._refreshingGuardTimeout), this._orientationTimeout && clearTimeout(this._orientationTimeout), window.__allCometMarqueeInstances) {
            var t = window.__allCometMarqueeInstances.indexOf(this);
            t > -1 && window.__allCometMarqueeInstances.splice(t, 1);
        }
        this.io && this.io.disconnect(), this.ro && this.ro.disconnect(), this.container.removeEventListener("mouseenter", this._hoverPause), this.container.removeEventListener("mouseleave", this._hoverResume), this.container.removeEventListener("click", this._clickToggle), document.removeEventListener("click", this._documentClick), window.removeEventListener("resize", this._resizeHandler), window.removeEventListener("resize", this._fadeEdgesResizeHandler), window.removeEventListener("orientationchange", this._orientationChangeHandler), document.removeEventListener("visibilitychange", this._visibilityHandler), this._fullWidthResizeHandler && window.removeEventListener("resize", this._fullWidthResizeHandler), this._fullWidthDebounceTimeout && clearTimeout(this._fullWidthDebounceTimeout), this._originalContainerStyles && (this.container.style.width = this._originalContainerStyles.width, this.container.style.height = this._originalContainerStyles.height, this.container.style.maxWidth = this._originalContainerStyles.maxWidth, this.container.style.maxHeight = this._originalContainerStyles.maxHeight, this.container.style.marginLeft = this._originalContainerStyles.marginLeft, this.container.style.marginTop = this._originalContainerStyles.marginTop, this.container.style.position = this._originalContainerStyles.position), this.isVertical && this.container.removeAttribute("data-vertical");
        var e = window.matchMedia("(prefers-reduced-motion: reduce)");
        e.removeEventListener && e.removeEventListener("change", this._motionChangeHandler), this.dispatchEvent("destroy-complete");
    }, i;
}();
"undefined" != typeof window && (window.cometMarquee && window.cometMarquee.CometMarquee ? window.CometMarquee = window.cometMarquee.CometMarquee : window.CometMarquee = $7082d30e5438ab38$export$2e2bcd8739ae039);
 //# sourceMappingURL=comet-marquee.modern.js.map



window.initClientsMarquee = function initClientsMarquee1() {
    const clientsMarqueeElsArr = document.querySelectorAll('.text-sec__tech-marquee');
    if (clientsMarqueeElsArr.length) clientsMarqueeElsArr.forEach((marqueeEl, idx)=>{
        const marquee = new (0, $7082d30e5438ab38$export$2e2bcd8739ae039)(marqueeEl, {
            speed: 60,
            adaptivePause: true,
            reverse: idx % 2 === 1,
            pauseOnInvisible: true,
            initialShift: false
        });
    });
};
if (!document.querySelector('.bold-loader-new')) initClientsMarquee();




window.initHighlightsMarquee = function initHighlightsMarquee1() {
    const clientsMarqueeElsArr = document.querySelectorAll('.highlights-marquee');
    if (clientsMarqueeElsArr.length) clientsMarqueeElsArr.forEach((marqueeEl, idx)=>{
        const marquee = new (0, $7082d30e5438ab38$export$2e2bcd8739ae039)(marqueeEl, {
            speed: 40,
            pauseOnHover: true,
            initialShift: window.innerWidth >= 1033,
            pauseOnInvisible: true,
            syncPause: false,
            repeatCount: 5,
            reverse: idx % 2 === 1,
            forceAnimation: window.innerWidth >= 1033,
            forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
            fullWidth: window.innerWidth >= 1033
        });
    });
};
if (!document.querySelector('.bold-loader-new')) initHighlightsMarquee();




const $13b9712cae62b7e4$var$initializedMarquees = new WeakSet();
window.initTrustpilotMarquee = function initTrustpilotMarquee1() {
    const trustpilotMarqueeElsArr = document.querySelectorAll('.trustpilot-reviews-marquee');
    if (trustpilotMarqueeElsArr.length) trustpilotMarqueeElsArr.forEach((marqueeEl, idx)=>{
        if ($13b9712cae62b7e4$var$initializedMarquees.has(marqueeEl) || !marqueeEl.querySelector('.comet-marquee-item')) return;
        $13b9712cae62b7e4$var$initializedMarquees.add(marqueeEl);
        marqueeEl.addEventListener('comet-marquee:clones-created', ()=>{
            marqueeEl.querySelectorAll('.comet-marquee-clone .dir-control[data-dir-init]').forEach((button)=>{
                const label = button.querySelector('.dir-control__label');
                if (label) {
                    button.innerHTML = label.innerHTML;
                    delete button.dataset.dirInit;
                }
            });
            window.dirControlBtnInit?.();
        });
        new (0, $7082d30e5438ab38$export$2e2bcd8739ae039)(marqueeEl, {
            speed: 30,
            pauseOnHover: true,
            initialShift: window.innerWidth >= 1033,
            pauseOnInvisible: true,
            syncPause: false,
            repeatCount: 5,
            reverse: idx % 2 === 1,
            forceAnimation: window.innerWidth >= 1033,
            forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
            fullWidth: window.innerWidth >= 1033
        });
    });
};
if (!document.querySelector('.bold-loader-new')) initTrustpilotMarquee();


const $ff5fc97cf8c86ba6$var$initializedSections = new WeakSet();
const $ff5fc97cf8c86ba6$var$getSections = (scope)=>{
    if (!scope?.querySelectorAll) return [];
    if (scope.matches?.('.trustpilot-reviews-sec')) return [
        scope
    ];
    return Array.from(scope.querySelectorAll('.trustpilot-reviews-sec'));
};
const $ff5fc97cf8c86ba6$var$revealSection = (section)=>{
    section.classList.add('is-visible');
};
function $ff5fc97cf8c86ba6$export$448b949fd7d804ab(scope = document) {
    $ff5fc97cf8c86ba6$var$getSections(scope).forEach((section)=>{
        if ($ff5fc97cf8c86ba6$var$initializedSections.has(section)) return;
        $ff5fc97cf8c86ba6$var$initializedSections.add(section);
        const bg = section.querySelector('.trustpilot-reviews-sec__bg');
        const backgroundLayer = section.parentElement?.querySelector('[data-trustpilot-reviews-bg]');
        if (backgroundLayer) {
            const container = section.parentElement;
            let frame = null;
            const updateBackgroundLayer = ()=>{
                if (frame !== null) return;
                frame = window.requestAnimationFrame(()=>{
                    frame = null;
                    backgroundLayer.style.setProperty('--trustpilot-reviews-bg-top', `${section.offsetTop}px`);
                    backgroundLayer.style.setProperty('--trustpilot-reviews-bg-height', `${section.offsetHeight}px`);
                });
            };
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver(updateBackgroundLayer);
                resizeObserver.observe(container);
                resizeObserver.observe(section);
            } else window.addEventListener('resize', updateBackgroundLayer, {
                passive: true
            });
            updateBackgroundLayer();
        }
        if (!bg || typeof IntersectionObserver === 'undefined') {
            $ff5fc97cf8c86ba6$var$revealSection(section);
            return;
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                $ff5fc97cf8c86ba6$var$revealSection(section);
                observer.unobserve(section);
            });
        }, {
            rootMargin: '0px 0px -18% 0px',
            threshold: 0.2
        });
        observer.observe(section);
    });
}
globalThis.initTrustpilotReviews = $ff5fc97cf8c86ba6$export$448b949fd7d804ab;
if (typeof document !== 'undefined' && !document.querySelector('.bold-loader-new')) $ff5fc97cf8c86ba6$export$448b949fd7d804ab();


const $c80aaccd10810ca1$var$initializedSections = new WeakSet();
const $c80aaccd10810ca1$var$initWhatWeDoAccordion = (scope = document)=>{
    const sections = scope.querySelectorAll('.what-we-do-sec');
    sections.forEach((section)=>{
        if ($c80aaccd10810ca1$var$initializedSections.has(section)) return;
        const accordion = section.querySelector('[data-what-we-do-accordion]');
        const mediaStage = section.querySelector('.what-we-do-sec__media');
        const items = Array.from(section.querySelectorAll('.what-we-do-sec__item'));
        const mediaItems = Array.from(section.querySelectorAll('.what-we-do-sec__media-picture'));
        const mobileSlots = new Map(items.map((item, index)=>{
            const mediaIndex = Number(item.dataset.whatWeDoItem);
            const slot = item.querySelector('[data-what-we-do-mobile-slot]');
            return [
                Number.isNaN(mediaIndex) ? index : mediaIndex,
                slot
            ];
        }).filter(([, slot])=>slot));
        const mobileMediaQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 1023px)') : null;
        if (!accordion || !items.length) return;
        $c80aaccd10810ca1$var$initializedSections.add(section);
        let isMobileLayout = false;
        const getMediaIndex = (element, fallbackIndex, dataAttribute)=>{
            const mediaIndex = Number(element.dataset[dataAttribute]);
            return Number.isNaN(mediaIndex) ? fallbackIndex : mediaIndex;
        };
        const updateMobileMediaHeight = ()=>{
            if (!isMobileLayout) return;
            mobileSlots.forEach((slot)=>{
                slot.style.setProperty('--what-we-do-mobile-media-height', `${slot.getBoundingClientRect().width}px`);
            });
        };
        const moveMediaToMobileSlots = ()=>{
            mediaItems.forEach((media, index)=>{
                const mediaIndex = getMediaIndex(media, index, 'whatWeDoMedia');
                const mobileSlot = mobileSlots.get(mediaIndex);
                if (mobileSlot) mobileSlot.append(media);
            });
        };
        const restoreMediaStage = ()=>{
            if (mediaStage) mediaStage.append(...mediaItems);
            mobileSlots.forEach((slot)=>{
                slot.style.removeProperty('--what-we-do-mobile-media-height');
            });
        };
        const syncMediaLayout = ()=>{
            const shouldUseMobileLayout = Boolean(mobileMediaQuery?.matches);
            if (shouldUseMobileLayout && !isMobileLayout) {
                moveMediaToMobileSlots();
                isMobileLayout = true;
            } else if (!shouldUseMobileLayout && isMobileLayout) {
                restoreMediaStage();
                isMobileLayout = false;
            }
            updateMobileMediaHeight();
        };
        const updatePanelHeight = (item)=>{
            const panel = item.querySelector('.what-we-do-sec__panel');
            if (!panel) return;
            panel.style.setProperty('--what-we-do-panel-height', `${panel.scrollHeight}px`);
        };
        const setItemState = (item, isActive)=>{
            const toggle = item.querySelector('.what-we-do-sec__toggle');
            const panel = item.querySelector('.what-we-do-sec__panel');
            item.classList.toggle('is-active', isActive);
            if (toggle) toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            if (panel) panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            if (isActive) updatePanelHeight(item);
        };
        const setActiveItem = (activeItem)=>{
            const activeIndex = items.indexOf(activeItem);
            const mediaIndex = getMediaIndex(activeItem, activeIndex, 'whatWeDoItem');
            items.forEach((item)=>{
                setItemState(item, item === activeItem);
            });
            mediaItems.forEach((media, index)=>{
                media.classList.toggle('is-active', getMediaIndex(media, index, 'whatWeDoMedia') === mediaIndex);
            });
            updateMobileMediaHeight();
        };
        const currentItem = items.find((item)=>item.classList.contains('is-active')) || items[0];
        requestAnimationFrame(()=>{
            syncMediaLayout();
            setActiveItem(currentItem);
        });
        accordion.addEventListener('click', (event)=>{
            const toggle = event.target.closest('.what-we-do-sec__toggle');
            if (!toggle || !accordion.contains(toggle)) return;
            const item = toggle.closest('.what-we-do-sec__item');
            if (!item || item.classList.contains('is-active')) return;
            setActiveItem(item);
        });
        let resizeFrame = 0;
        const updateActivePanel = ()=>{
            if (resizeFrame) cancelAnimationFrame(resizeFrame);
            resizeFrame = requestAnimationFrame(()=>{
                syncMediaLayout();
                const activeItem = items.find((item)=>item.classList.contains('is-active'));
                if (activeItem) updatePanelHeight(activeItem);
                resizeFrame = 0;
            });
        };
        window.addEventListener('resize', updateActivePanel, {
            passive: true
        });
        if (mobileMediaQuery) {
            const handleMediaQueryChange = ()=>{
                syncMediaLayout();
                updateActivePanel();
            };
            if (typeof mobileMediaQuery.addEventListener === 'function') mobileMediaQuery.addEventListener('change', handleMediaQueryChange);
            else if (typeof mobileMediaQuery.addListener === 'function') mobileMediaQuery.addListener(handleMediaQueryChange);
        }
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(updateActivePanel);
            items.forEach((item)=>{
                const text = item.querySelector('.what-we-do-sec__text');
                if (text) resizeObserver.observe(text);
            });
            resizeObserver.observe(accordion);
            section.whatWeDoResizeObserver = resizeObserver;
        }
    });
};
$c80aaccd10810ca1$var$initWhatWeDoAccordion();
window.initWhatWeDoAccordion = $c80aaccd10810ca1$var$initWhatWeDoAccordion;



const $2bcbd4aff6a50c28$var$mobileExpertiseMediaQuery = '(max-width: 640px)';
const $2bcbd4aff6a50c28$var$initializedWrappers = new WeakSet();
const $2bcbd4aff6a50c28$var$hydrateSlide = (slide)=>{
    if (!slide || slide.dataset.expertiseMobileLoaded === 'true') return;
    slide.querySelectorAll('source[data-srcset]').forEach((source)=>{
        source.srcset = source.dataset.srcset;
        delete source.dataset.srcset;
    });
    slide.querySelectorAll('img[data-src]').forEach((image)=>{
        image.src = image.dataset.src;
        delete image.dataset.src;
    });
    slide.dataset.expertiseMobileLoaded = 'true';
};
const $2bcbd4aff6a50c28$var$hydrateVisibleSlides = (swiper)=>{
    const slides = Array.from(swiper.slides || []);
    if (!slides.length) return;
    const visibleIndices = [
        swiper.activeIndex,
        swiper.activeIndex - 1,
        swiper.activeIndex + 1
    ];
    visibleIndices.forEach((index)=>{
        $2bcbd4aff6a50c28$var$hydrateSlide(slides[(index + slides.length) % slides.length]);
    });
};
const $2bcbd4aff6a50c28$var$initExpertiseMobileSwiper = (scope = document)=>{
    const wrappers = scope.matches?.('[data-expertise-mobile-swiper]') ? [
        scope
    ] : Array.from(scope.querySelectorAll('[data-expertise-mobile-swiper]'));
    wrappers.forEach((wrapper)=>{
        if ($2bcbd4aff6a50c28$var$initializedWrappers.has(wrapper)) return;
        const swiperEl = wrapper.querySelector('.swiper');
        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');
        const mobileMediaQuery = window.matchMedia($2bcbd4aff6a50c28$var$mobileExpertiseMediaQuery);
        if (!swiperEl || !nextEl || !prevEl) return;
        $2bcbd4aff6a50c28$var$initializedWrappers.add(wrapper);
        let observer = null;
        let swiper = null;
        const createSwiper = ()=>{
            if (swiper || !mobileMediaQuery.matches) return;
            swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(swiperEl, {
                modules: [
                    (0, $d6a8de0ae0918423$export$2e2bcd8739ae039),
                    (0, $8873c9004bc371bc$export$2e2bcd8739ae039),
                    (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
                ],
                slidesPerView: 1,
                speed: 460,
                threshold: 10,
                watchOverflow: true,
                rewind: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                on: {
                    afterInit: $2bcbd4aff6a50c28$var$hydrateVisibleSlides,
                    slideChangeTransitionStart: $2bcbd4aff6a50c28$var$hydrateVisibleSlides
                }
            });
        };
        const observeWrapper = ()=>{
            if (!mobileMediaQuery.matches || swiper || observer) return;
            if (typeof window.IntersectionObserver !== 'function') {
                createSwiper();
                return;
            }
            observer = new window.IntersectionObserver((entries)=>{
                if (!entries.some((entry)=>entry.isIntersecting)) return;
                observer.unobserve(wrapper);
                observer.disconnect();
                observer = null;
                createSwiper();
            }, {
                rootMargin: '300px 0px',
                threshold: 0.01
            });
            observer.observe(wrapper);
        };
        const handleMediaQueryChange = ()=>{
            if (mobileMediaQuery.matches) {
                observeWrapper();
                return;
            }
            observer?.disconnect();
            observer = null;
            swiper?.destroy(true, true);
            swiper = null;
        };
        mobileMediaQuery.addEventListener('change', handleMediaQueryChange);
        observeWrapper();
    });
};
$2bcbd4aff6a50c28$var$initExpertiseMobileSwiper();
window.initExpertiseMobileSwiper = $2bcbd4aff6a50c28$var$initExpertiseMobileSwiper;


var $4f41718f1a00a7f9$exports = {};
(function(global, factory) {
    $4f41718f1a00a7f9$exports = factory();
})($4f41718f1a00a7f9$exports, function() {
    'use strict';
    var root = document;
    var createText = root.createTextNode.bind(root);
    /**
 * # setProperty
 * Apply a CSS var
 * @param {HTMLElement} el
 * @param {string} varName 
 * @param {string|number} value 
 */ function setProperty(el, varName, value) {
        el.style.setProperty(varName, value);
    }
    /**
 * 
 * @param {!HTMLElement} el 
 * @param {!HTMLElement} child 
 */ function appendChild(el, child) {
        return el.appendChild(child);
    }
    /**
 * 
 * @param {!HTMLElement} parent 
 * @param {string} key 
 * @param {string} text 
 * @param {boolean} whitespace 
 */ function createElement(parent, key, text, whitespace) {
        var el = root.createElement('span');
        key && (el.className = key);
        if (text) {
            !whitespace && el.setAttribute("data-" + key, text);
            el.textContent = text;
        }
        return parent && appendChild(parent, el) || el;
    }
    /**
 * 
 * @param {!HTMLElement} el 
 * @param {string} key 
 */ function getData(el, key) {
        return el.getAttribute("data-" + key);
    }
    /**
 * 
 * @param {import('../types').Target} e 
 * @param {!HTMLElement} parent
 * @returns {!Array<!HTMLElement>}
 */ function $(e, parent) {
        return !e || e.length == 0 ? [] : e.nodeName ? [
            e
        ] : [].slice.call(e[0].nodeName ? e : (parent || root).querySelectorAll(e));
    }
    /**
 * Creates and fills an array with the value provided
 * @param {number} len
 * @param {() => T} valueProvider
 * @return {T}
 * @template T
 */ function Array2D(len) {
        var a = [];
        for(; len--;)a[len] = [];
        return a;
    }
    /**
 * A for loop wrapper used to reduce js minified size.
 * @param {!Array<T>} items 
 * @param {function(T):void} consumer
 * @template T
 */ function each(items, consumer) {
        items && items.some(consumer);
    }
    /**
 * @param {T} obj 
 * @return {function(string):*}
 * @template T
 */ function selectFrom(obj) {
        return function(key) {
            return obj[key];
        };
    }
    /**
 * # Splitting.index
 * Index split elements and add them to a Splitting instance.
 *
 * @param {HTMLElement} element
 * @param {string} key 
 * @param {!Array<!HTMLElement> | !Array<!Array<!HTMLElement>>} items 
 */ function index(element, key, items) {
        var prefix = '--' + key;
        var cssVar = prefix + "-index";
        each(items, function(items, i) {
            if (Array.isArray(items)) each(items, function(item) {
                setProperty(item, cssVar, i);
            });
            else setProperty(items, cssVar, i);
        });
        setProperty(element, prefix + "-total", items.length);
    }
    /**
 * @type {Record<string, import('./types').ISplittingPlugin>}
 */ var plugins = {};
    /**
 * @param {string} by
 * @param {string} parent
 * @param {!Array<string>} deps
 * @return {!Array<string>}
 */ function resolvePlugins(by, parent, deps) {
        // skip if already visited this dependency
        var index = deps.indexOf(by);
        if (index == -1) {
            // if new to dependency array, add to the beginning
            deps.unshift(by);
            // recursively call this function for all dependencies
            var plugin = plugins[by];
            if (!plugin) throw new Error("plugin not loaded: " + by);
            each(plugin.depends, function(p) {
                resolvePlugins(p, by, deps);
            });
        } else {
            // if this dependency was added already move to the left of
            // the parent dependency so it gets loaded in order
            var indexOfParent = deps.indexOf(parent);
            deps.splice(index, 1);
            deps.splice(indexOfParent, 0, by);
        }
        return deps;
    }
    /**
 * Internal utility for creating plugins... essentially to reduce
 * the size of the library
 * @param {string} by 
 * @param {string} key 
 * @param {string[]} depends 
 * @param {Function} split 
 * @returns {import('./types').ISplittingPlugin}
 */ function createPlugin(by, depends, key, split) {
        return {
            by: by,
            depends: depends,
            key: key,
            split: split
        };
    }
    /**
 *
 * @param {string} by
 * @returns {import('./types').ISplittingPlugin[]}
 */ function resolve(by) {
        return resolvePlugins(by, 0, []).map(selectFrom(plugins));
    }
    /**
 * Adds a new plugin to splitting
 * @param {import('./types').ISplittingPlugin} opts
 */ function add(opts) {
        plugins[opts.by] = opts;
    }
    /**
 * # Splitting.split
 * Split an element's textContent into individual elements
 * @param {!HTMLElement} el  Element to split
 * @param {string} key 
 * @param {string} splitOn 
 * @param {boolean} includePrevious 
 * @param {boolean} preserveWhitespace
 * @return {!Array<!HTMLElement>}
 */ function splitText(el, key, splitOn, includePrevious, preserveWhitespace) {
        // Combine any strange text nodes or empty whitespace.
        el.normalize();
        // Use fragment to prevent unnecessary DOM thrashing.
        var elements = [];
        var F = document.createDocumentFragment();
        if (includePrevious) elements.push(el.previousSibling);
        var allElements = [];
        $(el.childNodes).some(function(next) {
            if (next.tagName && !next.hasChildNodes()) {
                // keep elements without child nodes (no text and no children)
                allElements.push(next);
                return;
            }
            // Recursively run through child nodes
            if (next.childNodes && next.childNodes.length) {
                allElements.push(next);
                elements.push.apply(elements, splitText(next, key, splitOn, includePrevious, preserveWhitespace));
                return;
            }
            // Get the text to split, trimming out the whitespace
            /** @type {string} */ var wholeText = next.wholeText || '';
            var contents = wholeText.trim();
            // If there's no text left after trimming whitespace, continue the loop
            if (contents.length) {
                // insert leading space if there was one
                if (wholeText[0] === ' ') allElements.push(createText(' '));
                // Concatenate the split text children back into the full array
                var useSegmenter = splitOn === "" && typeof Intl.Segmenter === "function";
                each(useSegmenter ? Array.from(new Intl.Segmenter().segment(contents)).map(function(x) {
                    return x.segment;
                }) : contents.split(splitOn), function(splitText, i) {
                    if (i && preserveWhitespace) allElements.push(createElement(F, "whitespace", " ", preserveWhitespace));
                    var splitEl = createElement(F, key, splitText);
                    elements.push(splitEl);
                    allElements.push(splitEl);
                });
                // insert trailing space if there was one
                if (wholeText[wholeText.length - 1] === ' ') allElements.push(createText(' '));
            }
        });
        each(allElements, function(el) {
            appendChild(F, el);
        });
        // Clear out the existing element
        el.innerHTML = "";
        appendChild(el, F);
        return elements;
    }
    /** an empty value */ var _ = 0;
    function copy(dest, src) {
        for(var k in src)dest[k] = src[k];
        return dest;
    }
    var WORDS = 'words';
    var wordPlugin = createPlugin(/* by= */ WORDS, /* depends= */ _, /* key= */ 'word', /* split= */ function(el) {
        return splitText(el, 'word', /\s+/, 0, 1);
    });
    var CHARS = "chars";
    var charPlugin = createPlugin(/* by= */ CHARS, /* depends= */ [
        WORDS
    ], /* key= */ "char", /* split= */ function(el, options, ctx) {
        var results = [];
        each(ctx[WORDS], function(word, i) {
            results.push.apply(results, splitText(word, "char", "", options.whitespace && i));
        });
        return results;
    });
    /**
 * # Splitting
 * 
 * @param {import('./types').ISplittingOptions} opts
 * @return {!Array<*>}
 */ function Splitting(opts) {
        opts = opts || {};
        var key = opts.key;
        return $(opts.target || '[data-splitting]').map(function(el) {
            var ctx = el["\uD83C\uDF4C"];
            if (!opts.force && ctx) return ctx;
            ctx = el["\uD83C\uDF4C"] = {
                el: el
            };
            var by = opts.by || getData(el, 'splitting');
            if (!by || by == 'true') by = CHARS;
            var items = resolve(by);
            var opts2 = copy({}, opts);
            each(items, function(plugin) {
                if (plugin.split) {
                    var pluginBy = plugin.by;
                    var key2 = (key ? '-' + key : '') + plugin.key;
                    var results = plugin.split(el, opts2, ctx);
                    key2 && index(el, key2, results);
                    ctx[pluginBy] = results;
                    el.classList.add(pluginBy);
                }
            });
            el.classList.add('splitting');
            return ctx;
        });
    }
    /**
 * # Splitting.html
 * 
 * @param {import('./types').ISplittingOptions} opts
 */ function html(opts) {
        opts = opts || {};
        var parent = opts.target = createElement();
        parent.innerHTML = opts.content;
        Splitting(opts);
        return parent.outerHTML;
    }
    Splitting.html = html;
    Splitting.add = add;
    /**
 * Detects the grid by measuring which elements align to a side of it.
 * @param {!HTMLElement} el 
 * @param {import('../core/types').ISplittingOptions} options
 * @param {*} side 
 */ function detectGrid(el, options, side) {
        var items = $(options.matching || el.children, el);
        var c = {};
        each(items, function(w) {
            var val = Math.round(w[side]);
            (c[val] || (c[val] = [])).push(w);
        });
        return Object.keys(c).map(Number).sort(byNumber).map(selectFrom(c));
    }
    /**
 * Sorting function for numbers.
 * @param {number} a 
 * @param {number} b
 * @return {number} 
 */ function byNumber(a, b) {
        return a - b;
    }
    var linePlugin = createPlugin(/* by= */ 'lines', /* depends= */ [
        WORDS
    ], /* key= */ 'line', /* split= */ function(el, options, ctx) {
        return detectGrid(el, {
            matching: ctx[WORDS]
        }, 'offsetTop');
    });
    var itemPlugin = createPlugin(/* by= */ 'items', /* depends= */ _, /* key= */ 'item', /* split= */ function(el, options) {
        return $(options.matching || el.children, el);
    });
    var rowPlugin = createPlugin(/* by= */ 'rows', /* depends= */ _, /* key= */ 'row', /* split= */ function(el, options) {
        return detectGrid(el, options, "offsetTop");
    });
    var columnPlugin = createPlugin(/* by= */ 'cols', /* depends= */ _, /* key= */ "col", /* split= */ function(el, options) {
        return detectGrid(el, options, "offsetLeft");
    });
    var gridPlugin = createPlugin(/* by= */ 'grid', /* depends= */ [
        'rows',
        'cols'
    ]);
    var LAYOUT = "layout";
    var layoutPlugin = createPlugin(/* by= */ LAYOUT, /* depends= */ _, /* key= */ _, /* split= */ function(el, opts) {
        // detect and set options
        var rows = opts.rows = +(opts.rows || getData(el, 'rows') || 1);
        var columns = opts.columns = +(opts.columns || getData(el, 'columns') || 1);
        // Seek out the first <img> if the value is true 
        opts.image = opts.image || getData(el, 'image') || el.currentSrc || el.src;
        if (opts.image) {
            var img = $("img", el)[0];
            opts.image = img && (img.currentSrc || img.src);
        }
        // add optional image to background
        if (opts.image) setProperty(el, "background-image", "url(" + opts.image + ")");
        var totalCells = rows * columns;
        var elements = [];
        var container = createElement(_, "cell-grid");
        while(totalCells--){
            // Create a span
            var cell = createElement(container, "cell");
            createElement(cell, "cell-inner");
            elements.push(cell);
        }
        // Append elements back into the parent
        appendChild(el, container);
        return elements;
    });
    var cellRowPlugin = createPlugin(/* by= */ "cellRows", /* depends= */ [
        LAYOUT
    ], /* key= */ "row", /* split= */ function(el, opts, ctx) {
        var rowCount = opts.rows;
        var result = Array2D(rowCount);
        each(ctx[LAYOUT], function(cell, i, src) {
            result[Math.floor(i / (src.length / rowCount))].push(cell);
        });
        return result;
    });
    var cellColumnPlugin = createPlugin(/* by= */ "cellColumns", /* depends= */ [
        LAYOUT
    ], /* key= */ "col", /* split= */ function(el, opts, ctx) {
        var columnCount = opts.columns;
        var result = Array2D(columnCount);
        each(ctx[LAYOUT], function(cell, i) {
            result[i % columnCount].push(cell);
        });
        return result;
    });
    var cellPlugin = createPlugin(/* by= */ "cells", /* depends= */ [
        'cellRows',
        'cellColumns'
    ], /* key= */ "cell", /* split= */ function(el, opt, ctx) {
        // re-index the layout as the cells
        return ctx[LAYOUT];
    });
    // install plugins
    // word/char plugins
    add(wordPlugin);
    add(charPlugin);
    add(linePlugin);
    // grid plugins
    add(itemPlugin);
    add(rowPlugin);
    add(columnPlugin);
    add(gridPlugin);
    // cell-layout plugins
    add(layoutPlugin);
    add(cellRowPlugin);
    add(cellColumnPlugin);
    add(cellPlugin);
    return Splitting;
});


const $bd0377e4b39d9902$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.min(Math.max(value, min), max);
const $bd0377e4b39d9902$export$fb613036867c2173 = (baseEase, deltaMs, referenceFrameMs = 1000 / 60)=>{
    const safeEase = $bd0377e4b39d9902$export$7d15b64cf5a3a4c4(baseEase, 0, 1);
    const safeDelta = Math.max(0, Number.isFinite(deltaMs) ? deltaMs : referenceFrameMs);
    return 1 - (1 - safeEase) ** (safeDelta / referenceFrameMs);
};
const $bd0377e4b39d9902$export$6eb45378b3abe542 = (opacities, fallbackIndex = 0)=>{
    if (!opacities.length) return -1;
    return opacities.reduce((dominantIndex, opacity, index)=>{
        const dominantOpacity = opacities[dominantIndex] ?? Number.NEGATIVE_INFINITY;
        if (opacity > dominantOpacity) return index;
        if (opacity === dominantOpacity && index === fallbackIndex) return index;
        return dominantIndex;
    }, $bd0377e4b39d9902$export$7d15b64cf5a3a4c4(fallbackIndex, 0, opacities.length - 1));
};
const $bd0377e4b39d9902$export$5b1f08b8d979b640 = (dataset = {})=>[
        dataset.expertiseMediaType || '',
        dataset.expertiseVideoSrc || '',
        dataset.expertiseImgWebp || '',
        dataset.expertiseImgSrc || ''
    ].join('|');
const $bd0377e4b39d9902$export$4fc41e01721ae28 = (pointerType)=>pointerType !== 'touch';
const $bd0377e4b39d9902$export$f1cb57b10176b263 = ({ layerSize: layerSize, point: point, side: side, viewport: viewport, safePadding: safePadding, horizontalBias: horizontalBias, verticalBias: verticalBias })=>{
    const maxX = Math.max(safePadding, viewport.width - layerSize.width - safePadding);
    const maxY = Math.max(safePadding, viewport.height - layerSize.height - safePadding);
    const mediaXBias = side === 'left' ? horizontalBias.left : horizontalBias.right;
    return {
        x: $bd0377e4b39d9902$export$7d15b64cf5a3a4c4(point.x - layerSize.width * mediaXBias, safePadding, maxX),
        y: $bd0377e4b39d9902$export$7d15b64cf5a3a4c4(point.y - layerSize.height * verticalBias, safePadding, maxY)
    };
};
const $bd0377e4b39d9902$export$a5bac434b0849ed9 = ({ layerSize: layerSize, point: point, viewport: viewport, safePadding: safePadding })=>$bd0377e4b39d9902$export$f1cb57b10176b263({
        layerSize: layerSize,
        point: point,
        side: 'right',
        viewport: viewport,
        safePadding: safePadding,
        horizontalBias: {
            left: 0.5,
            right: 0.5
        },
        verticalBias: 0.5
    });
const $bd0377e4b39d9902$export$4c8ebe7100c4defd = (element, fallback = {
    width: 0,
    height: 0
})=>{
    const width = Number(element?.offsetWidth);
    const height = Number(element?.offsetHeight);
    return {
        width: Number.isFinite(width) && width > 0 ? width : fallback.width,
        height: Number.isFinite(height) && height > 0 ? height : fallback.height
    };
};
const $bd0377e4b39d9902$export$5c1c7630a61f63f5 = ({ layerSize: layerSize, point: point, rowRect: rowRect, viewport: viewport, safePadding: safePadding, verticalRange: verticalRange })=>{
    const rowCenterY = rowRect.top + rowRect.height / 2;
    const boundedPoint = {
        x: point.x,
        y: $bd0377e4b39d9902$export$7d15b64cf5a3a4c4(point.y, rowCenterY - verticalRange, rowCenterY + verticalRange)
    };
    return $bd0377e4b39d9902$export$a5bac434b0849ed9({
        layerSize: layerSize,
        point: boundedPoint,
        viewport: viewport,
        safePadding: safePadding
    });
};
const $bd0377e4b39d9902$export$f58b3b51bac700d6 = (index, baseDelay, staggerDelay)=>{
    const safeIndex = Number.isFinite(index) ? Math.max(0, Math.floor(index)) : 0;
    const safeBaseDelay = Number.isFinite(baseDelay) ? Math.max(0, baseDelay) : 0;
    const safeStaggerDelay = Number.isFinite(staggerDelay) ? Math.max(0, staggerDelay) : 0;
    return safeBaseDelay + safeIndex * safeStaggerDelay;
};
const $bd0377e4b39d9902$export$d1237822648a945 = (side, velocityX, flattenVelocity, baseRotation, flattenAmount)=>{
    const signedRotation = side === 'left' ? -baseRotation : baseRotation;
    const flattenRatio = $bd0377e4b39d9902$export$7d15b64cf5a3a4c4(Math.abs(velocityX) / flattenVelocity, 0, 1);
    const rotation = signedRotation * (1 - flattenRatio * flattenAmount);
    return Math.round(rotation * 1000000) / 1000000;
};
const $bd0377e4b39d9902$export$ca9fd91e91cc9f80 = (renderedRotation, targetRotation, flattenEase, restoreEase)=>Math.abs(targetRotation) < Math.abs(renderedRotation) ? flattenEase : restoreEase;
const $bd0377e4b39d9902$var$roundGeometryValue = (value)=>{
    const rounded = Math.round(value * 1000000) / 1000000;
    return Object.is(rounded, -0) ? 0 : rounded;
};
const $bd0377e4b39d9902$export$d565754665c32f63 = ({ x: x, y: y, width: width, height: height, rotation: rotation, scale: scale = 1 })=>{
    const centerX = x + width / 2;
    const centerY = y + height / 2;
    const radians = rotation * Math.PI / 180;
    const cosine = Math.cos(radians);
    const sine = Math.sin(radians);
    const safeScale = Math.max(0, Number.isFinite(scale) ? scale : 1);
    const halfWidth = width * safeScale / 2;
    const halfHeight = height * safeScale / 2;
    return [
        {
            x: -halfWidth,
            y: -halfHeight
        },
        {
            x: halfWidth,
            y: -halfHeight
        },
        {
            x: halfWidth,
            y: halfHeight
        },
        {
            x: -halfWidth,
            y: halfHeight
        }
    ].map((point)=>({
            x: $bd0377e4b39d9902$var$roundGeometryValue(centerX + point.x * cosine - point.y * sine),
            y: $bd0377e4b39d9902$var$roundGeometryValue(centerY + point.x * sine + point.y * cosine)
        }));
};
const $bd0377e4b39d9902$export$d861fa0e049bffae = (corners)=>corners.map((point)=>`${$bd0377e4b39d9902$var$roundGeometryValue(point.x)},${$bd0377e4b39d9902$var$roundGeometryValue(point.y)}`).join(' ');
const $bd0377e4b39d9902$export$a1cc2985adc3ca3c = ({ point: point, lastPoint: lastPoint, now: now, lastTime: lastTime, distanceThreshold: distanceThreshold, delayThreshold: delayThreshold })=>{
    if (!point || !Number.isFinite(point.x) || !Number.isFinite(point.y)) return false;
    if (!lastPoint) return true;
    const distance = Math.hypot(point.x - lastPoint.x, point.y - lastPoint.y);
    return distance >= distanceThreshold && now - lastTime >= delayThreshold;
};
const $bd0377e4b39d9902$export$bf56099dc16bb73f = (index, length)=>{
    if (length <= 0) return -1;
    return (index % length + length) % length;
};
const $bd0377e4b39d9902$export$9136a9e7cebffca6 = (currentIndex, length)=>$bd0377e4b39d9902$export$bf56099dc16bb73f(currentIndex + 1, length);
const $bd0377e4b39d9902$export$c32051b5003bd4e3 = (slots)=>{
    if (!slots.length) return -1;
    const inactiveIndex = slots.findIndex((slot)=>!slot.active);
    if (inactiveIndex !== -1) return inactiveIndex;
    return slots.reduce((oldestIndex, slot, index)=>slot.startedAt < slots[oldestIndex].startedAt ? index : oldestIndex, 0);
};
const $bd0377e4b39d9902$export$67691dc66ee99161 = (slots)=>slots.findIndex((slot)=>slot.active && slot.state === 'current');
const $bd0377e4b39d9902$export$41a66e0937245c04 = (slots, nextIndex)=>{
    const previousIndex = $bd0377e4b39d9902$export$67691dc66ee99161(slots);
    if (previousIndex === nextIndex) return -1;
    if (previousIndex !== -1) slots[previousIndex].state = 'retiring';
    if (slots[nextIndex]) slots[nextIndex].state = 'current';
    return previousIndex;
};
const $bd0377e4b39d9902$export$6573b83cddcf1f50 = (corners, bounds)=>{
    const points = corners.map((point)=>{
        const x = $bd0377e4b39d9902$var$roundGeometryValue(point.x - bounds.left);
        const y = $bd0377e4b39d9902$var$roundGeometryValue(point.y - bounds.top);
        return `${x}px ${y}px`;
    });
    return `polygon(${points.join(', ')})`;
};
const $bd0377e4b39d9902$export$aaae64f52aa818fb = (rect, viewportHeight)=>rect.bottom <= 0 || rect.top >= viewportHeight;


const $5b52ae0ba33fa205$var$initializedSections = new WeakSet();
let $5b52ae0ba33fa205$var$expertiseSectionId = 0;
const $5b52ae0ba33fa205$var$touchBreakpoint = 1033;
const $5b52ae0ba33fa205$var$viewportSafePadding = 24;
const $5b52ae0ba33fa205$var$mediaOddCursorBias = 0.84;
const $5b52ae0ba33fa205$var$mediaEvenCursorBias = 0.16;
const $5b52ae0ba33fa205$var$mediaVerticalCursorBias = 0.48;
const $5b52ae0ba33fa205$var$mediaBaseRotation = 4;
const $5b52ae0ba33fa205$var$mediaFlattenVelocity = 1600;
const $5b52ae0ba33fa205$var$mediaFlattenAmount = 0.95;
const $5b52ae0ba33fa205$var$mediaFollowEase = 0.105;
const $5b52ae0ba33fa205$var$mediaFlattenEase = 0.28;
const $5b52ae0ba33fa205$var$mediaRotationEase = 0.08;
const $5b52ae0ba33fa205$var$mediaVelocityDecayEase = 0.12;
const $5b52ae0ba33fa205$var$mediaSwitchOutDuration = 0.38;
const $5b52ae0ba33fa205$var$mediaSwitchInDuration = 0.46;
const $5b52ae0ba33fa205$var$mediaHideDuration = 0.24;
const $5b52ae0ba33fa205$var$mediaReadyTimeout = 1800;
const $5b52ae0ba33fa205$var$mediaVideoStartDelay = 120;
const $5b52ae0ba33fa205$var$posterFadeRemovalDelay = 320;
const $5b52ae0ba33fa205$var$motionPositionEpsilon = 0.08;
const $5b52ae0ba33fa205$var$motionRotationEpsilon = 0.015;
const $5b52ae0ba33fa205$var$maxCharStagger = 0.18;
const $5b52ae0ba33fa205$var$hoverLeaveDelay = 80;
const $5b52ae0ba33fa205$var$expertiseTrailPoolSize = 6;
const $5b52ae0ba33fa205$var$expertiseTrailDistance = 100;
const $5b52ae0ba33fa205$var$expertiseTrailDelay = 75;
const $5b52ae0ba33fa205$var$expertiseTrailInDuration = 0.55;
const $5b52ae0ba33fa205$var$expertiseTrailOutDuration = 0.5;
const $5b52ae0ba33fa205$var$expertiseTrailOverlayDuration = 0.22;
const $5b52ae0ba33fa205$var$expertiseTrailVerticalRange = 24;
const $5b52ae0ba33fa205$var$expertiseMobileAutoplayDelay = 3000;
const $5b52ae0ba33fa205$var$expertiseMobileAutoplayStagger = 450;
const $5b52ae0ba33fa205$var$expertiseMobileFadeDuration = 460;
const $5b52ae0ba33fa205$var$reducedMotionMediaQuery = '(prefers-reduced-motion: reduce)';
const $5b52ae0ba33fa205$var$touchPointerMediaQuery = '(hover: none), (pointer: coarse)';
const $5b52ae0ba33fa205$var$staticMobileMediaQuery = '(max-width: 640px)';
const $5b52ae0ba33fa205$var$getGsap = ()=>globalThis.gsap;
const $5b52ae0ba33fa205$var$getSections = (scope)=>{
    if (!scope?.querySelectorAll) return [];
    if (scope.matches?.('.expertise-sec')) return [
        scope
    ];
    return Array.from(scope.querySelectorAll('.expertise-sec'));
};
const $5b52ae0ba33fa205$var$toClientPoint = (point)=>{
    if (!point) return null;
    return {
        x: point.clientX,
        y: point.clientY
    };
};
const $5b52ae0ba33fa205$var$getTitlePoint = (title)=>{
    const rect = title.getBoundingClientRect();
    return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
    };
};
const $5b52ae0ba33fa205$var$getInteractionPoint = (event, title)=>{
    if (event?.touches?.[0]) return $5b52ae0ba33fa205$var$toClientPoint(event.touches[0]);
    if (event?.changedTouches?.[0]) return $5b52ae0ba33fa205$var$toClientPoint(event.changedTouches[0]);
    if (typeof event?.clientX === 'number' && typeof event?.clientY === 'number') return $5b52ae0ba33fa205$var$toClientPoint(event);
    return $5b52ae0ba33fa205$var$getTitlePoint(title);
};
const $5b52ae0ba33fa205$var$normalizeGalleryAsset = (dataset = {})=>{
    const src = dataset.src || dataset.expertiseImgSrc || '';
    const webp = dataset.webp || dataset.expertiseImgWebp || '';
    const poster = dataset.poster || dataset.expertisePosterSrc || '';
    const overlay = dataset.overlay === 'true' || dataset.expertiseOverlay === 'true';
    if (!src && !webp) return null;
    return {
        src: src,
        webp: webp,
        poster: poster,
        overlay: overlay
    };
};
const $5b52ae0ba33fa205$var$getRowGalleryAssets = (row)=>{
    const firstAsset = $5b52ae0ba33fa205$var$normalizeGalleryAsset(row.dataset);
    const template = row.querySelector('template[data-expertise-gallery]');
    const additionalAssets = template ? Array.from(template.content.querySelectorAll('[data-expertise-gallery-item]'), (item)=>$5b52ae0ba33fa205$var$normalizeGalleryAsset(item.dataset)).filter(Boolean) : [];
    return firstAsset ? [
        firstAsset,
        ...additionalAssets
    ] : additionalAssets;
};
const $5b52ae0ba33fa205$var$waitForImage = (image, timeout = $5b52ae0ba33fa205$var$mediaReadyTimeout, signal = null)=>new Promise((resolve)=>{
        let settled = false;
        let timer = null;
        let handleAbort = null;
        const finish = (ready)=>{
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
            signal?.removeEventListener('abort', handleAbort);
            resolve(ready);
        };
        const handleLoad = ()=>finish(image.naturalWidth > 0);
        const handleError = ()=>finish(false);
        handleAbort = ()=>finish(false);
        if (signal?.aborted) {
            finish(false);
            return;
        }
        image.addEventListener('load', handleLoad, {
            once: true
        });
        image.addEventListener('error', handleError, {
            once: true
        });
        signal?.addEventListener('abort', handleAbort, {
            once: true
        });
        timer = window.setTimeout(()=>finish(image.complete && image.naturalWidth > 0), timeout);
        if (image.complete) {
            handleLoad();
            return;
        }
        if (typeof image.decode === 'function') image.decode().then(handleLoad).catch(()=>{
            if (image.complete) handleLoad();
        });
    });
const $5b52ae0ba33fa205$var$waitForVideo = (video, timeout = $5b52ae0ba33fa205$var$mediaReadyTimeout, signal = null)=>new Promise((resolve)=>{
        let settled = false;
        let timer = null;
        let handleAbort = null;
        const finish = (ready)=>{
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            video.removeEventListener('loadeddata', handleReady);
            video.removeEventListener('error', handleError);
            signal?.removeEventListener('abort', handleAbort);
            resolve(ready);
        };
        const handleReady = ()=>finish(video.readyState >= 2);
        const handleError = ()=>finish(false);
        handleAbort = ()=>finish(false);
        if (signal?.aborted) {
            finish(false);
            return;
        }
        if (video.readyState >= 2) {
            finish(true);
            return;
        }
        video.addEventListener('loadeddata', handleReady, {
            once: true
        });
        video.addEventListener('error', handleError, {
            once: true
        });
        signal?.addEventListener('abort', handleAbort, {
            once: true
        });
        timer = window.setTimeout(()=>finish(video.readyState >= 2), timeout);
    });
const $5b52ae0ba33fa205$var$waitForFirstReady = (promises)=>new Promise((resolve)=>{
        let pending = promises.length;
        if (!pending) {
            resolve(false);
            return;
        }
        promises.forEach((promise)=>{
            promise.then((ready)=>{
                if (ready) {
                    resolve(true);
                    return;
                }
                pending -= 1;
                if (!pending) resolve(false);
            });
        });
    });
const $5b52ae0ba33fa205$var$watchImageReady = (image, onReady)=>{
    let active = true;
    const cleanup = ()=>{
        if (!active) return;
        active = false;
        image.removeEventListener('load', handleLoad);
        image.removeEventListener('error', cleanup);
    };
    const handleLoad = ()=>{
        if (image.naturalWidth <= 0) {
            cleanup();
            return;
        }
        cleanup();
        onReady();
    };
    image.addEventListener('load', handleLoad, {
        once: true
    });
    image.addEventListener('error', cleanup, {
        once: true
    });
    if (image.complete) handleLoad();
    return cleanup;
};
const $5b52ae0ba33fa205$var$retireExpertisePoster = (host, poster)=>{
    if (!poster || poster.dataset.expertisePosterRetiring === 'true') return ()=>{};
    poster.dataset.expertisePosterRetiring = 'true';
    host?.classList.add('is-media-ready');
    let timer = null;
    const removePoster = ()=>{
        window.clearTimeout(timer);
        poster.removeEventListener('transitionend', handleTransitionEnd);
        poster.removeAttribute('src');
        poster.remove();
    };
    const handleTransitionEnd = (event)=>{
        if (event.target === poster && event.propertyName === 'opacity') removePoster();
    };
    poster.addEventListener('transitionend', handleTransitionEnd);
    poster.classList.add('is-retiring');
    timer = window.setTimeout(removePoster, $5b52ae0ba33fa205$var$posterFadeRemovalDelay);
    return removePoster;
};
const $5b52ae0ba33fa205$var$addMediaQueryListener = (mediaQuery, listener)=>{
    if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', listener);
        return;
    }
    mediaQuery.addListener?.(listener);
};
const $5b52ae0ba33fa205$var$initExpertiseSection = (scope = document)=>{
    $5b52ae0ba33fa205$var$getSections(scope).forEach((section)=>{
        if ($5b52ae0ba33fa205$var$initializedSections.has(section)) return;
        const rows = Array.from(section.querySelectorAll('[data-expertise-row]'));
        const titles = rows.map((row)=>row.querySelector('[data-expertise-title]'));
        const rowsContainer = section.querySelector('.expertise-sec__rows');
        const mediaLayer = section.querySelector('[data-expertise-media-layer]');
        const mediaInner = mediaLayer?.querySelector('.expertise-sec__media-inner');
        const mobileMedia = Array.from(section.querySelectorAll('[data-expertise-mobile-media]'));
        if (!rows.length || titles.some((title)=>!title) || !mediaLayer || !mediaInner) return;
        $5b52ae0ba33fa205$var$initializedSections.add(section);
        const gsapInstance = $5b52ae0ba33fa205$var$getGsap();
        const touchMediaQuery = window.matchMedia($5b52ae0ba33fa205$var$touchPointerMediaQuery);
        const reducedMotionQuery = window.matchMedia($5b52ae0ba33fa205$var$reducedMotionMediaQuery);
        const staticMobileQuery = window.matchMedia($5b52ae0ba33fa205$var$staticMobileMediaQuery);
        section.classList.add('is-expertise-enhanced');
        section.classList.toggle('has-expertise-gsap', !!gsapInstance);
        section.classList.toggle('is-reduced-motion', reducedMotionQuery.matches);
        titles.forEach((title)=>{
            title.setAttribute('aria-pressed', 'false');
            if (title.classList.contains('is-expertise-splitting-init')) return;
            title.classList.add('is-expertise-splitting-init');
            (0, (/*@__PURE__*/$parcel$interopDefault($4f41718f1a00a7f9$exports)))({
                target: title,
                by: 'chars'
            });
            const chars = Array.from(title.querySelectorAll('.char'));
            const charStep = chars.length > 1 ? Math.min(0.015, $5b52ae0ba33fa205$var$maxCharStagger / (chars.length - 1)) : 0;
            title.style.setProperty('--expertise-char-step', `${charStep}s`);
            chars.forEach((char)=>{
                if (!char.hasAttribute('data-char')) char.setAttribute('data-char', char.textContent);
            });
        });
        let contrastLayer = rowsContainer?.querySelector('[data-expertise-contrast-layer]') || null;
        if (rowsContainer && !contrastLayer) {
            contrastLayer = document.createElement('div');
            contrastLayer.dataset.expertiseContrastLayer = '';
            contrastLayer.className = 'expertise-sec__contrast-layer';
            rowsContainer.append(contrastLayer);
        }
        const contrastTitles = contrastLayer ? titles.map((title, index)=>{
            const contrastTitle = document.createElement('div');
            contrastTitle.className = `${title.className} expertise-sec__contrast-title`;
            contrastTitle.dataset.expertiseContrastTitle = `${index}`;
            contrastTitle.style.cssText = title.style.cssText;
            contrastTitle.classList.add('is-flip-idle');
            contrastTitle.replaceChildren(...Array.from(title.childNodes, (node)=>node.cloneNode(true)));
            return contrastTitle;
        }) : [];
        if (contrastLayer) {
            contrastLayer.setAttribute('aria-hidden', 'true');
            contrastLayer.replaceChildren(...contrastTitles);
        }
        const rowGalleries = new Map(rows.map((row)=>[
                row,
                $5b52ae0ba33fa205$var$getRowGalleryAssets(row)
            ]));
        const rowGalleryIndexes = new Map();
        const rowHoverTokens = new Map();
        const imageCache = new Map();
        const svgNamespace = 'http://www.w3.org/2000/svg';
        const trailClipId = `expertise-trail-clip-${$5b52ae0ba33fa205$var$expertiseSectionId += 1}`;
        const trailSvg = document.createElementNS(svgNamespace, 'svg');
        const trailDefs = document.createElementNS(svgNamespace, 'defs');
        const trailClipPath = document.createElementNS(svgNamespace, 'clipPath');
        const trailLayer = document.createElement('div');
        trailSvg.classList.add('expertise-sec__trail-svg');
        trailSvg.setAttribute('aria-hidden', 'true');
        trailSvg.setAttribute('width', '0');
        trailSvg.setAttribute('height', '0');
        trailClipPath.id = trailClipId;
        trailClipPath.setAttribute('clipPathUnits', 'userSpaceOnUse');
        trailDefs.append(trailClipPath);
        trailSvg.append(trailDefs);
        section.append(trailSvg);
        trailLayer.className = 'expertise-sec__trail-layer';
        trailLayer.dataset.expertiseTrailLayer = '';
        trailLayer.setAttribute('aria-hidden', 'true');
        mediaLayer.parentElement.append(trailLayer);
        const trailSlots = Array.from({
            length: $5b52ae0ba33fa205$var$expertiseTrailPoolSize
        }, ()=>{
            const element = document.createElement('div');
            const image = document.createElement('img');
            const overlay = document.createElement('div');
            const polygon = document.createElementNS(svgNamespace, 'polygon');
            element.className = 'expertise-sec__trail-item';
            element.dataset.expertiseTrailSlot = '';
            image.alt = '';
            image.decoding = 'async';
            overlay.className = 'expertise-sec__trail-overlay';
            element.append(image, overlay);
            trailLayer.append(element);
            trailClipPath.append(polygon);
            return {
                active: false,
                state: 'idle',
                el: element,
                image: image,
                overlay: overlay,
                polygon: polygon,
                timeline: null,
                startedAt: 0,
                row: null,
                point: null,
                x: 0,
                y: 0,
                rotation: 0
            };
        });
        mediaInner.replaceChildren();
        const createMediaSlot = ()=>{
            const slotElement = document.createElement('div');
            slotElement.className = 'expertise-sec__media-slot';
            mediaInner.append(slotElement);
            return {
                el: slotElement,
                key: '',
                video: null,
                status: 'empty',
                loadToken: 0,
                loadController: null,
                dispose: null,
                playTimer: null,
                readyPromise: Promise.resolve(false)
            };
        };
        const slots = [];
        const setLayerX = gsapInstance?.quickSetter(mediaLayer, 'x', 'px') || null;
        const setLayerY = gsapInstance?.quickSetter(mediaLayer, 'y', 'px') || null;
        const setLayerRotation = gsapInstance?.quickSetter(mediaLayer, 'rotation', 'deg') || null;
        let activeRow = null;
        let activeTitle = null;
        let displayedRow = null;
        let displayedTitle = null;
        let displayedContrastTitle = null;
        let activeSlotIndex = -1;
        let interactionMode = null;
        let layerVisible = false;
        let tickerActive = false;
        let rafFrame = null;
        let resizeFrame = null;
        let contrastPositionFrame = null;
        let sectionVisibilityFrame = null;
        let mobileMediaObserver = null;
        let mobileVisibilityObserver = null;
        let sectionPreloadObserver = null;
        let hideTimer = null;
        let pauseTimer = null;
        let hoverLeaveTimer = null;
        let transitionTimeline = null;
        let mediaRequestToken = 0;
        let pointerFocusTitle = null;
        let pointer = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2
        };
        let pointerVelocityX = 0;
        let lastPointerMoveTime = 0;
        let target = {
            x: 0,
            y: 0,
            rotation: 0
        };
        let rendered = {
            x: 0,
            y: 0,
            rotation: 0
        };
        let layerSize = {
            width: 0,
            height: 0
        };
        let lastFrameTime = 0;
        let lastAppliedTransform = {
            x: NaN,
            y: NaN,
            rotation: NaN
        };
        let lastAppliedClipPath = '';
        let trailActiveRow = null;
        let trailLastPoint = null;
        let trailLastTime = 0;
        let trailGalleryIndex = 0;
        let trailStackIndex = 0;
        let trailMaskFrame = null;
        let trailPositionFrame = null;
        let trailActivationToken = 0;
        let trailSize = {
            width: 0,
            height: 0
        };
        const isTouchMode = ()=>window.innerWidth <= $5b52ae0ba33fa205$var$touchBreakpoint || touchMediaQuery.matches;
        const isReducedMotion = ()=>reducedMotionQuery.matches;
        const supportsSvgTrail = !!(contrastLayer && globalThis.CSS?.supports?.('clip-path', `url(#${trailClipId})`));
        const canUseTrail = ()=>!!gsapInstance && supportsSvgTrail && !isTouchMode() && !isReducedMotion();
        const hasRowMedia = (row)=>!!(row.dataset.expertiseVideoSrc || row.dataset.expertiseImgSrc);
        const getRowIndex = (row)=>rows.indexOf(row);
        const getMediaSide = (row)=>(getRowIndex(row) + 1) % 2 === 1 ? 'left' : 'right';
        const getMediaKey = (row, asset = null)=>{
            if (asset) return [
                row.dataset.expertiseMediaType || 'image',
                asset.webp || '',
                asset.src || '',
                asset.overlay ? 'overlay' : ''
            ].join('|');
            return `${(0, $bd0377e4b39d9902$export$5b1f08b8d979b640)(row.dataset)}|${row.dataset.expertiseOverlay || ''}`;
        };
        const loadGalleryAsset = (asset)=>{
            if (!asset) return Promise.resolve(null);
            const key = asset.webp || asset.src;
            if (!key) return Promise.resolve(null);
            const cached = imageCache.get(key);
            if (cached) return cached.promise;
            const record = {
                status: 'loading',
                url: '',
                promise: null
            };
            const loadCandidate = (url)=>{
                if (!url) return Promise.resolve(null);
                const image = new Image();
                image.alt = '';
                image.decoding = 'async';
                image.src = url;
                return $5b52ae0ba33fa205$var$waitForImage(image, 5000).then((ready)=>ready ? url : null);
            };
            record.promise = loadCandidate(asset.webp).then((url)=>url || loadCandidate(asset.src)).then((url)=>{
                record.status = url ? 'ready' : 'error';
                record.url = url || '';
                return url ? {
                    ...asset,
                    resolvedSrc: url
                } : null;
            });
            imageCache.set(key, record);
            return record.promise;
        };
        const preloadRowGallery = (row, all = false)=>{
            const gallery = rowGalleries.get(row) || [];
            const assets = all ? gallery : gallery.slice(0, 1);
            return Promise.all(assets.map(loadGalleryAsset));
        };
        const getNextRowGalleryAsset = async (row)=>{
            const gallery = rowGalleries.get(row) || [];
            if (!gallery.length) return null;
            const currentIndex = rowGalleryIndexes.get(row) ?? -1;
            for(let offset = 0; offset < gallery.length; offset += 1){
                const index = (0, $bd0377e4b39d9902$export$9136a9e7cebffca6)(currentIndex + offset, gallery.length);
                const asset = await loadGalleryAsset(gallery[index]);
                if (asset) {
                    rowGalleryIndexes.set(row, index);
                    return asset;
                }
            }
            return null;
        };
        const getReadyGalleryAsset = (gallery, preferredIndex)=>{
            if (!gallery.length) return null;
            for(let offset = 0; offset < gallery.length; offset += 1){
                const index = (0, $bd0377e4b39d9902$export$bf56099dc16bb73f)(preferredIndex + offset, gallery.length);
                const asset = gallery[index];
                const record = imageCache.get(asset.webp || asset.src);
                if (record?.status === 'ready' && record.url) return {
                    asset: {
                        ...asset,
                        resolvedSrc: record.url
                    },
                    index: index
                };
            }
            return null;
        };
        const mobileStates = mobileMedia.map((media, index)=>{
            const rowIndex = Number(media.dataset.expertiseMobileRowIndex);
            const row = rows[Number.isInteger(rowIndex) ? rowIndex : index] || null;
            return {
                index: index,
                media: media,
                row: row,
                track: media.querySelector('[data-expertise-mobile-track]'),
                gallery: row ? rowGalleries.get(row) || [] : [],
                slots: [],
                activeSlotIndex: 0,
                currentIndex: 0,
                timer: null,
                transitionToken: 0,
                hydrated: false,
                visible: false
            };
        });
        const stopMobileAutoplay = (state)=>{
            window.clearTimeout(state.timer);
            state.timer = null;
        };
        const canAutoplayMobile = (state)=>staticMobileQuery.matches && !isReducedMotion() && !document.hidden && state.visible && state.hydrated && state.gallery.length > 1 && !(0, $bd0377e4b39d9902$export$aaae64f52aa818fb)(state.media.getBoundingClientRect(), window.innerHeight);
        const renderMobileAsset = async (state, slotIndex, assetIndex)=>{
            const slot = state.slots[slotIndex];
            const asset = state.gallery[assetIndex];
            const token = state.transitionToken + 1;
            if (!slot || !asset) return false;
            state.transitionToken = token;
            const loadedAsset = await loadGalleryAsset(asset);
            if (!loadedAsset || token !== state.transitionToken) return false;
            const picture = document.createElement('picture');
            const image = document.createElement('img');
            image.src = loadedAsset.resolvedSrc;
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            image.width = 515;
            image.height = 348;
            picture.append(image);
            slot.replaceChildren(picture);
            return true;
        };
        const scheduleMobileAutoplay = (state, delay = $5b52ae0ba33fa205$var$expertiseMobileAutoplayDelay)=>{
            stopMobileAutoplay(state);
            if (!canAutoplayMobile(state)) return;
            loadGalleryAsset(state.gallery[(0, $bd0377e4b39d9902$export$bf56099dc16bb73f)(state.currentIndex + 1, state.gallery.length)]);
            state.timer = window.setTimeout(async ()=>{
                state.timer = null;
                if (!canAutoplayMobile(state)) return;
                const nextIndex = (0, $bd0377e4b39d9902$export$bf56099dc16bb73f)(state.currentIndex + 1, state.gallery.length);
                const nextSlotIndex = state.activeSlotIndex === 0 ? 1 : 0;
                const ready = await renderMobileAsset(state, nextSlotIndex, nextIndex);
                if (!ready || !canAutoplayMobile(state)) {
                    scheduleMobileAutoplay(state);
                    return;
                }
                const previousSlot = state.slots[state.activeSlotIndex];
                const nextSlot = state.slots[nextSlotIndex];
                nextSlot.classList.add('is-active');
                previousSlot.classList.remove('is-active');
                state.activeSlotIndex = nextSlotIndex;
                state.currentIndex = nextIndex;
                window.setTimeout(()=>{
                    if (!previousSlot.classList.contains('is-active')) previousSlot.replaceChildren();
                }, $5b52ae0ba33fa205$var$expertiseMobileFadeDuration);
                loadGalleryAsset(state.gallery[(0, $bd0377e4b39d9902$export$bf56099dc16bb73f)(nextIndex + 1, state.gallery.length)]);
                scheduleMobileAutoplay(state);
            }, delay);
        };
        const scheduleMobileAutoplayStart = (state)=>{
            scheduleMobileAutoplay(state, (0, $bd0377e4b39d9902$export$f58b3b51bac700d6)(state.index, $5b52ae0ba33fa205$var$expertiseMobileAutoplayDelay, $5b52ae0ba33fa205$var$expertiseMobileAutoplayStagger));
        };
        const syncMobileAutoplay = ()=>{
            mobileStates.forEach((state)=>{
                if (canAutoplayMobile(state)) scheduleMobileAutoplayStart(state);
                else stopMobileAutoplay(state);
            });
        };
        const hydrateMobileMedia = (media)=>{
            if (media.dataset.expertiseMobileLoaded === 'true') return;
            media.querySelectorAll('source[data-srcset]').forEach((source)=>{
                source.srcset = source.dataset.srcset;
                delete source.dataset.srcset;
            });
            media.querySelectorAll('img[data-src]').forEach((image)=>{
                if (!image.dataset.src) return;
                image.src = image.dataset.src;
                delete image.dataset.src;
            });
            const poster = media.querySelector('.expertise-sec__media-poster');
            const image = media.querySelector('picture img');
            if (poster && image) $5b52ae0ba33fa205$var$watchImageReady(image, ()=>{
                $5b52ae0ba33fa205$var$retireExpertisePoster(media, poster);
            });
            const state = mobileStates.find((item)=>item.media === media);
            if (state?.track && !state.hydrated) {
                const firstSlot = document.createElement('div');
                const secondSlot = document.createElement('div');
                const initialNodes = Array.from(state.track.childNodes);
                firstSlot.className = 'expertise-sec__mobile-slide is-active';
                secondSlot.className = 'expertise-sec__mobile-slide';
                firstSlot.append(...initialNodes);
                state.track.append(firstSlot, secondSlot);
                state.slots = [
                    firstSlot,
                    secondSlot
                ];
                state.hydrated = true;
                loadGalleryAsset(state.gallery[0]);
                scheduleMobileAutoplayStart(state);
            }
            media.dataset.expertiseMobileLoaded = 'true';
        };
        const initMobileMediaLoading = ()=>{
            if (!mobileMedia.length || !staticMobileQuery.matches) return;
            if (typeof window.IntersectionObserver !== 'function') {
                mobileStates.forEach((state)=>{
                    state.visible = true;
                    hydrateMobileMedia(state.media);
                });
                return;
            }
            if (mobileMediaObserver) return;
            mobileMediaObserver = new window.IntersectionObserver((entries)=>{
                if (!staticMobileQuery.matches) return;
                entries.forEach((entry)=>{
                    if (!entry.isIntersecting) return;
                    hydrateMobileMedia(entry.target);
                    mobileMediaObserver.unobserve(entry.target);
                });
            }, {
                rootMargin: '300px 0px',
                threshold: 0.01
            });
            mobileMedia.forEach((media)=>mobileMediaObserver.observe(media));
            if (!mobileVisibilityObserver) {
                mobileVisibilityObserver = new window.IntersectionObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const state = mobileStates.find((item)=>item.media === entry.target);
                        if (!state) return;
                        state.visible = entry.isIntersecting && entry.intersectionRatio > 0.1;
                        if (state.visible) scheduleMobileAutoplayStart(state);
                        else stopMobileAutoplay(state);
                    });
                }, {
                    threshold: [
                        0,
                        0.1,
                        0.5
                    ]
                });
                mobileMedia.forEach((media)=>mobileVisibilityObserver.observe(media));
            }
        };
        const measureLayer = ()=>{
            const rect = mediaLayer.getBoundingClientRect();
            layerSize = {
                width: rect.width || mediaLayer.offsetWidth,
                height: rect.height || mediaLayer.offsetHeight
            };
            trailSize = (0, $bd0377e4b39d9902$export$4c8ebe7100c4defd)(trailSlots[0]?.el, layerSize);
        };
        const updateContrastMask = ()=>{
            if (!contrastLayer || !displayedRow || interactionMode === 'trail') return;
            const corners = (0, $bd0377e4b39d9902$export$d565754665c32f63)({
                x: rendered.x,
                y: rendered.y,
                width: layerSize.width,
                height: layerSize.height,
                rotation: rendered.rotation
            });
            const clipPath = (0, $bd0377e4b39d9902$export$6573b83cddcf1f50)(corners, {
                left: 0,
                top: 0
            });
            if (clipPath === lastAppliedClipPath) return;
            lastAppliedClipPath = clipPath;
            contrastLayer.style.clipPath = clipPath;
            contrastLayer.style.webkitClipPath = clipPath;
        };
        const measureContrastTitles = ()=>{
            if (!contrastTitles.length) return;
            const rects = titles.map((title)=>title.getBoundingClientRect());
            contrastTitles.forEach((contrastTitle, index)=>{
                const rect = rects[index];
                contrastTitle.style.left = `${rect.left}px`;
                contrastTitle.style.top = `${rect.top}px`;
                contrastTitle.style.width = `${rect.width}px`;
                contrastTitle.style.height = `${rect.height}px`;
            });
        };
        const scheduleContrastPositionUpdate = ()=>{
            if (contrastPositionFrame) return;
            contrastPositionFrame = window.requestAnimationFrame(()=>{
                contrastPositionFrame = null;
                measureContrastTitles();
            });
        };
        const commitContrastTitle = (row)=>{
            contrastTitles.forEach((contrastTitle)=>{
                contrastTitle.classList.remove('is-displayed');
                if (!contrastTitle.classList.contains('is-flip-active')) contrastTitle.classList.add('is-flip-idle');
            });
            displayedContrastTitle = contrastTitles[getRowIndex(row)] || null;
            displayedContrastTitle?.classList.remove('is-flip-idle');
        };
        const applyLayerTransform = (force = false)=>{
            const transformChanged = force || rendered.x !== lastAppliedTransform.x || rendered.y !== lastAppliedTransform.y || rendered.rotation !== lastAppliedTransform.rotation;
            if (!transformChanged) {
                updateContrastMask();
                return;
            }
            lastAppliedTransform = {
                ...rendered
            };
            if (setLayerX && setLayerY && setLayerRotation) {
                setLayerX(rendered.x);
                setLayerY(rendered.y);
                setLayerRotation(rendered.rotation);
            } else mediaLayer.style.transform = `translate3d(${rendered.x}px, ${rendered.y}px, 0) rotate(${rendered.rotation}deg)`;
            updateContrastMask();
        };
        const cancelSlotPlay = (slot)=>{
            if (!slot?.playTimer) return;
            window.clearTimeout(slot.playTimer);
            slot.playTimer = null;
        };
        const pauseSlotVideo = (slot)=>{
            cancelSlotPlay(slot);
            slot?.video?.pause();
        };
        const playSlotVideo = (slot)=>{
            if (!slot?.video || slot.playTimer || !slot.video.paused) return;
            const slotIndex = slots.indexOf(slot);
            slot.playTimer = window.setTimeout(()=>{
                slot.playTimer = null;
                if (slotIndex !== activeSlotIndex || !slot.el.classList.contains('is-active') || !layerVisible || !slot.video) return;
                if (slot.video.preload === 'none') {
                    slot.video.preload = 'auto';
                    slot.video.dataset.expertiseDecoderStarted = 'true';
                    slot.video.load();
                }
                slot.video.play().catch(()=>{});
            }, isReducedMotion() ? 0 : $5b52ae0ba33fa205$var$mediaVideoStartDelay);
        };
        const pauseAllVideos = ()=>{
            slots.forEach(pauseSlotVideo);
        };
        const renderVideo = (row, signal)=>{
            if (!row.dataset.expertiseVideoSrc) return null;
            const videoWrap = document.createElement('div');
            const readiness = [];
            const hasPoster = !!row.dataset.expertisePoster;
            let poster = null;
            let disposePosterRetirement = ()=>{};
            videoWrap.className = 'expertise-sec__video';
            if (hasPoster) {
                videoWrap.classList.add('expertise-sec__poster-host', 'has-poster');
                poster = document.createElement('img');
                poster.className = 'expertise-sec__video-poster expertise-sec__media-poster';
                poster.src = row.dataset.expertisePoster;
                poster.alt = '';
                poster.loading = 'eager';
                poster.decoding = 'async';
                videoWrap.append(poster);
                readiness.push($5b52ae0ba33fa205$var$waitForImage(poster, $5b52ae0ba33fa205$var$mediaReadyTimeout, signal));
            }
            const video = document.createElement('video');
            video.className = hasPoster ? 'expertise-sec__video-el expertise-sec__media-content' : 'expertise-sec__video-el';
            video.muted = true;
            video.playsInline = true;
            video.loop = true;
            video.preload = hasPoster ? 'none' : 'metadata';
            if (hasPoster) video.poster = row.dataset.expertisePoster;
            video.src = row.dataset.expertiseVideoSrc;
            const handleVideoReady = ()=>{
                videoWrap.classList.add('is-video-ready');
                if (poster) disposePosterRetirement = $5b52ae0ba33fa205$var$retireExpertisePoster(videoWrap, poster);
            };
            video.addEventListener('loadeddata', handleVideoReady, {
                once: true
            });
            videoWrap.append(video);
            if (!hasPoster) {
                readiness.push($5b52ae0ba33fa205$var$waitForVideo(video, $5b52ae0ba33fa205$var$mediaReadyTimeout, signal));
                video.dataset.expertiseDecoderStarted = 'true';
                video.load();
            }
            return {
                element: videoWrap,
                video: video,
                ready: $5b52ae0ba33fa205$var$waitForFirstReady(readiness),
                dispose: ()=>{
                    const decoderStarted = video.dataset.expertiseDecoderStarted === 'true';
                    disposePosterRetirement();
                    video.removeEventListener('loadeddata', handleVideoReady);
                    video.pause();
                    video.removeAttribute('src');
                    video.removeAttribute('poster');
                    if (decoderStarted) video.load();
                    poster?.removeAttribute('src');
                }
            };
        };
        const renderImage = (row, signal, asset = null)=>{
            const resolvedSrc = asset?.resolvedSrc || '';
            const imageSrc = resolvedSrc || asset?.src || row.dataset.expertiseImgSrc;
            const imageWebp = resolvedSrc && resolvedSrc !== asset?.webp ? '' : asset?.webp || row.dataset.expertiseImgWebp;
            const posterSrc = asset?.poster || row.dataset.expertisePosterSrc;
            const hasOverlay = asset ? asset.overlay : row.dataset.expertiseOverlay === 'true';
            if (!imageSrc) return null;
            const picture = document.createElement('picture');
            const posterHost = posterSrc ? document.createElement('div') : null;
            let poster = null;
            let disposePosterRetirement = ()=>{};
            if (posterHost) {
                posterHost.className = 'expertise-sec__poster-host has-poster';
                picture.className = 'expertise-sec__media-content';
                poster = document.createElement('img');
                poster.className = 'expertise-sec__media-poster';
                poster.src = posterSrc;
                poster.alt = '';
                poster.loading = 'eager';
                poster.decoding = 'async';
                posterHost.append(poster, picture);
            }
            if (hasOverlay) (posterHost || picture).classList.add('has-overlay');
            if (imageWebp) {
                const source = document.createElement('source');
                source.type = 'image/webp';
                source.srcset = imageWebp;
                picture.append(source);
            }
            const image = document.createElement('img');
            image.src = imageSrc;
            image.alt = '';
            image.loading = 'eager';
            image.decoding = 'async';
            picture.append(image);
            const contentReady = $5b52ae0ba33fa205$var$waitForImage(image, $5b52ae0ba33fa205$var$mediaReadyTimeout, signal);
            const posterReady = poster ? $5b52ae0ba33fa205$var$waitForImage(poster, $5b52ae0ba33fa205$var$mediaReadyTimeout, signal) : contentReady;
            const stopWatchingImage = poster ? $5b52ae0ba33fa205$var$watchImageReady(image, ()=>{
                disposePosterRetirement = $5b52ae0ba33fa205$var$retireExpertisePoster(posterHost, poster);
            }) : ()=>{};
            return {
                element: posterHost || picture,
                video: null,
                ready: $5b52ae0ba33fa205$var$waitForFirstReady([
                    posterReady,
                    contentReady
                ]),
                dispose: ()=>{
                    stopWatchingImage();
                    disposePosterRetirement();
                    image.removeAttribute('src');
                    poster?.removeAttribute('src');
                    picture.querySelectorAll('source').forEach((source)=>{
                        source.removeAttribute('srcset');
                    });
                }
            };
        };
        const disposeSlotMedia = (slot)=>{
            pauseSlotVideo(slot);
            slot.loadController?.abort();
            slot.loadController = null;
            slot.dispose?.();
            slot.dispose = null;
            slot.video = null;
            slot.el.replaceChildren();
        };
        const setSlotMedia = (slot, row, asset = null)=>{
            const mediaKey = getMediaKey(row, asset);
            if (slot.key === mediaKey && slot.el.firstElementChild) {
                if (slot.status === 'ready') return Promise.resolve(true);
                if (slot.status === 'loading') return slot.readyPromise;
            }
            disposeSlotMedia(slot);
            slot.loadToken += 1;
            slot.key = mediaKey;
            slot.status = 'loading';
            slot.loadController = new AbortController();
            const media = row.dataset.expertiseMediaType === 'image' ? renderImage(row, slot.loadController.signal, asset) : renderVideo(row, slot.loadController.signal);
            if (!media) {
                slot.loadController.abort();
                slot.loadController = null;
                slot.key = '';
                slot.status = 'error';
                return Promise.resolve(false);
            }
            const loadToken = slot.loadToken;
            slot.el.append(media.element);
            slot.video = media.video;
            slot.dispose = media.dispose;
            slot.readyPromise = media.ready.then((ready)=>{
                if (slot.loadToken !== loadToken) return false;
                slot.status = ready ? 'ready' : 'error';
                if (!ready) slot.key = '';
                return ready;
            });
            return slot.readyPromise;
        };
        const getSlotOpacity = (slot)=>{
            const opacity = gsapInstance ? Number(gsapInstance.getProperty(slot.el, 'opacity')) : Number(getComputedStyle(slot.el).opacity);
            return Number.isFinite(opacity) ? opacity : 0;
        };
        const setSlotImmediate = (slotIndex, visible)=>{
            const slot = slots[slotIndex];
            if (!slot) return;
            slot.el.classList.toggle('is-active', visible);
            if (gsapInstance) gsapInstance.set(slot.el, {
                autoAlpha: visible ? 1 : 0,
                scale: visible ? 1 : 0.975
            });
            else {
                slot.el.style.removeProperty('opacity');
                slot.el.style.removeProperty('visibility');
                slot.el.style.removeProperty('transform');
            }
            if (!visible) pauseSlotVideo(slot);
        };
        const setContrastActive = (visible, duration = visible ? $5b52ae0ba33fa205$var$mediaSwitchInDuration : $5b52ae0ba33fa205$var$mediaSwitchOutDuration)=>{
            displayedContrastTitle?.style.setProperty('--expertise-contrast-duration', `${duration}s`);
            displayedContrastTitle?.classList.toggle('is-displayed', visible);
        };
        const idleHiddenContrastTitles = ()=>{
            contrastTitles.forEach((contrastTitle)=>{
                if (!contrastTitle.classList.contains('is-displayed')) contrastTitle.classList.add('is-flip-idle');
            });
        };
        const applyTrailContrastMask = ()=>{
            if (!contrastLayer) return;
            contrastLayer.style.clipPath = `url(#${trailClipId})`;
            contrastLayer.style.webkitClipPath = `url(#${trailClipId})`;
            lastAppliedClipPath = '';
        };
        const clearTrailContrastMask = ()=>{
            trailSlots.forEach((slot)=>slot.polygon.removeAttribute('points'));
            contrastLayer?.style.removeProperty('clip-path');
            contrastLayer?.style.removeProperty('-webkit-clip-path');
            lastAppliedClipPath = '';
        };
        const updateTrailMask = ()=>{
            trailMaskFrame = null;
            trailSlots.forEach((slot)=>{
                if (!slot.active) {
                    slot.polygon.removeAttribute('points');
                    return;
                }
                const scale = Number(gsapInstance?.getProperty(slot.el, 'scale'));
                const corners = (0, $bd0377e4b39d9902$export$d565754665c32f63)({
                    x: slot.x,
                    y: slot.y,
                    width: trailSize.width,
                    height: trailSize.height,
                    rotation: slot.rotation,
                    scale: Number.isFinite(scale) ? scale : 1
                });
                slot.polygon.setAttribute('points', (0, $bd0377e4b39d9902$export$d861fa0e049bffae)(corners));
            });
        };
        const scheduleTrailMaskUpdate = ()=>{
            if (trailMaskFrame) return;
            trailMaskFrame = window.requestAnimationFrame(updateTrailMask);
        };
        const updateTrailPositions = ()=>{
            trailPositionFrame = null;
            const rowRects = new Map();
            trailSlots.forEach((slot)=>{
                if (!slot.active || !slot.row || !slot.point) return;
                if (!rowRects.has(slot.row)) {
                    const rowTitle = titles[getRowIndex(slot.row)];
                    rowRects.set(slot.row, (rowTitle || slot.row).getBoundingClientRect());
                }
                const targetPosition = (0, $bd0377e4b39d9902$export$5c1c7630a61f63f5)({
                    layerSize: trailSize,
                    point: slot.point,
                    rowRect: rowRects.get(slot.row),
                    viewport: {
                        width: window.innerWidth,
                        height: window.innerHeight
                    },
                    safePadding: $5b52ae0ba33fa205$var$viewportSafePadding,
                    verticalRange: $5b52ae0ba33fa205$var$expertiseTrailVerticalRange
                });
                slot.x = targetPosition.x;
                slot.y = targetPosition.y;
                gsapInstance?.set(slot.el, {
                    x: slot.x,
                    y: slot.y
                });
            });
            scheduleTrailMaskUpdate();
        };
        const scheduleTrailPositionUpdate = ()=>{
            if (trailPositionFrame || !trailSlots.some((slot)=>slot.active)) return;
            trailPositionFrame = window.requestAnimationFrame(updateTrailPositions);
        };
        const finishTrailVisibility = ()=>{
            if (trailActiveRow || trailSlots.some((slot)=>slot.active)) return;
            trailLayer.classList.remove('is-visible');
            contrastLayer?.classList.remove('is-visible', 'is-motion-active');
            setContrastActive(false, $5b52ae0ba33fa205$var$mediaHideDuration);
            idleHiddenContrastTitles();
            clearTrailContrastMask();
            displayedRow = null;
            displayedTitle = null;
        };
        const releaseTrailSlot = (slot)=>{
            slot.timeline = null;
            slot.active = false;
            slot.state = 'idle';
            slot.row = null;
            slot.point = null;
            slot.el.classList.remove('is-active', 'is-current', 'is-retiring');
            slot.image.removeAttribute('src');
            slot.polygon.removeAttribute('points');
            gsapInstance?.set(slot.el, {
                autoAlpha: 0,
                scale: 0
            });
            gsapInstance?.set(slot.overlay, {
                opacity: 0
            });
            scheduleTrailMaskUpdate();
            finishTrailVisibility();
        };
        const retireTrailSlot = (slot, immediate = false)=>{
            if (!slot?.active) return;
            slot.timeline?.kill();
            slot.timeline = null;
            slot.state = 'retiring';
            slot.el.classList.remove('is-current');
            slot.el.classList.add('is-retiring');
            if (immediate) {
                releaseTrailSlot(slot);
                return;
            }
            slot.timeline = gsapInstance.timeline({
                onUpdate: scheduleTrailMaskUpdate,
                onComplete: ()=>releaseTrailSlot(slot)
            });
            slot.timeline.to(slot.overlay, {
                opacity: 0.3,
                duration: $5b52ae0ba33fa205$var$expertiseTrailOverlayDuration,
                ease: 'power1.out'
            }).to(slot.el, {
                scale: 0,
                duration: $5b52ae0ba33fa205$var$expertiseTrailOutDuration,
                ease: 'power2.in'
            }, '<');
        };
        const retireCurrentTrailSlot = (immediate = false)=>{
            const currentIndex = (0, $bd0377e4b39d9902$export$67691dc66ee99161)(trailSlots);
            if (currentIndex !== -1) retireTrailSlot(trailSlots[currentIndex], immediate);
        };
        const stopTrailSlots = ()=>{
            trailSlots.forEach((slot)=>{
                slot.timeline?.kill();
                releaseTrailSlot(slot);
            });
            window.cancelAnimationFrame(trailMaskFrame);
            trailMaskFrame = null;
            window.cancelAnimationFrame(trailPositionFrame);
            trailPositionFrame = null;
            updateTrailMask();
        };
        const spawnTrailMedia = async (row, point, force = false)=>{
            if (!row || row !== trailActiveRow || !canUseTrail()) return;
            const now = performance.now();
            if (!force && !(0, $bd0377e4b39d9902$export$a1cc2985adc3ca3c)({
                point: point,
                lastPoint: trailLastPoint,
                now: now,
                lastTime: trailLastTime,
                distanceThreshold: $5b52ae0ba33fa205$var$expertiseTrailDistance,
                delayThreshold: $5b52ae0ba33fa205$var$expertiseTrailDelay
            })) return;
            const gallery = rowGalleries.get(row) || [];
            const preferredIndex = (0, $bd0377e4b39d9902$export$bf56099dc16bb73f)(trailGalleryIndex, gallery.length);
            const activationToken = trailActivationToken;
            let selected = force ? null : getReadyGalleryAsset(gallery, preferredIndex);
            trailLastPoint = {
                ...point
            };
            trailLastTime = now;
            if (!selected && force && preferredIndex >= 0) {
                const loadedAsset = await loadGalleryAsset(gallery[preferredIndex]);
                if (!loadedAsset || activationToken !== trailActivationToken || row !== trailActiveRow) return;
                selected = {
                    asset: loadedAsset,
                    index: preferredIndex
                };
            }
            if (!selected || row !== trailActiveRow) return;
            const slotIndex = (0, $bd0377e4b39d9902$export$c32051b5003bd4e3)(trailSlots);
            const slot = trailSlots[slotIndex];
            if (!slot) return;
            if (slot.active) {
                slot.timeline?.kill();
                releaseTrailSlot(slot);
            }
            slot.active = true;
            const previousCurrentIndex = (0, $bd0377e4b39d9902$export$41a66e0937245c04)(trailSlots, slotIndex);
            if (previousCurrentIndex !== -1) retireTrailSlot(trailSlots[previousCurrentIndex]);
            slot.startedAt = now;
            slot.row = row;
            slot.point = {
                ...point
            };
            slot.image.src = selected.asset.resolvedSrc;
            slot.el.classList.remove('is-retiring');
            slot.el.classList.add('is-active', 'is-current');
            const rowTitle = titles[getRowIndex(row)];
            const targetPosition = (0, $bd0377e4b39d9902$export$5c1c7630a61f63f5)({
                layerSize: trailSize,
                point: point,
                rowRect: (rowTitle || row).getBoundingClientRect(),
                viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight
                },
                safePadding: $5b52ae0ba33fa205$var$viewportSafePadding,
                verticalRange: $5b52ae0ba33fa205$var$expertiseTrailVerticalRange
            });
            const sideRotation = getMediaSide(row) === 'left' ? -$5b52ae0ba33fa205$var$mediaBaseRotation : $5b52ae0ba33fa205$var$mediaBaseRotation;
            slot.x = targetPosition.x;
            slot.y = targetPosition.y;
            slot.rotation = sideRotation + gsapInstance.utils.random(-2, 2, 0.1);
            trailStackIndex += 1;
            trailGalleryIndex = (0, $bd0377e4b39d9902$export$bf56099dc16bb73f)(selected.index + 1, gallery.length);
            gsapInstance.set(slot.el, {
                x: slot.x,
                y: slot.y,
                rotation: slot.rotation,
                scale: 0,
                autoAlpha: 1,
                zIndex: trailStackIndex
            });
            gsapInstance.set(slot.overlay, {
                opacity: 0
            });
            scheduleTrailMaskUpdate();
            slot.timeline = gsapInstance.timeline({
                onUpdate: scheduleTrailMaskUpdate,
                onComplete: ()=>{
                    if (slot.state === 'current') slot.timeline = null;
                }
            });
            slot.timeline.to(slot.el, {
                scale: 1,
                duration: $5b52ae0ba33fa205$var$expertiseTrailInDuration,
                ease: 'back.out(1.7)'
            });
        };
        const activateTrail = (row, title, point)=>{
            window.clearTimeout(hideTimer);
            hideTimer = null;
            trailActivationToken += 1;
            trailActiveRow = row;
            trailLastPoint = null;
            trailLastTime = 0;
            trailGalleryIndex = 0;
            displayedRow = row;
            displayedTitle = title;
            commitContrastTitle(row);
            setContrastActive(true, $5b52ae0ba33fa205$var$expertiseTrailInDuration);
            applyTrailContrastMask();
            trailLayer.classList.add('is-visible');
            contrastLayer?.classList.add('is-visible', 'is-motion-active');
            mediaLayer.classList.remove('is-visible', 'is-motion-active', 'is-transitioning');
            pauseAllVideos();
            layerVisible = false;
            measureLayer();
            preloadRowGallery(row, true);
            spawnTrailMedia(row, point, true);
        };
        const deactivateTrail = (immediate = false)=>{
            trailActivationToken += 1;
            trailActiveRow = null;
            trailLastPoint = null;
            trailLastTime = 0;
            if (immediate) stopTrailSlots();
            else {
                retireCurrentTrailSlot(false);
                finishTrailVisibility();
            }
        };
        const settleSlots = (slotIndex)=>{
            slots.forEach((slot, index)=>setSlotImmediate(index, index === slotIndex));
            setContrastActive(true);
            activeSlotIndex = slotIndex;
            playSlotVideo(slots[slotIndex]);
            mediaLayer.classList.remove('is-transitioning');
        };
        const killCrossfade = ()=>{
            window.clearTimeout(pauseTimer);
            pauseTimer = null;
            slots.forEach(cancelSlotPlay);
            if (transitionTimeline) {
                transitionTimeline.kill();
                transitionTimeline = null;
            }
            if (gsapInstance) slots.forEach((slot)=>gsapInstance.killTweensOf(slot.el));
            mediaLayer.classList.remove('is-transitioning');
        };
        const killSlotAnimations = ()=>{
            killCrossfade();
        };
        const updateTarget = (usePointer = true, deltaMs = 1000 / 60)=>{
            if (!displayedRow || !displayedTitle) return;
            const side = getMediaSide(displayedRow);
            const point = usePointer ? pointer : $5b52ae0ba33fa205$var$getTitlePoint(displayedTitle);
            const velocityX = usePointer ? pointerVelocityX : 0;
            const viewportTarget = (0, $bd0377e4b39d9902$export$f1cb57b10176b263)({
                layerSize: layerSize,
                point: point,
                side: side,
                viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight
                },
                safePadding: $5b52ae0ba33fa205$var$viewportSafePadding,
                horizontalBias: {
                    left: $5b52ae0ba33fa205$var$mediaOddCursorBias,
                    right: $5b52ae0ba33fa205$var$mediaEvenCursorBias
                },
                verticalBias: $5b52ae0ba33fa205$var$mediaVerticalCursorBias
            });
            target = {
                x: viewportTarget.x,
                y: viewportTarget.y,
                rotation: isReducedMotion() ? 0 : (0, $bd0377e4b39d9902$export$d1237822648a945)(side, velocityX, $5b52ae0ba33fa205$var$mediaFlattenVelocity, $5b52ae0ba33fa205$var$mediaBaseRotation, $5b52ae0ba33fa205$var$mediaFlattenAmount)
            };
        };
        const seedMotion = (usePointer = true)=>{
            updateTarget(usePointer);
            rendered = {
                ...target
            };
            applyLayerTransform(true);
        };
        const isMotionSettled = ()=>Math.abs(target.x - rendered.x) <= $5b52ae0ba33fa205$var$motionPositionEpsilon && Math.abs(target.y - rendered.y) <= $5b52ae0ba33fa205$var$motionPositionEpsilon && Math.abs(target.rotation - rendered.rotation) <= $5b52ae0ba33fa205$var$motionRotationEpsilon;
        const renderMotion = (_time, deltaTime = 1000 / 60)=>{
            if (!tickerActive || !displayedRow || isTouchMode() || isReducedMotion()) return;
            const safeDelta = (0, $bd0377e4b39d9902$export$7d15b64cf5a3a4c4)(deltaTime, 1, 64);
            updateTarget(true, safeDelta);
            const positionEase = (0, $bd0377e4b39d9902$export$fb613036867c2173)($5b52ae0ba33fa205$var$mediaFollowEase, safeDelta);
            const rotationEase = (0, $bd0377e4b39d9902$export$fb613036867c2173)((0, $bd0377e4b39d9902$export$ca9fd91e91cc9f80)(rendered.rotation, target.rotation, $5b52ae0ba33fa205$var$mediaFlattenEase, $5b52ae0ba33fa205$var$mediaRotationEase), safeDelta);
            rendered = {
                x: rendered.x + (target.x - rendered.x) * positionEase,
                y: rendered.y + (target.y - rendered.y) * positionEase,
                rotation: rendered.rotation + (target.rotation - rendered.rotation) * rotationEase
            };
            if (isMotionSettled()) rendered = {
                ...target
            };
            applyLayerTransform();
            pointerVelocityX += (0 - pointerVelocityX) * (0, $bd0377e4b39d9902$export$fb613036867c2173)($5b52ae0ba33fa205$var$mediaVelocityDecayEase, safeDelta);
            if (isMotionSettled()) stopTicker();
        };
        const fallbackTick = (time)=>{
            if (!tickerActive) return;
            const deltaTime = lastFrameTime ? time - lastFrameTime : 1000 / 60;
            lastFrameTime = time;
            renderMotion(time / 1000, deltaTime);
            if (tickerActive) rafFrame = window.requestAnimationFrame(fallbackTick);
        };
        const startTicker = ()=>{
            if (tickerActive || displayedRow !== activeRow || interactionMode !== 'pointer' || isTouchMode() || isReducedMotion()) return;
            tickerActive = true;
            lastFrameTime = 0;
            if (gsapInstance) {
                gsapInstance.ticker.add(renderMotion);
                return;
            }
            rafFrame = window.requestAnimationFrame(fallbackTick);
        };
        const stopTicker = ()=>{
            if (!tickerActive) return;
            tickerActive = false;
            if (gsapInstance) gsapInstance.ticker.remove(renderMotion);
            else if (rafFrame) window.cancelAnimationFrame(rafFrame);
            rafFrame = null;
            lastFrameTime = 0;
        };
        const syncTicker = ()=>{
            if (displayedRow === activeRow && interactionMode === 'pointer' && !isTouchMode() && !isReducedMotion() && layerVisible) {
                startTicker();
                return;
            }
            stopTicker();
        };
        const showLayer = (withReveal = false)=>{
            const side = displayedRow ? getMediaSide(displayedRow) : 'right';
            window.clearTimeout(hideTimer);
            hideTimer = null;
            layerVisible = true;
            mediaLayer.classList.add('is-visible', 'is-motion-active');
            contrastLayer?.classList.add('is-visible', 'is-motion-active');
            if (!gsapInstance || isReducedMotion()) {
                if (gsapInstance) gsapInstance.set(mediaInner, {
                    xPercent: 0,
                    scale: 1
                });
                syncTicker();
                return;
            }
            gsapInstance.killTweensOf(mediaInner);
            if (withReveal) gsapInstance.fromTo(mediaInner, {
                xPercent: side === 'left' ? -8 : 8,
                scale: 0.96
            }, {
                xPercent: 0,
                scale: 1,
                duration: 0.34,
                ease: 'power3.out'
            });
            else gsapInstance.to(mediaInner, {
                xPercent: 0,
                scale: 1,
                duration: 0.2,
                ease: 'power2.out'
            });
            syncTicker();
        };
        const hideLayer = ()=>{
            if (!layerVisible) {
                contrastLayer?.classList.remove('is-visible', 'is-motion-active');
                setContrastActive(false, $5b52ae0ba33fa205$var$mediaHideDuration);
                idleHiddenContrastTitles();
                pauseAllVideos();
                return;
            }
            layerVisible = false;
            stopTicker();
            mediaLayer.classList.remove('is-visible', 'is-transitioning');
            contrastLayer?.classList.remove('is-visible');
            setContrastActive(false, $5b52ae0ba33fa205$var$mediaHideDuration);
            if (isReducedMotion()) {
                gsapInstance?.set(mediaInner, {
                    xPercent: 0,
                    scale: 1
                });
                mediaLayer.classList.remove('is-motion-active');
                contrastLayer?.classList.remove('is-motion-active');
                idleHiddenContrastTitles();
                pauseAllVideos();
                return;
            }
            if (gsapInstance) {
                gsapInstance.killTweensOf(mediaInner);
                gsapInstance.to(mediaInner, {
                    xPercent: displayedRow && getMediaSide(displayedRow) === 'left' ? -5 : 5,
                    scale: 0.97,
                    duration: $5b52ae0ba33fa205$var$mediaHideDuration,
                    ease: 'power2.out'
                });
            }
            window.clearTimeout(hideTimer);
            hideTimer = window.setTimeout(()=>{
                mediaLayer.classList.remove('is-motion-active');
                contrastLayer?.classList.remove('is-motion-active');
                idleHiddenContrastTitles();
                pauseAllVideos();
            }, $5b52ae0ba33fa205$var$mediaHideDuration * 1000);
        };
        const commitDisplayedMediaContext = (row, title, mode)=>{
            displayedRow = row;
            displayedTitle = title;
            const side = getMediaSide(row);
            const usePointer = mode === 'pointer' && !isTouchMode() && !isReducedMotion();
            mediaLayer.classList.toggle('is-left-side', side === 'left');
            mediaLayer.classList.toggle('is-right-side', side === 'right');
            if (!usePointer) pointer = $5b52ae0ba33fa205$var$getTitlePoint(title);
            commitContrastTitle(row);
            pointerVelocityX = 0;
            lastPointerMoveTime = 0;
            seedMotion(usePointer);
        };
        const crossfadeTo = (slotIndex, mediaContext)=>{
            const { row: row, title: title, mode: mode } = mediaContext;
            const wasHidden = !layerVisible;
            const targetSlot = slots[slotIndex];
            const sameDisplayedContext = displayedRow === row && displayedTitle === title;
            const reusingVisibleTarget = !wasHidden && !sameDisplayedContext && activeSlotIndex === slotIndex && getSlotOpacity(targetSlot) > 0.01;
            killCrossfade();
            if (!wasHidden && sameDisplayedContext && activeSlotIndex === slotIndex && getSlotOpacity(targetSlot) >= 0.99) {
                settleSlots(slotIndex);
                return;
            }
            if (wasHidden) {
                slots.forEach((_slot, index)=>setSlotImmediate(index, false));
                setContrastActive(false);
            }
            const outgoingSlots = slots.filter((slot, index)=>(index !== slotIndex || reusingVisibleTarget) && slot.el.firstElementChild && getSlotOpacity(slot) > 0.01);
            const outgoingElements = outgoingSlots.map((slot)=>slot.el);
            const outgoingOpacity = outgoingSlots.reduce((maximum, slot)=>Math.max(maximum, getSlotOpacity(slot)), 0);
            const fadeOutDuration = Math.max(0.08, $5b52ae0ba33fa205$var$mediaSwitchOutDuration * (0, $bd0377e4b39d9902$export$7d15b64cf5a3a4c4)(outgoingOpacity, 0, 1));
            const commitTargetMediaContext = ()=>{
                const currentMode = row === activeRow ? interactionMode : mode;
                commitDisplayedMediaContext(row, title, currentMode);
            };
            const revealTarget = ()=>{
                targetSlot.el.classList.add('is-active');
                setContrastActive(true);
                activeSlotIndex = slotIndex;
                playSlotVideo(targetSlot);
                syncTicker();
            };
            const hideOutgoing = ()=>{
                outgoingSlots.forEach((slot)=>{
                    slot.el.classList.remove('is-active');
                    pauseSlotVideo(slot);
                });
            };
            targetSlot.el.classList.remove('is-active');
            if (isReducedMotion()) {
                commitTargetMediaContext();
                showLayer(wasHidden);
                settleSlots(slotIndex);
                syncTicker();
                return;
            }
            mediaLayer.classList.add('is-transitioning');
            if (outgoingSlots.length) setContrastActive(false, fadeOutDuration);
            if (!gsapInstance) {
                const startIncomingFade = ()=>{
                    hideOutgoing();
                    commitTargetMediaContext();
                    showLayer(wasHidden);
                    revealTarget();
                    pauseTimer = window.setTimeout(()=>{
                        mediaLayer.classList.remove('is-transitioning');
                    }, $5b52ae0ba33fa205$var$mediaSwitchInDuration * 1000);
                };
                if (!outgoingSlots.length) {
                    startIncomingFade();
                    return;
                }
                outgoingSlots.forEach((slot)=>slot.el.classList.remove('is-active'));
                pauseTimer = window.setTimeout(startIncomingFade, fadeOutDuration * 1000);
                return;
            }
            if (sameDisplayedContext && activeSlotIndex === slotIndex) {
                targetSlot.el.classList.add('is-active');
                setContrastActive(true);
                showLayer(wasHidden);
                transitionTimeline = gsapInstance.timeline({
                    onComplete: ()=>{
                        transitionTimeline = null;
                        settleSlots(slotIndex);
                        syncTicker();
                    }
                });
                transitionTimeline.to(targetSlot.el, {
                    autoAlpha: 1,
                    scale: 1,
                    duration: $5b52ae0ba33fa205$var$mediaSwitchInDuration * (1 - (0, $bd0377e4b39d9902$export$7d15b64cf5a3a4c4)(getSlotOpacity(targetSlot), 0, 1)),
                    ease: 'sine.out'
                });
                return;
            }
            if (!reusingVisibleTarget) gsapInstance.set(targetSlot.el, {
                autoAlpha: 0,
                scale: 0.975
            });
            transitionTimeline = gsapInstance.timeline({
                onComplete: ()=>{
                    transitionTimeline = null;
                    settleSlots(slotIndex);
                    syncTicker();
                }
            });
            if (!outgoingElements.length) {
                commitTargetMediaContext();
                showLayer(wasHidden);
                revealTarget();
                transitionTimeline.to(targetSlot.el, {
                    autoAlpha: 1,
                    scale: 1,
                    duration: $5b52ae0ba33fa205$var$mediaSwitchInDuration,
                    ease: 'sine.out'
                });
                return;
            }
            transitionTimeline.to(outgoingElements, {
                autoAlpha: 0,
                scale: 0.975,
                duration: fadeOutDuration,
                ease: 'sine.inOut'
            }).add(hideOutgoing).add(commitTargetMediaContext).add(revealTarget).to(targetSlot.el, {
                autoAlpha: 1,
                scale: 1,
                duration: $5b52ae0ba33fa205$var$mediaSwitchInDuration,
                ease: 'sine.out'
            });
        };
        const handleMediaFailure = (row, token)=>{
            if (token !== mediaRequestToken || row !== activeRow) return;
            row.classList.add('is-media-unavailable');
            killSlotAnimations();
            hideLayer();
            displayedRow = null;
            displayedTitle = null;
        };
        const transitionMedia = async (row, title, mode, asset = null)=>{
            const token = mediaRequestToken + 1;
            const mediaKey = getMediaKey(row, asset);
            mediaRequestToken = token;
            row.classList.remove('is-media-unavailable');
            killSlotAnimations();
            if (displayedRow !== row) stopTicker();
            if (!hasRowMedia(row)) {
                handleMediaFailure(row, token);
                return;
            }
            const opacities = slots.map((slot)=>slot.el.firstElementChild ? getSlotOpacity(slot) : -1);
            const dominantIndex = (0, $bd0377e4b39d9902$export$6eb45378b3abe542)(opacities, activeSlotIndex);
            if (dominantIndex >= 0) activeSlotIndex = dominantIndex;
            let targetSlotIndex = slots.findIndex((slot)=>slot.key === mediaKey && slot.el.firstElementChild && slot.status !== 'error');
            if (targetSlotIndex < 0) {
                targetSlotIndex = slots.length;
                slots.push(createMediaSlot());
            }
            const ready = await setSlotMedia(slots[targetSlotIndex], row, asset);
            if (token !== mediaRequestToken || row !== activeRow) return;
            if (!ready) {
                handleMediaFailure(row, token);
                return;
            }
            crossfadeTo(targetSlotIndex, {
                row: row,
                title: title,
                mode: mode
            });
        };
        const setActiveRow = (row, event = null, mode = 'pointer', asset = null)=>{
            const title = row.querySelector('[data-expertise-title]');
            if (!title) return;
            activeRow = row;
            activeTitle = title;
            interactionMode = mode;
            pointer = mode === 'pointer' ? $5b52ae0ba33fa205$var$getInteractionPoint(event, title) : $5b52ae0ba33fa205$var$getTitlePoint(title);
            pointerVelocityX = 0;
            lastPointerMoveTime = 0;
            rows.forEach((currentRow, index)=>{
                const isActive = currentRow === row;
                const contrastTitle = contrastTitles[index];
                currentRow.classList.toggle('is-active', isActive);
                titles[index].setAttribute('aria-pressed', String(isActive));
                if (isActive) contrastTitle?.classList.remove('is-flip-idle');
                else if (contrastTitle !== displayedContrastTitle) contrastTitle?.classList.add('is-flip-idle');
                contrastTitles[index]?.classList.toggle('is-flip-active', isActive);
            });
            if (trailActiveRow || trailSlots.some((slot)=>slot.active)) deactivateTrail(true);
            transitionMedia(row, title, mode, asset);
        };
        const clearActiveRow = ({ immediateTrail: immediateTrail = false } = {})=>{
            const wasTrail = interactionMode === 'trail' || !!trailActiveRow || trailSlots.some((slot)=>slot.active);
            window.clearTimeout(hoverLeaveTimer);
            hoverLeaveTimer = null;
            mediaRequestToken += 1;
            stopTicker();
            rows.forEach((row)=>row.classList.remove('is-active', 'is-media-unavailable'));
            titles.forEach((title)=>title.setAttribute('aria-pressed', 'false'));
            contrastTitles.forEach((contrastTitle)=>{
                contrastTitle.classList.remove('is-flip-active');
            });
            if (wasTrail) deactivateTrail(immediateTrail);
            else {
                killSlotAnimations();
                hideLayer();
            }
            activeRow = null;
            activeTitle = null;
            displayedRow = null;
            displayedTitle = null;
            interactionMode = null;
            mediaLayer.classList.remove('is-left-side', 'is-right-side');
        };
        const repositionActiveLayer = ()=>{
            if (!displayedRow || !displayedTitle || displayedRow !== activeRow) return;
            const usePointer = interactionMode === 'pointer' && !isTouchMode() && !isReducedMotion();
            if (!usePointer) {
                pointer = $5b52ae0ba33fa205$var$getTitlePoint(displayedTitle);
                pointerVelocityX = 0;
                lastPointerMoveTime = 0;
            }
            seedMotion(usePointer);
            syncTicker();
        };
        titles.forEach((title)=>{
            const row = title.closest('[data-expertise-row]');
            if (!row) return;
            title.addEventListener('pointerdown', (event)=>{
                if ((0, $bd0377e4b39d9902$export$4fc41e01721ae28)(event.pointerType)) event.preventDefault();
                pointerFocusTitle = title;
                window.requestAnimationFrame(()=>{
                    if (pointerFocusTitle === title) pointerFocusTitle = null;
                });
            });
            title.addEventListener('mouseenter', async (event)=>{
                if (isTouchMode()) return;
                window.clearTimeout(hoverLeaveTimer);
                hoverLeaveTimer = null;
                const hoverToken = (rowHoverTokens.get(row) || 0) + 1;
                rowHoverTokens.set(row, hoverToken);
                preloadRowGallery(row, true);
                const asset = await getNextRowGalleryAsset(row);
                if (rowHoverTokens.get(row) !== hoverToken || !title.matches(':hover') || isTouchMode()) return;
                setActiveRow(row, event, 'pointer', asset);
            });
            title.addEventListener('pointermove', (event)=>{
                if (activeRow !== row || interactionMode !== 'trail' || !canUseTrail()) return;
                pointer = $5b52ae0ba33fa205$var$toClientPoint(event);
                spawnTrailMedia(row, pointer);
            }, {
                passive: true
            });
            title.addEventListener('mouseleave', ()=>{
                if (isTouchMode()) return;
                rowHoverTokens.set(row, (rowHoverTokens.get(row) || 0) + 1);
                window.clearTimeout(hoverLeaveTimer);
                hoverLeaveTimer = window.setTimeout(()=>{
                    hoverLeaveTimer = null;
                    if (activeRow !== row || interactionMode !== 'pointer' && interactionMode !== 'trail') return;
                    if (title === document.activeElement) {
                        if (interactionMode === 'trail') {
                            deactivateTrail(true);
                            interactionMode = 'keyboard';
                            transitionMedia(row, title, 'keyboard');
                        } else {
                            interactionMode = 'keyboard';
                            repositionActiveLayer();
                        }
                        return;
                    }
                    clearActiveRow();
                }, $5b52ae0ba33fa205$var$hoverLeaveDelay);
            });
            title.addEventListener('focus', ()=>{
                if (pointerFocusTitle === title) return;
                setActiveRow(row, null, 'keyboard');
            });
            title.addEventListener('blur', ()=>{
                window.requestAnimationFrame(()=>{
                    if (titles.includes(document.activeElement)) return;
                    if (interactionMode === 'keyboard' || isTouchMode()) clearActiveRow();
                });
            });
            title.addEventListener('click', (event)=>{
                if (!isTouchMode()) return;
                event.preventDefault();
                if (activeRow === row && interactionMode === 'touch' && layerVisible) {
                    clearActiveRow();
                    return;
                }
                setActiveRow(row, event, 'touch');
            });
        });
        section.addEventListener('pointermove', (event)=>{
            if (!activeRow || interactionMode === 'trail' || interactionMode !== 'pointer' || isTouchMode()) return;
            const nextPointer = $5b52ae0ba33fa205$var$toClientPoint(event);
            if (!nextPointer) return;
            const eventTime = Number.isFinite(event.timeStamp) ? event.timeStamp : performance.now();
            const deltaMs = lastPointerMoveTime ? (0, $bd0377e4b39d9902$export$7d15b64cf5a3a4c4)(eventTime - lastPointerMoveTime, 1, 64) : 1000 / 60;
            pointerVelocityX = (nextPointer.x - pointer.x) / (deltaMs / 1000);
            pointer = nextPointer;
            lastPointerMoveTime = eventTime;
            startTicker();
        }, {
            passive: true
        });
        section.addEventListener('pointerleave', ()=>{
            if (isTouchMode()) return;
            if (titles.includes(document.activeElement)) {
                if (interactionMode === 'trail') {
                    const focusedTitle = document.activeElement;
                    const focusedRow = focusedTitle.closest('[data-expertise-row]');
                    deactivateTrail(true);
                    interactionMode = 'keyboard';
                    if (focusedRow) {
                        activeRow = focusedRow;
                        activeTitle = focusedTitle;
                        transitionMedia(focusedRow, focusedTitle, 'keyboard');
                    }
                } else {
                    interactionMode = 'keyboard';
                    repositionActiveLayer();
                }
                return;
            }
            clearActiveRow();
        });
        document.addEventListener('click', (event)=>{
            if (!isTouchMode() || !activeRow || section.contains(event.target)) return;
            clearActiveRow();
        });
        const handleSectionVisibility = (entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) return;
            if (activeRow) clearActiveRow({
                immediateTrail: true
            });
            else if (trailSlots.some((slot)=>slot.active)) deactivateTrail(true);
        };
        const handleSectionViewportFallback = ()=>{
            if (!activeRow && !trailSlots.some((slot)=>slot.active) || sectionVisibilityFrame) return;
            sectionVisibilityFrame = window.requestAnimationFrame(()=>{
                sectionVisibilityFrame = null;
                if ((0, $bd0377e4b39d9902$export$aaae64f52aa818fb)(section.getBoundingClientRect(), window.innerHeight)) clearActiveRow({
                    immediateTrail: true
                });
            });
        };
        const handleResize = ()=>{
            window.cancelAnimationFrame(resizeFrame);
            resizeFrame = window.requestAnimationFrame(()=>{
                measureLayer();
                measureContrastTitles();
                if (interactionMode === 'trail') scheduleTrailPositionUpdate();
                else repositionActiveLayer();
            });
        };
        const handleTouchModeChange = ()=>{
            if (interactionMode === 'trail' || trailSlots.some((slot)=>slot.active)) {
                clearActiveRow({
                    immediateTrail: true
                });
                return;
            }
            repositionActiveLayer();
        };
        const handleStaticMobileChange = ()=>{
            if (staticMobileQuery.matches) clearActiveRow({
                immediateTrail: true
            });
            else mobileStates.forEach(stopMobileAutoplay);
            initMobileMediaLoading();
            syncMobileAutoplay();
        };
        const handleReducedMotionChange = ()=>{
            section.classList.toggle('is-reduced-motion', isReducedMotion());
            syncMobileAutoplay();
            if (!activeRow) {
                if (isReducedMotion()) deactivateTrail(true);
                return;
            }
            if (interactionMode === 'trail') {
                const row = activeRow;
                const title = activeTitle;
                deactivateTrail(true);
                interactionMode = 'pointer';
                transitionMedia(row, title, 'pointer');
                return;
            }
            mediaRequestToken += 1;
            killSlotAnimations();
            repositionActiveLayer();
            transitionMedia(activeRow, activeTitle, interactionMode);
        };
        const handleDocumentVisibility = ()=>{
            if (document.hidden && (trailActiveRow || trailSlots.some((slot)=>slot.active))) clearActiveRow({
                immediateTrail: true
            });
            syncMobileAutoplay();
        };
        window.addEventListener('resize', handleResize, {
            passive: true
        });
        window.addEventListener('scroll', scheduleContrastPositionUpdate, {
            passive: true
        });
        window.addEventListener('scroll', scheduleTrailPositionUpdate, {
            passive: true
        });
        $5b52ae0ba33fa205$var$addMediaQueryListener(touchMediaQuery, handleTouchModeChange);
        $5b52ae0ba33fa205$var$addMediaQueryListener(staticMobileQuery, handleStaticMobileChange);
        $5b52ae0ba33fa205$var$addMediaQueryListener(reducedMotionQuery, handleReducedMotionChange);
        document.addEventListener('visibilitychange', handleDocumentVisibility);
        const sectionVisibilityObserver = typeof window.IntersectionObserver === 'function' ? new window.IntersectionObserver(handleSectionVisibility, {
            threshold: 0
        }) : null;
        if (sectionVisibilityObserver) sectionVisibilityObserver.observe(section);
        else window.addEventListener('scroll', handleSectionViewportFallback, {
            passive: true
        });
        if (typeof window.IntersectionObserver === 'function') {
            sectionPreloadObserver = new window.IntersectionObserver((entries)=>{
                if (!entries.some((entry)=>entry.isIntersecting)) return;
                rows.forEach((row)=>preloadRowGallery(row));
                sectionPreloadObserver.disconnect();
                sectionPreloadObserver = null;
            }, {
                rootMargin: '300px 0px',
                threshold: 0.01
            });
            sectionPreloadObserver.observe(section);
        }
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(()=>{
                measureLayer();
                measureContrastTitles();
                if (interactionMode === 'trail') scheduleTrailPositionUpdate();
                else repositionActiveLayer();
            });
            resizeObserver.observe(mediaLayer);
            if (rowsContainer) resizeObserver.observe(rowsContainer);
        }
        measureLayer();
        measureContrastTitles();
        initMobileMediaLoading();
    });
};
$5b52ae0ba33fa205$var$initExpertiseSection();
window.initExpertiseSection = $5b52ae0ba33fa205$var$initExpertiseSection;


const $60e6c238adcfed92$var$initializedSections = new WeakSet();
const $60e6c238adcfed92$var$getSections = (scope)=>{
    if (scope.matches?.('.case-studies-head-sec')) return [
        scope
    ];
    return Array.from(scope.querySelectorAll('.case-studies-head-sec'));
};
const $60e6c238adcfed92$var$revealSection = (section)=>{
    section.classList.add('is-visible');
};
function $60e6c238adcfed92$export$19512d16aef61b2d(scope = document) {
    if (!scope?.querySelectorAll) return;
    const sections = $60e6c238adcfed92$var$getSections(scope);
    sections.forEach((section)=>{
        if ($60e6c238adcfed92$var$initializedSections.has(section)) return;
        $60e6c238adcfed92$var$initializedSections.add(section);
        const hasBg = !!section.querySelector('.case-studies-head-sec__bg');
        if (!hasBg || typeof IntersectionObserver === 'undefined') {
            $60e6c238adcfed92$var$revealSection(section);
            return;
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                $60e6c238adcfed92$var$revealSection(section);
                observer.unobserve(section);
            });
        }, {
            rootMargin: '0px 0px -18% 0px',
            threshold: 0.2
        });
        observer.observe(section);
    });
}
globalThis.initCaseStudiesHead = $60e6c238adcfed92$export$19512d16aef61b2d;
if (typeof document !== 'undefined' && !document.querySelector('.bold-loader-new')) $60e6c238adcfed92$export$19512d16aef61b2d();



const $f6bd844dee739ccb$var$initializedSections = new WeakMap();
const $f6bd844dee739ccb$var$desktopAutoplayMediaQuery = '(min-width: 1034px)';
const $f6bd844dee739ccb$var$caseStudiesSnapMediaQuery = '(min-width: 641px) and (max-width: 1033px)';
const $f6bd844dee739ccb$var$mobileCaseStudiesMediaQuery = '(max-width: 640px)';
const $f6bd844dee739ccb$var$reducedMotionMediaQuery = '(prefers-reduced-motion: reduce)';
const $f6bd844dee739ccb$var$caseStudiesMediaPreloadRootMargin = '1200px 0px';
const $f6bd844dee739ccb$var$caseStudiesAutoplayDuration = 20;
const $f6bd844dee739ccb$var$caseStudiesDesktopAutoplayDuration = 20;
const $f6bd844dee739ccb$var$caseStudiesFrameDuration = 4;
const $f6bd844dee739ccb$var$caseStudiesMinSlideDuration = 8;
const $f6bd844dee739ccb$var$caseStudiesGalleryMaxFrames = 5;
const $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration = 1.35;
const $f6bd844dee739ccb$var$caseStudiesFillDuration = 1;
const $f6bd844dee739ccb$var$caseStudiesDesktopFrameDuration = 2.4;
const $f6bd844dee739ccb$var$caseStudiesDesktopFadeDuration = 0.6;
const $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio = 0.15;
const $f6bd844dee739ccb$var$caseStudiesSnapTriggerViewportRatio = 0.25;
const $f6bd844dee739ccb$var$caseStudiesSnapReturnViewportRatio = 0.5;
const $f6bd844dee739ccb$var$caseStudiesDesktopSnapTriggerViewportRatio = 0.14;
const $f6bd844dee739ccb$var$caseStudiesDesktopSnapEntryDelay = 600;
const $f6bd844dee739ccb$var$caseStudiesSnapIdleDelay = 900;
const $f6bd844dee739ccb$var$caseStudiesMediaPromises = new WeakMap();
const $f6bd844dee739ccb$var$caseStudiesEntrySnapEvent = 'case-studies:entry-snap';
const $f6bd844dee739ccb$var$caseStudiesEntrySnapCompleteEvent = 'case-studies:entry-snap-complete';
const $f6bd844dee739ccb$var$caseStudiesEntrySnapCancelEvent = 'case-studies:entry-snap-cancel';
const $f6bd844dee739ccb$var$getGsap = ()=>globalThis.gsap;
const $f6bd844dee739ccb$var$getScrollTrigger = ()=>globalThis.ScrollTrigger;
const $f6bd844dee739ccb$var$getCaseStudySections = (scope)=>{
    if (scope.matches?.('[data-case-studies]')) return [
        scope
    ];
    return Array.from(scope.querySelectorAll('[data-case-studies]'));
};
const $f6bd844dee739ccb$var$getOrCreateContentStage = (pinEl)=>{
    const existingStage = pinEl.querySelector('.case-studies-sec__content-stage');
    if (existingStage) return existingStage;
    const stage = document.createElement('div');
    stage.className = 'case-studies-sec__content-stage';
    pinEl.appendChild(stage);
    return stage;
};
const $f6bd844dee739ccb$var$getOrCreateCaseStudiesRail = (line)=>{
    if (!line) return null;
    const existingRail = line.querySelector('.case-studies-sec__line-progress');
    if (existingRail) return existingRail;
    const progressLine = document.createElement('span');
    progressLine.className = 'case-studies-sec__line-progress';
    progressLine.setAttribute('aria-hidden', 'true');
    line.appendChild(progressLine);
    return progressLine;
};
const $f6bd844dee739ccb$var$getCaseStudiesGalleryFrames = (background, frameSelector)=>Array.from(background?.querySelectorAll(frameSelector) ?? []).slice(0, $f6bd844dee739ccb$var$caseStudiesGalleryMaxFrames);
const $f6bd844dee739ccb$var$setCaseStudiesGalleryStart = (gsapInstance, galleryFrames)=>{
    if (!galleryFrames.length) return;
    gsapInstance.set(galleryFrames, {
        clipPath: 'inset(0 0 0 0%)',
        scale: 1,
        opacity: 0,
        zIndex: 0
    });
    gsapInstance.set(galleryFrames[0], {
        opacity: 1,
        zIndex: 1
    });
};
const $f6bd844dee739ccb$var$addCaseStudiesGalleryTransition = (timeline, galleryFrames, fillStart, fillDuration)=>{
    if (galleryFrames.length < 2) return;
    const galleryStepDuration = fillDuration / galleryFrames.length;
    const transitionDuration = 0.6;
    galleryFrames.slice(1).forEach((galleryFrame, index)=>{
        const position = fillStart + galleryStepDuration * (index + 1) - transitionDuration;
        timeline.set(galleryFrame, {
            zIndex: index + 2
        }, position);
        timeline.to(galleryFrame, {
            opacity: 1,
            duration: transitionDuration,
            ease: 'sine.inOut'
        }, position);
        timeline.set(galleryFrames[index], {
            opacity: 0
        }, position + transitionDuration);
    });
};
const $f6bd844dee739ccb$var$canUseCaseStudiesDesktopScene = ()=>typeof window !== 'undefined' && window.matchMedia($f6bd844dee739ccb$var$desktopAutoplayMediaQuery).matches && !window.matchMedia($f6bd844dee739ccb$var$reducedMotionMediaQuery).matches;
const $f6bd844dee739ccb$var$canUseCaseStudiesSnap = ()=>typeof window !== 'undefined' && window.matchMedia($f6bd844dee739ccb$var$caseStudiesSnapMediaQuery).matches && !window.matchMedia($f6bd844dee739ccb$var$reducedMotionMediaQuery).matches;
const $f6bd844dee739ccb$var$clamp = (value, min, max)=>Math.min(max, Math.max(min, value));
const $f6bd844dee739ccb$var$getPinHeight = (pinEl)=>pinEl.offsetHeight;
const $f6bd844dee739ccb$export$a411e05b3828aa92 = (frameCount, defaultDuration = $f6bd844dee739ccb$var$caseStudiesDesktopAutoplayDuration)=>{
    if (!Number.isFinite(frameCount) || frameCount <= 0) return defaultDuration;
    return Math.max($f6bd844dee739ccb$var$caseStudiesMinSlideDuration, frameCount * $f6bd844dee739ccb$var$caseStudiesFrameDuration);
};
const $f6bd844dee739ccb$var$getCaseStudiesSceneDuration = (slideCount)=>slideCount * $f6bd844dee739ccb$var$caseStudiesFillDuration + Math.max(0, slideCount - 1) * $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration;
const $f6bd844dee739ccb$export$207d0a870580af4d = (sceneTrigger, slideCount)=>{
    if (!sceneTrigger || slideCount < 2) return null;
    const sceneDuration = $f6bd844dee739ccb$var$getCaseStudiesSceneDuration(slideCount);
    const lastSlideStart = (slideCount - 1) * ($f6bd844dee739ccb$var$caseStudiesFillDuration + $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration);
    return sceneTrigger.start + lastSlideStart / sceneDuration * (sceneTrigger.end - sceneTrigger.start);
};
const $f6bd844dee739ccb$export$b4f49b8620bf4fdd = (progress, slideCount)=>{
    const position = $f6bd844dee739ccb$var$clamp(progress, 0, 1) * Math.max(0, slideCount - 1);
    const from = Math.floor(position);
    const to = Math.min(from + 1, Math.max(0, slideCount - 1));
    const fraction = position - from;
    const settledIndex = fraction <= $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio ? from : fraction >= 1 - $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio ? to : null;
    return {
        from: settledIndex ?? from,
        to: settledIndex ?? to,
        settledIndex: settledIndex
    };
};
const $f6bd844dee739ccb$export$796d73c51b95e148 = ({ sectionTop: sectionTop, sectionBottom: sectionBottom, viewportHeight: viewportHeight, isScrollingDown: isScrollingDown, hasSnapped: hasSnapped, currentScrollY: currentScrollY, sceneStart: sceneStart, sceneEnd: sceneEnd, enteredFromBelow: enteredFromBelow = false })=>{
    if (hasSnapped) return false;
    if (Number.isFinite(sceneStart) && Number.isFinite(sceneEnd) && Number.isFinite(currentScrollY) && (isScrollingDown ? currentScrollY >= sceneStart : currentScrollY <= sceneEnd && !enteredFromBelow)) return false;
    if (isScrollingDown) return sectionTop > 0 && sectionTop <= viewportHeight * $f6bd844dee739ccb$var$caseStudiesSnapTriggerViewportRatio;
    return sectionTop < 0 && typeof sectionBottom === 'number' && sectionBottom >= viewportHeight * $f6bd844dee739ccb$var$caseStudiesSnapReturnViewportRatio;
};
const $f6bd844dee739ccb$var$loadCaseStudiesMedia = (image)=>{
    if (!image) return Promise.resolve();
    const existingPromise = $f6bd844dee739ccb$var$caseStudiesMediaPromises.get(image);
    if (existingPromise) return existingPromise;
    const source = image.closest('picture')?.querySelector('source[data-srcset]');
    const src = image.dataset.src;
    if (!src) return Promise.resolve();
    const promise = new Promise((resolve)=>{
        let settled = false;
        const finish = ()=>{
            if (settled) return;
            settled = true;
            image.dataset.caseStudiesMediaLoaded = 'true';
            if (typeof image.decode === 'function') {
                image.decode().catch(()=>undefined).finally(resolve);
                return;
            }
            resolve();
        };
        image.addEventListener('load', finish, {
            once: true
        });
        image.addEventListener('error', finish, {
            once: true
        });
        if (source?.dataset.srcset) source.srcset = source.dataset.srcset;
        image.src = src;
        if (image.complete) finish();
    });
    $f6bd844dee739ccb$var$caseStudiesMediaPromises.set(image, promise);
    return promise;
};
const $f6bd844dee739ccb$var$preloadCaseStudiesMedia = (section, mediaSelector)=>Promise.all(Array.from(section.querySelectorAll(mediaSelector)).map($f6bd844dee739ccb$var$loadCaseStudiesMedia));
const $f6bd844dee739ccb$var$initCaseStudiesMediaPreload = (section, mediaSelector)=>{
    if (typeof IntersectionObserver === 'undefined') {
        $f6bd844dee739ccb$var$preloadCaseStudiesMedia(section, mediaSelector);
        return ()=>undefined;
    }
    const observer = new IntersectionObserver((entries)=>{
        if (!entries.some((entry)=>entry.isIntersecting)) return;
        observer.disconnect();
        $f6bd844dee739ccb$var$preloadCaseStudiesMedia(section, mediaSelector);
    }, {
        rootMargin: $f6bd844dee739ccb$var$caseStudiesMediaPreloadRootMargin
    });
    observer.observe(section);
    return ()=>observer.disconnect();
};
const $f6bd844dee739ccb$var$createCaseStudiesScrollSnap = (section)=>{
    let hasSnapped = false;
    let lastScrollY = window.scrollY;
    let isScrollingDown = false;
    let snapTimeout;
    let snapTween;
    let activeSnapDetail;
    let enteredFromBelow = false;
    let isPointerDown = false;
    let destroyed = false;
    const heldScrollKeys = new Set();
    const scrollKeys = new Set([
        ' ',
        'ArrowDown',
        'ArrowUp',
        'PageDown',
        'PageUp',
        'Home',
        'End'
    ]);
    const getSceneTrigger = ()=>$f6bd844dee739ccb$var$getScrollTrigger()?.getAll?.().find((trigger)=>trigger.trigger === section);
    const cancelActiveSnap = ()=>{
        if (!snapTween) return;
        snapTween.kill();
        snapTween = undefined;
        section.dispatchEvent(new CustomEvent($f6bd844dee739ccb$var$caseStudiesEntrySnapCancelEvent, {
            detail: activeSnapDetail
        }));
        activeSnapDetail = undefined;
    };
    const syncSnap = ()=>{
        if (destroyed || isPointerDown || heldScrollKeys.size || snapTween) return;
        const currentScrollY = window.scrollY;
        const rect = section.getBoundingClientRect();
        const sceneTrigger = getSceneTrigger();
        if (!$f6bd844dee739ccb$export$796d73c51b95e148({
            sectionTop: rect.top,
            sectionBottom: rect.bottom,
            viewportHeight: window.innerHeight,
            isScrollingDown: isScrollingDown,
            hasSnapped: hasSnapped,
            currentScrollY: currentScrollY,
            sceneStart: sceneTrigger?.start,
            sceneEnd: sceneTrigger?.end,
            enteredFromBelow: enteredFromBelow
        })) return;
        const slideCount = section.querySelectorAll('.case-studies-sec__slide').length;
        const target = isScrollingDown ? Math.round(currentScrollY + rect.top) : $f6bd844dee739ccb$export$207d0a870580af4d(sceneTrigger, slideCount);
        const gsapInstance = $f6bd844dee739ccb$var$getGsap();
        if (target === null || !gsapInstance) return;
        hasSnapped = true;
        activeSnapDetail = isScrollingDown ? undefined : {
            restartSlideIndex: slideCount - 1
        };
        section.dispatchEvent(new CustomEvent($f6bd844dee739ccb$var$caseStudiesEntrySnapEvent, {
            detail: activeSnapDetail
        }));
        const proxy = {
            value: currentScrollY
        };
        snapTween = gsapInstance.to(proxy, {
            value: target,
            duration: 0.5,
            ease: 'sine.inOut',
            onUpdate: ()=>window.scrollTo(0, proxy.value),
            onComplete: ()=>{
                snapTween = undefined;
                enteredFromBelow = false;
                lastScrollY = window.scrollY;
                section.dispatchEvent(new CustomEvent($f6bd844dee739ccb$var$caseStudiesEntrySnapCompleteEvent, {
                    detail: activeSnapDetail
                }));
                activeSnapDetail = undefined;
            }
        });
    };
    const scheduleSnap = ()=>{
        window.clearTimeout(snapTimeout);
        if (!destroyed && !isPointerDown && !heldScrollKeys.size) snapTimeout = window.setTimeout(syncSnap, $f6bd844dee739ccb$var$caseStudiesSnapIdleDelay);
    };
    const onScroll = ()=>{
        const currentScrollY = window.scrollY;
        const previousScrollY = lastScrollY;
        lastScrollY = currentScrollY;
        if (snapTween || currentScrollY === previousScrollY) return;
        const rect = section.getBoundingClientRect();
        if (rect.top >= window.innerHeight || rect.bottom <= 0) {
            hasSnapped = false;
            enteredFromBelow = false;
        }
        isScrollingDown = currentScrollY > previousScrollY;
        const sceneTrigger = getSceneTrigger();
        if (!isScrollingDown && Number.isFinite(sceneTrigger?.end) && previousScrollY > sceneTrigger.end && currentScrollY <= sceneTrigger.end) enteredFromBelow = true;
        scheduleSnap();
    };
    const onManualInput = (event)=>{
        if (event.type === 'wheel' && (event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX))) return;
        if (event.type === 'keydown') {
            if (!scrollKeys.has(event.key) || event.target?.closest?.('input, textarea, select, [contenteditable="true"]')) return;
            heldScrollKeys.add(event.key);
        }
        if (event.type === 'pointerdown') isPointerDown = true;
        cancelActiveSnap();
        scheduleSnap();
    };
    const releaseManualInput = (event)=>{
        if (event.type === 'keyup') heldScrollKeys.delete(event.key);
        else {
            isPointerDown = false;
            if (event.type === 'blur') heldScrollKeys.clear();
        }
        scheduleSnap();
    };
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    window.addEventListener('wheel', onManualInput, {
        passive: true
    });
    window.addEventListener('pointerdown', onManualInput, {
        passive: true
    });
    window.addEventListener('keydown', onManualInput);
    window.addEventListener('pointerup', releaseManualInput, {
        passive: true
    });
    window.addEventListener('pointercancel', releaseManualInput, {
        passive: true
    });
    window.addEventListener('keyup', releaseManualInput);
    window.addEventListener('blur', releaseManualInput);
    return ()=>{
        destroyed = true;
        cancelActiveSnap();
        window.clearTimeout(snapTimeout);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('wheel', onManualInput);
        window.removeEventListener('pointerdown', onManualInput);
        window.removeEventListener('keydown', onManualInput);
        window.removeEventListener('pointerup', releaseManualInput);
        window.removeEventListener('pointercancel', releaseManualInput);
        window.removeEventListener('keyup', releaseManualInput);
        window.removeEventListener('blur', releaseManualInput);
    };
};
const $f6bd844dee739ccb$var$createMobileCaseStudiesSlider = (section)=>{
    const sliderWrapper = section.querySelector('[data-case-studies-mobile]');
    const sliderEl = sliderWrapper?.querySelector('.swiper');
    const slides = Array.from(sliderWrapper?.querySelectorAll('.case-studies-sec__mobile-slide') ?? []);
    const progressLines = slides.map((slide)=>slide.querySelector('.case-studies-sec__mobile-line-progress'));
    const galleryFrames = slides.map((slide)=>$f6bd844dee739ccb$var$getCaseStudiesGalleryFrames(slide.querySelector('.case-studies-sec__mobile-bg'), '.case-studies-sec__mobile-bg-frame'));
    const allGalleryFrames = galleryFrames.flat();
    const nextEl = sliderWrapper?.querySelector('.swiper-button-next');
    const prevEl = sliderWrapper?.querySelector('.swiper-button-prev');
    const gsapInstance = $f6bd844dee739ccb$var$getGsap();
    const reducedMotion = window.matchMedia($f6bd844dee739ccb$var$reducedMotionMediaQuery).matches;
    if (!sliderWrapper || !sliderEl || sliderEl.swiper || slides.length < 2 || progressLines.some((line)=>!line) || galleryFrames.some((frames)=>!frames.length)) return ()=>undefined;
    const pauseReasons = new Set([
        'viewport'
    ]);
    const canAutoplay = Boolean(gsapInstance && !reducedMotion);
    let swiper;
    let progressTimeline;
    let observer;
    let destroyed = false;
    const resetProgress = ()=>{
        gsapInstance?.set(progressLines, {
            '--case-studies-mobile-progress': 0
        });
    };
    const resetGalleries = ()=>{
        if (!gsapInstance) return;
        galleryFrames.forEach((frames)=>$f6bd844dee739ccb$var$setCaseStudiesGalleryStart(gsapInstance, frames));
    };
    const syncPlayback = ()=>{
        if (!progressTimeline || destroyed) return;
        if (document.hidden) pauseReasons.add('document-hidden');
        else pauseReasons.delete('document-hidden');
        if (pauseReasons.size > 0) {
            progressTimeline.pause();
            return;
        }
        progressTimeline.play();
    };
    const setPauseReason = (reason, shouldPause)=>{
        if (shouldPause) pauseReasons.add(reason);
        else pauseReasons.delete(reason);
        syncPlayback();
    };
    const startProgress = ()=>{
        if (!canAutoplay || !swiper || destroyed) return;
        progressTimeline?.kill();
        resetProgress();
        resetGalleries();
        progressTimeline = gsapInstance.timeline({
            paused: true,
            onComplete: ()=>{
                if (!destroyed) swiper?.slideNext();
            }
        });
        const slideDuration = $f6bd844dee739ccb$export$a411e05b3828aa92(galleryFrames[swiper.realIndex]?.length, $f6bd844dee739ccb$var$caseStudiesAutoplayDuration);
        progressTimeline.to(progressLines[swiper.realIndex], {
            '--case-studies-mobile-progress': 1,
            duration: slideDuration,
            ease: 'none'
        });
        $f6bd844dee739ccb$var$addCaseStudiesGalleryTransition(progressTimeline, galleryFrames[swiper.realIndex], 0, slideDuration);
        syncPlayback();
    };
    const stopProgressForSlideChange = ()=>{
        progressTimeline?.kill();
        progressTimeline = undefined;
        resetProgress();
        resetGalleries();
    };
    const pauseForFocus = ()=>setPauseReason('focus', true);
    const resumeAfterFocusLeaves = ()=>{
        queueMicrotask(()=>{
            if (!sliderWrapper.contains(document.activeElement)) setPauseReason('focus', false);
        });
    };
    section.classList.add('is-mobile-slider');
    swiper = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(sliderEl, {
        modules: [
            (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
        ],
        slidesPerView: 1,
        speed: 450,
        threshold: 10,
        watchOverflow: true,
        rewind: true,
        navigation: nextEl && prevEl ? {
            nextEl: nextEl,
            prevEl: prevEl
        } : undefined,
        on: {
            slideChangeTransitionStart: stopProgressForSlideChange,
            slideChangeTransitionEnd: startProgress,
            touchStart: ()=>progressTimeline?.pause(),
            touchEnd: ()=>{
                if (!swiper.animating) startProgress();
            }
        }
    });
    if (canAutoplay) {
        if (typeof IntersectionObserver === 'undefined') setPauseReason('viewport', false);
        else {
            observer = new IntersectionObserver(([entry])=>{
                setPauseReason('viewport', entry.intersectionRatio < 0.6);
            }, {
                threshold: 0.6
            });
            observer.observe(section);
        }
        document.addEventListener('visibilitychange', syncPlayback);
        sliderWrapper.addEventListener('focusin', pauseForFocus);
        sliderWrapper.addEventListener('focusout', resumeAfterFocusLeaves);
        startProgress();
    }
    return ()=>{
        if (destroyed) return;
        destroyed = true;
        observer?.disconnect();
        progressTimeline?.kill();
        document.removeEventListener('visibilitychange', syncPlayback);
        sliderWrapper.removeEventListener('focusin', pauseForFocus);
        sliderWrapper.removeEventListener('focusout', resumeAfterFocusLeaves);
        gsapInstance?.set([
            ...progressLines,
            ...allGalleryFrames
        ], {
            clearProps: '--case-studies-mobile-progress,transform,clip-path,opacity,zIndex'
        });
        swiper.destroy(true, true);
        section.classList.remove('is-mobile-slider');
    };
};
const $f6bd844dee739ccb$export$fb0a8a5001367f6 = (count)=>count > 0 ? count * $f6bd844dee739ccb$var$caseStudiesDesktopFrameDuration + (count - 1) * $f6bd844dee739ccb$var$caseStudiesDesktopFadeDuration : 0;
const $f6bd844dee739ccb$export$693829f159cbd252 = (frames, progressLine, gsapInstance, options = {})=>{
    const images = frames.map((frame)=>frame.querySelector('img'));
    const setOpacity = frames.map((frame)=>gsapInstance.quickSetter(frame, 'opacity'));
    const setProgress = gsapInstance.quickSetter(progressLine, '--case-studies-progress');
    let playlist = [];
    let preparation;
    let prepared = false;
    let elapsed = 0;
    let renderedIndex = -1;
    let running = false;
    let completed = false;
    let destroyed = false;
    const show = (index)=>{
        frames.forEach((frame, frameIndex)=>setOpacity[frameIndex](frameIndex === index ? 1 : 0));
        gsapInstance.set(frames, {
            zIndex: 0
        });
        if (frames[index]) gsapInstance.set(frames[index], {
            zIndex: 1
        });
    };
    const pause = ()=>{
        running = false;
        gsapInstance.ticker.remove(tick);
    };
    const tick = (_, deltaMilliseconds)=>{
        if (!running || destroyed || !prepared || !playlist.length || completed) return;
        const duration = $f6bd844dee739ccb$export$fb0a8a5001367f6(playlist.length);
        elapsed = Math.min(duration, elapsed + Math.min(deltaMilliseconds / 1000, 0.1));
        const slotDuration = $f6bd844dee739ccb$var$caseStudiesDesktopFrameDuration + $f6bd844dee739ccb$var$caseStudiesDesktopFadeDuration;
        const slot = Math.min(Math.floor((elapsed + 1e-9) / slotDuration), playlist.length - 1);
        const index = playlist[slot];
        if (index !== renderedIndex) {
            show(index);
            renderedIndex = index;
        }
        const fade = elapsed - slot * slotDuration - $f6bd844dee739ccb$var$caseStudiesDesktopFrameDuration;
        if (fade > 0 && slot < playlist.length - 1) {
            const next = playlist[slot + 1];
            gsapInstance.set(frames[next], {
                zIndex: 2
            });
            setOpacity[next]($f6bd844dee739ccb$var$clamp(fade / $f6bd844dee739ccb$var$caseStudiesDesktopFadeDuration, 0, 1));
        }
        setProgress(elapsed / duration);
        if (elapsed >= duration - 1e-9) {
            completed = true;
            setProgress(1);
            pause();
            options.onComplete?.();
        }
    };
    const freezePlaylist = ()=>{
        if (destroyed) return false;
        playlist = images.flatMap((image, index)=>image?.complete && image.naturalWidth > 0 ? [
                index
            ] : []);
        prepared = true;
        show(playlist[0] ?? 0);
        if (running && playlist.length) gsapInstance.ticker.add(tick);
        return playlist.length > 0;
    };
    const prepare = ()=>{
        if (prepared) return Promise.resolve(playlist.length > 0);
        if (preparation) return preparation;
        if (images.every((image)=>image?.complete && image.naturalWidth > 0)) return Promise.resolve(freezePlaylist());
        preparation = Promise.all(images.map((image)=>Promise.resolve().then(()=>(options.loadMedia ?? $f6bd844dee739ccb$var$loadCaseStudiesMedia)(image)).catch(()=>undefined))).then(freezePlaylist);
        return preparation;
    };
    const reset = ()=>{
        pause();
        elapsed = 0;
        completed = false;
        renderedIndex = -1;
        show(playlist[0] ?? 0);
        setProgress(0);
    };
    gsapInstance.set(frames, {
        clipPath: 'inset(0 0 0 0%)',
        scale: 1
    });
    reset();
    return {
        reset: reset,
        pause: pause,
        prepare: prepare,
        isComplete: ()=>completed,
        play: ()=>{
            if (running || destroyed || completed) return;
            running = true;
            if (prepared) {
                if (playlist.length) gsapInstance.ticker.add(tick);
            } else prepare();
        },
        destroy: ()=>{
            destroyed = true;
            pause();
        }
    };
};
const $f6bd844dee739ccb$export$50bf99b9fa0b7931 = ({ scrollY: scrollY, start: start, end: end, slideCount: slideCount, direction: direction, originIndex: originIndex, viewportHeight: viewportHeight, nextSectionTop: nextSectionTop })=>{
    if (!direction || slideCount < 2 || end <= start) return null;
    if (scrollY < start) return direction > 0 && scrollY >= start - viewportHeight * $f6bd844dee739ccb$var$caseStudiesDesktopSnapTriggerViewportRatio ? {
        target: start,
        duration: 0.9,
        delay: $f6bd844dee739ccb$var$caseStudiesDesktopSnapEntryDelay
    } : null;
    if (scrollY > end) return direction < 0 && scrollY <= end + viewportHeight * 0.6 ? {
        target: end,
        duration: 0.7,
        delay: 900
    } : null;
    const step = (end - start) / (slideCount - 1);
    const position = (scrollY - start) / step;
    const state = $f6bd844dee739ccb$export$b4f49b8620bf4fdd((scrollY - start) / (end - start), slideCount);
    let index = state.settledIndex;
    if (index === null) index = direction > 0 ? Math.ceil(position) : Math.floor(position);
    else if (index === originIndex) index += direction;
    let target;
    if (index < 0) target = Math.max(0, start - viewportHeight);
    else if (index >= slideCount) target = nextSectionTop > end ? nextSectionTop : end + viewportHeight;
    else {
        const centre = index === 0 ? $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio / 2 : index === slideCount - 1 ? index - $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio / 2 : index;
        target = start + centre * step;
    }
    return {
        target: target,
        duration: $f6bd844dee739ccb$var$clamp($f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration * Math.abs(target - scrollY) / step, 0.2, $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration),
        delay: 900
    };
};
const $f6bd844dee739ccb$export$c9574f4a902f3100 = (section, getSceneTrigger, slideCount, gsapInstance, options = {})=>{
    const scrollKeys = new Set([
        ' ',
        'ArrowDown',
        'ArrowUp',
        'PageDown',
        'PageUp',
        'Home',
        'End'
    ]);
    const heldKeys = new Set();
    let pointerDown = false;
    let pending = false;
    let direction = 0;
    let originIndex = null;
    let previousY = window.scrollY;
    let expectedY;
    let timeout;
    let tween;
    let destroyed = false;
    let moving = false;
    let automatic = false;
    const isBusy = ()=>pending || moving || pointerDown || heldKeys.size > 0;
    const notify = ()=>options.onStateChange?.();
    const clearTimer = ()=>{
        window.clearTimeout(timeout);
        timeout = undefined;
    };
    const stopTween = ()=>{
        tween?.kill();
        tween = undefined;
        moving = false;
        automatic = false;
        expectedY = undefined;
    };
    const cancel = ()=>{
        clearTimer();
        stopTween();
        pending = false;
        previousY = window.scrollY;
        notify();
    };
    const blocked = ()=>destroyed || document.hidden || section.contains(document.activeElement);
    const getTarget = ()=>{
        const trigger = getSceneTrigger();
        if (!trigger) return null;
        const nextSection = section.nextElementSibling;
        return $f6bd844dee739ccb$export$50bf99b9fa0b7931({
            scrollY: window.scrollY,
            start: trigger.start,
            end: trigger.end,
            slideCount: slideCount,
            direction: direction,
            originIndex: originIndex,
            viewportHeight: window.innerHeight,
            nextSectionTop: nextSection ? window.scrollY + nextSection.getBoundingClientRect().top : undefined
        });
    };
    const moveTo = (target, onComplete)=>{
        if (blocked() || pointerDown || heldKeys.size || !target) return false;
        clearTimer();
        stopTween();
        pending = false;
        moving = true;
        automatic = Boolean(target.automatic);
        if (automatic) {
            direction = 1;
            const trigger = getSceneTrigger();
            originIndex = trigger ? $f6bd844dee739ccb$export$b4f49b8620bf4fdd((window.scrollY - trigger.start) / (trigger.end - trigger.start), slideCount).settledIndex : null;
        }
        const proxy = {
            value: window.scrollY
        };
        tween = gsapInstance.to(proxy, {
            value: target.target,
            duration: target.duration,
            ease: 'sine.inOut',
            onUpdate: ()=>{
                expectedY = proxy.value;
                window.scrollTo(0, proxy.value);
            },
            onComplete: ()=>{
                tween = undefined;
                moving = false;
                previousY = window.scrollY;
                onComplete?.();
                notify();
            }
        });
        notify();
        return true;
    };
    const settle = ()=>{
        timeout = undefined;
        if (!pending || pointerDown || heldKeys.size || blocked()) return;
        const target = getTarget();
        pending = false;
        if (!target || Math.abs(target.target - window.scrollY) <= 2) {
            notify();
            return;
        }
        moveTo(target);
    };
    const schedule = ()=>{
        clearTimer();
        if (!pending || pointerDown || heldKeys.size || blocked()) {
            notify();
            return;
        }
        const target = getTarget();
        timeout = window.setTimeout(settle, target?.delay ?? 900);
        notify();
    };
    const recordInput = (newDirection, fromY)=>{
        if (!newDirection || blocked()) return;
        if (!pending || direction !== newDirection) {
            const trigger = getSceneTrigger();
            originIndex = trigger && fromY >= trigger.start && fromY <= trigger.end ? $f6bd844dee739ccb$export$b4f49b8620bf4fdd((fromY - trigger.start) / (trigger.end - trigger.start), slideCount).settledIndex : null;
        }
        stopTween();
        direction = newDirection;
        pending = true;
        schedule();
    };
    const onWheel = (event)=>{
        if (event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        recordInput(Math.sign(event.deltaY), window.scrollY);
    };
    const onKeyDown = (event)=>{
        if (!scrollKeys.has(event.key) || event.target?.closest?.('input, textarea, select, [contenteditable="true"]')) return;
        heldKeys.add(event.key);
        const backwards = [
            'ArrowUp',
            'PageUp',
            'Home'
        ].includes(event.key) || event.key === ' ' && event.shiftKey;
        recordInput(backwards ? -1 : 1, window.scrollY);
    };
    const onScroll = ()=>{
        const currentY = window.scrollY;
        if (expectedY !== undefined && Math.abs(currentY - expectedY) <= 2) {
            previousY = currentY;
            return;
        }
        if (currentY === previousY) return;
        const fromY = previousY;
        previousY = currentY;
        recordInput(Math.sign(currentY - fromY), fromY);
    };
    const onPointerDown = ()=>{
        pointerDown = true;
        if (tween) pending = true;
        clearTimer();
        stopTween();
        notify();
    };
    const release = (event)=>{
        if (event.type === 'keyup') heldKeys.delete(event.key);
        else pointerDown = false;
        schedule();
    };
    const onBlur = ()=>{
        pointerDown = false;
        heldKeys.clear();
        cancel();
    };
    const onVisibility = ()=>{
        if (document.hidden) onBlur();
    };
    const listeners = [
        [
            window,
            'wheel',
            onWheel
        ],
        [
            window,
            'scroll',
            onScroll
        ],
        [
            window,
            'keydown',
            onKeyDown
        ],
        [
            window,
            'keyup',
            release
        ],
        [
            window,
            'pointerdown',
            onPointerDown
        ],
        [
            window,
            'pointerup',
            release
        ],
        [
            window,
            'pointercancel',
            release
        ],
        [
            window,
            'blur',
            onBlur
        ],
        [
            window,
            'resize',
            cancel
        ],
        [
            document,
            'visibilitychange',
            onVisibility
        ],
        [
            section,
            'focusin',
            cancel
        ]
    ];
    listeners.forEach(([target, event, listener])=>target.addEventListener(event, listener, {
            passive: true
        }));
    const destroy = ()=>{
        destroyed = true;
        cancel();
        listeners.forEach(([target, event, listener])=>target.removeEventListener(event, listener));
    };
    destroy.isBusy = isBusy;
    destroy.shouldCancel = ()=>moving || pending;
    destroy.isAutomatic = ()=>automatic;
    destroy.cancel = cancel;
    destroy.advanceTo = (target, onComplete)=>!isBusy() && moveTo(target, onComplete);
    return destroy;
};
const $f6bd844dee739ccb$var$createCaseStudiesDesktopScene = (section)=>{
    const gsapInstance = $f6bd844dee739ccb$var$getGsap();
    const scrollTrigger = $f6bd844dee739ccb$var$getScrollTrigger();
    const pinEl = section.querySelector('.case-studies-sec__pin');
    const slides = Array.from(section.querySelectorAll('.case-studies-sec__slide'));
    const backgrounds = slides.map((slide)=>slide.querySelector('.case-studies-sec__bg'));
    const galleryFrames = backgrounds.map((background)=>$f6bd844dee739ccb$var$getCaseStudiesGalleryFrames(background, '.case-studies-sec__bg-frame'));
    const contents = slides.map((slide)=>slide.querySelector('.case-studies-sec__content'));
    const progressLines = contents.map((content)=>$f6bd844dee739ccb$var$getOrCreateCaseStudiesRail(content?.querySelector('.case-studies-sec__line')));
    if (!pinEl || !slides.length || backgrounds.some((background)=>!background) || galleryFrames.some((frames)=>!frames.length) || contents.some((content)=>!content) || progressLines.some((line)=>!line) || !gsapInstance || !scrollTrigger) return ()=>undefined;
    const originalContentParents = contents.map((content)=>({
            content: content,
            parent: content.parentElement
        }));
    const contentStage = $f6bd844dee739ccb$var$getOrCreateContentStage(pinEl);
    const galleries = galleryFrames.map((frames, index)=>$f6bd844dee739ccb$export$693829f159cbd252(frames, progressLines[index], gsapInstance, {
            onComplete: ()=>syncPlayback()
        }));
    let sceneTimeline;
    let observer;
    let visible = false;
    let focused = section.contains(document.activeElement);
    let activeIndex = 0;
    let lastSettledIndex = 0;
    const previewed = new Set();
    let destroySnap;
    let preparingAdvance = false;
    let advanceGeneration = 0;
    let destroyed = false;
    const syncPlayback = ()=>{
        if (destroyed) return;
        const allowed = visible && !document.hidden && !focused;
        if ((!visible && destroySnap?.isAutomatic() || document.hidden || focused) && destroySnap?.shouldCancel()) destroySnap.cancel();
        const ready = allowed && !destroySnap?.isBusy() && !sceneTimeline?.scrollTrigger?.getTween()?.isActive();
        galleries.forEach((gallery, index)=>{
            if (index === activeIndex && ready) gallery.play();
            else gallery.pause();
        });
        if (!ready || activeIndex === null || !destroySnap || preparingAdvance || activeIndex === galleries.length - 1 || !galleries[activeIndex].isComplete()) return;
        const origin = activeIndex;
        const generation = advanceGeneration;
        const next = origin + 1;
        preparingAdvance = true;
        const preparation = galleries[next].prepare();
        preparation.then((available)=>{
            if (generation !== advanceGeneration) return;
            preparingAdvance = false;
            if (!available || destroyed || activeIndex !== origin || !galleries[origin].isComplete() || !visible || document.hidden || focused || destroySnap.isBusy()) return;
            const trigger = sceneTimeline?.scrollTrigger;
            const step = trigger ? (trigger.end - trigger.start) / (slides.length - 1) : 0;
            const target = trigger.start + (next === slides.length - 1 ? next - $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio / 2 : next) * step;
            destroySnap.advanceTo({
                target: target,
                duration: $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration,
                automatic: true
            });
        });
    };
    const syncScene = ()=>{
        const state = $f6bd844dee739ccb$export$b4f49b8620bf4fdd(sceneTimeline?.progress() ?? 0, slides.length);
        new Set([
            state.from,
            state.to
        ]).forEach((index)=>{
            if (index !== lastSettledIndex && !previewed.has(index)) {
                galleries[index].reset();
                previewed.add(index);
            }
        });
        if (state.settledIndex !== null && state.settledIndex !== lastSettledIndex) {
            lastSettledIndex = state.settledIndex;
            advanceGeneration += 1;
            preparingAdvance = false;
            previewed.clear();
            galleries[lastSettledIndex + 1]?.prepare();
        }
        activeIndex = state.settledIndex;
        syncPlayback();
    };
    section.classList.add('is-enhanced');
    contents.forEach((content)=>contentStage.appendChild(content));
    gsapInstance.registerPlugin(scrollTrigger);
    gsapInstance.set(backgrounds, {
        yPercent: 100,
        zIndex: 1
    });
    gsapInstance.set(backgrounds[0], {
        yPercent: 0,
        zIndex: 2
    });
    gsapInstance.set(contents, {
        autoAlpha: 0,
        y: 0,
        zIndex: 1
    });
    gsapInstance.set(contents[0], {
        autoAlpha: 1,
        zIndex: 2
    });
    if (slides.length > 1) {
        sceneTimeline = gsapInstance.timeline({
            onUpdate: syncScene,
            scrollTrigger: {
                trigger: section,
                pin: pinEl,
                anticipatePin: 1,
                scrub: 0.85,
                onScrubComplete: syncPlayback,
                start: 'top top',
                end: ()=>`+=${$f6bd844dee739ccb$var$getPinHeight(pinEl) * (slides.length - 1)}`,
                invalidateOnRefresh: true
            }
        });
        slides.slice(0, -1).forEach((slide, index)=>{
            const previousContent = contents[index];
            const nextContent = contents[index + 1];
            const nextBackground = backgrounds[index + 1];
            const transitionDuration = $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration * (1 - 2 * $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio);
            const restDuration = $f6bd844dee739ccb$var$caseStudiesDesktopTransitionDuration * $f6bd844dee739ccb$var$caseStudiesDesktopRestRatio;
            sceneTimeline.to({}, {
                duration: restDuration
            }).to(previousContent, {
                autoAlpha: 0,
                duration: transitionDuration * 0.3,
                ease: 'sine.inOut'
            }).set(previousContent, {
                zIndex: 1
            }).to(nextBackground, {
                yPercent: 0,
                duration: transitionDuration * 0.45,
                ease: 'sine.inOut'
            }).set(nextContent, {
                autoAlpha: 0,
                y: 0,
                zIndex: 2
            }).to(nextContent, {
                autoAlpha: 1,
                y: 0,
                duration: transitionDuration * 0.25,
                ease: 'sine.out'
            }).to({}, {
                duration: restDuration
            });
        });
        syncScene();
    }
    destroySnap = $f6bd844dee739ccb$export$c9574f4a902f3100(section, ()=>sceneTimeline?.scrollTrigger, slides.length, gsapInstance, {
        onStateChange: syncPlayback
    });
    const pauseForFocus = ()=>{
        focused = true;
        syncPlayback();
    };
    const resumeAfterFocusLeaves = ()=>{
        queueMicrotask(()=>{
            focused = section.contains(document.activeElement);
            syncPlayback();
        });
    };
    if (typeof IntersectionObserver === 'undefined') visible = true;
    else {
        observer = new IntersectionObserver(([entry])=>{
            visible = entry.intersectionRatio >= 0.6;
            if (visible) {
                $f6bd844dee739ccb$var$preloadCaseStudiesMedia(section, '[data-case-studies-media]');
                galleries[(activeIndex ?? lastSettledIndex) + 1]?.prepare();
            }
            syncPlayback();
        }, {
            threshold: 0.6
        });
        observer.observe(pinEl);
    }
    document.addEventListener('visibilitychange', syncPlayback);
    section.addEventListener('focusin', pauseForFocus);
    section.addEventListener('focusout', resumeAfterFocusLeaves);
    syncPlayback();
    return ()=>{
        if (destroyed) return;
        destroyed = true;
        observer?.disconnect();
        destroySnap();
        galleries.forEach((gallery)=>gallery.destroy());
        sceneTimeline?.scrollTrigger?.kill();
        sceneTimeline?.kill();
        document.removeEventListener('visibilitychange', syncPlayback);
        section.removeEventListener('focusin', pauseForFocus);
        section.removeEventListener('focusout', resumeAfterFocusLeaves);
        gsapInstance.set([
            ...backgrounds,
            ...galleryFrames.flat(),
            ...contents,
            ...progressLines
        ], {
            clearProps: 'transform,clip-path,visibility,opacity,zIndex,--case-studies-progress'
        });
        originalContentParents.forEach(({ content: content, parent: parent })=>parent?.appendChild(content));
        contentStage.remove();
        section.classList.remove('is-enhanced');
    };
};
function $f6bd844dee739ccb$export$e8ae5caf6764b3bb(scope = document) {
    if (!scope?.querySelectorAll || typeof window === 'undefined') return;
    $f6bd844dee739ccb$var$getCaseStudySections(scope).forEach((section)=>{
        if ($f6bd844dee739ccb$var$initializedSections.has(section)) return;
        const desktopMedia = window.matchMedia($f6bd844dee739ccb$var$desktopAutoplayMediaQuery);
        const snapMedia = window.matchMedia($f6bd844dee739ccb$var$caseStudiesSnapMediaQuery);
        const mobileMedia = window.matchMedia($f6bd844dee739ccb$var$mobileCaseStudiesMediaQuery);
        const reducedMotionMedia = window.matchMedia($f6bd844dee739ccb$var$reducedMotionMediaQuery);
        let destroyAutoplay = ()=>undefined;
        let destroyScrollSnap = ()=>undefined;
        let destroyMobileSlider = ()=>undefined;
        let destroyMediaPreload = ()=>undefined;
        const syncCaseStudiesMode = ()=>{
            destroyAutoplay();
            destroyScrollSnap();
            destroyMobileSlider();
            destroyMediaPreload();
            destroyAutoplay = $f6bd844dee739ccb$var$canUseCaseStudiesDesktopScene() ? $f6bd844dee739ccb$var$createCaseStudiesDesktopScene(section) : ()=>undefined;
            destroyScrollSnap = $f6bd844dee739ccb$var$canUseCaseStudiesSnap() ? $f6bd844dee739ccb$var$createCaseStudiesScrollSnap(section) : ()=>undefined;
            destroyMobileSlider = mobileMedia.matches ? $f6bd844dee739ccb$var$createMobileCaseStudiesSlider(section) : ()=>undefined;
            destroyMediaPreload = $f6bd844dee739ccb$var$initCaseStudiesMediaPreload(section, mobileMedia.matches ? '[data-case-studies-mobile-media]' : '[data-case-studies-media]');
        };
        desktopMedia.addEventListener('change', syncCaseStudiesMode);
        snapMedia.addEventListener('change', syncCaseStudiesMode);
        mobileMedia.addEventListener('change', syncCaseStudiesMode);
        reducedMotionMedia.addEventListener('change', syncCaseStudiesMode);
        $f6bd844dee739ccb$var$initializedSections.set(section, ()=>{
            destroyAutoplay();
            destroyScrollSnap();
            destroyMobileSlider();
            destroyMediaPreload();
            desktopMedia.removeEventListener('change', syncCaseStudiesMode);
            snapMedia.removeEventListener('change', syncCaseStudiesMode);
            mobileMedia.removeEventListener('change', syncCaseStudiesMode);
            reducedMotionMedia.removeEventListener('change', syncCaseStudiesMode);
        });
        syncCaseStudiesMode();
    });
}
globalThis.initCaseStudies = $f6bd844dee739ccb$export$e8ae5caf6764b3bb;
if (typeof document !== 'undefined' && !document.querySelector('.bold-loader-new')) $f6bd844dee739ccb$export$e8ae5caf6764b3bb();


const $8efee52a8d87fad8$var$initializedSections = new WeakMap();
const $8efee52a8d87fad8$var$gradientStates = new WeakMap();
const $8efee52a8d87fad8$var$svgNamespace = 'http://www.w3.org/2000/svg';
const $8efee52a8d87fad8$var$reducedMotionMediaQuery = '(prefers-reduced-motion: reduce)';
const $8efee52a8d87fad8$var$touchPointerMediaQuery = '(hover: none), (pointer: coarse)';
const $8efee52a8d87fad8$var$gradientVisibleRadius = 160;
const $8efee52a8d87fad8$var$gradientTextureOffset = 28;
const $8efee52a8d87fad8$var$gradientAnglePattern = /^linear-gradient\(\s*(-?(?:\d+|\d*\.\d+))deg\s*,/i;
const $8efee52a8d87fad8$var$gradientAngleAmplitude = 95;
const $8efee52a8d87fad8$var$gradientAngleCycleDuration = 7600;
const $8efee52a8d87fad8$var$gradientTransitionDuration = 0.9;
const $8efee52a8d87fad8$var$gradientAmbientIntroDuration = 900;
const $8efee52a8d87fad8$var$gradientFillClass = 'integrations-sec__gradient-fill';
const $8efee52a8d87fad8$var$gradientFillCurrentClass = 'integrations-sec__gradient-fill-current';
const $8efee52a8d87fad8$var$gradientFillNextClass = 'integrations-sec__gradient-fill-next';
const $8efee52a8d87fad8$var$gradientActiveItemClass = 'is-integrations-gradient-active';
const $8efee52a8d87fad8$var$gradientTransitionClass = 'is-integrations-gradient-transitioning';
const $8efee52a8d87fad8$var$nestedInteractiveSelector = 'a, button, input, select, textarea, label, [role="button"], [contenteditable="true"]';
const $8efee52a8d87fad8$var$getGsap = ()=>globalThis.gsap;
const $8efee52a8d87fad8$var$isReducedMotion = ()=>typeof window !== 'undefined' && window.matchMedia?.($8efee52a8d87fad8$var$reducedMotionMediaQuery).matches;
const $8efee52a8d87fad8$var$getSections = (scope)=>{
    if (!scope?.querySelectorAll) return [];
    if (scope.matches?.('.integrations-sec')) return [
        scope
    ];
    return Array.from(scope.querySelectorAll('.integrations-sec'));
};
const $8efee52a8d87fad8$var$getItems = (section)=>Array.from(section.querySelectorAll('.integrations-sec__item'));
const $8efee52a8d87fad8$var$getItemBg = (item)=>item?.querySelector?.('.integrations-sec__item-bg') || null;
const $8efee52a8d87fad8$var$getItemFillGradient = (item)=>{
    const styles = getComputedStyle(item);
    return styles.getPropertyValue('--integrations-item-fill').trim() || styles.getPropertyValue('--integrations-item-border').trim() || 'linear-gradient(270deg, #E5127B 0%, #FF3E07 100%)';
};
const $8efee52a8d87fad8$var$getGradientAngle = (gradient)=>{
    const match = gradient?.match($8efee52a8d87fad8$var$gradientAnglePattern);
    const angle = match ? Number(match[1]) : Number.NaN;
    return Number.isFinite(angle) ? angle : null;
};
const $8efee52a8d87fad8$var$getGradientWithAngle = (gradient, angle)=>{
    if (!Number.isFinite(angle)) return gradient;
    return gradient.replace($8efee52a8d87fad8$var$gradientAnglePattern, `linear-gradient(${angle.toFixed(3)}deg,`);
};
const $8efee52a8d87fad8$var$createGradientLayer = (className)=>{
    const layer = document.createElement('div');
    layer.classList.add(className);
    return layer;
};
const $8efee52a8d87fad8$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $8efee52a8d87fad8$var$setLayerOpacity = (layer, opacity)=>{
    layer.style.opacity = String(opacity);
};
const $8efee52a8d87fad8$var$setGradientProgress = (state, progress)=>{
    state.progress = $8efee52a8d87fad8$var$clamp(progress, 0, 1);
    state.fill.style.setProperty('--gradient-radius', `${state.progress * $8efee52a8d87fad8$var$gradientVisibleRadius}%`);
};
const $8efee52a8d87fad8$var$setGradientOrigin = (state, origin)=>{
    state.originX = $8efee52a8d87fad8$var$clamp(origin.x, 0, 100);
    state.originY = $8efee52a8d87fad8$var$clamp(origin.y, 0, 100);
    state.fill.style.setProperty('--gradient-origin-x', `${state.originX}%`);
    state.fill.style.setProperty('--gradient-origin-y', `${state.originY}%`);
};
const $8efee52a8d87fad8$var$setGradientTexturePosition = (state, position)=>{
    state.textureX = $8efee52a8d87fad8$var$clamp(position.x, 0, 100);
    state.textureY = $8efee52a8d87fad8$var$clamp(position.y, 0, 100);
    state.fill.style.setProperty('--gradient-texture-x', `${state.textureX}%`);
    state.fill.style.setProperty('--gradient-texture-y', `${state.textureY}%`);
};
const $8efee52a8d87fad8$var$setLayerGradient = (layer, gradient)=>{
    layer.style.backgroundImage = gradient;
};
const $8efee52a8d87fad8$var$ensureItemGradientState = (item)=>{
    const existingState = $8efee52a8d87fad8$var$gradientStates.get(item);
    if (existingState?.bg?.isConnected) {
        existingState.gradient = $8efee52a8d87fad8$var$getItemFillGradient(item);
        return existingState;
    }
    const bg = $8efee52a8d87fad8$var$getItemBg(item);
    if (!bg) return null;
    let fill = Array.from(bg.children).find((child)=>child.classList?.contains($8efee52a8d87fad8$var$gradientFillClass));
    if (!fill) {
        fill = document.createElement('div');
        fill.classList.add($8efee52a8d87fad8$var$gradientFillClass);
        bg.appendChild(fill);
    }
    let currentLayer = fill.querySelector(`.${$8efee52a8d87fad8$var$gradientFillCurrentClass}`);
    let nextLayer = fill.querySelector(`.${$8efee52a8d87fad8$var$gradientFillNextClass}`);
    if (!currentLayer) {
        currentLayer = $8efee52a8d87fad8$var$createGradientLayer($8efee52a8d87fad8$var$gradientFillCurrentClass);
        fill.prepend(currentLayer);
    }
    if (!nextLayer) {
        nextLayer = $8efee52a8d87fad8$var$createGradientLayer($8efee52a8d87fad8$var$gradientFillNextClass);
        fill.appendChild(nextLayer);
    }
    const gradient = $8efee52a8d87fad8$var$getItemFillGradient(item);
    const state = {
        item: item,
        bg: bg,
        fill: fill,
        currentLayer: currentLayer,
        nextLayer: nextLayer,
        gradient: gradient,
        progress: 0,
        originX: 50,
        originY: 50,
        textureX: 50,
        textureY: 50,
        timeline: null
    };
    $8efee52a8d87fad8$var$setLayerGradient(currentLayer, gradient);
    $8efee52a8d87fad8$var$setLayerGradient(nextLayer, gradient);
    $8efee52a8d87fad8$var$setLayerOpacity(currentLayer, 1);
    $8efee52a8d87fad8$var$setLayerOpacity(nextLayer, 0);
    $8efee52a8d87fad8$var$setGradientOrigin(state, {
        x: 50,
        y: 50
    });
    $8efee52a8d87fad8$var$setGradientTexturePosition(state, {
        x: 50,
        y: 50
    });
    $8efee52a8d87fad8$var$setGradientProgress(state, 0);
    $8efee52a8d87fad8$var$gradientStates.set(item, state);
    return state;
};
const $8efee52a8d87fad8$var$getLayerOpacity = (layer)=>{
    const gsapInstance = $8efee52a8d87fad8$var$getGsap();
    const opacity = gsapInstance ? Number(gsapInstance.getProperty(layer, 'opacity')) : Number(getComputedStyle(layer).opacity);
    return Number.isFinite(opacity) ? opacity : 1;
};
const $8efee52a8d87fad8$var$getVisibleLayerBackground = (state)=>$8efee52a8d87fad8$var$getLayerOpacity(state.nextLayer) > $8efee52a8d87fad8$var$getLayerOpacity(state.currentLayer) ? state.nextLayer.style.backgroundImage : state.currentLayer.style.backgroundImage;
const $8efee52a8d87fad8$var$getRectBoundaryOrigin = (rect, point)=>{
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const directionX = point.x - centerX;
    const directionY = point.y - centerY;
    if (!directionX && !directionY || !rect.width || !rect.height) return {
        x: 50,
        y: 50
    };
    const horizontalScale = directionX ? rect.width / 2 / Math.abs(directionX) : Number.POSITIVE_INFINITY;
    const verticalScale = directionY ? rect.height / 2 / Math.abs(directionY) : Number.POSITIVE_INFINITY;
    const scale = Math.min(horizontalScale, verticalScale);
    const boundaryX = centerX + directionX * scale;
    const boundaryY = centerY + directionY * scale;
    return {
        x: (boundaryX - rect.left) / rect.width * 100,
        y: (boundaryY - rect.top) / rect.height * 100
    };
};
const $8efee52a8d87fad8$var$getDirectionalOrigins = (sourceItem, targetItem)=>{
    const sourceRect = sourceItem.getBoundingClientRect();
    const targetRect = targetItem.getBoundingClientRect();
    const sourceCenter = {
        x: sourceRect.left + sourceRect.width / 2,
        y: sourceRect.top + sourceRect.height / 2
    };
    const targetCenter = {
        x: targetRect.left + targetRect.width / 2,
        y: targetRect.top + targetRect.height / 2
    };
    return {
        source: $8efee52a8d87fad8$var$getRectBoundaryOrigin(sourceRect, targetCenter),
        target: $8efee52a8d87fad8$var$getRectBoundaryOrigin(targetRect, sourceCenter),
        hasSize: Boolean(sourceRect.width) && Boolean(sourceRect.height) && Boolean(targetRect.width) && Boolean(targetRect.height)
    };
};
const $8efee52a8d87fad8$var$getPointerTexturePosition = (item, event)=>{
    const rect = item.getBoundingClientRect();
    if (!rect.width || !rect.height || !Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return {
        x: 50,
        y: 50
    };
    const positionX = $8efee52a8d87fad8$var$clamp((event.clientX - rect.left) / rect.width, 0, 1);
    const positionY = $8efee52a8d87fad8$var$clamp((event.clientY - rect.top) / rect.height, 0, 1);
    return {
        x: 50 + (positionX - 0.5) * $8efee52a8d87fad8$var$gradientTextureOffset * 2,
        y: 50 + (positionY - 0.5) * $8efee52a8d87fad8$var$gradientTextureOffset * 2
    };
};
const $8efee52a8d87fad8$var$setActiveGradientItem = (items, activeItem)=>{
    items.forEach((item)=>{
        item.classList.toggle($8efee52a8d87fad8$var$gradientActiveItemClass, item === activeItem);
    });
};
const $8efee52a8d87fad8$var$setupGradientHover = (section, container, items, centerItem)=>{
    const states = items.map($8efee52a8d87fad8$var$ensureItemGradientState).filter(Boolean);
    const centerState = $8efee52a8d87fad8$var$gradientStates.get(centerItem);
    if (!centerState || states.length !== items.length) return null;
    let activeItem = centerItem;
    let requestedItem = centerItem;
    let hoverTimeline = null;
    let focusFrame = null;
    let activeGradientStartedAt = null;
    const touchPointerMedia = window.matchMedia?.($8efee52a8d87fad8$var$touchPointerMediaQuery);
    const isTouchPointer = ()=>Boolean(touchPointerMedia?.matches);
    section.classList.add('is-integrations-gradient-ready');
    $8efee52a8d87fad8$var$setActiveGradientItem(items, centerItem);
    const clearTransitionState = ()=>{
        states.forEach((state)=>{
            state.timeline = null;
            state.fill.classList.remove($8efee52a8d87fad8$var$gradientTransitionClass);
        });
    };
    const getMostVisibleState = ()=>{
        const fallbackState = $8efee52a8d87fad8$var$gradientStates.get(activeItem) || centerState;
        return states.reduce((mostVisible, state)=>state.progress > mostVisible.progress ? state : mostVisible, fallbackState);
    };
    const settleGradientState = (targetItem)=>{
        const targetState = $8efee52a8d87fad8$var$gradientStates.get(targetItem) || centerState;
        states.forEach((state)=>{
            const isTarget = state === targetState;
            $8efee52a8d87fad8$var$setGradientProgress(state, isTarget ? 1 : 0);
            $8efee52a8d87fad8$var$setGradientOrigin(state, {
                x: 50,
                y: 50
            });
            $8efee52a8d87fad8$var$setGradientTexturePosition(state, {
                x: 50,
                y: 50
            });
            $8efee52a8d87fad8$var$setLayerOpacity(state.currentLayer, 1);
            $8efee52a8d87fad8$var$setLayerOpacity(state.nextLayer, 0);
            $8efee52a8d87fad8$var$setLayerGradient(state.currentLayer, state.gradient);
            $8efee52a8d87fad8$var$setLayerGradient(state.nextLayer, state.gradient);
            state.fill.classList.remove($8efee52a8d87fad8$var$gradientTransitionClass);
            state.timeline = null;
        });
        activeItem = targetState.item;
        requestedItem = targetState.item;
        activeGradientStartedAt = null;
        $8efee52a8d87fad8$var$setActiveGradientItem(items, targetState.item);
    };
    const animateAmbientGradient = (time)=>{
        const activeState = $8efee52a8d87fad8$var$gradientStates.get(activeItem);
        if (activeState && activeState.progress >= 0.999 && !activeState.timeline && !$8efee52a8d87fad8$var$isReducedMotion()) {
            const baseAngle = $8efee52a8d87fad8$var$getGradientAngle(activeState.gradient);
            if (baseAngle !== null) {
                if (activeGradientStartedAt === null) activeGradientStartedAt = time;
                const elapsed = Math.max(0, time - activeGradientStartedAt);
                const phase = elapsed % $8efee52a8d87fad8$var$gradientAngleCycleDuration / $8efee52a8d87fad8$var$gradientAngleCycleDuration;
                const introProgress = $8efee52a8d87fad8$var$clamp(elapsed / $8efee52a8d87fad8$var$gradientAmbientIntroDuration, 0, 1);
                const angle = baseAngle + Math.sin(phase * Math.PI * 2) * $8efee52a8d87fad8$var$gradientAngleAmplitude * introProgress;
                $8efee52a8d87fad8$var$setLayerGradient(activeState.currentLayer, $8efee52a8d87fad8$var$getGradientWithAngle(activeState.gradient, angle));
            }
        }
        window.requestAnimationFrame(animateAmbientGradient);
    };
    const killGradientTimeline = ()=>{
        hoverTimeline?.kill();
        hoverTimeline = null;
        clearTransitionState();
    };
    const animateGradientOrigin = (timeline, state, origin)=>{
        const targetOrigin = {
            x: $8efee52a8d87fad8$var$clamp(origin.x, 0, 100),
            y: $8efee52a8d87fad8$var$clamp(origin.y, 0, 100)
        };
        if (state.progress <= 0.001 || state.progress >= 0.999) {
            $8efee52a8d87fad8$var$setGradientOrigin(state, targetOrigin);
            return;
        }
        timeline.to(state, {
            originX: targetOrigin.x,
            originY: targetOrigin.y,
            duration: 0.22,
            ease: 'power2.out',
            onUpdate: ()=>$8efee52a8d87fad8$var$setGradientOrigin(state, {
                    x: state.originX,
                    y: state.originY
                })
        }, 0);
    };
    const transitionGradient = (targetItem, { immediate: immediate = false } = {})=>{
        const targetState = $8efee52a8d87fad8$var$gradientStates.get(targetItem);
        if (!targetState) return;
        if (hoverTimeline && requestedItem === targetItem) return;
        const sourceState = getMostVisibleState();
        const origins = $8efee52a8d87fad8$var$getDirectionalOrigins(sourceState.item, targetItem);
        const gsapInstance = $8efee52a8d87fad8$var$getGsap();
        const hasOtherVisibleState = states.some((state)=>state !== targetState && state.progress > 0.001);
        if (!hoverTimeline && sourceState === targetState && targetState.progress >= 0.999 && !hasOtherVisibleState) {
            settleGradientState(targetItem);
            return;
        }
        const incomingGradient = $8efee52a8d87fad8$var$getVisibleLayerBackground(sourceState) || sourceState.gradient;
        killGradientTimeline();
        requestedItem = targetItem;
        if (immediate || $8efee52a8d87fad8$var$isReducedMotion() || !gsapInstance || !origins.hasSize) {
            settleGradientState(targetItem);
            return;
        }
        $8efee52a8d87fad8$var$setLayerGradient(targetState.currentLayer, targetState.gradient);
        $8efee52a8d87fad8$var$setLayerGradient(targetState.nextLayer, incomingGradient);
        $8efee52a8d87fad8$var$setGradientTexturePosition(targetState, {
            x: sourceState.textureX,
            y: sourceState.textureY
        });
        $8efee52a8d87fad8$var$setLayerOpacity(targetState.currentLayer, 0);
        $8efee52a8d87fad8$var$setLayerOpacity(targetState.nextLayer, 1);
        $8efee52a8d87fad8$var$setActiveGradientItem(items, targetItem);
        const outgoingStates = states.filter((state)=>state !== targetState && state.progress > 0.001);
        const transitioningStates = new Set([
            ...outgoingStates,
            targetState
        ]);
        transitioningStates.forEach((state)=>{
            state.fill.classList.add($8efee52a8d87fad8$var$gradientTransitionClass);
        });
        hoverTimeline = gsapInstance.timeline({
            defaults: {
                overwrite: 'auto'
            },
            onComplete: ()=>{
                hoverTimeline = null;
                settleGradientState(targetItem);
            }
        });
        transitioningStates.forEach((state)=>{
            state.timeline = hoverTimeline;
        });
        animateGradientOrigin(hoverTimeline, targetState, origins.target);
        outgoingStates.forEach((state)=>{
            const stateOrigins = state === sourceState ? origins : $8efee52a8d87fad8$var$getDirectionalOrigins(state.item, targetItem);
            animateGradientOrigin(hoverTimeline, state, stateOrigins.source);
        });
        outgoingStates.forEach((state)=>{
            const baseDuration = $8efee52a8d87fad8$var$gradientTransitionDuration;
            const duration = baseDuration * Math.max(0.25, state.progress);
            hoverTimeline.to(state, {
                progress: 0,
                duration: duration,
                ease: 'power3.inOut',
                onUpdate: ()=>$8efee52a8d87fad8$var$setGradientProgress(state, state.progress)
            }, 0);
        });
        hoverTimeline.to(targetState, {
            progress: 1,
            duration: $8efee52a8d87fad8$var$gradientTransitionDuration * Math.max(0.25, 1 - targetState.progress),
            ease: 'power3.inOut',
            onUpdate: ()=>$8efee52a8d87fad8$var$setGradientProgress(targetState, targetState.progress)
        }, 0);
        hoverTimeline.to(targetState.nextLayer, {
            opacity: 0,
            duration: $8efee52a8d87fad8$var$gradientTransitionDuration,
            ease: 'power2.inOut'
        }, 0);
        hoverTimeline.to(targetState.currentLayer, {
            opacity: 1,
            duration: $8efee52a8d87fad8$var$gradientTransitionDuration,
            ease: 'power2.inOut'
        }, 0);
    };
    settleGradientState(centerItem);
    window.requestAnimationFrame(animateAmbientGradient);
    const handlePointerOver = (event)=>{
        if (isTouchPointer() || !event.target?.closest) return;
        const item = event.target.closest('.integrations-sec__item');
        if (!item || !container.contains(item)) return;
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        transitionGradient(item);
    };
    const handlePointerMove = (event)=>{
        if (event.pointerType === 'touch' || $8efee52a8d87fad8$var$isReducedMotion() || hoverTimeline || !event.target?.closest) return;
        const item = event.target.closest('.integrations-sec__item');
        if (!item || !container.contains(item) || item !== activeItem) return;
        const state = $8efee52a8d87fad8$var$gradientStates.get(item);
        if (!state || state.progress < 0.999) return;
        $8efee52a8d87fad8$var$setGradientTexturePosition(state, $8efee52a8d87fad8$var$getPointerTexturePosition(item, event));
    };
    container.addEventListener('pointerover', handlePointerOver);
    container.addEventListener('pointermove', handlePointerMove);
    if (typeof PointerEvent === 'undefined') container.addEventListener('mouseover', handlePointerOver);
    container.addEventListener('pointerleave', ()=>{
        if (!isTouchPointer()) transitionGradient(centerItem);
    });
    container.addEventListener('click', (event)=>{
        if (!isTouchPointer() || !event.target?.closest) return;
        const item = event.target.closest('.integrations-sec__item');
        const interactiveElement = event.target.closest($8efee52a8d87fad8$var$nestedInteractiveSelector);
        if (!item || !container.contains(item) || interactiveElement && item.contains(interactiveElement)) return;
        transitionGradient(item);
    });
    container.addEventListener('focusin', (event)=>{
        const item = event.target?.closest?.('.integrations-sec__item');
        if (item && container.contains(item)) transitionGradient(item);
    });
    container.addEventListener('focusout', ()=>{
        if (focusFrame !== null) window.cancelAnimationFrame(focusFrame);
        focusFrame = window.requestAnimationFrame(()=>{
            focusFrame = null;
            if (!isTouchPointer() && !container.contains(document.activeElement)) transitionGradient(centerItem);
        });
    });
    return {
        refresh () {
            const mostVisibleState = getMostVisibleState();
            killGradientTimeline();
            settleGradientState(mostVisibleState.item);
        }
    };
};
const $8efee52a8d87fad8$var$getOrCreateLinesLayer = (container)=>{
    const existingLayer = Array.from(container.children).find((child)=>child.classList?.contains('integrations-sec__lines'));
    if (existingLayer) return existingLayer;
    const layer = document.createElementNS($8efee52a8d87fad8$var$svgNamespace, 'svg');
    layer.classList.add('integrations-sec__lines');
    layer.setAttribute('aria-hidden', 'true');
    layer.setAttribute('focusable', 'false');
    layer.setAttribute('preserveAspectRatio', 'none');
    container.appendChild(layer);
    return layer;
};
const $8efee52a8d87fad8$var$createLine = (layer, targetItem)=>{
    const line = document.createElementNS($8efee52a8d87fad8$var$svgNamespace, 'line');
    line.classList.add('integrations-sec__line');
    line.style.stroke = getComputedStyle(targetItem).getPropertyValue('--integrations-item-line-color').trim() || '#FF3E07';
    layer.appendChild(line);
    return line;
};
const $8efee52a8d87fad8$var$getRelativeRect = (element, parentRect)=>{
    const rect = element.getBoundingClientRect();
    return {
        left: rect.left - parentRect.left,
        top: rect.top - parentRect.top,
        right: rect.right - parentRect.left,
        bottom: rect.bottom - parentRect.top,
        width: rect.width,
        height: rect.height
    };
};
const $8efee52a8d87fad8$var$getRectCenter = (rect)=>({
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
    });
const $8efee52a8d87fad8$var$getAnchorPoint = (rect, directionX, directionY)=>{
    const absX = Math.abs(directionX);
    const absY = Math.abs(directionY);
    if (absX > 1 && absY > 1) return {
        x: directionX > 0 ? rect.right : rect.left,
        y: directionY > 0 ? rect.bottom : rect.top
    };
    if (absX >= absY) return {
        x: directionX > 0 ? rect.right : rect.left,
        y: rect.top + rect.height / 2
    };
    return {
        x: rect.left + rect.width / 2,
        y: directionY > 0 ? rect.bottom : rect.top
    };
};
const $8efee52a8d87fad8$var$setLinePoint = (line, attribute, value)=>{
    line.setAttribute(attribute, String(Math.round(value * 100) / 100));
};
const $8efee52a8d87fad8$var$initIntegrationsSection = (scope = document)=>{
    $8efee52a8d87fad8$var$getSections(scope).forEach((section)=>{
        const existingInstance = $8efee52a8d87fad8$var$initializedSections.get(section);
        if (existingInstance) {
            existingInstance.requestUpdate();
            existingInstance.gradientHover?.refresh();
            return;
        }
        const container = section.querySelector('.integrations-sec__container');
        const items = $8efee52a8d87fad8$var$getItems(section);
        const centerItem = section.querySelector('.integrations-sec__item--center');
        if (!container || !centerItem || items.length < 2) return;
        const layer = $8efee52a8d87fad8$var$getOrCreateLinesLayer(container);
        const targetItems = items.filter((item)=>item !== centerItem);
        layer.replaceChildren();
        const lines = targetItems.map((item)=>({
                item: item,
                line: $8efee52a8d87fad8$var$createLine(layer, item)
            }));
        let frame = null;
        const gradientHover = $8efee52a8d87fad8$var$setupGradientHover(section, container, items, centerItem);
        const update = ()=>{
            const containerRect = container.getBoundingClientRect();
            if (!containerRect.width || !containerRect.height) return;
            const centerRect = $8efee52a8d87fad8$var$getRelativeRect(centerItem, containerRect);
            const centerPoint = $8efee52a8d87fad8$var$getRectCenter(centerRect);
            layer.setAttribute('viewBox', `0 0 ${containerRect.width} ${containerRect.height}`);
            lines.forEach(({ item: item, line: line })=>{
                const itemRect = $8efee52a8d87fad8$var$getRelativeRect(item, containerRect);
                const itemPoint = $8efee52a8d87fad8$var$getRectCenter(itemRect);
                const directionX = itemPoint.x - centerPoint.x;
                const directionY = itemPoint.y - centerPoint.y;
                const sourcePoint = $8efee52a8d87fad8$var$getAnchorPoint(centerRect, directionX, directionY);
                const targetPoint = $8efee52a8d87fad8$var$getAnchorPoint(itemRect, -directionX, -directionY);
                $8efee52a8d87fad8$var$setLinePoint(line, 'x1', sourcePoint.x);
                $8efee52a8d87fad8$var$setLinePoint(line, 'y1', sourcePoint.y);
                $8efee52a8d87fad8$var$setLinePoint(line, 'x2', targetPoint.x);
                $8efee52a8d87fad8$var$setLinePoint(line, 'y2', targetPoint.y);
            });
        };
        const requestUpdate = ()=>{
            if (frame !== null) return;
            frame = window.requestAnimationFrame(()=>{
                frame = null;
                update();
            });
        };
        let resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(requestUpdate);
            resizeObserver.observe(container);
            items.forEach((item)=>resizeObserver.observe(item));
        }
        window.addEventListener('resize', requestUpdate, {
            passive: true
        });
        window.addEventListener('orientationchange', requestUpdate, {
            passive: true
        });
        const instance = {
            requestUpdate: requestUpdate,
            resizeObserver: resizeObserver,
            gradientHover: gradientHover
        };
        $8efee52a8d87fad8$var$initializedSections.set(section, instance);
        requestUpdate();
    });
};
if (!window.__boldIntegrationsSectionRuntime) {
    window.__boldIntegrationsSectionRuntime = true;
    $8efee52a8d87fad8$var$initIntegrationsSection();
    window.initIntegrationsSection = $8efee52a8d87fad8$var$initIntegrationsSection;
}


/*import { OverlayScrollbars } from 'overlayscrollbars';

if (document.querySelector('[data-scroll]')) {
  const scrollElArr = document.querySelectorAll('[data-scroll]');
  scrollElArr.forEach((scrollEl) => {
    const osInstance = OverlayScrollbars(scrollEl, {});
  });
}*/ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $456a24904ebe47f5$var$extendStatics = function(d, b) {
    $456a24904ebe47f5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $456a24904ebe47f5$var$extendStatics(d, b);
};
function $456a24904ebe47f5$export$a8ba968b8961cb8a(d, b) {
    $456a24904ebe47f5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $456a24904ebe47f5$export$18ce0697a983be9b = function() {
    $456a24904ebe47f5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $456a24904ebe47f5$export$18ce0697a983be9b.apply(this, arguments);
};
function $456a24904ebe47f5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $456a24904ebe47f5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $456a24904ebe47f5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $456a24904ebe47f5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $456a24904ebe47f5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $456a24904ebe47f5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $456a24904ebe47f5$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $456a24904ebe47f5$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $456a24904ebe47f5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $456a24904ebe47f5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $456a24904ebe47f5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($456a24904ebe47f5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $456a24904ebe47f5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $456a24904ebe47f5$export$10c90e4f7922046c(v) {
    return this instanceof $456a24904ebe47f5$export$10c90e4f7922046c ? (this.v = v, this) : new $456a24904ebe47f5$export$10c90e4f7922046c(v);
}
function $456a24904ebe47f5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $456a24904ebe47f5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $456a24904ebe47f5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $456a24904ebe47f5$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $456a24904ebe47f5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $456a24904ebe47f5$export$19a8beecd37a4c45 === "function" ? $456a24904ebe47f5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $456a24904ebe47f5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $456a24904ebe47f5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $456a24904ebe47f5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $456a24904ebe47f5$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $456a24904ebe47f5$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}





var $94024c8af2010ac2$var$eventListenerOptions;
var $94024c8af2010ac2$var$eventMap = new WeakMap();
function $94024c8af2010ac2$var$getOptions() {
    if ($94024c8af2010ac2$var$eventListenerOptions !== undefined) return $94024c8af2010ac2$var$eventListenerOptions;
    var supportPassiveEvent = false;
    try {
        var noop = function() {};
        var options = Object.defineProperty({}, 'passive', {
            enumerable: true,
            get: function() {
                supportPassiveEvent = true;
                return true;
            }
        });
        window.addEventListener('testPassive', noop, options);
        window.removeEventListener('testPassive', noop, options);
    } catch (e) {}
    $94024c8af2010ac2$var$eventListenerOptions = supportPassiveEvent ? {
        passive: false
    } : false;
    return $94024c8af2010ac2$var$eventListenerOptions;
}
function $94024c8af2010ac2$export$cfedec40817575fe(scrollbar) {
    var configs = $94024c8af2010ac2$var$eventMap.get(scrollbar) || [];
    $94024c8af2010ac2$var$eventMap.set(scrollbar, configs);
    return function addEvent(elem, events, fn) {
        function handler(event) {
            // ignore default prevented events
            if (event.defaultPrevented) return;
            fn(event);
        }
        events.split(/\s+/g).forEach(function(eventName) {
            configs.push({
                elem: elem,
                eventName: eventName,
                handler: handler
            });
            elem.addEventListener(eventName, handler, $94024c8af2010ac2$var$getOptions());
        });
    };
}
function $94024c8af2010ac2$export$2bf7a27f443e4893(scrollbar) {
    var configs = $94024c8af2010ac2$var$eventMap.get(scrollbar);
    if (!configs) return;
    configs.forEach(function(_a) {
        var elem = _a.elem, eventName = _a.eventName, handler = _a.handler;
        elem.removeEventListener(eventName, handler, $94024c8af2010ac2$var$getOptions());
    });
    $94024c8af2010ac2$var$eventMap.delete(scrollbar);
}


/**
 * Get pointer/touch data
 */ function $ac553971bdc7eda7$export$f7b14ec3e1349d05(evt) {
    // if is touch event, return last item in touchList
    // else return original event
    return evt.touches ? evt.touches[evt.touches.length - 1] : evt;
}



function $0009ce504af9b470$export$1690e12b840569b9(evt) {
    var data = (0, $ac553971bdc7eda7$export$f7b14ec3e1349d05)(evt);
    return {
        x: data.clientX,
        y: data.clientY
    };
}


/**
 * Check if `a` is one of `[...b]`
 */ function $295e49b2ddab6e10$export$532a90c0e5e8e48c(a, b) {
    if (b === void 0) b = [];
    return b.some(function(v) {
        return a === v;
    });
}


var $eab04834fceb44be$var$VENDOR_PREFIX = [
    'webkit',
    'moz',
    'ms',
    'o'
];
var $eab04834fceb44be$var$RE = new RegExp("^-(?!(?:" + $eab04834fceb44be$var$VENDOR_PREFIX.join('|') + ")-)");
function $eab04834fceb44be$var$autoPrefix(styles) {
    var res = {};
    Object.keys(styles).forEach(function(prop) {
        if (!$eab04834fceb44be$var$RE.test(prop)) {
            res[prop] = styles[prop];
            return;
        }
        var val = styles[prop];
        prop = prop.replace(/^-/, '');
        res[prop] = val;
        $eab04834fceb44be$var$VENDOR_PREFIX.forEach(function(prefix) {
            res["-" + prefix + "-" + prop] = val;
        });
    });
    return res;
}
function $eab04834fceb44be$export$37a5fde709c1db82(elem, styles) {
    styles = $eab04834fceb44be$var$autoPrefix(styles);
    Object.keys(styles).forEach(function(prop) {
        var cssProp = prop.replace(/^-/, '').replace(/-([a-z])/g, function(_, $1) {
            return $1.toUpperCase();
        });
        elem.style[cssProp] = styles[prop];
    });
}




var $e0fb56283bea6912$export$254d9747e34ddc90 = /** @class */ function() {
    function Tracker(touch) {
        this.velocityMultiplier = window.devicePixelRatio;
        this.updateTime = Date.now();
        this.delta = {
            x: 0,
            y: 0
        };
        this.velocity = {
            x: 0,
            y: 0
        };
        this.lastPosition = {
            x: 0,
            y: 0
        };
        this.lastPosition = (0, $0009ce504af9b470$export$1690e12b840569b9)(touch);
    }
    Tracker.prototype.update = function(touch) {
        var _a = this, velocity = _a.velocity, updateTime = _a.updateTime, lastPosition = _a.lastPosition;
        var now = Date.now();
        var position = (0, $0009ce504af9b470$export$1690e12b840569b9)(touch);
        var delta = {
            x: -(position.x - lastPosition.x),
            y: -(position.y - lastPosition.y)
        };
        var duration = now - updateTime || 16.7;
        var vx = delta.x / duration * 16.7;
        var vy = delta.y / duration * 16.7;
        velocity.x = vx * this.velocityMultiplier;
        velocity.y = vy * this.velocityMultiplier;
        this.delta = delta;
        this.updateTime = now;
        this.lastPosition = position;
    };
    return Tracker;
}();
var $e0fb56283bea6912$export$9da4f16074124683 = /** @class */ function() {
    function TouchRecord() {
        this._touchList = {};
    }
    Object.defineProperty(TouchRecord.prototype, "_primitiveValue", {
        get: function() {
            return {
                x: 0,
                y: 0
            };
        },
        enumerable: true,
        configurable: true
    });
    TouchRecord.prototype.isActive = function() {
        return this._activeTouchID !== undefined;
    };
    TouchRecord.prototype.getDelta = function() {
        var tracker = this._getActiveTracker();
        if (!tracker) return this._primitiveValue;
        return (0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, tracker.delta);
    };
    TouchRecord.prototype.getVelocity = function() {
        var tracker = this._getActiveTracker();
        if (!tracker) return this._primitiveValue;
        return (0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, tracker.velocity);
    };
    TouchRecord.prototype.getEasingDistance = function(damping) {
        var deAcceleration = 1 - damping;
        var distance = {
            x: 0,
            y: 0
        };
        var vel = this.getVelocity();
        Object.keys(vel).forEach(function(dir) {
            // ignore small velocity
            var v = Math.abs(vel[dir]) <= 10 ? 0 : vel[dir];
            while(v !== 0){
                distance[dir] += v;
                v = v * deAcceleration | 0;
            }
        });
        return distance;
    };
    TouchRecord.prototype.track = function(evt) {
        var _this = this;
        var targetTouches = evt.targetTouches;
        Array.from(targetTouches).forEach(function(touch) {
            _this._add(touch);
        });
        return this._touchList;
    };
    TouchRecord.prototype.update = function(evt) {
        var _this = this;
        var touches = evt.touches, changedTouches = evt.changedTouches;
        Array.from(touches).forEach(function(touch) {
            _this._renew(touch);
        });
        this._setActiveID(changedTouches);
        return this._touchList;
    };
    TouchRecord.prototype.release = function(evt) {
        var _this = this;
        delete this._activeTouchID;
        Array.from(evt.changedTouches).forEach(function(touch) {
            _this._delete(touch);
        });
    };
    TouchRecord.prototype._add = function(touch) {
        if (this._has(touch)) // reset tracker
        this._delete(touch);
        var tracker = new $e0fb56283bea6912$export$254d9747e34ddc90(touch);
        this._touchList[touch.identifier] = tracker;
    };
    TouchRecord.prototype._renew = function(touch) {
        if (!this._has(touch)) return;
        var tracker = this._touchList[touch.identifier];
        tracker.update(touch);
    };
    TouchRecord.prototype._delete = function(touch) {
        delete this._touchList[touch.identifier];
    };
    TouchRecord.prototype._has = function(touch) {
        return this._touchList.hasOwnProperty(touch.identifier);
    };
    TouchRecord.prototype._setActiveID = function(touches) {
        this._activeTouchID = touches[touches.length - 1].identifier;
    };
    TouchRecord.prototype._getActiveTracker = function() {
        var _a = this, _touchList = _a._touchList, _activeTouchID = _a._activeTouchID;
        return _touchList[_activeTouchID];
    };
    return TouchRecord;
}();


function $e996164389bf165c$export$7d15b64cf5a3a4c4(value, lower, upper) {
    return Math.max(lower, Math.min(upper, value));
}


function $b849c840bfa8c4c3$export$61fc7d43ac8f84b0(fn, wait, leading) {
    if (wait === void 0) wait = 0;
    var timer;
    var lastCalledAt = -Infinity;
    return function debouncedFn() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (leading) {
            var now = Date.now();
            var elapsed = now - lastCalledAt;
            lastCalledAt = now;
            if (elapsed >= wait) fn.apply(this, args);
        }
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, wait);
    };
}






function $4d36a8e05137ba49$export$d02631cccf789723(min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    return function(proto, key) {
        var alias = "_" + key;
        Object.defineProperty(proto, key, {
            get: function() {
                return this[alias];
            },
            set: function(val) {
                Object.defineProperty(this, alias, {
                    value: (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(val, min, max),
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
            },
            enumerable: true,
            configurable: true
        });
    };
}


function $210df718c763a65b$export$4a21f16c33752377(proto, key) {
    var alias = "_" + key;
    Object.defineProperty(proto, key, {
        get: function() {
            return this[alias];
        },
        set: function(val) {
            Object.defineProperty(this, alias, {
                value: !!val,
                enumerable: false,
                writable: true,
                configurable: true
            });
        },
        enumerable: true,
        configurable: true
    });
}




function $6453bbf79afc2be9$export$61fc7d43ac8f84b0() {
    var options = [];
    for(var _i = 0; _i < arguments.length; _i++)options[_i] = arguments[_i];
    return function(_proto, key, descriptor) {
        var fn = descriptor.value;
        return {
            get: function() {
                if (!this.hasOwnProperty(key)) Object.defineProperty(this, key, {
                    value: (0, $b849c840bfa8c4c3$export$61fc7d43ac8f84b0).apply(void 0, (0, $456a24904ebe47f5$export$6388937ca91ccae8)([
                        fn
                    ], options))
                });
                return this[key];
            }
        };
    };
}




var $050dfaa5fddaad28$export$c019608e5b5bb4cb = /** @class */ function() {
    function Options(config) {
        var _this = this;
        if (config === void 0) config = {};
        /**
         * Momentum reduction damping factor, a float value between `(0, 1)`.
         * The lower the value is, the more smooth the scrolling will be
         * (also the more paint frames).
         */ this.damping = 0.1;
        /**
         * Minimal size for scrollbar thumbs.
         */ this.thumbMinSize = 20;
        /**
         * Render every frame in integer pixel values
         * set to `true` to improve scrolling performance.
         */ this.renderByPixels = true;
        /**
         * Keep scrollbar tracks visible
         */ this.alwaysShowTracks = false;
        /**
         * Set to `true` to allow outer scrollbars continue scrolling
         * when current scrollbar reaches edge.
         */ this.continuousScrolling = true;
        /**
         * Delegate wheel events and touch events to the given element.
         * By default, the container element is used.
         * This option will be useful for dealing with fixed elements.
         */ this.delegateTo = null;
        /**
         * Options for plugins. Syntax:
         *   plugins[pluginName] = pluginOptions: any
         */ this.plugins = {};
        Object.keys(config).forEach(function(prop) {
            _this[prop] = config[prop];
        });
    }
    Object.defineProperty(Options.prototype, "wheelEventTarget", {
        get: function() {
            return this.delegateTo;
        },
        set: function(el) {
            console.warn('[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead.');
            this.delegateTo = el;
        },
        enumerable: true,
        configurable: true
    });
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $4d36a8e05137ba49$export$d02631cccf789723)(0, 1)
    ], Options.prototype, "damping", void 0);
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $4d36a8e05137ba49$export$d02631cccf789723)(0, Infinity)
    ], Options.prototype, "thumbMinSize", void 0);
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $210df718c763a65b$export$4a21f16c33752377)
    ], Options.prototype, "renderByPixels", void 0);
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $210df718c763a65b$export$4a21f16c33752377)
    ], Options.prototype, "alwaysShowTracks", void 0);
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $210df718c763a65b$export$4a21f16c33752377)
    ], Options.prototype, "continuousScrolling", void 0);
    return Options;
}();





var $975e805c9d0e1583$export$2d4c17c1fb94ad57;
(function(TrackDirection) {
    TrackDirection["X"] = "x";
    TrackDirection["Y"] = "y";
})($975e805c9d0e1583$export$2d4c17c1fb94ad57 || ($975e805c9d0e1583$export$2d4c17c1fb94ad57 = {}));



var $4e764f5437480042$export$2d610e681b8dabf8 = /** @class */ function() {
    function ScrollbarThumb(_direction, _minSize) {
        if (_minSize === void 0) _minSize = 0;
        this._direction = _direction;
        this._minSize = _minSize;
        /**
         * Thumb element
         */ this.element = document.createElement('div');
        /**
         * Display size of the thumb
         * will always be greater than `scrollbar.options.thumbMinSize`
         */ this.displaySize = 0;
        /**
         * Actual size of the thumb
         */ this.realSize = 0;
        /**
         * Thumb offset to the top
         */ this.offset = 0;
        this.element.className = "scrollbar-thumb scrollbar-thumb-" + _direction;
    }
    /**
     * Attach to track element
     *
     * @param trackEl Track element
     */ ScrollbarThumb.prototype.attachTo = function(trackEl) {
        trackEl.appendChild(this.element);
    };
    ScrollbarThumb.prototype.update = function(scrollOffset, containerSize, pageSize) {
        // calculate thumb size
        // pageSize > containerSize -> scrollable
        this.realSize = Math.min(containerSize / pageSize, 1) * containerSize;
        this.displaySize = Math.max(this.realSize, this._minSize);
        // calculate thumb offset
        this.offset = scrollOffset / pageSize * (containerSize + (this.realSize - this.displaySize));
        (0, $eab04834fceb44be$export$37a5fde709c1db82)(this.element, this._getStyle());
    };
    ScrollbarThumb.prototype._getStyle = function() {
        switch(this._direction){
            case (0, $975e805c9d0e1583$export$2d4c17c1fb94ad57).X:
                return {
                    width: this.displaySize + "px",
                    '-transform': "translate3d(" + this.offset + "px, 0, 0)"
                };
            case (0, $975e805c9d0e1583$export$2d4c17c1fb94ad57).Y:
                return {
                    height: this.displaySize + "px",
                    '-transform': "translate3d(0, " + this.offset + "px, 0)"
                };
            default:
                return null;
        }
    };
    return ScrollbarThumb;
}();



var $70279ce3b4829e8b$export$9e82a9d3e0d2088 = /** @class */ function() {
    function ScrollbarTrack(direction, thumbMinSize) {
        if (thumbMinSize === void 0) thumbMinSize = 0;
        /**
         * Track element
         */ this.element = document.createElement('div');
        this._isShown = false;
        this.element.className = "scrollbar-track scrollbar-track-" + direction;
        this.thumb = new (0, $4e764f5437480042$export$2d610e681b8dabf8)(direction, thumbMinSize);
        this.thumb.attachTo(this.element);
    }
    /**
     * Attach to scrollbar container element
     *
     * @param scrollbarContainer Scrollbar container element
     */ ScrollbarTrack.prototype.attachTo = function(scrollbarContainer) {
        scrollbarContainer.appendChild(this.element);
    };
    /**
     * Show track immediately
     */ ScrollbarTrack.prototype.show = function() {
        if (this._isShown) return;
        this._isShown = true;
        this.element.classList.add('show');
    };
    /**
     * Hide track immediately
     */ ScrollbarTrack.prototype.hide = function() {
        if (!this._isShown) return;
        this._isShown = false;
        this.element.classList.remove('show');
    };
    ScrollbarTrack.prototype.update = function(scrollOffset, containerSize, pageSize) {
        (0, $eab04834fceb44be$export$37a5fde709c1db82)(this.element, {
            display: pageSize <= containerSize ? 'none' : 'block'
        });
        this.thumb.update(scrollOffset, containerSize, pageSize);
    };
    return ScrollbarTrack;
}();




var $f6af8dbf2d32d8a2$export$40a0242a5dec07f5 = /** @class */ function() {
    function TrackController(_scrollbar) {
        this._scrollbar = _scrollbar;
        var thumbMinSize = _scrollbar.options.thumbMinSize;
        this.xAxis = new (0, $70279ce3b4829e8b$export$9e82a9d3e0d2088)((0, $975e805c9d0e1583$export$2d4c17c1fb94ad57).X, thumbMinSize);
        this.yAxis = new (0, $70279ce3b4829e8b$export$9e82a9d3e0d2088)((0, $975e805c9d0e1583$export$2d4c17c1fb94ad57).Y, thumbMinSize);
        this.xAxis.attachTo(_scrollbar.containerEl);
        this.yAxis.attachTo(_scrollbar.containerEl);
        if (_scrollbar.options.alwaysShowTracks) {
            this.xAxis.show();
            this.yAxis.show();
        }
    }
    /**
     * Updates track appearance
     */ TrackController.prototype.update = function() {
        var _a = this._scrollbar, size = _a.size, offset = _a.offset;
        this.xAxis.update(offset.x, size.container.width, size.content.width);
        this.yAxis.update(offset.y, size.container.height, size.content.height);
    };
    /**
     * Automatically hide tracks when scrollbar is in idle state
     */ TrackController.prototype.autoHideOnIdle = function() {
        if (this._scrollbar.options.alwaysShowTracks) return;
        this.xAxis.hide();
        this.yAxis.hide();
    };
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $6453bbf79afc2be9$export$61fc7d43ac8f84b0)(300)
    ], TrackController.prototype, "autoHideOnIdle", null);
    return TrackController;
}();


function $1f0809682f887b7f$export$31b21d0167753bb4(scrollbar) {
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    var containerStyles = getComputedStyle(containerEl);
    var paddings = [
        'paddingTop',
        'paddingBottom',
        'paddingLeft',
        'paddingRight'
    ].map(function(prop) {
        return containerStyles[prop] ? parseFloat(containerStyles[prop]) : 0;
    });
    var verticalPadding = paddings[0] + paddings[1];
    var horizontalPadding = paddings[2] + paddings[3];
    return {
        container: {
            // requires `overflow: hidden`
            width: containerEl.clientWidth,
            height: containerEl.clientHeight
        },
        content: {
            // border width and paddings should be included
            width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth + horizontalPadding,
            height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight + verticalPadding
        }
    };
}


function $46b7de144766f350$export$795910f5f15a9633(scrollbar, elem) {
    var bounding = scrollbar.bounding;
    var targetBounding = elem.getBoundingClientRect();
    // check overlapping
    var top = Math.max(bounding.top, targetBounding.top);
    var left = Math.max(bounding.left, targetBounding.left);
    var right = Math.min(bounding.right, targetBounding.right);
    var bottom = Math.min(bounding.bottom, targetBounding.bottom);
    return top < bottom && left < right;
}


function $e0eba474fbe25cf7$export$722fbec263ad908a(scrollbar) {
    var newSize = scrollbar.getSize();
    var limit = {
        x: Math.max(newSize.content.width - newSize.container.width, 0),
        y: Math.max(newSize.content.height - newSize.container.height, 0)
    };
    // metrics
    var containerBounding = scrollbar.containerEl.getBoundingClientRect();
    var bounding = {
        top: Math.max(containerBounding.top, 0),
        right: Math.min(containerBounding.right, window.innerWidth),
        bottom: Math.min(containerBounding.bottom, window.innerHeight),
        left: Math.max(containerBounding.left, 0)
    };
    // assign props
    scrollbar.size = newSize;
    scrollbar.limit = limit;
    scrollbar.bounding = bounding;
    // update tracks
    scrollbar.track.update();
    // re-positioning
    scrollbar.setPosition();
}







function $3f7a2cd3f63d716e$export$f9b088a47202d605(scrollbar, x, y) {
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit, track = scrollbar.track, contentEl = scrollbar.contentEl;
    if (options.renderByPixels) {
        x = Math.round(x);
        y = Math.round(y);
    }
    x = (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(x, 0, limit.x);
    y = (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(y, 0, limit.y);
    // position changed -> show track for 300ms
    if (x !== offset.x) track.xAxis.show();
    if (y !== offset.y) track.yAxis.show();
    if (!options.alwaysShowTracks) track.autoHideOnIdle();
    if (x === offset.x && y === offset.y) return null;
    offset.x = x;
    offset.y = y;
    (0, $eab04834fceb44be$export$37a5fde709c1db82)(contentEl, {
        '-transform': "translate3d(" + -x + "px, " + -y + "px, 0)"
    });
    track.update();
    return {
        offset: (0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, offset),
        limit: (0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, limit)
    };
}



var $e92dd3ff1702c132$var$animationIDStorage = new WeakMap();
function $e92dd3ff1702c132$export$3f99968195accfaf(scrollbar, x, y, duration, _a) {
    if (duration === void 0) duration = 0;
    var _b = _a === void 0 ? {} : _a, _c = _b.easing, easing = _c === void 0 ? $e92dd3ff1702c132$var$defaultEasing : _c, callback = _b.callback;
    var options = scrollbar.options, offset = scrollbar.offset, limit = scrollbar.limit;
    if (options.renderByPixels) {
        // ensure resolved with integer
        x = Math.round(x);
        y = Math.round(y);
    }
    var startX = offset.x;
    var startY = offset.y;
    var disX = (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(x, 0, limit.x) - startX;
    var disY = (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(y, 0, limit.y) - startY;
    var start = Date.now();
    function scroll() {
        var elapse = Date.now() - start;
        var progress = duration ? easing(Math.min(elapse / duration, 1)) : 1;
        scrollbar.setPosition(startX + disX * progress, startY + disY * progress);
        if (elapse >= duration) {
            if (typeof callback === 'function') callback.call(scrollbar);
        } else {
            var animationID = requestAnimationFrame(scroll);
            $e92dd3ff1702c132$var$animationIDStorage.set(scrollbar, animationID);
        }
    }
    cancelAnimationFrame($e92dd3ff1702c132$var$animationIDStorage.get(scrollbar));
    scroll();
}
/**
 * easeOutCubic
 */ function $e92dd3ff1702c132$var$defaultEasing(t) {
    return Math.pow(t - 1, 3) + 1;
}



function $85a8bb2ef848e1a1$export$53a0910f038337bd(scrollbar, elem, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.alignToTop, alignToTop = _c === void 0 ? true : _c, _d = _b.onlyScrollIfNeeded, onlyScrollIfNeeded = _d === void 0 ? false : _d, _e = _b.offsetTop, offsetTop = _e === void 0 ? 0 : _e, _f = _b.offsetLeft, offsetLeft = _f === void 0 ? 0 : _f, _g = _b.offsetBottom, offsetBottom = _g === void 0 ? 0 : _g;
    var containerEl = scrollbar.containerEl, bounding = scrollbar.bounding, offset = scrollbar.offset, limit = scrollbar.limit;
    if (!elem || !containerEl.contains(elem)) return;
    var targetBounding = elem.getBoundingClientRect();
    if (onlyScrollIfNeeded && scrollbar.isVisible(elem)) return;
    var delta = alignToTop ? targetBounding.top - bounding.top - offsetTop : targetBounding.bottom - bounding.bottom + offsetBottom;
    scrollbar.setMomentum(targetBounding.left - bounding.left - offsetLeft, (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(delta, -offset.y, limit.y - offset.y));
}





var $1f4e8c6708eb6289$export$db53f857c251fca3 = /** @class */ function() {
    function ScrollbarPlugin(scrollbar, options) {
        var _newTarget = this.constructor;
        this.scrollbar = scrollbar;
        this.name = _newTarget.pluginName;
        this.options = (0, $456a24904ebe47f5$export$18ce0697a983be9b)((0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, _newTarget.defaultOptions), options);
    }
    ScrollbarPlugin.prototype.onInit = function() {};
    ScrollbarPlugin.prototype.onDestroy = function() {};
    ScrollbarPlugin.prototype.onUpdate = function() {};
    ScrollbarPlugin.prototype.onRender = function(_remainMomentum) {};
    ScrollbarPlugin.prototype.transformDelta = function(delta, _evt) {
        return (0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, delta);
    };
    ScrollbarPlugin.pluginName = '';
    ScrollbarPlugin.defaultOptions = {};
    return ScrollbarPlugin;
}();
var $1f4e8c6708eb6289$export$905153d94e0757fa = {
    order: new Set(),
    constructors: {}
};
function $1f4e8c6708eb6289$export$19ec5365ea6ce8cf() {
    var Plugins = [];
    for(var _i = 0; _i < arguments.length; _i++)Plugins[_i] = arguments[_i];
    Plugins.forEach(function(P) {
        var pluginName = P.pluginName;
        if (!pluginName) throw new TypeError("plugin name is required");
        $1f4e8c6708eb6289$export$905153d94e0757fa.order.add(pluginName);
        $1f4e8c6708eb6289$export$905153d94e0757fa.constructors[pluginName] = P;
    });
}
function $1f4e8c6708eb6289$export$d117388934d9aaf6(scrollbar, options) {
    return Array.from($1f4e8c6708eb6289$export$905153d94e0757fa.order).filter(function(pluginName) {
        return options[pluginName] !== false;
    }).map(function(pluginName) {
        var Plugin = $1f4e8c6708eb6289$export$905153d94e0757fa.constructors[pluginName];
        var instance = new Plugin(scrollbar, options[pluginName]);
        // bind plugin options to `scrollbar.options`
        options[pluginName] = instance.options;
        return instance;
    });
}


var $deb9662c7bd3fc76$exports = {};
var $474c483cedfe287e$exports = {};

$parcel$export($474c483cedfe287e$exports, "keyboardHandler", function () { return $474c483cedfe287e$export$6ff2ab7955f7f068; });

var $474c483cedfe287e$var$KEY_CODE;
(function(KEY_CODE) {
    KEY_CODE[KEY_CODE["TAB"] = 9] = "TAB";
    KEY_CODE[KEY_CODE["SPACE"] = 32] = "SPACE";
    KEY_CODE[KEY_CODE["PAGE_UP"] = 33] = "PAGE_UP";
    KEY_CODE[KEY_CODE["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    KEY_CODE[KEY_CODE["END"] = 35] = "END";
    KEY_CODE[KEY_CODE["HOME"] = 36] = "HOME";
    KEY_CODE[KEY_CODE["LEFT"] = 37] = "LEFT";
    KEY_CODE[KEY_CODE["UP"] = 38] = "UP";
    KEY_CODE[KEY_CODE["RIGHT"] = 39] = "RIGHT";
    KEY_CODE[KEY_CODE["DOWN"] = 40] = "DOWN";
})($474c483cedfe287e$var$KEY_CODE || ($474c483cedfe287e$var$KEY_CODE = {}));
function $474c483cedfe287e$export$6ff2ab7955f7f068(scrollbar) {
    var addEvent = (0, $94024c8af2010ac2$export$cfedec40817575fe)(scrollbar);
    var container = scrollbar.containerEl;
    addEvent(container, 'keydown', function(evt) {
        var activeElement = document.activeElement;
        if (activeElement !== container && !container.contains(activeElement)) return;
        if ($474c483cedfe287e$var$isEditable(activeElement)) return;
        var delta = $474c483cedfe287e$var$getKeyDelta(scrollbar, evt.keyCode || evt.which);
        if (!delta) return;
        var x = delta[0], y = delta[1];
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll) evt.preventDefault();
            else {
                scrollbar.containerEl.blur();
                if (scrollbar.parent) scrollbar.parent.containerEl.focus();
            }
        });
    });
}
function $474c483cedfe287e$var$getKeyDelta(scrollbar, keyCode) {
    var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
    switch(keyCode){
        case $474c483cedfe287e$var$KEY_CODE.TAB:
            return $474c483cedfe287e$var$handleTabKey(scrollbar);
        case $474c483cedfe287e$var$KEY_CODE.SPACE:
            return [
                0,
                200
            ];
        case $474c483cedfe287e$var$KEY_CODE.PAGE_UP:
            return [
                0,
                -size.container.height + 40
            ];
        case $474c483cedfe287e$var$KEY_CODE.PAGE_DOWN:
            return [
                0,
                size.container.height - 40
            ];
        case $474c483cedfe287e$var$KEY_CODE.END:
            return [
                0,
                limit.y - offset.y
            ];
        case $474c483cedfe287e$var$KEY_CODE.HOME:
            return [
                0,
                -offset.y
            ];
        case $474c483cedfe287e$var$KEY_CODE.LEFT:
            return [
                -40,
                0
            ];
        case $474c483cedfe287e$var$KEY_CODE.UP:
            return [
                0,
                -40
            ];
        case $474c483cedfe287e$var$KEY_CODE.RIGHT:
            return [
                40,
                0
            ];
        case $474c483cedfe287e$var$KEY_CODE.DOWN:
            return [
                0,
                40
            ];
        default:
            return null;
    }
}
function $474c483cedfe287e$var$handleTabKey(scrollbar) {
    // handle in next frame
    requestAnimationFrame(function() {
        scrollbar.scrollIntoView(document.activeElement, {
            offsetTop: scrollbar.size.container.height / 2,
            offsetLeft: scrollbar.size.container.width / 2,
            onlyScrollIfNeeded: true
        });
    });
}
function $474c483cedfe287e$var$isEditable(elem) {
    if (elem.tagName === 'INPUT' || elem.tagName === 'SELECT' || elem.tagName === 'TEXTAREA' || elem.isContentEditable) return !elem.disabled;
    return false;
}


var $98e973beb4ac700d$exports = {};

$parcel$export($98e973beb4ac700d$exports, "mouseHandler", function () { return $98e973beb4ac700d$export$242d43875ab79ce3; });


var $98e973beb4ac700d$var$Direction;
(function(Direction) {
    Direction[Direction["X"] = 0] = "X";
    Direction[Direction["Y"] = 1] = "Y";
})($98e973beb4ac700d$var$Direction || ($98e973beb4ac700d$var$Direction = {}));
function $98e973beb4ac700d$export$242d43875ab79ce3(scrollbar) {
    var addEvent = (0, $94024c8af2010ac2$export$cfedec40817575fe)(scrollbar);
    var container = scrollbar.containerEl;
    var _a = scrollbar.track, xAxis = _a.xAxis, yAxis = _a.yAxis;
    function calcMomentum(direction, clickPosition) {
        var size = scrollbar.size, limit = scrollbar.limit, offset = scrollbar.offset;
        if (direction === $98e973beb4ac700d$var$Direction.X) {
            var totalWidth = size.container.width + (xAxis.thumb.realSize - xAxis.thumb.displaySize);
            return (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(clickPosition / totalWidth * size.content.width, 0, limit.x) - offset.x;
        }
        if (direction === $98e973beb4ac700d$var$Direction.Y) {
            var totalHeight = size.container.height + (yAxis.thumb.realSize - yAxis.thumb.displaySize);
            return (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(clickPosition / totalHeight * size.content.height, 0, limit.y) - offset.y;
        }
        return 0;
    }
    function getTrackDirection(elem) {
        if ((0, $295e49b2ddab6e10$export$532a90c0e5e8e48c)(elem, [
            xAxis.element,
            xAxis.thumb.element
        ])) return $98e973beb4ac700d$var$Direction.X;
        if ((0, $295e49b2ddab6e10$export$532a90c0e5e8e48c)(elem, [
            yAxis.element,
            yAxis.thumb.element
        ])) return $98e973beb4ac700d$var$Direction.Y;
        return void 0;
    }
    var isMouseDown;
    var isMouseMoving;
    var startOffsetToThumb;
    var trackDirection;
    var containerRect;
    addEvent(container, 'click', function(evt) {
        if (isMouseMoving || !(0, $295e49b2ddab6e10$export$532a90c0e5e8e48c)(evt.target, [
            xAxis.element,
            yAxis.element
        ])) return;
        var track = evt.target;
        var direction = getTrackDirection(track);
        var rect = track.getBoundingClientRect();
        var clickPos = (0, $0009ce504af9b470$export$1690e12b840569b9)(evt);
        if (direction === $98e973beb4ac700d$var$Direction.X) {
            var offsetOnTrack = clickPos.x - rect.left - xAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(calcMomentum(direction, offsetOnTrack), 0);
        }
        if (direction === $98e973beb4ac700d$var$Direction.Y) {
            var offsetOnTrack = clickPos.y - rect.top - yAxis.thumb.displaySize / 2;
            scrollbar.setMomentum(0, calcMomentum(direction, offsetOnTrack));
        }
    });
    addEvent(container, 'mousedown', function(evt) {
        if (!(0, $295e49b2ddab6e10$export$532a90c0e5e8e48c)(evt.target, [
            xAxis.thumb.element,
            yAxis.thumb.element
        ])) return;
        isMouseDown = true;
        var thumb = evt.target;
        var cursorPos = (0, $0009ce504af9b470$export$1690e12b840569b9)(evt);
        var thumbRect = thumb.getBoundingClientRect();
        trackDirection = getTrackDirection(thumb);
        // pointer offset to thumb
        startOffsetToThumb = {
            x: cursorPos.x - thumbRect.left,
            y: cursorPos.y - thumbRect.top
        };
        // container bounding rectangle
        containerRect = container.getBoundingClientRect();
        // prevent selection, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/48
        (0, $eab04834fceb44be$export$37a5fde709c1db82)(scrollbar.containerEl, {
            '-user-select': 'none'
        });
    });
    addEvent(window, 'mousemove', function(evt) {
        if (!isMouseDown) return;
        isMouseMoving = true;
        var cursorPos = (0, $0009ce504af9b470$export$1690e12b840569b9)(evt);
        if (trackDirection === $98e973beb4ac700d$var$Direction.X) {
            // get percentage of pointer position in track
            // then tranform to px
            // don't need easing
            var offsetOnTrack = cursorPos.x - startOffsetToThumb.x - containerRect.left;
            scrollbar.setMomentum(calcMomentum(trackDirection, offsetOnTrack), 0);
        }
        if (trackDirection === $98e973beb4ac700d$var$Direction.Y) {
            var offsetOnTrack = cursorPos.y - startOffsetToThumb.y - containerRect.top;
            scrollbar.setMomentum(0, calcMomentum(trackDirection, offsetOnTrack));
        }
    });
    addEvent(window, 'mouseup blur', function() {
        isMouseDown = isMouseMoving = false;
        (0, $eab04834fceb44be$export$37a5fde709c1db82)(scrollbar.containerEl, {
            '-user-select': ''
        });
    });
}


var $105a5765a705259d$exports = {};

$parcel$export($105a5765a705259d$exports, "resizeHandler", function () { return $105a5765a705259d$export$53d88fe222065052; });


function $105a5765a705259d$export$53d88fe222065052(scrollbar) {
    var addEvent = (0, $94024c8af2010ac2$export$cfedec40817575fe)(scrollbar);
    addEvent(window, 'resize', (0, $b849c840bfa8c4c3$export$61fc7d43ac8f84b0)(scrollbar.update.bind(scrollbar), 300));
}


var $48e9fc3349e46131$exports = {};

$parcel$export($48e9fc3349e46131$exports, "selectHandler", function () { return $48e9fc3349e46131$export$77907cd5c206b555; });


function $48e9fc3349e46131$export$77907cd5c206b555(scrollbar) {
    var addEvent = (0, $94024c8af2010ac2$export$cfedec40817575fe)(scrollbar);
    var containerEl = scrollbar.containerEl, contentEl = scrollbar.contentEl;
    var isSelected = false;
    var isContextMenuOpened = false; // flag to prevent selection when context menu is opened
    var animationID;
    function scroll(_a) {
        var x = _a.x, y = _a.y;
        if (!x && !y) return;
        var offset = scrollbar.offset, limit = scrollbar.limit;
        // DISALLOW delta transformation
        scrollbar.setMomentum((0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(offset.x + x, 0, limit.x) - offset.x, (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(offset.y + y, 0, limit.y) - offset.y);
        animationID = requestAnimationFrame(function() {
            scroll({
                x: x,
                y: y
            });
        });
    }
    addEvent(window, 'mousemove', function(evt) {
        if (!isSelected) return;
        cancelAnimationFrame(animationID);
        var dir = $48e9fc3349e46131$var$calcMomentum(scrollbar, evt);
        scroll(dir);
    });
    // prevent scrolling when context menu is opened
    // NOTE: `contextmenu` event may be fired
    //          1. BEFORE `selectstart`: when user right-clicks on the text content -> prevent future scrolling,
    //          2. AFTER `selectstart`: when user right-clicks on the blank area -> cancel current scrolling,
    //        so we need to both set the flag and cancel current scrolling
    addEvent(contentEl, 'contextmenu', function() {
        // set the flag to prevent future scrolling
        isContextMenuOpened = true;
        // stop current scrolling
        cancelAnimationFrame(animationID);
        isSelected = false;
    });
    // reset context menu flag on mouse down
    // to ensure the scrolling is allowed in the next selection
    addEvent(contentEl, 'mousedown', function() {
        isContextMenuOpened = false;
    });
    addEvent(contentEl, 'selectstart', function() {
        if (isContextMenuOpened) return;
        cancelAnimationFrame(animationID);
        isSelected = true;
    });
    addEvent(window, 'mouseup blur', function() {
        cancelAnimationFrame(animationID);
        isSelected = false;
        isContextMenuOpened = false;
    });
    // patch for touch devices
    addEvent(containerEl, 'scroll', function(evt) {
        evt.preventDefault();
        containerEl.scrollTop = containerEl.scrollLeft = 0;
    });
}
function $48e9fc3349e46131$var$calcMomentum(scrollbar, evt) {
    var _a = scrollbar.bounding, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
    var _b = (0, $0009ce504af9b470$export$1690e12b840569b9)(evt), x = _b.x, y = _b.y;
    var res = {
        x: 0,
        y: 0
    };
    var padding = 20;
    if (x === 0 && y === 0) return res;
    if (x > right - padding) res.x = x - right + padding;
    else if (x < left + padding) res.x = x - left - padding;
    if (y > bottom - padding) res.y = y - bottom + padding;
    else if (y < top + padding) res.y = y - top - padding;
    res.x *= 2;
    res.y *= 2;
    return res;
}


var $f92aba69465d18e9$exports = {};

$parcel$export($f92aba69465d18e9$exports, "touchHandler", function () { return $f92aba69465d18e9$export$2916e5349c3e671c; });

var $f92aba69465d18e9$var$activeScrollbar;
function $f92aba69465d18e9$export$2916e5349c3e671c(scrollbar) {
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var touchRecord = new (0, $e0fb56283bea6912$export$9da4f16074124683)();
    var addEvent = (0, $94024c8af2010ac2$export$cfedec40817575fe)(scrollbar);
    var damping;
    var pointerCount = 0;
    addEvent(target, 'touchstart', function(evt) {
        // start records
        touchRecord.track(evt);
        // stop scrolling
        scrollbar.setMomentum(0, 0);
        // save damping
        if (pointerCount === 0) {
            damping = scrollbar.options.damping;
            scrollbar.options.damping = Math.max(damping, 0.5); // less frames on touchmove
        }
        pointerCount++;
    });
    addEvent(target, 'touchmove', function(evt) {
        if ($f92aba69465d18e9$var$activeScrollbar && $f92aba69465d18e9$var$activeScrollbar !== scrollbar) return;
        touchRecord.update(evt);
        var _a = touchRecord.getDelta(), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll && evt.cancelable) {
                evt.preventDefault();
                $f92aba69465d18e9$var$activeScrollbar = scrollbar;
            }
        });
    });
    addEvent(target, 'touchcancel touchend', function(evt) {
        var delta = touchRecord.getEasingDistance(damping);
        scrollbar.addTransformableMomentum(delta.x, delta.y, evt);
        pointerCount--;
        // restore damping
        if (pointerCount === 0) scrollbar.options.damping = damping;
        touchRecord.release(evt);
        $f92aba69465d18e9$var$activeScrollbar = null;
    });
}


var $84aa71fb161c1c6d$exports = {};

$parcel$export($84aa71fb161c1c6d$exports, "wheelHandler", function () { return $84aa71fb161c1c6d$export$14c83f6c8045ea84; });

function $84aa71fb161c1c6d$export$14c83f6c8045ea84(scrollbar) {
    var addEvent = (0, $94024c8af2010ac2$export$cfedec40817575fe)(scrollbar);
    var target = scrollbar.options.delegateTo || scrollbar.containerEl;
    var eventName = 'onwheel' in window || document.implementation.hasFeature('Events.wheel', '3.0') ? 'wheel' : 'mousewheel';
    addEvent(target, eventName, function(evt) {
        var _a = $84aa71fb161c1c6d$var$normalizeDelta(evt), x = _a.x, y = _a.y;
        scrollbar.addTransformableMomentum(x, y, evt, function(willScroll) {
            if (willScroll) evt.preventDefault();
        });
    });
}
// Normalizing wheel delta
var $84aa71fb161c1c6d$var$DELTA_SCALE = {
    STANDARD: 1,
    OTHERS: -3
};
var $84aa71fb161c1c6d$var$DELTA_MODE = [
    1.0,
    28.0,
    500.0
];
var $84aa71fb161c1c6d$var$getDeltaMode = function(mode) {
    return $84aa71fb161c1c6d$var$DELTA_MODE[mode] || $84aa71fb161c1c6d$var$DELTA_MODE[0];
};
function $84aa71fb161c1c6d$var$normalizeDelta(evt) {
    if ('deltaX' in evt) {
        var mode = $84aa71fb161c1c6d$var$getDeltaMode(evt.deltaMode);
        return {
            x: evt.deltaX / $84aa71fb161c1c6d$var$DELTA_SCALE.STANDARD * mode,
            y: evt.deltaY / $84aa71fb161c1c6d$var$DELTA_SCALE.STANDARD * mode
        };
    }
    if ('wheelDeltaX' in evt) return {
        x: evt.wheelDeltaX / $84aa71fb161c1c6d$var$DELTA_SCALE.OTHERS,
        y: evt.wheelDeltaY / $84aa71fb161c1c6d$var$DELTA_SCALE.OTHERS
    };
    // ie with touchpad
    return {
        x: 0,
        y: evt.wheelDelta / $84aa71fb161c1c6d$var$DELTA_SCALE.OTHERS
    };
}


$parcel$exportWildcard($deb9662c7bd3fc76$exports, $474c483cedfe287e$exports);
$parcel$exportWildcard($deb9662c7bd3fc76$exports, $98e973beb4ac700d$exports);
$parcel$exportWildcard($deb9662c7bd3fc76$exports, $105a5765a705259d$exports);
$parcel$exportWildcard($deb9662c7bd3fc76$exports, $48e9fc3349e46131$exports);
$parcel$exportWildcard($deb9662c7bd3fc76$exports, $f92aba69465d18e9$exports);
$parcel$exportWildcard($deb9662c7bd3fc76$exports, $84aa71fb161c1c6d$exports);


var $b494c7668fffce2e$export$18a24ca5e48929da = new Map();
var $b494c7668fffce2e$export$9a4e88b92edfce6b = /** @class */ function() {
    function Scrollbar(containerEl, options) {
        var _this = this;
        /**
         * Current scrolling offsets
         */ this.offset = {
            x: 0,
            y: 0
        };
        /**
         * Max-allowed scrolling offsets
         */ this.limit = {
            x: Infinity,
            y: Infinity
        };
        /**
         * Container bounding rect
         */ this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        // private _observer: ResizeObserver;
        this._plugins = [];
        this._momentum = {
            x: 0,
            y: 0
        };
        this._listeners = new Set();
        this.containerEl = containerEl;
        var contentEl = this.contentEl = document.createElement('div');
        this.options = new (0, $050dfaa5fddaad28$export$c019608e5b5bb4cb)(options);
        // mark as a scroll element
        containerEl.setAttribute('data-scrollbar', 'true');
        // make container focusable
        containerEl.setAttribute('tabindex', '-1');
        (0, $eab04834fceb44be$export$37a5fde709c1db82)(containerEl, {
            overflow: 'hidden',
            outline: 'none'
        });
        // enable touch event capturing in IE, see:
        // https://github.com/idiotWu/smooth-scrollbar/issues/39
        if (window.navigator.msPointerEnabled) containerEl.style.msTouchAction = 'none';
        // mount content
        contentEl.className = 'scroll-content';
        Array.from(containerEl.childNodes).forEach(function(node) {
            contentEl.appendChild(node);
        });
        containerEl.appendChild(contentEl);
        // attach track
        this.track = new (0, $f6af8dbf2d32d8a2$export$40a0242a5dec07f5)(this);
        // initial measuring
        this.size = this.getSize();
        // init plugins
        this._plugins = (0, $1f4e8c6708eb6289$export$d117388934d9aaf6)(this, this.options.plugins);
        // preserve scroll offset
        var scrollLeft = containerEl.scrollLeft, scrollTop = containerEl.scrollTop;
        containerEl.scrollLeft = containerEl.scrollTop = 0;
        this.setPosition(scrollLeft, scrollTop, {
            withoutCallbacks: true
        });
        // FIXME: update typescript
        var ResizeObserver = window.ResizeObserver;
        // observe
        if (typeof ResizeObserver === 'function') {
            this._observer = new ResizeObserver(function() {
                _this.update();
            });
            this._observer.observe(contentEl);
        }
        $b494c7668fffce2e$export$18a24ca5e48929da.set(containerEl, this);
        // wait for DOM ready
        requestAnimationFrame(function() {
            _this._init();
        });
    }
    Object.defineProperty(Scrollbar.prototype, "parent", {
        /**
         * Parent scrollbar
         */ get: function() {
            var elem = this.containerEl.parentElement;
            while(elem){
                var parentScrollbar = $b494c7668fffce2e$export$18a24ca5e48929da.get(elem);
                if (parentScrollbar) return parentScrollbar;
                elem = elem.parentElement;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollTop", {
        /**
         * Gets or sets `scrollbar.offset.y`
         */ get: function() {
            return this.offset.y;
        },
        set: function(y) {
            this.setPosition(this.scrollLeft, y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scrollbar.prototype, "scrollLeft", {
        /**
         * Gets or sets `scrollbar.offset.x`
         */ get: function() {
            return this.offset.x;
        },
        set: function(x) {
            this.setPosition(x, this.scrollTop);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the size of the scrollbar container element
     * and the content wrapper element
     */ Scrollbar.prototype.getSize = function() {
        return (0, $1f0809682f887b7f$export$31b21d0167753bb4)(this);
    };
    /**
     * Forces scrollbar to update geometry infomation.
     *
     * By default, scrollbars are automatically updated with `100ms` debounce (or `MutationObserver` fires).
     * You can call this method to force an update when you modified contents
     */ Scrollbar.prototype.update = function() {
        (0, $e0eba474fbe25cf7$export$722fbec263ad908a)(this);
        this._plugins.forEach(function(plugin) {
            plugin.onUpdate();
        });
    };
    /**
     * Checks if an element is visible in the current view area
     */ Scrollbar.prototype.isVisible = function(elem) {
        return (0, $46b7de144766f350$export$795910f5f15a9633)(this, elem);
    };
    /**
     * Sets the scrollbar to the given offset without easing
     */ Scrollbar.prototype.setPosition = function(x, y, options) {
        var _this = this;
        if (x === void 0) x = this.offset.x;
        if (y === void 0) y = this.offset.y;
        if (options === void 0) options = {};
        var status = (0, $3f7a2cd3f63d716e$export$f9b088a47202d605)(this, x, y);
        if (!status || options.withoutCallbacks) return;
        this._listeners.forEach(function(fn) {
            fn.call(_this, status);
        });
    };
    /**
     * Scrolls to given position with easing function
     */ Scrollbar.prototype.scrollTo = function(x, y, duration, options) {
        if (x === void 0) x = this.offset.x;
        if (y === void 0) y = this.offset.y;
        if (duration === void 0) duration = 0;
        if (options === void 0) options = {};
        (0, $e92dd3ff1702c132$export$3f99968195accfaf)(this, x, y, duration, options);
    };
    /**
     * Scrolls the target element into visible area of scrollbar,
     * likes the DOM method `element.scrollIntoView().
     */ Scrollbar.prototype.scrollIntoView = function(elem, options) {
        if (options === void 0) options = {};
        (0, $85a8bb2ef848e1a1$export$53a0910f038337bd)(this, elem, options);
    };
    /**
     * Adds scrolling listener
     */ Scrollbar.prototype.addListener = function(fn) {
        if (typeof fn !== 'function') throw new TypeError('[smooth-scrollbar] scrolling listener should be a function');
        this._listeners.add(fn);
    };
    /**
     * Removes listener previously registered with `scrollbar.addListener()`
     */ Scrollbar.prototype.removeListener = function(fn) {
        this._listeners.delete(fn);
    };
    /**
     * Adds momentum and applys delta transformers.
     */ Scrollbar.prototype.addTransformableMomentum = function(x, y, fromEvent, callback) {
        this._updateDebounced();
        var finalDelta = this._plugins.reduce(function(delta, plugin) {
            return plugin.transformDelta(delta, fromEvent) || delta;
        }, {
            x: x,
            y: y
        });
        var willScroll = !this._shouldPropagateMomentum(finalDelta.x, finalDelta.y);
        if (willScroll) this.addMomentum(finalDelta.x, finalDelta.y);
        if (callback) callback.call(this, willScroll);
    };
    /**
     * Increases scrollbar's momentum
     */ Scrollbar.prototype.addMomentum = function(x, y) {
        this.setMomentum(this._momentum.x + x, this._momentum.y + y);
    };
    /**
     * Sets scrollbar's momentum to given value
     */ Scrollbar.prototype.setMomentum = function(x, y) {
        if (this.limit.x === 0) x = 0;
        if (this.limit.y === 0) y = 0;
        if (this.options.renderByPixels) {
            x = Math.round(x);
            y = Math.round(y);
        }
        this._momentum.x = x;
        this._momentum.y = y;
    };
    /**
     * Update options for specific plugin
     *
     * @param pluginName Name of the plugin
     * @param [options] An object includes the properties that you want to update
     */ Scrollbar.prototype.updatePluginOptions = function(pluginName, options) {
        this._plugins.forEach(function(plugin) {
            if (plugin.name === pluginName) Object.assign(plugin.options, options);
        });
    };
    Scrollbar.prototype.destroy = function() {
        var _a = this, containerEl = _a.containerEl, contentEl = _a.contentEl;
        (0, $94024c8af2010ac2$export$2bf7a27f443e4893)(this);
        this._listeners.clear();
        this.setMomentum(0, 0);
        cancelAnimationFrame(this._renderID);
        if (this._observer) this._observer.disconnect();
        $b494c7668fffce2e$export$18a24ca5e48929da.delete(this.containerEl);
        // restore contents
        var childNodes = Array.from(contentEl.childNodes);
        while(containerEl.firstChild)containerEl.removeChild(containerEl.firstChild);
        childNodes.forEach(function(el) {
            containerEl.appendChild(el);
        });
        // reset scroll position
        (0, $eab04834fceb44be$export$37a5fde709c1db82)(containerEl, {
            overflow: ''
        });
        containerEl.scrollTop = this.scrollTop;
        containerEl.scrollLeft = this.scrollLeft;
        // invoke plugin.onDestroy
        this._plugins.forEach(function(plugin) {
            plugin.onDestroy();
        });
        this._plugins.length = 0;
    };
    Scrollbar.prototype._init = function() {
        var _this = this;
        this.update();
        // init evet handlers
        Object.keys($deb9662c7bd3fc76$exports).forEach(function(prop) {
            $deb9662c7bd3fc76$exports[prop](_this);
        });
        // invoke `plugin.onInit`
        this._plugins.forEach(function(plugin) {
            plugin.onInit();
        });
        this._render();
    };
    Scrollbar.prototype._updateDebounced = function() {
        this.update();
    };
    // check whether to propagate monmentum to parent scrollbar
    // the following situations are considered as `true`:
    //         1. continuous scrolling is enabled (automatically disabled when overscroll is enabled)
    //         2. scrollbar reaches one side and is not about to scroll on the other direction
    Scrollbar.prototype._shouldPropagateMomentum = function(deltaX, deltaY) {
        if (deltaX === void 0) deltaX = 0;
        if (deltaY === void 0) deltaY = 0;
        var _a = this, options = _a.options, offset = _a.offset, limit = _a.limit;
        if (!options.continuousScrolling) return false;
        // force an update when scrollbar is "unscrollable", see #106
        if (limit.x === 0 && limit.y === 0) this._updateDebounced();
        var destX = (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(deltaX + offset.x, 0, limit.x);
        var destY = (0, $e996164389bf165c$export$7d15b64cf5a3a4c4)(deltaY + offset.y, 0, limit.y);
        var res = true;
        // offsets are not about to change
        // `&=` operator is not allowed for boolean types
        res = res && destX === offset.x;
        res = res && destY === offset.y;
        // current offsets are on the edge
        res = res && (offset.x === limit.x || offset.x === 0 || offset.y === limit.y || offset.y === 0);
        return res;
    };
    Scrollbar.prototype._render = function() {
        var _momentum = this._momentum;
        if (_momentum.x || _momentum.y) {
            var nextX = this._nextTick('x');
            var nextY = this._nextTick('y');
            _momentum.x = nextX.momentum;
            _momentum.y = nextY.momentum;
            this.setPosition(nextX.position, nextY.position);
        }
        var remain = (0, $456a24904ebe47f5$export$18ce0697a983be9b)({}, this._momentum);
        this._plugins.forEach(function(plugin) {
            plugin.onRender(remain);
        });
        this._renderID = requestAnimationFrame(this._render.bind(this));
    };
    Scrollbar.prototype._nextTick = function(direction) {
        var _a = this, options = _a.options, offset = _a.offset, _momentum = _a._momentum;
        var current = offset[direction];
        var remain = _momentum[direction];
        if (Math.abs(remain) <= 0.1) return {
            momentum: 0,
            position: current + remain
        };
        var nextMomentum = remain * (1 - options.damping);
        if (options.renderByPixels) nextMomentum |= 0;
        return {
            momentum: nextMomentum,
            position: current + remain - nextMomentum
        };
    };
    (0, $456a24904ebe47f5$export$29e00dfd3077644b)([
        (0, $6453bbf79afc2be9$export$61fc7d43ac8f84b0)(100, true)
    ], Scrollbar.prototype, "_updateDebounced", null);
    return Scrollbar;
}();



var $7733ebcc9ee9dfa2$var$TRACK_BG = 'rgba(222, 222, 222, .75)';
var $7733ebcc9ee9dfa2$var$THUMB_BG = 'rgba(0, 0, 0, .5)';
// sets content's display type to `flow-root` to suppress margin collapsing
var $7733ebcc9ee9dfa2$var$SCROLLBAR_STYLE = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  display: flow-root;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: " + $7733ebcc9ee9dfa2$var$TRACK_BG + ";\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: " + $7733ebcc9ee9dfa2$var$THUMB_BG + ";\n  border-radius: 4px;\n}\n";
var $7733ebcc9ee9dfa2$var$STYLE_ID = 'smooth-scrollbar-style';
var $7733ebcc9ee9dfa2$var$isStyleAttached = false;
function $7733ebcc9ee9dfa2$export$ff76c51b0f744e0a() {
    if ($7733ebcc9ee9dfa2$var$isStyleAttached || typeof window === 'undefined') return;
    var styleEl = document.createElement('style');
    styleEl.id = $7733ebcc9ee9dfa2$var$STYLE_ID;
    styleEl.textContent = $7733ebcc9ee9dfa2$var$SCROLLBAR_STYLE;
    if (document.head) document.head.appendChild(styleEl);
    $7733ebcc9ee9dfa2$var$isStyleAttached = true;
}
function $7733ebcc9ee9dfa2$export$11939e4e3dfbbb72() {
    if (!$7733ebcc9ee9dfa2$var$isStyleAttached || typeof window === 'undefined') return;
    var styleEl = document.getElementById($7733ebcc9ee9dfa2$var$STYLE_ID);
    if (!styleEl || !styleEl.parentNode) return;
    styleEl.parentNode.removeChild(styleEl);
    $7733ebcc9ee9dfa2$var$isStyleAttached = false;
}


/**
 * cast `I.Scrollbar` to `Scrollbar` to avoid error
 *
 * `I.Scrollbar` is not assignable to `Scrollbar`:
 *     "privateProp" is missing in `I.Scrollbar`
 *
 * @see https://github.com/Microsoft/TypeScript/issues/2672
 */ var $3c4056905a9fb0ef$var$SmoothScrollbar = /** @class */ function(_super) {
    (0, $456a24904ebe47f5$export$a8ba968b8961cb8a)(SmoothScrollbar, _super);
    function SmoothScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes a scrollbar on the given element.
     *
     * @param elem The DOM element that you want to initialize scrollbar to
     * @param [options] Initial options
     */ SmoothScrollbar.init = function(elem, options) {
        if (!elem || elem.nodeType !== 1) throw new TypeError("expect element to be DOM Element, but got " + elem);
        // attach stylesheet
        (0, $7733ebcc9ee9dfa2$export$ff76c51b0f744e0a)();
        if ((0, $b494c7668fffce2e$export$18a24ca5e48929da).has(elem)) return (0, $b494c7668fffce2e$export$18a24ca5e48929da).get(elem);
        return new (0, $b494c7668fffce2e$export$9a4e88b92edfce6b)(elem, options);
    };
    /**
     * Automatically init scrollbar on all elements base on the selector `[data-scrollbar]`
     *
     * @param options Initial options
     */ SmoothScrollbar.initAll = function(options) {
        return Array.from(document.querySelectorAll('[data-scrollbar]'), function(elem) {
            return SmoothScrollbar.init(elem, options);
        });
    };
    /**
     * Check if there is a scrollbar on given element
     *
     * @param elem The DOM element that you want to check
     */ SmoothScrollbar.has = function(elem) {
        return (0, $b494c7668fffce2e$export$18a24ca5e48929da).has(elem);
    };
    /**
     * Gets scrollbar on the given element.
     * If no scrollbar instance exsits, returns `undefined`
     *
     * @param elem The DOM element that you want to check.
     */ SmoothScrollbar.get = function(elem) {
        return (0, $b494c7668fffce2e$export$18a24ca5e48929da).get(elem);
    };
    /**
     * Returns an array that contains all scrollbar instances
     */ SmoothScrollbar.getAll = function() {
        return Array.from((0, $b494c7668fffce2e$export$18a24ca5e48929da).values());
    };
    /**
     * Removes scrollbar on the given element
     */ SmoothScrollbar.destroy = function(elem) {
        var scrollbar = (0, $b494c7668fffce2e$export$18a24ca5e48929da).get(elem);
        if (scrollbar) scrollbar.destroy();
    };
    /**
     * Removes all scrollbar instances from current document
     */ SmoothScrollbar.destroyAll = function() {
        (0, $b494c7668fffce2e$export$18a24ca5e48929da).forEach(function(scrollbar) {
            scrollbar.destroy();
        });
    };
    /**
     * Attaches plugins to scrollbars
     *
     * @param ...Plugins Scrollbar plugin classes
     */ SmoothScrollbar.use = function() {
        var Plugins = [];
        for(var _i = 0; _i < arguments.length; _i++)Plugins[_i] = arguments[_i];
        return (0, $1f4e8c6708eb6289$export$19ec5365ea6ce8cf).apply(void 0, Plugins);
    };
    /**
     * Attaches default style sheets to current document.
     * You don't need to call this method manually unless
     * you removed the default styles via `Scrollbar.detachStyle()`
     */ SmoothScrollbar.attachStyle = function() {
        return (0, $7733ebcc9ee9dfa2$export$ff76c51b0f744e0a)();
    };
    /**
     * Removes default styles from current document.
     * Use this method when you want to use your own css for scrollbars.
     */ SmoothScrollbar.detachStyle = function() {
        return (0, $7733ebcc9ee9dfa2$export$11939e4e3dfbbb72)();
    };
    SmoothScrollbar.version = "8.8.4";
    SmoothScrollbar.ScrollbarPlugin = (0, $1f4e8c6708eb6289$export$db53f857c251fca3);
    return SmoothScrollbar;
}((0, $b494c7668fffce2e$export$9a4e88b92edfce6b));
var $3c4056905a9fb0ef$export$2e2bcd8739ae039 = $3c4056905a9fb0ef$var$SmoothScrollbar;


window.scrollInitFunc = function scrollInitFunc1() {
    if (document.querySelector('[data-scroll]')) {
        const scrollElArr = document.querySelectorAll('[data-scroll]');
        scrollElArr.forEach((el)=>{
            if (!el.classList.contains('is-scroll-init')) {
                el.classList.add('is-scroll-init');
                const startScrollWidth = parseInt(el.getAttribute('data-start-scroll'), 10);
                if (!startScrollWidth || window.innerWidth <= startScrollWidth) {
                    const scrollbar = (0, $3c4056905a9fb0ef$export$2e2bcd8739ae039).init(el, {
                        alwaysShowTracks: true,
                        damping: 0.1,
                        renderByPixels: true
                    });
                    scrollbar.addListener(({ offset: offset })=>{
                        if (offset.x !== 0) scrollbar.setPosition(0, offset.y);
                    });
                }
            }
        });
    }
};
scrollInitFunc();


// import { gsap } from 'gsap';
let $4831641d81487c17$var$ellipseRotationTL, $4831641d81487c17$var$imgRotationTL, $4831641d81487c17$var$imgSecondRotationTL;
window.firstGradientGSAPAnimation = function firstGradientGSAPAnimation1() {
    const imgContainer = document.querySelector('.first-sec-bg__bg-decor-ellipses');
    const main = document.querySelector('.main');
    if (!imgContainer || !main) return;
    if (window.innerWidth > 1024) {
        imgContainer.getBoundingClientRect();
        requestAnimationFrame(()=>{
            const img = imgContainer.querySelector('.first-sec-bg__bg-decor-ellipse-img-wr:nth-child(1) .first-sec-bg__bg-decor-ellipse-img');
            const imgSecond = imgContainer.querySelector('.first-sec-bg__bg-decor-ellipse-img-wr:nth-child(2) .first-sec-bg__bg-decor-ellipse-img');
            gsap.set(imgContainer, {
                xPercent: 0,
                yPercent: -50,
                x: 0,
                y: 0,
                transformOrigin: 'center center'
            });
            $4831641d81487c17$var$ellipseRotationTL = gsap.to(imgContainer, {
                rotation: 360,
                ease: 'none',
                repeat: -1,
                duration: 30
            });
            $4831641d81487c17$var$imgRotationTL = gsap.to(img, {
                rotation: -360,
                ease: 'none',
                repeat: -1,
                duration: 30
            });
            $4831641d81487c17$var$imgSecondRotationTL = gsap.to(imgSecond, {
                rotation: 360,
                ease: 'none',
                repeat: -1,
                duration: 40
            });
        });
    }
};
window.pauseFirstGradientAnimation = function pauseFirstGradientAnimation() {
    if (window.innerWidth > 1024) {
        $4831641d81487c17$var$ellipseRotationTL?.pause();
        $4831641d81487c17$var$imgRotationTL?.pause();
        $4831641d81487c17$var$imgSecondRotationTL?.pause();
    }
};
window.resumeFirstGradientAnimation = function resumeFirstGradientAnimation() {
    if (window.innerWidth > 1024) {
        $4831641d81487c17$var$ellipseRotationTL?.play();
        $4831641d81487c17$var$imgRotationTL?.play();
        $4831641d81487c17$var$imgSecondRotationTL?.play();
    }
};
firstGradientGSAPAnimation();


const $168d9e58e6b512ee$var$defaultSelectors = {
    orbit: '[data-orbital-gradient-orbit]',
    first: '[data-orbital-gradient-orbit-wrap]:nth-child(1) [data-orbital-gradient-orbit-item]',
    second: '[data-orbital-gradient-orbit-wrap]:nth-child(2) [data-orbital-gradient-orbit-item]',
    images: '[data-orbital-gradient-motion] img'
};
const $168d9e58e6b512ee$var$orbitalGradientInstances = new WeakMap();
const $168d9e58e6b512ee$var$getMaskSupport = ()=>{
    if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('mask-image', 'url("data:image/png;base64,iVBORw0KGgo=")') || CSS.supports('-webkit-mask-image', 'url("data:image/png;base64,iVBORw0KGgo=")');
};
const $168d9e58e6b512ee$var$getReducedMotion = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $168d9e58e6b512ee$var$waitForImage = (image)=>{
    if (image.complete) return image.naturalWidth > 0 ? Promise.resolve() : Promise.reject(new Error('Orbital gradient asset failed to load'));
    return new Promise((resolve, reject)=>{
        image.addEventListener('load', resolve, {
            once: true
        });
        image.addEventListener('error', ()=>reject(new Error('Orbital gradient asset failed to load')), {
            once: true
        });
    });
};
const $168d9e58e6b512ee$var$waitForFirstFrame = ()=>new Promise((resolve)=>requestAnimationFrame(()=>resolve()));
const $168d9e58e6b512ee$var$loadMaskImage = (src)=>new Promise((resolve, reject)=>{
        const image = new Image();
        image.addEventListener('load', resolve, {
            once: true
        });
        image.addEventListener('error', ()=>reject(new Error('Orbital gradient mask failed to load')), {
            once: true
        });
        image.src = src;
    });
const $168d9e58e6b512ee$export$d7d39fa6ca6220fb = ({ width: width, reducedMotion: reducedMotion, gsap: gsap, maskSupported: maskSupported })=>width > 1024 && !reducedMotion && Boolean(gsap && typeof gsap.set === 'function' && typeof gsap.to === 'function') && maskSupported;
const $168d9e58e6b512ee$export$4ca8e834ce5bc122 = ({ footer: footer, clients: clients, isEnhanced: isEnhanced })=>({
        trigger: isEnhanced && clients ? clients : footer,
        start: isEnhanced && clients ? 'top bottom' : null,
        endTrigger: isEnhanced && clients ? footer : null
    });
const $168d9e58e6b512ee$export$91a19323b41ab819 = async (root, { width: width = typeof window === 'undefined' ? 0 : window.innerWidth, reducedMotion: reducedMotion = $168d9e58e6b512ee$var$getReducedMotion(), gsap: gsap = globalThis.gsap, maskSupported: maskSupported = $168d9e58e6b512ee$var$getMaskSupport(), nextFrame: nextFrame = $168d9e58e6b512ee$var$waitForFirstFrame, loadMask: loadMask = $168d9e58e6b512ee$var$loadMaskImage, selectors: selectors = $168d9e58e6b512ee$var$defaultSelectors, orbitSet: orbitSet = {
    xPercent: -50,
    yPercent: -50
} } = {})=>{
    if (!root || !$168d9e58e6b512ee$export$d7d39fa6ca6220fb({
        width: width,
        reducedMotion: reducedMotion,
        gsap: gsap,
        maskSupported: maskSupported
    })) return null;
    const orbit = root.querySelector(selectors.orbit);
    const first = root.querySelector(selectors.first);
    const second = root.querySelector(selectors.second);
    const images = [
        ...root.querySelectorAll(selectors.images)
    ];
    if (!orbit || !first || !second || images.length < 2) return null;
    try {
        const maskSrc = root.dataset?.orbitalGradientMaskSrc;
        await Promise.all([
            ...images.map($168d9e58e6b512ee$var$waitForImage),
            ...maskSrc ? [
                loadMask(maskSrc)
            ] : []
        ]);
    } catch  {
        return null;
    }
    gsap.set(orbit, {
        ...orbitSet,
        x: 0,
        y: 0,
        transformOrigin: 'center center'
    });
    const timelines = [
        gsap.to(orbit, {
            rotation: 360,
            ease: 'none',
            repeat: -1,
            duration: 30
        }),
        gsap.to(first, {
            rotation: -360,
            ease: 'none',
            repeat: -1,
            duration: 30
        }),
        gsap.to(second, {
            rotation: 360,
            ease: 'none',
            repeat: -1,
            duration: 40
        })
    ];
    let isInViewport = true;
    let isDocumentVisible = typeof document === 'undefined' || document.visibilityState !== 'hidden';
    const syncPlayback = ()=>{
        const method = isInViewport && isDocumentVisible ? 'play' : 'pause';
        timelines.forEach((timeline)=>timeline[method]());
    };
    const controller = {
        pause () {
            isInViewport = false;
            syncPlayback();
        },
        resume () {
            isInViewport = true;
            syncPlayback();
        },
        setDocumentVisible (isVisible) {
            isDocumentVisible = isVisible;
            syncPlayback();
        },
        destroy () {
            timelines.forEach((timeline)=>timeline.kill());
        }
    };
    syncPlayback();
    await nextFrame();
    root.classList.add('is-orbital-gradient-ready');
    return controller;
};
const $168d9e58e6b512ee$var$observeController = (root, controller)=>{
    if (typeof IntersectionObserver === 'undefined') return;
    controller.pause();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.target !== root) return;
            if (entry.isIntersecting) controller.resume();
            else controller.pause();
        });
    });
    observer.observe(root);
};
const $168d9e58e6b512ee$export$291bf900b9f551f9 = async (scope = document, options = {})=>{
    const roots = [
        ...scope.querySelectorAll('[data-orbital-gradient]')
    ];
    const observe = options.observe || $168d9e58e6b512ee$var$observeController;
    const controllers = await Promise.all(roots.map(async (root)=>{
        if (!$168d9e58e6b512ee$var$orbitalGradientInstances.has(root)) $168d9e58e6b512ee$var$orbitalGradientInstances.set(root, $168d9e58e6b512ee$export$91a19323b41ab819(root, options));
        const controller = await $168d9e58e6b512ee$var$orbitalGradientInstances.get(root);
        if (controller) observe(root, controller);
        return controller;
    }));
    const activeControllers = controllers.filter(Boolean);
    if (activeControllers.length && typeof document !== 'undefined') document.addEventListener('visibilitychange', ()=>{
        const isVisible = document.visibilityState !== 'hidden';
        activeControllers.forEach((controller)=>controller.setDocumentVisible(isVisible));
    });
    return activeControllers;
};
if (typeof document !== 'undefined') $168d9e58e6b512ee$export$291bf900b9f551f9();



let $09a14aa091525167$var$footerGradientController = null;
let $09a14aa091525167$var$footerGradientRoot = null;
let $09a14aa091525167$var$footerGradientInit = null;
let $09a14aa091525167$var$shouldPlayFooterGradient = true;
window.footerGradientGSAPAnimation = async function() {
    const root = document.querySelector('.footer-bg');
    const main = document.querySelector('.main');
    if (!root || !main) return;
    if (root === $09a14aa091525167$var$footerGradientRoot && ($09a14aa091525167$var$footerGradientController || $09a14aa091525167$var$footerGradientInit)) return;
    $09a14aa091525167$var$footerGradientController?.destroy();
    $09a14aa091525167$var$footerGradientController = null;
    $09a14aa091525167$var$footerGradientRoot = root;
    $09a14aa091525167$var$footerGradientInit = (0, $168d9e58e6b512ee$export$91a19323b41ab819)(root, {
        maskSupported: true,
        orbitSet: {
            xPercent: 0,
            yPercent: -50
        },
        selectors: {
            orbit: '.footer-bg__bg-decor-ellipses',
            first: '.footer-bg__bg-decor-ellipse-img-wr:nth-child(1) .footer-bg__bg-decor-ellipse-img',
            second: '.footer-bg__bg-decor-ellipse-img-wr:nth-child(2) .footer-bg__bg-decor-ellipse-img',
            images: '.footer-bg__bg-decor-ellipses img'
        }
    });
    const controller = await $09a14aa091525167$var$footerGradientInit;
    if ($09a14aa091525167$var$footerGradientRoot !== root) {
        controller?.destroy();
        return;
    }
    $09a14aa091525167$var$footerGradientController = controller;
    $09a14aa091525167$var$footerGradientInit = null;
    if ($09a14aa091525167$var$footerGradientController) {
        document.documentElement.classList.add('is-footer-orbital-gradient-ready');
        window.dispatchEvent(new CustomEvent('orbital-gradient:footer-ready'));
    }
    if (!$09a14aa091525167$var$footerGradientController || $09a14aa091525167$var$shouldPlayFooterGradient) return;
    $09a14aa091525167$var$footerGradientController.pause();
};
window.pauseFooterGradientAnimation = function pauseFooterGradientAnimation1() {
    $09a14aa091525167$var$shouldPlayFooterGradient = false;
    $09a14aa091525167$var$footerGradientController?.pause();
};
window.resumeFooterGradientAnimation = function resumeFooterGradientAnimation() {
    $09a14aa091525167$var$shouldPlayFooterGradient = true;
    $09a14aa091525167$var$footerGradientController?.resume();
};
footerGradientGSAPAnimation();
if (!document.querySelector('.bold-loader-new')) pauseFooterGradientAnimation();


// import { gsap } from 'gsap';
let $fd89f8ce079d60c4$var$latestWorksEllipseTL, $fd89f8ce079d60c4$var$latestWorksImgTL, $fd89f8ce079d60c4$var$latestWorksImgSecondTL;
window.latestWorksGradientGSAPAnimation = function() {
    const imgContainer = document.querySelector('.latest-works-bg__bg-decor-ellipses');
    const main = document.querySelector('.main');
    if (!imgContainer || !main) return;
    if (window.innerWidth > 1024) {
        imgContainer.getBoundingClientRect();
        requestAnimationFrame(()=>{
            const img = imgContainer.querySelector('.latest-works-bg__bg-decor-ellipse-img-wr:nth-child(1) .latest-works-bg__bg-decor-ellipse-img');
            const imgSecond = imgContainer.querySelector('.latest-works-bg__bg-decor-ellipse-img-wr:nth-child(2) .latest-works-bg__bg-decor-ellipse-img');
            gsap.set(imgContainer, {
                xPercent: 0,
                yPercent: -50,
                x: 0,
                y: 0,
                transformOrigin: 'right bottom'
            });
            $fd89f8ce079d60c4$var$latestWorksEllipseTL = gsap.to(imgContainer, {
                rotation: 360,
                ease: 'none',
                repeat: -1,
                duration: 30
            });
            $fd89f8ce079d60c4$var$latestWorksImgTL = gsap.to(img, {
                rotation: -360,
                ease: 'none',
                repeat: -1,
                duration: 30
            });
            $fd89f8ce079d60c4$var$latestWorksImgSecondTL = gsap.to(imgSecond, {
                rotation: 360,
                ease: 'none',
                repeat: -1,
                duration: 40
            });
        });
    }
};
window.pauseLatestWorksGradientAnimation = function pauseLatestWorksGradientAnimation1() {
    if (window.innerWidth > 1024) {
        $fd89f8ce079d60c4$var$latestWorksEllipseTL?.pause();
        $fd89f8ce079d60c4$var$latestWorksImgTL?.pause();
        $fd89f8ce079d60c4$var$latestWorksImgSecondTL?.pause();
    /*console.log(
        latestWorksEllipseTL?.paused(),
        latestWorksImgTL?.paused(),
        latestWorksImgSecondTL?.paused()
      );*/ }
};
window.resumeLatestWorksGradientAnimation = function resumeLatestWorksGradientAnimation() {
    if (window.innerWidth > 1024) {
        $fd89f8ce079d60c4$var$latestWorksEllipseTL?.play();
        $fd89f8ce079d60c4$var$latestWorksImgTL?.play();
        $fd89f8ce079d60c4$var$latestWorksImgSecondTL?.play();
    /*console.log(
        latestWorksEllipseTL?.paused(),
        latestWorksImgTL?.paused(),
        latestWorksImgSecondTL?.paused()
      );*/ }
};
latestWorksGradientGSAPAnimation();
if (!document.querySelector('.bold-loader-new')) pauseLatestWorksGradientAnimation();


// import { gsap } from 'gsap';
let $18f8c1e03bbdd4fb$var$projectEllipseTL, $18f8c1e03bbdd4fb$var$projectImgTL, $18f8c1e03bbdd4fb$var$projectImgSecondTL;
window.projectGradientGSAPAnimation = function() {
    const imgContainer = document.querySelector('.project-bg__bg-decor-ellipses');
    const main = document.querySelector('.main');
    if (!imgContainer || !main) return;
    imgContainer.getBoundingClientRect();
    requestAnimationFrame(()=>{
        const img = imgContainer.querySelector('.project-bg__bg-decor-ellipse-img-wr:nth-child(1) .project-bg__bg-decor-ellipse-img');
        const imgSecond = imgContainer.querySelector('.project-bg__bg-decor-ellipse-img-wr:nth-child(2) .project-bg__bg-decor-ellipse-img');
        gsap.set(imgContainer, {
            xPercent: 0,
            yPercent: -50,
            x: 0,
            y: 0,
            transformOrigin: 'right bottom'
        });
        $18f8c1e03bbdd4fb$var$projectEllipseTL = gsap.to(imgContainer, {
            rotation: 360,
            ease: 'none',
            repeat: -1,
            duration: 30
        });
        $18f8c1e03bbdd4fb$var$projectImgTL = gsap.to(img, {
            rotation: -360,
            ease: 'none',
            repeat: -1,
            duration: 30
        });
        $18f8c1e03bbdd4fb$var$projectImgSecondTL = gsap.to(imgSecond, {
            rotation: 360,
            ease: 'none',
            repeat: -1,
            duration: 40
        });
    });
};
window.pauseProjectGradientAnimation = function pauseProjectGradientAnimation1() {
    $18f8c1e03bbdd4fb$var$projectEllipseTL?.pause();
    $18f8c1e03bbdd4fb$var$projectImgTL?.pause();
    $18f8c1e03bbdd4fb$var$projectImgSecondTL?.pause();
};
window.resumeProjectGradientAnimation = function resumeProjectGradientAnimation() {
    if (window.innerWidth > 1024) {
        $18f8c1e03bbdd4fb$var$projectEllipseTL?.play();
        $18f8c1e03bbdd4fb$var$projectImgTL?.play();
        $18f8c1e03bbdd4fb$var$projectImgSecondTL?.play();
    /*console.log(
        projectEllipseTL?.paused(),
        projectImgTL?.paused(),
        projectImgSecondTL?.paused()
      );*/ }
};
projectGradientGSAPAnimation();
if (!document.querySelector('.bold-loader-new')) pauseProjectGradientAnimation();
if (window.innerWidth < 1025) setTimeout(function() {
    pauseProjectGradientAnimation();
}, 100);


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const $6e883e375beda63e$var$initializedBlurElements = new WeakSet();
const $6e883e375beda63e$var$blurAnimationHandles = new WeakMap();
const $6e883e375beda63e$var$gradientTrackTitleSelector = [
    'h1[data-blur-splitting]',
    'h2[data-blur-splitting]',
    'h3[data-blur-splitting]',
    'h4[data-blur-splitting]',
    'h5[data-blur-splitting]',
    'h6[data-blur-splitting]'
].join(', ');
const $6e883e375beda63e$var$gradientTrackElements = new Set();
let $6e883e375beda63e$var$gradientTrackFrame = null;
let $6e883e375beda63e$var$gradientTrackObserver = null;
const $6e883e375beda63e$var$getScopedElements = (scope, selector)=>{
    if (!scope) return [];
    if (typeof scope.matches === 'function' && scope.matches(selector)) return [
        scope
    ];
    if (typeof scope.querySelectorAll !== 'function') return [];
    return Array.from(scope.querySelectorAll(selector));
};
function $6e883e375beda63e$var$getGradientTrackElements(scope) {
    return $6e883e375beda63e$var$getScopedElements(scope, $6e883e375beda63e$var$gradientTrackTitleSelector).flatMap((title)=>Array.from(title.querySelectorAll('.gradient-cl-animate')));
}
function $6e883e375beda63e$var$updateGradientTrack(element) {
    const words = element.querySelectorAll('.word');
    if (!words.length) return;
    const trackRect = element.getBoundingClientRect();
    if (!trackRect.width) return;
    const trackSize = `${trackRect.width * 4}px auto`;
    words.forEach((word)=>{
        const wordRect = word.getBoundingClientRect();
        const offsetX = trackRect.left - wordRect.left;
        word.style.setProperty('--gradient-track-size', trackSize);
        word.style.setProperty('--gradient-track-offset-x', `${offsetX}px`);
    });
}
function $6e883e375beda63e$var$updateGradientTracks() {
    $6e883e375beda63e$var$gradientTrackElements.forEach((element)=>{
        if (!element.isConnected) {
            $6e883e375beda63e$var$gradientTrackObserver?.unobserve(element);
            $6e883e375beda63e$var$gradientTrackElements.delete(element);
            return;
        }
        $6e883e375beda63e$var$updateGradientTrack(element);
    });
}
function $6e883e375beda63e$var$scheduleGradientTrackUpdate() {
    if ($6e883e375beda63e$var$gradientTrackFrame !== null) return;
    $6e883e375beda63e$var$gradientTrackFrame = window.requestAnimationFrame(()=>{
        $6e883e375beda63e$var$gradientTrackFrame = null;
        $6e883e375beda63e$var$updateGradientTracks();
    });
}
function $6e883e375beda63e$var$registerGradientTracks(scope) {
    $6e883e375beda63e$var$getGradientTrackElements(scope).forEach((element)=>{
        $6e883e375beda63e$var$gradientTrackElements.add(element);
        $6e883e375beda63e$var$gradientTrackObserver?.observe(element);
        $6e883e375beda63e$var$updateGradientTrack(element);
    });
}
function $6e883e375beda63e$var$unregisterGradientTracks(scope) {
    $6e883e375beda63e$var$getGradientTrackElements(scope).forEach((element)=>{
        $6e883e375beda63e$var$gradientTrackObserver?.unobserve(element);
        $6e883e375beda63e$var$gradientTrackElements.delete(element);
    });
}
if (typeof ResizeObserver !== 'undefined') $6e883e375beda63e$var$gradientTrackObserver = new ResizeObserver($6e883e375beda63e$var$scheduleGradientTrackUpdate);
window.addEventListener('resize', $6e883e375beda63e$var$scheduleGradientTrackUpdate, {
    passive: true
});
const $6e883e375beda63e$var$trackBlurAnimationHandle = (element, handle)=>{
    if (!handle) return;
    const handles = $6e883e375beda63e$var$blurAnimationHandles.get(element) || [];
    handles.push(handle);
    $6e883e375beda63e$var$blurAnimationHandles.set(element, handles);
};
window.destroyScrollBlurAnimation = function destroyScrollBlurAnimation(scope = document) {
    $6e883e375beda63e$var$getScopedElements(scope, '[data-blur-splitting]').forEach((element)=>{
        $6e883e375beda63e$var$blurAnimationHandles.get(element)?.forEach((handle)=>handle.kill());
        $6e883e375beda63e$var$blurAnimationHandles.delete(element);
        $6e883e375beda63e$var$initializedBlurElements.delete(element);
        $6e883e375beda63e$var$unregisterGradientTracks(element);
    });
};
window.initScrollBlurAnimation = function initScrollBlurAnimation1(scope = document) {
    const elements = $6e883e375beda63e$var$getScopedElements(scope, '[data-blur-splitting]');
    const gradientLineElsArr = $6e883e375beda63e$var$getScopedElements(scope, '.gradient-cl-animate.if-line-animation');
    gradientLineElsArr.forEach((element)=>{
        const innerText = element.textContent.trim();
        element.style.setProperty('--element-text', `"${innerText}"`);
        element.setAttribute('data-element-text', innerText);
    });
    elements.forEach((element)=>{
        if (window.innerWidth <= 1024 && element.matches('.text-digital-sec__label')) return;
        if ($6e883e375beda63e$var$initializedBlurElements.has(element)) return;
        $6e883e375beda63e$var$initializedBlurElements.add(element);
        const parentSection = element.closest('section');
        (0, (/*@__PURE__*/$parcel$interopDefault($4f41718f1a00a7f9$exports)))({
            target: element,
            by: 'words'
        });
        $6e883e375beda63e$var$registerGradientTracks(element);
        const words = element.querySelectorAll('.word');
        if (window.innerWidth >= 1025) {
            const wrapper = element.parentElement;
            const isUp = element.hasAttribute('data-blur-splitting-to-up');
            const isDown = element.hasAttribute('data-blur-splitting-to-bottom');
            const isLeft = element.hasAttribute('data-blur-splitting-to-left');
            const isFromUpToStart = element.hasAttribute('data-blur-splitting-from-up-to-start');
            let startY = 130;
            let endY = 20;
            let startTrigger = 70;
            let endTrigger = 50;
            /*if (window.innerWidth <= 1024) {
        startY = 50;
        endY = 20;
        startTrigger = 90;
        endTrigger = 40;
      }*/ const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: `top-=${startY}vh ${startTrigger}%`,
                    end: `bottom+=${endY}vh ${endTrigger}%`,
                    scrub: 0.8
                }
            });
            $6e883e375beda63e$var$trackBlurAnimationHandle(element, tl);
            let startYTransform = 100;
            let endYTransform = 0;
            let startTriggerTransform = 60;
            let endTriggerTransform = 0;
            const tlTransform = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: `top-=${startYTransform}vh ${startTriggerTransform}%`,
                    end: `bottom+=${endYTransform}vh ${endTriggerTransform}%`,
                    scrub: 0.8,
                    // markers: true,
                    onUpdate: (self)=>{
                        const progress = self.progress;
                        if (isDown) {
                            const attrValue = element.getAttribute('data-blur-splitting-to-bottom');
                            let start = -10;
                            let end = 15;
                            if (element.classList.contains('text-sec__text--arrow')) {
                                start = 0;
                                end = 110;
                            }
                            if (window.innerHeight > 1100) end = 16;
                            if (attrValue) {
                                const [startStr, endStr] = attrValue.split(',');
                                start = parseFloat(startStr) || 0;
                                end = parseFloat(endStr) || 0;
                            }
                            element.style.transform = `translateY(${gsap.utils.interpolate(start, end, progress)}vh)`;
                            if (element.classList.contains('text-sec__text--arrow')) element.style.transform = `translateY(${gsap.utils.interpolate(start, end, progress)}px)`;
                        }
                        if (isUp) {
                            const attrValue = element.getAttribute('data-blur-splitting-to-up');
                            let start = 15;
                            let end = -20;
                            if (attrValue) {
                                const [startStr, endStr] = attrValue.split(',');
                                start = parseFloat(startStr) || 0;
                                end = parseFloat(endStr) || 0;
                            }
                            element.style.transform = `translateY(${gsap.utils.interpolate(start, end, progress)}vh)`;
                        }
                    }
                }
            });
            $6e883e375beda63e$var$trackBlurAnimationHandle(element, tlTransform);
            words.forEach((word, index)=>{
                const style = getComputedStyle(word);
                const wordIndex = parseInt(style.getPropertyValue('--word-index'), 10);
                const parent = word.parentElement;
                const isGradient = parent.classList.contains('gradient-cl-animate');
                const currentColor = window.getComputedStyle(word).color;
                const parentGradientLine = word.closest('.gradient-cl-animate.if-line-animation');
                if (parentGradientLine) {
                    const wordsArr = parentGradientLine.querySelectorAll('.word');
                    for(let i = 0; i < wordsArr.length; i++)wordsArr[wordsArr.length - 1].classList.add('is-trigger-gradient-line');
                }
                let startFilter = typeof window !== 'undefined' && window.innerWidth <= 640 ? 'blur(5px)' : 'blur(14px)';
                let endFilter = 'blur(0px)';
                let startOpacity = 0;
                let endOpacity = 1;
                let blurLineApplied = false;
                if (parent.classList.contains('with-bold-logo')) {
                    startFilter = 'blur(0px)';
                    endFilter = 'blur(0px)';
                    startOpacity = 1;
                    endOpacity = 1;
                }
                // Вместо index * 0.1, нормализуем по количеству слов
                const relativeDelay = wordIndex / words.length * 0.4; // *2 — растягивает
                // Создаем timeline с ScrollTrigger
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: parent,
                        start: 'top bottom',
                        end: 'bottom 70%',
                        scrub: 1
                    }
                });
                $6e883e375beda63e$var$trackBlurAnimationHandle(element, tl);
                tl.fromTo(word, {
                    opacity: startOpacity,
                    filter: startFilter
                }, {
                    opacity: endOpacity,
                    filter: endFilter,
                    duration: 0.5,
                    ease: 'power2.out',
                    /*onStart: () => {
                const parentGradientEl = word.closest('.gradient-cl-animate');
                if (parentGradientEl) {
                  parentGradientEl.classList.add('is-line-animation');
                }
              },*/ onUpdate: function() {
                        if (word.classList.contains('is-trigger-gradient-line')) {
                            const progress = this.progress();
                            if (progress <= 0.5 && blurLineApplied) {
                                parentGradientLine.classList.remove('is-blur-line-animation');
                                blurLineApplied = false;
                            } else if (progress >= 0.85 && !blurLineApplied) {
                                parentGradientLine.classList.add('is-blur-line-animation');
                                blurLineApplied = true;
                            }
                        }
                    }
                }, relativeDelay);
                if (parent.classList.contains('with-bold-logo')) {
                    const boldLogoEl = parent.closest('.with-bold-logo');
                    const relativeDelayBoldLogo = wordIndex / words.length * 0.17; // *2 — растягивает
                    tl.fromTo(boldLogoEl, {
                        opacity: 0,
                        filter: typeof window !== 'undefined' && window.innerWidth <= 640 ? 'blur(5px)' : 'blur(14px)'
                    }, {
                        opacity: 1,
                        filter: 'blur(0px)',
                        duration: 0.45,
                        ease: 'power2.out'
                    }, relativeDelayBoldLogo);
                }
            });
            function gradientTextFunc() {
                for(let i = 0; i < words.length; i++){
                    const parentGradient = words[i].closest('.gradient-cl-animate');
                    if (parentGradient) {
                        const gradientWords = parentGradient.querySelectorAll('.word');
                        const targetIndex = gradientWords.length > 2 ? Math.floor(gradientWords.length / 2) : gradientWords.length - 1;
                        const targetWord = gradientWords[targetIndex];
                        const opacity = parseFloat(getComputedStyle(targetWord).opacity);
                        if (opacity > 0.85) parentGradient.classList.remove('is-clear-gradient');
                        else parentGradient.classList.add('is-clear-gradient');
                    }
                }
            }
            gradientTextFunc();
            if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.batch(words, {
                start: 'top bottom',
                end: 'bottom 80%',
                onLeaveBack: (batch)=>{
                    batch.forEach((word)=>word.classList.remove('is-end'));
                }
            }).forEach((trigger)=>$6e883e375beda63e$var$trackBlurAnimationHandle(element, trigger));
        } else {
            element.setAttribute('data-aos', '');
            if (element.classList.contains('if-fade-in-mobile')) {
                element.classList.add('fade-in-blur-text-aos-animation');
                element.setAttribute('data-aos-offset', '20');
                element.setAttribute('data-aos-once', 'false');
            } else element.classList.add('blur-text-aos-animation');
            // Устанавливаем минимальную и максимальную продолжительность анимации
            const minDuration = 0.4; // Минимальная длительность анимации
            const maxDuration = 0.6; // Максимальная длительность анимации
            const minWords = 2; // Минимальное количество слов
            const maxWords = 14; // Максимальное количество слов
            const wordsCount = Math.min(Math.max(words.length, minWords), maxWords);
            // Линейная интерполяция продолжительности анимации в пределах от 0.5 до 1 секунды
            const duration = minDuration + (maxDuration - minDuration) * ((wordsCount - minWords) / (maxWords - minWords));
            element.style.setProperty('--animation-duration', `${duration}s`);
        }
    });
    if (window.innerWidth <= 1024) setTimeout(()=>{
        AOS.refreshHard();
    }, 100);
};
if (!document.querySelector('.bold-loader-new')) initScrollBlurAnimation();
const $6e883e375beda63e$var$blurTextAosAnimArr = document.querySelectorAll('.blur-text-aos-animation');
if ($6e883e375beda63e$var$blurTextAosAnimArr.length) $6e883e375beda63e$var$blurTextAosAnimArr.forEach((element)=>{
    const words = element.querySelectorAll('.word');
    const minDuration = 0.6;
    const maxDuration = 0.7;
    const minWords = 2;
    const maxWords = 14;
    const wordsCount = Math.min(Math.max(words.length, minWords), maxWords);
    const duration = minDuration + (maxDuration - minDuration) * ((wordsCount - minWords) / (maxWords - minWords));
    element.style.setProperty('--animation-duration', `${duration}s`);
});
window.blurLineAnimFunc = function blurLineAnimFunc1() {
    const blurLineAnimElArr = document.querySelectorAll('.gradient-cl-animate.if-line-animation');
    if (!blurLineAnimElArr.length) return;
    if (window.innerWidth >= 1025) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const el = entry.target;
            if (!entry.isIntersecting) {
                el.classList.remove('is-blur-line-animation');
                return;
            }
            // если вошёл в зону видимости → вешаем с задержкой
            setTimeout(()=>{
                el.classList.add('is-blur-line-animation');
            }, window.innerWidth > 1024 ? 1000 : 3000);
        });
    }, {
        threshold: 0.85
    }); // 85% видимости
    blurLineAnimElArr.forEach((el)=>observer.observe(el));
};
if (!document.querySelector('.bold-loader-new')) blurLineAnimFunc();



const $e48bc6b4fbbf1dd6$export$5d8d12fc451c5287 = 'text-digital-fill';
const $e48bc6b4fbbf1dd6$var$TEXT_DIGITAL_GRADIENT_SELECTOR = '[data-text-digital-gradient]';
const $e48bc6b4fbbf1dd6$var$TEXT_DIGITAL_STRIKETHROUGH_SELECTOR = 's, strike, del';
const $e48bc6b4fbbf1dd6$export$61dd42837a7b2a0e = (words, handoffWord)=>Array.from(words).find((word)=>word?.dataset?.word === handoffWord) || null;
const $e48bc6b4fbbf1dd6$export$8e97c680bb79abc7 = (element)=>{
    if (typeof element?.querySelector !== 'function') return {
        element: null,
        isLegacy: false
    };
    const legacyGradientElement = element.querySelector($e48bc6b4fbbf1dd6$var$TEXT_DIGITAL_GRADIENT_SELECTOR);
    if (legacyGradientElement) return {
        element: legacyGradientElement,
        isLegacy: true
    };
    const strongGradientElement = element.querySelector('strong');
    if (!strongGradientElement) return {
        element: null,
        isLegacy: false
    };
    strongGradientElement.setAttribute?.('data-text-digital-gradient', '');
    return {
        element: strongGradientElement,
        isLegacy: false
    };
};
const $e48bc6b4fbbf1dd6$export$af3026ebc4535b4f = (words, gradientElement)=>Array.from(words).find((word)=>gradientElement?.contains?.(word.node || word)) || null;
const $e48bc6b4fbbf1dd6$export$b0c0c181d4d711da = (words, textElement)=>{
    if (typeof textElement?.querySelector !== 'function') return null;
    const strikethroughElement = textElement.querySelector($e48bc6b4fbbf1dd6$var$TEXT_DIGITAL_STRIKETHROUGH_SELECTOR);
    if (!strikethroughElement) return null;
    return Array.from(words).find((word)=>strikethroughElement.contains?.(word.node || word)) || null;
};
const $e48bc6b4fbbf1dd6$export$162bd2bfa3b17af6 = (textElement, gradientElement)=>{
    if (typeof textElement?.querySelector !== 'function' || !gradientElement) return null;
    const markerElement = textElement.querySelector($e48bc6b4fbbf1dd6$var$TEXT_DIGITAL_STRIKETHROUGH_SELECTOR);
    const whitespaceNode = markerElement?.nextSibling;
    if (!markerElement || whitespaceNode?.nodeType !== 3 || !/\s/.test(whitespaceNode.textContent || '') || whitespaceNode.nextSibling !== gradientElement) return null;
    return {
        markerElement: markerElement,
        gradientElement: gradientElement
    };
};
const $e48bc6b4fbbf1dd6$export$a5fd1abb80fc3011 = (boundary)=>{
    const { markerElement: markerElement, gradientElement: gradientElement } = boundary || {};
    const parent = markerElement?.parentNode;
    if (!parent || parent !== gradientElement?.parentNode) return false;
    const nextSibling = markerElement.nextSibling;
    if (nextSibling?.nodeType === 3 && /\s/.test(nextSibling.textContent || '')) return false;
    if (nextSibling !== gradientElement) return false;
    const whitespaceNode = markerElement.ownerDocument?.createTextNode?.(' ');
    if (!whitespaceNode || typeof parent.insertBefore !== 'function') return false;
    parent.insertBefore(whitespaceNode, gradientElement);
    return true;
};
const $e48bc6b4fbbf1dd6$export$77d7e3765f13fd6b = (words, textElement, gradientElement, legacyHandoffWord)=>$e48bc6b4fbbf1dd6$export$b0c0c181d4d711da(words, textElement) || (legacyHandoffWord ? $e48bc6b4fbbf1dd6$export$61dd42837a7b2a0e(words, legacyHandoffWord) : null) || $e48bc6b4fbbf1dd6$export$af3026ebc4535b4f(words, gradientElement);
const $e48bc6b4fbbf1dd6$export$e11e969d56fc9f4e = (element, gradientElement, legacyHandoffWord)=>{
    const document = element.ownerDocument;
    const walker = document.createTreeWalker(element, 4);
    const words = [];
    let node;
    while(node = walker.nextNode())for (const match of node.textContent.matchAll(/\S+/g))words.push({
        node: node,
        start: match.index,
        end: match.index + match[0].length,
        dataset: {
            word: match[0]
        }
    });
    const word = $e48bc6b4fbbf1dd6$export$77d7e3765f13fd6b(words, element, gradientElement, legacyHandoffWord);
    if (!word) return null;
    const range = document.createRange();
    range.setStart(word.node, word.start);
    range.setEnd(word.node, word.end);
    return range;
};
const $e48bc6b4fbbf1dd6$export$6507f1d58f195203 = (currentTime, handoffEnd)=>Number.isFinite(handoffEnd) && currentTime >= handoffEnd;
const $e48bc6b4fbbf1dd6$export$350fdf95f4497d99 = (previousState, nextState)=>previousState !== nextState;
const $e48bc6b4fbbf1dd6$export$32c420d47021b0b1 = (gradientRect, wordRect)=>{
    const values = [
        gradientRect?.left,
        gradientRect?.top,
        gradientRect?.width,
        gradientRect?.height,
        wordRect?.left,
        wordRect?.top
    ];
    if (!values.every(Number.isFinite) || gradientRect.width <= 0 || gradientRect.height <= 0) return null;
    return {
        size: `${gradientRect.width}px ${gradientRect.height}px`,
        position: `${gradientRect.left - wordRect.left}px ${gradientRect.top - wordRect.top}px`
    };
};
const $e48bc6b4fbbf1dd6$export$69b0d70d744143e = (gradientElement)=>{
    if (typeof gradientElement?.getBoundingClientRect !== 'function' || typeof gradientElement.querySelectorAll !== 'function') return false;
    const words = Array.from(gradientElement.querySelectorAll('.word'));
    const clearWordStyles = ()=>{
        words.forEach((word)=>{
            word.style?.removeProperty('--text-digital-gradient-size');
            word.style?.removeProperty('--text-digital-gradient-position');
        });
        gradientElement.classList?.toggle('is-text-digital-gradient-positioned', false);
    };
    if (!words.length || words.some((word)=>typeof word?.getBoundingClientRect !== 'function' || typeof word.style?.setProperty !== 'function')) {
        clearWordStyles();
        return false;
    }
    const gradientRect = gradientElement.getBoundingClientRect();
    const wordStyles = words.map((word)=>({
            word: word,
            styles: $e48bc6b4fbbf1dd6$export$32c420d47021b0b1(gradientRect, word.getBoundingClientRect())
        }));
    if (wordStyles.some(({ styles: styles })=>!styles)) {
        clearWordStyles();
        return false;
    }
    wordStyles.forEach(({ word: word, styles: styles })=>{
        word.style.setProperty('--text-digital-gradient-size', styles.size);
        word.style.setProperty('--text-digital-gradient-position', styles.position);
    });
    gradientElement.classList?.toggle('is-text-digital-gradient-positioned', true);
    return true;
};


const $8b88263db9c9b79a$var$initializedTextDigitalFill = new WeakSet();
const $8b88263db9c9b79a$var$TEXT_DIGITAL_FILL_SCROLL_FACTOR = 0.35;
const $8b88263db9c9b79a$var$TEXT_DIGITAL_FILL_PARALLAX = {
    desktop: {
        from: 150,
        to: -80
    }
};
const $8b88263db9c9b79a$var$TEXT_DIGITAL_FILL_SCRUB = {
    desktop: 0.6
};
const $8b88263db9c9b79a$var$getTextDigitalFillElements = (scope)=>{
    if (!scope) return [];
    if (typeof scope.matches === 'function' && scope.matches('[data-text-digital-fill]')) return [
        scope
    ];
    if (typeof scope.querySelectorAll !== 'function') return [];
    return Array.from(scope.querySelectorAll('[data-text-digital-fill]'));
};
const $8b88263db9c9b79a$var$setWordsProgress = (words, progress)=>{
    words.forEach((word)=>{
        word.style.setProperty('--text-digital-fill-word-progress', progress);
    });
};
const $8b88263db9c9b79a$var$getWordsByRows = (words)=>{
    const rowThreshold = 8;
    return words.reduce((rows, word)=>{
        const rect = word.getBoundingClientRect();
        const row = rows.find((item)=>Math.abs(item.top - rect.top) <= rowThreshold);
        if (row) {
            row.words.push({
                word: word,
                left: rect.left
            });
            row.top = (row.top + rect.top) / 2;
            return rows;
        }
        rows.push({
            top: rect.top,
            words: [
                {
                    word: word,
                    left: rect.left
                }
            ]
        });
        return rows;
    }, []).sort((a, b)=>a.top - b.top).map((row)=>row.words.sort((a, b)=>a.left - b.left).map((item)=>item.word));
};
window.textDigitalFillAnimation = function textDigitalFillAnimation(scope = document) {
    const elements = $8b88263db9c9b79a$var$getTextDigitalFillElements(scope);
    if (!elements.length) return;
    const canAnimate = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
    if (canAnimate) gsap.registerPlugin(ScrollTrigger);
    elements.forEach((element)=>{
        if ($8b88263db9c9b79a$var$initializedTextDigitalFill.has(element)) return;
        $8b88263db9c9b79a$var$initializedTextDigitalFill.add(element);
        const section = element.closest('.text-digital-sec');
        const parallaxTarget = section?.querySelector('.text-digital-sec__wrap') || element;
        const pinTarget = section || parallaxTarget;
        const accessibleText = element.textContent.trim().replace(/\s+/g, ' ');
        if (accessibleText) element.setAttribute('aria-label', accessibleText);
        const originalHTML = element.innerHTML;
        const originalClass = element.getAttribute('class');
        const originalStyle = element.getAttribute('style');
        const restoreContent = ()=>{
            element.innerHTML = originalHTML;
            for (const [name, value] of [
                [
                    'class',
                    originalClass
                ],
                [
                    'style',
                    originalStyle
                ]
            ])if (value === null) element.removeAttribute(name);
            else element.setAttribute(name, value);
            delete element["\uD83C\uDF4C"];
            section?.classList.remove('is-text-digital-handoff');
            if (section?.classList.contains('is-bg-changes')) window.syncBgChangeTheme?.(section);
        };
        const showStaticText = (hasReducedMotion = true)=>{
            const { element: gradientElement, isLegacy: isLegacy } = (0, $e48bc6b4fbbf1dd6$export$8e97c680bb79abc7)(element);
            element.classList.add('is-text-digital-fill-static');
            section?.classList.remove('is-text-digital-handoff');
            if (canAnimate && section) {
                const watermark = section.querySelector('.text-digital-sec__watermark-logo');
                if (watermark && !hasReducedMotion) gsap.fromTo(watermark, {
                    y: 48
                }, {
                    y: -48,
                    ease: 'none',
                    scrollTrigger: {
                        id: 'text-digital-watermark-parallax',
                        trigger: section,
                        start: 'top 75%',
                        end: 'bottom 25%',
                        scrub: 0.6
                    }
                });
                const range = (0, $e48bc6b4fbbf1dd6$export$e11e969d56fc9f4e)(element, gradientElement, isLegacy ? element.dataset.textDigitalHandoffWord : undefined);
                if (range) {
                    const syncHandoff = (self)=>{
                        const active = self.scroll() >= self.start;
                        if (section.classList.contains('is-text-digital-handoff') === active) return;
                        section.classList.toggle('is-text-digital-handoff', active);
                        if (section.classList.contains('is-bg-changes')) window.syncBgChangeTheme?.(section);
                    };
                    ScrollTrigger.create({
                        id: 'text-digital-static-handoff',
                        trigger: section,
                        start: ()=>{
                            const rect = range.getBoundingClientRect();
                            return window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;
                        },
                        end: 'bottom top',
                        onUpdate: syncHandoff,
                        onRefresh: syncHandoff
                    });
                }
            }
            return restoreContent;
        };
        if (!canAnimate) {
            showStaticText();
            return;
        }
        const media = gsap.matchMedia();
        media.add({
            compact: '(max-width: 1024px)',
            desktop: '(min-width: 1025px)',
            reduced: '(prefers-reduced-motion: reduce)'
        }, (context)=>{
            if (context.conditions.compact) return showStaticText(context.conditions.reduced);
            const hasReducedMotion = context.conditions.reduced;
            const { element: gradientElement, isLegacy: isLegacyGradient } = (0, $e48bc6b4fbbf1dd6$export$8e97c680bb79abc7)(element);
            const markerWhitespaceBoundary = (0, $e48bc6b4fbbf1dd6$export$162bd2bfa3b17af6)(element, gradientElement);
            (0, (/*@__PURE__*/$parcel$interopDefault($4f41718f1a00a7f9$exports)))({
                target: element,
                by: 'words',
                force: true
            });
            (0, $e48bc6b4fbbf1dd6$export$a5fd1abb80fc3011)(markerWhitespaceBoundary);
            const words = Array.from(element.querySelectorAll('.word'));
            const gradientElements = Array.from(element.querySelectorAll('[data-text-digital-gradient]'));
            gradientElements.forEach((0, $e48bc6b4fbbf1dd6$export$69b0d70d744143e));
            if (!words.length) {
                element.classList.add('is-text-digital-fill-complete');
                return restoreContent;
            }
            words.forEach((word)=>{
                if (!word.dataset.word) word.dataset.word = word.textContent;
            });
            element.classList.add('is-text-digital-fill-init');
            $8b88263db9c9b79a$var$setWordsProgress(words, hasReducedMotion ? '100%' : '0%');
            if (hasReducedMotion) {
                element.classList.add('is-text-digital-fill-complete');
                return restoreContent;
            }
            const trigger = section || element;
            const rows = $8b88263db9c9b79a$var$getWordsByRows(words);
            const orderedWords = rows.flat();
            const handoffWord = (0, $e48bc6b4fbbf1dd6$export$77d7e3765f13fd6b)(orderedWords, element, gradientElement, isLegacyGradient ? element.dataset.textDigitalHandoffWord : undefined);
            const wordDuration = 1;
            const rowPause = 0.45;
            const parallax = $8b88263db9c9b79a$var$TEXT_DIGITAL_FILL_PARALLAX.desktop;
            const scrub = $8b88263db9c9b79a$var$TEXT_DIGITAL_FILL_SCRUB.desktop;
            const scrollDistance = Math.max(window.innerHeight * 1.85, orderedWords.length * 96 + Math.max(rows.length - 1, 0) * 140) * $8b88263db9c9b79a$var$TEXT_DIGITAL_FILL_SCROLL_FACTOR;
            let timelinePosition = 0;
            let handoffEnd;
            let isTextDigitalHandoff = false;
            const fillTimeline = gsap.timeline({
                scrollTrigger: {
                    id: (0, $e48bc6b4fbbf1dd6$export$5d8d12fc451c5287),
                    trigger: trigger,
                    start: 'top top',
                    end: `+=${scrollDistance}`,
                    pin: pinTarget,
                    pinSpacing: true,
                    anticipatePin: 1,
                    scrub: scrub,
                    refreshPriority: 2,
                    invalidateOnRefresh: true,
                    onRefresh: ()=>{
                        gradientElements.forEach((0, $e48bc6b4fbbf1dd6$export$69b0d70d744143e));
                    }
                }
            });
            fillTimeline.fromTo(parallaxTarget, {
                y: parallax.from
            }, {
                y: parallax.to,
                duration: orderedWords.length * wordDuration + rows.length * rowPause,
                ease: 'none'
            }, 0);
            rows.forEach((row)=>{
                row.forEach((word)=>{
                    fillTimeline.to(word, {
                        '--text-digital-fill-word-progress': '100%',
                        duration: wordDuration,
                        ease: 'none'
                    }, timelinePosition);
                    timelinePosition += wordDuration;
                    if (word === handoffWord) handoffEnd = timelinePosition;
                });
                timelinePosition += rowPause;
            });
            fillTimeline.eventCallback('onUpdate', ()=>{
                if (!fillTimeline.scrollTrigger?.isActive) return;
                const nextTextDigitalHandoff = (0, $e48bc6b4fbbf1dd6$export$6507f1d58f195203)(fillTimeline.time(), handoffEnd);
                if (!(0, $e48bc6b4fbbf1dd6$export$350fdf95f4497d99)(isTextDigitalHandoff, nextTextDigitalHandoff)) return;
                isTextDigitalHandoff = nextTextDigitalHandoff;
                section?.classList.toggle('is-text-digital-handoff', isTextDigitalHandoff);
                window.syncBgChangeTheme?.(section);
            });
            return restoreContent;
        });
    });
};
if (!document.querySelector('.bold-loader-new')) window.textDigitalFillAnimation();


gsap.registerPlugin(ScrollTrigger);
let $6c0add6e464e56a5$var$bgChangeTriggers = []; // массив только для этих триггеров
const $6c0add6e464e56a5$var$bgChangeMobileMediaQuery = '(max-width: 640px)';
let $6c0add6e464e56a5$var$bgChangeMediaQuery;
const $6c0add6e464e56a5$var$getBgChangeStart = (element)=>{
    const defaultStart = element.dataset.secBgChangeStart || 'top 50%';
    if (!$6c0add6e464e56a5$var$bgChangeMediaQuery?.matches) return defaultStart;
    return element.dataset.secBgChangeMobileStart || defaultStart;
};
window.bgChangeAnimation = function bgChangeAnimation1() {
    const body = document.querySelector('body');
    const bodyBg = document.querySelector('.body-bg');
    const elements = Array.from(document.querySelectorAll('[data-sec-bg-change]'));
    let currentBgChangeElement = null;
    let currentBgChangeTheme = null;
    // убиваем старые триггеры перед созданием новых
    $6c0add6e464e56a5$var$bgChangeTriggers.forEach((t)=>t.kill());
    $6c0add6e464e56a5$var$bgChangeTriggers = [];
    const isOnlyDark = !document.querySelectorAll('[data-sec-bg-change-light]');
    const isElementInViewport = (element)=>{
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    };
    const isBeforeCustomEnd = (candidate, endTrigger)=>{
        const end = candidate.dataset.secBgChangeEnd;
        if (!end || !endTrigger) return isElementInViewport(candidate);
        const [triggerEdge, viewportPosition] = end.split(/\s+/);
        const viewportRatio = Number.parseFloat(viewportPosition) / 100;
        if (![
            'top',
            'bottom'
        ].includes(triggerEdge) || !viewportPosition?.endsWith('%') || !Number.isFinite(viewportRatio)) return isElementInViewport(candidate);
        const endTriggerRect = endTrigger.getBoundingClientRect();
        return endTriggerRect[triggerEdge] > window.innerHeight * viewportRatio;
    };
    const getVisibleCustomEndOwner = (element)=>elements.find((candidate)=>{
            const endTriggerSelector = candidate.dataset.secBgChangeEndTrigger;
            const endTrigger = endTriggerSelector ? document.querySelector(endTriggerSelector) : null;
            if (!endTrigger) return false;
            return endTrigger === element && isBeforeCustomEnd(candidate, endTrigger);
        });
    const hasCustomEndOwner = (element)=>elements.some((candidate)=>{
            const endTriggerSelector = candidate.dataset.secBgChangeEndTrigger;
            return endTriggerSelector && document.querySelector(endTriggerSelector) === element;
        });
    const getBackgroundTheme = (element)=>{
        const isTextDigitalHandoff = element.classList.contains('is-text-digital-handoff');
        const isLight = element.hasAttribute('data-sec-bg-change-light') && !isTextDigitalHandoff;
        const isDark = element.hasAttribute('data-sec-bg-change-dark') || isTextDigitalHandoff;
        if (isLight && !isOnlyDark) return 'light';
        return isDark ? 'dark' : null;
    };
    const applyBackgroundTheme = (element, theme)=>{
        if (theme === 'light') {
            bodyBg.classList.remove('is-bg-dark');
            bodyBg.classList.add('is-bg-light');
            body.classList.remove('is-bg-dark');
            body.classList.add('is-bg-light');
            document.documentElement.style.setProperty('--mf-cursor-bg-actual', `${getComputedStyle(element).getPropertyValue('--cl-black').trim()}`);
            return;
        }
        if (theme === 'dark') {
            bodyBg.classList.remove('is-bg-light');
            bodyBg.classList.add('is-bg-dark');
            body.classList.remove('is-bg-light');
            body.classList.add('is-bg-dark');
            document.documentElement.style.setProperty('--mf-cursor-bg-actual', `${getComputedStyle(element).getPropertyValue('--cl-white').trim()}`);
        }
    };
    const activateElement = (sourceElement, options = {})=>{
        const { ignoreCustomEndOwner: ignoreCustomEndOwner = false, force: force = false } = options;
        const element = ignoreCustomEndOwner ? sourceElement : getVisibleCustomEndOwner(sourceElement) || sourceElement;
        const theme = getBackgroundTheme(element);
        if (!force && currentBgChangeElement === element && currentBgChangeTheme === theme) return;
        elements.forEach((el)=>{
            el.classList.remove('is-bg-changes', 'is-next-bg-changes');
        });
        element.classList.add('is-bg-changes');
        if (element.previousElementSibling) element.previousElementSibling.classList.add('is-next-bg-changes');
        applyBackgroundTheme(element, theme);
        if (element.classList.contains('latest-works-sec-wr')) {
            bodyBg.classList.remove('is-worked-full-video-bg');
            body.classList.remove('is-worked-full-video-bg');
        }
        currentBgChangeElement = element;
        currentBgChangeTheme = theme;
    };
    window.syncBgChangeTheme = (sourceElement)=>{
        if (!elements.includes(sourceElement)) return;
        activateElement(sourceElement, {
            ignoreCustomEndOwner: true,
            force: true
        });
    };
    elements.forEach((element)=>{
        const start = $6c0add6e464e56a5$var$getBgChangeStart(element);
        const end = element.dataset.secBgChangeEnd || 'bottom 50%';
        const endTriggerSelector = element.dataset.secBgChangeEndTrigger;
        const endTrigger = endTriggerSelector ? document.querySelector(endTriggerSelector) : null;
        const next = element.nextElementSibling;
        if (next) {
            const currentIsDark = element.hasAttribute('data-sec-bg-change-dark');
            const currentIsLight = element.hasAttribute('data-sec-bg-change-light');
            const nextIsDark = next.hasAttribute('data-sec-bg-change-dark');
            const nextIsLight = next.hasAttribute('data-sec-bg-change-light');
            if (currentIsDark && nextIsDark || currentIsLight && nextIsLight) element.classList.add('is-next-same-bg');
        }
        const triggerOptions = {
            trigger: element,
            start: start,
            end: end,
            onToggle: (self)=>{
                if (self.isActive) {
                    activateElement(element);
                    return;
                }
                if (self.direction < 0) {
                    const customEndOwner = getVisibleCustomEndOwner(element);
                    if (customEndOwner) activateElement(customEndOwner, {
                        ignoreCustomEndOwner: true
                    });
                }
            }
        };
        if (hasCustomEndOwner(element)) triggerOptions.onUpdate = (self)=>{
            if (self.isActive) activateElement(element);
        };
        if (endTrigger) triggerOptions.endTrigger = endTrigger;
        const trigger = ScrollTrigger.create(triggerOptions);
        $6c0add6e464e56a5$var$bgChangeTriggers.push(trigger);
    });
    ScrollTrigger.refresh();
};
window.reinitBgChangeAnimation = function reinitBgChangeAnimation() {
    bgChangeAnimation();
};
const $6c0add6e464e56a5$var$initBgChangeMediaQuery = ()=>{
    if ($6c0add6e464e56a5$var$bgChangeMediaQuery || typeof window.matchMedia !== 'function') return;
    $6c0add6e464e56a5$var$bgChangeMediaQuery = window.matchMedia($6c0add6e464e56a5$var$bgChangeMobileMediaQuery);
    const reinitBackgroundChange = ()=>window.bgChangeAnimation?.();
    if (typeof $6c0add6e464e56a5$var$bgChangeMediaQuery.addEventListener === 'function') {
        $6c0add6e464e56a5$var$bgChangeMediaQuery.addEventListener('change', reinitBackgroundChange);
        return;
    }
    $6c0add6e464e56a5$var$bgChangeMediaQuery.addListener(reinitBackgroundChange);
};
$6c0add6e464e56a5$var$initBgChangeMediaQuery();
if (!document.querySelector('.bold-loader-new')) bgChangeAnimation();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
var $5d42574cf5ae588d$exports = {};
"use strict";
Object.defineProperty($5d42574cf5ae588d$exports, "__esModule", {
    value: true
});
$5d42574cf5ae588d$exports.default = void 0;
var $5d42574cf5ae588d$var$_default = {
    days: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ],
    daysShort: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    daysMin: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03B5",
        "\u03A0\u03B1",
        "\u03A3\u03B1"
    ],
    months: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ],
    monthsShort: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    today: "\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1",
    clear: "\u039A\u03B1\u03B8\u03B1\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2",
    dateFormat: 'dd/MM/yyyy',
    timeFormat: 'hh:mm aa',
    firstDay: 1
};
$5d42574cf5ae588d$exports.default = $5d42574cf5ae588d$var$_default;


const $e015bea8e4582da0$export$ce659ed00d76b325 = (progress)=>{
    const isDigitalRevealVisible = progress > 0.6;
    return {
        isDigitalRevealVisible: isDigitalRevealVisible,
        isFirstFixedBackgroundVisible: !isDigitalRevealVisible,
        shouldPauseFirstGradient: progress > 0.8
    };
};


gsap.registerPlugin(ScrollTrigger);
const $2c742eff6756a66b$var$original = document.querySelector('.first-sec-bg')?.cloneNode(true);
window.insertClonedBgFirst = function insertClonedBgFirst() {
    const copy = $2c742eff6756a66b$var$original.cloneNode(true);
    document.querySelector('.body-bg')?.appendChild(copy);
};
window.bgFirstFixedAnimation = function bgFirstFixedAnimation1() {
    const bgEl = document.querySelector('[data-first-parallax-bg]');
    const section = document.querySelector('[data-first-parallax-bg-sec]');
    const btnOurWorkWr = document.querySelector('.btn-our-work-wr');
    const bodyBg = document.querySelector('.body-bg');
    const body = document.querySelector('body');
    const textArrowSec = document.querySelector('.text-digital-sec') || document.querySelector('.text-arrow-type.text-sec');
    if (!bgEl || !section) return;
    let endY = window.innerHeight * 1.3;
    if (window.innerWidth <= 640) endY = window.innerHeight / 1.5;
    else if (window.innerWidth <= 1024) endY = window.innerHeight / 1.4;
    if (section?.classList.contains('for-footer-bg-wr')) endY = 1000;
    ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: `${endY}px`,
        invalidateOnRefresh: true,
        // markers: true,
        onUpdate: (self)=>{
            requestAnimationFrame(()=>{
                const { isDigitalRevealVisible: isDigitalRevealVisible, isFirstFixedBackgroundVisible: isFirstFixedBackgroundVisible, shouldPauseFirstGradient: shouldPauseFirstGradient } = (0, $e015bea8e4582da0$export$ce659ed00d76b325)(self.progress);
                section.classList.toggle('is-hidden-gradient', isDigitalRevealVisible);
                btnOurWorkWr?.classList.toggle('is-hidden-gradient', isDigitalRevealVisible);
                textArrowSec?.classList.toggle('is-hidden-gradient', isDigitalRevealVisible);
                if (shouldPauseFirstGradient) {
                    if (!section.classList.contains('tap-latest-work-first-sec')) pauseFirstGradientAnimation();
                }
                if (!isFirstFixedBackgroundVisible) {
                    if (!section.classList.contains('tap-latest-work-first-sec')) {
                        bodyBg.classList.remove('is-worked-first-fixed-bg');
                        body.classList.remove('is-worked-first-fixed-bg');
                    }
                } else if (!bodyBg.classList.contains('is-worked-first-fixed-bg')) {
                    bodyBg.classList.add('is-worked-first-fixed-bg');
                    body.classList.add('is-worked-first-fixed-bg');
                    resumeFirstGradientAnimation();
                }
            });
        }
    });
};
if (!document.querySelector('.bold-loader-new')) {
    const bodyBg = document.querySelector('.body-bg');
    const firstBgEL = document.querySelector('.first-sec-bg');
    const body = document.querySelector('body');
    if (firstBgEL && bodyBg) {
        bodyBg.prepend(firstBgEL);
        bodyBg.classList.add('is-worked-first-fixed-bg');
        body.classList.add('is-worked-first-fixed-bg');
    }
    bgFirstFixedAnimation();
} else {
    const bodyBg = document.querySelector('.body-bg');
    const firstBgEL = document.querySelector('.first-sec-bg');
    const body = document.querySelector('body');
    if (firstBgEL && bodyBg) {
        bodyBg.classList.add('is-worked-first-fixed-bg');
        body.classList.add('is-worked-first-fixed-bg');
    }
}
window.scrollTriggerRefreshFunc = function scrollTriggerRefreshFunc() {
    ScrollTrigger.refresh(true);
};



gsap.registerPlugin(ScrollTrigger);
let $e65c7c7545e04d7d$var$bgFixedTriggers = [];
window.bgFixedAnimation = function bgFixedAnimation1() {
    $e65c7c7545e04d7d$var$bgFixedTriggers.forEach((trigger)=>trigger.kill());
    $e65c7c7545e04d7d$var$bgFixedTriggers = [];
    const bgSectionsElsArr = document.querySelectorAll('[data-parallax-bg-sec]');
    const bgElsArr = document.querySelectorAll('[data-parallax-bg]');
    const bodyBg = document.querySelector('.body-bg');
    const isBodyBgExists = !!bodyBg;
    const activeFixedBackgroundSections = new Set();
    const syncFixedBackgroundState = ()=>{
        if (!isBodyBgExists) return;
        bodyBg.classList.toggle('is-worked-fixed-bg', activeFixedBackgroundSections.size > 0);
    };
    bgSectionsElsArr.forEach((bgSecEl, idx)=>{
        let startY = 10;
        let endY = 10;
        let startTrigger = 'center';
        let endTrigger = 'center';
        const isFooterSection = bgSecEl?.classList.contains('footer');
        const bgEl = isFooterSection ? bodyBg?.querySelector('.footer-bg') : bgElsArr[idx];
        const footerTriggerConfig = (0, $168d9e58e6b512ee$export$4ca8e834ce5bc122)({
            footer: bgSecEl,
            clients: document.querySelector('.clients-gradient-sec'),
            isEnhanced: document.documentElement.classList.contains('is-footer-orbital-gradient-ready')
        });
        if (bgSecEl?.classList.contains('latest-works-sec-wr')) {
            startY = window.innerWidth > 1024 ? 6 : 10;
            endY = 0;
            endTrigger = '35%';
            if (window.innerWidth <= 640) endY = 0;
        }
        if (bgSecEl?.classList.contains('video-full-sec')) {
            startY = 0;
            endY = 0;
        }
        if (bgSecEl?.classList.contains('evolve-video-bg-wr')) {
            startY = 6;
            endY = window.innerWidth > 640 ? 0 : 3;
            // endTrigger = '35%';
            if (window.innerWidth <= 640) {
                endTrigger = '62%';
                startY = 0;
                endY = 0;
            }
        }
        if (bgSecEl?.classList.contains('for-clients-sec')) {
            startY = window.innerWidth > 640 ? 0 : 10;
            endY = 0;
            startTrigger = '35%';
        /*endTrigger = '35%';*/ /*endTrigger = '10%';*/ }
        if (bgSecEl?.classList.contains('footer')) {
            startY = window.innerWidth > 640 ? 15 : 6;
            endY = 0;
            if (document.querySelector('.contact-sec')) startY = 200;
        }
        if (bgSecEl?.classList.contains('for-footer-bg-wr')) endY = 1000;
        if (!bgSecEl || !bgEl) return;
        const trigger = isFooterSection ? footerTriggerConfig.trigger : bgSecEl;
        const start = isFooterSection && footerTriggerConfig.start ? footerTriggerConfig.start : `top-=${startY}% ${startTrigger}`;
        const scrollTrigger = ScrollTrigger.create({
            trigger: trigger,
            ...isFooterSection && footerTriggerConfig.endTrigger ? {
                endTrigger: footerTriggerConfig.endTrigger
            } : {},
            start: start,
            end: `bottom+=${endY}% ${endTrigger}`,
            scrub: true,
            invalidateOnRefresh: true,
            // markers: true,
            onToggle: (self)=>{
                const isVisible = bgEl.classList.contains('is-visible-bg');
                const isFooter = isFooterSection;
                const isFooterGradientWorked = isFooter && bgSecEl.classList.contains('is-worked-gradient-animation');
                const isLatestWorks = bgSecEl.classList.contains('latest-works-sec-wr');
                const isLatestWorksGradientWorked = isLatestWorks && bgSecEl.classList.contains('is-worked-gradient-animation');
                const isProject = bgSecEl.classList.contains('project-sec-wr');
                const isProjectGradientWorked = isProject && bgSecEl.classList.contains('is-worked-gradient-animation');
                if (!self.isActive) {
                    activeFixedBackgroundSections.delete(bgSecEl);
                    syncFixedBackgroundState();
                    if (isVisible) bgEl.classList.remove('is-visible-bg');
                    if (bgSecEl?.classList.contains('video-full-sec')) bodyBg.classList.remove('is-worked-full-video-bg');
                    if (isFooter && isFooterGradientWorked) {
                        bgSecEl.classList.remove('is-worked-gradient-animation');
                        pauseFooterGradientAnimation();
                    }
                    if (isProject && isProjectGradientWorked) {
                        bgSecEl.classList.remove('is-worked-gradient-animation');
                        pauseProjectGradientAnimation();
                    }
                    if (isLatestWorks && isLatestWorksGradientWorked) {
                        bgSecEl.classList.remove('is-worked-gradient-animation');
                        pauseLatestWorksGradientAnimation();
                        const beBoldSecWr = document.querySelector('.be-bold-sec-wr');
                        if (beBoldSecWr && isElementInViewport(beBoldSecWr) && window.innerWidth >= 1024) {
                            bodyBg.classList.remove('is-bg-dark');
                            bodyBg.classList.add('is-bg-light');
                            document.querySelector('body').classList.remove('is-bg-dark');
                            document.querySelector('body').classList.add('is-bg-light');
                        }
                    }
                } else {
                    activeFixedBackgroundSections.add(bgSecEl);
                    syncFixedBackgroundState();
                    if (!isVisible) bgEl.classList.add('is-visible-bg');
                    if (isBodyBgExists) {
                        if (bgSecEl?.classList.contains('video-full-sec')) bodyBg.classList.add('is-worked-full-video-bg');
                        if (bgSecEl?.classList.contains('latest-works-sec-wr')) bodyBg.classList.remove('is-worked-full-video-bg');
                    }
                    if (isFooter && !isFooterGradientWorked) {
                        bgSecEl.classList.add('is-worked-gradient-animation');
                        resumeFooterGradientAnimation();
                    }
                    if (isProject && !isProjectGradientWorked) {
                        bgSecEl.classList.add('is-worked-gradient-animation');
                        resumeProjectGradientAnimation();
                    }
                    if (isLatestWorks && !isLatestWorksGradientWorked) {
                        bgSecEl.classList.add('is-worked-gradient-animation');
                        resumeLatestWorksGradientAnimation();
                    }
                }
            }
        });
        $e65c7c7545e04d7d$var$bgFixedTriggers.push(scrollTrigger);
        function isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        }
    });
};
window.addEventListener('orbital-gradient:footer-ready', ()=>{
    if ($e65c7c7545e04d7d$var$bgFixedTriggers.length) bgFixedAnimation();
});
if (!document.querySelector('.bold-loader-new')) bgFixedAnimation();



const $626166d269b618a4$var$initializedSections = new WeakSet();
const $626166d269b618a4$var$loadedSlides = new WeakSet();
const $626166d269b618a4$var$slideLoadPromises = new WeakMap();
const $626166d269b618a4$var$prewarmedSlides = new WeakSet();
const $626166d269b618a4$var$slidePrewarmPromises = new WeakMap();
const $626166d269b618a4$var$reducedMotionMediaQuery = '(prefers-reduced-motion: reduce)';
const $626166d269b618a4$var$portfolioFlipbookImageLoadTimeout = 20000;
const $626166d269b618a4$var$portfolioFlipbookRetryDelay = 1000;
const $626166d269b618a4$export$832d0a92387ce902 = '(max-width: 1024px) and (orientation: portrait)';
const $626166d269b618a4$export$e27c0e00bcbd3448 = '(max-width: 640px)';
const $626166d269b618a4$export$c167262ec93c70b6 = (viewportWidth)=>Number(viewportWidth) <= 640;
const $626166d269b618a4$export$7cfb22248d1fb18d = (slideCount)=>{
    if (slideCount <= 27) return 6;
    return 6 + Math.ceil((slideCount - 27) / 10);
};
const $626166d269b618a4$export$9385a1eef4b21836 = (slideCount, isReverse = false)=>Array.from({
        length: slideCount
    }, (_, index)=>isReverse ? slideCount - index - 1 : index);
const $626166d269b618a4$export$c19293b7f52c8e8c = (slideCount)=>{
    if (slideCount <= 0) return [];
    if (slideCount === 1) return [
        0
    ];
    return [
        0,
        slideCount - 1
    ];
};
const $626166d269b618a4$export$540379d358cc12ea = (slideCount)=>slideCount < 2 ? [] : Array.from({
        length: slideCount - 1
    }, (_, index)=>[
            index,
            index + 1
        ]);
const $626166d269b618a4$var$getPortfolioFlipbookSections = (scope)=>{
    if (!scope?.querySelectorAll) return [];
    return scope.matches?.('[data-portfolio-flipbook]') ? [
        scope
    ] : Array.from(scope.querySelectorAll('[data-portfolio-flipbook]'));
};
const $626166d269b618a4$var$preloadImageSource = (source)=>new Promise((resolve)=>{
        if (!source || typeof Image !== 'function') {
            resolve('error');
            return;
        }
        let image;
        let timeoutId;
        let isResolved = false;
        const cleanup = ()=>{
            image?.removeEventListener('load', handleLoad);
            image?.removeEventListener('error', handleError);
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        };
        const finish = (result)=>{
            if (isResolved) return;
            isResolved = true;
            cleanup();
            resolve(result);
        };
        const handleLoad = ()=>{
            if (typeof image.decode === 'function') try {
                image.decode().catch(()=>undefined);
            } catch  {}
            finish('loaded');
        };
        const handleError = ()=>finish('error');
        try {
            image = new Image();
            image.addEventListener('load', handleLoad, {
                once: true
            });
            image.addEventListener('error', handleError, {
                once: true
            });
            image.decoding = 'async';
            timeoutId = setTimeout(()=>finish('timeout'), $626166d269b618a4$var$portfolioFlipbookImageLoadTimeout);
            image.src = source;
        } catch  {
            finish('error');
        }
    });
const $626166d269b618a4$export$ff6c553267fb78b5 = (slide)=>{
    if (!slide) return Promise.resolve(false);
    if ($626166d269b618a4$var$loadedSlides.has(slide)) return Promise.resolve(true);
    const existingPromise = $626166d269b618a4$var$slideLoadPromises.get(slide);
    if (existingPromise) return existingPromise;
    const source = slide.querySelector('source[data-srcset]');
    const image = slide.querySelector('img[data-src]');
    const preferredUrl = source?.dataset.srcset || '';
    const fallbackUrl = image?.dataset.src || '';
    if (!image || !preferredUrl && !fallbackUrl) return Promise.resolve(true);
    const loadPromise = new Promise((resolve)=>{
        let isFallback = !preferredUrl;
        let isResolved = false;
        const cleanup = ()=>{
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        };
        const finish = (result)=>{
            if (isResolved) return;
            isResolved = true;
            cleanup();
            resolve(result);
        };
        const handleLoad = ()=>{
            if (source?.dataset.srcset) delete source.dataset.srcset;
            if (image.dataset.src) delete image.dataset.src;
            $626166d269b618a4$var$loadedSlides.add(slide);
            finish(true);
        };
        const handleError = ()=>{
            if (!isFallback && fallbackUrl) {
                isFallback = true;
                source?.removeAttribute('srcset');
                image.src = fallbackUrl;
                settleCompletedImage();
                return;
            }
            finish(false);
        };
        const settleCompletedImage = ()=>{
            if (!image.complete) return;
            queueMicrotask(()=>{
                if (!isResolved && image.complete) {
                    if (image.naturalWidth > 0) handleLoad();
                    else handleError();
                }
            });
        };
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        image.loading = 'eager';
        try {
            if (preferredUrl && source) source.srcset = preferredUrl;
            else source?.removeAttribute('srcset');
            image.src = fallbackUrl || preferredUrl;
            settleCompletedImage();
        } catch  {
            finish(false);
        }
    });
    $626166d269b618a4$var$slideLoadPromises.set(slide, loadPromise);
    const clearLoadPromise = ()=>{
        if ($626166d269b618a4$var$slideLoadPromises.get(slide) === loadPromise) $626166d269b618a4$var$slideLoadPromises.delete(slide);
    };
    loadPromise.then(clearLoadPromise, clearLoadPromise);
    return loadPromise;
};
const $626166d269b618a4$var$prewarmPortfolioFlipbookSlide = (slide)=>{
    if (!slide) return Promise.resolve(false);
    if ($626166d269b618a4$var$prewarmedSlides.has(slide)) return Promise.resolve(true);
    const existingPromise = $626166d269b618a4$var$slidePrewarmPromises.get(slide);
    if (existingPromise) return existingPromise;
    const source = slide.querySelector('source[data-srcset]');
    const image = slide.querySelector('img[data-src]');
    const preferredUrl = source?.dataset.srcset || '';
    const fallbackUrl = image?.dataset.src || '';
    if (!preferredUrl && !fallbackUrl) return Promise.resolve(true);
    const prewarmPromise = (async ()=>{
        const preferredResult = preferredUrl ? await $626166d269b618a4$var$preloadImageSource(preferredUrl) : 'error';
        if (preferredResult === 'loaded') {
            $626166d269b618a4$var$prewarmedSlides.add(slide);
            return true;
        }
        if (preferredResult === 'timeout') return false;
        if (fallbackUrl && await $626166d269b618a4$var$preloadImageSource(fallbackUrl) === 'loaded') {
            $626166d269b618a4$var$prewarmedSlides.add(slide);
            return true;
        }
        return false;
    })();
    $626166d269b618a4$var$slidePrewarmPromises.set(slide, prewarmPromise);
    const clearPrewarmPromise = ()=>{
        if ($626166d269b618a4$var$slidePrewarmPromises.get(slide) === prewarmPromise) $626166d269b618a4$var$slidePrewarmPromises.delete(slide);
    };
    prewarmPromise.then(clearPrewarmPromise, clearPrewarmPromise);
    return prewarmPromise;
};
const $626166d269b618a4$export$7276f82d75ca5cd4 = (scope = document)=>{
    const loadPromises = $626166d269b618a4$var$getPortfolioFlipbookSections(scope).flatMap((section)=>{
        const slides = Array.from(section.querySelectorAll('[data-portfolio-flipbook-slide]'));
        return $626166d269b618a4$export$c19293b7f52c8e8c(slides.length).map((index)=>$626166d269b618a4$var$prewarmPortfolioFlipbookSlide(slides[index]));
    });
    if (!loadPromises.length) return Promise.resolve(false);
    return Promise.all(loadPromises).then((results)=>results.every(Boolean));
};
const $626166d269b618a4$var$waitForPortfolioFlipbookRetry = ()=>new Promise((resolve)=>setTimeout(resolve, $626166d269b618a4$var$portfolioFlipbookRetryDelay));
const $626166d269b618a4$var$preloadPortfolioFlipbookSlides = async (slides)=>{
    const results = await Promise.all(slides.map($626166d269b618a4$export$ff6c553267fb78b5));
    const failedSlides = slides.filter((slide, index)=>!results[index]);
    if (!failedSlides.length) return true;
    await $626166d269b618a4$var$waitForPortfolioFlipbookRetry();
    const retryResults = await Promise.all(failedSlides.map($626166d269b618a4$export$ff6c553267fb78b5));
    return retryResults.every(Boolean);
};
const $626166d269b618a4$export$efff473296e134d6 = (scope = document)=>{
    const sections = $626166d269b618a4$var$getPortfolioFlipbookSections(scope);
    sections.forEach((section)=>{
        if ($626166d269b618a4$var$initializedSections.has(section)) return;
        $626166d269b618a4$var$initializedSections.add(section);
        const pinEl = section.querySelector('.portfolio-sec__pin');
        const slides = Array.from(section.querySelectorAll('[data-portfolio-flipbook-slide]'));
        const slideCount = slides.length;
        const sliderWrapper = section.querySelector('.portfolio-swiper-wr');
        const sliderEl = sliderWrapper?.querySelector('.swiper');
        const nextEl = sliderWrapper?.querySelector('.swiper-button-next');
        const prevEl = sliderWrapper?.querySelector('.swiper-button-prev');
        $626166d269b618a4$export$7276f82d75ca5cd4(section);
        $626166d269b618a4$var$preloadPortfolioFlipbookSlides(slides);
        const gsapInstance = globalThis.gsap;
        const scrollTrigger = globalThis.ScrollTrigger;
        const mobileSliderMedia = typeof window.matchMedia === 'function' ? window.matchMedia($626166d269b618a4$export$e27c0e00bcbd3448) : null;
        const isMobileSliderActive = ()=>mobileSliderMedia?.matches ?? $626166d269b618a4$export$c167262ec93c70b6(window.innerWidth);
        const canAnimate = pinEl && slideCount > 1 && gsapInstance && scrollTrigger && !window.matchMedia($626166d269b618a4$var$reducedMotionMediaQuery).matches;
        const canCreateMobileSlider = sliderEl && slideCount > 1;
        if (!canAnimate && !canCreateMobileSlider) return;
        if (canAnimate) gsapInstance.registerPlugin(scrollTrigger);
        const portraitMedia = typeof window.matchMedia === 'function' ? window.matchMedia($626166d269b618a4$export$832d0a92387ce902) : null;
        const slideMedia = slides.map((slide)=>slide.querySelector('.portfolio-sec__slide-media')).filter(Boolean);
        let entranceTween;
        let timeline;
        let mobileSlider;
        const clearAnimation = ()=>{
            entranceTween?.scrollTrigger?.kill();
            entranceTween?.kill();
            timeline?.scrollTrigger?.kill();
            timeline?.kill();
            entranceTween = undefined;
            timeline = undefined;
            gsapInstance?.set(slides, {
                clearProps: 'transform,visibility,opacity,zIndex,--portfolio-slide-overlay-opacity'
            });
            gsapInstance?.set(slideMedia, {
                clearProps: 'transform'
            });
            section.classList.remove('is-enhanced', 'is-portrait-pairs');
        };
        const destroyMobileSlider = ()=>{
            mobileSlider?.destroy(true, true);
            mobileSlider = undefined;
            section.classList.remove('is-mobile-slider');
        };
        const initMobileSlider = ()=>{
            if (!canCreateMobileSlider || mobileSlider || sliderEl.swiper) return;
            section.classList.add('is-mobile-slider');
            mobileSlider = new (0, $41c4fba6d5b8bc4d$export$2e2bcd8739ae039)(sliderEl, {
                modules: [
                    (0, $7b5d41c9939efc77$export$2e2bcd8739ae039)
                ],
                slidesPerView: 1,
                speed: 450,
                threshold: 10,
                watchOverflow: true,
                navigation: nextEl && prevEl ? {
                    nextEl: nextEl,
                    prevEl: prevEl
                } : undefined
            });
        };
        const addPreviousSlideDepth = (animationTimeline, previousSlide, position)=>{
            const previousPicture = previousSlide.querySelector('.portfolio-sec__slide-media');
            animationTimeline.to(previousSlide, {
                '--portfolio-slide-overlay-opacity': 0.22,
                duration: 0.5,
                ease: 'none'
            }, position + 0.5);
            if (previousPicture) animationTimeline.to(previousPicture, {
                scale: 1.02,
                duration: 0.5,
                ease: 'none'
            }, position + 0.5);
        };
        const createTimeline = (isPortraitPairs)=>{
            const portraitPairs = $626166d269b618a4$export$540379d358cc12ea(slideCount);
            const entranceSlides = isPortraitPairs ? slides.slice(0, 2) : [
                slides[0]
            ];
            const initialSlidePosition = isPortraitPairs ? 200 : 100;
            const entranceOffset = 0;
            section.classList.add('is-enhanced');
            section.classList.toggle('is-portrait-pairs', isPortraitPairs);
            gsapInstance.set(slides, {
                autoAlpha: 1,
                yPercent: initialSlidePosition,
                zIndex: (index)=>index + 1
            });
            gsapInstance.set(entranceSlides, {
                yPercent: (index)=>index * 100 + entranceOffset
            });
            entranceTween = gsapInstance.to(entranceSlides, {
                yPercent: (index)=>index * 100,
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top bottom',
                    end: 'top top',
                    scrub: true,
                    invalidateOnRefresh: true
                }
            });
            if (isPortraitPairs && portraitPairs.length === 1) return;
            timeline = gsapInstance.timeline({
                scrollTrigger: {
                    trigger: section,
                    pin: pinEl,
                    start: 'top top',
                    end: ()=>`+=${window.innerHeight * $626166d269b618a4$export$7cfb22248d1fb18d(slideCount)}`,
                    scrub: 0.2,
                    invalidateOnRefresh: true
                }
            });
            if (isPortraitPairs) {
                portraitPairs.slice(1).forEach(([topIndex, bottomIndex], index)=>{
                    const position = index;
                    const previousSlide = slides[topIndex - 1];
                    timeline.to(slides[topIndex], {
                        yPercent: 0,
                        duration: 1,
                        ease: 'none'
                    }, position);
                    timeline.to(slides[bottomIndex], {
                        yPercent: 100,
                        duration: 1,
                        ease: 'none'
                    }, position);
                    addPreviousSlideDepth(timeline, previousSlide, position);
                });
                return;
            }
            slides.forEach((slide, index)=>{
                if (index === 0) return;
                const position = index - 1;
                const previousSlide = slides[index - 1];
                timeline.to(slide, {
                    yPercent: 0,
                    duration: 1,
                    ease: 'none'
                }, position);
                addPreviousSlideDepth(timeline, previousSlide, position);
            });
        };
        const rebuildAnimation = ()=>{
            if (isMobileSliderActive()) {
                clearAnimation();
                initMobileSlider();
                scrollTrigger?.refresh();
                return;
            }
            destroyMobileSlider();
            if (!canAnimate) return;
            clearAnimation();
            createTimeline(Boolean(portraitMedia?.matches));
            scrollTrigger.refresh();
        };
        rebuildAnimation();
        if (portraitMedia?.addEventListener) portraitMedia.addEventListener('change', rebuildAnimation);
        else if (portraitMedia?.addListener) portraitMedia.addListener(rebuildAnimation);
        if (mobileSliderMedia?.addEventListener) mobileSliderMedia.addEventListener('change', rebuildAnimation);
        else if (mobileSliderMedia?.addListener) mobileSliderMedia.addListener(rebuildAnimation);
    });
};
globalThis.initPortfolioFlipbook = $626166d269b618a4$export$efff473296e134d6;
globalThis.portfolioFlipbookPrewarm = $626166d269b618a4$export$7276f82d75ca5cd4;
if (typeof document !== 'undefined' && !document.querySelector('.bold-loader-new')) $626166d269b618a4$export$efff473296e134d6();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
const $5f65807ea62ef62a$var$arrowEl = document.querySelector('.text-sec__arrow-wr');
if ($5f65807ea62ef62a$var$arrowEl && window.innerWidth > 1024) gsap.to('#motionSVG-2', {
    scrollTrigger: {
        trigger: '#motionSVG-2',
        start: '150px 70%',
        end: '+=400px',
        scrub: 1,
        // markers: true,
        onUpdate: (self)=>{
            gsap.to('#motionSVG-2', {
                opacity: self.progress
            });
            if (self.progress < 0.15) $5f65807ea62ef62a$var$arrowEl.classList.add('is-hidden');
            else $5f65807ea62ef62a$var$arrowEl.classList.remove('is-hidden');
        }
    },
    duration: 10,
    ease: 'none',
    immediateRender: true,
    scale: 0.5,
    motionPath: {
        path: '#motionPath-2',
        align: '#motionPath-2',
        alignOrigin: [
            0.5,
            0.5
        ],
        autoRotate: true,
        start: 1,
        end: 0
    }
});


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
window.textParallaxAnimation = function textParallaxAnimation1() {
    let tl = gsap.timeline();
    const scrollingText = document.querySelectorAll('[data-text-parallax]');
    if (scrollingText.length >= 1) {
        let speed = 20;
        if (window.innerWidth <= 768) speed = 15;
        scrollingText.forEach((text, i)=>{
            let val;
            if (!text.hasAttribute('data-text-parallax-revert')) val = speed;
            else val = -speed;
            if (ScrollTrigger.isTouch !== 1) tl.to(text, {
                xPercent: val,
                scrollTrigger: {
                    trigger: text,
                    scrub: 0
                }
            });
            else {
                text.removeAttribute('data-text-parallax');
                if (text.hasAttribute('data-text-parallax-revert')) {
                    text.removeAttribute('data-text-parallax-revert');
                    text.setAttribute('data-view', 'fade-r');
                } else text.setAttribute('data-view', 'fade-l');
                text.parentElement.classList.add('optimize-animation');
            }
        });
    }
};
if (!document.querySelector('.bold-loader-new')) textParallaxAnimation();


const $0253570795621629$var$highlightsAuraMotionSelector = '[data-highlights-aura-motion]';
const $0253570795621629$var$highlightsAuraMotionInstances = new WeakMap();
const $0253570795621629$var$observedHighlightsAuraControllers = new WeakSet();
const $0253570795621629$var$visibleHighlightsAuraControllers = new Set();
let $0253570795621629$var$isVisibilityListenerAttached = false;
const $0253570795621629$var$getReducedMotion = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $0253570795621629$export$6d5bed9a8bb558 = ({ width: width, reducedMotion: reducedMotion, gsap: gsap })=>width > 1024 && !reducedMotion && Boolean(gsap && typeof gsap.set === 'function' && typeof gsap.timeline === 'function');
const $0253570795621629$export$855e6f7fc76fffe8 = (target, { width: width = typeof window === 'undefined' ? 0 : window.innerWidth, reducedMotion: reducedMotion = $0253570795621629$var$getReducedMotion(), gsap: gsap = globalThis.gsap } = {})=>{
    if (!target || !$0253570795621629$export$6d5bed9a8bb558({
        width: width,
        reducedMotion: reducedMotion,
        gsap: gsap
    })) return null;
    gsap.set(target, {
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        transformOrigin: 'center center'
    });
    const timeline = gsap.timeline({
        repeat: -1
    }).to(target, {
        xPercent: 4,
        yPercent: -2.5,
        rotation: 10,
        duration: 18,
        ease: 'sine.inOut'
    }).to(target, {
        xPercent: -3.5,
        yPercent: 3,
        rotation: -12,
        duration: 18,
        ease: 'sine.inOut'
    }).to(target, {
        xPercent: 2.5,
        yPercent: 1,
        rotation: 7,
        duration: 18,
        ease: 'sine.inOut'
    }).to(target, {
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        duration: 18,
        ease: 'sine.inOut'
    });
    let isInViewport = true;
    let isDocumentVisible = typeof document === 'undefined' || document.visibilityState !== 'hidden';
    const syncPlayback = ()=>{
        const method = isInViewport && isDocumentVisible ? 'play' : 'pause';
        timeline[method]();
    };
    const controller = {
        pause () {
            isInViewport = false;
            syncPlayback();
        },
        resume () {
            isInViewport = true;
            syncPlayback();
        },
        setDocumentVisible (isVisible) {
            isDocumentVisible = isVisible;
            syncPlayback();
        },
        destroy () {
            $0253570795621629$var$visibleHighlightsAuraControllers.delete(controller);
            timeline.kill();
        }
    };
    syncPlayback();
    return controller;
};
const $0253570795621629$var$observeHighlightsAuraController = (target, controller)=>{
    if (typeof IntersectionObserver === 'undefined') return;
    controller.pause();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.target !== target) return;
            if (entry.isIntersecting) controller.resume();
            else controller.pause();
        });
    });
    observer.observe(target);
};
const $0253570795621629$var$listenForDocumentVisibility = (controller)=>{
    if (typeof document === 'undefined') return;
    $0253570795621629$var$visibleHighlightsAuraControllers.add(controller);
    if ($0253570795621629$var$isVisibilityListenerAttached) return;
    document.addEventListener('visibilitychange', ()=>{
        const isVisible = document.visibilityState !== 'hidden';
        $0253570795621629$var$visibleHighlightsAuraControllers.forEach((activeController)=>{
            activeController.setDocumentVisible(isVisible);
        });
    });
    $0253570795621629$var$isVisibilityListenerAttached = true;
};
const $0253570795621629$export$daa228ce5e70dd60 = (scope = document, { observe: observe = $0253570795621629$var$observeHighlightsAuraController, listenForVisibility: listenForVisibility = $0253570795621629$var$listenForDocumentVisibility, ...controllerOptions } = {})=>{
    if (!scope || typeof scope.querySelectorAll !== 'function') return [];
    return [
        ...scope.querySelectorAll($0253570795621629$var$highlightsAuraMotionSelector)
    ].map((target)=>{
        if (!$0253570795621629$var$highlightsAuraMotionInstances.has(target)) $0253570795621629$var$highlightsAuraMotionInstances.set(target, $0253570795621629$export$855e6f7fc76fffe8(target, controllerOptions));
        const controller = $0253570795621629$var$highlightsAuraMotionInstances.get(target);
        if (!controller || $0253570795621629$var$observedHighlightsAuraControllers.has(controller)) return controller;
        $0253570795621629$var$observedHighlightsAuraControllers.add(controller);
        observe(target, controller);
        listenForVisibility(controller);
        return controller;
    }).filter(Boolean);
};
if (typeof document !== 'undefined') $0253570795621629$export$daa228ce5e70dd60();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
window.bgAuraFunc = function bgAuraFunc1() {
    const bodyBg = document.querySelector('.body-bg');
    const bodyAuraBg = document.querySelector('.bg-aura');
    if (!bodyBg || !bodyAuraBg) return;
    if (window.innerWidth > 1024) {
        const bodyAuraMask = document.querySelector('.bg-aura-mask');
        window.addEventListener('resize', ()=>{
            if (bodyAuraMask) {
                bodyAuraMask.style.mixBlendMode = 'normal';
                requestAnimationFrame(()=>{
                    // markers: true,
                    bodyAuraMask.style.mixBlendMode = 'soft-light';
                });
            }
        });
        let mouseX = 0;
        let mouseY = 0;
        let posX = 0;
        let posY = 0;
        const speed = 0.1;
        window.addEventListener('mousemove', (e)=>{
            // Учитываем прокрутку страницы
            mouseX = e.clientX + window.scrollX;
            mouseY = e.clientY + window.scrollY;
        });
        function animateAura() {
            posX += (mouseX - posX) * speed;
            posY += (mouseY - posY) * speed;
            gsap.to(bodyAuraBg, {
                x: posX,
                y: posY,
                duration: 0.3,
                ease: 'power2.out',
                overwrite: 'auto'
            });
            requestAnimationFrame(animateAura);
        }
        animateAura();
    }
};
bgAuraFunc();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
window.imageScaleAnimation = function imageScaleAnimation1() {
    const imageScaleElsArr = document.querySelectorAll('[data-image-scale-animation]');
    if (imageScaleElsArr.length) imageScaleElsArr.forEach((el)=>{
        if (!el.classList.contains('is-init')) {
            el.classList.add('is-init');
            let startY = 100;
            let endY = 20;
            let startTrigger = 90;
            let endTrigger = 10;
            if (el.hasAttribute('data-image-scale-animation-later-start')) {
                startTrigger = 70;
                endTrigger = 5;
                endY = 0;
            }
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: `top-=${startY}vh ${startTrigger}%`,
                    end: `bottom+=${endY}vh ${endTrigger}%`,
                    scrub: 0.85,
                    // markers: true,
                    invalidateOnRefresh: true
                }
            });
            if (el.hasAttribute('data-image-fade-scale-animation')) {
                tl.fromTo(el, {
                    scale: 0.9,
                    opacity: 0,
                    filter: 'blur(20px)'
                }, {
                    scale: 1,
                    duration: 0.6,
                    ease: 'power2.out'
                });
                tl.to(el, {
                    opacity: 1,
                    filter: 'blur(0px)',
                    duration: 0.35,
                    ease: 'power2.out'
                }, '<');
            } else tl.fromTo(el, {
                opacity: 0,
                scale: 0.9,
                filter: 'blur(20px)'
            }, {
                opacity: 1,
                scale: 1,
                duration: 0.6,
                filter: 'blur(0px)',
                ease: 'power2.out'
            });
        }
    });
};
imageScaleAnimation();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
window.cardScaleAnimation = function cardScaleAnimation1() {
    const cardScaleElsArr = document.querySelectorAll('[data-card-scale-animation]');
    if (cardScaleElsArr.length) cardScaleElsArr.forEach((el)=>{
        if (!el.classList.contains('is-init-card-scale-animation')) {
            el.classList.add('is-init-card-scale-animation');
            let startY = 100;
            let endY = 20;
            let startTrigger = 90;
            let endTrigger = 10;
            if (el.hasAttribute('data-card-scale-animation-later-start')) {
                startTrigger = 70;
                endTrigger = 5;
                endY = 0;
            }
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: `top-=${startY}vh ${startTrigger}%`,
                    end: `bottom+=${endY}vh ${endTrigger}%`,
                    scrub: 0.85,
                    // markers: true,
                    invalidateOnRefresh: true
                }
            });
            tl.fromTo(el, {
                scale: 0.9
            }, {
                scale: 1,
                duration: 0.6,
                ease: 'power2.out'
            });
        }
    });
};
if (!document.querySelector('.bold-loader-new')) cardScaleAnimation();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
window.parallaxVerticalAnimation = function parallaxVerticalAnimation1() {
    const parallaxVerticalElsArr = document.querySelectorAll('[data-parallax-vertical-animation]');
    if (parallaxVerticalElsArr.length && window.innerWidth > 1024) parallaxVerticalElsArr.forEach((el)=>{
        if (!el.classList.contains('is-init-parallax-vertical-animation')) {
            el.classList.add('is-init-parallax-vertical-animation');
            let startY = 100;
            let endY = 20;
            let startTrigger = 90;
            let endTrigger = 10;
            if (el.hasAttribute('data-parallax-vertical-later-start')) {
                startTrigger = 70;
                endTrigger = 5;
                endY = 0;
            }
            const attrValue = el.getAttribute('data-parallax-vertical-animation');
            let startPosition = 10;
            let endPosition = -20;
            if (attrValue) {
                const [startStr, endStr] = attrValue.split(',');
                startPosition = parseFloat(startStr) || 0;
                endPosition = parseFloat(endStr) || 0;
            }
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: `top-=${startY}vh ${startTrigger}%`,
                    end: `bottom+=${endY}vh ${endTrigger}%`,
                    scrub: 0.85,
                    // markers: true,
                    invalidateOnRefresh: true,
                    onUpdate: (self)=>{
                        const progress = self.progress;
                        el.style.transform = `translateY(${gsap.utils.interpolate(startPosition, endPosition, progress)}vh)`;
                    }
                }
            });
        }
    });
};
if (!document.querySelector('.bold-loader-new')) parallaxVerticalAnimation();


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
window.parallaxVerticalMobAnimation = function parallaxVerticalMobAnimation1() {
    const parallaxVerticalMobElsArr = document.querySelectorAll('[data-parallax-vertical-mob-animation]');
    if (parallaxVerticalMobElsArr.length && window.innerWidth <= 640) parallaxVerticalMobElsArr.forEach((el)=>{
        if (!el.classList.contains('is-init-parallax-vertical-mob-animation')) {
            el.classList.add('is-init-parallax-vertical-mob-animation');
            let startY = 100;
            let endY = 20;
            let startTrigger = 90;
            let endTrigger = 10;
            if (el.hasAttribute('data-parallax-vertical-mob-later-start')) {
                startTrigger = 70;
                endTrigger = 5;
                endY = 0;
            }
            const attrValue = el.getAttribute('data-parallax-vertical-mob-animation');
            let startPosition = 10;
            let endPosition = -20;
            if (attrValue) {
                const [startStr, endStr] = attrValue.split(',');
                startPosition = parseFloat(startStr) || 0;
                endPosition = parseFloat(endStr) || 0;
            }
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: `top-=${startY}vh ${startTrigger}%`,
                    end: `bottom+=${endY}vh ${endTrigger}%`,
                    scrub: 0.85,
                    // markers: true,
                    invalidateOnRefresh: true,
                    onUpdate: (self)=>{
                        const progress = self.progress;
                        el.style.transform = `translateY(${gsap.utils.interpolate(startPosition, endPosition, progress)}vh)`;
                    }
                }
            });
        }
    });
};
if (!document.querySelector('.bold-loader-new')) parallaxVerticalMobAnimation();


const $f7b9d924a4667822$var$overlapState = new Map();
function $f7b9d924a4667822$var$checkHeaderOverlap() {
    const header = document.querySelector('.header');
    if (!header) return;
    const headerLogo = header.querySelector('.logo-trigger');
    if (!headerLogo) return;
    const headerLogoRect = headerLogo.getBoundingClientRect();
    const textTags = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, ul, ol');
    let isAnyOverlapping = false;
    const margin = 0;
    for (const el of textTags){
        const elRect = el.getBoundingClientRect();
        const isVisible = elRect.width > 0 && elRect.height > 0;
        const verticallyOverlapping = headerLogoRect.top - 100 < elRect.bottom - margin && headerLogoRect.bottom > elRect.top + margin;
        const horizontallyOverlapping = headerLogoRect.left < elRect.right && headerLogoRect.right > elRect.left;
        const isOverlapping = verticallyOverlapping && horizontallyOverlapping;
        const currentState = $f7b9d924a4667822$var$overlapState.get(el) || {
            count: 0,
            state: false
        };
        if (isOverlapping !== currentState.state) {
            currentState.count++;
            if (currentState.count >= 5) {
                currentState.state = isOverlapping;
                currentState.count = 0;
                if (isOverlapping) el.classList.add('is-under-header-logo');
                else el.classList.remove('is-under-header-logo');
            }
        } else currentState.count = 0;
        $f7b9d924a4667822$var$overlapState.set(el, currentState);
        if (isOverlapping) isAnyOverlapping = true;
    }
    header.classList.toggle('is-over-text', isAnyOverlapping);
}
function $f7b9d924a4667822$var$throttleWithRaf(callback) {
    let ticking = false;
    return function() {
        if (!ticking) {
            window.requestAnimationFrame(()=>{
                callback();
                ticking = false;
            });
            ticking = true;
        }
    };
}
window.checkHeaderOverlapInit = function checkHeaderOverlapInit() {
    if (window.innerWidth > 1024) {
        window.addEventListener('scroll', $f7b9d924a4667822$var$checkHeaderOverlap, {
            passive: true
        });
        window.addEventListener('resize', $f7b9d924a4667822$var$checkHeaderOverlap);
        document.addEventListener('DOMContentLoaded', $f7b9d924a4667822$var$checkHeaderOverlap);
    }
}; /*if (!document.querySelector('.bold-loader-new')) {
  checkHeaderOverlapInit();
}*/ 


// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
window.textStickyAnimation = function textStickyAnimation1() {
    if (window.innerWidth > 1024) {
        let tl = gsap.timeline();
        const stickyTextArr = document.querySelectorAll('[data-text-sticky]');
        if (stickyTextArr.length >= 1) setTimeout(function() {
            stickyTextArr.forEach((stickyEl)=>{
                const section = stickyEl.closest('section');
                const wrap = section?.querySelector('.cont');
                if (!section || !wrap) return;
                const wrapRect = wrap.getBoundingClientRect();
                const stickyRect = stickyEl.getBoundingClientRect();
                const distance = stickyRect.top - wrapRect.top;
                let trackHeight = wrap.clientHeight - distance;
                if (stickyEl.classList.contains('if-minus-height-el')) trackHeight = wrap.clientHeight - distance - stickyEl.clientHeight;
                /*console.log(trackHeight);*/ let start = `top top+=${window.innerHeight < 810 ? 120 : 190}`;
                if (stickyEl.classList.contains('if-centered-position')) {
                    let centerPosition = window.innerHeight / 2 - stickyEl.clientHeight / 2;
                    if (stickyEl.classList.contains('text-sec__arrow-sticky')) {
                        const titleStickyEl = section.querySelector('.text-sec__title-sticky');
                        centerPosition = centerPosition - 50;
                        if (titleStickyEl) trackHeight = wrap.clientHeight - distance - titleStickyEl.clientHeight;
                    }
                    const arrowEl = document.querySelector('.text-sec__arrow-wr');
                    if (arrowEl) arrowEl.style.setProperty('--center-position', `${centerPosition}px`);
                    start = `top top+=${window.innerHeight < 810 ? 120 : centerPosition}`;
                }
                ScrollTrigger.create({
                    trigger: stickyEl,
                    start: start,
                    end: `+=${trackHeight}`,
                    pin: true,
                    pinSpacing: false,
                    scrub: true
                });
                const pinSpacer = stickyEl.closest('.pin-spacer');
                if (pinSpacer) pinSpacer.classList.add('sticky-text-element');
            });
        }, 1200);
    }
};
if (!document.querySelector('.bold-loader-new')) textStickyAnimation();
window.textStickyMobAnimation = function textStickyMobAnimation() {
    if (window.innerWidth <= 1024) {
        let tl = gsap.timeline();
        const stickyTextArr = document.querySelectorAll('[data-text-sticky-mob]');
        if (stickyTextArr.length >= 1) setTimeout(function() {
            stickyTextArr.forEach((stickyEl)=>{
                const section = stickyEl.closest('section');
                const wrap = section?.querySelector('.cont');
                if (!section || !wrap) return;
                const wrapRect = wrap.getBoundingClientRect();
                const stickyRect = stickyEl.getBoundingClientRect();
                const distance = stickyRect.top - wrapRect.top;
                let nextElHeight = stickyEl.nextElementSibling ? stickyEl.nextElementSibling.clientHeight : 0;
                if (window.innerWidth > 640) nextElHeight = 0;
                let trackHeight = wrap.clientHeight - distance;
                if (stickyEl.classList.contains('if-minus-height-el-mob')) trackHeight = wrap.clientHeight - distance - stickyEl.clientHeight - nextElHeight;
                let start = `top top+=${window.innerHeight < 810 ? 290 : 190}`;
                ScrollTrigger.create({
                    trigger: stickyEl,
                    start: start,
                    end: `+=${trackHeight}`,
                    pin: true,
                    pinSpacing: false,
                    scrub: 1
                });
                const pinSpacer = stickyEl.closest('.pin-spacer');
                if (pinSpacer) pinSpacer.classList.add('sticky-text-element');
            });
        }, 1200);
    }
};
if (!document.querySelector('.bold-loader-new')) textStickyAnimation();


window.firstImagesAnimation = function firstImagesAnimation() {
    const firstImagesEl = document.querySelector('.first-sec__title-images');
    /*console.log(firstImagesEl);*/ if (firstImagesEl) {
        const imagesArr = firstImagesEl.querySelectorAll('.first-sec__title-image');
        imagesArr.forEach((image, i)=>{});
        firstImagesEl.classList.add('is-first-images-animation');
    }
};


/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $cf10f6a70bd83671$export$3545e07a80636437 = '174';
const $cf10f6a70bd83671$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $cf10f6a70bd83671$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $cf10f6a70bd83671$export$3237e1f2c1ea1f44 = 0;
const $cf10f6a70bd83671$export$b9a7b4fc5cb15f9b = 1;
const $cf10f6a70bd83671$export$b8058bcc7037d3f3 = 2;
const $cf10f6a70bd83671$export$f24be24dcddeac0d = 3;
const $cf10f6a70bd83671$export$346307dbae2b7447 = 0;
const $cf10f6a70bd83671$export$5813f879eee7cd88 = 1;
const $cf10f6a70bd83671$export$a47c4b43a1be34f0 = 2;
const $cf10f6a70bd83671$export$896ae1ade6c829c4 = 3;
const $cf10f6a70bd83671$export$2ede184fc2998901 = 0;
const $cf10f6a70bd83671$export$d9f0486e75b5ace = 1;
const $cf10f6a70bd83671$export$3b296b6f144d5b03 = 2;
const $cf10f6a70bd83671$export$63b8d6b580fc65ba = 0;
const $cf10f6a70bd83671$export$5b29a26d96ee6af0 = 1;
const $cf10f6a70bd83671$export$777d8f9551c2216b = 2;
const $cf10f6a70bd83671$export$cdfa06f868e2e467 = 3;
const $cf10f6a70bd83671$export$4138e1c684b46a20 = 4;
const $cf10f6a70bd83671$export$eda4864c68df1fa2 = 5;
const $cf10f6a70bd83671$export$20183a0484ce21a0 = 100;
const $cf10f6a70bd83671$export$73e0df5177988548 = 101;
const $cf10f6a70bd83671$export$28e582859cbec660 = 102;
const $cf10f6a70bd83671$export$c8c1508da8d0600c = 103;
const $cf10f6a70bd83671$export$99948c02fb51055f = 104;
const $cf10f6a70bd83671$export$2110f05edf778d3d = 200;
const $cf10f6a70bd83671$export$8805bad65e24940e = 201;
const $cf10f6a70bd83671$export$7fbe15b28d28cf52 = 202;
const $cf10f6a70bd83671$export$947829af9f2c17f6 = 203;
const $cf10f6a70bd83671$export$d5773124e86cf28c = 204;
const $cf10f6a70bd83671$export$11d468cc7f19e971 = 205;
const $cf10f6a70bd83671$export$a78aed1ca2a87192 = 206;
const $cf10f6a70bd83671$export$5d0fe17fd8773bac = 207;
const $cf10f6a70bd83671$export$ef5f2dd8ffac5574 = 208;
const $cf10f6a70bd83671$export$56b85b2686ab16 = 209;
const $cf10f6a70bd83671$export$c05e2a1fc8609506 = 210;
const $cf10f6a70bd83671$export$7dd8f434fd59075 = 211;
const $cf10f6a70bd83671$export$99c8d898a9afbcee = 212;
const $cf10f6a70bd83671$export$310cd2be38d13b56 = 213;
const $cf10f6a70bd83671$export$db77b8fbcf45dbf4 = 214;
const $cf10f6a70bd83671$export$69025ce147cee220 = 0;
const $cf10f6a70bd83671$export$7182eb52ea3b3f04 = 1;
const $cf10f6a70bd83671$export$eedccec66ab7ebe = 2;
const $cf10f6a70bd83671$export$296f78a0b892f81a = 3;
const $cf10f6a70bd83671$export$a60d398fc7b7590e = 4;
const $cf10f6a70bd83671$export$7d7234c1240a1fc4 = 5;
const $cf10f6a70bd83671$export$c5e2c52991f30937 = 6;
const $cf10f6a70bd83671$export$2f843afa843d8916 = 7;
const $cf10f6a70bd83671$export$e50ac29801f1774d = 0;
const $cf10f6a70bd83671$export$9f9d94f963c85479 = 1;
const $cf10f6a70bd83671$export$e641dc52bc3494aa = 2;
const $cf10f6a70bd83671$export$9fcb6b4294603b2 = 0;
const $cf10f6a70bd83671$export$98f52c2a46c598ca = 1;
const $cf10f6a70bd83671$export$74b25e54b3bcd548 = 2;
const $cf10f6a70bd83671$export$932b3dd283d4a366 = 3;
const $cf10f6a70bd83671$export$a0d98fe6d7e4af64 = 4;
const $cf10f6a70bd83671$export$2c7b09c1e9abfb5e = 5;
const $cf10f6a70bd83671$export$212d53a513a325b2 = 6;
const $cf10f6a70bd83671$export$f2863e1668a8e317 = 7;
const $cf10f6a70bd83671$export$2595a3798997538 = 'attached';
const $cf10f6a70bd83671$export$d7e7dc2e114517a0 = 'detached';
const $cf10f6a70bd83671$export$1beec6768cbb3d2d = 300;
const $cf10f6a70bd83671$export$8759762a6477f2c4 = 301;
const $cf10f6a70bd83671$export$dc59f8aed047f61d = 302;
const $cf10f6a70bd83671$export$d64030b316d3b087 = 303;
const $cf10f6a70bd83671$export$ee99d97d46898098 = 304;
const $cf10f6a70bd83671$export$dbf3e70ff37af79 = 306;
const $cf10f6a70bd83671$export$533346c8e8dac0f5 = 1000;
const $cf10f6a70bd83671$export$9d9334239a5a5e06 = 1001;
const $cf10f6a70bd83671$export$c7e7c00b14f51a4f = 1002;
const $cf10f6a70bd83671$export$727aa5ec3fe39bf0 = 1003;
const $cf10f6a70bd83671$export$d129e38cf6feaa8c = 1004;
const $cf10f6a70bd83671$export$14a4936464a36496 = 1004;
const $cf10f6a70bd83671$export$d2327c1afe5bfdf2 = 1005;
const $cf10f6a70bd83671$export$cbc5b7f5647595d8 = 1005;
const $cf10f6a70bd83671$export$8a72f490b25c56c8 = 1006;
const $cf10f6a70bd83671$export$19a719f377145a13 = 1007;
const $cf10f6a70bd83671$export$dbe96bee3fe9dbf0 = 1007;
const $cf10f6a70bd83671$export$5d8599b6a933fb1b = 1008;
const $cf10f6a70bd83671$export$90d80f1e3506775f = 1008;
const $cf10f6a70bd83671$export$2e8ce08d3f6f5e10 = 1009;
const $cf10f6a70bd83671$export$545fce0311a9796a = 1010;
const $cf10f6a70bd83671$export$88572337f312435f = 1011;
const $cf10f6a70bd83671$export$c63dc51868b06a9d = 1012;
const $cf10f6a70bd83671$export$5c612977753abe2 = 1013;
const $cf10f6a70bd83671$export$c3c7fc4518ebba96 = 1014;
const $cf10f6a70bd83671$export$f6d331659b644596 = 1015;
const $cf10f6a70bd83671$export$2697304443f382bc = 1016;
const $cf10f6a70bd83671$export$b3969b01faf587f2 = 1017;
const $cf10f6a70bd83671$export$18886f8ae33e90de = 1018;
const $cf10f6a70bd83671$export$6c8ea339bfab1301 = 1020;
const $cf10f6a70bd83671$export$5a4c329b7e2092d3 = 35902;
const $cf10f6a70bd83671$export$988473390501ed4b = 1021;
const $cf10f6a70bd83671$export$7c67423a5ee6f5eb = 1022;
const $cf10f6a70bd83671$export$3f8bb04b555a363c = 1023;
const $cf10f6a70bd83671$export$cc09ccbf6d1ed449 = 1024;
const $cf10f6a70bd83671$export$9053a81c4a69c289 = 1025;
const $cf10f6a70bd83671$export$c1b6b5136be58045 = 1026;
const $cf10f6a70bd83671$export$1e113ac2d0905829 = 1027;
const $cf10f6a70bd83671$export$4e041a7967d15c4b = 1028;
const $cf10f6a70bd83671$export$aa92e870a709d190 = 1029;
const $cf10f6a70bd83671$export$6cdf0b461c7ce8a0 = 1030;
const $cf10f6a70bd83671$export$1ba1c45f9f77d4d7 = 1031;
const $cf10f6a70bd83671$export$d1fd40c11bfa798e = 1032;
const $cf10f6a70bd83671$export$c200e7d26f592f21 = 1033;
const $cf10f6a70bd83671$export$21d1799c6d552fc0 = 33776;
const $cf10f6a70bd83671$export$afa304c3e981b668 = 33777;
const $cf10f6a70bd83671$export$d2a1a68024a3e56c = 33778;
const $cf10f6a70bd83671$export$9a79c424327dacf9 = 33779;
const $cf10f6a70bd83671$export$19ada9bbb1af3573 = 35840;
const $cf10f6a70bd83671$export$d0f0355bb3d948e4 = 35841;
const $cf10f6a70bd83671$export$b82296714358084c = 35842;
const $cf10f6a70bd83671$export$b71692456c47b6c3 = 35843;
const $cf10f6a70bd83671$export$6ab91af2d757aee7 = 36196;
const $cf10f6a70bd83671$export$7800993ef8106a6a = 37492;
const $cf10f6a70bd83671$export$23ed8300a860e7d8 = 37496;
const $cf10f6a70bd83671$export$dc5570b4a2b92d48 = 37808;
const $cf10f6a70bd83671$export$68880cd325f8b2fb = 37809;
const $cf10f6a70bd83671$export$7d2c0be323373d95 = 37810;
const $cf10f6a70bd83671$export$22b52da301fc3a3e = 37811;
const $cf10f6a70bd83671$export$c009e2cb4a66485e = 37812;
const $cf10f6a70bd83671$export$118fff5afa255b63 = 37813;
const $cf10f6a70bd83671$export$120713c829ae0667 = 37814;
const $cf10f6a70bd83671$export$c79eeabbf53313e9 = 37815;
const $cf10f6a70bd83671$export$443cf6567cdd6424 = 37816;
const $cf10f6a70bd83671$export$6573984fc9840780 = 37817;
const $cf10f6a70bd83671$export$e7aee563f30091de = 37818;
const $cf10f6a70bd83671$export$2eb8634622ddeab7 = 37819;
const $cf10f6a70bd83671$export$202b1ce7b5d25742 = 37820;
const $cf10f6a70bd83671$export$18ab77abd087e467 = 37821;
const $cf10f6a70bd83671$export$ce40b115e188bc81 = 36492;
const $cf10f6a70bd83671$export$d279c5c4bac5121e = 36494;
const $cf10f6a70bd83671$export$cde52d17225fdbd3 = 36495;
const $cf10f6a70bd83671$export$b1688df4c4c21670 = 36283;
const $cf10f6a70bd83671$export$fc15e5d8261eed58 = 36284;
const $cf10f6a70bd83671$export$d220f6ade8463a0f = 36285;
const $cf10f6a70bd83671$export$768646d09dc1b6ef = 36286;
const $cf10f6a70bd83671$export$d62fdc9d1b1cccad = 2200;
const $cf10f6a70bd83671$export$dfaf4422ce096e29 = 2201;
const $cf10f6a70bd83671$export$f8f6f2041b78e210 = 2202;
const $cf10f6a70bd83671$export$995b32462a65e855 = 2300;
const $cf10f6a70bd83671$export$30fac1aace31cf4d = 2301;
const $cf10f6a70bd83671$export$198b11ff4c72bb30 = 2302;
const $cf10f6a70bd83671$export$7f795934b84ab523 = 2400;
const $cf10f6a70bd83671$export$24a4ccb5099273b5 = 2401;
const $cf10f6a70bd83671$export$8e8c3ecdcd8e1fee = 2402;
const $cf10f6a70bd83671$export$bcfbbdcf8de7f8cd = 2500;
const $cf10f6a70bd83671$export$d875e029ef558d3 = 2501;
const $cf10f6a70bd83671$export$4c28c87c2dc84758 = 0;
const $cf10f6a70bd83671$export$b23a071aa286eb29 = 1;
const $cf10f6a70bd83671$export$f0d8293634f88842 = 2;
const $cf10f6a70bd83671$export$deeb383078690b50 = 3200;
const $cf10f6a70bd83671$export$8f910f4c4f73df11 = 3201;
const $cf10f6a70bd83671$export$be2e2ddbc3983173 = 3202;
const $cf10f6a70bd83671$export$1a54198784742f80 = 3203;
const $cf10f6a70bd83671$export$2852a58ebdac27b8 = 0;
const $cf10f6a70bd83671$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $cf10f6a70bd83671$export$bfcb490c2dd3db51 = '';
const $cf10f6a70bd83671$export$561f394b24edfcaa = 'srgb';
const $cf10f6a70bd83671$export$42429b3acfb233a4 = 'srgb-linear';
const $cf10f6a70bd83671$export$f197347d588c1b4a = 'linear';
const $cf10f6a70bd83671$export$8d0a61916cc26abb = 'srgb';
const $cf10f6a70bd83671$export$69433f11f42d5527 = 0;
const $cf10f6a70bd83671$export$9f542ae4b5baca34 = 7680;
const $cf10f6a70bd83671$export$8a4f28336ef203d3 = 7681;
const $cf10f6a70bd83671$export$2928c0231297c036 = 7682;
const $cf10f6a70bd83671$export$c0e9611c8a15f9a8 = 7683;
const $cf10f6a70bd83671$export$9c2c08927385dcc4 = 34055;
const $cf10f6a70bd83671$export$7c74ea00fa1315e6 = 34056;
const $cf10f6a70bd83671$export$22e2e5726612443 = 5386;
const $cf10f6a70bd83671$export$1343870698229224 = 512;
const $cf10f6a70bd83671$export$8e1d8ed281997fa6 = 513;
const $cf10f6a70bd83671$export$55648a1cde8329a7 = 514;
const $cf10f6a70bd83671$export$2dff107857e6aca2 = 515;
const $cf10f6a70bd83671$export$6f93765ab2f451a2 = 516;
const $cf10f6a70bd83671$export$6f3fb2d2440f2b76 = 517;
const $cf10f6a70bd83671$export$4119cf7b4c98fd5a = 518;
const $cf10f6a70bd83671$export$14cf96713ddd97a8 = 519;
const $cf10f6a70bd83671$export$d9e2d19a747baaab = 512;
const $cf10f6a70bd83671$export$36bcf49c713b3eb7 = 513;
const $cf10f6a70bd83671$export$66f28d946fc6a0d5 = 514;
const $cf10f6a70bd83671$export$64eea11eb407ddf1 = 515;
const $cf10f6a70bd83671$export$155af022118f3a38 = 516;
const $cf10f6a70bd83671$export$67ab95dde6bed156 = 517;
const $cf10f6a70bd83671$export$1cdcb70d53d65f61 = 518;
const $cf10f6a70bd83671$export$187b73a3e352c145 = 519;
const $cf10f6a70bd83671$export$763e8360f4d7f77d = 35044;
const $cf10f6a70bd83671$export$8505d14ac8546ca = 35048;
const $cf10f6a70bd83671$export$721e63549e51d81e = 35040;
const $cf10f6a70bd83671$export$415731dc4f48e299 = 35045;
const $cf10f6a70bd83671$export$9e809946455f13bc = 35049;
const $cf10f6a70bd83671$export$2ed9499a35b5f832 = 35041;
const $cf10f6a70bd83671$export$32ab2503ea19469a = 35046;
const $cf10f6a70bd83671$export$ab4022c2c3f86315 = 35050;
const $cf10f6a70bd83671$export$ba7f1db36a76a970 = 35042;
const $cf10f6a70bd83671$export$43600cc67fabd9f = '100';
const $cf10f6a70bd83671$export$f63012db5506e7dd = '300 es';
const $cf10f6a70bd83671$export$5a0e9190d10875d3 = 2000;
const $cf10f6a70bd83671$export$cc83beedcb9be9ac = 2001;
const $cf10f6a70bd83671$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js]{@link https://github.com/mrdoob/eventdispatcher.js/}
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $cf10f6a70bd83671$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $cf10f6a70bd83671$var$_seed = 1234567;
const $cf10f6a70bd83671$var$DEG2RAD = Math.PI / 180;
const $cf10f6a70bd83671$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $cf10f6a70bd83671$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $cf10f6a70bd83671$var$_lut[d0 & 0xff] + $cf10f6a70bd83671$var$_lut[d0 >> 8 & 0xff] + $cf10f6a70bd83671$var$_lut[d0 >> 16 & 0xff] + $cf10f6a70bd83671$var$_lut[d0 >> 24 & 0xff] + '-' + $cf10f6a70bd83671$var$_lut[d1 & 0xff] + $cf10f6a70bd83671$var$_lut[d1 >> 8 & 0xff] + '-' + $cf10f6a70bd83671$var$_lut[d1 >> 16 & 0x0f | 0x40] + $cf10f6a70bd83671$var$_lut[d1 >> 24 & 0xff] + '-' + $cf10f6a70bd83671$var$_lut[d2 & 0x3f | 0x80] + $cf10f6a70bd83671$var$_lut[d2 >> 8 & 0xff] + '-' + $cf10f6a70bd83671$var$_lut[d2 >> 16 & 0xff] + $cf10f6a70bd83671$var$_lut[d2 >> 24 & 0xff] + $cf10f6a70bd83671$var$_lut[d3 & 0xff] + $cf10f6a70bd83671$var$_lut[d3 >> 8 & 0xff] + $cf10f6a70bd83671$var$_lut[d3 >> 16 & 0xff] + $cf10f6a70bd83671$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $cf10f6a70bd83671$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $cf10f6a70bd83671$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $cf10f6a70bd83671$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $cf10f6a70bd83671$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $cf10f6a70bd83671$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $cf10f6a70bd83671$var$damp(x, y, lambda, dt) {
    return $cf10f6a70bd83671$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $cf10f6a70bd83671$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($cf10f6a70bd83671$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $cf10f6a70bd83671$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $cf10f6a70bd83671$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $cf10f6a70bd83671$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $cf10f6a70bd83671$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $cf10f6a70bd83671$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $cf10f6a70bd83671$var$seededRandom(s) {
    if (s !== undefined) $cf10f6a70bd83671$var$_seed = s;
    // Mulberry32 generator
    let t = $cf10f6a70bd83671$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $cf10f6a70bd83671$var$degToRad(degrees) {
    return degrees * $cf10f6a70bd83671$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $cf10f6a70bd83671$var$radToDeg(radians) {
    return radians * $cf10f6a70bd83671$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $cf10f6a70bd83671$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $cf10f6a70bd83671$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $cf10f6a70bd83671$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $cf10f6a70bd83671$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $cf10f6a70bd83671$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $cf10f6a70bd83671$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $cf10f6a70bd83671$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $cf10f6a70bd83671$var$DEG2RAD,
    RAD2DEG: $cf10f6a70bd83671$export$914076c8150813e5,
    generateUUID: $cf10f6a70bd83671$var$generateUUID,
    clamp: $cf10f6a70bd83671$var$clamp,
    euclideanModulo: $cf10f6a70bd83671$var$euclideanModulo,
    mapLinear: $cf10f6a70bd83671$var$mapLinear,
    inverseLerp: $cf10f6a70bd83671$var$inverseLerp,
    lerp: $cf10f6a70bd83671$var$lerp,
    damp: $cf10f6a70bd83671$var$damp,
    pingpong: $cf10f6a70bd83671$var$pingpong,
    smoothstep: $cf10f6a70bd83671$var$smoothstep,
    smootherstep: $cf10f6a70bd83671$var$smootherstep,
    randInt: $cf10f6a70bd83671$var$randInt,
    randFloat: $cf10f6a70bd83671$var$randFloat,
    randFloatSpread: $cf10f6a70bd83671$var$randFloatSpread,
    seededRandom: $cf10f6a70bd83671$var$seededRandom,
    degToRad: $cf10f6a70bd83671$var$degToRad,
    radToDeg: $cf10f6a70bd83671$var$radToDeg,
    isPowerOfTwo: $cf10f6a70bd83671$var$isPowerOfTwo,
    ceilPowerOfTwo: $cf10f6a70bd83671$var$ceilPowerOfTwo,
    floorPowerOfTwo: $cf10f6a70bd83671$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $cf10f6a70bd83671$var$setQuaternionFromProperEuler,
    normalize: $cf10f6a70bd83671$var$normalize,
    denormalize: $cf10f6a70bd83671$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $cf10f6a70bd83671$export$c977b3e384af9ae1 {
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $cf10f6a70bd83671$export$c977b3e384af9ae1.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $cf10f6a70bd83671$var$clamp(this.x, min.x, max.x);
        this.y = $cf10f6a70bd83671$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $cf10f6a70bd83671$var$clamp(this.x, minVal, maxVal);
        this.y = $cf10f6a70bd83671$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($cf10f6a70bd83671$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($cf10f6a70bd83671$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $cf10f6a70bd83671$export$8ff26dafa08918 {
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $cf10f6a70bd83671$export$8ff26dafa08918.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($cf10f6a70bd83671$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($cf10f6a70bd83671$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($cf10f6a70bd83671$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $cf10f6a70bd83671$var$_m3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$8ff26dafa08918();
function $cf10f6a70bd83671$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $cf10f6a70bd83671$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $cf10f6a70bd83671$var$getTypedArray(type, buffer) {
    return new $cf10f6a70bd83671$var$TYPED_ARRAYS[type](buffer);
}
function $cf10f6a70bd83671$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $cf10f6a70bd83671$export$1033a2df66368859() {
    const canvas = $cf10f6a70bd83671$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $cf10f6a70bd83671$var$_cache = {};
function $cf10f6a70bd83671$export$5b28268982f175ba(message) {
    if (message in $cf10f6a70bd83671$var$_cache) return;
    $cf10f6a70bd83671$var$_cache[message] = true;
    console.warn(message);
}
function $cf10f6a70bd83671$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $cf10f6a70bd83671$export$5238391f68c729b(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $cf10f6a70bd83671$export$f8cf97d08da9bc86(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
const $cf10f6a70bd83671$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $cf10f6a70bd83671$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $cf10f6a70bd83671$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $cf10f6a70bd83671$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $cf10f6a70bd83671$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $cf10f6a70bd83671$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $cf10f6a70bd83671$export$8d0a61916cc26abb) {
                color.r = $cf10f6a70bd83671$var$SRGBToLinear(color.r);
                color.g = $cf10f6a70bd83671$var$SRGBToLinear(color.g);
                color.b = $cf10f6a70bd83671$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $cf10f6a70bd83671$export$8d0a61916cc26abb) {
                color.r = $cf10f6a70bd83671$var$LinearToSRGB(color.r);
                color.g = $cf10f6a70bd83671$var$LinearToSRGB(color.g);
                color.b = $cf10f6a70bd83671$var$LinearToSRGB(color.b);
            }
            return color;
        },
        fromWorkingColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $cf10f6a70bd83671$export$bfcb490c2dd3db51) return $cf10f6a70bd83671$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$cf10f6a70bd83671$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $cf10f6a70bd83671$export$f197347d588c1b4a,
            toXYZ: $cf10f6a70bd83671$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $cf10f6a70bd83671$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $cf10f6a70bd83671$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $cf10f6a70bd83671$export$561f394b24edfcaa
            }
        },
        [$cf10f6a70bd83671$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $cf10f6a70bd83671$export$8d0a61916cc26abb,
            toXYZ: $cf10f6a70bd83671$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $cf10f6a70bd83671$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $cf10f6a70bd83671$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $cf10f6a70bd83671$export$5e6fd513f44698c = /*@__PURE__*/ $cf10f6a70bd83671$var$createColorManagement();
function $cf10f6a70bd83671$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $cf10f6a70bd83671$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $cf10f6a70bd83671$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $cf10f6a70bd83671$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @return {string} The data URI.
	 */ static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($cf10f6a70bd83671$var$_canvas === undefined) $cf10f6a70bd83671$var$_canvas = $cf10f6a70bd83671$export$7094a064528c7fee('canvas');
            $cf10f6a70bd83671$var$_canvas.width = image.width;
            $cf10f6a70bd83671$var$_canvas.height = image.height;
            const context = $cf10f6a70bd83671$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $cf10f6a70bd83671$var$_canvas;
        }
        return canvas.toDataURL('image/png');
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $cf10f6a70bd83671$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $cf10f6a70bd83671$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($cf10f6a70bd83671$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $cf10f6a70bd83671$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $cf10f6a70bd83671$var$_sourceId = 0;
class $cf10f6a70bd83671$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_sourceId++
        });
        this.uuid = $cf10f6a70bd83671$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($cf10f6a70bd83671$var$serializeImage(data[i].image));
                else url.push($cf10f6a70bd83671$var$serializeImage(data[i]));
            } else // texture
            url = $cf10f6a70bd83671$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $cf10f6a70bd83671$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $cf10f6a70bd83671$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $cf10f6a70bd83671$var$_textureId = 0;
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $cf10f6a70bd83671$export$5431306cf43de24a extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The min filter value.
	 * @param {string} [colorSpace=NoColorSpace] - The min filter value.
	 */ constructor(image = $cf10f6a70bd83671$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $cf10f6a70bd83671$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $cf10f6a70bd83671$export$9d9334239a5a5e06, wrapT = $cf10f6a70bd83671$export$9d9334239a5a5e06, magFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8, minFilter = $cf10f6a70bd83671$export$5d8599b6a933fb1b, format = $cf10f6a70bd83671$export$3f8bb04b555a363c, type = $cf10f6a70bd83671$export$2e8ce08d3f6f5e10, anisotropy = $cf10f6a70bd83671$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $cf10f6a70bd83671$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $cf10f6a70bd83671$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $cf10f6a70bd83671$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default 0
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $cf10f6a70bd83671$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $cf10f6a70bd83671$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $cf10f6a70bd83671$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $cf10f6a70bd83671$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $cf10f6a70bd83671$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $cf10f6a70bd83671$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $cf10f6a70bd83671$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $cf10f6a70bd83671$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $cf10f6a70bd83671$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $cf10f6a70bd83671$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $cf10f6a70bd83671$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $cf10f6a70bd83671$export$5431306cf43de24a.DEFAULT_MAPPING = $cf10f6a70bd83671$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $cf10f6a70bd83671$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $cf10f6a70bd83671$export$fa7daccca11cdbe3 {
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $cf10f6a70bd83671$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $cf10f6a70bd83671$var$clamp(this.x, min.x, max.x);
        this.y = $cf10f6a70bd83671$var$clamp(this.y, min.y, max.y);
        this.z = $cf10f6a70bd83671$var$clamp(this.z, min.z, max.z);
        this.w = $cf10f6a70bd83671$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $cf10f6a70bd83671$var$clamp(this.x, minVal, maxVal);
        this.y = $cf10f6a70bd83671$var$clamp(this.y, minVal, maxVal);
        this.z = $cf10f6a70bd83671$var$clamp(this.z, minVal, maxVal);
        this.w = $cf10f6a70bd83671$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($cf10f6a70bd83671$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $cf10f6a70bd83671$export$efcb1f8bf367cbfb extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $cf10f6a70bd83671$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $cf10f6a70bd83671$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $cf10f6a70bd83671$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $cf10f6a70bd83671$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    get depthTexture() {
        return this._depthTexture;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $cf10f6a70bd83671$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $cf10f6a70bd83671$export$3c052beb2e51e23f extends $cf10f6a70bd83671$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $cf10f6a70bd83671$export$dfac6c8e811406a3 extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.minFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.wrapR = $cf10f6a70bd83671$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $cf10f6a70bd83671$export$c77a02c11ed180c7 extends $cf10f6a70bd83671$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $cf10f6a70bd83671$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $cf10f6a70bd83671$export$d7a3086320f856db extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.minFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.wrapR = $cf10f6a70bd83671$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $cf10f6a70bd83671$export$7ee06591009639df extends $cf10f6a70bd83671$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $cf10f6a70bd83671$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $cf10f6a70bd83671$export$23d6a54f0bbc85a3 {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed  in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($cf10f6a70bd83671$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $cf10f6a70bd83671$export$64b5c384219d3699 {
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $cf10f6a70bd83671$export$64b5c384219d3699.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($cf10f6a70bd83671$var$_quaternion$4.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($cf10f6a70bd83671$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $cf10f6a70bd83671$var$clamp(this.x, min.x, max.x);
        this.y = $cf10f6a70bd83671$var$clamp(this.y, min.y, max.y);
        this.z = $cf10f6a70bd83671$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $cf10f6a70bd83671$var$clamp(this.x, minVal, maxVal);
        this.y = $cf10f6a70bd83671$var$clamp(this.y, minVal, maxVal);
        this.z = $cf10f6a70bd83671$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($cf10f6a70bd83671$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $cf10f6a70bd83671$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($cf10f6a70bd83671$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($cf10f6a70bd83671$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($cf10f6a70bd83671$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $cf10f6a70bd83671$var$_vector$c = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_quaternion$4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $cf10f6a70bd83671$export$6f7d5a9418ab2aa3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $cf10f6a70bd83671$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $cf10f6a70bd83671$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($cf10f6a70bd83671$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($cf10f6a70bd83671$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $cf10f6a70bd83671$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $cf10f6a70bd83671$var$_vector$b);
                else $cf10f6a70bd83671$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $cf10f6a70bd83671$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($cf10f6a70bd83671$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $cf10f6a70bd83671$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $cf10f6a70bd83671$var$_box$4.copy(geometry.boundingBox);
                }
                $cf10f6a70bd83671$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($cf10f6a70bd83671$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $cf10f6a70bd83671$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $cf10f6a70bd83671$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($cf10f6a70bd83671$var$_center);
        $cf10f6a70bd83671$var$_extents.subVectors(this.max, $cf10f6a70bd83671$var$_center);
        // translate triangle to aabb origin
        $cf10f6a70bd83671$var$_v0$2.subVectors(triangle.a, $cf10f6a70bd83671$var$_center);
        $cf10f6a70bd83671$var$_v1$7.subVectors(triangle.b, $cf10f6a70bd83671$var$_center);
        $cf10f6a70bd83671$var$_v2$4.subVectors(triangle.c, $cf10f6a70bd83671$var$_center);
        // compute edge vectors for triangle
        $cf10f6a70bd83671$var$_f0.subVectors($cf10f6a70bd83671$var$_v1$7, $cf10f6a70bd83671$var$_v0$2);
        $cf10f6a70bd83671$var$_f1.subVectors($cf10f6a70bd83671$var$_v2$4, $cf10f6a70bd83671$var$_v1$7);
        $cf10f6a70bd83671$var$_f2.subVectors($cf10f6a70bd83671$var$_v0$2, $cf10f6a70bd83671$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$cf10f6a70bd83671$var$_f0.z,
            $cf10f6a70bd83671$var$_f0.y,
            0,
            -$cf10f6a70bd83671$var$_f1.z,
            $cf10f6a70bd83671$var$_f1.y,
            0,
            -$cf10f6a70bd83671$var$_f2.z,
            $cf10f6a70bd83671$var$_f2.y,
            $cf10f6a70bd83671$var$_f0.z,
            0,
            -$cf10f6a70bd83671$var$_f0.x,
            $cf10f6a70bd83671$var$_f1.z,
            0,
            -$cf10f6a70bd83671$var$_f1.x,
            $cf10f6a70bd83671$var$_f2.z,
            0,
            -$cf10f6a70bd83671$var$_f2.x,
            -$cf10f6a70bd83671$var$_f0.y,
            $cf10f6a70bd83671$var$_f0.x,
            0,
            -$cf10f6a70bd83671$var$_f1.y,
            $cf10f6a70bd83671$var$_f1.x,
            0,
            -$cf10f6a70bd83671$var$_f2.y,
            $cf10f6a70bd83671$var$_f2.x,
            0
        ];
        if (!$cf10f6a70bd83671$var$satForAxes(axes, $cf10f6a70bd83671$var$_v0$2, $cf10f6a70bd83671$var$_v1$7, $cf10f6a70bd83671$var$_v2$4, $cf10f6a70bd83671$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$cf10f6a70bd83671$var$satForAxes(axes, $cf10f6a70bd83671$var$_v0$2, $cf10f6a70bd83671$var$_v1$7, $cf10f6a70bd83671$var$_v2$4, $cf10f6a70bd83671$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $cf10f6a70bd83671$var$_triangleNormal.crossVectors($cf10f6a70bd83671$var$_f0, $cf10f6a70bd83671$var$_f1);
        axes = [
            $cf10f6a70bd83671$var$_triangleNormal.x,
            $cf10f6a70bd83671$var$_triangleNormal.y,
            $cf10f6a70bd83671$var$_triangleNormal.z
        ];
        return $cf10f6a70bd83671$var$satForAxes(axes, $cf10f6a70bd83671$var$_v0$2, $cf10f6a70bd83671$var$_v1$7, $cf10f6a70bd83671$var$_v2$4, $cf10f6a70bd83671$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $cf10f6a70bd83671$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($cf10f6a70bd83671$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $cf10f6a70bd83671$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $cf10f6a70bd83671$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $cf10f6a70bd83671$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $cf10f6a70bd83671$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $cf10f6a70bd83671$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $cf10f6a70bd83671$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $cf10f6a70bd83671$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $cf10f6a70bd83671$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($cf10f6a70bd83671$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $cf10f6a70bd83671$var$_points = [
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(),
    /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699()
];
const $cf10f6a70bd83671$var$_vector$b = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_box$4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $cf10f6a70bd83671$var$_v0$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v1$7 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v2$4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
// triangle edge vectors
const $cf10f6a70bd83671$var$_f0 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_f1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_f2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_center = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_extents = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_triangleNormal = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_testAxis = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
function $cf10f6a70bd83671$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $cf10f6a70bd83671$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($cf10f6a70bd83671$var$_testAxis.x) + extents.y * Math.abs($cf10f6a70bd83671$var$_testAxis.y) + extents.z * Math.abs($cf10f6a70bd83671$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($cf10f6a70bd83671$var$_testAxis);
        const p1 = v1.dot($cf10f6a70bd83671$var$_testAxis);
        const p2 = v2.dot($cf10f6a70bd83671$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $cf10f6a70bd83671$var$_box$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
const $cf10f6a70bd83671$var$_v1$6 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v2$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $cf10f6a70bd83671$export$805e8b72413ccaba {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $cf10f6a70bd83671$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $cf10f6a70bd83671$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $cf10f6a70bd83671$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $cf10f6a70bd83671$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($cf10f6a70bd83671$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $cf10f6a70bd83671$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($cf10f6a70bd83671$var$_v1$6.copy(sphere.center).add($cf10f6a70bd83671$var$_v2$3));
            this.expandByPoint($cf10f6a70bd83671$var$_v1$6.copy(sphere.center).sub($cf10f6a70bd83671$var$_v2$3));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $cf10f6a70bd83671$var$_vector$a = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_segCenter = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_segDir = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_diff = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_edge1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_edge2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_normal$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $cf10f6a70bd83671$export$a186db52eed6d40e {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $cf10f6a70bd83671$export$64b5c384219d3699(), direction = new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $cf10f6a70bd83671$var$_vector$a));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $cf10f6a70bd83671$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $cf10f6a70bd83671$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $cf10f6a70bd83671$var$_vector$a.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $cf10f6a70bd83671$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $cf10f6a70bd83671$var$_segDir.copy(v1).sub(v0).normalize();
        $cf10f6a70bd83671$var$_diff.copy(this.origin).sub($cf10f6a70bd83671$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($cf10f6a70bd83671$var$_segDir);
        const b0 = $cf10f6a70bd83671$var$_diff.dot(this.direction);
        const b1 = -$cf10f6a70bd83671$var$_diff.dot($cf10f6a70bd83671$var$_segDir);
        const c = $cf10f6a70bd83671$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($cf10f6a70bd83671$var$_segCenter).addScaledVector($cf10f6a70bd83671$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $cf10f6a70bd83671$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $cf10f6a70bd83671$var$_vector$a.dot(this.direction);
        const d2 = $cf10f6a70bd83671$var$_vector$a.dot($cf10f6a70bd83671$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $cf10f6a70bd83671$var$_vector$a) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $cf10f6a70bd83671$var$_edge1.subVectors(b, a);
        $cf10f6a70bd83671$var$_edge2.subVectors(c, a);
        $cf10f6a70bd83671$var$_normal$1.crossVectors($cf10f6a70bd83671$var$_edge1, $cf10f6a70bd83671$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($cf10f6a70bd83671$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $cf10f6a70bd83671$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($cf10f6a70bd83671$var$_edge2.crossVectors($cf10f6a70bd83671$var$_diff, $cf10f6a70bd83671$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($cf10f6a70bd83671$var$_edge1.cross($cf10f6a70bd83671$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $cf10f6a70bd83671$var$_diff.dot($cf10f6a70bd83671$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial]{@link https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices}
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $cf10f6a70bd83671$export$2ae72fc923e5eb5 {
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $cf10f6a70bd83671$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $cf10f6a70bd83671$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $cf10f6a70bd83671$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $cf10f6a70bd83671$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $cf10f6a70bd83671$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($cf10f6a70bd83671$var$_zero, q, $cf10f6a70bd83671$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $cf10f6a70bd83671$var$_z.subVectors(eye, target);
        if ($cf10f6a70bd83671$var$_z.lengthSq() === 0) // eye and target are in the same position
        $cf10f6a70bd83671$var$_z.z = 1;
        $cf10f6a70bd83671$var$_z.normalize();
        $cf10f6a70bd83671$var$_x.crossVectors(up, $cf10f6a70bd83671$var$_z);
        if ($cf10f6a70bd83671$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $cf10f6a70bd83671$var$_z.x += 0.0001;
            else $cf10f6a70bd83671$var$_z.z += 0.0001;
            $cf10f6a70bd83671$var$_z.normalize();
            $cf10f6a70bd83671$var$_x.crossVectors(up, $cf10f6a70bd83671$var$_z);
        }
        $cf10f6a70bd83671$var$_x.normalize();
        $cf10f6a70bd83671$var$_y.crossVectors($cf10f6a70bd83671$var$_z, $cf10f6a70bd83671$var$_x);
        te[0] = $cf10f6a70bd83671$var$_x.x;
        te[4] = $cf10f6a70bd83671$var$_y.x;
        te[8] = $cf10f6a70bd83671$var$_z.x;
        te[1] = $cf10f6a70bd83671$var$_x.y;
        te[5] = $cf10f6a70bd83671$var$_y.y;
        te[9] = $cf10f6a70bd83671$var$_z.y;
        te[2] = $cf10f6a70bd83671$var$_x.z;
        te[6] = $cf10f6a70bd83671$var$_y.z;
        te[10] = $cf10f6a70bd83671$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $cf10f6a70bd83671$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $cf10f6a70bd83671$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $cf10f6a70bd83671$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $cf10f6a70bd83671$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $cf10f6a70bd83671$var$_m1$2.elements[0] *= invSX;
        $cf10f6a70bd83671$var$_m1$2.elements[1] *= invSX;
        $cf10f6a70bd83671$var$_m1$2.elements[2] *= invSX;
        $cf10f6a70bd83671$var$_m1$2.elements[4] *= invSY;
        $cf10f6a70bd83671$var$_m1$2.elements[5] *= invSY;
        $cf10f6a70bd83671$var$_m1$2.elements[6] *= invSY;
        $cf10f6a70bd83671$var$_m1$2.elements[8] *= invSZ;
        $cf10f6a70bd83671$var$_m1$2.elements[9] *= invSZ;
        $cf10f6a70bd83671$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($cf10f6a70bd83671$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $cf10f6a70bd83671$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $cf10f6a70bd83671$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $cf10f6a70bd83671$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $cf10f6a70bd83671$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $cf10f6a70bd83671$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $cf10f6a70bd83671$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $cf10f6a70bd83671$var$_v1$5 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_m1$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_zero = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, 0);
const $cf10f6a70bd83671$var$_one = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(1, 1, 1);
const $cf10f6a70bd83671$var$_x = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_y = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_z = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_matrix$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_quaternion$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $cf10f6a70bd83671$export$d93cc409a0768c5f {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $cf10f6a70bd83671$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($cf10f6a70bd83671$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$cf10f6a70bd83671$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($cf10f6a70bd83671$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$cf10f6a70bd83671$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($cf10f6a70bd83671$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$cf10f6a70bd83671$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $cf10f6a70bd83671$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($cf10f6a70bd83671$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $cf10f6a70bd83671$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($cf10f6a70bd83671$var$_quaternion$3, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $cf10f6a70bd83671$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $cf10f6a70bd83671$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $cf10f6a70bd83671$var$_object3DId = 0;
const $cf10f6a70bd83671$var$_v1$4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_q1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
const $cf10f6a70bd83671$var$_m1$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_target = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_position$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_scale$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_quaternion$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
const $cf10f6a70bd83671$var$_xAxis = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(1, 0, 0);
const $cf10f6a70bd83671$var$_yAxis = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0);
const $cf10f6a70bd83671$var$_zAxis = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $cf10f6a70bd83671$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $cf10f6a70bd83671$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $cf10f6a70bd83671$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $cf10f6a70bd83671$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $cf10f6a70bd83671$export$e4dd07dff30cc924 extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $cf10f6a70bd83671$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const rotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        const quaternion = new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
        const scale = new $cf10f6a70bd83671$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $cf10f6a70bd83671$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $cf10f6a70bd83671$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $cf10f6a70bd83671$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $cf10f6a70bd83671$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($cf10f6a70bd83671$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $cf10f6a70bd83671$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($cf10f6a70bd83671$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($cf10f6a70bd83671$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($cf10f6a70bd83671$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($cf10f6a70bd83671$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $cf10f6a70bd83671$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($cf10f6a70bd83671$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($cf10f6a70bd83671$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($cf10f6a70bd83671$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($cf10f6a70bd83671$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($cf10f6a70bd83671$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $cf10f6a70bd83671$var$_target.copy(x);
        else $cf10f6a70bd83671$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $cf10f6a70bd83671$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $cf10f6a70bd83671$var$_m1$1.lookAt($cf10f6a70bd83671$var$_position$3, $cf10f6a70bd83671$var$_target, this.up);
        else $cf10f6a70bd83671$var$_m1$1.lookAt($cf10f6a70bd83671$var$_target, $cf10f6a70bd83671$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($cf10f6a70bd83671$var$_m1$1);
        if (parent) {
            $cf10f6a70bd83671$var$_m1$1.extractRotation(parent.matrixWorld);
            $cf10f6a70bd83671$var$_q1.setFromRotationMatrix($cf10f6a70bd83671$var$_m1$1);
            this.quaternion.premultiply($cf10f6a70bd83671$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($cf10f6a70bd83671$var$_addedEvent);
            $cf10f6a70bd83671$var$_childaddedEvent.child = object;
            this.dispatchEvent($cf10f6a70bd83671$var$_childaddedEvent);
            $cf10f6a70bd83671$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($cf10f6a70bd83671$var$_removedEvent);
            $cf10f6a70bd83671$var$_childremovedEvent.child = object;
            this.dispatchEvent($cf10f6a70bd83671$var$_childremovedEvent);
            $cf10f6a70bd83671$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $cf10f6a70bd83671$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $cf10f6a70bd83671$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($cf10f6a70bd83671$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($cf10f6a70bd83671$var$_addedEvent);
        $cf10f6a70bd83671$var$_childaddedEvent.child = object;
        this.dispatchEvent($cf10f6a70bd83671$var$_childaddedEvent);
        $cf10f6a70bd83671$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($cf10f6a70bd83671$var$_position$3, target, $cf10f6a70bd83671$var$_scale$2);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($cf10f6a70bd83671$var$_position$3, $cf10f6a70bd83671$var$_quaternion$2, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $cf10f6a70bd83671$var$_v0$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v1$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v2$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v3$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vab = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vac = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vbc = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vap = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vbp = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vcp = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v40 = /*@__PURE__*/ new $cf10f6a70bd83671$export$fa7daccca11cdbe3();
const $cf10f6a70bd83671$var$_v41 = /*@__PURE__*/ new $cf10f6a70bd83671$export$fa7daccca11cdbe3();
const $cf10f6a70bd83671$var$_v42 = /*@__PURE__*/ new $cf10f6a70bd83671$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $cf10f6a70bd83671$export$5a465592bfe74b48 {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $cf10f6a70bd83671$export$64b5c384219d3699(), b = new $cf10f6a70bd83671$export$64b5c384219d3699(), c = new $cf10f6a70bd83671$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $cf10f6a70bd83671$var$_v0$1.subVectors(a, b);
        target.cross($cf10f6a70bd83671$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $cf10f6a70bd83671$var$_v0$1.subVectors(c, a);
        $cf10f6a70bd83671$var$_v1$3.subVectors(b, a);
        $cf10f6a70bd83671$var$_v2$2.subVectors(point, a);
        const dot00 = $cf10f6a70bd83671$var$_v0$1.dot($cf10f6a70bd83671$var$_v0$1);
        const dot01 = $cf10f6a70bd83671$var$_v0$1.dot($cf10f6a70bd83671$var$_v1$3);
        const dot02 = $cf10f6a70bd83671$var$_v0$1.dot($cf10f6a70bd83671$var$_v2$2);
        const dot11 = $cf10f6a70bd83671$var$_v1$3.dot($cf10f6a70bd83671$var$_v1$3);
        const dot12 = $cf10f6a70bd83671$var$_v1$3.dot($cf10f6a70bd83671$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $cf10f6a70bd83671$var$_v3$2) === null) return false;
        return $cf10f6a70bd83671$var$_v3$2.x >= 0 && $cf10f6a70bd83671$var$_v3$2.y >= 0 && $cf10f6a70bd83671$var$_v3$2.x + $cf10f6a70bd83671$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $cf10f6a70bd83671$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $cf10f6a70bd83671$var$_v3$2.x);
        target.addScaledVector(v2, $cf10f6a70bd83671$var$_v3$2.y);
        target.addScaledVector(v3, $cf10f6a70bd83671$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $cf10f6a70bd83671$var$_v40.setScalar(0);
        $cf10f6a70bd83671$var$_v41.setScalar(0);
        $cf10f6a70bd83671$var$_v42.setScalar(0);
        $cf10f6a70bd83671$var$_v40.fromBufferAttribute(attr, i1);
        $cf10f6a70bd83671$var$_v41.fromBufferAttribute(attr, i2);
        $cf10f6a70bd83671$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($cf10f6a70bd83671$var$_v40, barycoord.x);
        target.addScaledVector($cf10f6a70bd83671$var$_v41, barycoord.y);
        target.addScaledVector($cf10f6a70bd83671$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $cf10f6a70bd83671$var$_v0$1.subVectors(c, b);
        $cf10f6a70bd83671$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $cf10f6a70bd83671$var$_v0$1.cross($cf10f6a70bd83671$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $cf10f6a70bd83671$var$_v0$1.subVectors(this.c, this.b);
        $cf10f6a70bd83671$var$_v1$3.subVectors(this.a, this.b);
        return $cf10f6a70bd83671$var$_v0$1.cross($cf10f6a70bd83671$var$_v1$3).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $cf10f6a70bd83671$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $cf10f6a70bd83671$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $cf10f6a70bd83671$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $cf10f6a70bd83671$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $cf10f6a70bd83671$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $cf10f6a70bd83671$var$_vab.subVectors(b, a);
        $cf10f6a70bd83671$var$_vac.subVectors(c, a);
        $cf10f6a70bd83671$var$_vap.subVectors(p, a);
        const d1 = $cf10f6a70bd83671$var$_vab.dot($cf10f6a70bd83671$var$_vap);
        const d2 = $cf10f6a70bd83671$var$_vac.dot($cf10f6a70bd83671$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $cf10f6a70bd83671$var$_vbp.subVectors(p, b);
        const d3 = $cf10f6a70bd83671$var$_vab.dot($cf10f6a70bd83671$var$_vbp);
        const d4 = $cf10f6a70bd83671$var$_vac.dot($cf10f6a70bd83671$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($cf10f6a70bd83671$var$_vab, v);
        }
        $cf10f6a70bd83671$var$_vcp.subVectors(p, c);
        const d5 = $cf10f6a70bd83671$var$_vab.dot($cf10f6a70bd83671$var$_vcp);
        const d6 = $cf10f6a70bd83671$var$_vac.dot($cf10f6a70bd83671$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($cf10f6a70bd83671$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $cf10f6a70bd83671$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($cf10f6a70bd83671$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($cf10f6a70bd83671$var$_vab, v).addScaledVector($cf10f6a70bd83671$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $cf10f6a70bd83671$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $cf10f6a70bd83671$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $cf10f6a70bd83671$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $cf10f6a70bd83671$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $cf10f6a70bd83671$export$892596cec99bc70e {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $cf10f6a70bd83671$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $cf10f6a70bd83671$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $cf10f6a70bd83671$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $cf10f6a70bd83671$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $cf10f6a70bd83671$var$euclideanModulo(h, 1);
        s = $cf10f6a70bd83671$var$clamp(s, 0, 1);
        l = $cf10f6a70bd83671$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $cf10f6a70bd83671$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $cf10f6a70bd83671$var$hue2rgb(q, p, h);
            this.b = $cf10f6a70bd83671$var$hue2rgb(q, p, h - 1 / 3);
        }
        $cf10f6a70bd83671$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa) {
        // color keywords
        const hex = $cf10f6a70bd83671$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $cf10f6a70bd83671$var$SRGBToLinear(color.r);
        this.g = $cf10f6a70bd83671$var$SRGBToLinear(color.g);
        this.b = $cf10f6a70bd83671$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $cf10f6a70bd83671$var$LinearToSRGB(color.r);
        this.g = $cf10f6a70bd83671$var$LinearToSRGB(color.g);
        this.b = $cf10f6a70bd83671$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa) {
        $cf10f6a70bd83671$export$5e6fd513f44698c.fromWorkingColorSpace($cf10f6a70bd83671$var$_color.copy(this), colorSpace);
        return Math.round($cf10f6a70bd83671$var$clamp($cf10f6a70bd83671$var$_color.r * 255, 0, 255)) * 65536 + Math.round($cf10f6a70bd83671$var$clamp($cf10f6a70bd83671$var$_color.g * 255, 0, 255)) * 256 + Math.round($cf10f6a70bd83671$var$clamp($cf10f6a70bd83671$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:0,s:0,l:0}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $cf10f6a70bd83671$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $cf10f6a70bd83671$export$5e6fd513f44698c.fromWorkingColorSpace($cf10f6a70bd83671$var$_color.copy(this), colorSpace);
        const r = $cf10f6a70bd83671$var$_color.r, g = $cf10f6a70bd83671$var$_color.g, b = $cf10f6a70bd83671$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $cf10f6a70bd83671$export$5e6fd513f44698c.workingColorSpace) {
        $cf10f6a70bd83671$export$5e6fd513f44698c.fromWorkingColorSpace($cf10f6a70bd83671$var$_color.copy(this), colorSpace);
        target.r = $cf10f6a70bd83671$var$_color.r;
        target.g = $cf10f6a70bd83671$var$_color.g;
        target.b = $cf10f6a70bd83671$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa) {
        $cf10f6a70bd83671$export$5e6fd513f44698c.fromWorkingColorSpace($cf10f6a70bd83671$var$_color.copy(this), colorSpace);
        const r = $cf10f6a70bd83671$var$_color.r, g = $cf10f6a70bd83671$var$_color.g, b = $cf10f6a70bd83671$var$_color.b;
        if (colorSpace !== $cf10f6a70bd83671$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($cf10f6a70bd83671$var$_hslA);
        return this.setHSL($cf10f6a70bd83671$var$_hslA.h + h, $cf10f6a70bd83671$var$_hslA.s + s, $cf10f6a70bd83671$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($cf10f6a70bd83671$var$_hslA);
        color.getHSL($cf10f6a70bd83671$var$_hslB);
        const h = $cf10f6a70bd83671$var$lerp($cf10f6a70bd83671$var$_hslA.h, $cf10f6a70bd83671$var$_hslB.h, alpha);
        const s = $cf10f6a70bd83671$var$lerp($cf10f6a70bd83671$var$_hslA.s, $cf10f6a70bd83671$var$_hslB.s, alpha);
        const l = $cf10f6a70bd83671$var$lerp($cf10f6a70bd83671$var$_hslA.l, $cf10f6a70bd83671$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $cf10f6a70bd83671$var$_color = /*@__PURE__*/ new $cf10f6a70bd83671$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $cf10f6a70bd83671$export$892596cec99bc70e.NAMES = $cf10f6a70bd83671$var$_colorKeywords;
let $cf10f6a70bd83671$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $cf10f6a70bd83671$export$a2d8b23205c25948 extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $cf10f6a70bd83671$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $cf10f6a70bd83671$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $cf10f6a70bd83671$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $cf10f6a70bd83671$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $cf10f6a70bd83671$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendEquation = $cf10f6a70bd83671$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $cf10f6a70bd83671$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $cf10f6a70bd83671$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $cf10f6a70bd83671$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $cf10f6a70bd83671$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $cf10f6a70bd83671$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $cf10f6a70bd83671$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $cf10f6a70bd83671$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $cf10f6a70bd83671$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $cf10f6a70bd83671$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $cf10f6a70bd83671$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $cf10f6a70bd83671$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $cf10f6a70bd83671$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $cf10f6a70bd83671$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $cf10f6a70bd83671$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $cf10f6a70bd83671$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $cf10f6a70bd83671$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
    }
}
class $cf10f6a70bd83671$export$55cbcc9b622fe1f5 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        this.combine = $cf10f6a70bd83671$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $cf10f6a70bd83671$var$_tables = /*@__PURE__*/ $cf10f6a70bd83671$var$_generateTables();
function $cf10f6a70bd83671$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $cf10f6a70bd83671$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $cf10f6a70bd83671$var$clamp(val, -65504, 65504);
    $cf10f6a70bd83671$var$_tables.floatView[0] = val;
    const f = $cf10f6a70bd83671$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $cf10f6a70bd83671$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $cf10f6a70bd83671$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $cf10f6a70bd83671$var$fromHalfFloat(val) {
    const m = val >> 10;
    $cf10f6a70bd83671$var$_tables.uint32View[0] = $cf10f6a70bd83671$var$_tables.mantissaTable[$cf10f6a70bd83671$var$_tables.offsetTable[m] + (val & 0x3ff)] + $cf10f6a70bd83671$var$_tables.exponentTable[m];
    return $cf10f6a70bd83671$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $cf10f6a70bd83671$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $cf10f6a70bd83671$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $cf10f6a70bd83671$var$fromHalfFloat(val);
    }
}
const $cf10f6a70bd83671$var$_vector$9 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vector2$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
let $cf10f6a70bd83671$var$_id$2 = 0;
class $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_id$2++
        });
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $cf10f6a70bd83671$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.gpuType = $cf10f6a70bd83671$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector2$1.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $cf10f6a70bd83671$var$_vector2$1.x, $cf10f6a70bd83671$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$9.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$9.x, $cf10f6a70bd83671$var$_vector$9.y, $cf10f6a70bd83671$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$9.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$9.x, $cf10f6a70bd83671$var$_vector$9.y, $cf10f6a70bd83671$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$9.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$9.x, $cf10f6a70bd83671$var$_vector$9.y, $cf10f6a70bd83671$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$9.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$9.x, $cf10f6a70bd83671$var$_vector$9.y, $cf10f6a70bd83671$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $cf10f6a70bd83671$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $cf10f6a70bd83671$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $cf10f6a70bd83671$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $cf10f6a70bd83671$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $cf10f6a70bd83671$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $cf10f6a70bd83671$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $cf10f6a70bd83671$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $cf10f6a70bd83671$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $cf10f6a70bd83671$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $cf10f6a70bd83671$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
            z = $cf10f6a70bd83671$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
            z = $cf10f6a70bd83671$var$normalize(z, this.array);
            w = $cf10f6a70bd83671$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $cf10f6a70bd83671$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
//
class $cf10f6a70bd83671$export$f9ff2d6a20248cbf extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$cacc90cf35d11cdd extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$baaa85a1a812c157 extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$2b755a102ccdcefe extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$640a853f68025f2e extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$46b369aed2968a0a extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$7eb8c9fa25cd5bd6 extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $cf10f6a70bd83671$export$dbd3698c64958d69 extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $cf10f6a70bd83671$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $cf10f6a70bd83671$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $cf10f6a70bd83671$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $cf10f6a70bd83671$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $cf10f6a70bd83671$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $cf10f6a70bd83671$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $cf10f6a70bd83671$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $cf10f6a70bd83671$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $cf10f6a70bd83671$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $cf10f6a70bd83671$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $cf10f6a70bd83671$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $cf10f6a70bd83671$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $cf10f6a70bd83671$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $cf10f6a70bd83671$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $cf10f6a70bd83671$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $cf10f6a70bd83671$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
        }
        this.array[index + 0] = $cf10f6a70bd83671$var$toHalfFloat(x);
        this.array[index + 1] = $cf10f6a70bd83671$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
            z = $cf10f6a70bd83671$var$normalize(z, this.array);
        }
        this.array[index + 0] = $cf10f6a70bd83671$var$toHalfFloat(x);
        this.array[index + 1] = $cf10f6a70bd83671$var$toHalfFloat(y);
        this.array[index + 2] = $cf10f6a70bd83671$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
            z = $cf10f6a70bd83671$var$normalize(z, this.array);
            w = $cf10f6a70bd83671$var$normalize(w, this.array);
        }
        this.array[index + 0] = $cf10f6a70bd83671$var$toHalfFloat(x);
        this.array[index + 1] = $cf10f6a70bd83671$var$toHalfFloat(y);
        this.array[index + 2] = $cf10f6a70bd83671$var$toHalfFloat(z);
        this.array[index + 3] = $cf10f6a70bd83671$var$toHalfFloat(w);
        return this;
    }
}
class $cf10f6a70bd83671$export$cbe7a62641830ebd extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $cf10f6a70bd83671$var$_id$1 = 0;
const $cf10f6a70bd83671$var$_m1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_obj = /*@__PURE__*/ new $cf10f6a70bd83671$export$e4dd07dff30cc924();
const $cf10f6a70bd83671$var$_offset = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_box$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
const $cf10f6a70bd83671$var$_boxMorphTargets = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
const $cf10f6a70bd83671$var$_vector$8 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
class $cf10f6a70bd83671$export$b7be63a67df8959 extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_id$1++
        });
        this.uuid = $cf10f6a70bd83671$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.indirect = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($cf10f6a70bd83671$export$bc6f937da07eae17(index) ? $cf10f6a70bd83671$export$7eb8c9fa25cd5bd6 : $cf10f6a70bd83671$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $cf10f6a70bd83671$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $cf10f6a70bd83671$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($cf10f6a70bd83671$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $cf10f6a70bd83671$var$_m1.makeRotationX(angle);
        this.applyMatrix4($cf10f6a70bd83671$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $cf10f6a70bd83671$var$_m1.makeRotationY(angle);
        this.applyMatrix4($cf10f6a70bd83671$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $cf10f6a70bd83671$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($cf10f6a70bd83671$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $cf10f6a70bd83671$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($cf10f6a70bd83671$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $cf10f6a70bd83671$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($cf10f6a70bd83671$var$_m1);
        return this;
    }
    lookAt(vector) {
        $cf10f6a70bd83671$var$_obj.lookAt(vector);
        $cf10f6a70bd83671$var$_obj.updateMatrix();
        this.applyMatrix4($cf10f6a70bd83671$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($cf10f6a70bd83671$var$_offset).negate();
        this.translate($cf10f6a70bd83671$var$_offset.x, $cf10f6a70bd83671$var$_offset.y, $cf10f6a70bd83671$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $cf10f6a70bd83671$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $cf10f6a70bd83671$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $cf10f6a70bd83671$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $cf10f6a70bd83671$var$_vector$8.addVectors(this.boundingBox.min, $cf10f6a70bd83671$var$_box$2.min);
                    this.boundingBox.expandByPoint($cf10f6a70bd83671$var$_vector$8);
                    $cf10f6a70bd83671$var$_vector$8.addVectors(this.boundingBox.max, $cf10f6a70bd83671$var$_box$2.max);
                    this.boundingBox.expandByPoint($cf10f6a70bd83671$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($cf10f6a70bd83671$var$_box$2.min);
                    this.boundingBox.expandByPoint($cf10f6a70bd83671$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $cf10f6a70bd83671$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $cf10f6a70bd83671$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $cf10f6a70bd83671$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $cf10f6a70bd83671$var$_vector$8.addVectors($cf10f6a70bd83671$var$_box$2.min, $cf10f6a70bd83671$var$_boxMorphTargets.min);
                    $cf10f6a70bd83671$var$_box$2.expandByPoint($cf10f6a70bd83671$var$_vector$8);
                    $cf10f6a70bd83671$var$_vector$8.addVectors($cf10f6a70bd83671$var$_box$2.max, $cf10f6a70bd83671$var$_boxMorphTargets.max);
                    $cf10f6a70bd83671$var$_box$2.expandByPoint($cf10f6a70bd83671$var$_vector$8);
                } else {
                    $cf10f6a70bd83671$var$_box$2.expandByPoint($cf10f6a70bd83671$var$_boxMorphTargets.min);
                    $cf10f6a70bd83671$var$_box$2.expandByPoint($cf10f6a70bd83671$var$_boxMorphTargets.max);
                }
            }
            $cf10f6a70bd83671$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $cf10f6a70bd83671$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($cf10f6a70bd83671$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $cf10f6a70bd83671$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $cf10f6a70bd83671$var$_offset.fromBufferAttribute(position, j);
                        $cf10f6a70bd83671$var$_vector$8.add($cf10f6a70bd83671$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($cf10f6a70bd83671$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $cf10f6a70bd83671$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $cf10f6a70bd83671$export$64b5c384219d3699();
            tan2[i] = new $cf10f6a70bd83671$export$64b5c384219d3699();
        }
        const vA = new $cf10f6a70bd83671$export$64b5c384219d3699(), vB = new $cf10f6a70bd83671$export$64b5c384219d3699(), vC = new $cf10f6a70bd83671$export$64b5c384219d3699(), uvA = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), uvB = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), uvC = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), sdir = new $cf10f6a70bd83671$export$64b5c384219d3699(), tdir = new $cf10f6a70bd83671$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $cf10f6a70bd83671$export$64b5c384219d3699(), tmp2 = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const n = new $cf10f6a70bd83671$export$64b5c384219d3699(), n2 = new $cf10f6a70bd83671$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $cf10f6a70bd83671$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $cf10f6a70bd83671$export$64b5c384219d3699(), pB = new $cf10f6a70bd83671$export$64b5c384219d3699(), pC = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const nA = new $cf10f6a70bd83671$export$64b5c384219d3699(), nB = new $cf10f6a70bd83671$export$64b5c384219d3699(), nC = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const cb = new $cf10f6a70bd83671$export$64b5c384219d3699(), ab = new $cf10f6a70bd83671$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $cf10f6a70bd83671$var$_vector$8.fromBufferAttribute(normals, i);
            $cf10f6a70bd83671$var$_vector$8.normalize();
            normals.setXYZ(i, $cf10f6a70bd83671$var$_vector$8.x, $cf10f6a70bd83671$var$_vector$8.y, $cf10f6a70bd83671$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $cf10f6a70bd83671$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $cf10f6a70bd83671$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $cf10f6a70bd83671$var$_inverseMatrix$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_ray$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$a186db52eed6d40e();
const $cf10f6a70bd83671$var$_sphere$6 = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
const $cf10f6a70bd83671$var$_sphereHitAt = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vA$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vB$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vC$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_tempA = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_morphA = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_intersectionPoint = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_intersectionPointWorld = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$e176487c05830cc5 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $cf10f6a70bd83671$export$b7be63a67df8959(), material = new $cf10f6a70bd83671$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $cf10f6a70bd83671$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $cf10f6a70bd83671$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $cf10f6a70bd83671$var$_morphA.addScaledVector($cf10f6a70bd83671$var$_tempA, influence);
                else $cf10f6a70bd83671$var$_morphA.addScaledVector($cf10f6a70bd83671$var$_tempA.sub(target), influence);
            }
            target.add($cf10f6a70bd83671$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $cf10f6a70bd83671$var$_sphere$6.copy(geometry.boundingSphere);
        $cf10f6a70bd83671$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $cf10f6a70bd83671$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($cf10f6a70bd83671$var$_sphere$6.containsPoint($cf10f6a70bd83671$var$_ray$3.origin) === false) {
            if ($cf10f6a70bd83671$var$_ray$3.intersectSphere($cf10f6a70bd83671$var$_sphere$6, $cf10f6a70bd83671$var$_sphereHitAt) === null) return;
            if ($cf10f6a70bd83671$var$_ray$3.origin.distanceToSquared($cf10f6a70bd83671$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $cf10f6a70bd83671$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $cf10f6a70bd83671$var$_ray$3.copy(raycaster.ray).applyMatrix4($cf10f6a70bd83671$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($cf10f6a70bd83671$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $cf10f6a70bd83671$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $cf10f6a70bd83671$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $cf10f6a70bd83671$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $cf10f6a70bd83671$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $cf10f6a70bd83671$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $cf10f6a70bd83671$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $cf10f6a70bd83671$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $cf10f6a70bd83671$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $cf10f6a70bd83671$var$_intersectionPointWorld.copy(point);
    $cf10f6a70bd83671$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($cf10f6a70bd83671$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $cf10f6a70bd83671$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $cf10f6a70bd83671$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $cf10f6a70bd83671$var$_vA$1);
    object.getVertexPosition(b, $cf10f6a70bd83671$var$_vB$1);
    object.getVertexPosition(c, $cf10f6a70bd83671$var$_vC$1);
    const intersection = $cf10f6a70bd83671$var$checkIntersection$1(object, material, raycaster, ray, $cf10f6a70bd83671$var$_vA$1, $cf10f6a70bd83671$var$_vB$1, $cf10f6a70bd83671$var$_vC$1, $cf10f6a70bd83671$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $cf10f6a70bd83671$export$64b5c384219d3699();
        $cf10f6a70bd83671$export$5a465592bfe74b48.getBarycoord($cf10f6a70bd83671$var$_intersectionPoint, $cf10f6a70bd83671$var$_vA$1, $cf10f6a70bd83671$var$_vB$1, $cf10f6a70bd83671$var$_vC$1, barycoord);
        if (uv) intersection.uv = $cf10f6a70bd83671$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $cf10f6a70bd83671$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $cf10f6a70bd83671$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $cf10f6a70bd83671$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $cf10f6a70bd83671$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $cf10f6a70bd83671$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $cf10f6a70bd83671$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $cf10f6a70bd83671$export$5a465592bfe74b48.getNormal($cf10f6a70bd83671$var$_vA$1, $cf10f6a70bd83671$var$_vB$1, $cf10f6a70bd83671$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$33e43285f7406bd5 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $cf10f6a70bd83671$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $cf10f6a70bd83671$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $cf10f6a70bd83671$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $cf10f6a70bd83671$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $cf10f6a70bd83671$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $cf10f6a70bd83671$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $cf10f6a70bd83671$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $cf10f6a70bd83671$export$d8ecdf8615bfea69 = {
    clone: $cf10f6a70bd83671$export$acda854380553452,
    merge: $cf10f6a70bd83671$export$8916ce6879271f43
};
var $cf10f6a70bd83671$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $cf10f6a70bd83671$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $cf10f6a70bd83671$export$83c7d75d550a8b0d extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $cf10f6a70bd83671$var$default_vertex;
        this.fragmentShader = $cf10f6a70bd83671$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $cf10f6a70bd83671$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $cf10f6a70bd83671$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$79f141de891a5fed extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $cf10f6a70bd83671$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $cf10f6a70bd83671$var$_v3$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_minTarget = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
const $cf10f6a70bd83671$var$_maxTarget = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection]{@link https://en.wikipedia.org/wiki/Perspective_(graphical)}.
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $cf10f6a70bd83671$export$74e4ae24825f68d7 extends $cf10f6a70bd83671$export$79f141de891a5fed {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $cf10f6a70bd83671$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($cf10f6a70bd83671$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $cf10f6a70bd83671$export$914076c8150813e5 * 2 * Math.atan(Math.tan($cf10f6a70bd83671$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $cf10f6a70bd83671$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($cf10f6a70bd83671$var$_v3$1.x, $cf10f6a70bd83671$var$_v3$1.y).multiplyScalar(-distance / $cf10f6a70bd83671$var$_v3$1.z);
        $cf10f6a70bd83671$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($cf10f6a70bd83671$var$_v3$1.x, $cf10f6a70bd83671$var$_v3$1.y).multiplyScalar(-distance / $cf10f6a70bd83671$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $cf10f6a70bd83671$var$_minTarget, $cf10f6a70bd83671$var$_maxTarget);
        return target.subVectors($cf10f6a70bd83671$var$_maxTarget, $cf10f6a70bd83671$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($cf10f6a70bd83671$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $cf10f6a70bd83671$var$fov = -90; // negative fov is not an error
const $cf10f6a70bd83671$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$d0cdd0bd804995de extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $cf10f6a70bd83671$export$74e4ae24825f68d7($cf10f6a70bd83671$var$fov, $cf10f6a70bd83671$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $cf10f6a70bd83671$export$74e4ae24825f68d7($cf10f6a70bd83671$var$fov, $cf10f6a70bd83671$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $cf10f6a70bd83671$export$74e4ae24825f68d7($cf10f6a70bd83671$var$fov, $cf10f6a70bd83671$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $cf10f6a70bd83671$export$74e4ae24825f68d7($cf10f6a70bd83671$var$fov, $cf10f6a70bd83671$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $cf10f6a70bd83671$export$74e4ae24825f68d7($cf10f6a70bd83671$var$fov, $cf10f6a70bd83671$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $cf10f6a70bd83671$export$74e4ae24825f68d7($cf10f6a70bd83671$var$fov, $cf10f6a70bd83671$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $cf10f6a70bd83671$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $cf10f6a70bd83671$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $cf10f6a70bd83671$export$ee2e5a18258a4049 extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $cf10f6a70bd83671$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $cf10f6a70bd83671$export$ac386671d651941e extends $cf10f6a70bd83671$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $cf10f6a70bd83671$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $cf10f6a70bd83671$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $cf10f6a70bd83671$export$33e43285f7406bd5(5, 5, 5);
        const material = new $cf10f6a70bd83671$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $cf10f6a70bd83671$export$acda854380553452(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $cf10f6a70bd83671$export$d9f0486e75b5ace,
            blending: $cf10f6a70bd83671$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $cf10f6a70bd83671$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $cf10f6a70bd83671$export$5d8599b6a933fb1b) texture.minFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8;
        const camera = new $cf10f6a70bd83671$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$eb2fcfdbd7ba97d4 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $cf10f6a70bd83671$var$_moveEvent = {
    type: 'move'
};
class $cf10f6a70bd83671$export$cb626c57dcc48b9f {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $cf10f6a70bd83671$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $cf10f6a70bd83671$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $cf10f6a70bd83671$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $cf10f6a70bd83671$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $cf10f6a70bd83671$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $cf10f6a70bd83671$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $cf10f6a70bd83671$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($cf10f6a70bd83671$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $cf10f6a70bd83671$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $cf10f6a70bd83671$export$6f1519f023b8d0f6 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $cf10f6a70bd83671$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $cf10f6a70bd83671$export$3c890837b09508d4 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $cf10f6a70bd83671$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$38af1803e3442a7f extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
class $cf10f6a70bd83671$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $cf10f6a70bd83671$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $cf10f6a70bd83671$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $cf10f6a70bd83671$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $cf10f6a70bd83671$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $cf10f6a70bd83671$var$_vector$7 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
class $cf10f6a70bd83671$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$7.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$7.applyMatrix4(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$7.x, $cf10f6a70bd83671$var$_vector$7.y, $cf10f6a70bd83671$var$_vector$7.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$7.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$7.applyNormalMatrix(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$7.x, $cf10f6a70bd83671$var$_vector$7.y, $cf10f6a70bd83671$var$_vector$7.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $cf10f6a70bd83671$var$_vector$7.fromBufferAttribute(this, i);
            $cf10f6a70bd83671$var$_vector$7.transformDirection(m);
            this.setXYZ(i, $cf10f6a70bd83671$var$_vector$7.x, $cf10f6a70bd83671$var$_vector$7.y, $cf10f6a70bd83671$var$_vector$7.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $cf10f6a70bd83671$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $cf10f6a70bd83671$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $cf10f6a70bd83671$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $cf10f6a70bd83671$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $cf10f6a70bd83671$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $cf10f6a70bd83671$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $cf10f6a70bd83671$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $cf10f6a70bd83671$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $cf10f6a70bd83671$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $cf10f6a70bd83671$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
            z = $cf10f6a70bd83671$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $cf10f6a70bd83671$var$normalize(x, this.array);
            y = $cf10f6a70bd83671$var$normalize(y, this.array);
            z = $cf10f6a70bd83671$var$normalize(z, this.array);
            w = $cf10f6a70bd83671$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $cf10f6a70bd83671$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $cf10f6a70bd83671$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $cf10f6a70bd83671$export$5ec7dd1c6994bf8e extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $cf10f6a70bd83671$var$_geometry;
const $cf10f6a70bd83671$var$_intersectPoint = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_worldScale = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_mvPosition = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_alignedPosition = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
const $cf10f6a70bd83671$var$_rotatedPosition = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
const $cf10f6a70bd83671$var$_viewWorldMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_vA = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vB = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vC = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_uvA = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
const $cf10f6a70bd83671$var$_uvB = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
const $cf10f6a70bd83671$var$_uvC = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$3075603db8e6204c extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {SpriteMaterial} [material] - The sprite material.
	 */ constructor(material = new $cf10f6a70bd83671$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($cf10f6a70bd83671$var$_geometry === undefined) {
            $cf10f6a70bd83671$var$_geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $cf10f6a70bd83671$export$3d5cd879f108f53f(float32Array, 5);
            $cf10f6a70bd83671$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $cf10f6a70bd83671$var$_geometry.setAttribute('position', new $cf10f6a70bd83671$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $cf10f6a70bd83671$var$_geometry.setAttribute('uv', new $cf10f6a70bd83671$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $cf10f6a70bd83671$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {SpriteMaterial}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $cf10f6a70bd83671$export$c977b3e384af9ae1(0.5, 0.5);
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $cf10f6a70bd83671$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $cf10f6a70bd83671$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $cf10f6a70bd83671$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $cf10f6a70bd83671$var$_worldScale.multiplyScalar(-$cf10f6a70bd83671$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $cf10f6a70bd83671$var$transformVertex($cf10f6a70bd83671$var$_vA.set(-0.5, -0.5, 0), $cf10f6a70bd83671$var$_mvPosition, center, $cf10f6a70bd83671$var$_worldScale, sin, cos);
        $cf10f6a70bd83671$var$transformVertex($cf10f6a70bd83671$var$_vB.set(0.5, -0.5, 0), $cf10f6a70bd83671$var$_mvPosition, center, $cf10f6a70bd83671$var$_worldScale, sin, cos);
        $cf10f6a70bd83671$var$transformVertex($cf10f6a70bd83671$var$_vC.set(0.5, 0.5, 0), $cf10f6a70bd83671$var$_mvPosition, center, $cf10f6a70bd83671$var$_worldScale, sin, cos);
        $cf10f6a70bd83671$var$_uvA.set(0, 0);
        $cf10f6a70bd83671$var$_uvB.set(1, 0);
        $cf10f6a70bd83671$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($cf10f6a70bd83671$var$_vA, $cf10f6a70bd83671$var$_vB, $cf10f6a70bd83671$var$_vC, false, $cf10f6a70bd83671$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $cf10f6a70bd83671$var$transformVertex($cf10f6a70bd83671$var$_vB.set(-0.5, 0.5, 0), $cf10f6a70bd83671$var$_mvPosition, center, $cf10f6a70bd83671$var$_worldScale, sin, cos);
            $cf10f6a70bd83671$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($cf10f6a70bd83671$var$_vA, $cf10f6a70bd83671$var$_vC, $cf10f6a70bd83671$var$_vB, false, $cf10f6a70bd83671$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($cf10f6a70bd83671$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $cf10f6a70bd83671$var$_intersectPoint.clone(),
            uv: $cf10f6a70bd83671$export$5a465592bfe74b48.getInterpolation($cf10f6a70bd83671$var$_intersectPoint, $cf10f6a70bd83671$var$_vA, $cf10f6a70bd83671$var$_vB, $cf10f6a70bd83671$var$_vC, $cf10f6a70bd83671$var$_uvA, $cf10f6a70bd83671$var$_uvB, $cf10f6a70bd83671$var$_uvC, new $cf10f6a70bd83671$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $cf10f6a70bd83671$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $cf10f6a70bd83671$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $cf10f6a70bd83671$var$_rotatedPosition.x = cos * $cf10f6a70bd83671$var$_alignedPosition.x - sin * $cf10f6a70bd83671$var$_alignedPosition.y;
        $cf10f6a70bd83671$var$_rotatedPosition.y = sin * $cf10f6a70bd83671$var$_alignedPosition.x + cos * $cf10f6a70bd83671$var$_alignedPosition.y;
    } else $cf10f6a70bd83671$var$_rotatedPosition.copy($cf10f6a70bd83671$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $cf10f6a70bd83671$var$_rotatedPosition.x;
    vertexPosition.y += $cf10f6a70bd83671$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($cf10f6a70bd83671$var$_viewWorldMatrix);
}
const $cf10f6a70bd83671$var$_v1$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v2$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$112e7237be0c5f30 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {Object3D|null} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $cf10f6a70bd83671$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($cf10f6a70bd83671$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is renderd with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $cf10f6a70bd83671$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $cf10f6a70bd83671$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $cf10f6a70bd83671$var$_v1$2.distanceTo($cf10f6a70bd83671$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $cf10f6a70bd83671$var$_basePosition = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_skinIndex = /*@__PURE__*/ new $cf10f6a70bd83671$export$fa7daccca11cdbe3();
const $cf10f6a70bd83671$var$_skinWeight = /*@__PURE__*/ new $cf10f6a70bd83671$export$fa7daccca11cdbe3();
const $cf10f6a70bd83671$var$_vector3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_matrix4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_vertex = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_sphere$5 = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
const $cf10f6a70bd83671$var$_inverseMatrix$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_ray$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 */ class $cf10f6a70bd83671$export$b303577035157ecf extends $cf10f6a70bd83671$export$e176487c05830cc5 {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $cf10f6a70bd83671$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $cf10f6a70bd83671$var$_vertex);
            this.boundingBox.expandByPoint($cf10f6a70bd83671$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $cf10f6a70bd83671$var$_vertex);
            this.boundingSphere.expandByPoint($cf10f6a70bd83671$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $cf10f6a70bd83671$var$_sphere$5.copy(this.boundingSphere);
        $cf10f6a70bd83671$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($cf10f6a70bd83671$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $cf10f6a70bd83671$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $cf10f6a70bd83671$var$_ray$2.copy(raycaster.ray).applyMatrix4($cf10f6a70bd83671$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($cf10f6a70bd83671$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $cf10f6a70bd83671$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $cf10f6a70bd83671$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $cf10f6a70bd83671$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $cf10f6a70bd83671$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $cf10f6a70bd83671$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $cf10f6a70bd83671$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $cf10f6a70bd83671$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $cf10f6a70bd83671$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $cf10f6a70bd83671$var$_skinIndex.getComponent(i);
                $cf10f6a70bd83671$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($cf10f6a70bd83671$var$_vector3.copy($cf10f6a70bd83671$var$_basePosition).applyMatrix4($cf10f6a70bd83671$var$_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$b127726e56765aa4 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
class $cf10f6a70bd83671$export$b691f601014eabe1 extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0, minFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $cf10f6a70bd83671$var$_offsetMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_identityMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $cf10f6a70bd83671$export$8f31e4c4a37b8e9c {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $cf10f6a70bd83671$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $cf10f6a70bd83671$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $cf10f6a70bd83671$var$_identityMatrix;
            $cf10f6a70bd83671$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $cf10f6a70bd83671$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $cf10f6a70bd83671$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $cf10f6a70bd83671$export$b691f601014eabe1(boneMatrices, size, size, $cf10f6a70bd83671$export$3f8bb04b555a363c, $cf10f6a70bd83671$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Array<Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $cf10f6a70bd83671$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $cf10f6a70bd83671$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $cf10f6a70bd83671$export$32ea87a8b54d744a extends $cf10f6a70bd83671$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $cf10f6a70bd83671$var$_instanceLocalMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_instanceWorldMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_instanceIntersects = [];
const $cf10f6a70bd83671$var$_box3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
const $cf10f6a70bd83671$var$_identity = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_mesh$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$e176487c05830cc5();
const $cf10f6a70bd83671$var$_sphere$4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $cf10f6a70bd83671$export$f3c979c331175ad7 extends $cf10f6a70bd83671$export$e176487c05830cc5 {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $cf10f6a70bd83671$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $cf10f6a70bd83671$var$_identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $cf10f6a70bd83671$var$_instanceLocalMatrix);
            $cf10f6a70bd83671$var$_box3.copy(geometry.boundingBox).applyMatrix4($cf10f6a70bd83671$var$_instanceLocalMatrix);
            this.boundingBox.union($cf10f6a70bd83671$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $cf10f6a70bd83671$var$_instanceLocalMatrix);
            $cf10f6a70bd83671$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($cf10f6a70bd83671$var$_instanceLocalMatrix);
            this.boundingSphere.union($cf10f6a70bd83671$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $cf10f6a70bd83671$var$_mesh$1.geometry = this.geometry;
        $cf10f6a70bd83671$var$_mesh$1.material = this.material;
        if ($cf10f6a70bd83671$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $cf10f6a70bd83671$var$_sphere$4.copy(this.boundingSphere);
        $cf10f6a70bd83671$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($cf10f6a70bd83671$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $cf10f6a70bd83671$var$_instanceLocalMatrix);
            $cf10f6a70bd83671$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $cf10f6a70bd83671$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $cf10f6a70bd83671$var$_mesh$1.matrixWorld = $cf10f6a70bd83671$var$_instanceWorldMatrix;
            $cf10f6a70bd83671$var$_mesh$1.raycast(raycaster, $cf10f6a70bd83671$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $cf10f6a70bd83671$var$_instanceIntersects.length; i < l; i++){
                const intersect = $cf10f6a70bd83671$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $cf10f6a70bd83671$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $cf10f6a70bd83671$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The the local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $cf10f6a70bd83671$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $cf10f6a70bd83671$export$4e041a7967d15c4b, $cf10f6a70bd83671$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const $cf10f6a70bd83671$var$_vector1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vector2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_normalMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form]{@link http://mathworld.wolfram.com/HessianNormalForm.html}
 * by a unit length normal vector and a constant.
 */ class $cf10f6a70bd83671$export$7ff5ac152ef991b0 {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $cf10f6a70bd83671$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $cf10f6a70bd83671$var$_vector1.subVectors(c, b).cross($cf10f6a70bd83671$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta($cf10f6a70bd83671$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $cf10f6a70bd83671$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($cf10f6a70bd83671$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $cf10f6a70bd83671$var$_sphere$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
const $cf10f6a70bd83671$var$_vector$6 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $cf10f6a70bd83671$export$35efe6f4c85463d2 {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $cf10f6a70bd83671$export$7ff5ac152ef991b0(), p1 = new $cf10f6a70bd83671$export$7ff5ac152ef991b0(), p2 = new $cf10f6a70bd83671$export$7ff5ac152ef991b0(), p3 = new $cf10f6a70bd83671$export$7ff5ac152ef991b0(), p4 = new $cf10f6a70bd83671$export$7ff5ac152ef991b0(), p5 = new $cf10f6a70bd83671$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $cf10f6a70bd83671$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $cf10f6a70bd83671$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $cf10f6a70bd83671$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $cf10f6a70bd83671$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $cf10f6a70bd83671$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($cf10f6a70bd83671$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $cf10f6a70bd83671$var$_sphere$3.center.set(0, 0, 0);
        $cf10f6a70bd83671$var$_sphere$3.radius = 0.7071067811865476;
        $cf10f6a70bd83671$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($cf10f6a70bd83671$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $cf10f6a70bd83671$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $cf10f6a70bd83671$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $cf10f6a70bd83671$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($cf10f6a70bd83671$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
function $cf10f6a70bd83671$var$ascIdSort(a, b) {
    return a - b;
}
function $cf10f6a70bd83671$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $cf10f6a70bd83671$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $cf10f6a70bd83671$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $cf10f6a70bd83671$var$_matrix$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_whiteColor = /*@__PURE__*/ new $cf10f6a70bd83671$export$892596cec99bc70e(1, 1, 1);
const $cf10f6a70bd83671$var$_frustum = /*@__PURE__*/ new $cf10f6a70bd83671$export$35efe6f4c85463d2();
const $cf10f6a70bd83671$var$_box$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
const $cf10f6a70bd83671$var$_sphere$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
const $cf10f6a70bd83671$var$_vector$5 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_forward = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_temp = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_renderList = /*@__PURE__*/ new $cf10f6a70bd83671$var$MultiDrawRenderList();
const $cf10f6a70bd83671$var$_mesh = /*@__PURE__*/ new $cf10f6a70bd83671$export$e176487c05830cc5();
const $cf10f6a70bd83671$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $cf10f6a70bd83671$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $cf10f6a70bd83671$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $cf10f6a70bd83671$export$6e01c5ee52ed8f7b extends $cf10f6a70bd83671$export$e176487c05830cc5 {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $cf10f6a70bd83671$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $cf10f6a70bd83671$export$b691f601014eabe1(matricesArray, size, size, $cf10f6a70bd83671$export$3f8bb04b555a363c, $cf10f6a70bd83671$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $cf10f6a70bd83671$export$b691f601014eabe1(indirectArray, size, size, $cf10f6a70bd83671$export$aa92e870a709d190, $cf10f6a70bd83671$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $cf10f6a70bd83671$export$b691f601014eabe1(colorsArray, size, size, $cf10f6a70bd83671$export$3f8bb04b555a363c, $cf10f6a70bd83671$export$f6d331659b644596);
        colorsTexture.colorSpace = $cf10f6a70bd83671$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $cf10f6a70bd83671$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $cf10f6a70bd83671$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The the instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The the geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $cf10f6a70bd83671$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $cf10f6a70bd83671$var$_box$1).applyMatrix4($cf10f6a70bd83671$var$_matrix$1);
            boundingBox.union($cf10f6a70bd83671$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $cf10f6a70bd83671$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $cf10f6a70bd83671$var$_sphere$2).applyMatrix4($cf10f6a70bd83671$var$_matrix$1);
            boundingSphere.union($cf10f6a70bd83671$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($cf10f6a70bd83671$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $cf10f6a70bd83671$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $cf10f6a70bd83671$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($cf10f6a70bd83671$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geomtry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $cf10f6a70bd83671$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geomtry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in [name] to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {Box3|null} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($cf10f6a70bd83671$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {Sphere|null} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $cf10f6a70bd83671$var$_box$1);
            $cf10f6a70bd83671$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $cf10f6a70bd83671$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($cf10f6a70bd83671$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($cf10f6a70bd83671$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $cf10f6a70bd83671$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $cf10f6a70bd83671$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $cf10f6a70bd83671$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $cf10f6a70bd83671$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $cf10f6a70bd83671$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $cf10f6a70bd83671$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$cf10f6a70bd83671$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $cf10f6a70bd83671$var$_mesh.material = this.material;
        $cf10f6a70bd83671$var$_mesh.geometry.index = batchGeometry.index;
        $cf10f6a70bd83671$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($cf10f6a70bd83671$var$_mesh.geometry.boundingBox === null) $cf10f6a70bd83671$var$_mesh.geometry.boundingBox = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
        if ($cf10f6a70bd83671$var$_mesh.geometry.boundingSphere === null) $cf10f6a70bd83671$var$_mesh.geometry.boundingSphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $cf10f6a70bd83671$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $cf10f6a70bd83671$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $cf10f6a70bd83671$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $cf10f6a70bd83671$var$_mesh.geometry.boundingSphere);
            $cf10f6a70bd83671$var$_mesh.raycast(raycaster, $cf10f6a70bd83671$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $cf10f6a70bd83671$var$_batchIntersects.length; j < l; j++){
                const intersect = $cf10f6a70bd83671$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $cf10f6a70bd83671$var$_batchIntersects.length = 0;
        }
        $cf10f6a70bd83671$var$_mesh.material = null;
        $cf10f6a70bd83671$var$_mesh.geometry.index = null;
        $cf10f6a70bd83671$var$_mesh.geometry.attributes = {};
        $cf10f6a70bd83671$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $cf10f6a70bd83671$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $cf10f6a70bd83671$var$_frustum.setFromProjectionMatrix($cf10f6a70bd83671$var$_matrix$1, renderer.coordinateSystem);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $cf10f6a70bd83671$var$_matrix$1.copy(this.matrixWorld).invert();
            $cf10f6a70bd83671$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($cf10f6a70bd83671$var$_matrix$1);
            $cf10f6a70bd83671$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($cf10f6a70bd83671$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $cf10f6a70bd83671$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $cf10f6a70bd83671$var$_sphere$2).applyMatrix4($cf10f6a70bd83671$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$cf10f6a70bd83671$var$_frustum.intersectsSphere($cf10f6a70bd83671$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $cf10f6a70bd83671$var$_temp.subVectors($cf10f6a70bd83671$var$_sphere$2.center, $cf10f6a70bd83671$var$_vector$5).dot($cf10f6a70bd83671$var$_forward);
                    $cf10f6a70bd83671$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $cf10f6a70bd83671$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $cf10f6a70bd83671$var$sortTransparent : $cf10f6a70bd83671$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $cf10f6a70bd83671$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $cf10f6a70bd83671$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $cf10f6a70bd83671$var$_sphere$2).applyMatrix4($cf10f6a70bd83671$var$_matrix$1);
                    culled = !$cf10f6a70bd83671$var$_frustum.intersectsSphere($cf10f6a70bd83671$var$_sphere$2);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
class $cf10f6a70bd83671$export$fbaaa33907730a0c extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $cf10f6a70bd83671$var$_vStart = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_vEnd = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_inverseMatrix$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_ray$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$a186db52eed6d40e();
const $cf10f6a70bd83671$var$_sphere$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
const $cf10f6a70bd83671$var$_intersectPointOnRay = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_intersectPointOnSegment = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$17d680238e50603e extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $cf10f6a70bd83671$export$b7be63a67df8959(), material = new $cf10f6a70bd83671$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $cf10f6a70bd83671$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $cf10f6a70bd83671$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $cf10f6a70bd83671$var$_vStart.distanceTo($cf10f6a70bd83671$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $cf10f6a70bd83671$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $cf10f6a70bd83671$var$_sphere$1.copy(geometry.boundingSphere);
        $cf10f6a70bd83671$var$_sphere$1.applyMatrix4(matrixWorld);
        $cf10f6a70bd83671$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($cf10f6a70bd83671$var$_sphere$1) === false) return;
        //
        $cf10f6a70bd83671$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $cf10f6a70bd83671$var$_ray$1.copy(raycaster.ray).applyMatrix4($cf10f6a70bd83671$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $cf10f6a70bd83671$var$checkIntersection(this, raycaster, $cf10f6a70bd83671$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $cf10f6a70bd83671$var$checkIntersection(this, raycaster, $cf10f6a70bd83671$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $cf10f6a70bd83671$var$checkIntersection(this, raycaster, $cf10f6a70bd83671$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $cf10f6a70bd83671$var$checkIntersection(this, raycaster, $cf10f6a70bd83671$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $cf10f6a70bd83671$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $cf10f6a70bd83671$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $cf10f6a70bd83671$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($cf10f6a70bd83671$var$_vStart, $cf10f6a70bd83671$var$_vEnd, $cf10f6a70bd83671$var$_intersectPointOnRay, $cf10f6a70bd83671$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $cf10f6a70bd83671$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($cf10f6a70bd83671$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $cf10f6a70bd83671$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $cf10f6a70bd83671$var$_start = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_end = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $cf10f6a70bd83671$export$ff1ed10fedfdd604 extends $cf10f6a70bd83671$export$17d680238e50603e {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $cf10f6a70bd83671$var$_start.fromBufferAttribute(positionAttribute, i);
                $cf10f6a70bd83671$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $cf10f6a70bd83671$var$_start.distanceTo($cf10f6a70bd83671$var$_end);
            }
            geometry.setAttribute('lineDistance', new $cf10f6a70bd83671$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $cf10f6a70bd83671$export$f85a24d745e4f17d extends $cf10f6a70bd83671$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $cf10f6a70bd83671$export$a178c45366ce5d6b extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $cf10f6a70bd83671$var$_inverseMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_ray = /*@__PURE__*/ new $cf10f6a70bd83671$export$a186db52eed6d40e();
const $cf10f6a70bd83671$var$_sphere = /*@__PURE__*/ new $cf10f6a70bd83671$export$805e8b72413ccaba();
const $cf10f6a70bd83671$var$_position$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$1c787534cb11aa3e extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $cf10f6a70bd83671$export$b7be63a67df8959(), material = new $cf10f6a70bd83671$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $cf10f6a70bd83671$var$_sphere.copy(geometry.boundingSphere);
        $cf10f6a70bd83671$var$_sphere.applyMatrix4(matrixWorld);
        $cf10f6a70bd83671$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($cf10f6a70bd83671$var$_sphere) === false) return;
        //
        $cf10f6a70bd83671$var$_inverseMatrix.copy(matrixWorld).invert();
        $cf10f6a70bd83671$var$_ray.copy(raycaster.ray).applyMatrix4($cf10f6a70bd83671$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $cf10f6a70bd83671$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $cf10f6a70bd83671$var$testPoint($cf10f6a70bd83671$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $cf10f6a70bd83671$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $cf10f6a70bd83671$var$testPoint($cf10f6a70bd83671$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $cf10f6a70bd83671$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $cf10f6a70bd83671$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $cf10f6a70bd83671$export$64b5c384219d3699();
        $cf10f6a70bd83671$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
class $cf10f6a70bd83671$export$6e09d1edf8d5a25c extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $cf10f6a70bd83671$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $cf10f6a70bd83671$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $cf10f6a70bd83671$export$68498d200b825382 extends $cf10f6a70bd83671$export$6e09d1edf8d5a25c {
    constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoFrameTexture = true;
    }
    update() {
    // overwrites `VideoTexture.update()` with an empty method since
    // this type of texture is updated via `setFrame()`.
    }
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
class $cf10f6a70bd83671$export$9270d786f73ce6fe extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.minFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $cf10f6a70bd83671$export$3466bac9141a5cc4 extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $cf10f6a70bd83671$export$5fe6b8e34b274fcb extends $cf10f6a70bd83671$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $cf10f6a70bd83671$export$9d9334239a5a5e06;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $cf10f6a70bd83671$export$d80173634de65bff extends $cf10f6a70bd83671$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $cf10f6a70bd83671$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $cf10f6a70bd83671$export$f7189e49152d1c13 extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
class $cf10f6a70bd83671$export$fc830aa069cc8c2f extends $cf10f6a70bd83671$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = $cf10f6a70bd83671$export$c1b6b5136be58045){
        if (format !== $cf10f6a70bd83671$export$c1b6b5136be58045 && format !== $cf10f6a70bd83671$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $cf10f6a70bd83671$export$c1b6b5136be58045) type = $cf10f6a70bd83671$export$c3c7fc4518ebba96;
        if (type === undefined && format === $cf10f6a70bd83671$export$1e113ac2d0905829) type = $cf10f6a70bd83671$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new $cf10f6a70bd83671$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $cf10f6a70bd83671$export$c977b3e384af9ae1() : new $cf10f6a70bd83671$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const mat = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $cf10f6a70bd83671$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $cf10f6a70bd83671$export$64b5c384219d3699();
        binormals[0] = new $cf10f6a70bd83671$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($cf10f6a70bd83671$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($cf10f6a70bd83671$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$3f87a931616cde04 extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $cf10f6a70bd83671$export$b1eedc9aab6300e8 extends $cf10f6a70bd83671$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $cf10f6a70bd83671$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $cf10f6a70bd83671$var$tmp = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$px = /*@__PURE__*/ new $cf10f6a70bd83671$var$CubicPoly();
const $cf10f6a70bd83671$var$py = /*@__PURE__*/ new $cf10f6a70bd83671$var$CubicPoly();
const $cf10f6a70bd83671$var$pz = /*@__PURE__*/ new $cf10f6a70bd83671$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$b9146b27c24b744c extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $cf10f6a70bd83671$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $cf10f6a70bd83671$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $cf10f6a70bd83671$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $cf10f6a70bd83671$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $cf10f6a70bd83671$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $cf10f6a70bd83671$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $cf10f6a70bd83671$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $cf10f6a70bd83671$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $cf10f6a70bd83671$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $cf10f6a70bd83671$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($cf10f6a70bd83671$var$px.calc(weight), $cf10f6a70bd83671$var$py.calc(weight), $cf10f6a70bd83671$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $cf10f6a70bd83671$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
// Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
/**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $cf10f6a70bd83671$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $cf10f6a70bd83671$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $cf10f6a70bd83671$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $cf10f6a70bd83671$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $cf10f6a70bd83671$var$QuadraticBezier(t, p0, p1, p2) {
    return $cf10f6a70bd83671$var$QuadraticBezierP0(t, p0) + $cf10f6a70bd83671$var$QuadraticBezierP1(t, p1) + $cf10f6a70bd83671$var$QuadraticBezierP2(t, p2);
}
//
function $cf10f6a70bd83671$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $cf10f6a70bd83671$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $cf10f6a70bd83671$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $cf10f6a70bd83671$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $cf10f6a70bd83671$var$CubicBezier(t, p0, p1, p2, p3) {
    return $cf10f6a70bd83671$var$CubicBezierP0(t, p0) + $cf10f6a70bd83671$var$CubicBezierP1(t, p1) + $cf10f6a70bd83671$var$CubicBezierP2(t, p2) + $cf10f6a70bd83671$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$e36650d36468bb39 extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), v1 = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), v2 = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), v3 = new $cf10f6a70bd83671$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($cf10f6a70bd83671$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $cf10f6a70bd83671$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$13d5f1c9525f246c extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $cf10f6a70bd83671$export$64b5c384219d3699(), v1 = new $cf10f6a70bd83671$export$64b5c384219d3699(), v2 = new $cf10f6a70bd83671$export$64b5c384219d3699(), v3 = new $cf10f6a70bd83671$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($cf10f6a70bd83671$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $cf10f6a70bd83671$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $cf10f6a70bd83671$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$ab2e07e76531a47e extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), v2 = new $cf10f6a70bd83671$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $cf10f6a70bd83671$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$1fdfd9d9cf487600 extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $cf10f6a70bd83671$export$64b5c384219d3699(), v2 = new $cf10f6a70bd83671$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $cf10f6a70bd83671$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$5938c4ee491a43ad extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), v1 = new $cf10f6a70bd83671$export$c977b3e384af9ae1(), v2 = new $cf10f6a70bd83671$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($cf10f6a70bd83671$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $cf10f6a70bd83671$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$bf3f4c7e459f90fc extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $cf10f6a70bd83671$export$64b5c384219d3699(), v1 = new $cf10f6a70bd83671$export$64b5c384219d3699(), v2 = new $cf10f6a70bd83671$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($cf10f6a70bd83671$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $cf10f6a70bd83671$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $cf10f6a70bd83671$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$d3bdd77da77afc1b extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $cf10f6a70bd83671$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($cf10f6a70bd83671$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $cf10f6a70bd83671$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $cf10f6a70bd83671$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $cf10f6a70bd83671$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $cf10f6a70bd83671$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $cf10f6a70bd83671$export$b9146b27c24b744c,
    CubicBezierCurve: $cf10f6a70bd83671$export$e36650d36468bb39,
    CubicBezierCurve3: $cf10f6a70bd83671$export$13d5f1c9525f246c,
    EllipseCurve: $cf10f6a70bd83671$export$3f87a931616cde04,
    LineCurve: $cf10f6a70bd83671$export$ab2e07e76531a47e,
    LineCurve3: $cf10f6a70bd83671$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $cf10f6a70bd83671$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $cf10f6a70bd83671$export$bf3f4c7e459f90fc,
    SplineCurve: $cf10f6a70bd83671$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $cf10f6a70bd83671$export$4aaf9b66af1bbf2c extends $cf10f6a70bd83671$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $cf10f6a70bd83671$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $cf10f6a70bd83671$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $cf10f6a70bd83671$export$4b2950bdac9b6ee9 extends $cf10f6a70bd83671$export$4aaf9b66af1bbf2c {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $cf10f6a70bd83671$export$ab2e07e76531a47e(this.currentPoint.clone(), new $cf10f6a70bd83671$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $cf10f6a70bd83671$export$5938c4ee491a43ad(this.currentPoint.clone(), new $cf10f6a70bd83671$export$c977b3e384af9ae1(aCPx, aCPy), new $cf10f6a70bd83671$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $cf10f6a70bd83671$export$e36650d36468bb39(this.currentPoint.clone(), new $cf10f6a70bd83671$export$c977b3e384af9ae1(aCP1x, aCP1y), new $cf10f6a70bd83671$export$c977b3e384af9ae1(aCP2x, aCP2y), new $cf10f6a70bd83671$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $cf10f6a70bd83671$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} aX - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} aY - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} aRadius - The radius of the arc.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} aX - The x coordinate of the center of the arc.
	 * @param {number} aY - The y coordinate of the center of the arc.
	 * @param {number} aRadius - The radius of the arc.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} aX - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} aY - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} xRadius - The radius of the ellipse in the x axis.
	 * @param {number} yRadius - The radius of the ellipse in the y axis.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {boolean} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} aX - The x coordinate of the absolute center of the ellipse.
	 * @param {number} aY - The y coordinate of the absolute center of the ellipse.
	 * @param {number} xRadius - The radius of the ellipse in the x axis.
	 * @param {number} yRadius - The radius of the ellipse in the y axis.
	 * @param {number} aStartAngle - The start angle in radians.
	 * @param {number} aEndAngle - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $cf10f6a70bd83671$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$6d839803fcd1882c extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0, -0.5),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0.5, 0),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $cf10f6a70bd83671$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const uv = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
        const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const curNormal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const prevNormal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for a capsule with given radii and height. It is constructed using a lathe.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments LatheGeometry
 */ class $cf10f6a70bd83671$export$41680e8551036033 extends $cf10f6a70bd83671$export$6d839803fcd1882c {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [length=1] - Length of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build the caps.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule.
	 */ constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $cf10f6a70bd83671$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$d5c0e8d607467193 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const uv = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$68f745719dbe5198 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {boolean} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {boolean} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
            const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 */ class $cf10f6a70bd83671$export$a7a48974f285c9b3 extends $cf10f6a70bd83671$export$68f745719dbe5198 {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {boolean} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {boolean} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$60e57a7d3f20ff65 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const b = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const c = new $cf10f6a70bd83671$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const b = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const c = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const centroid = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const uvA = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
            const uvB = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
            const uvC = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $cf10f6a70bd83671$export$c0babfeb8708fc9c extends $cf10f6a70bd83671$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $cf10f6a70bd83671$var$_v0 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v1$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_normal = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_triangle = /*@__PURE__*/ new $cf10f6a70bd83671$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$4730b1542707547f extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($cf10f6a70bd83671$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $cf10f6a70bd83671$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $cf10f6a70bd83671$var$_triangle.getNormal($cf10f6a70bd83671$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $cf10f6a70bd83671$var$_triangle[vertKeys[j]];
                    const v1 = $cf10f6a70bd83671$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($cf10f6a70bd83671$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $cf10f6a70bd83671$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $cf10f6a70bd83671$var$_v0.fromBufferAttribute(positionAttr, index0);
                $cf10f6a70bd83671$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($cf10f6a70bd83671$var$_v0.x, $cf10f6a70bd83671$var$_v0.y, $cf10f6a70bd83671$var$_v0.z);
                vertices.push($cf10f6a70bd83671$var$_v1$1.x, $cf10f6a70bd83671$var$_v1$1.y, $cf10f6a70bd83671$var$_v1$1.z);
            }
            this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $cf10f6a70bd83671$export$6428a7f2611ef1fa extends $cf10f6a70bd83671$export$4b2950bdac9b6ee9 {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $cf10f6a70bd83671$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $cf10f6a70bd83671$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * An implementation of the earcut polygon triangulation algorithm. The code
 * is a port of [mapbox/earcut]{@link https://github.com/mapbox/earcut mapbox/earcut} (v2.2.4).
 *
 * @hideconstructor
 */ class $cf10f6a70bd83671$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $cf10f6a70bd83671$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $cf10f6a70bd83671$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $cf10f6a70bd83671$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
}
// create a circular doubly linked list from polygon points in the specified winding order
function $cf10f6a70bd83671$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $cf10f6a70bd83671$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $cf10f6a70bd83671$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $cf10f6a70bd83671$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $cf10f6a70bd83671$var$equals(last, last.next)) {
        $cf10f6a70bd83671$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $cf10f6a70bd83671$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($cf10f6a70bd83671$var$equals(p, p.next) || $cf10f6a70bd83671$var$area(p.prev, p, p.next) === 0)) {
            $cf10f6a70bd83671$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $cf10f6a70bd83671$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $cf10f6a70bd83671$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $cf10f6a70bd83671$var$isEarHashed(ear, minX, minY, invSize) : $cf10f6a70bd83671$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $cf10f6a70bd83671$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $cf10f6a70bd83671$var$earcutLinked($cf10f6a70bd83671$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $cf10f6a70bd83671$var$cureLocalIntersections($cf10f6a70bd83671$var$filterPoints(ear), triangles, dim);
                $cf10f6a70bd83671$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $cf10f6a70bd83671$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $cf10f6a70bd83671$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($cf10f6a70bd83671$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $cf10f6a70bd83671$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $cf10f6a70bd83671$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $cf10f6a70bd83671$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($cf10f6a70bd83671$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $cf10f6a70bd83671$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $cf10f6a70bd83671$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $cf10f6a70bd83671$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $cf10f6a70bd83671$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $cf10f6a70bd83671$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $cf10f6a70bd83671$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $cf10f6a70bd83671$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $cf10f6a70bd83671$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $cf10f6a70bd83671$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $cf10f6a70bd83671$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $cf10f6a70bd83671$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$cf10f6a70bd83671$var$equals(a, b) && $cf10f6a70bd83671$var$intersects(a, p, p.next, b) && $cf10f6a70bd83671$var$locallyInside(a, b) && $cf10f6a70bd83671$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $cf10f6a70bd83671$var$removeNode(p);
            $cf10f6a70bd83671$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $cf10f6a70bd83671$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $cf10f6a70bd83671$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $cf10f6a70bd83671$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $cf10f6a70bd83671$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $cf10f6a70bd83671$var$filterPoints(a, a.next);
                c = $cf10f6a70bd83671$var$filterPoints(c, c.next);
                // run earcut on each half
                $cf10f6a70bd83671$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $cf10f6a70bd83671$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $cf10f6a70bd83671$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $cf10f6a70bd83671$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($cf10f6a70bd83671$var$getLeftmost(list));
    }
    queue.sort($cf10f6a70bd83671$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $cf10f6a70bd83671$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $cf10f6a70bd83671$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $cf10f6a70bd83671$var$eliminateHole(hole, outerNode) {
    const bridge = $cf10f6a70bd83671$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $cf10f6a70bd83671$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $cf10f6a70bd83671$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $cf10f6a70bd83671$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $cf10f6a70bd83671$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $cf10f6a70bd83671$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($cf10f6a70bd83671$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $cf10f6a70bd83671$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $cf10f6a70bd83671$var$sectorContainsSector(m, p) {
    return $cf10f6a70bd83671$var$area(m.prev, m, p.prev) < 0 && $cf10f6a70bd83671$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $cf10f6a70bd83671$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $cf10f6a70bd83671$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $cf10f6a70bd83671$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $cf10f6a70bd83671$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $cf10f6a70bd83671$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $cf10f6a70bd83671$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $cf10f6a70bd83671$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $cf10f6a70bd83671$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$cf10f6a70bd83671$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($cf10f6a70bd83671$var$locallyInside(a, b) && $cf10f6a70bd83671$var$locallyInside(b, a) && $cf10f6a70bd83671$var$middleInside(a, b) && // locally visible
    ($cf10f6a70bd83671$var$area(a.prev, a, b.prev) || $cf10f6a70bd83671$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $cf10f6a70bd83671$var$equals(a, b) && $cf10f6a70bd83671$var$area(a.prev, a, a.next) > 0 && $cf10f6a70bd83671$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $cf10f6a70bd83671$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $cf10f6a70bd83671$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $cf10f6a70bd83671$var$intersects(p1, q1, p2, q2) {
    const o1 = $cf10f6a70bd83671$var$sign($cf10f6a70bd83671$var$area(p1, q1, p2));
    const o2 = $cf10f6a70bd83671$var$sign($cf10f6a70bd83671$var$area(p1, q1, q2));
    const o3 = $cf10f6a70bd83671$var$sign($cf10f6a70bd83671$var$area(p2, q2, p1));
    const o4 = $cf10f6a70bd83671$var$sign($cf10f6a70bd83671$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $cf10f6a70bd83671$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $cf10f6a70bd83671$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $cf10f6a70bd83671$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $cf10f6a70bd83671$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $cf10f6a70bd83671$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $cf10f6a70bd83671$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $cf10f6a70bd83671$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $cf10f6a70bd83671$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $cf10f6a70bd83671$var$locallyInside(a, b) {
    return $cf10f6a70bd83671$var$area(a.prev, a, a.next) < 0 ? $cf10f6a70bd83671$var$area(a, b, a.next) >= 0 && $cf10f6a70bd83671$var$area(a, a.prev, b) >= 0 : $cf10f6a70bd83671$var$area(a, b, a.prev) < 0 || $cf10f6a70bd83671$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $cf10f6a70bd83671$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $cf10f6a70bd83671$var$splitPolygon(a, b) {
    const a2 = new $cf10f6a70bd83671$var$Node(a.i, a.x, a.y), b2 = new $cf10f6a70bd83671$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $cf10f6a70bd83671$var$insertNode(i, x, y, last) {
    const p = new $cf10f6a70bd83671$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $cf10f6a70bd83671$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $cf10f6a70bd83671$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $cf10f6a70bd83671$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $cf10f6a70bd83671$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $cf10f6a70bd83671$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $cf10f6a70bd83671$var$removeDupEndPts(contour);
        $cf10f6a70bd83671$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($cf10f6a70bd83671$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $cf10f6a70bd83671$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $cf10f6a70bd83671$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $cf10f6a70bd83671$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $cf10f6a70bd83671$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ /**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$598697a1efa63ca7 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {Object} [options={}] - The extrude settings.
	 * @param {number} [options.curveSegments=12] - Number of points on the curves.
	 * @param {number} [options.steps=1] - Number of points used for subdividing segments along the depth of the extruded spline.
	 * @param {number} [options.depth=1] - Depth to extrude the shape.
	 * @param {boolean} [options.bevelEnabled=true] - Whether to beveling to the shape or not.
	 * @param {number} [options.bevelThickness=0.2] - How deep into the original shape the bevel goes.
	 * @param {number} [options.bevelSize=bevelThickness-0.1] - Distance from the shape outline that the bevel extends.
	 * @param {number} [options.bevelOffset=0] - Distance from the shape outline that the bevel starts.
	 * @param {number} [options.bevelSegments=3] - Number of bevel layers.
	 * @param {Curve} [options.extrudePath=3] - A 3D spline path along which the shape should be extruded. Bevels not supported for path extrusion.
	 * @param {Object} [options.UVGenerator] - An object that provides UV generator functions for custom UV generation.
	 */ constructor(shapes = new $cf10f6a70bd83671$export$6428a7f2611ef1fa([
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0.5, 0.5),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(-0.5, 0.5),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(-0.5, -0.5),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $cf10f6a70bd83671$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $cf10f6a70bd83671$export$64b5c384219d3699();
                normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
                position2 = new $cf10f6a70bd83671$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$cf10f6a70bd83671$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($cf10f6a70bd83671$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $cf10f6a70bd83671$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $cf10f6a70bd83671$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $cf10f6a70bd83671$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $cf10f6a70bd83671$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $cf10f6a70bd83671$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $cf10f6a70bd83671$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $cf10f6a70bd83671$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(a_x, a_y),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(b_x, b_y),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $cf10f6a70bd83671$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $cf10f6a70bd83671$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $cf10f6a70bd83671$export$9567cc828c9535da extends $cf10f6a70bd83671$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$9567cc828c9535da(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $cf10f6a70bd83671$export$1954e2b809fe361e extends $cf10f6a70bd83671$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$967d831af31f69ce extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$68cb731f50f614af extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const uv = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$57a29a1c803e9065 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $cf10f6a70bd83671$export$6428a7f2611ef1fa([
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0, 0.5),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(-0.5, -0.5),
        new $cf10f6a70bd83671$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($cf10f6a70bd83671$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($cf10f6a70bd83671$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $cf10f6a70bd83671$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $cf10f6a70bd83671$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $cf10f6a70bd83671$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $cf10f6a70bd83671$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$1b417fc3b307a251 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $cf10f6a70bd83671$export$fb3f7adc68bd6e02 extends $cf10f6a70bd83671$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$a2312a2a1fa56495 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$77e9bfadfb9ab8c8 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const P1 = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const P2 = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const B = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const T = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const N = new $cf10f6a70bd83671$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $cf10f6a70bd83671$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$7897d9d48904490c extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $cf10f6a70bd83671$export$bf3f4c7e459f90fc(new $cf10f6a70bd83671$export$64b5c384219d3699(-1, -1, 0), new $cf10f6a70bd83671$export$64b5c384219d3699(-1, 1, 0), new $cf10f6a70bd83671$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const normal = new $cf10f6a70bd83671$export$64b5c384219d3699();
        const uv = new $cf10f6a70bd83671$export$c977b3e384af9ae1();
        let P = new $cf10f6a70bd83671$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $cf10f6a70bd83671$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $cf10f6a70bd83671$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $cf10f6a70bd83671$export$7897d9d48904490c(new $cf10f6a70bd83671$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $cf10f6a70bd83671$export$4b739da06d24892b extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $cf10f6a70bd83671$export$64b5c384219d3699();
            const end = new $cf10f6a70bd83671$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($cf10f6a70bd83671$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($cf10f6a70bd83671$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $cf10f6a70bd83671$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $cf10f6a70bd83671$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $cf10f6a70bd83671$export$33e43285f7406bd5,
    CapsuleGeometry: $cf10f6a70bd83671$export$41680e8551036033,
    CircleGeometry: $cf10f6a70bd83671$export$d5c0e8d607467193,
    ConeGeometry: $cf10f6a70bd83671$export$a7a48974f285c9b3,
    CylinderGeometry: $cf10f6a70bd83671$export$68f745719dbe5198,
    DodecahedronGeometry: $cf10f6a70bd83671$export$c0babfeb8708fc9c,
    EdgesGeometry: $cf10f6a70bd83671$export$4730b1542707547f,
    ExtrudeGeometry: $cf10f6a70bd83671$export$598697a1efa63ca7,
    IcosahedronGeometry: $cf10f6a70bd83671$export$9567cc828c9535da,
    LatheGeometry: $cf10f6a70bd83671$export$6d839803fcd1882c,
    OctahedronGeometry: $cf10f6a70bd83671$export$1954e2b809fe361e,
    PlaneGeometry: $cf10f6a70bd83671$export$967d831af31f69ce,
    PolyhedronGeometry: $cf10f6a70bd83671$export$60e57a7d3f20ff65,
    RingGeometry: $cf10f6a70bd83671$export$68cb731f50f614af,
    ShapeGeometry: $cf10f6a70bd83671$export$57a29a1c803e9065,
    SphereGeometry: $cf10f6a70bd83671$export$1b417fc3b307a251,
    TetrahedronGeometry: $cf10f6a70bd83671$export$fb3f7adc68bd6e02,
    TorusGeometry: $cf10f6a70bd83671$export$a2312a2a1fa56495,
    TorusKnotGeometry: $cf10f6a70bd83671$export$77e9bfadfb9ab8c8,
    TubeGeometry: $cf10f6a70bd83671$export$7897d9d48904490c,
    WireframeGeometry: $cf10f6a70bd83671$export$4b739da06d24892b
});
class $cf10f6a70bd83671$export$e8564da406055a3 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $cf10f6a70bd83671$export$21c421a2e1df9d22 extends $cf10f6a70bd83671$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $cf10f6a70bd83671$export$f2980790215acccd extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $cf10f6a70bd83671$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $cf10f6a70bd83671$export$2852a58ebdac27b8;
        this.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $cf10f6a70bd83671$export$28d04986c4269c9f extends $cf10f6a70bd83671$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $cf10f6a70bd83671$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $cf10f6a70bd83671$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $cf10f6a70bd83671$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $cf10f6a70bd83671$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $cf10f6a70bd83671$export$24c72f71cbaf0678 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $cf10f6a70bd83671$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $cf10f6a70bd83671$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $cf10f6a70bd83671$export$2852a58ebdac27b8;
        this.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        this.combine = $cf10f6a70bd83671$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $cf10f6a70bd83671$export$df893cf97e765622 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $cf10f6a70bd83671$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $cf10f6a70bd83671$export$2852a58ebdac27b8;
        this.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $cf10f6a70bd83671$export$bfe8c0a091f41ae7 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $cf10f6a70bd83671$export$2852a58ebdac27b8;
        this.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $cf10f6a70bd83671$export$5023a9a8114806b8 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $cf10f6a70bd83671$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $cf10f6a70bd83671$export$2852a58ebdac27b8;
        this.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $cf10f6a70bd83671$export$d93cc409a0768c5f();
        this.combine = $cf10f6a70bd83671$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $cf10f6a70bd83671$export$2698c22ec13825db extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $cf10f6a70bd83671$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $cf10f6a70bd83671$export$33e187ed002f2a19 extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
class $cf10f6a70bd83671$export$6f5fef6235ec12ee extends $cf10f6a70bd83671$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $cf10f6a70bd83671$export$2852a58ebdac27b8;
        this.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $cf10f6a70bd83671$export$327886a3efaeaebe extends $cf10f6a70bd83671$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $cf10f6a70bd83671$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $cf10f6a70bd83671$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $cf10f6a70bd83671$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $cf10f6a70bd83671$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $cf10f6a70bd83671$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $cf10f6a70bd83671$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $cf10f6a70bd83671$var$convertArray(times, track.times.constructor);
        track.values = $cf10f6a70bd83671$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $cf10f6a70bd83671$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $cf10f6a70bd83671$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $cf10f6a70bd83671$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $cf10f6a70bd83671$export$d875e029ef558d3;
    return targetClip;
}
const $cf10f6a70bd83671$export$7ee8caa573e71ad1 = {
    convertArray: $cf10f6a70bd83671$var$convertArray,
    isTypedArray: $cf10f6a70bd83671$var$isTypedArray,
    getKeyframeOrder: $cf10f6a70bd83671$var$getKeyframeOrder,
    sortedArray: $cf10f6a70bd83671$var$sortedArray,
    flattenJSON: $cf10f6a70bd83671$var$flattenJSON,
    subclip: $cf10f6a70bd83671$var$subclip,
    makeClipAdditive: $cf10f6a70bd83671$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $cf10f6a70bd83671$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $cf10f6a70bd83671$export$3646682e7a3959 extends $cf10f6a70bd83671$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $cf10f6a70bd83671$export$7f795934b84ab523,
            endingEnd: $cf10f6a70bd83671$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $cf10f6a70bd83671$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $cf10f6a70bd83671$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $cf10f6a70bd83671$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $cf10f6a70bd83671$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $cf10f6a70bd83671$export$a8e6009059f51e1a extends $cf10f6a70bd83671$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $cf10f6a70bd83671$export$fb9758ef7ef8d5cc extends $cf10f6a70bd83671$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $cf10f6a70bd83671$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $cf10f6a70bd83671$var$convertArray(times, this.TimeBufferType);
        this.values = $cf10f6a70bd83671$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $cf10f6a70bd83671$var$convertArray(track.times, Array),
                'values': $cf10f6a70bd83671$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $cf10f6a70bd83671$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $cf10f6a70bd83671$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $cf10f6a70bd83671$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $cf10f6a70bd83671$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $cf10f6a70bd83671$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $cf10f6a70bd83671$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $cf10f6a70bd83671$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $cf10f6a70bd83671$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $cf10f6a70bd83671$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($cf10f6a70bd83671$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $cf10f6a70bd83671$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$cf10f6a70bd83671$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$cf10f6a70bd83671$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$cf10f6a70bd83671$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $cf10f6a70bd83671$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $cf10f6a70bd83671$export$d3a344b98cf0b775 extends $cf10f6a70bd83671$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$cf10f6a70bd83671$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$cf10f6a70bd83671$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$cf10f6a70bd83671$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $cf10f6a70bd83671$export$995b32462a65e855;
$cf10f6a70bd83671$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$cf10f6a70bd83671$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $cf10f6a70bd83671$export$83444c5d885347d8 extends $cf10f6a70bd83671$export$b0e479f45b7006d6 {
}
$cf10f6a70bd83671$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $cf10f6a70bd83671$export$d45f0d1a4d9a9314 extends $cf10f6a70bd83671$export$b0e479f45b7006d6 {
}
$cf10f6a70bd83671$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $cf10f6a70bd83671$export$2db1cfb7923d931e extends $cf10f6a70bd83671$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$cf10f6a70bd83671$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $cf10f6a70bd83671$export$b8043f12b5aafbd7 extends $cf10f6a70bd83671$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $cf10f6a70bd83671$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$cf10f6a70bd83671$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$cf10f6a70bd83671$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $cf10f6a70bd83671$export$6ce41d4f3a8df9cd extends $cf10f6a70bd83671$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$cf10f6a70bd83671$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$cf10f6a70bd83671$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$cf10f6a70bd83671$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $cf10f6a70bd83671$export$995b32462a65e855;
$cf10f6a70bd83671$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$cf10f6a70bd83671$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $cf10f6a70bd83671$export$5ce2dcb4cc9f2bff extends $cf10f6a70bd83671$export$b0e479f45b7006d6 {
}
$cf10f6a70bd83671$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $cf10f6a70bd83671$export$d942c706bf23829c {
    constructor(name = '', duration = -1, tracks = [], blendMode = $cf10f6a70bd83671$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $cf10f6a70bd83671$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($cf10f6a70bd83671$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($cf10f6a70bd83671$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $cf10f6a70bd83671$var$getKeyframeOrder(times);
            times = $cf10f6a70bd83671$var$sortedArray(times, 1, order);
            values = $cf10f6a70bd83671$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $cf10f6a70bd83671$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $cf10f6a70bd83671$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $cf10f6a70bd83671$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($cf10f6a70bd83671$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($cf10f6a70bd83671$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($cf10f6a70bd83671$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $cf10f6a70bd83671$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $cf10f6a70bd83671$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $cf10f6a70bd83671$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $cf10f6a70bd83671$export$83444c5d885347d8;
        case 'quaternion':
            return $cf10f6a70bd83671$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $cf10f6a70bd83671$export$d3a344b98cf0b775;
        case 'string':
            return $cf10f6a70bd83671$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $cf10f6a70bd83671$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $cf10f6a70bd83671$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $cf10f6a70bd83671$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $cf10f6a70bd83671$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $cf10f6a70bd83671$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $cf10f6a70bd83671$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $cf10f6a70bd83671$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $cf10f6a70bd83671$export$3b0d6d7590275603 {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $cf10f6a70bd83671$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
		 * used in HTTP request.
		 *
		 * @type {Object}
		 */ this.requestHeader = {};
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $cf10f6a70bd83671$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $cf10f6a70bd83671$var$loading = {};
class $cf10f6a70bd83671$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $cf10f6a70bd83671$export$98435a25b5cf7b2b extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $cf10f6a70bd83671$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($cf10f6a70bd83671$var$loading[url] !== undefined) {
            $cf10f6a70bd83671$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $cf10f6a70bd83671$var$loading[url] = [];
        $cf10f6a70bd83671$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $cf10f6a70bd83671$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $cf10f6a70bd83671$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $cf10f6a70bd83671$export$94affb487e701bf2.add(url, data);
            const callbacks = $cf10f6a70bd83671$var$loading[url];
            delete $cf10f6a70bd83671$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $cf10f6a70bd83671$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $cf10f6a70bd83671$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $cf10f6a70bd83671$export$29711c7e14f61db extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $cf10f6a70bd83671$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $cf10f6a70bd83671$export$bd73ce947a280350 extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $cf10f6a70bd83671$export$3466bac9141a5cc4();
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $cf10f6a70bd83671$export$8905ce1c7a2464a1 extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $cf10f6a70bd83671$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $cf10f6a70bd83671$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            $cf10f6a70bd83671$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $cf10f6a70bd83671$export$2ec114afc2cf6308 extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $cf10f6a70bd83671$export$ee2e5a18258a4049();
        texture.colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa;
        const loader = new $cf10f6a70bd83671$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $cf10f6a70bd83671$export$792d8a18f2c55855 extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $cf10f6a70bd83671$export$b691f601014eabe1();
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $cf10f6a70bd83671$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $cf10f6a70bd83671$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $cf10f6a70bd83671$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $cf10f6a70bd83671$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $cf10f6a70bd83671$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $cf10f6a70bd83671$export$fd1bfc71f64c538c extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $cf10f6a70bd83671$export$5431306cf43de24a();
        const loader = new $cf10f6a70bd83671$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$6ecadb6ed240d696 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $cf10f6a70bd83671$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$8d474f55edbb9624 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $cf10f6a70bd83671$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $cf10f6a70bd83671$var$_projScreenMatrix$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_lightPositionWorld$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_lookTarget$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different ligth types.
 *
 * @abstract
 */ class $cf10f6a70bd83671$var$LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `PCFSoftShadowMap` and
		 * and it is recommended to increase softness by decreasing the shadow map size instead.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $cf10f6a70bd83671$export$c977b3e384af9ae1(512, 512);
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $cf10f6a70bd83671$export$35efe6f4c85463d2();
        this._frameExtents = new $cf10f6a70bd83671$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $cf10f6a70bd83671$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($cf10f6a70bd83671$var$_lightPositionWorld$1);
        $cf10f6a70bd83671$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($cf10f6a70bd83671$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $cf10f6a70bd83671$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($cf10f6a70bd83671$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($cf10f6a70bd83671$var$_projScreenMatrix$1);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $cf10f6a70bd83671$var$SpotLightShadow extends $cf10f6a70bd83671$var$LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $cf10f6a70bd83671$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $cf10f6a70bd83671$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$81495cbb73897362 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $cf10f6a70bd83671$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $cf10f6a70bd83671$var$SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $cf10f6a70bd83671$var$_projScreenMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_lightPositionWorld = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_lookTarget = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $cf10f6a70bd83671$var$PointLightShadow extends $cf10f6a70bd83671$var$LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $cf10f6a70bd83671$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
        this._frameExtents = new $cf10f6a70bd83671$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $cf10f6a70bd83671$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $cf10f6a70bd83671$export$64b5c384219d3699(1, 0, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(-1, 0, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, 1),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, -1),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 1, 0),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, 1),
            new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 * @param {number} [viewportIndex=0] - The viewport index.
	 */ updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $cf10f6a70bd83671$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($cf10f6a70bd83671$var$_lightPositionWorld);
        $cf10f6a70bd83671$var$_lookTarget.copy(camera.position);
        $cf10f6a70bd83671$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($cf10f6a70bd83671$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$cf10f6a70bd83671$var$_lightPositionWorld.x, -$cf10f6a70bd83671$var$_lightPositionWorld.y, -$cf10f6a70bd83671$var$_lightPositionWorld.z);
        $cf10f6a70bd83671$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($cf10f6a70bd83671$var$_projScreenMatrix);
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$4c9c1cb3f0b6f455 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $cf10f6a70bd83671$var$PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
/**
 * Camera that uses [orthographic projection]{@link https://en.wikipedia.org/wiki/Orthographic_projection}.
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $cf10f6a70bd83671$export$9ebf355ee4ed261b extends $cf10f6a70bd83671$export$79f141de891a5fed {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $cf10f6a70bd83671$var$DirectionalLightShadow extends $cf10f6a70bd83671$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $cf10f6a70bd83671$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$3fea33cc9972c868 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($cf10f6a70bd83671$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $cf10f6a70bd83671$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $cf10f6a70bd83671$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$af279bfef9ec2c96 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$61db2d908bbd2429 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $cf10f6a70bd83671$export$ba61ce607e1f405a {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $cf10f6a70bd83671$export$64b5c384219d3699());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $cf10f6a70bd83671$export$e7ef036e309b38d2 extends $cf10f6a70bd83671$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $cf10f6a70bd83671$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    /**
	 * Deserializes the light prove from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized light probe.
	 * @return {LightProbe} A reference to this light probe.
	 */ fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $cf10f6a70bd83671$export$3bd6d323353dcf96 extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $cf10f6a70bd83671$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $cf10f6a70bd83671$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $cf10f6a70bd83671$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $cf10f6a70bd83671$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $cf10f6a70bd83671$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $cf10f6a70bd83671$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $cf10f6a70bd83671$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $cf10f6a70bd83671$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    createMaterialFromType(type) {
        return $cf10f6a70bd83671$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $cf10f6a70bd83671$export$e8564da406055a3,
            SpriteMaterial: $cf10f6a70bd83671$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $cf10f6a70bd83671$export$21c421a2e1df9d22,
            ShaderMaterial: $cf10f6a70bd83671$export$83c7d75d550a8b0d,
            PointsMaterial: $cf10f6a70bd83671$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $cf10f6a70bd83671$export$28d04986c4269c9f,
            MeshStandardMaterial: $cf10f6a70bd83671$export$f2980790215acccd,
            MeshPhongMaterial: $cf10f6a70bd83671$export$24c72f71cbaf0678,
            MeshToonMaterial: $cf10f6a70bd83671$export$df893cf97e765622,
            MeshNormalMaterial: $cf10f6a70bd83671$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $cf10f6a70bd83671$export$5023a9a8114806b8,
            MeshDepthMaterial: $cf10f6a70bd83671$export$2698c22ec13825db,
            MeshDistanceMaterial: $cf10f6a70bd83671$export$33e187ed002f2a19,
            MeshBasicMaterial: $cf10f6a70bd83671$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $cf10f6a70bd83671$export$6f5fef6235ec12ee,
            LineDashedMaterial: $cf10f6a70bd83671$export$327886a3efaeaebe,
            LineBasicMaterial: $cf10f6a70bd83671$export$fbaaa33907730a0c,
            Material: $cf10f6a70bd83671$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $cf10f6a70bd83671$export$b5d2dc08d867e41a {
    static decodeText(array) {
        console.warn('THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.');
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $cf10f6a70bd83671$export$231f009cbe414146 extends $cf10f6a70bd83671$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $cf10f6a70bd83671$export$dc275bb96327833a extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $cf10f6a70bd83671$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $cf10f6a70bd83671$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $cf10f6a70bd83671$export$231f009cbe414146() : new $cf10f6a70bd83671$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $cf10f6a70bd83671$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $cf10f6a70bd83671$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $cf10f6a70bd83671$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $cf10f6a70bd83671$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $cf10f6a70bd83671$export$32ea87a8b54d744a : $cf10f6a70bd83671$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $cf10f6a70bd83671$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $cf10f6a70bd83671$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $cf10f6a70bd83671$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $cf10f6a70bd83671$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $cf10f6a70bd83671$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $cf10f6a70bd83671$export$40110c8505c5ad19 extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $cf10f6a70bd83671$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $cf10f6a70bd83671$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $cf10f6a70bd83671$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $cf10f6a70bd83671$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $cf10f6a70bd83671$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $cf10f6a70bd83671$var$Geometries) geometry = $cf10f6a70bd83671$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $cf10f6a70bd83671$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $cf10f6a70bd83671$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $cf10f6a70bd83671$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $cf10f6a70bd83671$export$99cc795e99919eed(onLoad);
            loader = new $cf10f6a70bd83671$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $cf10f6a70bd83671$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $cf10f6a70bd83671$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $cf10f6a70bd83671$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $cf10f6a70bd83671$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $cf10f6a70bd83671$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $cf10f6a70bd83671$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $cf10f6a70bd83671$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $cf10f6a70bd83671$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $cf10f6a70bd83671$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $cf10f6a70bd83671$export$b691f601014eabe1();
                else texture = new $cf10f6a70bd83671$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $cf10f6a70bd83671$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $cf10f6a70bd83671$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $cf10f6a70bd83671$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $cf10f6a70bd83671$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $cf10f6a70bd83671$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $cf10f6a70bd83671$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $cf10f6a70bd83671$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $cf10f6a70bd83671$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $cf10f6a70bd83671$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $cf10f6a70bd83671$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $cf10f6a70bd83671$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $cf10f6a70bd83671$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $cf10f6a70bd83671$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $cf10f6a70bd83671$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $cf10f6a70bd83671$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $cf10f6a70bd83671$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $cf10f6a70bd83671$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $cf10f6a70bd83671$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $cf10f6a70bd83671$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $cf10f6a70bd83671$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $cf10f6a70bd83671$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $cf10f6a70bd83671$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $cf10f6a70bd83671$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $cf10f6a70bd83671$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $cf10f6a70bd83671$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case 'LOD':
                object = new $cf10f6a70bd83671$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $cf10f6a70bd83671$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $cf10f6a70bd83671$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $cf10f6a70bd83671$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $cf10f6a70bd83671$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $cf10f6a70bd83671$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $cf10f6a70bd83671$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $cf10f6a70bd83671$export$b127726e56765aa4();
                break;
            default:
                object = new $cf10f6a70bd83671$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $cf10f6a70bd83671$export$e4dd07dff30cc924();
            }
        });
    }
}
const $cf10f6a70bd83671$var$TEXTURE_MAPPING = {
    UVMapping: $cf10f6a70bd83671$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $cf10f6a70bd83671$export$8759762a6477f2c4,
    CubeRefractionMapping: $cf10f6a70bd83671$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $cf10f6a70bd83671$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $cf10f6a70bd83671$export$ee99d97d46898098,
    CubeUVReflectionMapping: $cf10f6a70bd83671$export$dbf3e70ff37af79
};
const $cf10f6a70bd83671$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $cf10f6a70bd83671$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $cf10f6a70bd83671$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $cf10f6a70bd83671$export$c7e7c00b14f51a4f
};
const $cf10f6a70bd83671$var$TEXTURE_FILTER = {
    NearestFilter: $cf10f6a70bd83671$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $cf10f6a70bd83671$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $cf10f6a70bd83671$export$d2327c1afe5bfdf2,
    LinearFilter: $cf10f6a70bd83671$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $cf10f6a70bd83671$export$19a719f377145a13,
    LinearMipmapLinearFilter: $cf10f6a70bd83671$export$5d8599b6a933fb1b
};
class $cf10f6a70bd83671$export$52286b55c4a9b51f extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $cf10f6a70bd83671$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $cf10f6a70bd83671$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $cf10f6a70bd83671$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $cf10f6a70bd83671$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $cf10f6a70bd83671$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $cf10f6a70bd83671$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if ($cf10f6a70bd83671$var$_context === undefined) $cf10f6a70bd83671$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $cf10f6a70bd83671$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $cf10f6a70bd83671$var$_context = value;
    }
}
class $cf10f6a70bd83671$export$d8d5fccfbf47714e extends $cf10f6a70bd83671$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $cf10f6a70bd83671$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $cf10f6a70bd83671$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $cf10f6a70bd83671$var$_eyeRight = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_eyeLeft = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_projectionMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph]{@link https://en.wikipedia.org/wiki/Anaglyph_3D} or
 * [Parallax Barrier]{@link https://en.wikipedia.org/wiki/parallax_barrier}.
 */ class $cf10f6a70bd83671$export$bc7f73a1065bee0c {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $cf10f6a70bd83671$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $cf10f6a70bd83671$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $cf10f6a70bd83671$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($cf10f6a70bd83671$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $cf10f6a70bd83671$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $cf10f6a70bd83671$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $cf10f6a70bd83671$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $cf10f6a70bd83671$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($cf10f6a70bd83671$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $cf10f6a70bd83671$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $cf10f6a70bd83671$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($cf10f6a70bd83671$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($cf10f6a70bd83671$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($cf10f6a70bd83671$var$_eyeRight);
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $cf10f6a70bd83671$export$56b937d9e5581166 extends $cf10f6a70bd83671$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
        this.index = 0;
    }
}
class $cf10f6a70bd83671$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $cf10f6a70bd83671$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $cf10f6a70bd83671$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $cf10f6a70bd83671$var$now() {
    return performance.now();
}
const $cf10f6a70bd83671$var$_position$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_quaternion$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
const $cf10f6a70bd83671$var$_scale$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_orientation$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$8a1b810c6fde8951 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $cf10f6a70bd83671$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._clock = new $cf10f6a70bd83671$export$9735c82c4bae3302();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($cf10f6a70bd83671$var$_position$1, $cf10f6a70bd83671$var$_quaternion$1, $cf10f6a70bd83671$var$_scale$1);
        $cf10f6a70bd83671$var$_orientation$1.set(0, 0, -1).applyQuaternion($cf10f6a70bd83671$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($cf10f6a70bd83671$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($cf10f6a70bd83671$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($cf10f6a70bd83671$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($cf10f6a70bd83671$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($cf10f6a70bd83671$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($cf10f6a70bd83671$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($cf10f6a70bd83671$var$_position$1.x, $cf10f6a70bd83671$var$_position$1.y, $cf10f6a70bd83671$var$_position$1.z);
            listener.setOrientation($cf10f6a70bd83671$var$_orientation$1.x, $cf10f6a70bd83671$var$_orientation$1.y, $cf10f6a70bd83671$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API]{@link https://www.w3.org/TR/webaudio-1.1/}.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$153755f98d9861de extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            console.warn('THREE.Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $cf10f6a70bd83671$var$_position = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_quaternion = /*@__PURE__*/ new $cf10f6a70bd83671$export$23d6a54f0bbc85a3();
const $cf10f6a70bd83671$var$_scale = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_orientation = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $cf10f6a70bd83671$export$4b3e397ef1832507 extends $cf10f6a70bd83671$export$153755f98d9861de {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {Audio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {Audio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec]{@link https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype}
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {Audio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {Audio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {Audio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($cf10f6a70bd83671$var$_position, $cf10f6a70bd83671$var$_quaternion, $cf10f6a70bd83671$var$_scale);
        $cf10f6a70bd83671$var$_orientation.set(0, 0, 1).applyQuaternion($cf10f6a70bd83671$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($cf10f6a70bd83671$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($cf10f6a70bd83671$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($cf10f6a70bd83671$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($cf10f6a70bd83671$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($cf10f6a70bd83671$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($cf10f6a70bd83671$var$_orientation.z, endTime);
        } else {
            panner.setPosition($cf10f6a70bd83671$var$_position.x, $cf10f6a70bd83671$var$_position.y, $cf10f6a70bd83671$var$_position.z);
            panner.setOrientation($cf10f6a70bd83671$var$_orientation.x, $cf10f6a70bd83671$var$_orientation.y, $cf10f6a70bd83671$var$_orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $cf10f6a70bd83671$export$d47da1ef3d382827 {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {Audio} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $cf10f6a70bd83671$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $cf10f6a70bd83671$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $cf10f6a70bd83671$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $cf10f6a70bd83671$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $cf10f6a70bd83671$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $cf10f6a70bd83671$var$_reservedRe = new RegExp('[' + $cf10f6a70bd83671$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $cf10f6a70bd83671$var$_wordChar = '[^' + $cf10f6a70bd83671$var$_RESERVED_CHARS_RE + ']';
const $cf10f6a70bd83671$var$_wordCharOrDot = '[^' + $cf10f6a70bd83671$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $cf10f6a70bd83671$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $cf10f6a70bd83671$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $cf10f6a70bd83671$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $cf10f6a70bd83671$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $cf10f6a70bd83671$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $cf10f6a70bd83671$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $cf10f6a70bd83671$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $cf10f6a70bd83671$var$_wordChar);
const $cf10f6a70bd83671$var$_trackRe = new RegExp("^" + $cf10f6a70bd83671$var$_directoryRe + $cf10f6a70bd83671$var$_nodeRe + $cf10f6a70bd83671$var$_objectRe + $cf10f6a70bd83671$var$_propertyRe + '$');
const $cf10f6a70bd83671$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $cf10f6a70bd83671$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $cf10f6a70bd83671$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $cf10f6a70bd83671$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $cf10f6a70bd83671$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $cf10f6a70bd83671$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $cf10f6a70bd83671$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $cf10f6a70bd83671$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($cf10f6a70bd83671$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $cf10f6a70bd83671$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($cf10f6a70bd83671$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $cf10f6a70bd83671$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$cf10f6a70bd83671$export$7bf70fcf9f891893.Composite = $cf10f6a70bd83671$var$Composite;
$cf10f6a70bd83671$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$cf10f6a70bd83671$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$cf10f6a70bd83671$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._getValue_direct,
    $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._getValue_array,
    $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$cf10f6a70bd83671$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_direct,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_array,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $cf10f6a70bd83671$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $cf10f6a70bd83671$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $cf10f6a70bd83671$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $cf10f6a70bd83671$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $cf10f6a70bd83671$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $cf10f6a70bd83671$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $cf10f6a70bd83671$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $cf10f6a70bd83671$export$7f795934b84ab523,
            endingEnd: $cf10f6a70bd83671$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $cf10f6a70bd83671$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $cf10f6a70bd83671$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $cf10f6a70bd83671$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $cf10f6a70bd83671$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $cf10f6a70bd83671$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $cf10f6a70bd83671$export$24a4ccb5099273b5;
            settings.endingEnd = $cf10f6a70bd83671$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $cf10f6a70bd83671$export$24a4ccb5099273b5 : $cf10f6a70bd83671$export$7f795934b84ab523;
            else settings.endingStart = $cf10f6a70bd83671$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $cf10f6a70bd83671$export$24a4ccb5099273b5 : $cf10f6a70bd83671$export$7f795934b84ab523;
            else settings.endingEnd = $cf10f6a70bd83671$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $cf10f6a70bd83671$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $cf10f6a70bd83671$export$fbd77e5aefaa0102 extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $cf10f6a70bd83671$export$dfe0af1ca1acb78a($cf10f6a70bd83671$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $cf10f6a70bd83671$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $cf10f6a70bd83671$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $cf10f6a70bd83671$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $cf10f6a70bd83671$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $cf10f6a70bd83671$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $cf10f6a70bd83671$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $cf10f6a70bd83671$export$6b116d2fdfef087c extends $cf10f6a70bd83671$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isRenderTarget3D = true;
        this.depth = depth;
        this.texture = new $cf10f6a70bd83671$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $cf10f6a70bd83671$export$eb4d196341728d65 extends $cf10f6a70bd83671$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isRenderTargetArray = true;
        this.depth = depth;
        this.texture = new $cf10f6a70bd83671$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $cf10f6a70bd83671$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $cf10f6a70bd83671$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $cf10f6a70bd83671$var$_id = 0;
class $cf10f6a70bd83671$export$c412d5ffe1f79209 extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $cf10f6a70bd83671$var$_id++
        });
        this.name = '';
        this.usage = $cf10f6a70bd83671$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $cf10f6a70bd83671$export$25ec0e1af1389358 extends $cf10f6a70bd83671$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $cf10f6a70bd83671$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
const $cf10f6a70bd83671$var$_matrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
class $cf10f6a70bd83671$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $cf10f6a70bd83671$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $cf10f6a70bd83671$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    setFromXRController(controller) {
        $cf10f6a70bd83671$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($cf10f6a70bd83671$var$_matrix);
        return this;
    }
    intersectObject(object, recursive = true, intersects = []) {
        $cf10f6a70bd83671$var$intersect(object, this, intersects, recursive);
        intersects.sort($cf10f6a70bd83671$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$cf10f6a70bd83671$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($cf10f6a70bd83671$var$ascSort);
        return intersects;
    }
}
function $cf10f6a70bd83671$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $cf10f6a70bd83671$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$cf10f6a70bd83671$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates]{@link https://en.wikipedia.org/wiki/Spherical_coordinate_system}.
 */ class $cf10f6a70bd83671$export$d712cd887b4a00f7 {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $cf10f6a70bd83671$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($cf10f6a70bd83671$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates]{@link https://en.wikipedia.org/wiki/Cylindrical_coordinate_system}.
 */ class $cf10f6a70bd83671$export$287165bb2177f4fd {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $cf10f6a70bd83671$export$cbcc6560bf79fb38 {
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $cf10f6a70bd83671$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $cf10f6a70bd83671$var$_vector$4 = /*@__PURE__*/ new $cf10f6a70bd83671$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $cf10f6a70bd83671$export$60f553fa130f08b0 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $cf10f6a70bd83671$export$c977b3e384af9ae1(Infinity, Infinity), max = new $cf10f6a70bd83671$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $cf10f6a70bd83671$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $cf10f6a70bd83671$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $cf10f6a70bd83671$var$_startP = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_startEnd = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $cf10f6a70bd83671$export$e0ba6359f1954fd3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $cf10f6a70bd83671$export$64b5c384219d3699(), end = new $cf10f6a70bd83671$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $cf10f6a70bd83671$var$_startP.subVectors(point, this.start);
        $cf10f6a70bd83671$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $cf10f6a70bd83671$var$_startEnd.dot($cf10f6a70bd83671$var$_startEnd);
        const startEnd_startP = $cf10f6a70bd83671$var$_startEnd.dot($cf10f6a70bd83671$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $cf10f6a70bd83671$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closets point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target -  The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $cf10f6a70bd83671$var$_vector$3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$4b14638ffdd81e68 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(positions, 3));
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $cf10f6a70bd83671$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $cf10f6a70bd83671$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($cf10f6a70bd83671$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $cf10f6a70bd83671$var$_vector$2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_boneMatrix = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
const $cf10f6a70bd83671$var$_matrixWorldInv = /*@__PURE__*/ new $cf10f6a70bd83671$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$5277df3c9e732259 extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $cf10f6a70bd83671$var$getBoneList(object);
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $cf10f6a70bd83671$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $cf10f6a70bd83671$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $cf10f6a70bd83671$export$cbe7a62641830ebd(colors, 3));
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * he list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $cf10f6a70bd83671$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $cf10f6a70bd83671$var$_boneMatrix.multiplyMatrices($cf10f6a70bd83671$var$_matrixWorldInv, bone.matrixWorld);
                $cf10f6a70bd83671$var$_vector$2.setFromMatrixPosition($cf10f6a70bd83671$var$_boneMatrix);
                position.setXYZ(j, $cf10f6a70bd83671$var$_vector$2.x, $cf10f6a70bd83671$var$_vector$2.y, $cf10f6a70bd83671$var$_vector$2.z);
                $cf10f6a70bd83671$var$_boneMatrix.multiplyMatrices($cf10f6a70bd83671$var$_matrixWorldInv, bone.parent.matrixWorld);
                $cf10f6a70bd83671$var$_vector$2.setFromMatrixPosition($cf10f6a70bd83671$var$_boneMatrix);
                position.setXYZ(j + 1, $cf10f6a70bd83671$var$_vector$2.x, $cf10f6a70bd83671$var$_vector$2.y, $cf10f6a70bd83671$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $cf10f6a70bd83671$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$cf10f6a70bd83671$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $cf10f6a70bd83671$export$9a9291685b9e4023 extends $cf10f6a70bd83671$export$e176487c05830cc5 {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $cf10f6a70bd83671$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $cf10f6a70bd83671$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $cf10f6a70bd83671$var$_vector$1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_color1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$892596cec99bc70e();
const $cf10f6a70bd83671$var$_color2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$8dca15f13f4f8172 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $cf10f6a70bd83671$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $cf10f6a70bd83671$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $cf10f6a70bd83671$export$8dea267bd6bde117(colors, 3));
        this.add(new $cf10f6a70bd83671$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $cf10f6a70bd83671$var$_color1.copy(this.light.color);
            $cf10f6a70bd83671$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $cf10f6a70bd83671$var$_color1 : $cf10f6a70bd83671$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($cf10f6a70bd83671$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$3875d39926561055 extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $cf10f6a70bd83671$export$892596cec99bc70e(color1);
        color2 = new $cf10f6a70bd83671$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $cf10f6a70bd83671$export$cbe7a62641830ebd(colors, 3));
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$361430a10f533cd3 extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $cf10f6a70bd83671$export$892596cec99bc70e(color1);
        color2 = new $cf10f6a70bd83671$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $cf10f6a70bd83671$export$cbe7a62641830ebd(colors, 3));
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $cf10f6a70bd83671$var$_v1 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v2 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_v3 = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$f8e434dc14203e7d extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $cf10f6a70bd83671$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $cf10f6a70bd83671$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $cf10f6a70bd83671$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $cf10f6a70bd83671$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $cf10f6a70bd83671$var$_v3.subVectors($cf10f6a70bd83671$var$_v2, $cf10f6a70bd83671$var$_v1);
        this.lightPlane.lookAt($cf10f6a70bd83671$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($cf10f6a70bd83671$var$_v2);
        this.targetLine.scale.z = $cf10f6a70bd83671$var$_v3.length();
    }
}
const $cf10f6a70bd83671$var$_vector = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
const $cf10f6a70bd83671$var$_camera = /*@__PURE__*/ new $cf10f6a70bd83671$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example]{@link https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html}.
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$ed8e93f853cd795 extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $cf10f6a70bd83671$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $cf10f6a70bd83671$export$892596cec99bc70e(0xff0000);
        const colorUp = new $cf10f6a70bd83671$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $cf10f6a70bd83671$export$892596cec99bc70e(0xffffff);
        const colorCross = new $cf10f6a70bd83671$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $cf10f6a70bd83671$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        const nearZ = this.camera.coordinateSystem === $cf10f6a70bd83671$export$5a0e9190d10875d3 ? -1 : 0;
        // center / target
        $cf10f6a70bd83671$var$setPoint('c', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, 0, nearZ);
        $cf10f6a70bd83671$var$setPoint('t', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, 0, 1);
        // near
        $cf10f6a70bd83671$var$setPoint('n1', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -1, -1, nearZ);
        $cf10f6a70bd83671$var$setPoint('n2', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w, -1, nearZ);
        $cf10f6a70bd83671$var$setPoint('n3', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -1, h, nearZ);
        $cf10f6a70bd83671$var$setPoint('n4', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w, h, nearZ);
        // far
        $cf10f6a70bd83671$var$setPoint('f1', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -1, -1, 1);
        $cf10f6a70bd83671$var$setPoint('f2', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w, -1, 1);
        $cf10f6a70bd83671$var$setPoint('f3', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -1, h, 1);
        $cf10f6a70bd83671$var$setPoint('f4', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w, h, 1);
        // up
        $cf10f6a70bd83671$var$setPoint('u1', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w * 0.7, h * 1.1, nearZ);
        $cf10f6a70bd83671$var$setPoint('u2', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -0.7, h * 1.1, nearZ);
        $cf10f6a70bd83671$var$setPoint('u3', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, h * 2, nearZ);
        // cross
        $cf10f6a70bd83671$var$setPoint('cf1', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -1, 0, 1);
        $cf10f6a70bd83671$var$setPoint('cf2', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w, 0, 1);
        $cf10f6a70bd83671$var$setPoint('cf3', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, -1, 1);
        $cf10f6a70bd83671$var$setPoint('cf4', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, h, 1);
        $cf10f6a70bd83671$var$setPoint('cn1', pointMap, geometry, $cf10f6a70bd83671$var$_camera, -1, 0, nearZ);
        $cf10f6a70bd83671$var$setPoint('cn2', pointMap, geometry, $cf10f6a70bd83671$var$_camera, w, 0, nearZ);
        $cf10f6a70bd83671$var$setPoint('cn3', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, -1, nearZ);
        $cf10f6a70bd83671$var$setPoint('cn4', pointMap, geometry, $cf10f6a70bd83671$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $cf10f6a70bd83671$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $cf10f6a70bd83671$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $cf10f6a70bd83671$var$_vector.x, $cf10f6a70bd83671$var$_vector.y, $cf10f6a70bd83671$var$_vector.z);
    }
}
const $cf10f6a70bd83671$var$_box = /*@__PURE__*/ new $cf10f6a70bd83671$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$38a664cc862a6a9d extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setIndex(new $cf10f6a70bd83671$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $cf10f6a70bd83671$var$_box.setFromObject(this.object);
        if ($cf10f6a70bd83671$var$_box.isEmpty()) return;
        const min = $cf10f6a70bd83671$var$_box.min;
        const max = $cf10f6a70bd83671$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$ce39f4bb96c9a290 extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setIndex(new $cf10f6a70bd83671$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $cf10f6a70bd83671$export$a34fe8156c66e5d7 extends $cf10f6a70bd83671$export$17d680238e50603e {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $cf10f6a70bd83671$export$e176487c05830cc5(geometry2, new $cf10f6a70bd83671$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $cf10f6a70bd83671$var$_axis = /*@__PURE__*/ new $cf10f6a70bd83671$export$64b5c384219d3699();
let $cf10f6a70bd83671$var$_lineGeometry, $cf10f6a70bd83671$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $cf10f6a70bd83671$export$a3008e7bd8d2cbe7 extends $cf10f6a70bd83671$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, 1), origin = new $cf10f6a70bd83671$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($cf10f6a70bd83671$var$_lineGeometry === undefined) {
            $cf10f6a70bd83671$var$_lineGeometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
            $cf10f6a70bd83671$var$_lineGeometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $cf10f6a70bd83671$var$_coneGeometry = new $cf10f6a70bd83671$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $cf10f6a70bd83671$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $cf10f6a70bd83671$export$17d680238e50603e($cf10f6a70bd83671$var$_lineGeometry, new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $cf10f6a70bd83671$export$e176487c05830cc5($cf10f6a70bd83671$var$_coneGeometry, new $cf10f6a70bd83671$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $cf10f6a70bd83671$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($cf10f6a70bd83671$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $cf10f6a70bd83671$export$6c8303f35b8578fd extends $cf10f6a70bd83671$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $cf10f6a70bd83671$export$b7be63a67df8959();
        geometry.setAttribute('position', new $cf10f6a70bd83671$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $cf10f6a70bd83671$export$cbe7a62641830ebd(colors, 3));
        const material = new $cf10f6a70bd83671$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $cf10f6a70bd83671$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $cf10f6a70bd83671$export$148534a3c727230b {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $cf10f6a70bd83671$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $cf10f6a70bd83671$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $cf10f6a70bd83671$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $cf10f6a70bd83671$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $cf10f6a70bd83671$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $cf10f6a70bd83671$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $cf10f6a70bd83671$export$c7c44baae9d9f25f extends $cf10f6a70bd83671$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLDOMElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 */ connect() {}
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $cf10f6a70bd83671$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $cf10f6a70bd83671$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $cf10f6a70bd83671$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $cf10f6a70bd83671$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $cf10f6a70bd83671$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $cf10f6a70bd83671$export$988473390501ed4b:
            return width * height;
        case $cf10f6a70bd83671$export$cc09ccbf6d1ed449:
            return width * height;
        case $cf10f6a70bd83671$export$9053a81c4a69c289:
            return width * height * 2;
        case $cf10f6a70bd83671$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $cf10f6a70bd83671$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $cf10f6a70bd83671$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $cf10f6a70bd83671$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $cf10f6a70bd83671$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $cf10f6a70bd83671$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $cf10f6a70bd83671$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $cf10f6a70bd83671$export$21d1799c6d552fc0:
        case $cf10f6a70bd83671$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $cf10f6a70bd83671$export$d2a1a68024a3e56c:
        case $cf10f6a70bd83671$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $cf10f6a70bd83671$export$d0f0355bb3d948e4:
        case $cf10f6a70bd83671$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $cf10f6a70bd83671$export$19ada9bbb1af3573:
        case $cf10f6a70bd83671$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $cf10f6a70bd83671$export$6ab91af2d757aee7:
        case $cf10f6a70bd83671$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $cf10f6a70bd83671$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $cf10f6a70bd83671$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $cf10f6a70bd83671$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $cf10f6a70bd83671$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $cf10f6a70bd83671$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $cf10f6a70bd83671$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $cf10f6a70bd83671$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $cf10f6a70bd83671$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $cf10f6a70bd83671$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $cf10f6a70bd83671$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $cf10f6a70bd83671$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $cf10f6a70bd83671$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $cf10f6a70bd83671$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $cf10f6a70bd83671$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $cf10f6a70bd83671$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $cf10f6a70bd83671$export$ce40b115e188bc81:
        case $cf10f6a70bd83671$export$d279c5c4bac5121e:
        case $cf10f6a70bd83671$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $cf10f6a70bd83671$export$b1688df4c4c21670:
        case $cf10f6a70bd83671$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $cf10f6a70bd83671$export$d220f6ade8463a0f:
        case $cf10f6a70bd83671$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $cf10f6a70bd83671$var$getTextureTypeByteLength(type) {
    switch(type){
        case $cf10f6a70bd83671$export$2e8ce08d3f6f5e10:
        case $cf10f6a70bd83671$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $cf10f6a70bd83671$export$c63dc51868b06a9d:
        case $cf10f6a70bd83671$export$88572337f312435f:
        case $cf10f6a70bd83671$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $cf10f6a70bd83671$export$b3969b01faf587f2:
        case $cf10f6a70bd83671$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $cf10f6a70bd83671$export$c3c7fc4518ebba96:
        case $cf10f6a70bd83671$export$5c612977753abe2:
        case $cf10f6a70bd83671$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $cf10f6a70bd83671$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $cf10f6a70bd83671$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $cf10f6a70bd83671$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $cf10f6a70bd83671$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $cf10f6a70bd83671$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $cf10f6a70bd83671$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $cf10f6a70bd83671$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $cf10f6a70bd83671$export$3545e07a80636437;
}

/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
function $d5e9756b64e059ca$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5e9756b64e059ca$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $d5e9756b64e059ca$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5e9756b64e059ca$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $d5e9756b64e059ca$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5e9756b64e059ca$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5e9756b64e059ca$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5e9756b64e059ca$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5e9756b64e059ca$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $d5e9756b64e059ca$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $d5e9756b64e059ca$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $d5e9756b64e059ca$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5e9756b64e059ca$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $d5e9756b64e059ca$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5e9756b64e059ca$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5e9756b64e059ca$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5e9756b64e059ca$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5e9756b64e059ca$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5e9756b64e059ca$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $d5e9756b64e059ca$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5e9756b64e059ca$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5e9756b64e059ca$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $d5e9756b64e059ca$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5e9756b64e059ca$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5e9756b64e059ca$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5e9756b64e059ca$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5e9756b64e059ca$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5e9756b64e059ca$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5e9756b64e059ca$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5e9756b64e059ca$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5e9756b64e059ca$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $d5e9756b64e059ca$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5e9756b64e059ca$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5e9756b64e059ca$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5e9756b64e059ca$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $d5e9756b64e059ca$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5e9756b64e059ca$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5e9756b64e059ca$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $d5e9756b64e059ca$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $d5e9756b64e059ca$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5e9756b64e059ca$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $d5e9756b64e059ca$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5e9756b64e059ca$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $d5e9756b64e059ca$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5e9756b64e059ca$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5e9756b64e059ca$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5e9756b64e059ca$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $d5e9756b64e059ca$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5e9756b64e059ca$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5e9756b64e059ca$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5e9756b64e059ca$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $d5e9756b64e059ca$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5e9756b64e059ca$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5e9756b64e059ca$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5e9756b64e059ca$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5e9756b64e059ca$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5e9756b64e059ca$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5e9756b64e059ca$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $d5e9756b64e059ca$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5e9756b64e059ca$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5e9756b64e059ca$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $d5e9756b64e059ca$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5e9756b64e059ca$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $d5e9756b64e059ca$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5e9756b64e059ca$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $d5e9756b64e059ca$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $d5e9756b64e059ca$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5e9756b64e059ca$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5e9756b64e059ca$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5e9756b64e059ca$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5e9756b64e059ca$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5e9756b64e059ca$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5e9756b64e059ca$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5e9756b64e059ca$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5e9756b64e059ca$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5e9756b64e059ca$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5e9756b64e059ca$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5e9756b64e059ca$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $d5e9756b64e059ca$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5e9756b64e059ca$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5e9756b64e059ca$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5e9756b64e059ca$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $d5e9756b64e059ca$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5e9756b64e059ca$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5e9756b64e059ca$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5e9756b64e059ca$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5e9756b64e059ca$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5e9756b64e059ca$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5e9756b64e059ca$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5e9756b64e059ca$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $d5e9756b64e059ca$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5e9756b64e059ca$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5e9756b64e059ca$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5e9756b64e059ca$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5e9756b64e059ca$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5e9756b64e059ca$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5e9756b64e059ca$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5e9756b64e059ca$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5e9756b64e059ca$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $d5e9756b64e059ca$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5e9756b64e059ca$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $d5e9756b64e059ca$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5e9756b64e059ca$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5e9756b64e059ca$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5e9756b64e059ca$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5e9756b64e059ca$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5e9756b64e059ca$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5e9756b64e059ca$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5e9756b64e059ca$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5e9756b64e059ca$var$alphahash_fragment,
    alphahash_pars_fragment: $d5e9756b64e059ca$var$alphahash_pars_fragment,
    alphamap_fragment: $d5e9756b64e059ca$var$alphamap_fragment,
    alphamap_pars_fragment: $d5e9756b64e059ca$var$alphamap_pars_fragment,
    alphatest_fragment: $d5e9756b64e059ca$var$alphatest_fragment,
    alphatest_pars_fragment: $d5e9756b64e059ca$var$alphatest_pars_fragment,
    aomap_fragment: $d5e9756b64e059ca$var$aomap_fragment,
    aomap_pars_fragment: $d5e9756b64e059ca$var$aomap_pars_fragment,
    batching_pars_vertex: $d5e9756b64e059ca$var$batching_pars_vertex,
    batching_vertex: $d5e9756b64e059ca$var$batching_vertex,
    begin_vertex: $d5e9756b64e059ca$var$begin_vertex,
    beginnormal_vertex: $d5e9756b64e059ca$var$beginnormal_vertex,
    bsdfs: $d5e9756b64e059ca$var$bsdfs,
    iridescence_fragment: $d5e9756b64e059ca$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5e9756b64e059ca$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5e9756b64e059ca$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5e9756b64e059ca$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5e9756b64e059ca$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5e9756b64e059ca$var$clipping_planes_vertex,
    color_fragment: $d5e9756b64e059ca$var$color_fragment,
    color_pars_fragment: $d5e9756b64e059ca$var$color_pars_fragment,
    color_pars_vertex: $d5e9756b64e059ca$var$color_pars_vertex,
    color_vertex: $d5e9756b64e059ca$var$color_vertex,
    common: $d5e9756b64e059ca$var$common,
    cube_uv_reflection_fragment: $d5e9756b64e059ca$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5e9756b64e059ca$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5e9756b64e059ca$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5e9756b64e059ca$var$displacementmap_vertex,
    emissivemap_fragment: $d5e9756b64e059ca$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5e9756b64e059ca$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5e9756b64e059ca$var$colorspace_fragment,
    colorspace_pars_fragment: $d5e9756b64e059ca$var$colorspace_pars_fragment,
    envmap_fragment: $d5e9756b64e059ca$var$envmap_fragment,
    envmap_common_pars_fragment: $d5e9756b64e059ca$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5e9756b64e059ca$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5e9756b64e059ca$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5e9756b64e059ca$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5e9756b64e059ca$var$envmap_vertex,
    fog_vertex: $d5e9756b64e059ca$var$fog_vertex,
    fog_pars_vertex: $d5e9756b64e059ca$var$fog_pars_vertex,
    fog_fragment: $d5e9756b64e059ca$var$fog_fragment,
    fog_pars_fragment: $d5e9756b64e059ca$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5e9756b64e059ca$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $d5e9756b64e059ca$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5e9756b64e059ca$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5e9756b64e059ca$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5e9756b64e059ca$var$lights_pars_begin,
    lights_toon_fragment: $d5e9756b64e059ca$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5e9756b64e059ca$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5e9756b64e059ca$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5e9756b64e059ca$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5e9756b64e059ca$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5e9756b64e059ca$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5e9756b64e059ca$var$lights_fragment_begin,
    lights_fragment_maps: $d5e9756b64e059ca$var$lights_fragment_maps,
    lights_fragment_end: $d5e9756b64e059ca$var$lights_fragment_end,
    logdepthbuf_fragment: $d5e9756b64e059ca$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5e9756b64e059ca$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5e9756b64e059ca$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5e9756b64e059ca$var$logdepthbuf_vertex,
    map_fragment: $d5e9756b64e059ca$var$map_fragment,
    map_pars_fragment: $d5e9756b64e059ca$var$map_pars_fragment,
    map_particle_fragment: $d5e9756b64e059ca$var$map_particle_fragment,
    map_particle_pars_fragment: $d5e9756b64e059ca$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5e9756b64e059ca$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5e9756b64e059ca$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $d5e9756b64e059ca$var$morphinstance_vertex,
    morphcolor_vertex: $d5e9756b64e059ca$var$morphcolor_vertex,
    morphnormal_vertex: $d5e9756b64e059ca$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5e9756b64e059ca$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5e9756b64e059ca$var$morphtarget_vertex,
    normal_fragment_begin: $d5e9756b64e059ca$var$normal_fragment_begin,
    normal_fragment_maps: $d5e9756b64e059ca$var$normal_fragment_maps,
    normal_pars_fragment: $d5e9756b64e059ca$var$normal_pars_fragment,
    normal_pars_vertex: $d5e9756b64e059ca$var$normal_pars_vertex,
    normal_vertex: $d5e9756b64e059ca$var$normal_vertex,
    normalmap_pars_fragment: $d5e9756b64e059ca$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5e9756b64e059ca$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5e9756b64e059ca$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5e9756b64e059ca$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5e9756b64e059ca$var$iridescence_pars_fragment,
    opaque_fragment: $d5e9756b64e059ca$var$opaque_fragment,
    packing: $d5e9756b64e059ca$var$packing,
    premultiplied_alpha_fragment: $d5e9756b64e059ca$var$premultiplied_alpha_fragment,
    project_vertex: $d5e9756b64e059ca$var$project_vertex,
    dithering_fragment: $d5e9756b64e059ca$var$dithering_fragment,
    dithering_pars_fragment: $d5e9756b64e059ca$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5e9756b64e059ca$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5e9756b64e059ca$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5e9756b64e059ca$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5e9756b64e059ca$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5e9756b64e059ca$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5e9756b64e059ca$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5e9756b64e059ca$var$skinbase_vertex,
    skinning_pars_vertex: $d5e9756b64e059ca$var$skinning_pars_vertex,
    skinning_vertex: $d5e9756b64e059ca$var$skinning_vertex,
    skinnormal_vertex: $d5e9756b64e059ca$var$skinnormal_vertex,
    specularmap_fragment: $d5e9756b64e059ca$var$specularmap_fragment,
    specularmap_pars_fragment: $d5e9756b64e059ca$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5e9756b64e059ca$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5e9756b64e059ca$var$tonemapping_pars_fragment,
    transmission_fragment: $d5e9756b64e059ca$var$transmission_fragment,
    transmission_pars_fragment: $d5e9756b64e059ca$var$transmission_pars_fragment,
    uv_pars_fragment: $d5e9756b64e059ca$var$uv_pars_fragment,
    uv_pars_vertex: $d5e9756b64e059ca$var$uv_pars_vertex,
    uv_vertex: $d5e9756b64e059ca$var$uv_vertex,
    worldpos_vertex: $d5e9756b64e059ca$var$worldpos_vertex,
    background_vert: $d5e9756b64e059ca$var$vertex$h,
    background_frag: $d5e9756b64e059ca$var$fragment$h,
    backgroundCube_vert: $d5e9756b64e059ca$var$vertex$g,
    backgroundCube_frag: $d5e9756b64e059ca$var$fragment$g,
    cube_vert: $d5e9756b64e059ca$var$vertex$f,
    cube_frag: $d5e9756b64e059ca$var$fragment$f,
    depth_vert: $d5e9756b64e059ca$var$vertex$e,
    depth_frag: $d5e9756b64e059ca$var$fragment$e,
    distanceRGBA_vert: $d5e9756b64e059ca$var$vertex$d,
    distanceRGBA_frag: $d5e9756b64e059ca$var$fragment$d,
    equirect_vert: $d5e9756b64e059ca$var$vertex$c,
    equirect_frag: $d5e9756b64e059ca$var$fragment$c,
    linedashed_vert: $d5e9756b64e059ca$var$vertex$b,
    linedashed_frag: $d5e9756b64e059ca$var$fragment$b,
    meshbasic_vert: $d5e9756b64e059ca$var$vertex$a,
    meshbasic_frag: $d5e9756b64e059ca$var$fragment$a,
    meshlambert_vert: $d5e9756b64e059ca$var$vertex$9,
    meshlambert_frag: $d5e9756b64e059ca$var$fragment$9,
    meshmatcap_vert: $d5e9756b64e059ca$var$vertex$8,
    meshmatcap_frag: $d5e9756b64e059ca$var$fragment$8,
    meshnormal_vert: $d5e9756b64e059ca$var$vertex$7,
    meshnormal_frag: $d5e9756b64e059ca$var$fragment$7,
    meshphong_vert: $d5e9756b64e059ca$var$vertex$6,
    meshphong_frag: $d5e9756b64e059ca$var$fragment$6,
    meshphysical_vert: $d5e9756b64e059ca$var$vertex$5,
    meshphysical_frag: $d5e9756b64e059ca$var$fragment$5,
    meshtoon_vert: $d5e9756b64e059ca$var$vertex$4,
    meshtoon_frag: $d5e9756b64e059ca$var$fragment$4,
    points_vert: $d5e9756b64e059ca$var$vertex$3,
    points_frag: $d5e9756b64e059ca$var$fragment$3,
    shadow_vert: $d5e9756b64e059ca$var$vertex$2,
    shadow_frag: $d5e9756b64e059ca$var$fragment$2,
    sprite_vert: $d5e9756b64e059ca$var$vertex$1,
    sprite_frag: $d5e9756b64e059ca$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5e9756b64e059ca$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5e9756b64e059ca$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.specularmap,
            $d5e9756b64e059ca$export$6643083551874bf5.envmap,
            $d5e9756b64e059ca$export$6643083551874bf5.aomap,
            $d5e9756b64e059ca$export$6643083551874bf5.lightmap,
            $d5e9756b64e059ca$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.specularmap,
            $d5e9756b64e059ca$export$6643083551874bf5.envmap,
            $d5e9756b64e059ca$export$6643083551874bf5.aomap,
            $d5e9756b64e059ca$export$6643083551874bf5.lightmap,
            $d5e9756b64e059ca$export$6643083551874bf5.emissivemap,
            $d5e9756b64e059ca$export$6643083551874bf5.bumpmap,
            $d5e9756b64e059ca$export$6643083551874bf5.normalmap,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            $d5e9756b64e059ca$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.specularmap,
            $d5e9756b64e059ca$export$6643083551874bf5.envmap,
            $d5e9756b64e059ca$export$6643083551874bf5.aomap,
            $d5e9756b64e059ca$export$6643083551874bf5.lightmap,
            $d5e9756b64e059ca$export$6643083551874bf5.emissivemap,
            $d5e9756b64e059ca$export$6643083551874bf5.bumpmap,
            $d5e9756b64e059ca$export$6643083551874bf5.normalmap,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            $d5e9756b64e059ca$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.envmap,
            $d5e9756b64e059ca$export$6643083551874bf5.aomap,
            $d5e9756b64e059ca$export$6643083551874bf5.lightmap,
            $d5e9756b64e059ca$export$6643083551874bf5.emissivemap,
            $d5e9756b64e059ca$export$6643083551874bf5.bumpmap,
            $d5e9756b64e059ca$export$6643083551874bf5.normalmap,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            $d5e9756b64e059ca$export$6643083551874bf5.roughnessmap,
            $d5e9756b64e059ca$export$6643083551874bf5.metalnessmap,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            $d5e9756b64e059ca$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.aomap,
            $d5e9756b64e059ca$export$6643083551874bf5.lightmap,
            $d5e9756b64e059ca$export$6643083551874bf5.emissivemap,
            $d5e9756b64e059ca$export$6643083551874bf5.bumpmap,
            $d5e9756b64e059ca$export$6643083551874bf5.normalmap,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            $d5e9756b64e059ca$export$6643083551874bf5.gradientmap,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            $d5e9756b64e059ca$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.bumpmap,
            $d5e9756b64e059ca$export$6643083551874bf5.normalmap,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.points,
            $d5e9756b64e059ca$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.bumpmap,
            $d5e9756b64e059ca$export$6643083551874bf5.normalmap,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.sprite,
            $d5e9756b64e059ca$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            }
        },
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.common,
            $d5e9756b64e059ca$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
            $d5e9756b64e059ca$export$6643083551874bf5.lights,
            $d5e9756b64e059ca$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5e9756b64e059ca$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $cf10f6a70bd83671$export$8916ce6879271f43)([
        $d5e9756b64e059ca$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)()
            }
        }
    ]),
    vertexShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5e9756b64e059ca$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5e9756b64e059ca$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $d5e9756b64e059ca$var$_e1$1 = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$d93cc409a0768c5f)();
const $d5e9756b64e059ca$var$_m1$1 = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$2ae72fc923e5eb5)();
function $d5e9756b64e059ca$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $cf10f6a70bd83671$export$dbf3e70ff37af79))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(new (0, $cf10f6a70bd83671$export$33e43285f7406bd5)(1, 1, 1), new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $cf10f6a70bd83671$export$acda854380553452)($d5e9756b64e059ca$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5e9756b64e059ca$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5e9756b64e059ca$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $cf10f6a70bd83671$export$d9f0486e75b5ace),
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $d5e9756b64e059ca$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $d5e9756b64e059ca$var$_e1$1.x *= -1;
            $d5e9756b64e059ca$var$_e1$1.y *= -1;
            $d5e9756b64e059ca$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5e9756b64e059ca$var$_e1$1.y *= -1;
                $d5e9756b64e059ca$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($d5e9756b64e059ca$var$_m1$1.makeRotationFromEuler($d5e9756b64e059ca$var$_e1$1));
            boxMesh.material.toneMapped = (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $cf10f6a70bd83671$export$8d0a61916cc26abb);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(new (0, $cf10f6a70bd83671$export$967d831af31f69ce)(2, 2), new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $cf10f6a70bd83671$export$acda854380553452)($d5e9756b64e059ca$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5e9756b64e059ca$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5e9756b64e059ca$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $cf10f6a70bd83671$export$2ede184fc2998901),
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $cf10f6a70bd83671$export$8d0a61916cc26abb);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5e9756b64e059ca$var$_rgb, (0, $cf10f6a70bd83671$export$a630742c640528c1)(renderer));
        state.buffers.color.setClear($d5e9756b64e059ca$var$_rgb.r, $d5e9756b64e059ca$var$_rgb.g, $d5e9756b64e059ca$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $d5e9756b64e059ca$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $cf10f6a70bd83671$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5e9756b64e059ca$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5e9756b64e059ca$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $cf10f6a70bd83671$export$3f8bb04b555a363c) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $cf10f6a70bd83671$export$2697304443f382bc) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $cf10f6a70bd83671$export$f6d331659b644596) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $d5e9756b64e059ca$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $cf10f6a70bd83671$export$7ff5ac152ef991b0)(), viewNormalMatrix = new (0, $cf10f6a70bd83671$export$8ff26dafa08918)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5e9756b64e059ca$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $cf10f6a70bd83671$export$d64030b316d3b087)) texture.mapping = (0, $cf10f6a70bd83671$export$8759762a6477f2c4);
        else if (mapping === (0, $cf10f6a70bd83671$export$ee99d97d46898098)) texture.mapping = (0, $cf10f6a70bd83671$export$dc59f8aed047f61d);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $cf10f6a70bd83671$export$d64030b316d3b087) || mapping === (0, $cf10f6a70bd83671$export$ee99d97d46898098)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, $cf10f6a70bd83671$export$ac386671d651941e)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $d5e9756b64e059ca$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5e9756b64e059ca$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5e9756b64e059ca$var$MAX_SAMPLES = 20;
const $d5e9756b64e059ca$var$_flatCamera = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$9ebf355ee4ed261b)();
const $d5e9756b64e059ca$var$_clearColor = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$892596cec99bc70e)();
let $d5e9756b64e059ca$var$_oldTarget = null;
let $d5e9756b64e059ca$var$_oldActiveCubeFace = 0;
let $d5e9756b64e059ca$var$_oldActiveMipmapLevel = 0;
let $d5e9756b64e059ca$var$_oldXrEnabled = false;
// Golden Ratio
const $d5e9756b64e059ca$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5e9756b64e059ca$var$INV_PHI = 1 / $d5e9756b64e059ca$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5e9756b64e059ca$var$_axisDirections = [
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(-$d5e9756b64e059ca$var$PHI, $d5e9756b64e059ca$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)($d5e9756b64e059ca$var$PHI, $d5e9756b64e059ca$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(-$d5e9756b64e059ca$var$INV_PHI, 0, $d5e9756b64e059ca$var$PHI),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)($d5e9756b64e059ca$var$INV_PHI, 0, $d5e9756b64e059ca$var$PHI),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(0, $d5e9756b64e059ca$var$PHI, -$d5e9756b64e059ca$var$INV_PHI),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(0, $d5e9756b64e059ca$var$PHI, $d5e9756b64e059ca$var$INV_PHI),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(-1, 1, -1),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(1, 1, -1),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(-1, 1, 1),
    /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(1, 1, 1)
];
const $d5e9756b64e059ca$var$_origin = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5e9756b64e059ca$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene
	 * @param {number} sigma
	 * @param {number} near
	 * @param {number} far
	 * @param {Object} [options={}]
	 * @return {WebGLRenderTarget}
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $d5e9756b64e059ca$var$_origin } = options;
        $d5e9756b64e059ca$var$_oldTarget = this._renderer.getRenderTarget();
        $d5e9756b64e059ca$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5e9756b64e059ca$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5e9756b64e059ca$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 *
	 * @param {Texture} equirectangular
	 * @param {?WebGLRenderTarget} [renderTarget=null] - Optional render target.
	 * @return {WebGLRenderTarget}
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 *
	 * @param {Texture} cubemap
	 * @param {null} [renderTarget=null] - Optional render target.
	 * @return {WebGLRenderTarget}
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5e9756b64e059ca$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5e9756b64e059ca$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5e9756b64e059ca$var$_oldTarget, $d5e9756b64e059ca$var$_oldActiveCubeFace, $d5e9756b64e059ca$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $d5e9756b64e059ca$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $d5e9756b64e059ca$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $cf10f6a70bd83671$export$8759762a6477f2c4) || texture.mapping === (0, $cf10f6a70bd83671$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5e9756b64e059ca$var$_oldTarget = this._renderer.getRenderTarget();
        $d5e9756b64e059ca$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5e9756b64e059ca$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5e9756b64e059ca$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $cf10f6a70bd83671$export$8a72f490b25c56c8),
            minFilter: (0, $cf10f6a70bd83671$export$8a72f490b25c56c8),
            generateMipmaps: false,
            type: (0, $cf10f6a70bd83671$export$2697304443f382bc),
            format: (0, $cf10f6a70bd83671$export$3f8bb04b555a363c),
            colorSpace: (0, $cf10f6a70bd83671$export$42429b3acfb233a4),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5e9756b64e059ca$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5e9756b64e059ca$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5e9756b64e059ca$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5e9756b64e059ca$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5e9756b64e059ca$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $cf10f6a70bd83671$export$74e4ae24825f68d7)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5e9756b64e059ca$var$_clearColor);
        renderer.toneMapping = (0, $cf10f6a70bd83671$export$9fcb6b4294603b2);
        renderer.autoClear = false;
        const backgroundMaterial = new (0, $cf10f6a70bd83671$export$55cbcc9b622fe1f5)({
            name: 'PMREM.Background',
            side: (0, $cf10f6a70bd83671$export$d9f0486e75b5ace),
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(new (0, $cf10f6a70bd83671$export$33e43285f7406bd5)(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5e9756b64e059ca$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5e9756b64e059ca$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $cf10f6a70bd83671$export$8759762a6477f2c4) || texture.mapping === (0, $cf10f6a70bd83671$export$dc59f8aed047f61d);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5e9756b64e059ca$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5e9756b64e059ca$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5e9756b64e059ca$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5e9756b64e059ca$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5e9756b64e059ca$var$_axisDirections[(n - i - 1) % $d5e9756b64e059ca$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5e9756b64e059ca$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5e9756b64e059ca$var$MAX_SAMPLES;
        if (samples > $d5e9756b64e059ca$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5e9756b64e059ca$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5e9756b64e059ca$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5e9756b64e059ca$var$LOD_MIN ? lodOut - _lodMax + $d5e9756b64e059ca$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5e9756b64e059ca$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5e9756b64e059ca$var$_flatCamera);
    }
}
function $d5e9756b64e059ca$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5e9756b64e059ca$var$LOD_MIN + 1 + $d5e9756b64e059ca$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5e9756b64e059ca$var$LOD_MIN) sigma = $d5e9756b64e059ca$var$EXTRA_LOD_SIGMA[i - lodMax + $d5e9756b64e059ca$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $cf10f6a70bd83671$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $cf10f6a70bd83671$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $cf10f6a70bd83671$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $cf10f6a70bd83671$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5e9756b64e059ca$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5e9756b64e059ca$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $cf10f6a70bd83671$export$3c052beb2e51e23f)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $cf10f6a70bd83671$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5e9756b64e059ca$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5e9756b64e059ca$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5e9756b64e059ca$var$MAX_SAMPLES);
    const poleAxis = new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(0, 1, 0);
    const shaderMaterial = new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5e9756b64e059ca$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5e9756b64e059ca$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $cf10f6a70bd83671$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5e9756b64e059ca$var$_getEquirectMaterial() {
    return new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5e9756b64e059ca$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $cf10f6a70bd83671$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $d5e9756b64e059ca$var$_getCubemapMaterial() {
    return new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5e9756b64e059ca$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $cf10f6a70bd83671$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $d5e9756b64e059ca$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5e9756b64e059ca$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $cf10f6a70bd83671$export$d64030b316d3b087) || mapping === (0, $cf10f6a70bd83671$export$ee99d97d46898098);
            const isCubeMap = mapping === (0, $cf10f6a70bd83671$export$8759762a6477f2c4) || mapping === (0, $cf10f6a70bd83671$export$dc59f8aed047f61d);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $d5e9756b64e059ca$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5e9756b64e059ca$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5e9756b64e059ca$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $cf10f6a70bd83671$export$5b28268982f175ba)('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5e9756b64e059ca$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, $cf10f6a70bd83671$export$bc6f937da07eae17)(indices) ? (0, $cf10f6a70bd83671$export$7eb8c9fa25cd5bd6) : (0, $cf10f6a70bd83671$export$640a853f68025f2e))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5e9756b64e059ca$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $d5e9756b64e059ca$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5e9756b64e059ca$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $cf10f6a70bd83671$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $cf10f6a70bd83671$export$f6d331659b644596);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $d5e9756b64e059ca$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5e9756b64e059ca$var$emptyTexture = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$5431306cf43de24a)();
const $d5e9756b64e059ca$var$emptyShadowTexture = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$fc830aa069cc8c2f)(1, 1);
const $d5e9756b64e059ca$var$emptyArrayTexture = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$dfac6c8e811406a3)();
const $d5e9756b64e059ca$var$empty3dTexture = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$d7a3086320f856db)();
const $d5e9756b64e059ca$var$emptyCubeTexture = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$ee2e5a18258a4049)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5e9756b64e059ca$var$arrayCacheF32 = [];
const $d5e9756b64e059ca$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5e9756b64e059ca$var$mat4array = new Float32Array(16);
const $d5e9756b64e059ca$var$mat3array = new Float32Array(9);
const $d5e9756b64e059ca$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5e9756b64e059ca$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5e9756b64e059ca$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5e9756b64e059ca$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5e9756b64e059ca$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5e9756b64e059ca$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5e9756b64e059ca$var$allocTexUnits(textures, n) {
    let r = $d5e9756b64e059ca$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5e9756b64e059ca$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5e9756b64e059ca$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5e9756b64e059ca$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
function $d5e9756b64e059ca$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
function $d5e9756b64e059ca$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5e9756b64e059ca$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, elements)) return;
        $d5e9756b64e059ca$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5e9756b64e059ca$var$mat2array);
        $d5e9756b64e059ca$var$copyArray(cache, elements);
    }
}
function $d5e9756b64e059ca$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, elements)) return;
        $d5e9756b64e059ca$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5e9756b64e059ca$var$mat3array);
        $d5e9756b64e059ca$var$copyArray(cache, elements);
    }
}
function $d5e9756b64e059ca$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, elements)) return;
        $d5e9756b64e059ca$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5e9756b64e059ca$var$mat4array);
        $d5e9756b64e059ca$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5e9756b64e059ca$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5e9756b64e059ca$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
function $d5e9756b64e059ca$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
function $d5e9756b64e059ca$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5e9756b64e059ca$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5e9756b64e059ca$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
function $d5e9756b64e059ca$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
function $d5e9756b64e059ca$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5e9756b64e059ca$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5e9756b64e059ca$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5e9756b64e059ca$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $d5e9756b64e059ca$var$emptyShadowTexture.compareFunction = (0, $cf10f6a70bd83671$export$64eea11eb407ddf1); // #28670
        emptyTexture2D = $d5e9756b64e059ca$var$emptyShadowTexture;
    } else emptyTexture2D = $d5e9756b64e059ca$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $d5e9756b64e059ca$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5e9756b64e059ca$var$empty3dTexture, unit);
}
function $d5e9756b64e059ca$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5e9756b64e059ca$var$emptyCubeTexture, unit);
}
function $d5e9756b64e059ca$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5e9756b64e059ca$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5e9756b64e059ca$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5e9756b64e059ca$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5e9756b64e059ca$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5e9756b64e059ca$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5e9756b64e059ca$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5e9756b64e059ca$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5e9756b64e059ca$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5e9756b64e059ca$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5e9756b64e059ca$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5e9756b64e059ca$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5e9756b64e059ca$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5e9756b64e059ca$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5e9756b64e059ca$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5e9756b64e059ca$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5e9756b64e059ca$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5e9756b64e059ca$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5e9756b64e059ca$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5e9756b64e059ca$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5e9756b64e059ca$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5e9756b64e059ca$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5e9756b64e059ca$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5e9756b64e059ca$var$setValueV2fArray(gl, v) {
    const data = $d5e9756b64e059ca$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5e9756b64e059ca$var$setValueV3fArray(gl, v) {
    const data = $d5e9756b64e059ca$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5e9756b64e059ca$var$setValueV4fArray(gl, v) {
    const data = $d5e9756b64e059ca$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5e9756b64e059ca$var$setValueM2Array(gl, v) {
    const data = $d5e9756b64e059ca$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5e9756b64e059ca$var$setValueM3Array(gl, v) {
    const data = $d5e9756b64e059ca$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5e9756b64e059ca$var$setValueM4Array(gl, v) {
    const data = $d5e9756b64e059ca$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5e9756b64e059ca$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5e9756b64e059ca$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5e9756b64e059ca$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5e9756b64e059ca$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5e9756b64e059ca$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5e9756b64e059ca$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5e9756b64e059ca$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5e9756b64e059ca$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5e9756b64e059ca$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5e9756b64e059ca$var$allocTexUnits(textures, n);
    if (!$d5e9756b64e059ca$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5e9756b64e059ca$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5e9756b64e059ca$var$emptyTexture, units[i]);
}
function $d5e9756b64e059ca$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5e9756b64e059ca$var$allocTexUnits(textures, n);
    if (!$d5e9756b64e059ca$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5e9756b64e059ca$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5e9756b64e059ca$var$empty3dTexture, units[i]);
}
function $d5e9756b64e059ca$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5e9756b64e059ca$var$allocTexUnits(textures, n);
    if (!$d5e9756b64e059ca$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5e9756b64e059ca$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5e9756b64e059ca$var$emptyCubeTexture, units[i]);
}
function $d5e9756b64e059ca$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5e9756b64e059ca$var$allocTexUnits(textures, n);
    if (!$d5e9756b64e059ca$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5e9756b64e059ca$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5e9756b64e059ca$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5e9756b64e059ca$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5e9756b64e059ca$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5e9756b64e059ca$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5e9756b64e059ca$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5e9756b64e059ca$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5e9756b64e059ca$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5e9756b64e059ca$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5e9756b64e059ca$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5e9756b64e059ca$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5e9756b64e059ca$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5e9756b64e059ca$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5e9756b64e059ca$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5e9756b64e059ca$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5e9756b64e059ca$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5e9756b64e059ca$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5e9756b64e059ca$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5e9756b64e059ca$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5e9756b64e059ca$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5e9756b64e059ca$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5e9756b64e059ca$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5e9756b64e059ca$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $d5e9756b64e059ca$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5e9756b64e059ca$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $d5e9756b64e059ca$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5e9756b64e059ca$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5e9756b64e059ca$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5e9756b64e059ca$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5e9756b64e059ca$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5e9756b64e059ca$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5e9756b64e059ca$var$RePathPart.exec(path), matchEnd = $d5e9756b64e059ca$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5e9756b64e059ca$var$addUniform(container, subscript === undefined ? new $d5e9756b64e059ca$var$SingleUniform(id, activeInfo, addr) : new $d5e9756b64e059ca$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5e9756b64e059ca$var$StructuredUniform(id);
                $d5e9756b64e059ca$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5e9756b64e059ca$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5e9756b64e059ca$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5e9756b64e059ca$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $d5e9756b64e059ca$var$COMPLETION_STATUS_KHR = 0x91B1;
let $d5e9756b64e059ca$var$programIdCount = 0;
function $d5e9756b64e059ca$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $d5e9756b64e059ca$var$_m0 = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$8ff26dafa08918)();
function $d5e9756b64e059ca$var$getEncodingComponents(colorSpace) {
    (0, $cf10f6a70bd83671$export$5e6fd513f44698c)._getMatrix($d5e9756b64e059ca$var$_m0, (0, $cf10f6a70bd83671$export$5e6fd513f44698c).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$d5e9756b64e059ca$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(colorSpace)){
        case 0, $cf10f6a70bd83671$export$f197347d588c1b4a:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $cf10f6a70bd83671$export$8d0a61916cc26abb:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $d5e9756b64e059ca$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5e9756b64e059ca$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5e9756b64e059ca$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $d5e9756b64e059ca$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
function $d5e9756b64e059ca$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case 0, $cf10f6a70bd83671$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case 0, $cf10f6a70bd83671$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case 0, $cf10f6a70bd83671$export$932b3dd283d4a366:
            toneMappingName = 'Cineon';
            break;
        case 0, $cf10f6a70bd83671$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $cf10f6a70bd83671$export$212d53a513a325b2:
            toneMappingName = 'AgX';
            break;
        case 0, $cf10f6a70bd83671$export$f2863e1668a8e317:
            toneMappingName = 'Neutral';
            break;
        case 0, $cf10f6a70bd83671$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $d5e9756b64e059ca$var$_v0 = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$64b5c384219d3699)();
function $d5e9756b64e059ca$var$getLuminanceFunction() {
    (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getLuminanceCoefficients($d5e9756b64e059ca$var$_v0);
    const r = $d5e9756b64e059ca$var$_v0.x.toFixed(4);
    const g = $d5e9756b64e059ca$var$_v0.y.toFixed(4);
    const b = $d5e9756b64e059ca$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $d5e9756b64e059ca$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($d5e9756b64e059ca$var$filterEmptyLine).join('\n');
}
function $d5e9756b64e059ca$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5e9756b64e059ca$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5e9756b64e059ca$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5e9756b64e059ca$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5e9756b64e059ca$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5e9756b64e059ca$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5e9756b64e059ca$var$resolveIncludes(string) {
    return string.replace($d5e9756b64e059ca$var$includePattern, $d5e9756b64e059ca$var$includeReplacer);
}
const $d5e9756b64e059ca$var$shaderChunkMap = new Map();
function $d5e9756b64e059ca$var$includeReplacer(match, include) {
    let string = $d5e9756b64e059ca$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5e9756b64e059ca$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5e9756b64e059ca$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $d5e9756b64e059ca$var$resolveIncludes(string);
}
// Unroll Loops
const $d5e9756b64e059ca$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5e9756b64e059ca$var$unrollLoops(string) {
    return string.replace($d5e9756b64e059ca$var$unrollLoopPattern, $d5e9756b64e059ca$var$loopReplacer);
}
function $d5e9756b64e059ca$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5e9756b64e059ca$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $d5e9756b64e059ca$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $cf10f6a70bd83671$export$5813f879eee7cd88)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $cf10f6a70bd83671$export$a47c4b43a1be34f0)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $cf10f6a70bd83671$export$896ae1ade6c829c4)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $d5e9756b64e059ca$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $cf10f6a70bd83671$export$8759762a6477f2c4:
        case 0, $cf10f6a70bd83671$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $cf10f6a70bd83671$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $d5e9756b64e059ca$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $cf10f6a70bd83671$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $d5e9756b64e059ca$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $cf10f6a70bd83671$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $cf10f6a70bd83671$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $cf10f6a70bd83671$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $d5e9756b64e059ca$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5e9756b64e059ca$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5e9756b64e059ca$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5e9756b64e059ca$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5e9756b64e059ca$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5e9756b64e059ca$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5e9756b64e059ca$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $d5e9756b64e059ca$var$generateVertexExtensions(parameters);
    const customDefines = $d5e9756b64e059ca$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5e9756b64e059ca$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5e9756b64e059ca$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5e9756b64e059ca$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5e9756b64e059ca$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $d5e9756b64e059ca$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $cf10f6a70bd83671$export$9fcb6b4294603b2) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $cf10f6a70bd83671$export$9fcb6b4294603b2) ? $d5e9756b64e059ca$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $cf10f6a70bd83671$export$9fcb6b4294603b2) ? $d5e9756b64e059ca$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5e9756b64e059ca$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $d5e9756b64e059ca$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $d5e9756b64e059ca$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5e9756b64e059ca$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5e9756b64e059ca$var$resolveIncludes(vertexShader);
    vertexShader = $d5e9756b64e059ca$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5e9756b64e059ca$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5e9756b64e059ca$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5e9756b64e059ca$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5e9756b64e059ca$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5e9756b64e059ca$var$unrollLoops(vertexShader);
    fragmentShader = $d5e9756b64e059ca$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $cf10f6a70bd83671$export$f63012db5506e7dd) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $cf10f6a70bd83671$export$f63012db5506e7dd) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5e9756b64e059ca$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5e9756b64e059ca$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $d5e9756b64e059ca$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $d5e9756b64e059ca$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $d5e9756b64e059ca$var$WebGLUniforms(gl, program);
        cachedAttributes = $d5e9756b64e059ca$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $d5e9756b64e059ca$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5e9756b64e059ca$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5e9756b64e059ca$var$_id = 0;
class $d5e9756b64e059ca$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5e9756b64e059ca$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5e9756b64e059ca$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5e9756b64e059ca$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5e9756b64e059ca$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $cf10f6a70bd83671$export$89312ce47c0ca777)();
    const _customShaders = new $d5e9756b64e059ca$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $cf10f6a70bd83671$export$dbf3e70ff37af79) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5e9756b64e059ca$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $cf10f6a70bd83671$export$9fcb6b4294603b2);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $cf10f6a70bd83671$export$42429b3acfb233a4),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $cf10f6a70bd83671$export$9990ad26f9db5b2c),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $cf10f6a70bd83671$export$2852a58ebdac27b8),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $cf10f6a70bd83671$export$5b29a26d96ee6af0) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(material.map.colorSpace) === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(material.emissiveMap.colorSpace) === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $cf10f6a70bd83671$export$3b296b6f144d5b03),
            flipSided: material.side === (0, $cf10f6a70bd83671$export$d9f0486e75b5ace),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5e9756b64e059ca$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $cf10f6a70bd83671$export$d8ecdf8615bfea69).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5e9756b64e059ca$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5e9756b64e059ca$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5e9756b64e059ca$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5e9756b64e059ca$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5e9756b64e059ca$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5e9756b64e059ca$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5e9756b64e059ca$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5e9756b64e059ca$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5e9756b64e059ca$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5e9756b64e059ca$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5e9756b64e059ca$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5e9756b64e059ca$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        color: new (0, $cf10f6a70bd83671$export$892596cec99bc70e)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        direction: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        color: new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        color: new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        skyColor: new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(),
                        groundColor: new (0, $cf10f6a70bd83671$export$892596cec99bc70e)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(),
                        position: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        halfWidth: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)(),
                        halfHeight: new (0, $cf10f6a70bd83671$export$64b5c384219d3699)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5e9756b64e059ca$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5e9756b64e059ca$var$nextVersion = 0;
function $d5e9756b64e059ca$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5e9756b64e059ca$var$WebGLLights(extensions) {
    const cache = new $d5e9756b64e059ca$var$UniformsCache();
    const shadowCache = $d5e9756b64e059ca$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $cf10f6a70bd83671$export$64b5c384219d3699)());
    const vector3 = new (0, $cf10f6a70bd83671$export$64b5c384219d3699)();
    const matrix4 = new (0, $cf10f6a70bd83671$export$2ae72fc923e5eb5)();
    const matrix42 = new (0, $cf10f6a70bd83671$export$2ae72fc923e5eb5)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5e9756b64e059ca$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $d5e9756b64e059ca$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5e9756b64e059ca$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $d5e9756b64e059ca$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $d5e9756b64e059ca$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $d5e9756b64e059ca$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5e9756b64e059ca$var$WebGLRenderState(extensions) {
    const lights = new $d5e9756b64e059ca$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5e9756b64e059ca$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5e9756b64e059ca$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5e9756b64e059ca$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $d5e9756b64e059ca$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5e9756b64e059ca$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5e9756b64e059ca$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $cf10f6a70bd83671$export$35efe6f4c85463d2)();
    const _shadowMapSize = new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(), _viewportSize = new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)(), _viewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)(), _depthMaterial = new (0, $cf10f6a70bd83671$export$2698c22ec13825db)({
        depthPacking: (0, $cf10f6a70bd83671$export$8f910f4c4f73df11)
    }), _distanceMaterial = new (0, $cf10f6a70bd83671$export$33e187ed002f2a19)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $cf10f6a70bd83671$export$2ede184fc2998901)]: (0, $cf10f6a70bd83671$export$d9f0486e75b5ace),
        [(0, $cf10f6a70bd83671$export$d9f0486e75b5ace)]: (0, $cf10f6a70bd83671$export$2ede184fc2998901),
        [(0, $cf10f6a70bd83671$export$3b296b6f144d5b03)]: (0, $cf10f6a70bd83671$export$3b296b6f144d5b03)
    };
    const shadowMaterialVertical = new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5e9756b64e059ca$var$vertex,
        fragmentShader: $d5e9756b64e059ca$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $cf10f6a70bd83671$export$b7be63a67df8959)();
    fullScreenTri.setAttribute('position', new (0, $cf10f6a70bd83671$export$8dea267bd6bde117)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $cf10f6a70bd83671$export$5813f879eee7cd88);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $cf10f6a70bd83671$export$63b8d6b580fc65ba));
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== (0, $cf10f6a70bd83671$export$896ae1ade6c829c4) && this.type === (0, $cf10f6a70bd83671$export$896ae1ade6c829c4);
        const fromVSM = _previousType === (0, $cf10f6a70bd83671$export$896ae1ade6c829c4) && this.type !== (0, $cf10f6a70bd83671$export$896ae1ade6c829c4);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== (0, $cf10f6a70bd83671$export$896ae1ade6c829c4) ? {
                    minFilter: (0, $cf10f6a70bd83671$export$727aa5ec3fe39bf0),
                    magFilter: (0, $cf10f6a70bd83671$export$727aa5ec3fe39bf0)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $cf10f6a70bd83671$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $cf10f6a70bd83671$export$896ae1ade6c829c4)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $cf10f6a70bd83671$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $cf10f6a70bd83671$export$896ae1ade6c829c4)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $cf10f6a70bd83671$export$896ae1ade6c829c4)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $d5e9756b64e059ca$var$reversedFuncs = {
    [(0, $cf10f6a70bd83671$export$69025ce147cee220)]: (0, $cf10f6a70bd83671$export$7182eb52ea3b3f04),
    [(0, $cf10f6a70bd83671$export$eedccec66ab7ebe)]: (0, $cf10f6a70bd83671$export$c5e2c52991f30937),
    [(0, $cf10f6a70bd83671$export$a60d398fc7b7590e)]: (0, $cf10f6a70bd83671$export$2f843afa843d8916),
    [(0, $cf10f6a70bd83671$export$296f78a0b892f81a)]: (0, $cf10f6a70bd83671$export$7d7234c1240a1fc4),
    [(0, $cf10f6a70bd83671$export$7182eb52ea3b3f04)]: (0, $cf10f6a70bd83671$export$69025ce147cee220),
    [(0, $cf10f6a70bd83671$export$c5e2c52991f30937)]: (0, $cf10f6a70bd83671$export$eedccec66ab7ebe),
    [(0, $cf10f6a70bd83671$export$2f843afa843d8916)]: (0, $cf10f6a70bd83671$export$a60d398fc7b7590e),
    [(0, $cf10f6a70bd83671$export$7d7234c1240a1fc4)]: (0, $cf10f6a70bd83671$export$296f78a0b892f81a)
};
function $d5e9756b64e059ca$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
        let currentColorMask = null;
        const currentColorClear = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let reversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(value) {
                if (reversed !== value) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
                reversed = value;
            },
            getReversed: function() {
                return reversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (reversed) depthFunc = $d5e9756b64e059ca$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $cf10f6a70bd83671$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $cf10f6a70bd83671$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $cf10f6a70bd83671$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $cf10f6a70bd83671$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $cf10f6a70bd83671$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $cf10f6a70bd83671$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $cf10f6a70bd83671$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $cf10f6a70bd83671$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (reversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                reversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)().fromArray(scissorParam);
    const currentViewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $cf10f6a70bd83671$export$296f78a0b892f81a));
    setFlipSided(false);
    setCullFace((0, $cf10f6a70bd83671$export$b9a7b4fc5cb15f9b));
    enable(gl.CULL_FACE);
    setBlending((0, $cf10f6a70bd83671$export$63b8d6b580fc65ba));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $cf10f6a70bd83671$export$20183a0484ce21a0)]: gl.FUNC_ADD,
        [(0, $cf10f6a70bd83671$export$73e0df5177988548)]: gl.FUNC_SUBTRACT,
        [(0, $cf10f6a70bd83671$export$28e582859cbec660)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $cf10f6a70bd83671$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[0, $cf10f6a70bd83671$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [(0, $cf10f6a70bd83671$export$2110f05edf778d3d)]: gl.ZERO,
        [(0, $cf10f6a70bd83671$export$8805bad65e24940e)]: gl.ONE,
        [(0, $cf10f6a70bd83671$export$7fbe15b28d28cf52)]: gl.SRC_COLOR,
        [(0, $cf10f6a70bd83671$export$d5773124e86cf28c)]: gl.SRC_ALPHA,
        [(0, $cf10f6a70bd83671$export$c05e2a1fc8609506)]: gl.SRC_ALPHA_SATURATE,
        [(0, $cf10f6a70bd83671$export$ef5f2dd8ffac5574)]: gl.DST_COLOR,
        [(0, $cf10f6a70bd83671$export$a78aed1ca2a87192)]: gl.DST_ALPHA,
        [(0, $cf10f6a70bd83671$export$947829af9f2c17f6)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $cf10f6a70bd83671$export$11d468cc7f19e971)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $cf10f6a70bd83671$export$56b85b2686ab16)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $cf10f6a70bd83671$export$5d0fe17fd8773bac)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $cf10f6a70bd83671$export$7dd8f434fd59075)]: gl.CONSTANT_COLOR,
        [(0, $cf10f6a70bd83671$export$99c8d898a9afbcee)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $cf10f6a70bd83671$export$310cd2be38d13b56)]: gl.CONSTANT_ALPHA,
        [(0, $cf10f6a70bd83671$export$db77b8fbcf45dbf4)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $cf10f6a70bd83671$export$63b8d6b580fc65ba)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $cf10f6a70bd83671$export$eda4864c68df1fa2)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $cf10f6a70bd83671$export$20183a0484ce21a0) || currentBlendEquationAlpha !== (0, $cf10f6a70bd83671$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $cf10f6a70bd83671$export$20183a0484ce21a0);
                    currentBlendEquationAlpha = (0, $cf10f6a70bd83671$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $cf10f6a70bd83671$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $cf10f6a70bd83671$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $cf10f6a70bd83671$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $cf10f6a70bd83671$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $cf10f6a70bd83671$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $cf10f6a70bd83671$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case 0, $cf10f6a70bd83671$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $cf10f6a70bd83671$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $cf10f6a70bd83671$export$3b296b6f144d5b03) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $cf10f6a70bd83671$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $cf10f6a70bd83671$export$5b29a26d96ee6af0) && material.transparent === false ? setBlending((0, $cf10f6a70bd83671$export$63b8d6b580fc65ba)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $cf10f6a70bd83671$export$3237e1f2c1ea1f44)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $cf10f6a70bd83671$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $cf10f6a70bd83671$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5e9756b64e059ca$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $cf10f6a70bd83671$export$7094a064528c7fee)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $cf10f6a70bd83671$export$f197347d588c1b4a) : (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $cf10f6a70bd83671$export$c3c7fc4518ebba96) || depthType === (0, $cf10f6a70bd83671$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $cf10f6a70bd83671$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $cf10f6a70bd83671$export$c63dc51868b06a9d)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $cf10f6a70bd83671$export$c3c7fc4518ebba96) || depthType === (0, $cf10f6a70bd83671$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $cf10f6a70bd83671$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $cf10f6a70bd83671$export$c63dc51868b06a9d)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $cf10f6a70bd83671$export$727aa5ec3fe39bf0) && texture.minFilter !== (0, $cf10f6a70bd83671$export$8a72f490b25c56c8)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $cf10f6a70bd83671$export$533346c8e8dac0f5)]: _gl.REPEAT,
        [(0, $cf10f6a70bd83671$export$9d9334239a5a5e06)]: _gl.CLAMP_TO_EDGE,
        [(0, $cf10f6a70bd83671$export$c7e7c00b14f51a4f)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $cf10f6a70bd83671$export$727aa5ec3fe39bf0)]: _gl.NEAREST,
        [(0, $cf10f6a70bd83671$export$d129e38cf6feaa8c)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $cf10f6a70bd83671$export$d2327c1afe5bfdf2)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $cf10f6a70bd83671$export$8a72f490b25c56c8)]: _gl.LINEAR,
        [(0, $cf10f6a70bd83671$export$19a719f377145a13)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $cf10f6a70bd83671$export$5d8599b6a933fb1b)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $cf10f6a70bd83671$export$d9e2d19a747baaab)]: _gl.NEVER,
        [(0, $cf10f6a70bd83671$export$187b73a3e352c145)]: _gl.ALWAYS,
        [(0, $cf10f6a70bd83671$export$36bcf49c713b3eb7)]: _gl.LESS,
        [(0, $cf10f6a70bd83671$export$64eea11eb407ddf1)]: _gl.LEQUAL,
        [(0, $cf10f6a70bd83671$export$66f28d946fc6a0d5)]: _gl.EQUAL,
        [(0, $cf10f6a70bd83671$export$1cdcb70d53d65f61)]: _gl.GEQUAL,
        [(0, $cf10f6a70bd83671$export$155af022118f3a38)]: _gl.GREATER,
        [(0, $cf10f6a70bd83671$export$67ab95dde6bed156)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $cf10f6a70bd83671$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $cf10f6a70bd83671$export$8a72f490b25c56c8) || texture.magFilter === (0, $cf10f6a70bd83671$export$19a719f377145a13) || texture.magFilter === (0, $cf10f6a70bd83671$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $cf10f6a70bd83671$export$5d8599b6a933fb1b) || texture.minFilter === (0, $cf10f6a70bd83671$export$8a72f490b25c56c8) || texture.minFilter === (0, $cf10f6a70bd83671$export$19a719f377145a13) || texture.minFilter === (0, $cf10f6a70bd83671$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $cf10f6a70bd83671$export$5d8599b6a933fb1b))) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $cf10f6a70bd83671$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $cf10f6a70bd83671$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $cf10f6a70bd83671$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $cf10f6a70bd83671$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getPrimaries((0, $cf10f6a70bd83671$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $cf10f6a70bd83671$export$bfcb490c2dd3db51) ? null : (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $cf10f6a70bd83671$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $cf10f6a70bd83671$export$1e113ac2d0905829), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $cf10f6a70bd83671$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $cf10f6a70bd83671$export$cc8c3b705bb8e6e2)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $cf10f6a70bd83671$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $cf10f6a70bd83671$export$cc8c3b705bb8e6e2)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getPrimaries((0, $cf10f6a70bd83671$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $cf10f6a70bd83671$export$bfcb490c2dd3db51) ? null : (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $cf10f6a70bd83671$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $cf10f6a70bd83671$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $cf10f6a70bd83671$export$c1b6b5136be58045)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $cf10f6a70bd83671$export$1e113ac2d0905829)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $cf10f6a70bd83671$export$42429b3acfb233a4) && colorSpace !== (0, $cf10f6a70bd83671$export$bfcb490c2dd3db51)) {
            // sRGB
            if ((0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(colorSpace) === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $cf10f6a70bd83671$export$3f8bb04b555a363c) || type !== (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10)) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5e9756b64e059ca$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $cf10f6a70bd83671$export$bfcb490c2dd3db51)) {
        let extension;
        const transfer = (0, $cf10f6a70bd83671$export$5e6fd513f44698c).getTransfer(colorSpace);
        if (p === (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $cf10f6a70bd83671$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $cf10f6a70bd83671$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $cf10f6a70bd83671$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $cf10f6a70bd83671$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $cf10f6a70bd83671$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $cf10f6a70bd83671$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $cf10f6a70bd83671$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $cf10f6a70bd83671$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $cf10f6a70bd83671$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $cf10f6a70bd83671$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $cf10f6a70bd83671$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $cf10f6a70bd83671$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $cf10f6a70bd83671$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $cf10f6a70bd83671$export$cc09ccbf6d1ed449)) return gl.LUMINANCE;
        if (p === (0, $cf10f6a70bd83671$export$9053a81c4a69c289)) return gl.LUMINANCE_ALPHA;
        if (p === (0, $cf10f6a70bd83671$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $cf10f6a70bd83671$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $cf10f6a70bd83671$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $cf10f6a70bd83671$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $cf10f6a70bd83671$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $cf10f6a70bd83671$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $cf10f6a70bd83671$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $cf10f6a70bd83671$export$21d1799c6d552fc0) || p === (0, $cf10f6a70bd83671$export$afa304c3e981b668) || p === (0, $cf10f6a70bd83671$export$d2a1a68024a3e56c) || p === (0, $cf10f6a70bd83671$export$9a79c424327dacf9)) {
            if (transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $cf10f6a70bd83671$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $cf10f6a70bd83671$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $cf10f6a70bd83671$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $cf10f6a70bd83671$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $cf10f6a70bd83671$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $cf10f6a70bd83671$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $cf10f6a70bd83671$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $cf10f6a70bd83671$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $cf10f6a70bd83671$export$19ada9bbb1af3573) || p === (0, $cf10f6a70bd83671$export$d0f0355bb3d948e4) || p === (0, $cf10f6a70bd83671$export$b82296714358084c) || p === (0, $cf10f6a70bd83671$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $cf10f6a70bd83671$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $cf10f6a70bd83671$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $cf10f6a70bd83671$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $cf10f6a70bd83671$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $cf10f6a70bd83671$export$6ab91af2d757aee7) || p === (0, $cf10f6a70bd83671$export$7800993ef8106a6a) || p === (0, $cf10f6a70bd83671$export$23ed8300a860e7d8)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $cf10f6a70bd83671$export$6ab91af2d757aee7) || p === (0, $cf10f6a70bd83671$export$7800993ef8106a6a)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $cf10f6a70bd83671$export$23ed8300a860e7d8)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $cf10f6a70bd83671$export$dc5570b4a2b92d48) || p === (0, $cf10f6a70bd83671$export$68880cd325f8b2fb) || p === (0, $cf10f6a70bd83671$export$7d2c0be323373d95) || p === (0, $cf10f6a70bd83671$export$22b52da301fc3a3e) || p === (0, $cf10f6a70bd83671$export$c009e2cb4a66485e) || p === (0, $cf10f6a70bd83671$export$118fff5afa255b63) || p === (0, $cf10f6a70bd83671$export$120713c829ae0667) || p === (0, $cf10f6a70bd83671$export$c79eeabbf53313e9) || p === (0, $cf10f6a70bd83671$export$443cf6567cdd6424) || p === (0, $cf10f6a70bd83671$export$6573984fc9840780) || p === (0, $cf10f6a70bd83671$export$e7aee563f30091de) || p === (0, $cf10f6a70bd83671$export$2eb8634622ddeab7) || p === (0, $cf10f6a70bd83671$export$202b1ce7b5d25742) || p === (0, $cf10f6a70bd83671$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $cf10f6a70bd83671$export$dc5570b4a2b92d48)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $cf10f6a70bd83671$export$68880cd325f8b2fb)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $cf10f6a70bd83671$export$7d2c0be323373d95)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $cf10f6a70bd83671$export$22b52da301fc3a3e)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $cf10f6a70bd83671$export$c009e2cb4a66485e)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $cf10f6a70bd83671$export$118fff5afa255b63)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $cf10f6a70bd83671$export$120713c829ae0667)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $cf10f6a70bd83671$export$c79eeabbf53313e9)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $cf10f6a70bd83671$export$443cf6567cdd6424)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $cf10f6a70bd83671$export$6573984fc9840780)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $cf10f6a70bd83671$export$e7aee563f30091de)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $cf10f6a70bd83671$export$2eb8634622ddeab7)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $cf10f6a70bd83671$export$202b1ce7b5d25742)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $cf10f6a70bd83671$export$18ab77abd087e467)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $cf10f6a70bd83671$export$ce40b115e188bc81) || p === (0, $cf10f6a70bd83671$export$d279c5c4bac5121e) || p === (0, $cf10f6a70bd83671$export$cde52d17225fdbd3)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $cf10f6a70bd83671$export$ce40b115e188bc81)) return transfer === (0, $cf10f6a70bd83671$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $cf10f6a70bd83671$export$d279c5c4bac5121e)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $cf10f6a70bd83671$export$cde52d17225fdbd3)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $cf10f6a70bd83671$export$b1688df4c4c21670) || p === (0, $cf10f6a70bd83671$export$fc15e5d8261eed58) || p === (0, $cf10f6a70bd83671$export$d220f6ade8463a0f) || p === (0, $cf10f6a70bd83671$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $cf10f6a70bd83671$export$ce40b115e188bc81)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $cf10f6a70bd83671$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $cf10f6a70bd83671$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $cf10f6a70bd83671$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $cf10f6a70bd83671$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $d5e9756b64e059ca$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $d5e9756b64e059ca$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $d5e9756b64e059ca$var$WebXRDepthSensing {
    constructor(){
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $cf10f6a70bd83671$export$5431306cf43de24a)();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $cf10f6a70bd83671$export$83c7d75d550a8b0d)({
                    vertexShader: $d5e9756b64e059ca$var$_occlusion_vertex,
                    fragmentShader: $d5e9756b64e059ca$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $cf10f6a70bd83671$export$e176487c05830cc5)(new (0, $cf10f6a70bd83671$export$967d831af31f69ce)(20, 20), material);
            }
        }
        return this.mesh;
    }
    reset() {
        this.texture = null;
        this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $d5e9756b64e059ca$var$WebXRManager extends (0, $cf10f6a70bd83671$export$ec8b666c5fe2c75a) {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $d5e9756b64e059ca$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $cf10f6a70bd83671$export$c977b3e384af9ae1)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $cf10f6a70bd83671$export$74e4ae24825f68d7)();
        cameraL.viewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
        const cameraR = new (0, $cf10f6a70bd83671$export$74e4ae24825f68d7)();
        cameraR.viewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $cf10f6a70bd83671$export$56b937d9e5581166)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $cf10f6a70bd83671$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $cf10f6a70bd83671$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $cf10f6a70bd83671$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const useLayers = typeof XRWebGLBinding !== 'undefined' && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!useLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $cf10f6a70bd83671$export$3c052beb2e51e23f)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $cf10f6a70bd83671$export$3f8bb04b555a363c),
                        type: (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $cf10f6a70bd83671$export$1e113ac2d0905829) : (0, $cf10f6a70bd83671$export$c1b6b5136be58045);
                        depthType = attributes.stencil ? (0, $cf10f6a70bd83671$export$6c8ea339bfab1301) : (0, $cf10f6a70bd83671$export$c3c7fc4518ebba96);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $cf10f6a70bd83671$export$3c052beb2e51e23f)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $cf10f6a70bd83671$export$3f8bb04b555a363c),
                        type: (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10),
                        depthTexture: new (0, $cf10f6a70bd83671$export$fc830aa069cc8c2f)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $cf10f6a70bd83671$export$64b5c384219d3699)();
        const cameraRPos = new (0, $cf10f6a70bd83671$export$64b5c384219d3699)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $cf10f6a70bd83671$export$914076c8150813e5) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $cf10f6a70bd83671$export$74e4ae24825f68d7)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && glBinding) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5e9756b64e059ca$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $d5e9756b64e059ca$var$_e1 = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$d93cc409a0768c5f)();
const $d5e9756b64e059ca$var$_m1 = /*@__PURE__*/ new (0, $cf10f6a70bd83671$export$2ae72fc923e5eb5)();
function $d5e9756b64e059ca$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $cf10f6a70bd83671$export$a630742c640528c1)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $cf10f6a70bd83671$export$d9f0486e75b5ace)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $cf10f6a70bd83671$export$d9f0486e75b5ace)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $d5e9756b64e059ca$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $d5e9756b64e059ca$var$_e1.x *= -1;
            $d5e9756b64e059ca$var$_e1.y *= -1;
            $d5e9756b64e059ca$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $d5e9756b64e059ca$var$_e1.y *= -1;
                $d5e9756b64e059ca$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($d5e9756b64e059ca$var$_m1.makeRotationFromEuler($d5e9756b64e059ca$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $cf10f6a70bd83671$export$d9f0486e75b5ace)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5e9756b64e059ca$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $d5e9756b64e059ca$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = (0, $cf10f6a70bd83671$export$1033a2df66368859)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reverseDepthBuffer: reverseDepthBuffer = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = (0, $cf10f6a70bd83671$export$561f394b24edfcaa);
        // tone mapping
        this.toneMapping = (0, $cf10f6a70bd83671$export$9fcb6b4294603b2);
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
        const _currentScissor = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $cf10f6a70bd83671$export$892596cec99bc70e)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        const _scissor = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $cf10f6a70bd83671$export$35efe6f4c85463d2)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission render target scale
        this.transmissionResolutionScale = 1.0;
        // camera matrices cache
        const _currentProjectionMatrix = new (0, $cf10f6a70bd83671$export$2ae72fc923e5eb5)();
        const _projScreenMatrix = new (0, $cf10f6a70bd83671$export$2ae72fc923e5eb5)();
        const _vector3 = new (0, $cf10f6a70bd83671$export$64b5c384219d3699)();
        const _vector4 = new (0, $cf10f6a70bd83671$export$fa7daccca11cdbe3)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $cf10f6a70bd83671$export$3545e07a80636437)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5e9756b64e059ca$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $d5e9756b64e059ca$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $d5e9756b64e059ca$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $d5e9756b64e059ca$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $d5e9756b64e059ca$var$WebGLInfo(_gl);
            properties = new $d5e9756b64e059ca$var$WebGLProperties();
            textures = new $d5e9756b64e059ca$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5e9756b64e059ca$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5e9756b64e059ca$var$WebGLCubeUVMaps(_this);
            attributes = new $d5e9756b64e059ca$var$WebGLAttributes(_gl);
            bindingStates = new $d5e9756b64e059ca$var$WebGLBindingStates(_gl, attributes);
            geometries = new $d5e9756b64e059ca$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5e9756b64e059ca$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5e9756b64e059ca$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5e9756b64e059ca$var$WebGLClipping(properties);
            programCache = new $d5e9756b64e059ca$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5e9756b64e059ca$var$WebGLMaterials(_this, properties);
            renderLists = new $d5e9756b64e059ca$var$WebGLRenderLists();
            renderStates = new $d5e9756b64e059ca$var$WebGLRenderStates(extensions);
            background = new $d5e9756b64e059ca$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5e9756b64e059ca$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5e9756b64e059ca$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5e9756b64e059ca$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $d5e9756b64e059ca$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5e9756b64e059ca$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === (0, $cf10f6a70bd83671$export$c200e7d26f592f21) || targetFormat === (0, $cf10f6a70bd83671$export$1ba1c45f9f77d4d7) || targetFormat === (0, $cf10f6a70bd83671$export$aa92e870a709d190);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10) || targetType === (0, $cf10f6a70bd83671$export$c3c7fc4518ebba96) || targetType === (0, $cf10f6a70bd83671$export$c63dc51868b06a9d) || targetType === (0, $cf10f6a70bd83671$export$6c8ea339bfab1301) || targetType === (0, $cf10f6a70bd83671$export$b3969b01faf587f2) || targetType === (0, $cf10f6a70bd83671$export$18886f8ae33e90de);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $cf10f6a70bd83671$export$5b28268982f175ba)('THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $cf10f6a70bd83671$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $cf10f6a70bd83671$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $cf10f6a70bd83671$export$2ede184fc2998901);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $cf10f6a70bd83671$export$3b296b6f144d5b03);
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5e9756b64e059ca$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $cf10f6a70bd83671$export$3c052beb2e51e23f)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $cf10f6a70bd83671$export$2697304443f382bc) : (0, $cf10f6a70bd83671$export$2e8ce08d3f6f5e10),
                minFilter: (0, $cf10f6a70bd83671$export$5d8599b6a933fb1b),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $cf10f6a70bd83671$export$5e6fd513f44698c).workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $cf10f6a70bd83671$export$9fcb6b4294603b2);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === (0, $cf10f6a70bd83671$export$3b296b6f144d5b03) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $cf10f6a70bd83671$export$d9f0486e75b5ace);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $cf10f6a70bd83671$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $cf10f6a70bd83671$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $cf10f6a70bd83671$export$2ede184fc2998901);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $cf10f6a70bd83671$export$3b296b6f144d5b03);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $d5e9756b64e059ca$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $cf10f6a70bd83671$export$42429b3acfb233a4);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $cf10f6a70bd83671$export$9fcb6b4294603b2);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    (0, $cf10f6a70bd83671$export$5238391f68c729b)(_currentProjectionMatrix);
                    (0, $cf10f6a70bd83671$export$f8cf97d08da9bc86)(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $d5e9756b64e059ca$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5e9756b64e059ca$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel, layer);
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $cf10f6a70bd83671$export$d43f91ebeafb2c7)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                (0, $cf10f6a70bd83671$export$5b28268982f175ba)('WebGLRenderer: copyFramebufferToTexture function signature has changed.');
                position = arguments[0] || null;
                texture = arguments[1];
            }
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                (0, $cf10f6a70bd83671$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture function signature has changed.');
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                dstLevel = arguments[3] || 0;
                srcRegion = null;
            }
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $cf10f6a70bd83671$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                (0, $cf10f6a70bd83671$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture3D function signature has changed.');
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            // @deprecated, r170
            (0, $cf10f6a70bd83671$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return 0, $cf10f6a70bd83671$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorspace = (0, $cf10f6a70bd83671$export$5e6fd513f44698c)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $cf10f6a70bd83671$export$5e6fd513f44698c)._getUnpackColorSpace();
    }
}


const $e099036f3e0c3fd4$export$b2defa77b0ee83d8 = {
    minItems: 36,
    maxItems: 40,
    initialLoadCount: 12,
    lazyLoadBatchSize: 4,
    lazyLoadDelay: 180,
    duplicateTextureUniqueMax: 1,
    duplicateTextureStrictMinPoolSize: 28,
    duplicateTextureStrictMax: 2,
    duplicateTextureRelaxedMax: 3,
    selection: 'first',
    seed: 'floema-hero',
    preferredFormats: [
        'webp',
        'avif'
    ]
};
const $e099036f3e0c3fd4$var$TAU = Math.PI * 2;
function $e099036f3e0c3fd4$export$e5be90d95559fc20(image, index = 0, options = {}) {
    const preferredFormats = options.preferredFormats ?? $e099036f3e0c3fd4$export$b2defa77b0ee83d8.preferredFormats;
    if (typeof image === 'string') return {
        id: `image-${index}`,
        src: image,
        fallbackSrc: image,
        srcset: '',
        sizes: '',
        alt: '',
        width: undefined,
        height: undefined,
        textureKey: image,
        raw: image
    };
    const sources = image?.sources ?? {};
    const topLevelSources = {
        avif: image?.avif,
        webp: image?.webp
    };
    const sourceCandidates = {
        ...sources,
        ...topLevelSources
    };
    const preferredSource = preferredFormats.map((format)=>sourceCandidates[format]).find(Boolean);
    const fallbackSrc = image?.src ?? preferredSource ?? sourceCandidates.jpg ?? sourceCandidates.jpeg ?? sourceCandidates.png ?? '';
    const src = preferredSource ?? fallbackSrc;
    const srcset = image?.srcset ?? sourceCandidates.srcset ?? '';
    const sizes = image?.sizes ?? '';
    const textureKey = [
        src,
        srcset,
        sizes
    ].filter(Boolean).join('|');
    return {
        id: image?.id ?? `image-${index}`,
        src: src,
        fallbackSrc: fallbackSrc,
        srcset: srcset,
        sizes: sizes,
        alt: image?.alt ?? '',
        width: image?.width,
        height: image?.height,
        textureKey: textureKey,
        raw: image
    };
}
function $e099036f3e0c3fd4$export$54b61e86a3412b8d(backendImages = [], options = {}) {
    const config = $e099036f3e0c3fd4$var$normalizeConfig(options);
    const resources = $e099036f3e0c3fd4$var$avoidPreferredSourceCollisions(backendImages.map((image, index)=>({
            ...$e099036f3e0c3fd4$export$e5be90d95559fc20(image, index, config),
            sourceIndex: index
        })).filter((resource)=>resource.src));
    if (resources.length === 0) return [];
    const selectedResources = $e099036f3e0c3fd4$var$selectResources(resources, config);
    const targetCount = selectedResources.length < config.minItems ? config.minItems : selectedResources.length;
    const sceneResources = [];
    const initialIndexSet = $e099036f3e0c3fd4$var$getDistributedInitialIndexSet(targetCount, config.initialLoadCount);
    for(let index = 0; index < targetCount; index += 1)sceneResources.push(selectedResources[index % selectedResources.length]);
    return sceneResources.map((resource, slotIndex)=>{
        const duplicateIndex = Math.floor(slotIndex / selectedResources.length);
        const random = $e099036f3e0c3fd4$var$createRandom(`${config.seed}:${resource.textureKey}:${slotIndex}`);
        const transform = $e099036f3e0c3fd4$var$createSceneTransform(slotIndex, sceneResources.length, random, resource);
        return {
            id: `${resource.id}--slot-${slotIndex}`,
            sourceId: resource.id,
            sourceIndex: resource.sourceIndex,
            slotIndex: slotIndex,
            duplicateIndex: duplicateIndex,
            isDuplicate: duplicateIndex > 0,
            textureKey: resource.textureKey,
            resource: resource,
            loadPriority: initialIndexSet.has(slotIndex) ? 'initial' : 'lazy',
            ...transform
        };
    });
}
function $e099036f3e0c3fd4$export$db802ba6b23bef39(sceneImages = [], options = {}) {
    const initialLoadCount = Math.max(1, Math.floor(options.initialLoadCount ?? $e099036f3e0c3fd4$export$b2defa77b0ee83d8.initialLoadCount));
    const lazyLoadBatchSize = Math.max(1, Math.floor(options.lazyLoadBatchSize ?? $e099036f3e0c3fd4$export$b2defa77b0ee83d8.lazyLoadBatchSize));
    const initialIndexSet = $e099036f3e0c3fd4$var$getDistributedInitialIndexSet(sceneImages.length, initialLoadCount);
    const initial = [];
    const lazyItems = [];
    const lazy = [];
    sceneImages.forEach((item, index)=>{
        if (initialIndexSet.has(index)) initial.push(item);
        else lazyItems.push(item);
    });
    for(let index = 0; index < lazyItems.length; index += lazyLoadBatchSize)lazy.push(lazyItems.slice(index, index + lazyLoadBatchSize));
    return {
        initial: initial,
        lazy: lazy
    };
}
function $e099036f3e0c3fd4$var$getDistributedInitialIndexSet(count, initialLoadCount) {
    const total = Math.max(0, Math.floor(count));
    const target = Math.min(total, Math.max(1, Math.floor(initialLoadCount ?? $e099036f3e0c3fd4$export$b2defa77b0ee83d8.initialLoadCount)));
    const selected = new Set();
    if (!total) return selected;
    for(let step = 0; step < target; step += 1){
        let index = Math.min(total - 1, Math.floor(step * total / target));
        while(selected.has(index) && selected.size < target)index = (index + 1) % total;
        selected.add(index);
    }
    return selected;
}
function $e099036f3e0c3fd4$var$normalizeConfig(options) {
    const merged = {
        ...$e099036f3e0c3fd4$export$b2defa77b0ee83d8,
        ...options
    };
    const maxItems = Math.max(1, Math.floor(merged.maxItems));
    const minItems = Math.max(1, Math.min(Math.floor(merged.minItems), maxItems));
    const initialLoadCount = Math.max(1, Math.min(Math.floor(merged.initialLoadCount), maxItems));
    const lazyLoadBatchSize = Math.max(1, Math.floor(merged.lazyLoadBatchSize));
    const lazyLoadDelay = Math.max(0, Math.floor(merged.lazyLoadDelay));
    return {
        ...merged,
        minItems: minItems,
        maxItems: maxItems,
        initialLoadCount: initialLoadCount,
        lazyLoadBatchSize: lazyLoadBatchSize,
        lazyLoadDelay: lazyLoadDelay
    };
}
function $e099036f3e0c3fd4$var$selectResources(resources, config) {
    if (resources.length <= config.maxItems) return resources;
    if (config.selection === 'random') {
        const random = $e099036f3e0c3fd4$var$createRandom(`${config.seed}:selection`);
        const shuffled = [
            ...resources
        ];
        for(let index = shuffled.length - 1; index > 0; index -= 1){
            const swapIndex = Math.floor(random() * (index + 1));
            [shuffled[index], shuffled[swapIndex]] = [
                shuffled[swapIndex],
                shuffled[index]
            ];
        }
        return shuffled.slice(0, config.maxItems);
    }
    return resources.slice(0, config.maxItems);
}
function $e099036f3e0c3fd4$var$avoidPreferredSourceCollisions(resources) {
    const groups = new Map();
    for (const resource of resources){
        const group = groups.get(resource.src) ?? [];
        group.push(resource);
        groups.set(resource.src, group);
    }
    const collidingSources = new Set();
    for (const [src, group] of groups){
        const fallbackSources = new Set(group.map((resource)=>resource.fallbackSrc).filter(Boolean));
        if (group.length > 1 && fallbackSources.size > 1) collidingSources.add(src);
    }
    if (collidingSources.size === 0) return resources;
    return resources.map((resource)=>{
        if (!collidingSources.has(resource.src) || !resource.fallbackSrc || resource.fallbackSrc === resource.src) return resource;
        return {
            ...resource,
            src: resource.fallbackSrc,
            srcset: '',
            sizes: '',
            textureKey: resource.fallbackSrc
        };
    });
}
function $e099036f3e0c3fd4$var$createSceneTransform(slotIndex, count, random, resource) {
    const angle = slotIndex / count * $e099036f3e0c3fd4$var$TAU + $e099036f3e0c3fd4$var$randomBetween(random, -0.2, 0.2);
    const screenRadiusX = $e099036f3e0c3fd4$var$randomBetween(random, 0.18, 0.5);
    const screenRadiusY = $e099036f3e0c3fd4$var$randomBetween(random, 0.13, 0.45);
    let screenX = Math.cos(angle) * screenRadiusX + $e099036f3e0c3fd4$var$randomBetween(random, -0.035, 0.035);
    let screenY = Math.sin(angle) * screenRadiusY + $e099036f3e0c3fd4$var$randomBetween(random, -0.035, 0.035);
    const edgeItem = slotIndex % 7 === 0 || slotIndex % 11 === 0;
    if (Math.abs(screenX) < 0.22 && Math.abs(screenY) < 0.16) {
        const xFactor = Math.abs(screenX) > 0.01 ? 0.22 / Math.abs(screenX) : 1.4;
        const yFactor = Math.abs(screenY) > 0.01 ? 0.16 / Math.abs(screenY) : 1.4;
        const factor = Math.max(xFactor, yFactor) + $e099036f3e0c3fd4$var$randomBetween(random, 0.2, 0.55);
        screenX *= factor;
        screenY *= factor;
    }
    if (edgeItem) {
        screenX = $e099036f3e0c3fd4$var$clamp(screenX * $e099036f3e0c3fd4$var$randomBetween(random, 1.08, 1.22), -0.56, 0.56);
        screenY = $e099036f3e0c3fd4$var$clamp(screenY * $e099036f3e0c3fd4$var$randomBetween(random, 1.05, 1.18), -0.52, 0.52);
    }
    const depthLayer = slotIndex % 4;
    const layerDepth = [
        -1.15,
        -0.36,
        0.42,
        1.1
    ][depthLayer];
    const z = layerDepth + $e099036f3e0c3fd4$var$randomBetween(random, -0.22, 0.22);
    const depthRatio = $e099036f3e0c3fd4$var$clamp((z + 1.45) / 2.85, 0, 1);
    const aspectRatio = $e099036f3e0c3fd4$var$resolveAspectRatio(resource, random);
    const scale = $e099036f3e0c3fd4$var$randomBetween(random, 0.38, 0.72) + depthRatio * 0.2 + (edgeItem ? $e099036f3e0c3fd4$var$randomBetween(random, 0.32, 0.58) : 0);
    const opacity = $e099036f3e0c3fd4$var$clamp($e099036f3e0c3fd4$var$randomBetween(random, 0.28, 0.56) + depthRatio * 0.34, 0.22, 0.92);
    const x = screenX * 9.6;
    const y = screenY * 5.4;
    return {
        screenPosition: {
            x: $e099036f3e0c3fd4$var$round(screenX),
            y: $e099036f3e0c3fd4$var$round(screenY)
        },
        position: {
            x: $e099036f3e0c3fd4$var$round(x),
            y: $e099036f3e0c3fd4$var$round(y),
            z: $e099036f3e0c3fd4$var$round(z)
        },
        rotation: {
            x: $e099036f3e0c3fd4$var$round($e099036f3e0c3fd4$var$randomBetween(random, -0.045, 0.045)),
            y: $e099036f3e0c3fd4$var$round($e099036f3e0c3fd4$var$randomBetween(random, -0.065, 0.065)),
            z: $e099036f3e0c3fd4$var$round($e099036f3e0c3fd4$var$randomBetween(random, -0.2, 0.2))
        },
        scale: $e099036f3e0c3fd4$var$round(scale),
        opacity: $e099036f3e0c3fd4$var$round(opacity),
        aspectRatio: $e099036f3e0c3fd4$var$round(aspectRatio),
        depth: $e099036f3e0c3fd4$var$round(z)
    };
}
function $e099036f3e0c3fd4$var$resolveAspectRatio(resource, random) {
    if (resource.width && resource.height) return $e099036f3e0c3fd4$var$clamp(resource.width / resource.height, 0.62, 1.58);
    return $e099036f3e0c3fd4$var$randomBetween(random, 0.72, 1.34);
}
function $e099036f3e0c3fd4$var$createRandom(seed) {
    let state = $e099036f3e0c3fd4$var$hashString(seed);
    return ()=>{
        state += 0x6d2b79f5;
        let value = state;
        value = Math.imul(value ^ value >>> 15, value | 1);
        value ^= value + Math.imul(value ^ value >>> 7, value | 61);
        return ((value ^ value >>> 14) >>> 0) / 4294967296;
    };
}
function $e099036f3e0c3fd4$var$hashString(value) {
    let hash = 2166136261;
    for(let index = 0; index < value.length; index += 1){
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
}
function $e099036f3e0c3fd4$var$randomBetween(random, min, max) {
    return min + (max - min) * random();
}
function $e099036f3e0c3fd4$var$clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
function $e099036f3e0c3fd4$var$round(value) {
    return Math.round(value * 10000) / 10000;
}



class $8bac6a671cbdf43a$export$35a0542af0b8e35c {
    constructor(options = {}){
        this.imageLoader = options.imageLoader ?? $8bac6a671cbdf43a$var$loadImageResource;
        this.textureFactory = options.textureFactory ?? $8bac6a671cbdf43a$var$createTextureFromImage;
        this.fallbackTextureFactory = options.fallbackTextureFactory ?? $8bac6a671cbdf43a$var$createFallbackTexture;
        this.entries = new Map();
        this.ownedTextures = new Set();
        this.fallbackTexture = null;
        this.disposed = false;
    }
    load(resource) {
        const key = resource?.textureKey || resource?.src;
        if (!key || !resource?.src) return Promise.resolve(this.getFallbackTexture());
        if (this.entries.has(key)) return this.entries.get(key);
        const promise = this.imageLoader(resource).then((image)=>this.createTexture(image, resource)).catch(()=>this.getFallbackTexture());
        this.entries.set(key, promise);
        return promise;
    }
    dispose() {
        this.disposed = true;
        this.entries.clear();
        for (const texture of this.ownedTextures)texture.dispose?.();
        this.ownedTextures.clear();
        this.fallbackTexture = null;
    }
    createTexture(image, resource) {
        if (this.disposed) return this.getFallbackTexture();
        const texture = this.textureFactory(image, resource);
        this.ownedTextures.add(texture);
        return texture;
    }
    getFallbackTexture() {
        if (!this.fallbackTexture) {
            this.fallbackTexture = this.fallbackTextureFactory();
            this.ownedTextures.add(this.fallbackTexture);
        }
        return this.fallbackTexture;
    }
}
function $8bac6a671cbdf43a$var$loadImageResource(resource) {
    return $8bac6a671cbdf43a$var$loadWithFallback(resource, false);
}
function $8bac6a671cbdf43a$var$loadWithFallback(resource, fallbackAttempt) {
    const src = fallbackAttempt ? resource.fallbackSrc : resource.src;
    const useResponsiveFields = !fallbackAttempt;
    return $8bac6a671cbdf43a$var$loadImage({
        src: src,
        srcset: useResponsiveFields ? resource.srcset : '',
        sizes: useResponsiveFields ? resource.sizes : '',
        crossOrigin: resource.crossOrigin,
        referrerPolicy: resource.referrerPolicy
    }).catch((error)=>{
        if (!fallbackAttempt && resource.fallbackSrc && resource.fallbackSrc !== resource.src) return $8bac6a671cbdf43a$var$loadWithFallback(resource, true);
        throw error;
    });
}
function $8bac6a671cbdf43a$var$loadImage({ src: src, srcset: srcset, sizes: sizes, crossOrigin: crossOrigin, referrerPolicy: referrerPolicy }) {
    return new Promise((resolve, reject)=>{
        const image = new Image();
        if (crossOrigin !== false && !$8bac6a671cbdf43a$var$isDataLikeUrl(src)) image.crossOrigin = crossOrigin ?? 'anonymous';
        if (referrerPolicy) image.referrerPolicy = referrerPolicy;
        image.decoding = 'async';
        image.onload = async ()=>{
            try {
                if (image.decode) await image.decode();
            } catch  {}
            resolve(image);
        };
        image.onerror = ()=>reject(new Error(`Failed to load image: ${src}`));
        if (srcset) image.srcset = srcset;
        if (sizes) image.sizes = sizes;
        image.src = src;
    });
}
function $8bac6a671cbdf43a$var$createTextureFromImage(image) {
    const texture = new $cf10f6a70bd83671$export$5431306cf43de24a(image);
    texture.needsUpdate = true;
    texture.colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa;
    texture.minFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8;
    texture.magFilter = $cf10f6a70bd83671$export$8a72f490b25c56c8;
    texture.generateMipmaps = false;
    return texture;
}
function $8bac6a671cbdf43a$var$createFallbackTexture() {
    const data = new Uint8Array([
        232,
        228,
        220,
        255,
        214,
        208,
        198,
        255,
        214,
        208,
        198,
        255,
        232,
        228,
        220,
        255
    ]);
    const texture = new $cf10f6a70bd83671$export$b691f601014eabe1(data, 2, 2, $cf10f6a70bd83671$export$3f8bb04b555a363c);
    texture.needsUpdate = true;
    texture.colorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa;
    texture.minFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
    texture.magFilter = $cf10f6a70bd83671$export$727aa5ec3fe39bf0;
    return texture;
}
function $8bac6a671cbdf43a$var$isDataLikeUrl(src = '') {
    return src.startsWith('data:') || src.startsWith('blob:');
}


const $a45dcdcd18e65853$var$TAU = Math.PI * 2;
const $a45dcdcd18e65853$export$f994f0fecd259d34 = {
    farZ: -104,
    nearZ: -6.4,
    recycleZ: -5.8,
    minLaneRadius: 6.8,
    maxLaneRadius: 15.8,
    minSpeed: 7.8,
    maxSpeed: 12.2,
    loopSpeed: 9.6,
    loopDepthJitter: 0.08,
    planeScaleMultiplier: 1.16,
    recycleDepthStart: 0.015,
    recycleDepthSpan: 0.22,
    recycleDepthSlots: 36,
    farOpacity: 0.035,
    introBoostMultiplier: 1,
    introBoostDuration: 1.2,
    introCameraStartZ: 54,
    introCameraDuration: 1.35,
    introLoopRampStart: 0.65,
    introLoopRampDuration: 0.75,
    sectors: 18,
    candidateAttempts: 18,
    candidateStride: 997,
    minProjectedDistance: 0.075,
    minProjectedEdgeGap: 0.035,
    projectedPlaneAspect: 1,
    initialDepthStart: 0.02,
    initialDepthSpan: 0.88,
    lazyIntroDepthStart: 0.16,
    lazyIntroDepthSpan: 0.28,
    seed: 'floema-tunnel'
};
function $a45dcdcd18e65853$export$86fba2050cc79700(index = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const random = $a45dcdcd18e65853$var$createRandom(`${config.seed}:${index}`);
    const sectorCount = Math.max(5, Math.floor(config.sectors));
    const sectorWidth = $a45dcdcd18e65853$var$TAU / sectorCount;
    const cycle = Math.floor(index / sectorCount);
    const sector = $a45dcdcd18e65853$var$getSectorForIndex(index, sectorCount, config.seed, cycle);
    const angle = $a45dcdcd18e65853$var$normalizeAngle((sector + 0.5) * sectorWidth + $a45dcdcd18e65853$var$randomBetween(random, -sectorWidth * 0.34, sectorWidth * 0.34));
    const radiusBias = 0.22 + Math.pow(random(), 0.82) * 0.78;
    const radius = config.minLaneRadius + (config.maxLaneRadius - config.minLaneRadius) * radiusBias;
    const z = $a45dcdcd18e65853$var$randomBetween(random, config.farZ, config.farZ * 0.28);
    const speed = Number.isFinite(config.loopSpeed) ? config.loopSpeed : $a45dcdcd18e65853$var$randomBetween(random, config.minSpeed, config.maxSpeed);
    const scale = $a45dcdcd18e65853$var$randomBetween(random, 0.88, 1.72) * config.planeScaleMultiplier;
    return {
        x: $a45dcdcd18e65853$var$round(Math.cos(angle) * radius),
        y: $a45dcdcd18e65853$var$round(Math.sin(angle) * radius * $a45dcdcd18e65853$var$randomBetween(random, 0.84, 1.08)),
        z: $a45dcdcd18e65853$var$round(z),
        speed: $a45dcdcd18e65853$var$round(speed),
        baseScale: $a45dcdcd18e65853$var$round(scale),
        rotationZ: 0,
        rotationSpeed: 0,
        laneAngle: $a45dcdcd18e65853$var$round(angle),
        sectorIndex: sector
    };
}
function $a45dcdcd18e65853$export$fb43fd7d15d23469(index = 0, occupiedSlots = [], options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const attempts = Math.max(1, Math.floor(config.candidateAttempts));
    let bestSlot = null;
    let bestScore = -Infinity;
    for(let attempt = 0; attempt < attempts; attempt += 1){
        const candidate = $a45dcdcd18e65853$export$86fba2050cc79700(index + attempt * config.candidateStride, config);
        candidate.projectedPlaneAspect = $a45dcdcd18e65853$var$getSlotProjectedPlaneAspect(candidate, config);
        if (Number.isFinite(config.fixedZ)) candidate.z = $a45dcdcd18e65853$var$round(config.fixedZ);
        const distance = $a45dcdcd18e65853$var$getNearestProjectedDistance(candidate, occupiedSlots, config);
        const edgeGap = $a45dcdcd18e65853$var$getNearestProjectedEdgeGap(candidate, occupiedSlots, config);
        const score = $a45dcdcd18e65853$var$getSeparationScore(distance, edgeGap, config);
        if (score > bestScore) {
            bestSlot = candidate;
            bestScore = score;
        }
        if (distance >= config.minProjectedDistance && edgeGap >= config.minProjectedEdgeGap) return candidate;
    }
    return bestSlot;
}
function $a45dcdcd18e65853$export$111295781de51c22(a, b, options = {}) {
    const first = $a45dcdcd18e65853$var$projectTunnelSlot(a, options);
    const second = $a45dcdcd18e65853$var$projectTunnelSlot(b, options);
    return Math.hypot(first.x - second.x, first.y - second.y);
}
function $a45dcdcd18e65853$export$1997980c59a76704(depthProgress, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const start = options.lazy ? config.lazyIntroDepthStart : config.initialDepthStart;
    const span = options.lazy ? config.lazyIntroDepthSpan : config.initialDepthSpan;
    const visibleRange = config.nearZ - config.farZ;
    return $a45dcdcd18e65853$var$round(config.farZ + visibleRange * (start + $a45dcdcd18e65853$var$clamp(depthProgress, 0, 1) * span));
}
function $a45dcdcd18e65853$export$f6a20b37c8001c45(index = 0, total = 1, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const count = Math.max(1, Math.floor(total));
    const random = $a45dcdcd18e65853$var$createRandom(`${config.seed}:loop-depth:${index}`);
    const jitter = (random() - 0.5) * config.loopDepthJitter;
    return $a45dcdcd18e65853$var$normalizeUnit((index + 0.5 + jitter) / count);
}
function $a45dcdcd18e65853$export$c692be574a1f644e(slot, deltaSeconds, options = {}) {
    const speedMultiplier = options.speedMultiplier ?? 1;
    slot.z = $a45dcdcd18e65853$var$round(slot.z + slot.speed * deltaSeconds * speedMultiplier);
    slot.rotationZ = $a45dcdcd18e65853$var$round(slot.rotationZ + slot.rotationSpeed * deltaSeconds * speedMultiplier);
    return slot;
}
function $a45dcdcd18e65853$export$b8825e68d1251f0e(offset = 0, deltaSeconds = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const speedMultiplier = options.speedMultiplier ?? 1;
    const depthRange = Math.max(0.001, $a45dcdcd18e65853$var$getTunnelLoopEndZ(config) - config.farZ);
    return offset + config.loopSpeed * deltaSeconds * speedMultiplier / depthRange;
}
function $a45dcdcd18e65853$export$5ca4fba57ac7249a(phase = 0, offset = 0) {
    return $a45dcdcd18e65853$var$normalizeUnit(phase + offset);
}
function $a45dcdcd18e65853$export$aa918636d686e7e5(phase = 0, offset = 0) {
    return Math.floor(phase + offset);
}
function $a45dcdcd18e65853$export$ebe4bc045e3c0e34(progress = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    return $a45dcdcd18e65853$var$round(config.farZ + ($a45dcdcd18e65853$var$getTunnelLoopEndZ(config) - config.farZ) * $a45dcdcd18e65853$var$clamp(progress, 0, 1));
}
function $a45dcdcd18e65853$export$fbb49e6d76aa3180(elapsedSeconds = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const duration = Math.max(0.001, config.introBoostDuration);
    const boost = Math.max(1, config.introBoostMultiplier);
    const release = $a45dcdcd18e65853$var$smoothstep(0, duration, elapsedSeconds);
    return $a45dcdcd18e65853$var$round(1 + (boost - 1) * (1 - release));
}
function $a45dcdcd18e65853$export$d79eeeed6586c2b4(elapsedSeconds = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const duration = Math.max(0.001, config.introCameraDuration);
    const startZ = Math.max(0, config.introCameraStartZ);
    const release = $a45dcdcd18e65853$var$smootherstep(0, duration, elapsedSeconds);
    return $a45dcdcd18e65853$var$round(startZ * (1 - release));
}
function $a45dcdcd18e65853$export$f8fb49d5ad4843d5(elapsedSeconds = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const rampStart = Math.max(0, config.introLoopRampStart);
    const rampDuration = Math.max(0.001, config.introLoopRampDuration);
    if (elapsedSeconds < rampStart) return 0;
    return $a45dcdcd18e65853$var$round($a45dcdcd18e65853$var$smoothstep(rampStart, rampStart + rampDuration, elapsedSeconds));
}
function $a45dcdcd18e65853$export$f26ca86f9f33df1b(slot, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    return slot.z >= config.recycleZ;
}
function $a45dcdcd18e65853$export$35d30a2d20fcd003(cycle = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const visibleRange = config.nearZ - config.farZ;
    const slots = Math.max(1, Math.floor(config.recycleDepthSlots));
    const slotProgress = (cycle % slots + 0.5) / slots;
    const progress = config.recycleDepthStart + slotProgress * config.recycleDepthSpan;
    return $a45dcdcd18e65853$var$round(config.farZ + visibleRange * progress);
}
function $a45dcdcd18e65853$export$3b97b00068bacde5(slot, index = 0, cycle = 0, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const next = $a45dcdcd18e65853$export$86fba2050cc79700(index + cycle * 997, {
        ...config,
        farZ: config.farZ
    });
    Object.assign(slot, next, {
        z: $a45dcdcd18e65853$export$35d30a2d20fcd003(cycle, config)
    });
    return slot;
}
function $a45dcdcd18e65853$export$fbb7e661e1046eb3(slot, options = {}) {
    const config = {
        ...$a45dcdcd18e65853$export$f994f0fecd259d34,
        ...options
    };
    const progress = $a45dcdcd18e65853$var$clamp((slot.z - config.farZ) / (config.nearZ - config.farZ), 0, 1);
    const fadeIn = $a45dcdcd18e65853$var$smoothstep(0.04, 0.5, progress);
    const opacity = $a45dcdcd18e65853$var$clamp(config.farOpacity + (1 - config.farOpacity) * fadeIn, config.farOpacity, 1);
    const contrast = $a45dcdcd18e65853$var$clamp(0.7 + progress * 0.45, 0.7, 1.08);
    const scaleMultiplier = $a45dcdcd18e65853$var$clamp(0.62 + progress * 0.78, 0.62, 1.36);
    return {
        progress: progress,
        opacity: $a45dcdcd18e65853$var$round(opacity),
        contrast: $a45dcdcd18e65853$var$round(contrast),
        scaleMultiplier: $a45dcdcd18e65853$var$round(scaleMultiplier)
    };
}
function $a45dcdcd18e65853$export$bb9c75b121ace2bc(index = 0, options = {}) {
    const bands = Math.max(2, Math.floor(options.bands ?? 10));
    const seed = options.seed ?? $a45dcdcd18e65853$export$f994f0fecd259d34.seed;
    const cycle = Math.floor(index / bands);
    const band = $a45dcdcd18e65853$var$getSectorForIndex(index, bands, `${seed}:depth`, cycle);
    const random = $a45dcdcd18e65853$var$createRandom(`${seed}:depth-jitter:${index}`);
    const jitter = $a45dcdcd18e65853$var$randomBetween(random, 0.12, 0.88);
    return (band + jitter) / bands;
}
function $a45dcdcd18e65853$var$createRandom(seed) {
    let state = $a45dcdcd18e65853$var$hashString(seed);
    return ()=>{
        state += 0x6d2b79f5;
        let value = state;
        value = Math.imul(value ^ value >>> 15, value | 1);
        value ^= value + Math.imul(value ^ value >>> 7, value | 61);
        return ((value ^ value >>> 14) >>> 0) / 4294967296;
    };
}
function $a45dcdcd18e65853$var$getNearestProjectedDistance(slot, occupiedSlots, options) {
    if (occupiedSlots.length === 0) return Infinity;
    return occupiedSlots.reduce((minDistance, occupiedSlot)=>Math.min(minDistance, $a45dcdcd18e65853$export$111295781de51c22(slot, occupiedSlot, options)), Infinity);
}
function $a45dcdcd18e65853$var$getNearestProjectedEdgeGap(slot, occupiedSlots, options) {
    if (occupiedSlots.length === 0) return Infinity;
    return occupiedSlots.reduce((minGap, occupiedSlot)=>Math.min(minGap, $a45dcdcd18e65853$var$getProjectedTunnelEdgeGap(slot, occupiedSlot, options)), Infinity);
}
function $a45dcdcd18e65853$var$getProjectedTunnelEdgeGap(a, b, options = {}) {
    const first = $a45dcdcd18e65853$var$projectTunnelSlotBounds(a, options);
    const second = $a45dcdcd18e65853$var$projectTunnelSlotBounds(b, options);
    const gapX = Math.abs(first.x - second.x) - first.halfWidth - second.halfWidth;
    const gapY = Math.abs(first.y - second.y) - first.halfHeight - second.halfHeight;
    return Math.max(gapX, gapY);
}
function $a45dcdcd18e65853$var$getSeparationScore(distance, edgeGap, options) {
    const minDistance = Math.max(0, options.minProjectedDistance ?? 0);
    const minEdgeGap = Math.max(0, options.minProjectedEdgeGap ?? 0);
    const distanceScore = Number.isFinite(distance) ? Math.min(distance, minDistance * 2 || distance) : distance;
    const edgeScore = Number.isFinite(edgeGap) ? Math.min(edgeGap, minEdgeGap * 2 || edgeGap) : edgeGap;
    return edgeScore * 4 + distanceScore;
}
function $a45dcdcd18e65853$var$projectTunnelSlot(slot, options = {}) {
    const bounds = $a45dcdcd18e65853$var$projectTunnelSlotBounds(slot, options);
    return {
        x: bounds.x,
        y: bounds.y
    };
}
function $a45dcdcd18e65853$var$projectTunnelSlotBounds(slot, options = {}) {
    const fov = options.fov ?? 50;
    const aspect = options.cameraAspect ?? options.aspect ?? 1;
    const planeAspect = $a45dcdcd18e65853$var$getSlotProjectedPlaneAspect(slot, options);
    const visual = $a45dcdcd18e65853$export$fbb7e661e1046eb3(slot, options);
    const scale = slot.baseScale * visual.scaleMultiplier;
    const depth = Math.max(0.2, -slot.z);
    const halfViewportHeight = depth * Math.tan(fov * Math.PI / 360);
    const halfViewportWidth = halfViewportHeight * aspect;
    return {
        x: slot.x / halfViewportWidth,
        y: slot.y / halfViewportHeight,
        halfWidth: scale * planeAspect * 0.5 / halfViewportWidth,
        halfHeight: scale * 0.5 / halfViewportHeight
    };
}
function $a45dcdcd18e65853$var$getSlotProjectedPlaneAspect(slot, options = {}) {
    return Math.max(0.2, $a45dcdcd18e65853$var$toFiniteNumber(slot?.projectedPlaneAspect, $a45dcdcd18e65853$var$toFiniteNumber(options.projectedPlaneAspect, 1)));
}
function $a45dcdcd18e65853$var$getTunnelLoopEndZ(config) {
    return Number.isFinite(config.loopEndZ) ? config.loopEndZ : config.recycleZ;
}
function $a45dcdcd18e65853$var$hashString(value) {
    let hash = 2166136261;
    for(let index = 0; index < value.length; index += 1){
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
}
function $a45dcdcd18e65853$var$randomBetween(random, min, max) {
    return min + (max - min) * random();
}
function $a45dcdcd18e65853$var$getSectorForIndex(index, sectorCount, seed, cycle) {
    return $a45dcdcd18e65853$var$createSectorOrder(sectorCount, seed, cycle)[index % sectorCount];
}
function $a45dcdcd18e65853$var$createSectorOrder(sectorCount, seed, cycle) {
    let bestOrder = null;
    let bestScore = Infinity;
    for(let attempt = 0; attempt < 16; attempt += 1){
        const sectors = Array.from({
            length: sectorCount
        }, (_, sector)=>sector);
        const random = $a45dcdcd18e65853$var$createRandom(`${seed}:sectors:${cycle}:${attempt}`);
        for(let current = sectors.length - 1; current > 0; current -= 1){
            const target = Math.floor(random() * (current + 1));
            [sectors[current], sectors[target]] = [
                sectors[target],
                sectors[current]
            ];
        }
        const score = $a45dcdcd18e65853$var$scoreSectorOrder(sectors, sectorCount);
        if (score < bestScore) {
            bestOrder = sectors;
            bestScore = score;
        }
    }
    return bestOrder;
}
function $a45dcdcd18e65853$var$scoreSectorOrder(sectors, sectorCount) {
    const sectorWidth = $a45dcdcd18e65853$var$TAU / sectorCount;
    const goldenAngle = 2.399963229728653;
    let score = 0;
    for(let index = 1; index < sectors.length; index += 1){
        const diff = $a45dcdcd18e65853$var$angularDistance(sectors[index] * sectorWidth, sectors[index - 1] * sectorWidth);
        if (Math.abs(diff - goldenAngle) < 0.38) score += 3;
        if (diff < sectorWidth * 1.35) score += 1.4;
    }
    return score;
}
function $a45dcdcd18e65853$var$normalizeAngle(angle) {
    return (angle % $a45dcdcd18e65853$var$TAU + $a45dcdcd18e65853$var$TAU) % $a45dcdcd18e65853$var$TAU;
}
function $a45dcdcd18e65853$var$angularDistance(a, b) {
    const diff = Math.abs($a45dcdcd18e65853$var$normalizeAngle(a - b));
    return Math.min(diff, $a45dcdcd18e65853$var$TAU - diff);
}
function $a45dcdcd18e65853$var$smoothstep(edge0, edge1, value) {
    const x = $a45dcdcd18e65853$var$clamp((value - edge0) / (edge1 - edge0), 0, 1);
    return x * x * (3 - 2 * x);
}
function $a45dcdcd18e65853$var$smootherstep(edge0, edge1, value) {
    const x = $a45dcdcd18e65853$var$clamp((value - edge0) / (edge1 - edge0), 0, 1);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
function $a45dcdcd18e65853$var$clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
function $a45dcdcd18e65853$var$normalizeUnit(value) {
    return (value % 1 + 1) % 1;
}
function $a45dcdcd18e65853$var$toFiniteNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}
function $a45dcdcd18e65853$var$round(value) {
    return Math.round(value * 10000) / 10000;
}


function $42d19cc2e73ceac2$export$741cda984e31e47f(sourceAspectRatio, options = {}) {
    const aspect = $42d19cc2e73ceac2$var$toFiniteNumber(sourceAspectRatio, 1);
    const hasMinAspect = Number.isFinite(Number(options.minAspect));
    const hasMaxAspect = Number.isFinite(Number(options.maxAspect));
    if (!hasMinAspect && !hasMaxAspect) return $42d19cc2e73ceac2$var$round(aspect);
    const minAspect = hasMinAspect ? Number(options.minAspect) : 0;
    const maxAspect = hasMaxAspect ? Math.max(minAspect, Number(options.maxAspect)) : Infinity;
    return $42d19cc2e73ceac2$var$round(Math.min(maxAspect, Math.max(minAspect, aspect)));
}
function $42d19cc2e73ceac2$var$toFiniteNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}
function $42d19cc2e73ceac2$var$round(value) {
    return Math.round(value * 10000) / 10000;
}


class $36f5c84af8d5b03f$export$2fc02929ca5105dc {
    constructor(root, backendImages = [], options = {}){
        this.root = typeof root === 'string' ? document.querySelector(root) : root;
        this.canvas = options.canvas ?? this.root?.querySelector('.first-sec__floema-floating-canvas') ?? this.root?.querySelector('.hero-scene__canvas');
        this.backendImages = backendImages;
        this.config = {
            ...(0, $e099036f3e0c3fd4$export$b2defa77b0ee83d8),
            ...options
        };
        this.tunnel = {
            ...(0, $a45dcdcd18e65853$export$f994f0fecd259d34),
            ...options.tunnel ?? {}
        };
        this.portrait = options.portrait ?? {};
        this.textureCache = options.textureCache ?? new (0, $8bac6a671cbdf43a$export$35a0542af0b8e35c)();
        this.ownsTextureCache = options.ownsTextureCache ?? !options.textureCache;
        this.gsap = options.gsap ?? globalThis.gsap;
        this.sceneImages = [];
        this.meshes = new Map();
        this.texturePool = [];
        this.texturePoolKeys = new Set();
        this.lazyTimers = [];
        this.textureRebalanceTimer = null;
        this.needsTextureRebalance = false;
        this.clock = new $cf10f6a70bd83671$export$9735c82c4bae3302(false);
        this.reducedMotion = globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
        this.isStarted = false;
        this.motionStarted = false;
        this.isDestroyed = false;
        this.animationFrame = 0;
        this.recycleCycle = 1;
        this.motionElapsed = 0;
        this.loopOffset = 0;
        this.isPaused = false;
        this.isInViewport = true;
        this.isDocumentVisible = typeof document === 'undefined' || document.visibilityState !== 'hidden';
        this.observer = null;
        this.handleResize = this.handleResize.bind(this);
        this.render = this.render.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    start() {
        if (!this.root || !this.canvas || this.isStarted) return this;
        this.sceneImages = (0, $e099036f3e0c3fd4$export$54b61e86a3412b8d)(this.backendImages, this.config);
        if (!this.sceneImages.length) return this;
        this.isStarted = true;
        this.createRenderer();
        this.createScene();
        this.handleResize();
        globalThis.addEventListener?.('resize', this.handleResize);
        if (typeof IntersectionObserver !== 'undefined' && this.root) {
            this.observer = new IntersectionObserver((entries)=>{
                for (const entry of entries)if (entry.target === this.root) {
                    this.isInViewport = entry.isIntersecting;
                    this.syncPlayback();
                }
            }, {
                rootMargin: '200px 0px 200px 0px'
            });
            this.observer.observe(this.root);
        }
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.render();
        this.loadImages();
        this.root.dataset.sceneReady = 'true';
        if (this.config.autoPlay !== false) this.play();
        return this;
    }
    play() {
        if (!this.isStarted || this.motionStarted || this.isDestroyed) return this;
        this.motionStarted = true;
        this.motionElapsed = 0;
        this.clock.start();
        if (this.camera) this.camera.position.z = this.reducedMotion ? 0 : (0, $a45dcdcd18e65853$export$d79eeeed6586c2b4)(0, this.tunnel);
        for (const mesh of this.meshes.values())this.revealMesh(mesh);
        if (this.needsTextureRebalance) this.requestTextureRebalance();
        return this;
    }
    syncPlayback() {
        if (this.isDestroyed || !this.isStarted) return;
        const shouldRender = this.isInViewport && this.isDocumentVisible;
        if (shouldRender) {
            if (this.isPaused) {
                this.isPaused = false;
                this.clock.getDelta();
                if (!this.animationFrame) this.render();
            }
        } else if (!this.isPaused) {
            this.isPaused = true;
            if (this.animationFrame) {
                globalThis.cancelAnimationFrame?.(this.animationFrame);
                this.animationFrame = 0;
            }
        }
    }
    handleVisibilityChange() {
        this.isDocumentVisible = typeof document === 'undefined' || document.visibilityState !== 'hidden';
        this.syncPlayback();
    }
    pause() {
        this.isInViewport = false;
        this.syncPlayback();
    }
    resume() {
        this.isInViewport = true;
        this.syncPlayback();
    }
    destroy() {
        this.isDestroyed = true;
        this.observer?.disconnect();
        this.observer = null;
        if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        globalThis.removeEventListener?.('resize', this.handleResize);
        globalThis.cancelAnimationFrame?.(this.animationFrame);
        this.animationFrame = 0;
        for (const timer of this.lazyTimers)clearTimeout(timer);
        clearTimeout(this.textureRebalanceTimer);
        this.lazyTimers = [];
        this.textureRebalanceTimer = null;
        for (const mesh of this.meshes.values()){
            this.gsap?.killTweensOf?.(mesh.userData);
            this.scene?.remove(mesh);
            mesh.material.dispose();
        }
        this.meshes.clear();
        this.texturePool = [];
        this.texturePoolKeys.clear();
        this.geometry?.dispose();
        this.renderer?.dispose();
        if (this.ownsTextureCache) this.textureCache.dispose();
    }
    createRenderer() {
        this.renderer = new $d5e9756b64e059ca$export$f6cc00ef28d7cf97({
            canvas: this.canvas,
            alpha: true,
            antialias: true,
            powerPreference: 'high-performance'
        });
        this.renderer.setClearColor(0x000000, 0);
        this.renderer.outputColorSpace = $cf10f6a70bd83671$export$561f394b24edfcaa;
    }
    createScene() {
        this.scene = new $cf10f6a70bd83671$export$38af1803e3442a7f();
        this.camera = new $cf10f6a70bd83671$export$74e4ae24825f68d7(50, 1, 0.1, 260);
        this.camera.position.set(0, 0, (0, $a45dcdcd18e65853$export$d79eeeed6586c2b4)(0, this.tunnel));
        this.camera.lookAt(0, 0, -1);
        this.geometry = new $cf10f6a70bd83671$export$967d831af31f69ce(1, 1, 1, 1);
    }
    handleResize() {
        if (!this.renderer || !this.camera) return;
        const width = Math.max(1, this.root.clientWidth || globalThis.innerWidth || 1);
        const height = Math.max(1, this.root.clientHeight || globalThis.innerHeight || 1);
        const viewport = $36f5c84af8d5b03f$export$9e1483f61d50e5b9(width, height, this.config);
        const pixelRatio = Math.min(globalThis.devicePixelRatio || 1, this.config.pixelRatioCap ?? 2);
        this.root.style.setProperty('--hero-render-bleed-bottom', `${viewport.bleedBottom}px`);
        this.root.style.setProperty('--hero-render-bleed-x', `${viewport.bleedX}px`);
        this.camera.aspect = viewport.renderWidth / viewport.contentHeight;
        this.camera.setViewOffset(viewport.renderWidth, viewport.contentHeight, 0, 0, viewport.renderWidth, viewport.renderHeight);
        this.camera.updateProjectionMatrix();
        this.renderer.setPixelRatio(pixelRatio);
        this.renderer.setSize(viewport.renderWidth, viewport.renderHeight, false);
    }
    loadImages() {
        const queue = (0, $e099036f3e0c3fd4$export$db802ba6b23bef39)(this.sceneImages, this.config);
        this.loadBatch(queue.initial, 0);
        queue.lazy.forEach((batch, index)=>{
            const timer = globalThis.setTimeout(()=>{
                this.loadBatch(batch, index + 1);
            }, this.config.lazyLoadDelay * (index + 1));
            this.lazyTimers.push(timer);
        });
    }
    async loadBatch(batch, batchIndex) {
        const results = await Promise.allSettled(batch.map(async (item, index)=>{
            const texture = await this.textureCache.load(item.resource);
            return {
                item: item,
                texture: texture,
                index: index
            };
        }));
        for (const result of results)if (result.status === 'fulfilled' && !this.isDestroyed) this.addToTexturePool(result.value.item, result.value.texture);
        if (batchIndex === 0) this.ensureLoopMeshes();
        else {
            this.ensureLoopMeshes();
            if (!this.shouldStageUniqueMeshCreation()) this.requestTextureRebalance();
        }
    }
    addToTexturePool(item, texture) {
        const key = item.textureKey ?? item.resource?.textureKey;
        if (!key || this.texturePoolKeys.has(key)) return;
        this.texturePoolKeys.add(key);
        this.texturePool.push({
            item: item,
            textureKey: key,
            texture: texture,
            aspectRatio: (0, $42d19cc2e73ceac2$export$741cda984e31e47f)($36f5c84af8d5b03f$var$getTextureAspectRatio(texture, item.aspectRatio), this.portrait)
        });
    }
    ensureLoopMeshes() {
        if (this.texturePool.length === 0) return;
        if (!this.meshes) this.meshes = new Map();
        if (!this.sceneImages?.length) return;
        if (this.meshes.size === 0) {
            this.motionElapsed = 0;
            this.loopOffset = 0;
        }
        const poolByItemId = this.getTexturePoolByItemId();
        const items = this.getLoopMeshItems(poolByItemId);
        items.forEach((item)=>{
            if (this.meshes.has(item.id)) return;
            const poolEntry = poolByItemId.get(item.id) ?? this.pickTextureForSlot(item.slotIndex, 0);
            this.addTunnelPlane(item, poolEntry);
        });
    }
    getLoopMeshItems(poolByItemId = this.getTexturePoolByItemId()) {
        if (!this.shouldStageUniqueMeshCreation()) return this.sceneImages;
        return this.sceneImages.filter((item)=>poolByItemId.has(item.id));
    }
    addTunnelPlane(item, poolEntry) {
        if (!poolEntry) return;
        const texture = poolEntry.texture;
        const material = new $cf10f6a70bd83671$export$55cbcc9b622fe1f5({
            map: texture,
            transparent: true,
            opacity: 0,
            depthTest: true,
            depthWrite: false,
            side: $cf10f6a70bd83671$export$3b296b6f144d5b03,
            toneMapped: false
        });
        const mesh = new $cf10f6a70bd83671$export$e176487c05830cc5(this.geometry, material);
        const aspectRatio = (0, $42d19cc2e73ceac2$export$741cda984e31e47f)($36f5c84af8d5b03f$var$getTextureAspectRatio(texture, item.aspectRatio), this.portrait);
        const planeAspect = poolEntry.aspectRatio ?? aspectRatio;
        const { slot: slot, depthPhase: depthPhase } = this.createInitialSlot(item, planeAspect);
        mesh.userData.item = item;
        mesh.userData.textureItem = poolEntry.item;
        mesh.userData.slot = slot;
        mesh.userData.aspectRatio = planeAspect;
        mesh.userData.reveal = 0;
        mesh.userData.recycleReveal = 1;
        mesh.userData.loopSlotIndex = item.slotIndex;
        mesh.userData.depthPhase = depthPhase;
        mesh.userData.loopCycle = (0, $a45dcdcd18e65853$export$aa918636d686e7e5)(depthPhase, this.loopOffset);
        this.applyPlaneGeometry(mesh);
        this.scene.add(mesh);
        this.meshes.set(item.id, mesh);
        if (this.motionStarted) this.revealMesh(mesh);
    }
    createInitialSlot(item, aspectRatio = 1) {
        const depthProgress = (0, $a45dcdcd18e65853$export$f6a20b37c8001c45)(item.slotIndex, this.sceneImages.length, {
            seed: this.tunnel.seed,
            loopDepthJitter: this.tunnel.loopDepthJitter
        });
        const z = (0, $a45dcdcd18e65853$export$ebe4bc045e3c0e34)(depthProgress, this.tunnel);
        const slot = (0, $a45dcdcd18e65853$export$fb43fd7d15d23469)(item.slotIndex, this.getOccupiedSlots(), {
            ...this.tunnel,
            cameraAspect: this.camera.aspect,
            fixedZ: z,
            projectedPlaneAspect: aspectRatio
        });
        return {
            slot: slot,
            depthPhase: depthProgress
        };
    }
    render() {
        if (this.isDestroyed || this.isPaused) {
            this.animationFrame = 0;
            return;
        }
        this.animationFrame = globalThis.requestAnimationFrame?.(this.render) ?? 0;
        const delta = Math.min(this.clock.getDelta(), 0.05);
        this.updateTunnel(delta);
        this.updateCameraIntro();
        this.renderer.render(this.scene, this.camera);
    }
    updateTunnel(delta) {
        if (this.meshes.size === 0 || !this.motionStarted) return;
        this.motionElapsed += delta;
        const speedMultiplier = this.reducedMotion ? 0.18 : (0, $a45dcdcd18e65853$export$fbb49e6d76aa3180)(this.motionElapsed, this.tunnel) * (0, $a45dcdcd18e65853$export$f8fb49d5ad4843d5)(this.motionElapsed, this.tunnel);
        this.loopOffset = (0, $a45dcdcd18e65853$export$b8825e68d1251f0e)(this.loopOffset, delta, {
            ...this.tunnel,
            speedMultiplier: speedMultiplier
        });
        for (const mesh of this.meshes.values()){
            const slot = mesh.userData.slot;
            const progress = (0, $a45dcdcd18e65853$export$5ca4fba57ac7249a)(mesh.userData.depthPhase, this.loopOffset);
            const cycle = (0, $a45dcdcd18e65853$export$aa918636d686e7e5)(mesh.userData.depthPhase, this.loopOffset);
            if (cycle !== mesh.userData.loopCycle) {
                this.recyclePlane(mesh, cycle);
                mesh.userData.loopCycle = cycle;
            }
            slot.z = (0, $a45dcdcd18e65853$export$ebe4bc045e3c0e34)(progress, this.tunnel);
            this.applyPlaneGeometry(mesh);
        }
    }
    updateCameraIntro() {
        if (!this.motionStarted || !this.camera) return;
        this.camera.position.z = this.reducedMotion ? 0 : (0, $a45dcdcd18e65853$export$d79eeeed6586c2b4)(this.motionElapsed, this.tunnel);
    }
    recyclePlane(mesh, cycle) {
        const keepTexture = this.shouldKeepMeshTextureOnRecycle();
        const next = keepTexture ? null : this.pickTextureForSlot(mesh.userData.loopSlotIndex, cycle, mesh.material.map, mesh);
        const progress = (0, $a45dcdcd18e65853$export$5ca4fba57ac7249a)(mesh.userData.depthPhase, this.loopOffset);
        const z = (0, $a45dcdcd18e65853$export$ebe4bc045e3c0e34)(progress, this.tunnel);
        this.recycleCycle += 1;
        const nextAspectRatio = keepTexture ? mesh.userData.aspectRatio ?? 1 : next?.aspectRatio ?? mesh.userData.aspectRatio ?? 1;
        Object.assign(mesh.userData.slot, (0, $a45dcdcd18e65853$export$fb43fd7d15d23469)(mesh.userData.loopSlotIndex + this.recycleCycle * 997, this.getOccupiedSlots(mesh), {
            ...this.tunnel,
            cameraAspect: this.camera.aspect,
            fixedZ: z,
            projectedPlaneAspect: nextAspectRatio
        }));
        this.gsap?.killTweensOf?.(mesh.userData, 'recycleReveal');
        mesh.userData.recycleReveal = 1;
        if (next) {
            mesh.userData.textureItem = next.item;
            mesh.userData.aspectRatio = nextAspectRatio;
            mesh.material.map = next.texture;
            mesh.material.needsUpdate = true;
        }
    }
    pickTextureForSlot(slotIndex, cycle = 0, excludedTexture = null, excludedMesh = null) {
        const length = this.texturePool.length;
        if (length === 0) return null;
        const initialIndex = $36f5c84af8d5b03f$var$mixInteger(slotIndex * 73856093 + cycle * 19349663) % length;
        const usageCounts = this.getTextureUsageCounts(excludedMesh);
        const repeatLimit = this.getTextureRepeatLimit();
        const isUnderRepeatLimit = (entry)=>{
            const key = $36f5c84af8d5b03f$var$getTextureEntryKey(entry);
            return !key || (usageCounts.get(key) ?? 0) < repeatLimit;
        };
        const canUseCandidate = (entry)=>{
            if (!entry) return false;
            if (excludedTexture && length > 1 && entry.texture === excludedTexture) return false;
            return isUnderRepeatLimit(entry);
        };
        if (canUseCandidate(this.texturePool[initialIndex])) return this.texturePool[initialIndex];
        for(let offset = 1; offset < length; offset += 1){
            const candidateIndex = (initialIndex + offset) % length;
            if (canUseCandidate(this.texturePool[candidateIndex])) return this.texturePool[candidateIndex];
        }
        const excludedEntry = excludedTexture ? this.texturePool.find((entry)=>entry.texture === excludedTexture) : null;
        if (excludedEntry && isUnderRepeatLimit(excludedEntry)) return excludedEntry;
        let index = initialIndex;
        if (excludedTexture && length > 1 && this.texturePool[index]?.texture === excludedTexture) for(let offset = 1; offset < length; offset += 1){
            const candidateIndex = (index + offset) % length;
            if (this.texturePool[candidateIndex]?.texture !== excludedTexture) {
                index = candidateIndex;
                break;
            }
        }
        return this.texturePool[index];
    }
    getTextureRepeatLimit() {
        const uniqueMax = $36f5c84af8d5b03f$var$toPositiveInteger(this.config?.duplicateTextureUniqueMax, (0, $e099036f3e0c3fd4$export$b2defa77b0ee83d8).duplicateTextureUniqueMax);
        const strictMinPoolSize = $36f5c84af8d5b03f$var$toPositiveInteger(this.config?.duplicateTextureStrictMinPoolSize, (0, $e099036f3e0c3fd4$export$b2defa77b0ee83d8).duplicateTextureStrictMinPoolSize);
        const strictMax = $36f5c84af8d5b03f$var$toPositiveInteger(this.config?.duplicateTextureStrictMax, (0, $e099036f3e0c3fd4$export$b2defa77b0ee83d8).duplicateTextureStrictMax);
        const relaxedMax = $36f5c84af8d5b03f$var$toPositiveInteger(this.config?.duplicateTextureRelaxedMax, (0, $e099036f3e0c3fd4$export$b2defa77b0ee83d8).duplicateTextureRelaxedMax);
        const activeSceneCount = Math.max(1, this.sceneImages?.length ?? 0);
        if (this.canLoadedPoolCoverActiveUniqueMeshes()) return uniqueMax;
        if (this.texturePool.length >= activeSceneCount) return uniqueMax;
        return this.texturePool.length >= strictMinPoolSize ? strictMax : relaxedMax;
    }
    canLoadedPoolCoverActiveUniqueMeshes() {
        const activeMeshCount = Math.max(1, this.meshes?.size ?? 0);
        return this.shouldStageUniqueMeshCreation() && this.texturePool.length >= activeMeshCount;
    }
    getTextureUsageCounts(excludedMesh = null) {
        const counts = new Map();
        for (const mesh of this.meshes.values()){
            if (mesh === excludedMesh) continue;
            const key = $36f5c84af8d5b03f$var$getMeshTextureKey(mesh, this.texturePool);
            if (key) counts.set(key, (counts.get(key) ?? 0) + 1);
        }
        return counts;
    }
    getTexturePoolByItemId() {
        return new Map(this.texturePool.map((entry)=>[
                entry.item?.id,
                entry
            ]).filter(([id])=>Boolean(id)));
    }
    shouldStageUniqueMeshCreation() {
        if (!this.sceneImages?.length) return false;
        return $36f5c84af8d5b03f$var$getUniqueSceneTextureCount(this.sceneImages) >= this.sceneImages.length;
    }
    shouldKeepMeshTextureOnRecycle() {
        return this.shouldStageUniqueMeshCreation();
    }
    requestTextureRebalance() {
        this.needsTextureRebalance = true;
        if (!this.motionStarted || this.isDestroyed) return;
        clearTimeout(this.textureRebalanceTimer);
        this.textureRebalanceTimer = globalThis.setTimeout(()=>{
            this.textureRebalanceTimer = null;
            if (this.isDestroyed || !this.motionStarted) return;
            this.needsTextureRebalance = false;
            this.rebalanceTextureAssignments();
        }, this.config?.textureRebalanceDelay ?? 700);
    }
    rebalanceTextureAssignments() {
        if (!this.meshes.size || !this.texturePool.length) return false;
        let changed = false;
        const maxPasses = this.meshes.size;
        for(let pass = 0; pass < maxPasses; pass += 1){
            const repeatLimit = this.getTextureRepeatLimit();
            const overusedKey = [
                ...this.getTextureUsageCounts()
            ].find(([, count])=>count > repeatLimit)?.[0];
            if (!overusedKey) break;
            const mesh = this.getRebalanceMeshForTexture(overusedKey);
            if (!mesh) break;
            const next = this.pickTextureForSlot(mesh.userData.loopSlotIndex ?? pass, this.recycleCycle + pass, mesh.material.map, mesh);
            if (!next || $36f5c84af8d5b03f$var$getTextureEntryKey(next) === overusedKey) break;
            changed = this.assignTextureToMesh(mesh, next) || changed;
        }
        return changed;
    }
    getRebalanceMeshForTexture(textureKey) {
        return Array.from(this.meshes.values()).filter((mesh)=>$36f5c84af8d5b03f$var$getMeshTextureKey(mesh, this.texturePool) === textureKey).sort($36f5c84af8d5b03f$var$compareRebalanceMeshes)[0];
    }
    assignTextureToMesh(mesh, poolEntry) {
        if (!mesh || !poolEntry || mesh.material?.map === poolEntry.texture) return false;
        mesh.userData.textureItem = poolEntry.item;
        mesh.userData.aspectRatio = poolEntry.aspectRatio ?? mesh.userData.aspectRatio ?? 1;
        mesh.material.map = poolEntry.texture;
        mesh.material.needsUpdate = true;
        if (this.camera && mesh.userData.slot) this.applyPlaneGeometry(mesh);
        return true;
    }
    applyPlaneGeometry(mesh) {
        const slot = mesh.userData.slot;
        const visual = (0, $a45dcdcd18e65853$export$fbb7e661e1046eb3)(slot, this.tunnel);
        const scale = slot.baseScale * visual.scaleMultiplier;
        const aspectRatio = mesh.userData.aspectRatio || 1;
        mesh.position.set(slot.x, slot.y, slot.z);
        mesh.rotation.set(0, 0, 0);
        mesh.scale.set(scale * aspectRatio, scale, 1);
        mesh.userData.currentScale = scale;
        mesh.material.opacity = visual.opacity * this.getCenterOpacityFactor(slot) * mesh.userData.reveal * mesh.userData.recycleReveal;
    }
    getCenterOpacityFactor(slot) {
        const farZ = this.tunnel?.farZ ?? (0, $a45dcdcd18e65853$export$f994f0fecd259d34).farZ;
        const nearZ = this.tunnel?.nearZ ?? (0, $a45dcdcd18e65853$export$f994f0fecd259d34).nearZ;
        const depthProgress = Math.min(1, Math.max(0, (slot.z - farZ) / (nearZ - farZ)));
        const depth = Math.max(0.2, -slot.z);
        const halfViewportHeight = depth * Math.tan(this.camera.fov * Math.PI / 360);
        const halfViewportWidth = halfViewportHeight * this.camera.aspect;
        const x = Math.abs(slot.x / halfViewportWidth);
        const y = Math.abs(slot.y / halfViewportHeight);
        const clearance = Math.max(x / 0.72, y / 0.46);
        const centerFactor = Math.min(1, Math.max(0.14, 0.14 + clearance * 0.86));
        const release = $36f5c84af8d5b03f$var$smoothstep(0.26, 0.5, depthProgress);
        return centerFactor + (1 - centerFactor) * release;
    }
    getOccupiedSlots(excludedMesh = null) {
        return Array.from(this.meshes.values()).filter((mesh)=>mesh !== excludedMesh).map((mesh)=>mesh.userData.slot);
    }
    revealMesh(mesh) {
        this.gsap?.killTweensOf?.(mesh.userData, 'reveal');
        if (!this.gsap) {
            mesh.userData.reveal = 1;
            this.applyPlaneGeometry(mesh);
            return;
        }
        this.gsap.to(mesh.userData, {
            reveal: 1,
            duration: this.reducedMotion ? 0 : 1.1,
            delay: 0,
            ease: 'power2.out'
        });
    }
}
function $36f5c84af8d5b03f$export$9e1483f61d50e5b9(width, contentHeight, options = {}) {
    const bleedRatio = Math.max(0, Math.min(0.4, options.renderBleedBottomRatio ?? 0.18));
    const bleedXRatio = Math.max(0, Math.min(0.4, options.renderBleedXRatio ?? 0.12));
    const bleedX = Math.round(width * bleedXRatio);
    const bleedBottom = Math.round(contentHeight * bleedRatio);
    return {
        width: width,
        contentWidth: width,
        contentHeight: contentHeight,
        bleedX: bleedX,
        bleedBottom: bleedBottom,
        renderWidth: width + bleedX * 2,
        renderHeight: contentHeight + bleedBottom
    };
}
function $36f5c84af8d5b03f$var$getTextureAspectRatio(texture, fallbackAspectRatio) {
    const image = texture?.image;
    const width = image?.naturalWidth ?? image?.videoWidth ?? image?.width;
    const height = image?.naturalHeight ?? image?.videoHeight ?? image?.height;
    if (width && height) return width / height;
    return fallbackAspectRatio || 1;
}
function $36f5c84af8d5b03f$var$getTextureEntryKey(entry) {
    return entry?.textureKey ?? entry?.item?.textureKey ?? entry?.item?.resource?.textureKey;
}
function $36f5c84af8d5b03f$var$getUniqueSceneTextureCount(sceneImages = []) {
    return new Set(sceneImages.map((item)=>item.textureKey).filter(Boolean)).size;
}
function $36f5c84af8d5b03f$var$getMeshTextureKey(mesh, texturePool = []) {
    const userDataKey = mesh?.userData?.textureItem?.textureKey ?? mesh?.userData?.textureItem?.resource?.textureKey;
    if (userDataKey) return userDataKey;
    const texture = mesh?.material?.map;
    const match = texturePool.find((entry)=>entry.texture === texture);
    return $36f5c84af8d5b03f$var$getTextureEntryKey(match);
}
function $36f5c84af8d5b03f$var$compareRebalanceMeshes(first, second) {
    const firstOpacity = Number(first?.material?.opacity ?? 1);
    const secondOpacity = Number(second?.material?.opacity ?? 1);
    if (firstOpacity !== secondOpacity) return firstOpacity - secondOpacity;
    return Number(first?.userData?.slot?.z ?? 0) - Number(second?.userData?.slot?.z ?? 0);
}
function $36f5c84af8d5b03f$var$toPositiveInteger(value, fallback = 1) {
    const number = Math.floor(Number(value));
    if (Number.isFinite(number) && number > 0) return number;
    return fallback;
}
function $36f5c84af8d5b03f$var$smoothstep(edge0, edge1, value) {
    const x = Math.min(1, Math.max(0, (value - edge0) / (edge1 - edge0)));
    return x * x * (3 - 2 * x);
}
function $36f5c84af8d5b03f$var$mixInteger(value) {
    let state = value | 0;
    state ^= state >>> 16;
    state = Math.imul(state, 0x7feb352d);
    state ^= state >>> 15;
    state = Math.imul(state, 0x846ca68b);
    state ^= state >>> 16;
    return state >>> 0;
}




const $1ba53a613aa7c9ba$var$FLOEMA_FLOATING_VISIBLE_MIN_WIDTH = 768;
const $1ba53a613aa7c9ba$var$SLOW_CONNECTION_TYPES = new Set([
    'slow-2g',
    '2g'
]);
function $1ba53a613aa7c9ba$export$c42a6bbbb9c6102f(viewportWidth) {
    return $1ba53a613aa7c9ba$var$toFiniteNumber(viewportWidth, 0) >= $1ba53a613aa7c9ba$var$FLOEMA_FLOATING_VISIBLE_MIN_WIDTH;
}
function $1ba53a613aa7c9ba$export$f847ca59edb9f76(viewportWidth, connection = {}) {
    const width = $1ba53a613aa7c9ba$var$toFiniteNumber(viewportWidth, 0);
    const effectiveType = String(connection?.effectiveType || '').toLowerCase();
    const isSlow = connection?.saveData || $1ba53a613aa7c9ba$var$SLOW_CONNECTION_TYPES.has(effectiveType);
    const adaptive = isSlow ? {
        minItems: 18,
        maxItems: 22,
        initialLoadCount: 6,
        lazyLoadBatchSize: 3,
        lazyLoadDelay: 260,
        pixelRatioCap: 1.25
    } : width < 1025 ? {
        minItems: 24,
        maxItems: 28,
        initialLoadCount: 8,
        lazyLoadBatchSize: 4,
        lazyLoadDelay: 220,
        pixelRatioCap: 1.5
    } : {
        pixelRatioCap: 2
    };
    return {
        ...(0, $e099036f3e0c3fd4$export$b2defa77b0ee83d8),
        ...adaptive,
        tunnel: {
            ...(0, $a45dcdcd18e65853$export$f994f0fecd259d34)
        },
        portrait: {},
        renderBleedBottomRatio: 0.18,
        renderBleedXRatio: 0.12,
        autoPlay: false
    };
}
function $1ba53a613aa7c9ba$var$toFiniteNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}




const $1a37a94846fe1dfb$export$e67270681485a43d = 1200;
class $1a37a94846fe1dfb$export$693073b73e86fc75 {
    constructor(options = {}){
        this.textureCacheFactory = options.textureCacheFactory ?? (()=>new (0, $8bac6a671cbdf43a$export$35a0542af0b8e35c)());
        this.state = null;
    }
    prewarm(sources = [], profile = {}, options = {}) {
        const sceneImages = (0, $e099036f3e0c3fd4$export$54b61e86a3412b8d)(sources, profile);
        if (!sceneImages.length) {
            this.dispose();
            return Promise.resolve(false);
        }
        const signature = $1a37a94846fe1dfb$export$c655ff9201aa787b(sources, profile);
        if (!this.state || this.state.signature !== signature) {
            this.dispose();
            const textureCache = this.textureCacheFactory();
            const queue = (0, $e099036f3e0c3fd4$export$db802ba6b23bef39)(sceneImages, profile);
            const initialPromise = Promise.allSettled(queue.initial.map((item)=>textureCache.load(item.resource))).then(()=>true);
            this.state = {
                signature: signature,
                textureCache: textureCache,
                initialPromise: initialPromise
            };
        }
        this.state.timedPromise = $1a37a94846fe1dfb$var$withTimeout(this.state.initialPromise, options.timeout ?? $1a37a94846fe1dfb$export$e67270681485a43d);
        return this.state.timedPromise;
    }
    consume(sources = [], profile = {}) {
        const signature = $1a37a94846fe1dfb$export$c655ff9201aa787b(sources, profile);
        if (!this.state || this.state.signature !== signature) return null;
        const textureCache = this.state.textureCache;
        this.state = null;
        return textureCache;
    }
    dispose() {
        this.state?.textureCache?.dispose?.();
        this.state = null;
    }
}
const $1a37a94846fe1dfb$export$2495dd8a57205d83 = new $1a37a94846fe1dfb$export$693073b73e86fc75();
function $1a37a94846fe1dfb$export$c655ff9201aa787b(sources = [], profile = {}) {
    return JSON.stringify({
        sources: sources.map((source)=>({
                src: source.src,
                fallbackSrc: source.fallbackSrc,
                webp: source.webp,
                srcset: source.srcset,
                sizes: source.sizes
            })),
        profile: $1a37a94846fe1dfb$var$normalizeSignatureValue(profile)
    });
}
function $1a37a94846fe1dfb$var$withTimeout(promise, timeout) {
    const timeoutMs = Math.max(0, Math.floor(Number(timeout) || 0));
    if (!timeoutMs) return promise;
    return Promise.race([
        promise,
        new Promise((resolve)=>{
            setTimeout(()=>resolve(false), timeoutMs);
        })
    ]);
}
function $1a37a94846fe1dfb$var$normalizeSignatureValue(value) {
    if (Array.isArray(value)) return value.map($1a37a94846fe1dfb$var$normalizeSignatureValue);
    if (value && typeof value === 'object') return Object.keys(value).sort().reduce((result, key)=>{
        const normalized = $1a37a94846fe1dfb$var$normalizeSignatureValue(value[key]);
        if (typeof normalized !== 'undefined') result[key] = normalized;
        return result;
    }, {});
    if (typeof value === 'function') return undefined;
    return value;
}


const $2c9b72a2f6be713e$export$338f7f1a6a80d34f = 1500;
function $2c9b72a2f6be713e$export$3ed6f7b587b3fcc2(delayMs, leadMs = $2c9b72a2f6be713e$export$338f7f1a6a80d34f) {
    const delay = $2c9b72a2f6be713e$var$toFiniteNumber(delayMs, 0);
    const lead = Math.max(0, $2c9b72a2f6be713e$var$toFiniteNumber(leadMs, $2c9b72a2f6be713e$export$338f7f1a6a80d34f));
    return Math.max(0, delay - lead);
}
function $2c9b72a2f6be713e$var$toFiniteNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}


const $6170adaa51bee928$var$TITLE_ANIMATION_FALLBACK = 3200;
const $6170adaa51bee928$var$TITLE_ANIMATION_BUFFER = 180;
const $6170adaa51bee928$var$TITLE_WORD_DURATION = 1000;
const $6170adaa51bee928$var$TITLE_WORD_DELAY_BASE = 300;
const $6170adaa51bee928$var$TITLE_WORD_DELAY_STEP = 300;
let $6170adaa51bee928$var$activeHeroScene = null;
const $6170adaa51bee928$var$getNetworkConnection = ()=>typeof navigator === 'undefined' ? {} : navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
const $6170adaa51bee928$var$getFirstSrcsetUrl = (srcset = '')=>srcset.split(',')[0]?.trim().split(/\s+/)[0] || '';
const $6170adaa51bee928$var$readSource = (card, index)=>{
    const img = card.querySelector('img');
    const source = card.querySelector('source');
    const src = img?.dataset.src || img?.getAttribute('src') || '';
    const srcset = source?.dataset.srcset || source?.getAttribute('srcset') || '';
    const webp = $6170adaa51bee928$var$getFirstSrcsetUrl(srcset);
    return {
        id: `floema-source-${index}`,
        alt: img?.getAttribute('alt') || '',
        src: src,
        fallbackSrc: src,
        webp: webp,
        srcset: srcset
    };
};
const $6170adaa51bee928$var$parseTimeList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean).map((item)=>item.endsWith('ms') ? parseFloat(item) : parseFloat(item) * 1000).filter((item)=>Number.isFinite(item));
const $6170adaa51bee928$var$getTitleWordIndex = (word, fallback)=>{
    const styles = window.getComputedStyle(word);
    const index = parseFloat(styles.getPropertyValue('--word-index'));
    return Number.isFinite(index) ? index : fallback;
};
const $6170adaa51bee928$var$getEstimatedTitleAnimationTime = (words)=>{
    if (!words.length) return $6170adaa51bee928$var$TITLE_ANIMATION_FALLBACK;
    const maxWordIndex = words.reduce((maxIndex, word, index)=>Math.max(maxIndex, $6170adaa51bee928$var$getTitleWordIndex(word, index)), 0);
    return $6170adaa51bee928$var$TITLE_WORD_DURATION + $6170adaa51bee928$var$TITLE_WORD_DELAY_BASE + $6170adaa51bee928$var$TITLE_WORD_DELAY_STEP * maxWordIndex;
};
const $6170adaa51bee928$var$getTitleAnimationDelay = (titleEl)=>{
    const words = Array.from(titleEl.querySelectorAll('.word'));
    if (!words.length) return $6170adaa51bee928$var$TITLE_ANIMATION_FALLBACK;
    const maxWordTime = words.reduce((maxTime, word)=>{
        const styles = window.getComputedStyle(word);
        const durations = $6170adaa51bee928$var$parseTimeList(styles.animationDuration);
        const delays = $6170adaa51bee928$var$parseTimeList(styles.animationDelay);
        const duration = durations[0] || 0;
        const delay = delays[0] || 0;
        return Math.max(maxTime, duration + delay);
    }, 0);
    return Math.max(maxWordTime, $6170adaa51bee928$var$getEstimatedTitleAnimationTime(words)) + $6170adaa51bee928$var$TITLE_ANIMATION_BUFFER;
};
const $6170adaa51bee928$var$schedule = (callback, delaySeconds)=>{
    if (typeof gsap !== 'undefined') {
        gsap.delayedCall(delaySeconds, callback);
        return;
    }
    setTimeout(callback, delaySeconds * 1000);
};
const $6170adaa51bee928$var$hasWebGLSupport = ()=>{
    try {
        const canvas = document.createElement('canvas');
        return Boolean(canvas.getContext('webgl2') || canvas.getContext('webgl'));
    } catch  {
        return false;
    }
};
const $6170adaa51bee928$var$createCanvas = (scene)=>{
    const canvas = document.createElement('canvas');
    canvas.className = 'first-sec__floema-floating-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    scene.innerHTML = '';
    scene.appendChild(canvas);
    return canvas;
};
const $6170adaa51bee928$var$getHeroRuntimeContext = (options = {})=>{
    if (!(0, $1ba53a613aa7c9ba$export$c42a6bbbb9c6102f)(window.innerWidth)) return null;
    if (!$6170adaa51bee928$var$hasWebGLSupport()) return null;
    const root = document.querySelector('[data-floema-floating-hero]');
    if (!root || options.skipInited && root.dataset.inited === '1') return null;
    const scene = root.querySelector('[data-floema-floating-scene]');
    const sourceCards = Array.from(root.querySelectorAll('[data-floema-floating-card]'));
    if (!scene || !sourceCards.length) return null;
    const sources = sourceCards.map($6170adaa51bee928$var$readSource).filter((source)=>source.src);
    if (!sources.length) return null;
    return {
        root: root,
        scene: scene,
        sources: sources,
        profile: (0, $1ba53a613aa7c9ba$export$f847ca59edb9f76)(window.innerWidth, $6170adaa51bee928$var$getNetworkConnection())
    };
};
const $6170adaa51bee928$var$initScrollFade = (root)=>{
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.fromTo(root, {
        opacity: 1
    }, {
        opacity: 0.5,
        ease: 'none',
        scrollTrigger: {
            trigger: '.first-sec.home-first-sec',
            start: 'top top',
            end: 'bottom top',
            scrub: true
        }
    });
};
const $6170adaa51bee928$var$playScene = (root, heroScene)=>{
    if (!heroScene || heroScene.isDestroyed) return;
    root.classList.add('is-ready');
    heroScene.play();
    $6170adaa51bee928$var$initScrollFade(root);
};
const $6170adaa51bee928$var$watchTitleAndPlay = (root, heroScene)=>{
    const titleEl = document.querySelector('.home-first-sec .first-sec__title');
    const playAfterTitleAnimation = ()=>{
        $6170adaa51bee928$var$schedule(()=>$6170adaa51bee928$var$playScene(root, heroScene), (0, $2c9b72a2f6be713e$export$3ed6f7b587b3fcc2)($6170adaa51bee928$var$getTitleAnimationDelay(titleEl)) / 1000);
    };
    if (!titleEl) {
        setTimeout(()=>$6170adaa51bee928$var$playScene(root, heroScene), (0, $2c9b72a2f6be713e$export$3ed6f7b587b3fcc2)(3000));
        return;
    }
    if (titleEl.classList.contains('aos-animate')) {
        playAfterTitleAnimation();
        return;
    }
    let started = false;
    const tryStart = ()=>{
        if (started) return;
        if (titleEl.classList.contains('aos-animate')) {
            started = true;
            observer.disconnect();
            clearTimeout(fallback);
            playAfterTitleAnimation();
        }
    };
    const observer = new MutationObserver(tryStart);
    observer.observe(titleEl, {
        attributes: true,
        attributeFilter: [
            'class'
        ]
    });
    const fallback = setTimeout(()=>{
        if (started) return;
        started = true;
        observer.disconnect();
        $6170adaa51bee928$var$playScene(root, heroScene);
    }, (0, $2c9b72a2f6be713e$export$3ed6f7b587b3fcc2)(5500));
};
window.floemaFloatingHeroPrewarm = function floemaFloatingHeroPrewarm(options = {}) {
    try {
        const context = $6170adaa51bee928$var$getHeroRuntimeContext({
            skipInited: true
        });
        if (!context) return Promise.resolve(false);
        return (0, $1a37a94846fe1dfb$export$2495dd8a57205d83).prewarm(context.sources, context.profile, {
            timeout: options.timeout ?? (0, $1a37a94846fe1dfb$export$e67270681485a43d)
        });
    } catch  {
        return Promise.resolve(false);
    }
};
window.floemaFloatingHeroAnimation = function floemaFloatingHeroAnimation() {
    const context = $6170adaa51bee928$var$getHeroRuntimeContext({
        skipInited: true
    });
    if (!context) return;
    const { root: root, scene: scene, sources: sources, profile: profile } = context;
    const canvas = $6170adaa51bee928$var$createCanvas(scene);
    const prewarmedTextureCache = (0, $1a37a94846fe1dfb$export$2495dd8a57205d83).consume(sources, profile);
    root.dataset.inited = '1';
    let nextHeroScene = null;
    try {
        $6170adaa51bee928$var$activeHeroScene?.destroy();
        nextHeroScene = new (0, $36f5c84af8d5b03f$export$2fc02929ca5105dc)(root, sources, {
            ...profile,
            canvas: canvas,
            gsap: typeof gsap === 'undefined' ? null : gsap,
            textureCache: prewarmedTextureCache ?? undefined,
            ownsTextureCache: prewarmedTextureCache ? true : undefined
        });
        $6170adaa51bee928$var$activeHeroScene = nextHeroScene.start();
    } catch  {
        if (nextHeroScene) nextHeroScene.destroy();
        else prewarmedTextureCache?.dispose?.();
        $6170adaa51bee928$var$activeHeroScene = null;
        root.classList.remove('is-ready');
        delete root.dataset.inited;
        scene.innerHTML = '';
        return;
    }
    if (!$6170adaa51bee928$var$activeHeroScene?.isStarted) {
        delete root.dataset.inited;
        scene.innerHTML = '';
        return;
    }
    $6170adaa51bee928$var$watchTitleAndPlay(root, $6170adaa51bee928$var$activeHeroScene);
};
const $6170adaa51bee928$var$scheduleFloemaFloatingHeroAutoInit = ()=>{
    if (!document.querySelector('[data-floema-floating-hero]')) return;
    if (!(0, $1ba53a613aa7c9ba$export$c42a6bbbb9c6102f)(window.innerWidth)) return;
    const init = ()=>{
        const delay = document.querySelector('.bold-loader-new') ? 3200 : 0;
        setTimeout(()=>{
            window.floemaFloatingHeroAnimation();
        }, delay);
    };
    if (document.readyState === 'complete') init();
    else window.addEventListener('load', init, {
        once: true
    });
};
window.addEventListener('beforeunload', ()=>{
    $6170adaa51bee928$var$activeHeroScene?.destroy();
});
$6170adaa51bee928$var$scheduleFloemaFloatingHeroAutoInit();


window.firstDragImagesAnimation = function firstDragImagesAnimation() {
    const container = document.querySelector('.drag-container'); // большой bounds
    const positionContainer = document.querySelector('.drag-container-position'); // контейнер с позициями
    const imagesElArr = container?.querySelectorAll('.drag-item');
    if (!container || !positionContainer || !imagesElArr?.length) return;
    gsap.registerPlugin(Draggable, InertiaPlugin);
    const draggables = [];
    const startPositions = [];
    imagesElArr.forEach((imageEl)=>{
        const rect = imageEl.getBoundingClientRect();
        const containerRect = positionContainer.getBoundingClientRect();
        startPositions.push({
            x: rect.left - containerRect.left,
            y: rect.top - containerRect.top
        });
    });
    const setImages = ()=>{
        const positionRect = positionContainer.getBoundingClientRect();
        imagesElArr.forEach((imageEl, i)=>{
            const pos = startPositions[i];
            const x = pos.x * (positionRect.width / positionRect.width);
            const y = pos.y * (positionRect.height / positionRect.height);
            gsap.set(imageEl, {
                x: x,
                y: y,
                top: 0,
                left: 0,
                position: 'absolute'
            });
            if (!draggables[i]) draggables[i] = Draggable.create(imageEl, {
                type: 'x,y',
                bounds: container,
                edgeResistance: 0.75,
                inertia: true,
                maxDuration: 0.5,
                minDuration: 0.1
            })[0];
            else {
                draggables[i].applyBounds(container);
                draggables[i].update();
            }
        });
    };
    setImages();
    window.addEventListener('resize', ()=>{
        setImages();
    });
};
window.firstDragWrImagesAnimation = function firstDragWrImagesAnimation() {
    const imgWrElArr = document.querySelectorAll('.drag-item .drag-item-img');
    if (!imgWrElArr.length) return;
    const startDelay = 800;
    const intervalDelay = 400;
    const remaining = [
        ...imgWrElArr
    ];
    let timeoutId = setTimeout(function addRandom() {
        if (!remaining.length) return;
        const randomIndex = Math.floor(Math.random() * remaining.length);
        const el = remaining.splice(randomIndex, 1)[0];
        el.classList.add('is-start-animation');
        if (remaining.length) timeoutId = setTimeout(addRandom, intervalDelay);
    }, startDelay);
};


if (document.querySelector('.tabs-sec__tabs-container')) {
    const tabsContainersArr = document.querySelectorAll('.tabs-sec__tabs-container');
    tabsContainersArr.forEach((tabsContainer)=>{
        if (!tabsContainer.classList.contains('is-init')) {
            tabsContainer.classList.add('is-init');
            const togglesDeskArr = tabsContainer.querySelectorAll('.tabs-sec__toggles .tabs-sec__toggle');
            const togglesMobArr = tabsContainer.querySelectorAll('.tabs-sec__container .tabs-sec__toggle');
            const contentsArr = tabsContainer.querySelectorAll('.tabs-sec__content');
            togglesDeskArr.forEach((toggleDesk, idx)=>{
                toggleDesk.addEventListener('click', ()=>{
                    openTabFunc(toggleDesk, togglesMobArr[idx], contentsArr[idx]);
                });
            });
            togglesMobArr.forEach((toggleMob, idx)=>{
                toggleMob.addEventListener('click', ()=>{
                    openTabFunc(togglesDeskArr[idx], toggleMob, contentsArr[idx]);
                });
                if (idx === 0) toggleMob.click();
            });
            function openTabFunc(toggleDesk, toggleMob, content) {
                for(let i = 0; i < togglesDeskArr.length; i++){
                    togglesDeskArr[i].classList.remove('is-active');
                    togglesMobArr[i].classList.remove('is-active');
                    contentsArr[i].classList.remove('is-active');
                }
                toggleDesk.classList.add('is-active');
                toggleMob.classList.add('is-active');
                content.classList.add('is-active');
                reinitBgChangeAnimation();
                AOS.refreshHard();
            }
            function closeTabFunc(toggleDesk, toggleMob, content) {
                toggleDesk.classList.remove('is-active');
                toggleMob.classList.remove('is-active');
                content.classList.remove('is-active');
            }
        }
    });
}


window.formValidation = function formValidation(formData) {
    if (!document.querySelector('.portal')) try {
        console.log(formData);
        const data = typeof formData === 'string' ? JSON.parse(formData) : formData;
        console.log(data);
        const formId = data.form_id;
        const errorMessages = data.names;
        let formErrorMessage = '';
        let fieldErrors = {};
        if (data?.names && Array.isArray(data.names) && Array.isArray(data.names[0]) && typeof data.names[0][0] === 'string') formErrorMessage = data.names[0][0];
        else if (data?.names && typeof data.names === 'object' && !Array.isArray(data.names)) fieldErrors = data.names;
        const defaultOptions = {
            errorTextClasses: 'text-red-500',
            errorTextClassesCheckRadio: 'text-red-500 absolute bottom-0 left-0',
            errorTextClassesFile: 'text-red-500',
            errorTextClassesSelect: 'text-red-500',
            inputErrorClasses: '!border-red-400',
            selectErrorClasses: '!border-red-400',
            errorTextClassesForm: 'text-red-500',
            defaultErrorMessage: 'This field is required',
            errorClearDelay: 500,
            transitionDelay: 300
        };
        const finalOptions = {
            ...defaultOptions
        };
        const errors = {};
        const form = document.getElementById(formId);
        if (!form) throw new Error(`Form with ID "${formId}" not found.`);
        if (formErrorMessage && formErrorMessage !== '') {
            let formErrorElement = form.querySelector('.form-error-text');
            if (formErrorElement) formErrorElement.remove();
            formErrorElement = document.createElement('div');
            formErrorElement.className = `form-error-text ${finalOptions.errorTextClassesForm}`;
            formErrorElement.textContent = formErrorMessage;
            form.classList.add('error');
            form.appendChild(formErrorElement);
            /*form.insertBefore(formErrorElement, form.firstChild);*/ console.log(form);
            if (form.querySelector('input, textarea')) {
                const inputs = form.querySelectorAll('input, textarea');
                inputs.forEach((input)=>{
                    input.addEventListener('click', ()=>{
                        form.classList.remove('error');
                    });
                    input.addEventListener('change', ()=>{
                        form.classList.remove('error');
                    });
                });
            }
        }
        if (errorMessages && (typeof errorMessages !== 'object' || Array.isArray(errorMessages))) throw new Error('Invalid error format. Expected an object.');
        if (errorMessages) Object.keys(errorMessages).forEach((fieldName)=>{
            const inputField = form.elements[fieldName];
            if (!inputField) {
                console.warn(`Input field "${fieldName}" not found in form.`);
                return;
            }
            const fieldValue = inputField.value.trim();
            const parentElement = inputField.parentElement;
            const isCheckboxOrRadio = inputField.type === 'checkbox' || inputField.type === 'radio';
            const isFile = inputField.name === 'cv_field';
            const isSelect = inputField.tagName.toLowerCase() === 'select';
            const errorMessage = errorMessages[fieldName]?.[0] || finalOptions.defaultErrorMessage;
            const errorTextClass = isFile ? finalOptions.errorTextClassesFile : isCheckboxOrRadio ? finalOptions.errorTextClassesCheckRadio : isSelect ? finalOptions.errorTextClassesSelect : finalOptions.errorTextClasses;
            let errorTextElement = isSelect ? parentElement.parentElement.parentElement.querySelector('.error-text') : parentElement.querySelector('.error-text');
            if (!isCheckboxOrRadio && !isFile && !isSelect) {
                errors[fieldName] = errorMessage;
                inputField.classList.add('error', ...finalOptions.inputErrorClasses.split(' '));
                if (!errorTextElement) {
                    errorTextElement = document.createElement('span');
                    errorTextElement.className = `error-text ${errorTextClass}`;
                    parentElement.appendChild(errorTextElement);
                    errorTextElement.addEventListener('click', ()=>{
                        const metaParentEl = errorTextElement.closest("[class^='meta-']");
                        const errorParentElement = errorTextElement.closest('.error');
                        if (errorParentElement) errorParentElement.classList.remove('error');
                        if (metaParentEl) {
                            const errorsElArr = metaParentEl.querySelectorAll('.error');
                            for(let i = 0; i < errorsElArr.length; i++)errorsElArr[i].classList.remove('error');
                            const inputClassesToRemove = defaultOptions.inputErrorClasses.split(' ');
                            const selectClassesToRemove = defaultOptions.selectErrorClasses.split(' ');
                            const fields = metaParentEl.querySelectorAll('input, select, textarea, .choices__inner');
                            fields.forEach((field)=>{
                                inputClassesToRemove.forEach((cls)=>field.classList.remove(cls));
                                selectClassesToRemove.forEach((cls)=>field.classList.remove(cls));
                            });
                        }
                    });
                } else if (errorTextElement) errorTextElement.addEventListener('click', ()=>{
                    const metaParentEl = errorTextElement.closest("[class^='meta-']");
                    const errorParentElement = errorTextElement.closest('.error');
                    if (errorParentElement) errorParentElement.classList.remove('error');
                    if (metaParentEl) {
                        const errorsElArr = metaParentEl.querySelectorAll('.error');
                        for(let i = 0; i < errorsElArr.length; i++)errorsElArr[i].classList.remove('error');
                        const inputClassesToRemove = defaultOptions.inputErrorClasses.split(' ');
                        const selectClassesToRemove = defaultOptions.selectErrorClasses.split(' ');
                        const fields = metaParentEl.querySelectorAll('input, select, textarea, .choices__inner');
                        fields.forEach((field)=>{
                            inputClassesToRemove.forEach((cls)=>field.classList.remove(cls));
                            selectClassesToRemove.forEach((cls)=>field.classList.remove(cls));
                        });
                    }
                });
                errorTextElement.textContent = errorMessage;
            } else if (!isCheckboxOrRadio && !isFile && !isSelect) {
                inputField.classList.remove('error', ...finalOptions.inputErrorClasses.split(' '));
                if (errorTextElement) setTimeout(()=>{
                    parentElement.removeChild(errorTextElement);
                }, finalOptions.transitionDelay + finalOptions.errorClearDelay);
            } else if (isCheckboxOrRadio || isFile || isSelect) {
                errors[fieldName] = errorMessage;
                inputField.classList.add('error');
                if (isCheckboxOrRadio || isFile) parentElement.classList.add('error');
                else if (isSelect) {
                    const selectParent = parentElement.parentElement;
                    selectParent.classList.add('error', ...finalOptions.selectErrorClasses.split(' '));
                }
                if (!errorTextElement) {
                    errorTextElement = document.createElement('span');
                    errorTextElement.className = `error-text ${errorTextClass}`;
                    if (isFile) parentElement.insertAdjacentElement('afterend', errorTextElement);
                    else if (isSelect) {
                        const selectParent = parentElement.parentElement;
                        selectParent.insertAdjacentElement('afterend', errorTextElement);
                    } else parentElement.appendChild(errorTextElement);
                }
                errorTextElement.textContent = errorMessage;
            }
            if (inputField.closest('.meta-upload-file')) {
                const metaUploadFileEl = inputField.closest('.meta-upload-file');
                metaUploadFileEl.classList.add('error');
            }
            inputField.addEventListener('click', ()=>{
                setTimeout(()=>{
                    inputField.classList.remove('error', ...finalOptions.inputErrorClasses.split(' '));
                    form.classList.remove('error');
                    if (inputField.closest('.meta-upload-file')) {
                        const metaUploadFileEl = inputField.closest('.meta-upload-file');
                        metaUploadFileEl.classList.remove('error');
                    }
                    if (errorTextElement) setTimeout(()=>{
                        if (errorTextElement.parentElement) errorTextElement.parentElement.classList.remove('error');
                        errorTextElement.remove();
                    }, finalOptions.transitionDelay * 2);
                }, finalOptions.errorClearDelay);
            });
            inputField.parentElement.parentElement.addEventListener('click', ()=>{
                setTimeout(()=>{
                    inputField.parentElement.parentElement.classList.remove('error');
                    form.classList.remove('error');
                    if (inputField.closest('.meta-upload-file')) {
                        const metaUploadFileEl = inputField.closest('.meta-upload-file');
                        metaUploadFileEl.classList.remove('error');
                    }
                }, finalOptions.errorClearDelay);
            });
            inputField.parentElement.addEventListener('click', ()=>{
                setTimeout(()=>{
                    inputField.parentElement.classList.remove('error');
                    form.classList.remove('error');
                    if (inputField.closest('.meta-upload-file')) {
                        const metaUploadFileEl = inputField.closest('.meta-upload-file');
                        metaUploadFileEl.classList.remove('error');
                    }
                }, finalOptions.errorClearDelay);
            });
        });
        setTimeout(function() {
            const metaCheckboxesArr = document.querySelectorAll('.meta-checkbox');
            metaCheckboxesArr.forEach((checkbox)=>{
                checkbox.addEventListener('mouseenter', (e)=>{
                    checkbox.classList.remove('error');
                });
                checkbox.addEventListener('mousemove', (e)=>{
                    checkbox.classList.remove('error');
                });
            });
        }, 50);
        const metaCheckboxesArr = document.querySelectorAll('.meta-checkbox');
        function updateAllSimpleBars() {
            document.querySelectorAll('.simplebar-content').forEach((content)=>{
                const simpleBarInstance = SimpleBar.instances.get(content.closest('[data-simplebar]'));
                if (simpleBarInstance) simpleBarInstance.recalculate();
            });
        }
        updateAllSimpleBars();
        return errors;
    } catch (error) {
        console.error('Error parsing JSON data:', error.message);
        return {};
    }
};


window.openVideo = (id)=>{
    const popup = document.getElementById(id);
    if (popup) {
        const closeBtn = popup.querySelector('.close-btn');
        const video = popup.querySelector('video');
        scrollLock.disablePageScroll();
        popup.classList.add('active');
        let iframe = popup.querySelector('iframe');
        if (!iframe) {
            popup.insertAdjacentHTML('beforeend', `
        <iframe
          src="https://player.vimeo.com/video/870987464?badge=0&autopause=0&quality_selector=1&progress_bar=1&player_id=0&app_id=58479"
          width="1920"
          height="1080"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          title="Bold Summer 2023 Showreel"
        ></iframe>
      `);
            iframe = popup.querySelector('iframe');
        }
        if (video) video.play();
        if (iframe) {
            const vimeoPlayer = new Vimeo.Player(iframe);
            vimeoPlayer.play();
        }
        closeBtn.addEventListener('click', ()=>{
            popup.classList.remove('active');
            if (video) video.pause();
            if (iframe) iframe.remove();
            scrollLock.enablePageScroll();
            const cursorEl = document.querySelector('.mf-cursor');
            cursorEl?.classList.remove('is-open-vimeo');
        });
        const cursorEl = document.querySelector('.mf-cursor');
        cursorEl?.classList.add('is-open-vimeo');
    }
};


window.initCountUp = function initCountUp() {
    const counts = document.querySelectorAll('.count-up');
    if (!counts.length) return;
    const observer = new IntersectionObserver((entries, obs)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const count = entry.target;
            if (!count.dataset.target) count.dataset.target = count.textContent.trim();
            const target = parseFloat(count.dataset.target) || 0;
            const duration = parseFloat(count.dataset.duration) || 1200; // мс
            const start = performance.now();
            function animate(time) {
                const progress = Math.min((time - start) / duration, 1);
                const value = Math.floor(progress * target);
                count.textContent = value;
                if (progress < 1) requestAnimationFrame(animate);
                else count.textContent = target;
            }
            count.textContent = '0';
            requestAnimationFrame(animate);
            obs.unobserve(count);
        });
    }, {
        threshold: 0,
        rootMargin: window.innerWidth >= 640 ? '0% 0% -10% 0%' : '0% 0% -5% 0%'
    });
    counts.forEach((count)=>observer.observe(count));
};


(()=>{
    const firstHomeButtons = document.querySelector('.first-sec.home-first-sec .first-sec__buttons');
    const btnToTop = document.querySelector('.btn-to-top');
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    if (isChrome && window.innerWidth >= 1025) {
        if (firstHomeButtons) firstHomeButtons.classList.add('is-chrome');
        if (btnToTop) btnToTop.classList.add('is-chrome');
    }
})();
window.jsScrollToEl = function jsScrollToEl(targetID) {
    let config = targetID.split('|');
    let duration = +config[1] && (config[1], true) ? +config[1] : 800;
    let paddingTop = +config[2] && (config[2], true) ? +config[2] : 0;
    let target = config[0];
    let targetElement = document.querySelector(target);
    if (targetElement) {
        let targetOffsetTop = targetElement.offsetTop - paddingTop;
        window.scrollTo({
            top: targetOffsetTop,
            behavior: 'smooth'
        });
        return false;
    }
};
(function detectSafari() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) document.body.classList.add('is-safari');
})();
function $42a766e449d15d73$var$setUrlParams(paramName, value = 1) {
    window.history.replaceState(null, null, `?${paramName}=${value}`);
}
window.setUrlParams = $42a766e449d15d73$var$setUrlParams;
function $42a766e449d15d73$var$removeUrlParams() {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, document.title, url.href);
}
window.removeUrlParams = $42a766e449d15d73$var$removeUrlParams;
window.addEventListener('load', ()=>{
    const regex = /showreel=1/;
    const url = new URL(window.location.href);
    if (regex.test(url.search)) window.openVideo('hero-video');
});

})();
//# sourceMappingURL=scripts.e05f5d96.js.map
